//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.2.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap, catchError } from 'rxjs/operators';
import { Observable, from, throwError, of } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const OM_ORDER_API_BASE_URL = new InjectionToken<string>('OM_ORDER_API_BASE_URL');

export class ServiceBaseConfig {
  public key: string;
}

export class ServiceBase {
  private readonly apiKey: string;
  private readonly apimHeaderName: string = 'Ocp-Apim-Subscription-Key';
  private readonly tenantIdHeaderName: string = 'TenantId';
  private readonly tenantIdLocalStorageKey: string = 'samplicity-dtp-current-client';
  private readonly idTokenKey: string = 'samplicity-id-token';

  constructor(config: ServiceBaseConfig) {
    this.apiKey = config.key;
  }

  protected transformOptions(options: any) {
    let headers: HttpHeaders = options.headers;

    if (this.apiKey) {
      headers = headers.append(this.apimHeaderName, this.apiKey);
    }

    const tenantId = sessionStorage.getItem(this.tenantIdLocalStorageKey);
    if (tenantId) {
      headers = headers.append(this.tenantIdHeaderName, tenantId);
    }

    const token = localStorage.getItem(this.idTokenKey);
    if (token) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }

    options.headers = headers;

    return Promise.resolve(options);
  }
}

@Injectable()
export class OrderManagementOrder extends ServiceBase {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(ServiceBaseConfig) configuration: ServiceBaseConfig, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(OM_ORDER_API_BASE_URL) baseUrl?: string) {
    super(configuration);
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param inboundMessage (optional) 
   * @return Success
   */
  sendReplenishmentMessage(inboundMessage?: AllocationReplenishmentMessage | null | undefined): Observable<AjaxResponseOfAllocationReplenishmentMessage> {
    let url_ = this.baseUrl + "/api/services/app/AllocationQueueService/SendReplenishmentMessage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(inboundMessage);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSendReplenishmentMessage(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSendReplenishmentMessage(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfAllocationReplenishmentMessage>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfAllocationReplenishmentMessage>;
    }));
  }

  protected processSendReplenishmentMessage(response: HttpResponseBase): Observable<AjaxResponseOfAllocationReplenishmentMessage> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfAllocationReplenishmentMessage.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param request (optional) 
   * @return Success
   */
  startBatch(request?: StartBatchRequestDto | null | undefined): Observable<AjaxResponseOfNullableOfGuid> {
    let url_ = this.baseUrl + "/api/services/app/ControlFileDataLoad/StartBatch";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processStartBatch(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processStartBatch(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfNullableOfGuid>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfNullableOfGuid>;
    }));
  }

  protected processStartBatch(response: HttpResponseBase): Observable<AjaxResponseOfNullableOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfNullableOfGuid.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param request (optional) 
   * @return Success
   */
  endBatch(request?: EndBatchRequestDto | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/services/app/ControlFileDataLoad/EndBatch";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processEndBatch(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processEndBatch(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<void>;
        }
      } else
        return throwError(response_) as any as Observable<void>;
    }));
  }

  protected processEndBatch(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return of(null as any);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param request (optional) 
   * @return Success
   */
  load(request?: LoadControlFileRequestDto | null | undefined): Observable<DataLoadResponseDto> {
    let url_ = this.baseUrl + "/api/services/app/ControlFileDataLoad/Load";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processLoad(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLoad(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<DataLoadResponseDto>;
        }
      } else
        return throwError(response_) as any as Observable<DataLoadResponseDto>;
    }));
  }

  protected processLoad(response: HttpResponseBase): Observable<DataLoadResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = DataLoadResponseDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param oPRequestDto (optional) 
   * @return Success
   */
  oPToOMSCustomerCreation(oPRequestDto?: CustomerOPRequestDto | null | undefined): Observable<CustomerOPRequestDto> {
    let url_ = this.baseUrl + "/api/services/app/CustomerService/OPToOMSCustomerCreation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(oPRequestDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processOPToOMSCustomerCreation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processOPToOMSCustomerCreation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<CustomerOPRequestDto>;
        }
      } else
        return throwError(response_) as any as Observable<CustomerOPRequestDto>;
    }));
  }

  protected processOPToOMSCustomerCreation(response: HttpResponseBase): Observable<CustomerOPRequestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CustomerOPRequestDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param addressOPRequestDto (optional) 
   * @return Success
   */
  oPToOMSCustomerAddressCreation(addressOPRequestDto?: CustomerAddressOPRequestDto | null | undefined): Observable<CustomerAddressOPRequestDto> {
    let url_ = this.baseUrl + "/api/services/app/CustomerService/OPToOMSCustomerAddressCreation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(addressOPRequestDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processOPToOMSCustomerAddressCreation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processOPToOMSCustomerAddressCreation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<CustomerAddressOPRequestDto>;
        }
      } else
        return throwError(response_) as any as Observable<CustomerAddressOPRequestDto>;
    }));
  }

  protected processOPToOMSCustomerAddressCreation(response: HttpResponseBase): Observable<CustomerAddressOPRequestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CustomerAddressOPRequestDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param tenantId (optional) 
   * @return Success
   */
  generateCustomerAccountNumber(tenantId?: number | null | undefined): Observable<string> {
    let url_ = this.baseUrl + "/api/services/app/CustomerService/GenerateCustomerAccountNumber?";
    if (tenantId !== undefined && tenantId !== null)
      url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGenerateCustomerAccountNumber(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGenerateCustomerAccountNumber(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<string>;
        }
      } else
        return throwError(response_) as any as Observable<string>;
    }));
  }

  protected processGenerateCustomerAccountNumber(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param tenantId (optional) 
   * @return Success
   */
  generateAddressLocationId(tenantId?: number | null | undefined): Observable<string> {
    let url_ = this.baseUrl + "/api/services/app/CustomerService/GenerateAddressLocationId?";
    if (tenantId !== undefined && tenantId !== null)
      url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGenerateAddressLocationId(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGenerateAddressLocationId(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<string>;
        }
      } else
        return throwError(response_) as any as Observable<string>;
    }));
  }

  protected processGenerateAddressLocationId(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param customerDto (optional) 
   * @return Success
   */
  checkCustomerAddressFuzzyMatch(customerDto?: CustomerSPSearchDto | null | undefined): Observable<CustomerMatchScore> {
    let url_ = this.baseUrl + "/api/services/app/CustomerService/CheckCustomerAddressFuzzyMatch";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(customerDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_))
      .pipe(mergeMap(transformedOptions_ => this.http.request("post", url_, transformedOptions_)))
      .pipe(mergeMap((response_: any) => this.processCheckCustomerAddressFuzzyMatch(response_)))
      .pipe(catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processCheckCustomerAddressFuzzyMatch(response_ as any);
          } catch (e) {
            return throwError(e) as any as Observable<CustomerMatchScore>;
          }
        } else {
          return throwError(response_) as any as Observable<CustomerMatchScore>;
        }
      })
      );
  }

  protected processCheckCustomerAddressFuzzyMatch(response: HttpResponseBase): Observable<CustomerMatchScore> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CustomerMatchScore.fromJS(resultData200);
          return of(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return of<CustomerMatchScore>(null as any);
  }

  /**
   * @param orderLineId (optional) 
   * @return Success
   */
  deleteOrderLineItem(orderLineId?: string | null | undefined): Observable<AjaxResponseOfDeleteOrderLineResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/DeleteOrderLineItem?";
    if (orderLineId !== undefined && orderLineId !== null)
      url_ += "orderLineId=" + encodeURIComponent("" + orderLineId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("delete", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processDeleteOrderLineItem(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteOrderLineItem(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfDeleteOrderLineResultDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfDeleteOrderLineResultDto>;
    }));
  }

  protected processDeleteOrderLineItem(response: HttpResponseBase): Observable<AjaxResponseOfDeleteOrderLineResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfDeleteOrderLineResultDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * Get configured SourceCode list using programID
   * @param orderId (optional) 
   * @return Success
   */
  getProgramSourceCodeList(orderId?: string | null | undefined): Observable<AjaxResponseOfListOfDtpProgramConfigSourceCodeDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetProgramSourceCodeList?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetProgramSourceCodeList(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetProgramSourceCodeList(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfListOfDtpProgramConfigSourceCodeDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfListOfDtpProgramConfigSourceCodeDto>;
    }));
  }

  protected processGetProgramSourceCodeList(response: HttpResponseBase): Observable<AjaxResponseOfListOfDtpProgramConfigSourceCodeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfListOfDtpProgramConfigSourceCodeDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  validateOrder(orderId?: string | null | undefined): Observable<boolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/ValidateOrder?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processValidateOrder(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processValidateOrder(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<boolean>;
        }
      } else
        return throwError(response_) as any as Observable<boolean>;
    }));
  }

  protected processValidateOrder(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  validateCustomerWithOrderId(orderId?: string | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/ValidateCustomerWithOrderId?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(
      mergeMap(transformedOptions_ => this.http.request("post", url_, transformedOptions_)),
      mergeMap((response_: any) => this.processValidateCustomerWithOrderId(response_)),
      catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processValidateCustomerWithOrderId(response_ as any);
          } catch (e) {
            return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
          }
        } else {
          return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
        }
      })
    );
  }

  protected processValidateCustomerWithOrderId(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of<AjaxResponseOfBoolean>(null as any);
  }

  /**
       * @return Success
       */
  getCustomerOrderTypes(): Observable<AjaxResponseOfListOfCustomerOrderTypeDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetCustomerOrderTypes";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(
      mergeMap(transformedOptions_ => this.http.request("get", url_, transformedOptions_)),
      mergeMap((response_: any) => this.processGetCustomerOrderTypes(response_)),
      catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processGetCustomerOrderTypes(response_ as any);
          } catch (e) {
            return throwError(e) as any as Observable<AjaxResponseOfListOfCustomerOrderTypeDto>;
          }
        } else {
          return throwError(response_) as any as Observable<AjaxResponseOfListOfCustomerOrderTypeDto>;
        }
      })
    );
  }

  protected processGetCustomerOrderTypes(response: HttpResponseBase): Observable<AjaxResponseOfListOfCustomerOrderTypeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfListOfCustomerOrderTypeDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap(_responseText => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of<AjaxResponseOfListOfCustomerOrderTypeDto>(null as any);
  }

  /**
   * @param notificationRequest (optional) 
   * @return Success
   */
  buildEmailRequest(notificationRequest?: NotificationRequest | null | undefined): Observable<AjaxResponseOfEmailRequest> {
    let url_ = this.baseUrl + "/api/services/app/Order/BuildEmailRequest";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(notificationRequest);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(
      mergeMap(transformedOptions_ => this.http.request("post", url_, transformedOptions_)),
      mergeMap((response_: any) => this.processBuildEmailRequest(response_)),
      catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processBuildEmailRequest(response_ as any);
          } catch (e) {
            return throwError(() => e) as any as Observable<AjaxResponseOfEmailRequest>;
          }
        } else {
          return throwError(() => response_) as any as Observable<AjaxResponseOfEmailRequest>;
        }
      })
    );
  }

  protected processBuildEmailRequest(response: HttpResponseBase): Observable<AjaxResponseOfEmailRequest> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AjaxResponseOfEmailRequest.fromJS(resultData200);
          return of(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return of<AjaxResponseOfEmailRequest>(null as any);
  }

  /**
   * @param emailRequest (optional) 
   * @return Success
   */
  sendEmailCommunication(emailRequest?: EmailRequest | null | undefined): Observable<AjaxResponseOfEmailResponse> {
    let url_ = this.baseUrl + "/api/services/app/Order/SendEmailCommunication";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(emailRequest);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(
      mergeMap(transformedOptions_ => this.http.request("post", url_, transformedOptions_)),
      mergeMap((response_: any) => this.processSendEmailCommunication(response_)),
      catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processSendEmailCommunication(response_ as any);
          } catch (e) {
            return throwError(() => e) as any as Observable<AjaxResponseOfEmailResponse>;
          }
        } else {
          return throwError(() => response_) as any as Observable<AjaxResponseOfEmailResponse>;
        }
      })
    );
  }

  protected processSendEmailCommunication(response: HttpResponseBase): Observable<AjaxResponseOfEmailResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AjaxResponseOfEmailResponse.fromJS(resultData200);
          return of(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return of<AjaxResponseOfEmailResponse>(null as any);
  }

  /**
   * @param order3plStatusRequestDto (optional) 
   * @return Success
   */
  getWebhookOrderStatus(order3plStatusRequestDto?: Order3PLStatusRequestDto | null | undefined): Observable<Order3PLStatusResponseDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetWebhookOrderStatus";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(order3plStatusRequestDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(
      mergeMap(transformedOptions_ => this.http.request("post", url_, transformedOptions_)),
      mergeMap((response_: any) => this.processGetWebhookOrderStatus(response_)),
      catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processGetWebhookOrderStatus(response_ as any);
          } catch (e) {
            return throwError(() => e) as any as Observable<Order3PLStatusResponseDto>;
          }
        } else {
          return throwError(() => response_) as any as Observable<Order3PLStatusResponseDto>;
        }
      })
    );
  }

  protected processGetWebhookOrderStatus(response: HttpResponseBase): Observable<Order3PLStatusResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Order3PLStatusResponseDto.fromJS(resultData200);
          return of(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return of<Order3PLStatusResponseDto>(null as any);
  }

  /**
   * @param statusHistoryRequestDto (optional) 
   * @return Success
   */
  getWebhookOrderStatusHistory(statusHistoryRequestDto?: Order3PLStatusHistoryRequestDto | null | undefined): Observable<Order3PLStatusHistoryResponseDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetWebhookOrderStatusHistory";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(statusHistoryRequestDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(
      mergeMap(transformedOptions_ => this.http.request("post", url_, transformedOptions_)),
      mergeMap((response_: any) => this.processGetWebhookOrderStatusHistory(response_)),
      catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processGetWebhookOrderStatusHistory(response_ as any);
          } catch (e) {
            return throwError(() => e) as any as Observable<Order3PLStatusHistoryResponseDto>;
          }
        } else {
          return throwError(() => response_) as any as Observable<Order3PLStatusHistoryResponseDto>;
        }
      })
    );
  }

  protected processGetWebhookOrderStatusHistory(response: HttpResponseBase): Observable<Order3PLStatusHistoryResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Order3PLStatusHistoryResponseDto.fromJS(resultData200);
          return of(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return of<Order3PLStatusHistoryResponseDto>(null as any);
  }

  /**
   * @param integrationOrderDto (optional) 
   * @param tenantId (optional) 
   * @return Success
   */
  createWebhookOrderAllowAnonymous(integrationOrderDto?: Order3PLRequestDto | null | undefined, tenantId?: number | null | undefined): Observable<Order3PLResponseDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/CreateWebhookOrderAllowAnonymous?";
    if (tenantId !== undefined && tenantId !== null)
      url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(integrationOrderDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(
      mergeMap(transformedOptions_ => this.http.request("post", url_, transformedOptions_)),
      mergeMap((response_: any) => this.processCreateWebhookOrderAllowAnonymous(response_)),
      catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processCreateWebhookOrderAllowAnonymous(response_ as any);
          } catch (e) {
            return throwError(() => e) as any as Observable<Order3PLResponseDto>;
          }
        } else {
          return throwError(() => response_) as any as Observable<Order3PLResponseDto>;
        }
      })
    );
  }

  protected processCreateWebhookOrderAllowAnonymous(response: HttpResponseBase): Observable<Order3PLResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Order3PLResponseDto.fromJS(resultData200);
          return of(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return of<Order3PLResponseDto>(null as any);
  }

  /**
   * @param filter (optional) 
   * @return Success
   */
  searchOrders(filter?: OrderSearchFilterDto | null | undefined): Observable<AjaxResponseOfPagedResultOfOrderSearchDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/SearchOrders";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(filter);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSearchOrders(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchOrders(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPagedResultOfOrderSearchDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPagedResultOfOrderSearchDto>;
    }));
  }

  protected processSearchOrders(response: HttpResponseBase): Observable<AjaxResponseOfPagedResultOfOrderSearchDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPagedResultOfOrderSearchDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param filter (optional) 
   * @return Success
   */
  searchExceptionOrdersForMitigation(filter?: MitigationOrderSearchFilterDto | null | undefined): Observable<AjaxResponseOfPagedResultOfMitigationOrderDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/SearchExceptionOrdersForMitigation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(filter);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSearchExceptionOrdersForMitigation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchExceptionOrdersForMitigation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPagedResultOfMitigationOrderDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPagedResultOfMitigationOrderDto>;
    }));
  }

  protected processSearchExceptionOrdersForMitigation(response: HttpResponseBase): Observable<AjaxResponseOfPagedResultOfMitigationOrderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPagedResultOfMitigationOrderDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param filter (optional) 
   * @return Success
   */
  searchOnHoldOrdersForMitigation(filter?: MitigationOnHoldOrderFilterDto | null | undefined): Observable<AjaxResponseOfPagedResultOfMitigationOnHoldOrderDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/SearchOnHoldOrdersForMitigation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(filter);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSearchOnHoldOrdersForMitigation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchOnHoldOrdersForMitigation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPagedResultOfMitigationOnHoldOrderDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPagedResultOfMitigationOnHoldOrderDto>;
    }));
  }

  protected processSearchOnHoldOrdersForMitigation(response: HttpResponseBase): Observable<AjaxResponseOfPagedResultOfMitigationOnHoldOrderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPagedResultOfMitigationOnHoldOrderDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param filter (optional) 
   * @return Success
   */
  searchDataEntryOrders(filter?: DataEntryOrdersSearchFilterDto | null | undefined): Observable<AjaxResponseOfPagedResultOfDataEntryOrderSearchDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/SearchDataEntryOrders";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(filter);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSearchDataEntryOrders(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchDataEntryOrders(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPagedResultOfDataEntryOrderSearchDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPagedResultOfDataEntryOrderSearchDto>;
    }));
  }

  protected processSearchDataEntryOrders(response: HttpResponseBase): Observable<AjaxResponseOfPagedResultOfDataEntryOrderSearchDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPagedResultOfDataEntryOrderSearchDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  getOrderInvestigation(orderId?: string | null | undefined): Observable<AjaxResponseOfPageValidationOfInvestigationDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetOrderInvestigation?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderInvestigation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderInvestigation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfInvestigationDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfInvestigationDto>;
    }));
  }

  protected processGetOrderInvestigation(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfInvestigationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfInvestigationDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param src (optional) 
   * @return Success
   */
  saveOrderInvestigation(src?: InvestigationDto | null | undefined): Observable<AjaxResponseOfPageValidationOfInvestigationDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/SaveOrderInvestigation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(src);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSaveOrderInvestigation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSaveOrderInvestigation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfInvestigationDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfInvestigationDto>;
    }));
  }

  protected processSaveOrderInvestigation(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfInvestigationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfInvestigationDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @param offerStatusId (optional) 
   * @param activityTypeId (optional) 
   * @param formId (optional) 
   * @return Success
   */
  updateOfferStatus(orderId?: string | null | undefined, offerStatusId?: string | null | undefined, activityTypeId?: string | null | undefined, formId?: string | null | undefined): Observable<AjaxResponseOfString> {
    let url_ = this.baseUrl + "/api/services/app/Order/UpdateOfferStatus?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    if (offerStatusId !== undefined && offerStatusId !== null)
      url_ += "offerStatusId=" + encodeURIComponent("" + offerStatusId) + "&";
    if (activityTypeId !== undefined && activityTypeId !== null)
      url_ += "activityTypeId=" + encodeURIComponent("" + activityTypeId) + "&";
    if (formId !== undefined && formId !== null)
      url_ += "formId=" + encodeURIComponent("" + formId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUpdateOfferStatus(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateOfferStatus(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfString>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfString>;
    }));
  }

  protected processUpdateOfferStatus(response: HttpResponseBase): Observable<AjaxResponseOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AjaxResponseOfString.fromJS(resultData200);
          return of(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return of<AjaxResponseOfString>(null as any);
  }

  /**
   * @param ruleCode (optional) 
   * @param orderId (optional) 
   * @param orderLineId (optional) 
   * @return Success
   */
  getInvestigationCurrentValueDto(ruleCode?: string | null | undefined, orderId?: string | null | undefined, orderLineId?: string | null | undefined): Observable<AjaxResponseOfInvestigationCurrentValueDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetInvestigationCurrentValueDto?";
    if (ruleCode !== undefined && ruleCode !== null)
      url_ += "RuleCode=" + encodeURIComponent("" + ruleCode) + "&";
    if (orderId !== undefined && orderId !== null)
      url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
    if (orderLineId !== undefined && orderLineId !== null)
      url_ += "OrderLineId=" + encodeURIComponent("" + orderLineId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetInvestigationCurrentValueDto(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetInvestigationCurrentValueDto(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfInvestigationCurrentValueDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfInvestigationCurrentValueDto>;
    }));
  }

  protected processGetInvestigationCurrentValueDto(response: HttpResponseBase): Observable<AjaxResponseOfInvestigationCurrentValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfInvestigationCurrentValueDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  getOrderById(id?: string | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetOrderById?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderDto>;
    }));
  }

  protected processGetOrderById(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  getOrderHcpSalesRepDetailsById(id?: string | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderHcpSalesRepDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetOrderHcpSalesRepDetailsById?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderHcpSalesRepDetailsById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderHcpSalesRepDetailsById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderHcpSalesRepDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderHcpSalesRepDto>;
    }));
  }

  protected processGetOrderHcpSalesRepDetailsById(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderHcpSalesRepDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderHcpSalesRepDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param src (optional) 
   * @return Success
   */
  updateHcpSalesRepDetails(src?: OrderHcpSalesRepDto | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderHcpSalesRepDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/UpdateHcpSalesRepDetails";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(src);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUpdateHcpSalesRepDetails(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateHcpSalesRepDetails(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderHcpSalesRepDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderHcpSalesRepDto>;
    }));
  }

  protected processUpdateHcpSalesRepDetails(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderHcpSalesRepDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderHcpSalesRepDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  getOrderAttachmentsAndCommentsByOrderId(id?: string | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetOrderAttachmentsAndCommentsByOrderId?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderAttachmentsAndCommentsByOrderId(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderAttachmentsAndCommentsByOrderId(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto>;
    }));
  }

  protected processGetOrderAttachmentsAndCommentsByOrderId(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  updateOrderAttachmentsAndComments(dto?: OrderAttachmentAndCommentUpdateDto | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderAttachmentsAndComments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUpdateOrderAttachmentsAndComments(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateOrderAttachmentsAndComments(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto>;
    }));
  }

  protected processUpdateOrderAttachmentsAndComments(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  getOrderDetailsById(id?: string | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailsById?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderDetailsById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderDetailsById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
    }));
  }

  protected processGetOrderDetailsById(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderDetailsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  getOnHoldHistoryList(id?: string | null | undefined): Observable<AjaxResponseOfListOfOnHoldHistoryDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetOnHoldHistoryList?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOnHoldHistoryList(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOnHoldHistoryList(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfListOfOnHoldHistoryDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfListOfOnHoldHistoryDto>;
    }));
  }

  protected processGetOnHoldHistoryList(response: HttpResponseBase): Observable<AjaxResponseOfListOfOnHoldHistoryDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfListOfOnHoldHistoryDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  updateOrderHeader(dto?: OrderDto | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderHeader";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUpdateOrderHeader(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateOrderHeader(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
    }));
  }

  protected processUpdateOrderHeader(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderDetailsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  updateOrderDetails(dto?: OrderDetailsDto | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderDetails";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUpdateOrderDetails(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateOrderDetails(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
    }));
  }

  protected processUpdateOrderDetails(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderDetailsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  productLotInventoryValidation(dto?: ProductLotInventoryValidationDto | null | undefined): Observable<AjaxResponseOfProductLotInventoryValidationDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/ProductLotInventoryValidation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(
      mergeMap(transformedOptions_ => this.http.request("post", url_, transformedOptions_)),
      mergeMap((response_: any) => this.processProductLotInventoryValidation(response_)),
      catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processProductLotInventoryValidation(response_ as any);
          } catch (e) {
            return throwError(() => e) as any as Observable<AjaxResponseOfProductLotInventoryValidationDto>;
          }
        } else {
          return throwError(() => response_) as any as Observable<AjaxResponseOfProductLotInventoryValidationDto>;
        }
      })
    );
  }

  protected processProductLotInventoryValidation(response: HttpResponseBase): Observable<AjaxResponseOfProductLotInventoryValidationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AjaxResponseOfProductLotInventoryValidationDto.fromJS(resultData200);
          return of(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return of<AjaxResponseOfProductLotInventoryValidationDto>(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  getOrderCancelRequestStatus(orderId?: string | null | undefined): Observable<AjaxResponseOfCancelOrderRequestStatusDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetOrderCancelRequestStatus?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderCancelRequestStatus(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderCancelRequestStatus(response_ as any);
        } catch (e) {
          return throwError(() => e) as any as Observable<AjaxResponseOfCancelOrderRequestStatusDto>;
        }
      } else
        return throwError(() => response_) as any as Observable<AjaxResponseOfCancelOrderRequestStatusDto>;
    }));
  }

  protected processGetOrderCancelRequestStatus(response: HttpResponseBase): Observable<AjaxResponseOfCancelOrderRequestStatusDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfCancelOrderRequestStatusDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  requestToCancelOrder(dto?: CancelOrderRequestDto | null | undefined): Observable<AjaxResponseOfCancelOrderRequestStatusDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/RequestToCancelOrder";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processRequestToCancelOrder(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processRequestToCancelOrder(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfCancelOrderRequestStatusDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfCancelOrderRequestStatusDto>;
    }));
  }

  protected processRequestToCancelOrder(response: HttpResponseBase): Observable<AjaxResponseOfCancelOrderRequestStatusDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfCancelOrderRequestStatusDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  cancelOrder(dto?: CancelOrderInSamplicityRequestDto | null | undefined): Observable<AjaxResponseOfCancelOrderInSamplicityResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/CancelOrder";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processCancelOrder(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCancelOrder(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfCancelOrderInSamplicityResultDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfCancelOrderInSamplicityResultDto>;
    }));
  }

  protected processCancelOrder(response: HttpResponseBase): Observable<AjaxResponseOfCancelOrderInSamplicityResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfCancelOrderInSamplicityResultDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  bulkCancelOrder(dto?: BulkCancelOrderInSamplicityRequestDto | null | undefined): Observable<AjaxResponseOfBulkCancelOrderInSamplicityResponseDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/BulkCancelOrder";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processBulkCancelOrder(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processBulkCancelOrder(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBulkCancelOrderInSamplicityResponseDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBulkCancelOrderInSamplicityResponseDto>;
    }));
  }

  protected processBulkCancelOrder(response: HttpResponseBase): Observable<AjaxResponseOfBulkCancelOrderInSamplicityResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBulkCancelOrderInSamplicityResponseDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  generateOfferSrfDocumentForOrder(orderId?: string | null | undefined): Observable<AjaxResponseOfString> {
    let url_ = this.baseUrl + "/api/services/app/Order/GenerateOfferSrfDocumentForOrder?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGenerateOfferSrfDocumentForOrder(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGenerateOfferSrfDocumentForOrder(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfString>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfString>;
    }));
  }

  protected processGenerateOfferSrfDocumentForOrder(response: HttpResponseBase): Observable<AjaxResponseOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfString.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  saveSelectDayVerification(dto?: SelectDayVerificationDto | null | undefined): Observable<AjaxResponseOfTask> {
    let url_ = this.baseUrl + "/api/services/app/Order/SaveSelectDayVerification";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSaveSelectDayVerification(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSaveSelectDayVerification(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfTask>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfTask>;
    }));
  }

  protected processSaveSelectDayVerification(response: HttpResponseBase): Observable<AjaxResponseOfTask> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfTask.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  getSelectDayVerificationInformation(orderId?: string | null | undefined): Observable<AjaxResponseOfSelectDayVerificationDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetSelectDayVerificationInformation?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetSelectDayVerificationInformation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSelectDayVerificationInformation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfSelectDayVerificationDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfSelectDayVerificationDto>;
    }));
  }

  protected processGetSelectDayVerificationInformation(response: HttpResponseBase): Observable<AjaxResponseOfSelectDayVerificationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfSelectDayVerificationDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  createOrderPlitInvestigation(dto?: OrderPlitInvestigationDto | null | undefined): Observable<AjaxResponseOfTask> {
    let url_ = this.baseUrl + "/api/services/app/Order/CreateOrderPlitInvestigation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processCreateOrderPlitInvestigation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateOrderPlitInvestigation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfTask>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfTask>;
    }));
  }

  protected processCreateOrderPlitInvestigation(response: HttpResponseBase): Observable<AjaxResponseOfTask> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfTask.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  getLostInTransitEventConfirmation(orderId?: string | null | undefined): Observable<AjaxResponseOfLostInTransitConfirmationDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetLostInTransitEventConfirmation?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetLostInTransitEventConfirmation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetLostInTransitEventConfirmation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfLostInTransitConfirmationDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfLostInTransitConfirmationDto>;
    }));
  }

  protected processGetLostInTransitEventConfirmation(response: HttpResponseBase): Observable<AjaxResponseOfLostInTransitConfirmationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfLostInTransitConfirmationDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  saveLostInTransitEventConfirmation(dto?: LostInTransitConfirmationDto | null | undefined): Observable<AjaxResponseOfTask> {
    let url_ = this.baseUrl + "/api/services/app/Order/SaveLostInTransitEventConfirmation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSaveLostInTransitEventConfirmation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSaveLostInTransitEventConfirmation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfTask>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfTask>;
    }));
  }

  protected processSaveLostInTransitEventConfirmation(response: HttpResponseBase): Observable<AjaxResponseOfTask> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfTask.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  getAllocationReviewLineItemDetailsById(id?: string | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetAllocationReviewLineItemDetailsById?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetAllocationReviewLineItemDetailsById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllocationReviewLineItemDetailsById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
    }));
  }

  protected processGetAllocationReviewLineItemDetailsById(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderDetailsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }
  protected processValidateShippedDateByOrder(response: HttpResponseBase): Observable<AjaxResponseOfSSDCalculationResultEnum> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        mergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AjaxResponseOfSSDCalculationResultEnum.fromJS(resultData200);
          return of(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        mergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return of(null as any);
  }

  /**
 * @param customerId (optional) 
 * @return Success
 */
  getCustomerConfigurationDetails(customerId?: string | null | undefined): Observable<TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetCustomerConfigurationDetails?";
    if (customerId !== undefined && customerId !== null)
      url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(
      mergeMap(transformedOptions_ => this.http.request("get", url_, transformedOptions_)),
      mergeMap((response_: any) => this.processGetCustomerConfigurationDetails(response_)),
      catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processGetCustomerConfigurationDetails(response_ as any);
          } catch (e) {
            return throwError(() => e) as any as Observable<TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32>;
          }
        } else {
          return throwError(() => response_) as any as Observable<TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32>;
        }
      })
    );
  }

  protected processGetCustomerConfigurationDetails(response: HttpResponseBase): Observable<TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          let result200: any = null;
          let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32.fromJS(resultData200);
          return of(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        mergeMap(_responseText => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return of<TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32>(null as any);
  }


  /**
   * @param orderDetailsDto (optional) 
   * @return Success
   */
  validateShippedDateByOrder(orderDetailsDto?: OrderDetailsDto | null | undefined): Observable<AjaxResponseOfSSDCalculationResultEnum> {
    let url_ = this.baseUrl + "/api/services/app/Order/ValidateShippedDateByOrder";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(orderDetailsDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(
      mergeMap(transformedOptions_ => this.http.request("post", url_, transformedOptions_)),
      mergeMap((response_: any) => this.processValidateShippedDateByOrder(response_)),
      catchError((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processValidateShippedDateByOrder(response_ as any);
          } catch (e) {
            return throwError(() => e) as any as Observable<AjaxResponseOfSSDCalculationResultEnum>;
          }
        } else {
          return throwError(() => response_) as any as Observable<AjaxResponseOfSSDCalculationResultEnum>;
        }
      })
    );
  }
  /**
   * @param dto (optional) 
   * @return Success
   */
  updateAllocationReviewOrderDetails(dto?: OrderDetailsDto | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/UpdateAllocationReviewOrderDetails";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUpdateAllocationReviewOrderDetails(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateAllocationReviewOrderDetails(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
    }));
  }

  protected processUpdateAllocationReviewOrderDetails(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderDetailsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  submitAllocationReviewDetailsRevalidation(dto?: OrderDetailsDto | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/SubmitAllocationReviewDetailsRevalidation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSubmitAllocationReviewDetailsRevalidation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSubmitAllocationReviewDetailsRevalidation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
    }));
  }

  protected processSubmitAllocationReviewDetailsRevalidation(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderDetailsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @return Success
   */
  getSalesOrderTypes(): Observable<AjaxResponseOfIListOfSalesOrderTypesDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetSalesOrderTypes";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetSalesOrderTypes(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSalesOrderTypes(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfIListOfSalesOrderTypesDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfIListOfSalesOrderTypesDto>;
    }));
  }

  protected processGetSalesOrderTypes(response: HttpResponseBase): Observable<AjaxResponseOfIListOfSalesOrderTypesDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfIListOfSalesOrderTypesDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param getOrdersSalesTypesDtoRequest (optional) 
   * @return Success
   */
  getOrderDetailsFor945Edi(getOrdersSalesTypesDtoRequest?: GetOrdersSalesTypesDtoRequest | null | undefined): Observable<AjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDetailsFor945Edi";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(getOrdersSalesTypesDtoRequest);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderDetailsFor945Edi(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderDetailsFor945Edi(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse>;
    }));
  }

  protected processGetOrderDetailsFor945Edi(response: HttpResponseBase): Observable<AjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderDetails (optional) 
   * @return Success
   */
  releaseNonRejectProduct(orderDetails?: OrderDetailsDto | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/ReleaseNonRejectProduct";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(orderDetails);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processReleaseNonRejectProduct(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processReleaseNonRejectProduct(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processReleaseNonRejectProduct(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  createSomsRequest(orderId?: string | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/CreateSomsRequest?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processCreateSomsRequest(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processCreateSomsRequest(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processCreateSomsRequest(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  downloadSomsRequestContent(orderId?: string | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/DownloadSomsRequestContent?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processDownloadSomsRequestContent(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDownloadSomsRequestContent(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processDownloadSomsRequestContent(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderNumbers (optional) 
   * @return Success
   */
  processSomsOrders(orderNumbers?: string[] | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/ProcessSomsOrders";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(orderNumbers);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processProcessSomsOrders(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processProcessSomsOrders(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processProcessSomsOrders(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param somsOrderStatusResponse (optional) 
   * @return Success
   */
  processSomsResponse(somsOrderStatusResponse?: SomsOrderResponseDto[] | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/ProcessSomsResponse";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(somsOrderStatusResponse);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processProcessSomsResponse(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processProcessSomsResponse(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processProcessSomsResponse(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  getOrderDeliveryDetailsById(id?: string | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetOrderDeliveryDetailsById?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderDeliveryDetailsById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderDeliveryDetailsById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto>;
    }));
  }

  protected processGetOrderDeliveryDetailsById(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  updateOrderDeliveryDetails(dto?: OrderDeliveryDetailsDto | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/UpdateOrderDeliveryDetails";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUpdateOrderDeliveryDetails(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateOrderDeliveryDetails(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto>;
    }));
  }

  protected processUpdateOrderDeliveryDetails(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * Get shipment, Delivery, Date validity and order status
   * @param orderRecievedDate (optional) 
   * @param orderDeliveryType (optional) 
   * @param desiredDeliveryDate (optional) 
   * @param orderDeliverySelectDays (optional) 
   * @param programDeliverySelectDays (optional) 
   * @param programShipDays (optional) 
   * @param shipmentSla (optional) 
   * @param maxDaysToDeliver (optional) 
   * @param allowNonWorkingDaysIntransit (optional) 
   * @return Success
   */
  getDeliveryAndShipmentDates(orderRecievedDate?: Date | null | undefined, orderDeliveryType?: string | null | undefined, desiredDeliveryDate?: Date | null | undefined, orderDeliverySelectDays?: string | null | undefined, programDeliverySelectDays?: string | null | undefined, programShipDays?: string | null | undefined, shipmentSla?: number | null | undefined, maxDaysToDeliver?: number | null | undefined, allowNonWorkingDaysIntransit?: boolean | null | undefined): Observable<AjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetDeliveryAndShipmentDates?";
    if (orderRecievedDate !== undefined && orderRecievedDate !== null)
      url_ += "orderRecievedDate=" + encodeURIComponent(orderRecievedDate ? "" + orderRecievedDate.toISOString() : "") + "&";
    if (orderDeliveryType !== undefined && orderDeliveryType !== null)
      url_ += "orderDeliveryType=" + encodeURIComponent("" + orderDeliveryType) + "&";
    if (desiredDeliveryDate !== undefined && desiredDeliveryDate !== null)
      url_ += "desiredDeliveryDate=" + encodeURIComponent(desiredDeliveryDate ? "" + desiredDeliveryDate.toISOString() : "") + "&";
    if (orderDeliverySelectDays !== undefined && orderDeliverySelectDays !== null)
      url_ += "orderDeliverySelectDays=" + encodeURIComponent("" + orderDeliverySelectDays) + "&";
    if (programDeliverySelectDays !== undefined && programDeliverySelectDays !== null)
      url_ += "programDeliverySelectDays=" + encodeURIComponent("" + programDeliverySelectDays) + "&";
    if (programShipDays !== undefined && programShipDays !== null)
      url_ += "programShipDays=" + encodeURIComponent("" + programShipDays) + "&";
    if (shipmentSla !== undefined && shipmentSla !== null)
      url_ += "shipmentSla=" + encodeURIComponent("" + shipmentSla) + "&";
    if (maxDaysToDeliver !== undefined && maxDaysToDeliver !== null)
      url_ += "maxDaysToDeliver=" + encodeURIComponent("" + maxDaysToDeliver) + "&";
    if (allowNonWorkingDaysIntransit !== undefined && allowNonWorkingDaysIntransit !== null)
      url_ += "allowNonWorkingDaysIntransit=" + encodeURIComponent("" + allowNonWorkingDaysIntransit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetDeliveryAndShipmentDates(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDeliveryAndShipmentDates(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid>;
    }));
  }

  protected processGetDeliveryAndShipmentDates(response: HttpResponseBase): Observable<AjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  getShippingAddressRequiresReformattingOrderExceptionDetails(id?: string | null | undefined): Observable<AjaxResponseOfShippingAddressWithFieldContraintsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetShippingAddressRequiresReformattingOrderExceptionDetails?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetShippingAddressRequiresReformattingOrderExceptionDetails(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetShippingAddressRequiresReformattingOrderExceptionDetails(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfShippingAddressWithFieldContraintsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfShippingAddressWithFieldContraintsDto>;
    }));
  }

  protected processGetShippingAddressRequiresReformattingOrderExceptionDetails(response: HttpResponseBase): Observable<AjaxResponseOfShippingAddressWithFieldContraintsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfShippingAddressWithFieldContraintsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param shippingAddressDto (optional) 
   * @return Success
   */
  handleShippingAddressRequiresReformattingOrderException(shippingAddressDto?: ShippingAddressDto | null | undefined): Observable<AjaxResponseOfShippingAddressDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/HandleShippingAddressRequiresReformattingOrderException";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(shippingAddressDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processHandleShippingAddressRequiresReformattingOrderException(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHandleShippingAddressRequiresReformattingOrderException(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfShippingAddressDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfShippingAddressDto>;
    }));
  }

  protected processHandleShippingAddressRequiresReformattingOrderException(response: HttpResponseBase): Observable<AjaxResponseOfShippingAddressDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfShippingAddressDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param src (optional) 
   * @return Success
   */
  handleInactiveHCPOrderException(src?: InactiveHCPOrderExceptionHandlerDto | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/HandleInactiveHCPOrderException";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(src);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processHandleInactiveHCPOrderException(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHandleInactiveHCPOrderException(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processHandleInactiveHCPOrderException(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  getBackorderLineItemDetails(orderId?: string | null | undefined): Observable<AjaxResponseOfBackorderAdjustmentDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetBackorderLineItemDetails?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetBackorderLineItemDetails(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetBackorderLineItemDetails(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBackorderAdjustmentDetailsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBackorderAdjustmentDetailsDto>;
    }));
  }

  protected processGetBackorderLineItemDetails(response: HttpResponseBase): Observable<AjaxResponseOfBackorderAdjustmentDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBackorderAdjustmentDetailsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param src (optional) 
   * @return Success
   */
  submitBackorderAdjustmentForRevalidation(src?: BackorderAdjustmentSubmitForRevalidationDto | null | undefined): Observable<AjaxResponse> {
    let url_ = this.baseUrl + "/api/services/app/Order/SubmitBackorderAdjustmentForRevalidation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(src);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSubmitBackorderAdjustmentForRevalidation(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSubmitBackorderAdjustmentForRevalidation(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponse>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponse>;
    }));
  }

  protected processSubmitBackorderAdjustmentForRevalidation(response: HttpResponseBase): Observable<AjaxResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponse.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param src (optional) 
   * @return Success
   */
  releaseOrderFromBlackoutHold(src?: OrderBlackoutHoldReleaseReasonDto | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/ReleaseOrderFromBlackoutHold";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(src);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processReleaseOrderFromBlackoutHold(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processReleaseOrderFromBlackoutHold(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processReleaseOrderFromBlackoutHold(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param src (optional) 
   * @return Success
   */
  releaseAllocationReviewOrder(src?: OrderDetailsDto | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/ReleaseAllocationReviewOrder";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(src);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processReleaseAllocationReviewOrder(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processReleaseAllocationReviewOrder(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processReleaseAllocationReviewOrder(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  releaseOrderFromOnHold(dto?: OrderOnHoldReleaseReasonDto | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/ReleaseOrderFromOnHold";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processReleaseOrderFromOnHold(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processReleaseOrderFromOnHold(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processReleaseOrderFromOnHold(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  bulkReleaseOrderFromOnHold(dto?: BulkReleaseOnHoldOrderRequestDto | null | undefined): Observable<AjaxResponseOfBulkReleaseOnHoldOrderResponseDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/BulkReleaseOrderFromOnHold";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processBulkReleaseOrderFromOnHold(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processBulkReleaseOrderFromOnHold(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBulkReleaseOnHoldOrderResponseDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBulkReleaseOnHoldOrderResponseDto>;
    }));
  }

  protected processBulkReleaseOrderFromOnHold(response: HttpResponseBase): Observable<AjaxResponseOfBulkReleaseOnHoldOrderResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBulkReleaseOnHoldOrderResponseDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  replaceOrder(orderId?: string | null | undefined): Observable<AjaxResponseOfGuid> {
    let url_ = this.baseUrl + "/api/services/app/Order/ReplaceOrder?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processReplaceOrder(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processReplaceOrder(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfGuid>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfGuid>;
    }));
  }

  protected processReplaceOrder(response: HttpResponseBase): Observable<AjaxResponseOfGuid> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfGuid.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param aocId (optional) 
   * @return Success
   */
  getAocInvestigationById(aocId?: string | null | undefined): Observable<AjaxResponseOfAocInvestigationDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetAocInvestigationById?";
    if (aocId !== undefined && aocId !== null)
      url_ += "aocId=" + encodeURIComponent("" + aocId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetAocInvestigationById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAocInvestigationById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfAocInvestigationDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfAocInvestigationDto>;
    }));
  }

  protected processGetAocInvestigationById(response: HttpResponseBase): Observable<AjaxResponseOfAocInvestigationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfAocInvestigationDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param aoc (optional) 
   * @return Success
   */
  updateAocInvestigationById(aoc?: AocInvestigationDto | null | undefined): Observable<AjaxResponseOfAocInvestigationDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/UpdateAocInvestigationById";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(aoc);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUpdateAocInvestigationById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateAocInvestigationById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfAocInvestigationDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfAocInvestigationDto>;
    }));
  }

  protected processUpdateAocInvestigationById(response: HttpResponseBase): Observable<AjaxResponseOfAocInvestigationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfAocInvestigationDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @param communicationId (optional) 
   * @return Success
   */
  generateEAocDorForCommunication(orderId?: string | null | undefined, communicationId?: string | null | undefined): Observable<AjaxResponseOfString> {
    let url_ = this.baseUrl + "/api/services/app/Order/GenerateEAocDorForCommunication?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    if (communicationId !== undefined && communicationId !== null)
      url_ += "communicationId=" + encodeURIComponent("" + communicationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGenerateEAocDorForCommunication(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGenerateEAocDorForCommunication(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfString>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfString>;
    }));
  }

  protected processGenerateEAocDorForCommunication(response: HttpResponseBase): Observable<AjaxResponseOfString> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfString.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param svlId (optional) 
   * @return Success
   */
  getSvlInvestigationById(svlId?: string | null | undefined): Observable<AjaxResponseOfSvlInvestigationDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetSvlInvestigationById?";
    if (svlId !== undefined && svlId !== null)
      url_ += "svlId=" + encodeURIComponent("" + svlId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetSvlInvestigationById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSvlInvestigationById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfSvlInvestigationDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfSvlInvestigationDto>;
    }));
  }

  protected processGetSvlInvestigationById(response: HttpResponseBase): Observable<AjaxResponseOfSvlInvestigationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfSvlInvestigationDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param svl (optional) 
   * @return Success
   */
  updateSvlInvestigationById(svl?: SvlInvestigationDto | null | undefined): Observable<AjaxResponseOfSvlInvestigationDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/UpdateSvlInvestigationById";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(svl);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUpdateSvlInvestigationById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateSvlInvestigationById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfSvlInvestigationDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfSvlInvestigationDto>;
    }));
  }

  protected processUpdateSvlInvestigationById(response: HttpResponseBase): Observable<AjaxResponseOfSvlInvestigationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfSvlInvestigationDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param svlId (optional) 
   * @return Success
   */
  getNegativeResponseCommentsById(svlId?: string | null | undefined): Observable<AjaxResponseOfSvlNegativeResponseCommentHistoryDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetNegativeResponseCommentsById?";
    if (svlId !== undefined && svlId !== null)
      url_ += "svlId=" + encodeURIComponent("" + svlId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetNegativeResponseCommentsById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetNegativeResponseCommentsById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfSvlNegativeResponseCommentHistoryDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfSvlNegativeResponseCommentHistoryDto>;
    }));
  }

  protected processGetNegativeResponseCommentsById(response: HttpResponseBase): Observable<AjaxResponseOfSvlNegativeResponseCommentHistoryDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfSvlNegativeResponseCommentHistoryDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param svlNegativeComment (optional) 
   * @return Success
   */
  updateSvlNegativeResponseComments(svlNegativeComment?: SvlNegativeResponseCommentDto | null | undefined): Observable<AjaxResponseOfSvlNegativeResponseCommentHistoryDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/UpdateSvlNegativeResponseComments";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(svlNegativeComment);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUpdateSvlNegativeResponseComments(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUpdateSvlNegativeResponseComments(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfSvlNegativeResponseCommentHistoryDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfSvlNegativeResponseCommentHistoryDto>;
    }));
  }

  protected processUpdateSvlNegativeResponseComments(response: HttpResponseBase): Observable<AjaxResponseOfSvlNegativeResponseCommentHistoryDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfSvlNegativeResponseCommentHistoryDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  getDataEntryOrderDetailsById(orderId?: string | null | undefined): Observable<AjaxResponseOfDataEntryOrderDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetDataEntryOrderDetailsById?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetDataEntryOrderDetailsById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDataEntryOrderDetailsById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfDataEntryOrderDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfDataEntryOrderDto>;
    }));
  }

  protected processGetDataEntryOrderDetailsById(response: HttpResponseBase): Observable<AjaxResponseOfDataEntryOrderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfDataEntryOrderDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dataEntryOrder (optional) 
   * @return Success
   */
  saveDataEntryOrderDetails(dataEntryOrder?: DataEntryOrderDto | null | undefined): Observable<AjaxResponseOfDataEntryOrderDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/SaveDataEntryOrderDetails";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dataEntryOrder);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSaveDataEntryOrderDetails(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSaveDataEntryOrderDetails(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfDataEntryOrderDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfDataEntryOrderDto>;
    }));
  }

  protected processSaveDataEntryOrderDetails(response: HttpResponseBase): Observable<AjaxResponseOfDataEntryOrderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfDataEntryOrderDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param requestDto (optional) 
   * @return Success
   */
  softDeleteDataEntryOrder(requestDto?: DeleteDataEntryOrderRequestDto | null | undefined): Observable<AjaxResponseOfDeleteDataEntryOrderResultDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/SoftDeleteDataEntryOrder";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(requestDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processSoftDeleteDataEntryOrder(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSoftDeleteDataEntryOrder(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfDeleteDataEntryOrderResultDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfDeleteDataEntryOrderResultDto>;
    }));
  }

  protected processSoftDeleteDataEntryOrder(response: HttpResponseBase): Observable<AjaxResponseOfDeleteDataEntryOrderResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfDeleteDataEntryOrderResultDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param dto (optional) 
   * @return Success
   */
  uploadOrderFile(dto?: OrderFileUploadDto | null | undefined): Observable<AjaxResponseOfOrderFileUploadDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/UploadOrderFile";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUploadOrderFile(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUploadOrderFile(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfOrderFileUploadDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfOrderFileUploadDto>;
    }));
  }

  protected processUploadOrderFile(response: HttpResponseBase): Observable<AjaxResponseOfOrderFileUploadDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfOrderFileUploadDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param aocId (optional) 
   * @return Success
   */
  getSignedByTypeById(aocId?: string | null | undefined): Observable<AjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetSignedByTypeById?";
    if (aocId !== undefined && aocId !== null)
      url_ += "aocId=" + encodeURIComponent("" + aocId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetSignedByTypeById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSignedByTypeById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean>;
    }));
  }

  protected processGetSignedByTypeById(response: HttpResponseBase): Observable<AjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @param extendLock (optional) 
   * @return Success
   */
  lockOrderById(id?: string | null | undefined, extendLock?: boolean | null | undefined): Observable<AjaxResponseOfLockAckDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/LockOrderById?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    if (extendLock !== undefined && extendLock !== null)
      url_ += "extendLock=" + encodeURIComponent("" + extendLock) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processLockOrderById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processLockOrderById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfLockAckDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfLockAckDto>;
    }));
  }

  protected processLockOrderById(response: HttpResponseBase): Observable<AjaxResponseOfLockAckDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfLockAckDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  unlockOrderById(id?: string | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/UnlockOrderById?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processUnlockOrderById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processUnlockOrderById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processUnlockOrderById(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  adminUnlockOrderById(id?: string | null | undefined): Observable<AjaxResponseOfBoolean> {
    let url_ = this.baseUrl + "/api/services/app/Order/AdminUnlockOrderById?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processAdminUnlockOrderById(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processAdminUnlockOrderById(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
    }));
  }

  protected processAdminUnlockOrderById(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfBoolean.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param id (optional) 
   * @return Success
   */
  getOrderLockInfo(id?: string | null | undefined): Observable<AjaxResponseOfLockInfoDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetOrderLockInfo?";
    if (id !== undefined && id !== null)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderLockInfo(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderLockInfo(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfLockInfoDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfLockInfoDto>;
    }));
  }

  protected processGetOrderLockInfo(response: HttpResponseBase): Observable<AjaxResponseOfLockInfoDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfLockInfoDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param parentOrderId (optional) 
   * @return Success
   */
  getAssociatedOrders(parentOrderId?: string | null | undefined): Observable<AjaxResponseOfAssociatedOrderItemDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetAssociatedOrders?";
    if (parentOrderId !== undefined && parentOrderId !== null)
      url_ += "parentOrderId=" + encodeURIComponent("" + parentOrderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetAssociatedOrders(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAssociatedOrders(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfAssociatedOrderItemDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfAssociatedOrderItemDto>;
    }));
  }

  protected processGetAssociatedOrders(response: HttpResponseBase): Observable<AjaxResponseOfAssociatedOrderItemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfAssociatedOrderItemDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param parentOrderId (optional) 
   * @param submissionDate (optional) 
   * @return Success
   */
  getAllocationChildOrders(parentOrderId?: string | null | undefined, submissionDate?: Date | null | undefined): Observable<AjaxResponseOfAllocationAssociatedOrderItemDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/GetAllocationChildOrders?";
    if (parentOrderId !== undefined && parentOrderId !== null)
      url_ += "parentOrderId=" + encodeURIComponent("" + parentOrderId) + "&";
    if (submissionDate !== undefined && submissionDate !== null)
      url_ += "submissionDate=" + encodeURIComponent(submissionDate ? "" + submissionDate.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetAllocationChildOrders(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllocationChildOrders(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfAllocationAssociatedOrderItemDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfAllocationAssociatedOrderItemDto>;
    }));
  }

  protected processGetAllocationChildOrders(response: HttpResponseBase): Observable<AjaxResponseOfAllocationAssociatedOrderItemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfAllocationAssociatedOrderItemDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  validateOrderInventory(orderId?: string | null | undefined, isCalledFromOrderDetailPage?: boolean | null | undefined): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    let url_ = this.baseUrl + "/api/services/app/Order/ValidateOrderInventory?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    if (isCalledFromOrderDetailPage !== undefined && isCalledFromOrderDetailPage !== null)
      url_ += "isCalledFromOrderDetailPage=" + encodeURIComponent("" + isCalledFromOrderDetailPage) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processValidateOrderInventory(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processValidateOrderInventory(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfPageValidationOfOrderDetailsDto>;
    }));
  }

  protected processValidateOrderInventory(response: HttpResponseBase): Observable<AjaxResponseOfPageValidationOfOrderDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfPageValidationOfOrderDetailsDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @return Success
   */
  getOrderMitigationHistory(orderId?: string | null | undefined): Observable<AjaxResponseOfListOfInvestigationDto> {
    let url_ = this.baseUrl + "/api/services/app/OrderMitigation/GetOrderMitigationHistory?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderMitigationHistory(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderMitigationHistory(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfListOfInvestigationDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfListOfInvestigationDto>;
    }));
  }

  protected processGetOrderMitigationHistory(response: HttpResponseBase): Observable<AjaxResponseOfListOfInvestigationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfListOfInvestigationDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }

  /**
   * @param orderId (optional) 
   * @param orderLineId (optional) 
   * @return Success
   */
  getOrderValidationResultModal(orderId?: string | null | undefined, orderLineId?: string | null | undefined): Observable<AjaxResponseOfOrderValidationResultDto> {
    let url_ = this.baseUrl + "/api/services/app/OrderMitigation/GetOrderValidationResultModal?";
    if (orderId !== undefined && orderId !== null)
      url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
    if (orderLineId !== undefined && orderLineId !== null)
      url_ += "orderLineId=" + encodeURIComponent("" + orderLineId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(mergeMap((response_: any) => {
      return this.processGetOrderValidationResultModal(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOrderValidationResultModal(response_ as any);
        } catch (e) {
          return throwError(e) as any as Observable<AjaxResponseOfOrderValidationResultDto>;
        }
      } else
        return throwError(response_) as any as Observable<AjaxResponseOfOrderValidationResultDto>;
    }));
  }

  protected processGetOrderValidationResultModal(response: HttpResponseBase): Observable<AjaxResponseOfOrderValidationResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
    if (status === 200) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AjaxResponseOfOrderValidationResultDto.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of(null as any);
  }
}

export class AllocationReplenishmentMessage implements IAllocationReplenishmentMessage {
  source: string | undefined;
  tenantId: number | undefined;
  replenishments: AllocationReplenishmentRequestDto[] | undefined;

  constructor(data?: IAllocationReplenishmentMessage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.source = _data["source"];
      this.tenantId = _data["tenantId"];
      if (Array.isArray(_data["Replenishments"])) {
        this.replenishments = [] as any;
        for (let item of _data["Replenishments"])
          this.replenishments.push(AllocationReplenishmentRequestDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AllocationReplenishmentMessage {
    data = typeof data === 'object' ? data : {};
    let result = new AllocationReplenishmentMessage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["source"] = this.source;
    data["tenantId"] = this.tenantId;
    if (Array.isArray(this.replenishments)) {
      data["Replenishments"] = [];
      for (let item of this.replenishments)
        data["Replenishments"].push(item.toJSON());
    }
    return data;
  }

  clone(): AllocationReplenishmentMessage {
    const json = this.toJSON();
    let result = new AllocationReplenishmentMessage();
    result.init(json);
    return result;
  }
}

export interface IAllocationReplenishmentMessage {
  source: string | undefined;
  tenantId: number | undefined;
  replenishments: AllocationReplenishmentRequestDto[] | undefined;
}

export class AllocationReplenishmentRequestDto implements IAllocationReplenishmentRequestDto {
  orderId: string | undefined;
  orderNumber: string | undefined;
  hcpId: string | undefined;
  repId: string | undefined;
  territoryCode: string | undefined;
  deductRequestId: string | undefined;
  ruleCode: string | undefined;
  allocationReplenishmentItems: AllocationReplenishmentItemRequestDto[] | undefined;

  constructor(data?: IAllocationReplenishmentRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderNumber = _data["orderNumber"];
      this.hcpId = _data["hcpId"];
      this.repId = _data["repId"];
      this.territoryCode = _data["territoryCode"];
      this.deductRequestId = _data["deductRequestId"];
      this.ruleCode = _data["ruleCode"];
      if (Array.isArray(_data["allocationReplenishmentItems"])) {
        this.allocationReplenishmentItems = [] as any;
        for (let item of _data["allocationReplenishmentItems"])
          this.allocationReplenishmentItems.push(AllocationReplenishmentItemRequestDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AllocationReplenishmentRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new AllocationReplenishmentRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderNumber"] = this.orderNumber;
    data["hcpId"] = this.hcpId;
    data["repId"] = this.repId;
    data["territoryCode"] = this.territoryCode;
    data["deductRequestId"] = this.deductRequestId;
    data["ruleCode"] = this.ruleCode;
    if (Array.isArray(this.allocationReplenishmentItems)) {
      data["allocationReplenishmentItems"] = [];
      for (let item of this.allocationReplenishmentItems)
        data["allocationReplenishmentItems"].push(item.toJSON());
    }
    return data;
  }

  clone(): AllocationReplenishmentRequestDto {
    const json = this.toJSON();
    let result = new AllocationReplenishmentRequestDto();
    result.init(json);
    return result;
  }
}

export interface IAllocationReplenishmentRequestDto {
  orderId: string | undefined;
  orderNumber: string | undefined;
  hcpId: string | undefined;
  repId: string | undefined;
  territoryCode: string | undefined;
  deductRequestId: string | undefined;
  ruleCode: string | undefined;
  allocationReplenishmentItems: AllocationReplenishmentItemRequestDto[] | undefined;
}

export class AllocationReplenishmentItemRequestDto implements IAllocationReplenishmentItemRequestDto {
  itemCode: string | undefined;
  externalLineItemId: string | undefined;
  quantity: number | undefined;
  errorCode: string | undefined;
  errorMessage: string | undefined;
  isReplenished: boolean | undefined;

  constructor(data?: IAllocationReplenishmentItemRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.itemCode = _data["itemCode"];
      this.externalLineItemId = _data["externalLineItemId"];
      this.quantity = _data["quantity"];
      this.errorCode = _data["errorCode"];
      this.errorMessage = _data["errorMessage"];
      this.isReplenished = _data["isReplenished"];
    }
  }

  static fromJS(data: any): AllocationReplenishmentItemRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new AllocationReplenishmentItemRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["itemCode"] = this.itemCode;
    data["externalLineItemId"] = this.externalLineItemId;
    data["quantity"] = this.quantity;
    data["errorCode"] = this.errorCode;
    data["errorMessage"] = this.errorMessage;
    data["isReplenished"] = this.isReplenished;
    return data;
  }

  clone(): AllocationReplenishmentItemRequestDto {
    const json = this.toJSON();
    let result = new AllocationReplenishmentItemRequestDto();
    result.init(json);
    return result;
  }
}

export interface IAllocationReplenishmentItemRequestDto {
  itemCode: string | undefined;
  externalLineItemId: string | undefined;
  quantity: number | undefined;
  errorCode: string | undefined;
  errorMessage: string | undefined;
  isReplenished: boolean | undefined;
}

export class AjaxResponseOfAllocationReplenishmentMessage implements IAjaxResponseOfAllocationReplenishmentMessage {
  result: AllocationReplenishmentMessage | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfAllocationReplenishmentMessage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? AllocationReplenishmentMessage.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfAllocationReplenishmentMessage {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfAllocationReplenishmentMessage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfAllocationReplenishmentMessage {
    const json = this.toJSON();
    let result = new AjaxResponseOfAllocationReplenishmentMessage();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfAllocationReplenishmentMessage {
  result: AllocationReplenishmentMessage | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class ErrorInfo implements IErrorInfo {
  code: number | undefined;
  message: string | undefined;
  details: string | undefined;
  validationErrors: ValidationErrorInfo[] | undefined;

  constructor(data?: IErrorInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.message = _data["message"];
      this.details = _data["details"];
      if (Array.isArray(_data["validationErrors"])) {
        this.validationErrors = [] as any;
        for (let item of _data["validationErrors"])
          this.validationErrors.push(ValidationErrorInfo.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ErrorInfo {
    data = typeof data === 'object' ? data : {};
    let result = new ErrorInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["code"] = this.code;
    data["message"] = this.message;
    data["details"] = this.details;
    if (Array.isArray(this.validationErrors)) {
      data["validationErrors"] = [];
      for (let item of this.validationErrors)
        data["validationErrors"].push(item.toJSON());
    }
    return data;
  }

  clone(): ErrorInfo {
    const json = this.toJSON();
    let result = new ErrorInfo();
    result.init(json);
    return result;
  }
}

export interface IErrorInfo {
  code: number | undefined;
  message: string | undefined;
  details: string | undefined;
  validationErrors: ValidationErrorInfo[] | undefined;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
  message: string | undefined;
  members: string[] | undefined;

  constructor(data?: IValidationErrorInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.message = _data["message"];
      if (Array.isArray(_data["members"])) {
        this.members = [] as any;
        for (let item of _data["members"])
          this.members.push(item);
      }
    }
  }

  static fromJS(data: any): ValidationErrorInfo {
    data = typeof data === 'object' ? data : {};
    let result = new ValidationErrorInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["message"] = this.message;
    if (Array.isArray(this.members)) {
      data["members"] = [];
      for (let item of this.members)
        data["members"].push(item);
    }
    return data;
  }

  clone(): ValidationErrorInfo {
    const json = this.toJSON();
    let result = new ValidationErrorInfo();
    result.init(json);
    return result;
  }
}

export interface IValidationErrorInfo {
  message: string | undefined;
  members: string[] | undefined;
}

export class StartBatchRequestDto implements IStartBatchRequestDto {
  dataLoadFileName: string | undefined;
  expectedRecordCount: number | undefined;
  programCode: string | undefined;
  etlRequest: EtlDataLoadRequestDto | undefined;

  constructor(data?: IStartBatchRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dataLoadFileName = _data["dataLoadFileName"];
      this.expectedRecordCount = _data["expectedRecordCount"];
      this.programCode = _data["programCode"];
      this.etlRequest = _data["etlRequest"] ? EtlDataLoadRequestDto.fromJS(_data["etlRequest"]) : <any>undefined;
    }
  }

  static fromJS(data: any): StartBatchRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new StartBatchRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dataLoadFileName"] = this.dataLoadFileName;
    data["expectedRecordCount"] = this.expectedRecordCount;
    data["programCode"] = this.programCode;
    data["etlRequest"] = this.etlRequest ? this.etlRequest.toJSON() : <any>undefined;
    return data;
  }

  clone(): StartBatchRequestDto {
    const json = this.toJSON();
    let result = new StartBatchRequestDto();
    result.init(json);
    return result;
  }
}

export interface IStartBatchRequestDto {
  dataLoadFileName: string | undefined;
  expectedRecordCount: number | undefined;
  programCode: string | undefined;
  etlRequest: EtlDataLoadRequestDto | undefined;
}

export class EtlDataLoadRequestDto implements IEtlDataLoadRequestDto {
  tenantId: number | undefined;
  programId: string | undefined;
  storageType: string | undefined;
  sourceFileType: string | undefined;
  sourceFileHostName: string | undefined;
  sourceFileDirectoryName: string | undefined;
  sourceFileFileName: string | undefined;
  sourceFileCredentials: EtlRequestCredentialsDto | undefined;
  sourceFileMappingJson: string | undefined;
  dropFileHostName: string | undefined;
  dropFileDirectory: string | undefined;
  dropFileFileName: string | undefined;
  dropFileCredentials: EtlRequestCredentialsDto | undefined;
  isManuallyTriggered: boolean | undefined;
  maxBatchSize: number | undefined;
  delimeter: string | undefined;
  dataLoadType: string | undefined;
  sourceSystem: string | undefined;
  configurationJson: ConfigurationDto | undefined;
  tenantBlobStorageContainer: string | undefined;
  invalidErrorMessages: string | undefined;
  orderSourceId: string | undefined;
  userId: number | undefined;

  constructor(data?: IEtlDataLoadRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.programId = _data["programId"];
      this.storageType = _data["storageType"];
      this.sourceFileType = _data["sourceFileType"];
      this.sourceFileHostName = _data["sourceFileHostName"];
      this.sourceFileDirectoryName = _data["sourceFileDirectoryName"];
      this.sourceFileFileName = _data["sourceFileFileName"];
      this.sourceFileCredentials = _data["sourceFileCredentials"] ? EtlRequestCredentialsDto.fromJS(_data["sourceFileCredentials"]) : <any>undefined;
      this.sourceFileMappingJson = _data["sourceFileMappingJson"];
      this.dropFileHostName = _data["dropFileHostName"];
      this.dropFileDirectory = _data["dropFileDirectory"];
      this.dropFileFileName = _data["dropFileFileName"];
      this.dropFileCredentials = _data["dropFileCredentials"] ? EtlRequestCredentialsDto.fromJS(_data["dropFileCredentials"]) : <any>undefined;
      this.isManuallyTriggered = _data["isManuallyTriggered"];
      this.maxBatchSize = _data["maxBatchSize"];
      this.delimeter = _data["Delimeter"];
      this.dataLoadType = _data["dataLoadType"];
      this.sourceSystem = _data["sourceSystem"];
      this.configurationJson = _data["configurationJson"] ? ConfigurationDto.fromJS(_data["configurationJson"]) : <any>undefined;
      this.tenantBlobStorageContainer = _data["tenantBlobStorageContainer"];
      this.invalidErrorMessages = _data["invalidErrorMessages"];
      this.orderSourceId = _data["orderSourceId"];
      this.userId = _data["userId"];
    }
  }

  static fromJS(data: any): EtlDataLoadRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new EtlDataLoadRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["programId"] = this.programId;
    data["storageType"] = this.storageType;
    data["sourceFileType"] = this.sourceFileType;
    data["sourceFileHostName"] = this.sourceFileHostName;
    data["sourceFileDirectoryName"] = this.sourceFileDirectoryName;
    data["sourceFileFileName"] = this.sourceFileFileName;
    data["sourceFileCredentials"] = this.sourceFileCredentials ? this.sourceFileCredentials.toJSON() : <any>undefined;
    data["sourceFileMappingJson"] = this.sourceFileMappingJson;
    data["dropFileHostName"] = this.dropFileHostName;
    data["dropFileDirectory"] = this.dropFileDirectory;
    data["dropFileFileName"] = this.dropFileFileName;
    data["dropFileCredentials"] = this.dropFileCredentials ? this.dropFileCredentials.toJSON() : <any>undefined;
    data["isManuallyTriggered"] = this.isManuallyTriggered;
    data["maxBatchSize"] = this.maxBatchSize;
    data["Delimeter"] = this.delimeter;
    data["dataLoadType"] = this.dataLoadType;
    data["sourceSystem"] = this.sourceSystem;
    data["configurationJson"] = this.configurationJson ? this.configurationJson.toJSON() : <any>undefined;
    data["tenantBlobStorageContainer"] = this.tenantBlobStorageContainer;
    data["invalidErrorMessages"] = this.invalidErrorMessages;
    data["orderSourceId"] = this.orderSourceId;
    data["userId"] = this.userId;
    return data;
  }

  clone(): EtlDataLoadRequestDto {
    const json = this.toJSON();
    let result = new EtlDataLoadRequestDto();
    result.init(json);
    return result;
  }
}

export interface IEtlDataLoadRequestDto {
  tenantId: number | undefined;
  programId: string | undefined;
  storageType: string | undefined;
  sourceFileType: string | undefined;
  sourceFileHostName: string | undefined;
  sourceFileDirectoryName: string | undefined;
  sourceFileFileName: string | undefined;
  sourceFileCredentials: EtlRequestCredentialsDto | undefined;
  sourceFileMappingJson: string | undefined;
  dropFileHostName: string | undefined;
  dropFileDirectory: string | undefined;
  dropFileFileName: string | undefined;
  dropFileCredentials: EtlRequestCredentialsDto | undefined;
  isManuallyTriggered: boolean | undefined;
  maxBatchSize: number | undefined;
  delimeter: string | undefined;
  dataLoadType: string | undefined;
  sourceSystem: string | undefined;
  configurationJson: ConfigurationDto | undefined;
  tenantBlobStorageContainer: string | undefined;
  invalidErrorMessages: string | undefined;
  orderSourceId: string | undefined;
  userId: number | undefined;
}

export class EtlRequestCredentialsDto implements IEtlRequestCredentialsDto {
  userName: string | undefined;
  passWord: string | undefined;

  constructor(data?: IEtlRequestCredentialsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data["userName"];
      this.passWord = _data["passWord"];
    }
  }

  static fromJS(data: any): EtlRequestCredentialsDto {
    data = typeof data === 'object' ? data : {};
    let result = new EtlRequestCredentialsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userName"] = this.userName;
    data["passWord"] = this.passWord;
    return data;
  }

  clone(): EtlRequestCredentialsDto {
    const json = this.toJSON();
    let result = new EtlRequestCredentialsDto();
    result.init(json);
    return result;
  }
}

export interface IEtlRequestCredentialsDto {
  userName: string | undefined;
  passWord: string | undefined;
}

export class ConfigurationDto implements IConfigurationDto {
  mapping: string | undefined;
  credentials: EtlRequestCredentialsDto | undefined;
  controlFileConfigurations: ControlFileConfigurationDto[] | undefined;

  constructor(data?: IConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.mapping = _data["mapping"];
      this.credentials = _data["credentials"] ? EtlRequestCredentialsDto.fromJS(_data["credentials"]) : <any>undefined;
      if (Array.isArray(_data["controlFileConfigurations"])) {
        this.controlFileConfigurations = [] as any;
        for (let item of _data["controlFileConfigurations"])
          this.controlFileConfigurations.push(ControlFileConfigurationDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["mapping"] = this.mapping;
    data["credentials"] = this.credentials ? this.credentials.toJSON() : <any>undefined;
    if (Array.isArray(this.controlFileConfigurations)) {
      data["controlFileConfigurations"] = [];
      for (let item of this.controlFileConfigurations)
        data["controlFileConfigurations"].push(item.toJSON());
    }
    return data;
  }

  clone(): ConfigurationDto {
    const json = this.toJSON();
    let result = new ConfigurationDto();
    result.init(json);
    return result;
  }
}

export interface IConfigurationDto {
  mapping: string | undefined;
  credentials: EtlRequestCredentialsDto | undefined;
  controlFileConfigurations: ControlFileConfigurationDto[] | undefined;
}

export class ControlFileConfigurationDto implements IControlFileConfigurationDto {
  dataLoadType: string | undefined;
  column: string | undefined;
  value: string | undefined;
  filePath: string | undefined;

  constructor(data?: IControlFileConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dataLoadType = _data["dataLoadType"];
      this.column = _data["column"];
      this.value = _data["value"];
      this.filePath = _data["filePath"];
    }
  }

  static fromJS(data: any): ControlFileConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ControlFileConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dataLoadType"] = this.dataLoadType;
    data["column"] = this.column;
    data["value"] = this.value;
    data["filePath"] = this.filePath;
    return data;
  }

  clone(): ControlFileConfigurationDto {
    const json = this.toJSON();
    let result = new ControlFileConfigurationDto();
    result.init(json);
    return result;
  }
}

export interface IControlFileConfigurationDto {
  dataLoadType: string | undefined;
  column: string | undefined;
  value: string | undefined;
  filePath: string | undefined;
}

export class AjaxResponseOfNullableOfGuid implements IAjaxResponseOfNullableOfGuid {
  result: string | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfNullableOfGuid) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfNullableOfGuid {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfNullableOfGuid();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfNullableOfGuid {
    const json = this.toJSON();
    let result = new AjaxResponseOfNullableOfGuid();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfNullableOfGuid {
  result: string | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class EndBatchRequestDto implements IEndBatchRequestDto {
  batchId: string | undefined;

  constructor(data?: IEndBatchRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.batchId = _data["batchId"];
    }
  }

  static fromJS(data: any): EndBatchRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new EndBatchRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["batchId"] = this.batchId;
    return data;
  }

  clone(): EndBatchRequestDto {
    const json = this.toJSON();
    let result = new EndBatchRequestDto();
    result.init(json);
    return result;
  }
}

export interface IEndBatchRequestDto {
  batchId: string | undefined;
}

export class LoadControlFileRequestDto implements ILoadControlFileRequestDto {
  isControlFileMissing: boolean | undefined;
  isDataFileMissing: boolean | undefined;
  recordsInTheFile: number | undefined;
  rejectedCount: number | undefined;
  recordsMismatch: boolean | undefined;
  isUniqueIdentifierMismatch: boolean | undefined;
  dataLoads: DataLoad[] | undefined;
  rejectedValues: string[] | undefined;
  processedValues: string[] | undefined;
  tenantId: number | undefined;
  /** Maps to Samplicity Program.JobId */
  programCode: string | undefined;
  batchId: string | undefined;

  constructor(data?: ILoadControlFileRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isControlFileMissing = _data["isControlFileMissing"];
      this.isDataFileMissing = _data["isDataFileMissing"];
      this.recordsInTheFile = _data["recordsInTheFile"];
      this.rejectedCount = _data["rejectedCount"];
      this.recordsMismatch = _data["recordsMismatch"];
      this.isUniqueIdentifierMismatch = _data["isUniqueIdentifierMismatch"];
      if (Array.isArray(_data["dataLoads"])) {
        this.dataLoads = [] as any;
        for (let item of _data["dataLoads"])
          this.dataLoads.push(DataLoad.fromJS(item));
      }
      if (Array.isArray(_data["rejectedValues"])) {
        this.rejectedValues = [] as any;
        for (let item of _data["rejectedValues"])
          this.rejectedValues.push(item);
      }
      if (Array.isArray(_data["processedValues"])) {
        this.processedValues = [] as any;
        for (let item of _data["processedValues"])
          this.processedValues.push(item);
      }
      this.tenantId = _data["tenantId"];
      this.programCode = _data["programCode"];
      this.batchId = _data["batchId"];
    }
  }

  static fromJS(data: any): LoadControlFileRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new LoadControlFileRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isControlFileMissing"] = this.isControlFileMissing;
    data["isDataFileMissing"] = this.isDataFileMissing;
    data["recordsInTheFile"] = this.recordsInTheFile;
    data["rejectedCount"] = this.rejectedCount;
    data["recordsMismatch"] = this.recordsMismatch;
    data["isUniqueIdentifierMismatch"] = this.isUniqueIdentifierMismatch;
    if (Array.isArray(this.dataLoads)) {
      data["dataLoads"] = [];
      for (let item of this.dataLoads)
        data["dataLoads"].push(item.toJSON());
    }
    if (Array.isArray(this.rejectedValues)) {
      data["rejectedValues"] = [];
      for (let item of this.rejectedValues)
        data["rejectedValues"].push(item);
    }
    if (Array.isArray(this.processedValues)) {
      data["processedValues"] = [];
      for (let item of this.processedValues)
        data["processedValues"].push(item);
    }
    data["tenantId"] = this.tenantId;
    data["programCode"] = this.programCode;
    data["batchId"] = this.batchId;
    return data;
  }

  clone(): LoadControlFileRequestDto {
    const json = this.toJSON();
    let result = new LoadControlFileRequestDto();
    result.init(json);
    return result;
  }
}

export interface ILoadControlFileRequestDto {
  isControlFileMissing: boolean | undefined;
  isDataFileMissing: boolean | undefined;
  recordsInTheFile: number | undefined;
  rejectedCount: number | undefined;
  recordsMismatch: boolean | undefined;
  isUniqueIdentifierMismatch: boolean | undefined;
  dataLoads: DataLoad[] | undefined;
  rejectedValues: string[] | undefined;
  processedValues: string[] | undefined;
  tenantId: number | undefined;
  /** Maps to Samplicity Program.JobId */
  programCode: string | undefined;
  batchId: string | undefined;
}

export class DataLoad implements IDataLoad {
  dataLoadTypeId: string | undefined;
  fileName: string | undefined;

  constructor(data?: IDataLoad) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dataLoadTypeId = _data["dataLoadTypeId"];
      this.fileName = _data["fileName"];
    }
  }

  static fromJS(data: any): DataLoad {
    data = typeof data === 'object' ? data : {};
    let result = new DataLoad();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dataLoadTypeId"] = this.dataLoadTypeId;
    data["fileName"] = this.fileName;
    return data;
  }

  clone(): DataLoad {
    const json = this.toJSON();
    let result = new DataLoad();
    result.init(json);
    return result;
  }
}

export interface IDataLoad {
  dataLoadTypeId: string | undefined;
  fileName: string | undefined;
}

export class DataLoadResponseDto implements IDataLoadResponseDto {
  batchId: string | undefined;
  items: DataLoadItemResponseDto[] | undefined;
  errors: DataLoadResponseErrorDto[] | undefined;

  constructor(data?: IDataLoadResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.batchId = _data["batchId"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(DataLoadItemResponseDto.fromJS(item));
      }
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"])
          this.errors.push(DataLoadResponseErrorDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DataLoadResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new DataLoadResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["batchId"] = this.batchId;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors)
        data["errors"].push(item.toJSON());
    }
    return data;
  }

  clone(): DataLoadResponseDto {
    const json = this.toJSON();
    let result = new DataLoadResponseDto();
    result.init(json);
    return result;
  }
}

export interface IDataLoadResponseDto {
  batchId: string | undefined;
  items: DataLoadItemResponseDto[] | undefined;
  errors: DataLoadResponseErrorDto[] | undefined;
}

export class DataLoadItemResponseDto implements IDataLoadItemResponseDto {
  lineNumber: number | undefined;
  lineId: string | undefined;
  lineType: string | undefined;
  lineValue: string | undefined;
  isSuccessful: boolean | undefined;
  errors: DataLoadResponseErrorDto[] | undefined;

  constructor(data?: IDataLoadItemResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lineNumber = _data["lineNumber"];
      this.lineId = _data["lineId"];
      this.lineType = _data["lineType"];
      this.lineValue = _data["lineValue"];
      this.isSuccessful = _data["isSuccessful"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"])
          this.errors.push(DataLoadResponseErrorDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DataLoadItemResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new DataLoadItemResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lineNumber"] = this.lineNumber;
    data["lineId"] = this.lineId;
    data["lineType"] = this.lineType;
    data["lineValue"] = this.lineValue;
    data["isSuccessful"] = this.isSuccessful;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors)
        data["errors"].push(item.toJSON());
    }
    return data;
  }

  clone(): DataLoadItemResponseDto {
    const json = this.toJSON();
    let result = new DataLoadItemResponseDto();
    result.init(json);
    return result;
  }
}

export interface IDataLoadItemResponseDto {
  lineNumber: number | undefined;
  lineId: string | undefined;
  lineType: string | undefined;
  lineValue: string | undefined;
  isSuccessful: boolean | undefined;
  errors: DataLoadResponseErrorDto[] | undefined;
}

export class DataLoadResponseErrorDto implements IDataLoadResponseErrorDto {
  propertyName: string | undefined;
  errorMessage: string | undefined;

  constructor(data?: IDataLoadResponseErrorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.propertyName = _data["propertyName"];
      this.errorMessage = _data["errorMessage"];
    }
  }

  static fromJS(data: any): DataLoadResponseErrorDto {
    data = typeof data === 'object' ? data : {};
    let result = new DataLoadResponseErrorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["propertyName"] = this.propertyName;
    data["errorMessage"] = this.errorMessage;
    return data;
  }

  clone(): DataLoadResponseErrorDto {
    const json = this.toJSON();
    let result = new DataLoadResponseErrorDto();
    result.init(json);
    return result;
  }
}

export interface IDataLoadResponseErrorDto {
  propertyName: string | undefined;
  errorMessage: string | undefined;
}

export class CustomerOPRequestDto implements ICustomerOPRequestDto {
  integrationRequestId: string | undefined;
  tenantId: string | undefined;
  companyId: string | undefined;
  sourceSystem: string | undefined;
  customerOPInfo: CustomerOPInfoDto | undefined;
  validationErrors: CustomerOPRequestErrorDto[] | undefined;

  constructor(data?: ICustomerOPRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.integrationRequestId = _data["integrationRequestId"];
      this.tenantId = _data["tenantId"];
      this.companyId = _data["companyId"];
      this.sourceSystem = _data["sourceSystem"];
      this.customerOPInfo = _data["customerOPInfo"] ? CustomerOPInfoDto.fromJS(_data["customerOPInfo"]) : <any>undefined;
      if (Array.isArray(_data["validationErrors"])) {
        this.validationErrors = [] as any;
        for (let item of _data["validationErrors"])
          this.validationErrors.push(CustomerOPRequestErrorDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CustomerOPRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerOPRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["integrationRequestId"] = this.integrationRequestId;
    data["tenantId"] = this.tenantId;
    data["companyId"] = this.companyId;
    data["sourceSystem"] = this.sourceSystem;
    data["customerOPInfo"] = this.customerOPInfo ? this.customerOPInfo.toJSON() : <any>undefined;
    if (Array.isArray(this.validationErrors)) {
      data["validationErrors"] = [];
      for (let item of this.validationErrors)
        data["validationErrors"].push(item.toJSON());
    }
    return data;
  }

  clone(): CustomerOPRequestDto {
    const json = this.toJSON();
    let result = new CustomerOPRequestDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerOPRequestDto {
  integrationRequestId: string | undefined;
  tenantId: string | undefined;
  companyId: string | undefined;
  sourceSystem: string | undefined;
  customerOPInfo: CustomerOPInfoDto | undefined;
  validationErrors: CustomerOPRequestErrorDto[] | undefined;
}

export class CustomerOPInfoDto implements ICustomerOPInfoDto {
  customerId: string | undefined;
  isActive: boolean | undefined;
  customerTypeClassificationValue: string | undefined;
  customerAccountNbr: string | undefined;
  customerName: string | undefined;
  invoiceAccountNumber: string | undefined;
  primaryContactEmail: string | undefined;
  customerClassificationId: string | undefined;
  customerGroupId: string | undefined;
  paymentTermsCode: string | undefined;
  paymentMethodCode: string | undefined;

  constructor(data?: ICustomerOPInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerId = _data["customerId"];
      this.isActive = _data["isActive"];
      this.customerTypeClassificationValue = _data["customerTypeClassificationValue"];
      this.customerAccountNbr = _data["customerAccountNbr"];
      this.customerName = _data["customerName"];
      this.invoiceAccountNumber = _data["invoiceAccountNumber"];
      this.primaryContactEmail = _data["primaryContactEmail"];
      this.customerClassificationId = _data["customerClassificationId"];
      this.customerGroupId = _data["customerGroupId"];
      this.paymentTermsCode = _data["paymentTermsCode"];
      this.paymentMethodCode = _data["paymentMethodCode"];
    }
  }

  static fromJS(data: any): CustomerOPInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerOPInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["customerId"] = this.customerId;
    data["isActive"] = this.isActive;
    data["customerTypeClassificationValue"] = this.customerTypeClassificationValue;
    data["customerAccountNbr"] = this.customerAccountNbr;
    data["customerName"] = this.customerName;
    data["invoiceAccountNumber"] = this.invoiceAccountNumber;
    data["primaryContactEmail"] = this.primaryContactEmail;
    data["customerClassificationId"] = this.customerClassificationId;
    data["customerGroupId"] = this.customerGroupId;
    data["paymentTermsCode"] = this.paymentTermsCode;
    data["paymentMethodCode"] = this.paymentMethodCode;
    return data;
  }

  clone(): CustomerOPInfoDto {
    const json = this.toJSON();
    let result = new CustomerOPInfoDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerOPInfoDto {
  customerId: string | undefined;
  isActive: boolean | undefined;
  customerTypeClassificationValue: string | undefined;
  customerAccountNbr: string | undefined;
  customerName: string | undefined;
  invoiceAccountNumber: string | undefined;
  primaryContactEmail: string | undefined;
  customerClassificationId: string | undefined;
  customerGroupId: string | undefined;
  paymentTermsCode: string | undefined;
  paymentMethodCode: string | undefined;
}

export class CustomerOPRequestErrorDto implements ICustomerOPRequestErrorDto {
  propertyName: string | undefined;
  errorMessage: string | undefined;

  constructor(data?: ICustomerOPRequestErrorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.propertyName = _data["propertyName"];
      this.errorMessage = _data["errorMessage"];
    }
  }

  static fromJS(data: any): CustomerOPRequestErrorDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerOPRequestErrorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["propertyName"] = this.propertyName;
    data["errorMessage"] = this.errorMessage;
    return data;
  }

  clone(): CustomerOPRequestErrorDto {
    const json = this.toJSON();
    let result = new CustomerOPRequestErrorDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerOPRequestErrorDto {
  propertyName: string | undefined;
  errorMessage: string | undefined;
}

export class CustomerAddressOPRequestDto implements ICustomerAddressOPRequestDto {
  integrationRequestId: string | undefined;
  tenantId: string | undefined;
  companyId: string | undefined;
  sourceSystem: string | undefined;
  customerAddressOPInfo: CustomerAddressOPInfoDto | undefined;
  validationErrors: CustomerOPRequestErrorDto[] | undefined;

  constructor(data?: ICustomerAddressOPRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.integrationRequestId = _data["integrationRequestId"];
      this.tenantId = _data["tenantId"];
      this.companyId = _data["companyId"];
      this.sourceSystem = _data["sourceSystem"];
      this.customerAddressOPInfo = _data["customerAddressOPInfo"] ? CustomerAddressOPInfoDto.fromJS(_data["customerAddressOPInfo"]) : <any>undefined;
      if (Array.isArray(_data["validationErrors"])) {
        this.validationErrors = [] as any;
        for (let item of _data["validationErrors"])
          this.validationErrors.push(CustomerOPRequestErrorDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CustomerAddressOPRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerAddressOPRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["integrationRequestId"] = this.integrationRequestId;
    data["tenantId"] = this.tenantId;
    data["companyId"] = this.companyId;
    data["sourceSystem"] = this.sourceSystem;
    data["customerAddressOPInfo"] = this.customerAddressOPInfo ? this.customerAddressOPInfo.toJSON() : <any>undefined;
    if (Array.isArray(this.validationErrors)) {
      data["validationErrors"] = [];
      for (let item of this.validationErrors)
        data["validationErrors"].push(item.toJSON());
    }
    return data;
  }

  clone(): CustomerAddressOPRequestDto {
    const json = this.toJSON();
    let result = new CustomerAddressOPRequestDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerAddressOPRequestDto {
  integrationRequestId: string | undefined;
  tenantId: string | undefined;
  companyId: string | undefined;
  sourceSystem: string | undefined;
  customerAddressOPInfo: CustomerAddressOPInfoDto | undefined;
  validationErrors: CustomerOPRequestErrorDto[] | undefined;
}

export class CustomerAddressOPInfoDto implements ICustomerAddressOPInfoDto {
  addressId: string | undefined;
  customerId: string | undefined;
  addressLocationId: string | undefined;
  addressLocationRoles: string | undefined;
  addressDescription: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  attention: string | undefined;

  constructor(data?: ICustomerAddressOPInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.addressId = _data["addressId"];
      this.customerId = _data["customerId"];
      this.addressLocationId = _data["addressLocationId"];
      this.addressLocationRoles = _data["addressLocationRoles"];
      this.addressDescription = _data["addressDescription"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.address3Text = _data["address3Text"];
      this.address4Text = _data["address4Text"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.stateCode = _data["stateCode"];
      this.countryCode = _data["countryCode"];
      this.attention = _data["attention"];
    }
  }

  static fromJS(data: any): CustomerAddressOPInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerAddressOPInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["addressId"] = this.addressId;
    data["customerId"] = this.customerId;
    data["addressLocationId"] = this.addressLocationId;
    data["addressLocationRoles"] = this.addressLocationRoles;
    data["addressDescription"] = this.addressDescription;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["address3Text"] = this.address3Text;
    data["address4Text"] = this.address4Text;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["stateCode"] = this.stateCode;
    data["countryCode"] = this.countryCode;
    data["attention"] = this.attention;
    return data;
  }

  clone(): CustomerAddressOPInfoDto {
    const json = this.toJSON();
    let result = new CustomerAddressOPInfoDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerAddressOPInfoDto {
  addressId: string | undefined;
  customerId: string | undefined;
  addressLocationId: string | undefined;
  addressLocationRoles: string | undefined;
  addressDescription: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  attention: string | undefined;
}

export class CustomerConfigurationDto implements ICustomerConfigurationDto {
  customer: CustomerDto | undefined;
  orderSlaWorkingDays: number | undefined;
  placeOrderOnAnyDay: boolean | undefined;
  placeOrderOnMonday: boolean | undefined;
  useD365Integration: boolean | undefined;
  placeOrderOnTuesday: boolean | undefined;
  placeOrderOnWednesday: boolean | undefined;
  placeOrderOnThursday: boolean | undefined;
  placeOrderOnFriday: boolean | undefined;
  orderReceivedCutoffTime: string | undefined;
  productLevelCarrierServiceTypeId: string | undefined;
  anySpecificShipmentPickupDay: boolean | undefined;
  shippingComments: string | undefined;
  customerConfigurationProducts: CustomerConfigurationProductDto[] | undefined;
  customerConfigurationProductTypes: CustomerConfigurationProductTypeDto[] | undefined;
  customerConfigurationShipments: CustomerConfigurationShipmentDto[] | undefined;
  id: string | undefined;

  constructor(data?: ICustomerConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
      this.orderSlaWorkingDays = _data["orderSlaWorkingDays"];
      this.placeOrderOnAnyDay = _data["placeOrderOnAnyDay"];
      this.placeOrderOnMonday = _data["placeOrderOnMonday"];
      this.useD365Integration = _data["useD365Integration"];
      this.placeOrderOnTuesday = _data["placeOrderOnTuesday"];
      this.placeOrderOnWednesday = _data["placeOrderOnWednesday"];
      this.placeOrderOnThursday = _data["placeOrderOnThursday"];
      this.placeOrderOnFriday = _data["placeOrderOnFriday"];
      this.orderReceivedCutoffTime = _data["orderReceivedCutoffTime"];
      this.productLevelCarrierServiceTypeId = _data["productLevelCarrierServiceTypeId"];
      this.anySpecificShipmentPickupDay = _data["anySpecificShipmentPickupDay"];
      this.shippingComments = _data["shippingComments"];
      if (Array.isArray(_data["customerConfigurationProducts"])) {
        this.customerConfigurationProducts = [] as any;
        for (let item of _data["customerConfigurationProducts"])
          this.customerConfigurationProducts.push(CustomerConfigurationProductDto.fromJS(item));
      }
      if (Array.isArray(_data["customerConfigurationProductTypes"])) {
        this.customerConfigurationProductTypes = [] as any;
        for (let item of _data["customerConfigurationProductTypes"])
          this.customerConfigurationProductTypes.push(CustomerConfigurationProductTypeDto.fromJS(item));
      }
      if (Array.isArray(_data["customerConfigurationShipments"])) {
        this.customerConfigurationShipments = [] as any;
        for (let item of _data["customerConfigurationShipments"])
          this.customerConfigurationShipments.push(CustomerConfigurationShipmentDto.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CustomerConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
    data["orderSlaWorkingDays"] = this.orderSlaWorkingDays;
    data["placeOrderOnAnyDay"] = this.placeOrderOnAnyDay;
    data["placeOrderOnMonday"] = this.placeOrderOnMonday;
    data["useD365Integration"] = this.useD365Integration;
    data["placeOrderOnTuesday"] = this.placeOrderOnTuesday;
    data["placeOrderOnWednesday"] = this.placeOrderOnWednesday;
    data["placeOrderOnThursday"] = this.placeOrderOnThursday;
    data["placeOrderOnFriday"] = this.placeOrderOnFriday;
    data["orderReceivedCutoffTime"] = this.orderReceivedCutoffTime;
    data["productLevelCarrierServiceTypeId"] = this.productLevelCarrierServiceTypeId;
    data["anySpecificShipmentPickupDay"] = this.anySpecificShipmentPickupDay;
    data["shippingComments"] = this.shippingComments;
    if (Array.isArray(this.customerConfigurationProducts)) {
      data["customerConfigurationProducts"] = [];
      for (let item of this.customerConfigurationProducts)
        data["customerConfigurationProducts"].push(item.toJSON());
    }
    if (Array.isArray(this.customerConfigurationProductTypes)) {
      data["customerConfigurationProductTypes"] = [];
      for (let item of this.customerConfigurationProductTypes)
        data["customerConfigurationProductTypes"].push(item.toJSON());
    }
    if (Array.isArray(this.customerConfigurationShipments)) {
      data["customerConfigurationShipments"] = [];
      for (let item of this.customerConfigurationShipments)
        data["customerConfigurationShipments"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }

  clone(): CustomerConfigurationDto {
    const json = this.toJSON();
    let result = new CustomerConfigurationDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerConfigurationDto {
  customer: CustomerDto | undefined;
  orderSlaWorkingDays: number | undefined;
  placeOrderOnAnyDay: boolean | undefined;
  placeOrderOnMonday: boolean | undefined;
  useD365Integration: boolean | undefined;
  placeOrderOnTuesday: boolean | undefined;
  placeOrderOnWednesday: boolean | undefined;
  placeOrderOnThursday: boolean | undefined;
  placeOrderOnFriday: boolean | undefined;
  orderReceivedCutoffTime: string | undefined;
  productLevelCarrierServiceTypeId: string | undefined;
  anySpecificShipmentPickupDay: boolean | undefined;
  shippingComments: string | undefined;
  customerConfigurationProducts: CustomerConfigurationProductDto[] | undefined;
  customerConfigurationProductTypes: CustomerConfigurationProductTypeDto[] | undefined;
  customerConfigurationShipments: CustomerConfigurationShipmentDto[] | undefined;
  id: string | undefined;
}

export class CustomerDto implements ICustomerDto {
  customerName: string | undefined;
  customerAccountNbr: string | undefined;
  isActive: boolean | undefined;
  customerTypeClassificationValueId: string | undefined;
  invoiceAccountNumber: string | undefined;
  primaryContactEmail: string | undefined;
  customerClassificationId: string | undefined;
  customerGroupId: string | undefined;
  lineOfBusinessCode: string | undefined;
  paymentMethodCode: string | undefined;
  paymentMethodValue: string | undefined;
  paymentTermsCode: string | undefined;
  paymentTermsValue: string | undefined;
  lineDiscountGroup: string | undefined;
  multilineDiscountGroup: string | undefined;
  totalDiscountGroup: string | undefined;
  priceGroup: string | undefined;
  clientCustomerNumber: string | undefined;
  id: string | undefined;

  constructor(data?: ICustomerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerName = _data["customerName"];
      this.customerAccountNbr = _data["customerAccountNbr"];
      this.isActive = _data["isActive"];
      this.customerTypeClassificationValueId = _data["customerTypeClassificationValueId"];
      this.invoiceAccountNumber = _data["invoiceAccountNumber"];
      this.primaryContactEmail = _data["primaryContactEmail"];
      this.customerClassificationId = _data["customerClassificationId"];
      this.customerGroupId = _data["customerGroupId"];
      this.lineOfBusinessCode = _data["lineOfBusinessCode"];
      this.paymentMethodCode = _data["paymentMethodCode"];
      this.paymentMethodValue = _data["paymentMethodValue"];
      this.paymentTermsCode = _data["paymentTermsCode"];
      this.paymentTermsValue = _data["paymentTermsValue"];
      this.lineDiscountGroup = _data["lineDiscountGroup"];
      this.multilineDiscountGroup = _data["multilineDiscountGroup"];
      this.totalDiscountGroup = _data["totalDiscountGroup"];
      this.priceGroup = _data["priceGroup"];
      this.clientCustomerNumber = _data["clientCustomerNumber"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CustomerDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["customerName"] = this.customerName;
    data["customerAccountNbr"] = this.customerAccountNbr;
    data["isActive"] = this.isActive;
    data["customerTypeClassificationValueId"] = this.customerTypeClassificationValueId;
    data["invoiceAccountNumber"] = this.invoiceAccountNumber;
    data["primaryContactEmail"] = this.primaryContactEmail;
    data["customerClassificationId"] = this.customerClassificationId;
    data["customerGroupId"] = this.customerGroupId;
    data["lineOfBusinessCode"] = this.lineOfBusinessCode;
    data["paymentMethodCode"] = this.paymentMethodCode;
    data["paymentMethodValue"] = this.paymentMethodValue;
    data["paymentTermsCode"] = this.paymentTermsCode;
    data["paymentTermsValue"] = this.paymentTermsValue;
    data["lineDiscountGroup"] = this.lineDiscountGroup;
    data["multilineDiscountGroup"] = this.multilineDiscountGroup;
    data["totalDiscountGroup"] = this.totalDiscountGroup;
    data["priceGroup"] = this.priceGroup;
    data["clientCustomerNumber"] = this.clientCustomerNumber;
    data["id"] = this.id;
    return data;
  }

  clone(): CustomerDto {
    const json = this.toJSON();
    let result = new CustomerDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerDto {
  customerName: string | undefined;
  customerAccountNbr: string | undefined;
  isActive: boolean | undefined;
  customerTypeClassificationValueId: string | undefined;
  invoiceAccountNumber: string | undefined;
  primaryContactEmail: string | undefined;
  customerClassificationId: string | undefined;
  customerGroupId: string | undefined;
  lineOfBusinessCode: string | undefined;
  paymentMethodCode: string | undefined;
  paymentMethodValue: string | undefined;
  paymentTermsCode: string | undefined;
  paymentTermsValue: string | undefined;
  lineDiscountGroup: string | undefined;
  multilineDiscountGroup: string | undefined;
  totalDiscountGroup: string | undefined;
  priceGroup: string | undefined;
  clientCustomerNumber: string | undefined;
  id: string | undefined;
}

export class CustomerConfigurationProductDto implements ICustomerConfigurationProductDto {
  product: CustomerConfigurationProductMasterDto | undefined;
  customerProductCode: string | undefined;
  uoMConversionTypeId: string | undefined;
  uoMConversionValue: number | undefined;
  uoMDisplayQuantity: string | undefined;
  minOrderQuantity: number | undefined;
  id: string | undefined;

  constructor(data?: ICustomerConfigurationProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.product = _data["product"] ? CustomerConfigurationProductMasterDto.fromJS(_data["product"]) : <any>undefined;
      this.customerProductCode = _data["customerProductCode"];
      this.uoMConversionTypeId = _data["uoMConversionTypeId"];
      this.uoMConversionValue = _data["uoMConversionValue"];
      this.uoMDisplayQuantity = _data["uoMDisplayQuantity"];
      this.minOrderQuantity = _data["minOrderQuantity"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CustomerConfigurationProductDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerConfigurationProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["customerProductCode"] = this.customerProductCode;
    data["uoMConversionTypeId"] = this.uoMConversionTypeId;
    data["uoMConversionValue"] = this.uoMConversionValue;
    data["uoMDisplayQuantity"] = this.uoMDisplayQuantity;
    data["minOrderQuantity"] = this.minOrderQuantity;
    data["id"] = this.id;
    return data;
  }

  clone(): CustomerConfigurationProductDto {
    const json = this.toJSON();
    let result = new CustomerConfigurationProductDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerConfigurationProductDto {
  product: CustomerConfigurationProductMasterDto | undefined;
  customerProductCode: string | undefined;
  uoMConversionTypeId: string | undefined;
  uoMConversionValue: number | undefined;
  uoMDisplayQuantity: string | undefined;
  minOrderQuantity: number | undefined;
  id: string | undefined;
}

export class CustomerConfigurationProductTypeDto implements ICustomerConfigurationProductTypeDto {
  priority: number | undefined;
  productTypeId: string | undefined;
  primaryCarrierServiceTypeId: string | undefined;
  secondaryCarrierServiceTypeId: string | undefined;
  carrierServiceStatesJson: string | undefined;
  id: string | undefined;

  constructor(data?: ICustomerConfigurationProductTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.priority = _data["priority"];
      this.productTypeId = _data["productTypeId"];
      this.primaryCarrierServiceTypeId = _data["primaryCarrierServiceTypeId"];
      this.secondaryCarrierServiceTypeId = _data["secondaryCarrierServiceTypeId"];
      this.carrierServiceStatesJson = _data["carrierServiceStatesJson"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CustomerConfigurationProductTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerConfigurationProductTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["priority"] = this.priority;
    data["productTypeId"] = this.productTypeId;
    data["primaryCarrierServiceTypeId"] = this.primaryCarrierServiceTypeId;
    data["secondaryCarrierServiceTypeId"] = this.secondaryCarrierServiceTypeId;
    data["carrierServiceStatesJson"] = this.carrierServiceStatesJson;
    data["id"] = this.id;
    return data;
  }

  clone(): CustomerConfigurationProductTypeDto {
    const json = this.toJSON();
    let result = new CustomerConfigurationProductTypeDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerConfigurationProductTypeDto {
  priority: number | undefined;
  productTypeId: string | undefined;
  primaryCarrierServiceTypeId: string | undefined;
  secondaryCarrierServiceTypeId: string | undefined;
  carrierServiceStatesJson: string | undefined;
  id: string | undefined;
}

export class CustomerConfigurationShipmentDto implements ICustomerConfigurationShipmentDto {
  lineIndex: number | undefined;
  pickupDay: string | undefined;
  pickupTime: string | undefined;
  shipDays: ShipDays[] | undefined;
  id: string | undefined;

  constructor(data?: ICustomerConfigurationShipmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lineIndex = _data["lineIndex"];
      this.pickupDay = _data["pickupDay"];
      this.pickupTime = _data["pickupTime"];
      if (Array.isArray(_data["shipDays"])) {
        this.shipDays = [] as any;
        for (let item of _data["shipDays"])
          this.shipDays.push(item);
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CustomerConfigurationShipmentDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerConfigurationShipmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lineIndex"] = this.lineIndex;
    data["pickupDay"] = this.pickupDay;
    data["pickupTime"] = this.pickupTime;
    if (Array.isArray(this.shipDays)) {
      data["shipDays"] = [];
      for (let item of this.shipDays)
        data["shipDays"].push(item);
    }
    data["id"] = this.id;
    return data;
  }

  clone(): CustomerConfigurationShipmentDto {
    const json = this.toJSON();
    let result = new CustomerConfigurationShipmentDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerConfigurationShipmentDto {
  lineIndex: number | undefined;
  pickupDay: string | undefined;
  pickupTime: string | undefined;
  shipDays: ShipDays[] | undefined;
  id: string | undefined;
}

export class CustomerConfigurationProductMasterDto implements ICustomerConfigurationProductMasterDto {
  productCode: string | undefined;
  productName: string | undefined;
  productTypeId: string | undefined;
  distributionUnitOfMeasure: string | undefined;
  productGroupId: string | undefined;
  id: string | undefined;

  constructor(data?: ICustomerConfigurationProductMasterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productCode = _data["productCode"];
      this.productName = _data["productName"];
      this.productTypeId = _data["productTypeId"];
      this.distributionUnitOfMeasure = _data["distributionUnitOfMeasure"];
      this.productGroupId = _data["productGroupId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CustomerConfigurationProductMasterDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerConfigurationProductMasterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["productCode"] = this.productCode;
    data["productName"] = this.productName;
    data["productTypeId"] = this.productTypeId;
    data["distributionUnitOfMeasure"] = this.distributionUnitOfMeasure;
    data["productGroupId"] = this.productGroupId;
    data["id"] = this.id;
    return data;
  }

  clone(): CustomerConfigurationProductMasterDto {
    const json = this.toJSON();
    let result = new CustomerConfigurationProductMasterDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerConfigurationProductMasterDto {
  productCode: string | undefined;
  productName: string | undefined;
  productTypeId: string | undefined;
  distributionUnitOfMeasure: string | undefined;
  productGroupId: string | undefined;
  id: string | undefined;
}

export class CustomerSPSearchDto implements ICustomerSPSearchDto {
  tenantId: number | undefined;
  customerName: string | undefined;
  addressLine1: string | undefined;
  addressLine2: string | undefined;
  city: string | undefined;
  stateCode: string | undefined;
  zipCode: string | undefined;

  constructor(data?: ICustomerSPSearchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.customerName = _data["customerName"];
      this.addressLine1 = _data["addressLine1"];
      this.addressLine2 = _data["addressLine2"];
      this.city = _data["city"];
      this.stateCode = _data["stateCode"];
      this.zipCode = _data["zipCode"];
    }
  }

  static fromJS(data: any): CustomerSPSearchDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerSPSearchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["customerName"] = this.customerName;
    data["addressLine1"] = this.addressLine1;
    data["addressLine2"] = this.addressLine2;
    data["city"] = this.city;
    data["stateCode"] = this.stateCode;
    data["zipCode"] = this.zipCode;
    return data;
  }

  clone(): CustomerSPSearchDto {
    const json = this.toJSON();
    let result = new CustomerSPSearchDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerSPSearchDto {
  tenantId: number | undefined;
  customerName: string | undefined;
  addressLine1: string | undefined;
  addressLine2: string | undefined;
  city: string | undefined;
  stateCode: string | undefined;
  zipCode: string | undefined;
}

export class CustomerMatchScore implements ICustomerMatchScore {
  customerAccountNbr: string | undefined;
  facilityDistance: number | undefined;
  addressDistance1: number | undefined;
  addressDistance2: number | undefined;
  combinedDistance: number | undefined;
  isSimilarCustomerExists: boolean | undefined;
  errorMessage: string | undefined;

  constructor(data?: ICustomerMatchScore) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerAccountNbr = _data["customerAccountNbr"];
      this.facilityDistance = _data["facilityDistance"];
      this.addressDistance1 = _data["addressDistance1"];
      this.addressDistance2 = _data["addressDistance2"];
      this.combinedDistance = _data["combinedDistance"];
      this.isSimilarCustomerExists = _data["isSimilarCustomerExists"];
      this.errorMessage = _data["errorMessage"];
    }
  }

  static fromJS(data: any): CustomerMatchScore {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerMatchScore();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["customerAccountNbr"] = this.customerAccountNbr;
    data["facilityDistance"] = this.facilityDistance;
    data["addressDistance1"] = this.addressDistance1;
    data["addressDistance2"] = this.addressDistance2;
    data["combinedDistance"] = this.combinedDistance;
    data["isSimilarCustomerExists"] = this.isSimilarCustomerExists;
    data["errorMessage"] = this.errorMessage;
    return data;
  }

  clone(): CustomerMatchScore {
    const json = this.toJSON();
    let result = new CustomerMatchScore();
    result.init(json);
    return result;
  }
}

export interface ICustomerMatchScore {
  customerAccountNbr: string | undefined;
  facilityDistance: number | undefined;
  addressDistance1: number | undefined;
  addressDistance2: number | undefined;
  combinedDistance: number | undefined;
  isSimilarCustomerExists: boolean | undefined;
  errorMessage: string | undefined;
}

export class AjaxResponseOfDeleteOrderLineResultDto implements IAjaxResponseOfDeleteOrderLineResultDto {
  result: DeleteOrderLineResultDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfDeleteOrderLineResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? DeleteOrderLineResultDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfDeleteOrderLineResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfDeleteOrderLineResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfDeleteOrderLineResultDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfDeleteOrderLineResultDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfDeleteOrderLineResultDto {
  result: DeleteOrderLineResultDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class DeleteOrderLineResultDto implements IDeleteOrderLineResultDto {
  orderId: string | undefined;
  orderLineId: string | undefined;
  orderNumber: string | undefined;
  orderStatusId: string | undefined;
  isSuccessfullyDeleted: boolean | undefined;
  deletionFailureReasonText: string | undefined;

  constructor(data?: IDeleteOrderLineResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderLineId = _data["orderLineId"];
      this.orderNumber = _data["orderNumber"];
      this.orderStatusId = _data["orderStatusId"];
      this.isSuccessfullyDeleted = _data["isSuccessfullyDeleted"];
      this.deletionFailureReasonText = _data["deletionFailureReasonText"];
    }
  }

  static fromJS(data: any): DeleteOrderLineResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new DeleteOrderLineResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderLineId"] = this.orderLineId;
    data["orderNumber"] = this.orderNumber;
    data["orderStatusId"] = this.orderStatusId;
    data["isSuccessfullyDeleted"] = this.isSuccessfullyDeleted;
    data["deletionFailureReasonText"] = this.deletionFailureReasonText;
    return data;
  }

  clone(): DeleteOrderLineResultDto {
    const json = this.toJSON();
    let result = new DeleteOrderLineResultDto();
    result.init(json);
    return result;
  }
}

export interface IDeleteOrderLineResultDto {
  orderId: string | undefined;
  orderLineId: string | undefined;
  orderNumber: string | undefined;
  orderStatusId: string | undefined;
  isSuccessfullyDeleted: boolean | undefined;
  deletionFailureReasonText: string | undefined;
}

export class AjaxResponseOfListOfDtpProgramConfigSourceCodeDto implements IAjaxResponseOfListOfDtpProgramConfigSourceCodeDto {
  result: DtpProgramConfigSourceCodeDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfListOfDtpProgramConfigSourceCodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result.push(DtpProgramConfigSourceCodeDto.fromJS(item));
      }
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfListOfDtpProgramConfigSourceCodeDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfListOfDtpProgramConfigSourceCodeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfListOfDtpProgramConfigSourceCodeDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfListOfDtpProgramConfigSourceCodeDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfListOfDtpProgramConfigSourceCodeDto {
  result: DtpProgramConfigSourceCodeDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class DtpProgramConfigSourceCodeDto implements IDtpProgramConfigSourceCodeDto {
  campaignDescription: string | undefined;
  sourceCode: string | undefined;
  therapeuticClass: string | undefined;
  productGroupId: string | undefined;

  constructor(data?: IDtpProgramConfigSourceCodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.campaignDescription = _data["campaignDescription"];
      this.sourceCode = _data["sourceCode"];
      this.therapeuticClass = _data["therapeuticClass"];
      this.productGroupId = _data["productGroupId"];
    }
  }

  static fromJS(data: any): DtpProgramConfigSourceCodeDto {
    data = typeof data === 'object' ? data : {};
    let result = new DtpProgramConfigSourceCodeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["campaignDescription"] = this.campaignDescription;
    data["sourceCode"] = this.sourceCode;
    data["therapeuticClass"] = this.therapeuticClass;
    data["productGroupId"] = this.productGroupId;
    return data;
  }

  clone(): DtpProgramConfigSourceCodeDto {
    const json = this.toJSON();
    let result = new DtpProgramConfigSourceCodeDto();
    result.init(json);
    return result;
  }
}

export interface IDtpProgramConfigSourceCodeDto {
  campaignDescription: string | undefined;
  sourceCode: string | undefined;
  therapeuticClass: string | undefined;
  productGroupId: string | undefined;
}

export class AjaxResponseOfBoolean implements IAjaxResponseOfBoolean {
  result: boolean | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfBoolean) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfBoolean {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfBoolean();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfBoolean {
    const json = this.toJSON();
    let result = new AjaxResponseOfBoolean();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfBoolean {
  result: boolean | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class AjaxResponseOfListOfCustomerOrderTypeDto implements IAjaxResponseOfListOfCustomerOrderTypeDto {
  result: CustomerOrderTypeDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfListOfCustomerOrderTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result.push(CustomerOrderTypeDto.fromJS(item));
      }
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfListOfCustomerOrderTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfListOfCustomerOrderTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfListOfCustomerOrderTypeDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfListOfCustomerOrderTypeDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfListOfCustomerOrderTypeDto {
  result: CustomerOrderTypeDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class CustomerOrderTypeDto implements ICustomerOrderTypeDto {
  customerOrderTypeCode: string | undefined;
  customerOrderTypeValue: string | undefined;
  sequence: number | undefined;
  id: string | undefined;

  constructor(data?: ICustomerOrderTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerOrderTypeCode = _data["customerOrderTypeCode"];
      this.customerOrderTypeValue = _data["customerOrderTypeValue"];
      this.sequence = _data["sequence"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CustomerOrderTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerOrderTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["customerOrderTypeCode"] = this.customerOrderTypeCode;
    data["customerOrderTypeValue"] = this.customerOrderTypeValue;
    data["sequence"] = this.sequence;
    data["id"] = this.id;
    return data;
  }

  clone(): CustomerOrderTypeDto {
    const json = this.toJSON();
    let result = new CustomerOrderTypeDto();
    result.init(json);
    return result;
  }
}

export interface ICustomerOrderTypeDto {
  customerOrderTypeCode: string | undefined;
  customerOrderTypeValue: string | undefined;
  sequence: number | undefined;
  id: string | undefined;
}

export class NotificationRequest implements INotificationRequest {
  emailNotificationTemplateTypeId: string | undefined;
  attachments: DocumentLocation[] | undefined;
  attachmentOptions: EmailRequestAttachmentOptions | undefined;
  context: { [key: string]: string; } | undefined;
  model: any | undefined;
  tenantId: number | undefined;
  programId: string | undefined;
  referencedEntities: SamplicityReferencedEntity[] | undefined;
  communicationIds: string[] | undefined;

  constructor(data?: INotificationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailNotificationTemplateTypeId = _data["emailNotificationTemplateTypeId"];
      if (Array.isArray(_data["attachments"])) {
        this.attachments = [] as any;
        for (let item of _data["attachments"])
          this.attachments.push(DocumentLocation.fromJS(item));
      }
      this.attachmentOptions = _data["attachmentOptions"] ? EmailRequestAttachmentOptions.fromJS(_data["attachmentOptions"]) : <any>undefined;
      if (_data["context"]) {
        this.context = {} as any;
        for (let key in _data["context"]) {
          if (_data["context"].hasOwnProperty(key))
            (<any>this.context)[key] = _data["context"][key];
        }
      }
      this.model = _data["model"];
      this.tenantId = _data["tenantId"];
      this.programId = _data["programId"];
      if (Array.isArray(_data["referencedEntities"])) {
        this.referencedEntities = [] as any;
        for (let item of _data["referencedEntities"])
          this.referencedEntities.push(SamplicityReferencedEntity.fromJS(item));
      }
      if (Array.isArray(_data["communicationIds"])) {
        this.communicationIds = [] as any;
        for (let item of _data["communicationIds"])
          this.communicationIds.push(item);
      }
    }
  }

  static fromJS(data: any): NotificationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["emailNotificationTemplateTypeId"] = this.emailNotificationTemplateTypeId;
    if (Array.isArray(this.attachments)) {
      data["attachments"] = [];
      for (let item of this.attachments)
        data["attachments"].push(item.toJSON());
    }
    data["attachmentOptions"] = this.attachmentOptions ? this.attachmentOptions.toJSON() : <any>undefined;
    if (this.context) {
      data["context"] = {};
      for (let key in this.context) {
        if (this.context.hasOwnProperty(key))
          (<any>data["context"])[key] = (<any>this.context)[key];
      }
    }
    data["model"] = this.model;
    data["tenantId"] = this.tenantId;
    data["programId"] = this.programId;
    if (Array.isArray(this.referencedEntities)) {
      data["referencedEntities"] = [];
      for (let item of this.referencedEntities)
        data["referencedEntities"].push(item.toJSON());
    }
    if (Array.isArray(this.communicationIds)) {
      data["communicationIds"] = [];
      for (let item of this.communicationIds)
        data["communicationIds"].push(item);
    }
    return data;
  }

  clone(): NotificationRequest {
    const json = this.toJSON();
    let result = new NotificationRequest();
    result.init(json);
    return result;
  }
}

export interface INotificationRequest {
  emailNotificationTemplateTypeId: string | undefined;
  attachments: DocumentLocation[] | undefined;
  attachmentOptions: EmailRequestAttachmentOptions | undefined;
  context: { [key: string]: string; } | undefined;
  model: any | undefined;
  tenantId: number | undefined;
  programId: string | undefined;
  referencedEntities: SamplicityReferencedEntity[] | undefined;
  communicationIds: string[] | undefined;
}

export class DocumentLocation implements IDocumentLocation {
  documentName: string | undefined;
  documentDescription: string | undefined;
  contentType: string | undefined;
  documentTemplateId: string | undefined;
  storageLocation: DocumentLocationStorageLocation | undefined;
  blobLocation: AzureBlobLocation | undefined;
  databaseLocation: DatabaseLocation | undefined;
  sftpLocation: SftpLocation | undefined;
  inMemoryLocation: InMemoryDocumentLocation | undefined;
  fileShareLocation: AzureFileShareLocation | undefined;

  constructor(data?: IDocumentLocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.documentName = _data["documentName"];
      this.documentDescription = _data["documentDescription"];
      this.contentType = _data["contentType"];
      this.documentTemplateId = _data["documentTemplateId"];
      this.storageLocation = _data["storageLocation"];
      this.blobLocation = _data["blobLocation"] ? AzureBlobLocation.fromJS(_data["blobLocation"]) : <any>undefined;
      this.databaseLocation = _data["databaseLocation"] ? DatabaseLocation.fromJS(_data["databaseLocation"]) : <any>undefined;
      this.sftpLocation = _data["sftpLocation"] ? SftpLocation.fromJS(_data["sftpLocation"]) : <any>undefined;
      this.inMemoryLocation = _data["inMemoryLocation"] ? InMemoryDocumentLocation.fromJS(_data["inMemoryLocation"]) : <any>undefined;
      this.fileShareLocation = _data["fileShareLocation"] ? AzureFileShareLocation.fromJS(_data["fileShareLocation"]) : <any>undefined;
    }
  }

  static fromJS(data: any): DocumentLocation {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentLocation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["documentName"] = this.documentName;
    data["documentDescription"] = this.documentDescription;
    data["contentType"] = this.contentType;
    data["documentTemplateId"] = this.documentTemplateId;
    data["storageLocation"] = this.storageLocation;
    data["blobLocation"] = this.blobLocation ? this.blobLocation.toJSON() : <any>undefined;
    data["databaseLocation"] = this.databaseLocation ? this.databaseLocation.toJSON() : <any>undefined;
    data["sftpLocation"] = this.sftpLocation ? this.sftpLocation.toJSON() : <any>undefined;
    data["inMemoryLocation"] = this.inMemoryLocation ? this.inMemoryLocation.toJSON() : <any>undefined;
    data["fileShareLocation"] = this.fileShareLocation ? this.fileShareLocation.toJSON() : <any>undefined;
    return data;
  }

  clone(): DocumentLocation {
    const json = this.toJSON();
    let result = new DocumentLocation();
    result.init(json);
    return result;
  }
}

export interface IDocumentLocation {
  documentName: string | undefined;
  documentDescription: string | undefined;
  contentType: string | undefined;
  documentTemplateId: string | undefined;
  storageLocation: DocumentLocationStorageLocation | undefined;
  blobLocation: AzureBlobLocation | undefined;
  databaseLocation: DatabaseLocation | undefined;
  sftpLocation: SftpLocation | undefined;
  inMemoryLocation: InMemoryDocumentLocation | undefined;
  fileShareLocation: AzureFileShareLocation | undefined;
}

export class EmailRequestAttachmentOptions implements IEmailRequestAttachmentOptions {
  mergePdfFlag: boolean | undefined;
  mergePdfFileName: string | undefined;

  constructor(data?: IEmailRequestAttachmentOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.mergePdfFlag = _data["mergePdfFlag"];
      this.mergePdfFileName = _data["mergePdfFileName"];
    }
  }

  static fromJS(data: any): EmailRequestAttachmentOptions {
    data = typeof data === 'object' ? data : {};
    let result = new EmailRequestAttachmentOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["mergePdfFlag"] = this.mergePdfFlag;
    data["mergePdfFileName"] = this.mergePdfFileName;
    return data;
  }

  clone(): EmailRequestAttachmentOptions {
    const json = this.toJSON();
    let result = new EmailRequestAttachmentOptions();
    result.init(json);
    return result;
  }
}

export interface IEmailRequestAttachmentOptions {
  mergePdfFlag: boolean | undefined;
  mergePdfFileName: string | undefined;
}

export class SamplicityReferencedEntity implements ISamplicityReferencedEntity {
  entityId: string | undefined;
  referencedEntityTypeClassificationId: string | undefined;
  attributes: SamplicityReferencedEntityAttribute[] | undefined;

  constructor(data?: ISamplicityReferencedEntity) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityId = _data["entityId"];
      this.referencedEntityTypeClassificationId = _data["referencedEntityTypeClassificationId"];
      if (Array.isArray(_data["attributes"])) {
        this.attributes = [] as any;
        for (let item of _data["attributes"])
          this.attributes.push(SamplicityReferencedEntityAttribute.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SamplicityReferencedEntity {
    data = typeof data === 'object' ? data : {};
    let result = new SamplicityReferencedEntity();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["entityId"] = this.entityId;
    data["referencedEntityTypeClassificationId"] = this.referencedEntityTypeClassificationId;
    if (Array.isArray(this.attributes)) {
      data["attributes"] = [];
      for (let item of this.attributes)
        data["attributes"].push(item.toJSON());
    }
    return data;
  }

  clone(): SamplicityReferencedEntity {
    const json = this.toJSON();
    let result = new SamplicityReferencedEntity();
    result.init(json);
    return result;
  }
}

export interface ISamplicityReferencedEntity {
  entityId: string | undefined;
  referencedEntityTypeClassificationId: string | undefined;
  attributes: SamplicityReferencedEntityAttribute[] | undefined;
}

export class AzureBlobLocation implements IAzureBlobLocation {
  directory: string | undefined;
  filePathAndExtension: string | undefined;
  readonly contentType: string | undefined;

  constructor(data?: IAzureBlobLocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.directory = _data["directory"];
      this.filePathAndExtension = _data["filePathAndExtension"];
      (<any>this).contentType = _data["contentType"];
    }
  }

  static fromJS(data: any): AzureBlobLocation {
    data = typeof data === 'object' ? data : {};
    let result = new AzureBlobLocation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["directory"] = this.directory;
    data["filePathAndExtension"] = this.filePathAndExtension;
    data["contentType"] = this.contentType;
    return data;
  }

  clone(): AzureBlobLocation {
    const json = this.toJSON();
    let result = new AzureBlobLocation();
    result.init(json);
    return result;
  }
}

export interface IAzureBlobLocation {
  directory: string | undefined;
  filePathAndExtension: string | undefined;
  contentType: string | undefined;
}

export class DatabaseLocation implements IDatabaseLocation {
  recordId: string | undefined;
  recordType: string | undefined;
  fieldName: string | undefined;

  constructor(data?: IDatabaseLocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.recordId = _data["recordId"];
      this.recordType = _data["recordType"];
      this.fieldName = _data["fieldName"];
    }
  }

  static fromJS(data: any): DatabaseLocation {
    data = typeof data === 'object' ? data : {};
    let result = new DatabaseLocation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["recordId"] = this.recordId;
    data["recordType"] = this.recordType;
    data["fieldName"] = this.fieldName;
    return data;
  }

  clone(): DatabaseLocation {
    const json = this.toJSON();
    let result = new DatabaseLocation();
    result.init(json);
    return result;
  }
}

export interface IDatabaseLocation {
  recordId: string | undefined;
  recordType: string | undefined;
  fieldName: string | undefined;
}

export class SftpLocation implements ISftpLocation {
  connection: SftpConnection | undefined;
  directory: string | undefined;
  filePathAndExtension: string | undefined;
  readonly contentType: string | undefined;

  constructor(data?: ISftpLocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.connection = _data["connection"] ? SftpConnection.fromJS(_data["connection"]) : <any>undefined;
      this.directory = _data["directory"];
      this.filePathAndExtension = _data["filePathAndExtension"];
      (<any>this).contentType = _data["contentType"];
    }
  }

  static fromJS(data: any): SftpLocation {
    data = typeof data === 'object' ? data : {};
    let result = new SftpLocation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["connection"] = this.connection ? this.connection.toJSON() : <any>undefined;
    data["directory"] = this.directory;
    data["filePathAndExtension"] = this.filePathAndExtension;
    data["contentType"] = this.contentType;
    return data;
  }

  clone(): SftpLocation {
    const json = this.toJSON();
    let result = new SftpLocation();
    result.init(json);
    return result;
  }
}

export interface ISftpLocation {
  connection: SftpConnection | undefined;
  directory: string | undefined;
  filePathAndExtension: string | undefined;
  contentType: string | undefined;
}

export class InMemoryDocumentLocation implements IInMemoryDocumentLocation {
  documentContents: string | undefined;

  constructor(data?: IInMemoryDocumentLocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.documentContents = _data["documentContents"];
    }
  }

  static fromJS(data: any): InMemoryDocumentLocation {
    data = typeof data === 'object' ? data : {};
    let result = new InMemoryDocumentLocation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["documentContents"] = this.documentContents;
    return data;
  }

  clone(): InMemoryDocumentLocation {
    const json = this.toJSON();
    let result = new InMemoryDocumentLocation();
    result.init(json);
    return result;
  }
}

export interface IInMemoryDocumentLocation {
  documentContents: string | undefined;
}

export class AzureFileShareLocation implements IAzureFileShareLocation {
  fileShareName: string | undefined;
  directory: string | undefined;
  filePathAndExtension: string | undefined;
  readonly contentType: string | undefined;

  constructor(data?: IAzureFileShareLocation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileShareName = _data["fileShareName"];
      this.directory = _data["directory"];
      this.filePathAndExtension = _data["filePathAndExtension"];
      (<any>this).contentType = _data["contentType"];
    }
  }

  static fromJS(data: any): AzureFileShareLocation {
    data = typeof data === 'object' ? data : {};
    let result = new AzureFileShareLocation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fileShareName"] = this.fileShareName;
    data["directory"] = this.directory;
    data["filePathAndExtension"] = this.filePathAndExtension;
    data["contentType"] = this.contentType;
    return data;
  }

  clone(): AzureFileShareLocation {
    const json = this.toJSON();
    let result = new AzureFileShareLocation();
    result.init(json);
    return result;
  }
}

export interface IAzureFileShareLocation {
  fileShareName: string | undefined;
  directory: string | undefined;
  filePathAndExtension: string | undefined;
  contentType: string | undefined;
}

export class SamplicityReferencedEntityAttribute implements ISamplicityReferencedEntityAttribute {
  attributeTypeClassificationId: string | undefined;
  attributeValueText: string | undefined;

  constructor(data?: ISamplicityReferencedEntityAttribute) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.attributeTypeClassificationId = _data["attributeTypeClassificationId"];
      this.attributeValueText = _data["attributeValueText"];
    }
  }

  static fromJS(data: any): SamplicityReferencedEntityAttribute {
    data = typeof data === 'object' ? data : {};
    let result = new SamplicityReferencedEntityAttribute();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["attributeTypeClassificationId"] = this.attributeTypeClassificationId;
    data["attributeValueText"] = this.attributeValueText;
    return data;
  }

  clone(): SamplicityReferencedEntityAttribute {
    const json = this.toJSON();
    let result = new SamplicityReferencedEntityAttribute();
    result.init(json);
    return result;
  }
}

export interface ISamplicityReferencedEntityAttribute {
  attributeTypeClassificationId: string | undefined;
  attributeValueText: string | undefined;
}

export class SftpConnection implements ISftpConnection {
  host: string | undefined;
  username: string | undefined;
  password: string | undefined;

  constructor(data?: ISftpConnection) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.host = _data["host"];
      this.username = _data["username"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): SftpConnection {
    data = typeof data === 'object' ? data : {};
    let result = new SftpConnection();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["host"] = this.host;
    data["username"] = this.username;
    data["password"] = this.password;
    return data;
  }

  clone(): SftpConnection {
    const json = this.toJSON();
    let result = new SftpConnection();
    result.init(json);
    return result;
  }
}

export interface ISftpConnection {
  host: string | undefined;
  username: string | undefined;
  password: string | undefined;
}

export class AjaxResponseOfEmailRequest implements IAjaxResponseOfEmailRequest {
  result: EmailRequest | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfEmailRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? EmailRequest.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfEmailRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfEmailRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfEmailRequest {
    const json = this.toJSON();
    let result = new AjaxResponseOfEmailRequest();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfEmailRequest {
  result: EmailRequest | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class EmailRequest implements IEmailRequest {
  options: OutboundCommunicationOptions | undefined;
  emailToAddresses: string[] | undefined;
  emailCcAddresses: string[] | undefined;
  emailBccAddresses: string[] | undefined;
  subject: string | undefined;
  emailContent: DocumentLocation | undefined;
  attachments: DocumentLocation[] | undefined;
  attachmentOptions: EmailRequestAttachmentOptions | undefined;
  context: { [key: string]: string; } | undefined;
  tenantId: number | undefined;
  referencedEntities: SamplicityReferencedEntity[] | undefined;

  constructor(data?: IEmailRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.options = _data["options"] ? OutboundCommunicationOptions.fromJS(_data["options"]) : <any>undefined;
      if (Array.isArray(_data["emailToAddresses"])) {
        this.emailToAddresses = [] as any;
        for (let item of _data["emailToAddresses"])
          this.emailToAddresses.push(item);
      }
      if (Array.isArray(_data["emailCcAddresses"])) {
        this.emailCcAddresses = [] as any;
        for (let item of _data["emailCcAddresses"])
          this.emailCcAddresses.push(item);
      }
      if (Array.isArray(_data["emailBccAddresses"])) {
        this.emailBccAddresses = [] as any;
        for (let item of _data["emailBccAddresses"])
          this.emailBccAddresses.push(item);
      }
      this.subject = _data["subject"];
      this.emailContent = _data["emailContent"] ? DocumentLocation.fromJS(_data["emailContent"]) : <any>undefined;
      if (Array.isArray(_data["attachments"])) {
        this.attachments = [] as any;
        for (let item of _data["attachments"])
          this.attachments.push(DocumentLocation.fromJS(item));
      }
      this.attachmentOptions = _data["attachmentOptions"] ? EmailRequestAttachmentOptions.fromJS(_data["attachmentOptions"]) : <any>undefined;
      if (_data["context"]) {
        this.context = {} as any;
        for (let key in _data["context"]) {
          if (_data["context"].hasOwnProperty(key))
            (<any>this.context)[key] = _data["context"][key];
        }
      }
      this.tenantId = _data["tenantId"];
      if (Array.isArray(_data["referencedEntities"])) {
        this.referencedEntities = [] as any;
        for (let item of _data["referencedEntities"])
          this.referencedEntities.push(SamplicityReferencedEntity.fromJS(item));
      }
    }
  }

  static fromJS(data: any): EmailRequest {
    data = typeof data === 'object' ? data : {};
    let result = new EmailRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["options"] = this.options ? this.options.toJSON() : <any>undefined;
    if (Array.isArray(this.emailToAddresses)) {
      data["emailToAddresses"] = [];
      for (let item of this.emailToAddresses)
        data["emailToAddresses"].push(item);
    }
    if (Array.isArray(this.emailCcAddresses)) {
      data["emailCcAddresses"] = [];
      for (let item of this.emailCcAddresses)
        data["emailCcAddresses"].push(item);
    }
    if (Array.isArray(this.emailBccAddresses)) {
      data["emailBccAddresses"] = [];
      for (let item of this.emailBccAddresses)
        data["emailBccAddresses"].push(item);
    }
    data["subject"] = this.subject;
    data["emailContent"] = this.emailContent ? this.emailContent.toJSON() : <any>undefined;
    if (Array.isArray(this.attachments)) {
      data["attachments"] = [];
      for (let item of this.attachments)
        data["attachments"].push(item.toJSON());
    }
    data["attachmentOptions"] = this.attachmentOptions ? this.attachmentOptions.toJSON() : <any>undefined;
    if (this.context) {
      data["context"] = {};
      for (let key in this.context) {
        if (this.context.hasOwnProperty(key))
          (<any>data["context"])[key] = (<any>this.context)[key];
      }
    }
    data["tenantId"] = this.tenantId;
    if (Array.isArray(this.referencedEntities)) {
      data["referencedEntities"] = [];
      for (let item of this.referencedEntities)
        data["referencedEntities"].push(item.toJSON());
    }
    return data;
  }

  clone(): EmailRequest {
    const json = this.toJSON();
    let result = new EmailRequest();
    result.init(json);
    return result;
  }
}

export interface IEmailRequest {
  options: OutboundCommunicationOptions | undefined;
  emailToAddresses: string[] | undefined;
  emailCcAddresses: string[] | undefined;
  emailBccAddresses: string[] | undefined;
  subject: string | undefined;
  emailContent: DocumentLocation | undefined;
  attachments: DocumentLocation[] | undefined;
  attachmentOptions: EmailRequestAttachmentOptions | undefined;
  context: { [key: string]: string; } | undefined;
  tenantId: number | undefined;
  referencedEntities: SamplicityReferencedEntity[] | undefined;
}

export class OutboundCommunicationOptions implements IOutboundCommunicationOptions {
  communicationRecordOptions: OutboundCommunicationOptionsCommunicationRecordOptions | undefined;
  communicationIds: string[] | undefined;

  constructor(data?: IOutboundCommunicationOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.communicationRecordOptions = _data["communicationRecordOptions"];
      if (Array.isArray(_data["communicationIds"])) {
        this.communicationIds = [] as any;
        for (let item of _data["communicationIds"])
          this.communicationIds.push(item);
      }
    }
  }

  static fromJS(data: any): OutboundCommunicationOptions {
    data = typeof data === 'object' ? data : {};
    let result = new OutboundCommunicationOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["communicationRecordOptions"] = this.communicationRecordOptions;
    if (Array.isArray(this.communicationIds)) {
      data["communicationIds"] = [];
      for (let item of this.communicationIds)
        data["communicationIds"].push(item);
    }
    return data;
  }

  clone(): OutboundCommunicationOptions {
    const json = this.toJSON();
    let result = new OutboundCommunicationOptions();
    result.init(json);
    return result;
  }
}

export interface IOutboundCommunicationOptions {
  communicationRecordOptions: OutboundCommunicationOptionsCommunicationRecordOptions | undefined;
  communicationIds: string[] | undefined;
}

export class AjaxResponseOfEmailResponse implements IAjaxResponseOfEmailResponse {
  result: EmailResponse | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfEmailResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? EmailResponse.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfEmailResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfEmailResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfEmailResponse {
    const json = this.toJSON();
    let result = new AjaxResponseOfEmailResponse();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfEmailResponse {
  result: EmailResponse | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class EmailResponse implements IEmailResponse {
  emailTrackingId: string | undefined;
  emailToAddresses: string[] | undefined;
  emailBccAddresses: string[] | undefined;
  emailCcAddresses: string[] | undefined;
  success: boolean | undefined;
  errorMessage: string | undefined;
  context: { [key: string]: string; } | undefined;
  communicationIds: string[] | undefined;

  constructor(data?: IEmailResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailTrackingId = _data["emailTrackingId"];
      if (Array.isArray(_data["emailToAddresses"])) {
        this.emailToAddresses = [] as any;
        for (let item of _data["emailToAddresses"])
          this.emailToAddresses.push(item);
      }
      if (Array.isArray(_data["emailBccAddresses"])) {
        this.emailBccAddresses = [] as any;
        for (let item of _data["emailBccAddresses"])
          this.emailBccAddresses.push(item);
      }
      if (Array.isArray(_data["emailCcAddresses"])) {
        this.emailCcAddresses = [] as any;
        for (let item of _data["emailCcAddresses"])
          this.emailCcAddresses.push(item);
      }
      this.success = _data["success"];
      this.errorMessage = _data["errorMessage"];
      if (_data["context"]) {
        this.context = {} as any;
        for (let key in _data["context"]) {
          if (_data["context"].hasOwnProperty(key))
            (<any>this.context)[key] = _data["context"][key];
        }
      }
      if (Array.isArray(_data["communicationIds"])) {
        this.communicationIds = [] as any;
        for (let item of _data["communicationIds"])
          this.communicationIds.push(item);
      }
    }
  }

  static fromJS(data: any): EmailResponse {
    data = typeof data === 'object' ? data : {};
    let result = new EmailResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["emailTrackingId"] = this.emailTrackingId;
    if (Array.isArray(this.emailToAddresses)) {
      data["emailToAddresses"] = [];
      for (let item of this.emailToAddresses)
        data["emailToAddresses"].push(item);
    }
    if (Array.isArray(this.emailBccAddresses)) {
      data["emailBccAddresses"] = [];
      for (let item of this.emailBccAddresses)
        data["emailBccAddresses"].push(item);
    }
    if (Array.isArray(this.emailCcAddresses)) {
      data["emailCcAddresses"] = [];
      for (let item of this.emailCcAddresses)
        data["emailCcAddresses"].push(item);
    }
    data["success"] = this.success;
    data["errorMessage"] = this.errorMessage;
    if (this.context) {
      data["context"] = {};
      for (let key in this.context) {
        if (this.context.hasOwnProperty(key))
          (<any>data["context"])[key] = (<any>this.context)[key];
      }
    }
    if (Array.isArray(this.communicationIds)) {
      data["communicationIds"] = [];
      for (let item of this.communicationIds)
        data["communicationIds"].push(item);
    }
    return data;
  }

  clone(): EmailResponse {
    const json = this.toJSON();
    let result = new EmailResponse();
    result.init(json);
    return result;
  }
}

export interface IEmailResponse {
  emailTrackingId: string | undefined;
  emailToAddresses: string[] | undefined;
  emailBccAddresses: string[] | undefined;
  emailCcAddresses: string[] | undefined;
  success: boolean | undefined;
  errorMessage: string | undefined;
  context: { [key: string]: string; } | undefined;
  communicationIds: string[] | undefined;
}

export class Order3PLStatusRequestDto implements IOrder3PLStatusRequestDto {
  clientOrderId: string | undefined;
  orderNumber: string | undefined;
  companyId: string | undefined;

  constructor(data?: IOrder3PLStatusRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientOrderId = _data["clientOrderId"];
      this.orderNumber = _data["orderNumber"];
      this.companyId = _data["companyId"];
    }
  }

  static fromJS(data: any): Order3PLStatusRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new Order3PLStatusRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientOrderId"] = this.clientOrderId;
    data["orderNumber"] = this.orderNumber;
    data["companyId"] = this.companyId;
    return data;
  }

  clone(): Order3PLStatusRequestDto {
    const json = this.toJSON();
    let result = new Order3PLStatusRequestDto();
    result.init(json);
    return result;
  }
}

export interface IOrder3PLStatusRequestDto {
  clientOrderId: string | undefined;
  orderNumber: string | undefined;
  companyId: string | undefined;
}

export class Order3PLStatusResponseDto implements IOrder3PLStatusResponseDto {
  clientOrderId: string | undefined;
  omsOrderNumber: string | undefined;
  customerName: string | undefined;
  status: string | undefined;
  statusDescription: string | undefined;
  statusDate: string | undefined;
  shippingDetails: ShippingInfo | undefined;
  errorMessage: string | undefined;

  constructor(data?: IOrder3PLStatusResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientOrderId = _data["clientOrderId"];
      this.omsOrderNumber = _data["omsOrderNumber"];
      this.customerName = _data["customerName"];
      this.status = _data["status"];
      this.statusDescription = _data["statusDescription"];
      this.statusDate = _data["statusDate"];
      this.shippingDetails = _data["shippingDetails"] ? ShippingInfo.fromJS(_data["shippingDetails"]) : <any>undefined;
      this.errorMessage = _data["errorMessage"];
    }
  }

  static fromJS(data: any): Order3PLStatusResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new Order3PLStatusResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientOrderId"] = this.clientOrderId;
    data["omsOrderNumber"] = this.omsOrderNumber;
    data["customerName"] = this.customerName;
    data["status"] = this.status;
    data["statusDescription"] = this.statusDescription;
    data["statusDate"] = this.statusDate;
    data["shippingDetails"] = this.shippingDetails ? this.shippingDetails.toJSON() : <any>undefined;
    data["errorMessage"] = this.errorMessage;
    return data;
  }

  clone(): Order3PLStatusResponseDto {
    const json = this.toJSON();
    let result = new Order3PLStatusResponseDto();
    result.init(json);
    return result;
  }
}

export interface IOrder3PLStatusResponseDto {
  clientOrderId: string | undefined;
  omsOrderNumber: string | undefined;
  customerName: string | undefined;
  status: string | undefined;
  statusDescription: string | undefined;
  statusDate: string | undefined;
  shippingDetails: ShippingInfo | undefined;
  errorMessage: string | undefined;
}

export class ShippingInfo implements IShippingInfo {
  carrier: string | undefined;
  tracking_number: string | undefined;
  trackingUrl: string | undefined;
  service_level: string | undefined;
  shipped_date: Date | undefined;
  estimated_delivery_date: Date | undefined;
  actual_delivery_date: Date | undefined;

  constructor(data?: IShippingInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.carrier = _data["carrier"];
      this.tracking_number = _data["tracking_number"];
      this.trackingUrl = _data["trackingUrl"];
      this.service_level = _data["service_level"];
      this.shipped_date = _data["shipped_date"] ? new Date(_data["shipped_date"].toString()) : <any>undefined;
      this.estimated_delivery_date = _data["estimated_delivery_date"] ? new Date(_data["estimated_delivery_date"].toString()) : <any>undefined;
      this.actual_delivery_date = _data["actual_delivery_date"] ? new Date(_data["actual_delivery_date"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): ShippingInfo {
    data = typeof data === 'object' ? data : {};
    let result = new ShippingInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["carrier"] = this.carrier;
    data["tracking_number"] = this.tracking_number;
    data["trackingUrl"] = this.trackingUrl;
    data["service_level"] = this.service_level;
    data["shipped_date"] = this.shipped_date ? this.shipped_date.toISOString() : <any>undefined;
    data["estimated_delivery_date"] = this.estimated_delivery_date ? this.estimated_delivery_date.toISOString() : <any>undefined;
    data["actual_delivery_date"] = this.actual_delivery_date ? this.actual_delivery_date.toISOString() : <any>undefined;
    return data;
  }

  clone(): ShippingInfo {
    const json = this.toJSON();
    let result = new ShippingInfo();
    result.init(json);
    return result;
  }
}

export interface IShippingInfo {
  carrier: string | undefined;
  tracking_number: string | undefined;
  trackingUrl: string | undefined;
  service_level: string | undefined;
  shipped_date: Date | undefined;
  estimated_delivery_date: Date | undefined;
  actual_delivery_date: Date | undefined;
}

export class Order3PLStatusHistoryRequestDto implements IOrder3PLStatusHistoryRequestDto {
  clientOrderId: string | undefined;
  orderNumber: string | undefined;
  companyId: string | undefined;

  constructor(data?: IOrder3PLStatusHistoryRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientOrderId = _data["clientOrderId"];
      this.orderNumber = _data["orderNumber"];
      this.companyId = _data["companyId"];
    }
  }

  static fromJS(data: any): Order3PLStatusHistoryRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new Order3PLStatusHistoryRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientOrderId"] = this.clientOrderId;
    data["orderNumber"] = this.orderNumber;
    data["companyId"] = this.companyId;
    return data;
  }

  clone(): Order3PLStatusHistoryRequestDto {
    const json = this.toJSON();
    let result = new Order3PLStatusHistoryRequestDto();
    result.init(json);
    return result;
  }
}

export interface IOrder3PLStatusHistoryRequestDto {
  clientOrderId: string | undefined;
  orderNumber: string | undefined;
  companyId: string | undefined;
}

export class Order3PLStatusHistoryResponseDto implements IOrder3PLStatusHistoryResponseDto {
  clientOrderId: string | undefined;
  omsOrderNumber: string | undefined;
  customerName: string | undefined;
  errorMessage: string | undefined;
  orderStatusHistoryData: OrderStatusHistoryData[] | undefined;

  constructor(data?: IOrder3PLStatusHistoryResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientOrderId = _data["clientOrderId"];
      this.omsOrderNumber = _data["omsOrderNumber"];
      this.customerName = _data["customerName"];
      this.errorMessage = _data["errorMessage"];
      if (Array.isArray(_data["orderStatusHistoryData"])) {
        this.orderStatusHistoryData = [] as any;
        for (let item of _data["orderStatusHistoryData"])
          this.orderStatusHistoryData.push(OrderStatusHistoryData.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Order3PLStatusHistoryResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new Order3PLStatusHistoryResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["clientOrderId"] = this.clientOrderId;
    data["omsOrderNumber"] = this.omsOrderNumber;
    data["customerName"] = this.customerName;
    data["errorMessage"] = this.errorMessage;
    if (Array.isArray(this.orderStatusHistoryData)) {
      data["orderStatusHistoryData"] = [];
      for (let item of this.orderStatusHistoryData)
        data["orderStatusHistoryData"].push(item.toJSON());
    }
    return data;
  }

  clone(): Order3PLStatusHistoryResponseDto {
    const json = this.toJSON();
    let result = new Order3PLStatusHistoryResponseDto();
    result.init(json);
    return result;
  }
}

export interface IOrder3PLStatusHistoryResponseDto {
  clientOrderId: string | undefined;
  omsOrderNumber: string | undefined;
  customerName: string | undefined;
  errorMessage: string | undefined;
  orderStatusHistoryData: OrderStatusHistoryData[] | undefined;
}

export class OrderStatusHistoryData implements IOrderStatusHistoryData {
  status: string | undefined;
  statusDescription: string | undefined;
  statusDate: string | undefined;
  shippingDetails: ShippingInfo | undefined;

  constructor(data?: IOrderStatusHistoryData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.status = _data["status"];
      this.statusDescription = _data["statusDescription"];
      this.statusDate = _data["statusDate"];
      this.shippingDetails = _data["shippingDetails"] ? ShippingInfo.fromJS(_data["shippingDetails"]) : <any>undefined;
    }
  }

  static fromJS(data: any): OrderStatusHistoryData {
    data = typeof data === 'object' ? data : {};
    let result = new OrderStatusHistoryData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["status"] = this.status;
    data["statusDescription"] = this.statusDescription;
    data["statusDate"] = this.statusDate;
    data["shippingDetails"] = this.shippingDetails ? this.shippingDetails.toJSON() : <any>undefined;
    return data;
  }

  clone(): OrderStatusHistoryData {
    const json = this.toJSON();
    let result = new OrderStatusHistoryData();
    result.init(json);
    return result;
  }
}

export interface IOrderStatusHistoryData {
  status: string | undefined;
  statusDescription: string | undefined;
  statusDate: string | undefined;
  shippingDetails: ShippingInfo | undefined;
}

export class Order3PLRequestDto implements IOrder3PLRequestDto {
  accountCode: string | undefined;
  billToAddress1: string | undefined;
  billToAddress2: string | undefined;
  billToCity: string | undefined;
  billToCountry: string | undefined;
  billToName: string | undefined;
  billToState: string | undefined;
  billToZip: string | undefined;
  apEmailAddress: string | undefined;
  customerType: string | undefined;
  customerNumber: string | undefined;
  lineOfBusiness: string | undefined;
  depositorOrderNum: string | undefined;
  desiredDeliveryDate: Date | undefined;
  externalBillingNbr: string | undefined;
  clientOrderId: string | undefined;
  facilityName: string | undefined;
  methodCode: string | undefined;
  orderDate: Date | undefined;
  orderType: string | undefined;
  packSize: number | undefined;
  pickTicketNumber: number | undefined;
  programCode: string | undefined;
  address1: string | undefined;
  address2: string | undefined;
  address3: string | undefined;
  city: string | undefined;
  countryCode: string | undefined;
  dea: string | undefined;
  email: string | undefined;
  phone: string | undefined;
  san: string | undefined;
  sanExemption: boolean | undefined;
  state: string | undefined;
  sln: string | undefined;
  slnStateCode: string | undefined;
  zip: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  middleName: string | undefined;
  routing: string | undefined;
  shipDate: Date | undefined;
  orderPriority: string | undefined;
  shippingPayment: string | undefined;
  department: string | undefined;
  dcNumber: string | undefined;
  poShipTo: string | undefined;
  clientId: string | undefined;
  attentionToName: string | undefined;
  shippingInstructions: string | undefined;
  orderLines: ThreePLOrderLineRequestDto[] | undefined;

  constructor(data?: IOrder3PLRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accountCode = _data["accountCode"];
      this.billToAddress1 = _data["billToAddress1"];
      this.billToAddress2 = _data["billToAddress2"];
      this.billToCity = _data["billToCity"];
      this.billToCountry = _data["billToCountry"];
      this.billToName = _data["billToName"];
      this.billToState = _data["billToState"];
      this.billToZip = _data["billToZip"];
      this.apEmailAddress = _data["apEmailAddress"];
      this.customerType = _data["customerType"];
      this.customerNumber = _data["customerNumber"];
      this.lineOfBusiness = _data["lineOfBusiness"];
      this.depositorOrderNum = _data["depositorOrderNum"];
      this.desiredDeliveryDate = _data["desiredDeliveryDate"] ? new Date(_data["desiredDeliveryDate"].toString()) : <any>undefined;
      this.externalBillingNbr = _data["externalBillingNbr"];
      this.clientOrderId = _data["clientOrderId"];
      this.facilityName = _data["facilityName"];
      this.methodCode = _data["methodCode"];
      this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
      this.orderType = _data["orderType"];
      this.packSize = _data["packSize"];
      this.pickTicketNumber = _data["pickTicketNumber"];
      this.programCode = _data["programCode"];
      this.address1 = _data["address1"];
      this.address2 = _data["address2"];
      this.address3 = _data["address3"];
      this.city = _data["city"];
      this.countryCode = _data["countryCode"];
      this.dea = _data["dea"];
      this.email = _data["email"];
      this.phone = _data["phone"];
      this.san = _data["san"];
      this.sanExemption = _data["sanExemption"];
      this.state = _data["state"];
      this.sln = _data["sln"];
      this.slnStateCode = _data["slnStateCode"];
      this.zip = _data["zip"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.middleName = _data["middleName"];
      this.routing = _data["routing"];
      this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : <any>undefined;
      this.orderPriority = _data["orderPriority"];
      this.shippingPayment = _data["shippingPayment"];
      this.department = _data["department"];
      this.dcNumber = _data["dcNumber"];
      this.poShipTo = _data["poShipTo"];
      this.clientId = _data["clientId"];
      this.attentionToName = _data["attentionToName"];
      this.shippingInstructions = _data["shippingInstructions"];
      if (Array.isArray(_data["orderLines"])) {
        this.orderLines = [] as any;
        for (let item of _data["orderLines"])
          this.orderLines.push(ThreePLOrderLineRequestDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Order3PLRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new Order3PLRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["accountCode"] = this.accountCode;
    data["billToAddress1"] = this.billToAddress1;
    data["billToAddress2"] = this.billToAddress2;
    data["billToCity"] = this.billToCity;
    data["billToCountry"] = this.billToCountry;
    data["billToName"] = this.billToName;
    data["billToState"] = this.billToState;
    data["billToZip"] = this.billToZip;
    data["apEmailAddress"] = this.apEmailAddress;
    data["customerType"] = this.customerType;
    data["customerNumber"] = this.customerNumber;
    data["lineOfBusiness"] = this.lineOfBusiness;
    data["depositorOrderNum"] = this.depositorOrderNum;
    data["desiredDeliveryDate"] = this.desiredDeliveryDate ? this.desiredDeliveryDate.toISOString() : <any>undefined;
    data["externalBillingNbr"] = this.externalBillingNbr;
    data["clientOrderId"] = this.clientOrderId;
    data["facilityName"] = this.facilityName;
    data["methodCode"] = this.methodCode;
    data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
    data["orderType"] = this.orderType;
    data["packSize"] = this.packSize;
    data["pickTicketNumber"] = this.pickTicketNumber;
    data["programCode"] = this.programCode;
    data["address1"] = this.address1;
    data["address2"] = this.address2;
    data["address3"] = this.address3;
    data["city"] = this.city;
    data["countryCode"] = this.countryCode;
    data["dea"] = this.dea;
    data["email"] = this.email;
    data["phone"] = this.phone;
    data["san"] = this.san;
    data["sanExemption"] = this.sanExemption;
    data["state"] = this.state;
    data["sln"] = this.sln;
    data["slnStateCode"] = this.slnStateCode;
    data["zip"] = this.zip;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["middleName"] = this.middleName;
    data["routing"] = this.routing;
    data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : <any>undefined;
    data["orderPriority"] = this.orderPriority;
    data["shippingPayment"] = this.shippingPayment;
    data["department"] = this.department;
    data["dcNumber"] = this.dcNumber;
    data["poShipTo"] = this.poShipTo;
    data["clientId"] = this.clientId;
    data["attentionToName"] = this.attentionToName;
    data["shippingInstructions"] = this.shippingInstructions;
    if (Array.isArray(this.orderLines)) {
      data["orderLines"] = [];
      for (let item of this.orderLines)
        data["orderLines"].push(item.toJSON());
    }
    return data;
  }

  clone(): Order3PLRequestDto {
    const json = this.toJSON();
    let result = new Order3PLRequestDto();
    result.init(json);
    return result;
  }
}

export interface IOrder3PLRequestDto {
  accountCode: string | undefined;
  billToAddress1: string | undefined;
  billToAddress2: string | undefined;
  billToCity: string | undefined;
  billToCountry: string | undefined;
  billToName: string | undefined;
  billToState: string | undefined;
  billToZip: string | undefined;
  apEmailAddress: string | undefined;
  customerType: string | undefined;
  customerNumber: string | undefined;
  lineOfBusiness: string | undefined;
  depositorOrderNum: string | undefined;
  desiredDeliveryDate: Date | undefined;
  externalBillingNbr: string | undefined;
  clientOrderId: string | undefined;
  facilityName: string | undefined;
  methodCode: string | undefined;
  orderDate: Date | undefined;
  orderType: string | undefined;
  packSize: number | undefined;
  pickTicketNumber: number | undefined;
  programCode: string | undefined;
  address1: string | undefined;
  address2: string | undefined;
  address3: string | undefined;
  city: string | undefined;
  countryCode: string | undefined;
  dea: string | undefined;
  email: string | undefined;
  phone: string | undefined;
  san: string | undefined;
  sanExemption: boolean | undefined;
  state: string | undefined;
  sln: string | undefined;
  slnStateCode: string | undefined;
  zip: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  middleName: string | undefined;
  routing: string | undefined;
  shipDate: Date | undefined;
  orderPriority: string | undefined;
  shippingPayment: string | undefined;
  department: string | undefined;
  dcNumber: string | undefined;
  poShipTo: string | undefined;
  clientId: string | undefined;
  attentionToName: string | undefined;
  shippingInstructions: string | undefined;
  orderLines: ThreePLOrderLineRequestDto[] | undefined;
}

export class ThreePLOrderLineRequestDto implements IThreePLOrderLineRequestDto {
  orderQty: number | undefined;
  clientOrderLineId: string | undefined;
  poLineNum: number | undefined;
  productCode: string | undefined;
  clientProductCode: string | undefined;
  productPrice: number | undefined;
  purchaseUOM: string | undefined;

  constructor(data?: IThreePLOrderLineRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderQty = _data["orderQty"];
      this.clientOrderLineId = _data["clientOrderLineId"];
      this.poLineNum = _data["poLineNum"];
      this.productCode = _data["productCode"];
      this.clientProductCode = _data["clientProductCode"];
      this.productPrice = _data["productPrice"];
      this.purchaseUOM = _data["purchaseUOM"];
    }
  }

  static fromJS(data: any): ThreePLOrderLineRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThreePLOrderLineRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderQty"] = this.orderQty;
    data["clientOrderLineId"] = this.clientOrderLineId;
    data["poLineNum"] = this.poLineNum;
    data["productCode"] = this.productCode;
    data["clientProductCode"] = this.clientProductCode;
    data["productPrice"] = this.productPrice;
    data["purchaseUOM"] = this.purchaseUOM;
    return data;
  }

  clone(): ThreePLOrderLineRequestDto {
    const json = this.toJSON();
    let result = new ThreePLOrderLineRequestDto();
    result.init(json);
    return result;
  }
}

export interface IThreePLOrderLineRequestDto {
  orderQty: number | undefined;
  clientOrderLineId: string | undefined;
  poLineNum: number | undefined;
  productCode: string | undefined;
  clientProductCode: string | undefined;
  productPrice: number | undefined;
  purchaseUOM: string | undefined;
}

export class Order3PLResponseDto implements IOrder3PLResponseDto {
  order: Order | undefined;
  validationResult: ValidationResult | undefined;

  constructor(data?: IOrder3PLResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.validationResult = _data["validationResult"] ? ValidationResult.fromJS(_data["validationResult"]) : <any>undefined;
    }
  }

  static fromJS(data: any): Order3PLResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new Order3PLResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["validationResult"] = this.validationResult ? this.validationResult.toJSON() : <any>undefined;
    return data;
  }

  clone(): Order3PLResponseDto {
    const json = this.toJSON();
    let result = new Order3PLResponseDto();
    result.init(json);
    return result;
  }
}

export interface IOrder3PLResponseDto {
  order: Order | undefined;
  validationResult: ValidationResult | undefined;
}

export class Order implements IOrder {
  orderedByUserProfileId: string | undefined;
  territoryId: string | undefined;
  territory: Territory | undefined;
  orderTypeClassificationValueId: string | undefined;
  approvedByUserProfileId: string | undefined;
  cancelledByUserProfileId: string | undefined;
  orderNumberText: string | undefined;
  kid: string | undefined;
  externalOrderNbr: string | undefined;
  externalFormId: string | undefined;
  internalFormId: string | undefined;
  orderDate: Date | undefined;
  needByDate: Date | undefined;
  rushFlag: boolean | undefined;
  approvedDate: Date | undefined;
  addressVerifiedFlag: boolean | undefined;
  orderInternalNbr: number | undefined;
  orderFulfillmentId: string | undefined;
  isPostProcessedFlag: boolean | undefined;
  parentOrderId: string | undefined;
  parentOrder: Order | undefined;
  replacementOrderId: string | undefined;
  replacementOrder: Order | undefined;
  originalOrderId: string | undefined;
  originalOrder: Order | undefined;
  requestorHcpId: string | undefined;
  requestorHcp: Hcp | undefined;
  recipientHcpId: string | undefined;
  recipientHcp: Hcp | undefined;
  secondaryValidationFlag: boolean | undefined;
  requestorPharmacistId: string | undefined;
  requestorPharmacist: Pharmacist | undefined;
  recipientPharmacistId: string | undefined;
  recipientPharmacist: Pharmacist | undefined;
  moduleId: string | undefined;
  programId: string | undefined;
  program: Program | undefined;
  recipientHcpAddressId: string | undefined;
  recipientHcpAddress: HcpAddress | undefined;
  requestorHcpAddressId: string | undefined;
  requestorHcpAddress: HcpAddress | undefined;
  salesRepId: string | undefined;
  salesRep: SalesRep | undefined;
  orderSourceId: string | undefined;
  orderStatusId: string | undefined;
  orderStatusLastModifiedTime: Date | undefined;
  offerId: string | undefined;
  offer: Offer | undefined;
  requestorClientTargetId: string | undefined;
  requestorCompanyName: string | undefined;
  requestorFirstName: string | undefined;
  requestorMiddleName: string | undefined;
  requestorLastName: string | undefined;
  requestorSuffix: string | undefined;
  requestorSuffixClassificationValueId: string | undefined;
  requestorProfessionalDesignationValueCode: string | undefined;
  requestorProfessionalDesignationId: string | undefined;
  requestorSpecialityCode: string | undefined;
  requestorSpecialityClassificationValueId: string | undefined;
  requestorStateLicenceNbr: string | undefined;
  requestorStateLicenceStateCodeId: string | undefined;
  requestorStateLicenceStateCode: string | undefined;
  requestorDeaNbr: string | undefined;
  requestorSan: string | undefined;
  requestorAddressId: string | undefined;
  requestorAddress1Text: string | undefined;
  requestorAddress2Text: string | undefined;
  requestorAddress3Text: string | undefined;
  requestorAddress4Text: string | undefined;
  requestorCityName: string | undefined;
  requestorZipCode: string | undefined;
  requestorStateCodeId: string | undefined;
  requestorStateCode: string | undefined;
  requestorCountryCodeId: string | undefined;
  requestorCountryCode: string | undefined;
  requestorEmailAddressText: string | undefined;
  requestorPhoneNbr: string | undefined;
  requestorPhoneExtensionNbr: string | undefined;
  requestorMobileNbr: string | undefined;
  requestorFaxNbr: string | undefined;
  requestorSANExemption: boolean | undefined;
  recipientAttentionToName: string | undefined;
  recipientSANExemption: boolean | undefined;
  recipientCompanyName: string | undefined;
  recipientTitleClassificationValueId: string | undefined;
  recipientFirstName: string | undefined;
  recipientMiddleName: string | undefined;
  recipientLastName: string | undefined;
  recipientSuffix: string | undefined;
  recipientSuffixClassificationValueId: string | undefined;
  recipientProfessionDesignationValueCode: string | undefined;
  recipientProfessionDesignationId: string | undefined;
  recipientSpecialityCode: string | undefined;
  recipientSpecialityClassificationValueId: string | undefined;
  recipientStateLicenceNbr: string | undefined;
  recipientStateLicenceStateCodeId: string | undefined;
  recipientStateLicenceStateCode: string | undefined;
  recipientDeaNbr: string | undefined;
  recipientSan: string | undefined;
  recipientAddressId: string | undefined;
  recipientAddress1Text: string | undefined;
  recipientAddress2Text: string | undefined;
  recipientAddress3Text: string | undefined;
  recipientAddress4Text: string | undefined;
  recipientCityName: string | undefined;
  recipientZipCode: string | undefined;
  recipientStateCodeId: string | undefined;
  recipientStateCode: string | undefined;
  recipientCountryCodeId: string | undefined;
  recipientCountryCode: string | undefined;
  recipientEmailAddressText: string | undefined;
  recipientPhoneNbr: string | undefined;
  recipientPhoneExtensionNbr: string | undefined;
  recipientMobileNumber: string | undefined;
  recipientFaxNbr: string | undefined;
  salesRepNbr: string | undefined;
  salesRepFirstName: string | undefined;
  salesRepMiddleName: string | undefined;
  salesRepLastName: string | undefined;
  salesRepEmailAddressText: string | undefined;
  territoryCode: string | undefined;
  postValidationFlag: boolean | undefined;
  lockedByUserId: number | undefined;
  lockTimestamp: Date | undefined;
  unlockedByUserId: number | undefined;
  unlockTimestamp: Date | undefined;
  unlockReasonId: string | undefined;
  lockExpiryTimestamp: Date | undefined;
  blackoutHoldReleaseReasonClassificationValueId: string | undefined;
  blackoutHoldReleaseReasonDescription: string | undefined;
  requestorNpiNbr: string | undefined;
  caseId: string | undefined;
  sourceCode: string | undefined;
  deAuditRequired: boolean | undefined;
  salesforceId: string | undefined;
  recipientInstitutionTerritoryNumber: string | undefined;
  customerId: string | undefined;
  customerTypeClassificationValueId: string | undefined;
  salesOrderTypeClassificationValueId: string | undefined;
  externalNotes: string | undefined;
  replacementOrders: Order[] | undefined;
  childOrders: Order[] | undefined;
  orderLines: OrderLine[] | undefined;
  orderStatusReasons: OrderStatusReason[] | undefined;
  orderAttachments: OrderAttachment[] | undefined;
  orderComments: OrderComment[] | undefined;
  orderContexts: OrderContext[] | undefined;
  orderStatusHistories: OrderStatusHistory[] | undefined;
  shipments: Shipment[] | undefined;
  orderInvestigations: OrderInvestigation[] | undefined;
  orderValidations: OrderValidation[] | undefined;
  aocs: Aoc[] | undefined;
  svls: Svl[] | undefined;
  orderFormFields: OrderFormField[] | undefined;
  orderPlitInvestigations: OrderPlitInvestigation[] | undefined;
  orderSelectDayVerifications: OrderSelectDayVerification[] | undefined;
  returns: OrderReturn[] | undefined;
  rrofrOrders: RrofrOrder[] | undefined;
  hcpDoNotHonorExclusions: HcpDoNotHonorExclusion[] | undefined;
  orderInvoices: OrderInvoice[] | undefined;
  dtpOrder: TplOrder | undefined;
  fgOrder: FgOrder | undefined;
  orderStatus: ReferencedClassification | undefined;
  patientOrder: PatientOrder | undefined;
  requestDate: Date | undefined;
  customer: Customer | undefined;
  paymentMethodClassificationValueId: string | undefined;
  billingAddressId: string | undefined;
  billToEmail: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrder) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderedByUserProfileId = _data["orderedByUserProfileId"];
      this.territoryId = _data["territoryId"];
      this.territory = _data["territory"] ? Territory.fromJS(_data["territory"]) : <any>undefined;
      this.orderTypeClassificationValueId = _data["orderTypeClassificationValueId"];
      this.approvedByUserProfileId = _data["approvedByUserProfileId"];
      this.cancelledByUserProfileId = _data["cancelledByUserProfileId"];
      this.orderNumberText = _data["orderNumberText"];
      this.kid = _data["kid"];
      this.externalOrderNbr = _data["externalOrderNbr"];
      this.externalFormId = _data["externalFormId"];
      this.internalFormId = _data["internalFormId"];
      this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
      this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : <any>undefined;
      this.rushFlag = _data["rushFlag"];
      this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
      this.addressVerifiedFlag = _data["addressVerifiedFlag"];
      this.orderInternalNbr = _data["orderInternalNbr"];
      this.orderFulfillmentId = _data["orderFulfillmentId"];
      this.isPostProcessedFlag = _data["isPostProcessedFlag"];
      this.parentOrderId = _data["parentOrderId"];
      this.parentOrder = _data["parentOrder"] ? Order.fromJS(_data["parentOrder"]) : <any>undefined;
      this.replacementOrderId = _data["replacementOrderId"];
      this.replacementOrder = _data["replacementOrder"] ? Order.fromJS(_data["replacementOrder"]) : <any>undefined;
      this.originalOrderId = _data["originalOrderId"];
      this.originalOrder = _data["originalOrder"] ? Order.fromJS(_data["originalOrder"]) : <any>undefined;
      this.requestorHcpId = _data["requestorHcpId"];
      this.requestorHcp = _data["requestorHcp"] ? Hcp.fromJS(_data["requestorHcp"]) : <any>undefined;
      this.recipientHcpId = _data["recipientHcpId"];
      this.recipientHcp = _data["recipientHcp"] ? Hcp.fromJS(_data["recipientHcp"]) : <any>undefined;
      this.secondaryValidationFlag = _data["secondaryValidationFlag"];
      this.requestorPharmacistId = _data["requestorPharmacistId"];
      this.requestorPharmacist = _data["requestorPharmacist"] ? Pharmacist.fromJS(_data["requestorPharmacist"]) : <any>undefined;
      this.recipientPharmacistId = _data["recipientPharmacistId"];
      this.recipientPharmacist = _data["recipientPharmacist"] ? Pharmacist.fromJS(_data["recipientPharmacist"]) : <any>undefined;
      this.moduleId = _data["moduleId"];
      this.programId = _data["programId"];
      this.program = _data["program"] ? Program.fromJS(_data["program"]) : <any>undefined;
      this.recipientHcpAddressId = _data["recipientHcpAddressId"];
      this.recipientHcpAddress = _data["recipientHcpAddress"] ? HcpAddress.fromJS(_data["recipientHcpAddress"]) : <any>undefined;
      this.requestorHcpAddressId = _data["requestorHcpAddressId"];
      this.requestorHcpAddress = _data["requestorHcpAddress"] ? HcpAddress.fromJS(_data["requestorHcpAddress"]) : <any>undefined;
      this.salesRepId = _data["salesRepId"];
      this.salesRep = _data["salesRep"] ? SalesRep.fromJS(_data["salesRep"]) : <any>undefined;
      this.orderSourceId = _data["orderSourceId"];
      this.orderStatusId = _data["orderStatusId"];
      this.orderStatusLastModifiedTime = _data["orderStatusLastModifiedTime"] ? new Date(_data["orderStatusLastModifiedTime"].toString()) : <any>undefined;
      this.offerId = _data["offerId"];
      this.offer = _data["offer"] ? Offer.fromJS(_data["offer"]) : <any>undefined;
      this.requestorClientTargetId = _data["requestorClientTargetId"];
      this.requestorCompanyName = _data["requestorCompanyName"];
      this.requestorFirstName = _data["requestorFirstName"];
      this.requestorMiddleName = _data["requestorMiddleName"];
      this.requestorLastName = _data["requestorLastName"];
      this.requestorSuffix = _data["requestorSuffix"];
      this.requestorSuffixClassificationValueId = _data["requestorSuffixClassificationValueId"];
      this.requestorProfessionalDesignationValueCode = _data["requestorProfessionalDesignationValueCode"];
      this.requestorProfessionalDesignationId = _data["requestorProfessionalDesignationId"];
      this.requestorSpecialityCode = _data["requestorSpecialityCode"];
      this.requestorSpecialityClassificationValueId = _data["requestorSpecialityClassificationValueId"];
      this.requestorStateLicenceNbr = _data["requestorStateLicenceNbr"];
      this.requestorStateLicenceStateCodeId = _data["requestorStateLicenceStateCodeId"];
      this.requestorStateLicenceStateCode = _data["requestorStateLicenceStateCode"];
      this.requestorDeaNbr = _data["requestorDeaNbr"];
      this.requestorSan = _data["requestorSan"];
      this.requestorAddressId = _data["requestorAddressId"];
      this.requestorAddress1Text = _data["requestorAddress1Text"];
      this.requestorAddress2Text = _data["requestorAddress2Text"];
      this.requestorAddress3Text = _data["requestorAddress3Text"];
      this.requestorAddress4Text = _data["requestorAddress4Text"];
      this.requestorCityName = _data["requestorCityName"];
      this.requestorZipCode = _data["requestorZipCode"];
      this.requestorStateCodeId = _data["requestorStateCodeId"];
      this.requestorStateCode = _data["requestorStateCode"];
      this.requestorCountryCodeId = _data["requestorCountryCodeId"];
      this.requestorCountryCode = _data["requestorCountryCode"];
      this.requestorEmailAddressText = _data["requestorEmailAddressText"];
      this.requestorPhoneNbr = _data["requestorPhoneNbr"];
      this.requestorPhoneExtensionNbr = _data["requestorPhoneExtensionNbr"];
      this.requestorMobileNbr = _data["requestorMobileNbr"];
      this.requestorFaxNbr = _data["requestorFaxNbr"];
      this.requestorSANExemption = _data["requestorSANExemption"];
      this.recipientAttentionToName = _data["recipientAttentionToName"];
      this.recipientSANExemption = _data["recipientSANExemption"];
      this.recipientCompanyName = _data["recipientCompanyName"];
      this.recipientTitleClassificationValueId = _data["recipientTitleClassificationValueId"];
      this.recipientFirstName = _data["recipientFirstName"];
      this.recipientMiddleName = _data["recipientMiddleName"];
      this.recipientLastName = _data["recipientLastName"];
      this.recipientSuffix = _data["recipientSuffix"];
      this.recipientSuffixClassificationValueId = _data["recipientSuffixClassificationValueId"];
      this.recipientProfessionDesignationValueCode = _data["recipientProfessionDesignationValueCode"];
      this.recipientProfessionDesignationId = _data["recipientProfessionDesignationId"];
      this.recipientSpecialityCode = _data["recipientSpecialityCode"];
      this.recipientSpecialityClassificationValueId = _data["recipientSpecialityClassificationValueId"];
      this.recipientStateLicenceNbr = _data["recipientStateLicenceNbr"];
      this.recipientStateLicenceStateCodeId = _data["recipientStateLicenceStateCodeId"];
      this.recipientStateLicenceStateCode = _data["recipientStateLicenceStateCode"];
      this.recipientDeaNbr = _data["recipientDeaNbr"];
      this.recipientSan = _data["recipientSan"];
      this.recipientAddressId = _data["recipientAddressId"];
      this.recipientAddress1Text = _data["recipientAddress1Text"];
      this.recipientAddress2Text = _data["recipientAddress2Text"];
      this.recipientAddress3Text = _data["recipientAddress3Text"];
      this.recipientAddress4Text = _data["recipientAddress4Text"];
      this.recipientCityName = _data["recipientCityName"];
      this.recipientZipCode = _data["recipientZipCode"];
      this.recipientStateCodeId = _data["recipientStateCodeId"];
      this.recipientStateCode = _data["recipientStateCode"];
      this.recipientCountryCodeId = _data["recipientCountryCodeId"];
      this.recipientCountryCode = _data["recipientCountryCode"];
      this.recipientEmailAddressText = _data["recipientEmailAddressText"];
      this.recipientPhoneNbr = _data["recipientPhoneNbr"];
      this.recipientPhoneExtensionNbr = _data["recipientPhoneExtensionNbr"];
      this.recipientMobileNumber = _data["recipientMobileNumber"];
      this.recipientFaxNbr = _data["recipientFaxNbr"];
      this.salesRepNbr = _data["salesRepNbr"];
      this.salesRepFirstName = _data["salesRepFirstName"];
      this.salesRepMiddleName = _data["salesRepMiddleName"];
      this.salesRepLastName = _data["salesRepLastName"];
      this.salesRepEmailAddressText = _data["salesRepEmailAddressText"];
      this.territoryCode = _data["territoryCode"];
      this.postValidationFlag = _data["postValidationFlag"];
      this.lockedByUserId = _data["lockedByUserId"];
      this.lockTimestamp = _data["lockTimestamp"] ? new Date(_data["lockTimestamp"].toString()) : <any>undefined;
      this.unlockedByUserId = _data["unlockedByUserId"];
      this.unlockTimestamp = _data["unlockTimestamp"] ? new Date(_data["unlockTimestamp"].toString()) : <any>undefined;
      this.unlockReasonId = _data["unlockReasonId"];
      this.lockExpiryTimestamp = _data["lockExpiryTimestamp"] ? new Date(_data["lockExpiryTimestamp"].toString()) : <any>undefined;
      this.blackoutHoldReleaseReasonClassificationValueId = _data["blackoutHoldReleaseReasonClassificationValueId"];
      this.blackoutHoldReleaseReasonDescription = _data["blackoutHoldReleaseReasonDescription"];
      this.requestorNpiNbr = _data["requestorNpiNbr"];
      this.caseId = _data["caseId"];
      this.sourceCode = _data["sourceCode"];
      this.deAuditRequired = _data["deAuditRequired"];
      this.salesforceId = _data["salesforceId"];
      this.recipientInstitutionTerritoryNumber = _data["recipientInstitutionTerritoryNumber"];
      this.customerId = _data["customerId"];
      this.customerTypeClassificationValueId = _data["customerTypeClassificationValueId"];
      this.salesOrderTypeClassificationValueId = _data["salesOrderTypeClassificationValueId"];
      this.externalNotes = _data["externalNotes"];
      if (Array.isArray(_data["replacementOrders"])) {
        this.replacementOrders = [] as any;
        for (let item of _data["replacementOrders"])
          this.replacementOrders.push(Order.fromJS(item));
      }
      if (Array.isArray(_data["childOrders"])) {
        this.childOrders = [] as any;
        for (let item of _data["childOrders"])
          this.childOrders.push(Order.fromJS(item));
      }
      if (Array.isArray(_data["orderLines"])) {
        this.orderLines = [] as any;
        for (let item of _data["orderLines"])
          this.orderLines.push(OrderLine.fromJS(item));
      }
      if (Array.isArray(_data["orderStatusReasons"])) {
        this.orderStatusReasons = [] as any;
        for (let item of _data["orderStatusReasons"])
          this.orderStatusReasons.push(OrderStatusReason.fromJS(item));
      }
      if (Array.isArray(_data["orderAttachments"])) {
        this.orderAttachments = [] as any;
        for (let item of _data["orderAttachments"])
          this.orderAttachments.push(OrderAttachment.fromJS(item));
      }
      if (Array.isArray(_data["orderComments"])) {
        this.orderComments = [] as any;
        for (let item of _data["orderComments"])
          this.orderComments.push(OrderComment.fromJS(item));
      }
      if (Array.isArray(_data["orderContexts"])) {
        this.orderContexts = [] as any;
        for (let item of _data["orderContexts"])
          this.orderContexts.push(OrderContext.fromJS(item));
      }
      if (Array.isArray(_data["orderStatusHistories"])) {
        this.orderStatusHistories = [] as any;
        for (let item of _data["orderStatusHistories"])
          this.orderStatusHistories.push(OrderStatusHistory.fromJS(item));
      }
      if (Array.isArray(_data["shipments"])) {
        this.shipments = [] as any;
        for (let item of _data["shipments"])
          this.shipments.push(Shipment.fromJS(item));
      }
      if (Array.isArray(_data["orderInvestigations"])) {
        this.orderInvestigations = [] as any;
        for (let item of _data["orderInvestigations"])
          this.orderInvestigations.push(OrderInvestigation.fromJS(item));
      }
      if (Array.isArray(_data["orderValidations"])) {
        this.orderValidations = [] as any;
        for (let item of _data["orderValidations"])
          this.orderValidations.push(OrderValidation.fromJS(item));
      }
      if (Array.isArray(_data["aocs"])) {
        this.aocs = [] as any;
        for (let item of _data["aocs"])
          this.aocs.push(Aoc.fromJS(item));
      }
      if (Array.isArray(_data["svls"])) {
        this.svls = [] as any;
        for (let item of _data["svls"])
          this.svls.push(Svl.fromJS(item));
      }
      if (Array.isArray(_data["orderFormFields"])) {
        this.orderFormFields = [] as any;
        for (let item of _data["orderFormFields"])
          this.orderFormFields.push(OrderFormField.fromJS(item));
      }
      if (Array.isArray(_data["orderPlitInvestigations"])) {
        this.orderPlitInvestigations = [] as any;
        for (let item of _data["orderPlitInvestigations"])
          this.orderPlitInvestigations.push(OrderPlitInvestigation.fromJS(item));
      }
      if (Array.isArray(_data["orderSelectDayVerifications"])) {
        this.orderSelectDayVerifications = [] as any;
        for (let item of _data["orderSelectDayVerifications"])
          this.orderSelectDayVerifications.push(OrderSelectDayVerification.fromJS(item));
      }
      if (Array.isArray(_data["returns"])) {
        this.returns = [] as any;
        for (let item of _data["returns"])
          this.returns.push(OrderReturn.fromJS(item));
      }
      if (Array.isArray(_data["rrofrOrders"])) {
        this.rrofrOrders = [] as any;
        for (let item of _data["rrofrOrders"])
          this.rrofrOrders.push(RrofrOrder.fromJS(item));
      }
      if (Array.isArray(_data["hcpDoNotHonorExclusions"])) {
        this.hcpDoNotHonorExclusions = [] as any;
        for (let item of _data["hcpDoNotHonorExclusions"])
          this.hcpDoNotHonorExclusions.push(HcpDoNotHonorExclusion.fromJS(item));
      }
      if (Array.isArray(_data["orderInvoices"])) {
        this.orderInvoices = [] as any;
        for (let item of _data["orderInvoices"])
          this.orderInvoices.push(OrderInvoice.fromJS(item));
      }
      this.dtpOrder = _data["dtpOrder"] ? TplOrder.fromJS(_data["dtpOrder"]) : <any>undefined;
      this.fgOrder = _data["fgOrder"] ? FgOrder.fromJS(_data["fgOrder"]) : <any>undefined;
      this.orderStatus = _data["orderStatus"] ? ReferencedClassification.fromJS(_data["orderStatus"]) : <any>undefined;
      this.patientOrder = _data["patientOrder"] ? PatientOrder.fromJS(_data["patientOrder"]) : <any>undefined;
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
      this.paymentMethodClassificationValueId = _data["paymentMethodClassificationValueId"];
      this.billingAddressId = _data["billingAddressId"];
      this.billToEmail = _data["billToEmail"];
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Order {
    data = typeof data === 'object' ? data : {};
    let result = new Order();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderedByUserProfileId"] = this.orderedByUserProfileId;
    data["territoryId"] = this.territoryId;
    data["territory"] = this.territory ? this.territory.toJSON() : <any>undefined;
    data["orderTypeClassificationValueId"] = this.orderTypeClassificationValueId;
    data["approvedByUserProfileId"] = this.approvedByUserProfileId;
    data["cancelledByUserProfileId"] = this.cancelledByUserProfileId;
    data["orderNumberText"] = this.orderNumberText;
    data["kid"] = this.kid;
    data["externalOrderNbr"] = this.externalOrderNbr;
    data["externalFormId"] = this.externalFormId;
    data["internalFormId"] = this.internalFormId;
    data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
    data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : <any>undefined;
    data["rushFlag"] = this.rushFlag;
    data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
    data["addressVerifiedFlag"] = this.addressVerifiedFlag;
    data["orderInternalNbr"] = this.orderInternalNbr;
    data["orderFulfillmentId"] = this.orderFulfillmentId;
    data["isPostProcessedFlag"] = this.isPostProcessedFlag;
    data["parentOrderId"] = this.parentOrderId;
    data["parentOrder"] = this.parentOrder ? this.parentOrder.toJSON() : <any>undefined;
    data["replacementOrderId"] = this.replacementOrderId;
    data["replacementOrder"] = this.replacementOrder ? this.replacementOrder.toJSON() : <any>undefined;
    data["originalOrderId"] = this.originalOrderId;
    data["originalOrder"] = this.originalOrder ? this.originalOrder.toJSON() : <any>undefined;
    data["requestorHcpId"] = this.requestorHcpId;
    data["requestorHcp"] = this.requestorHcp ? this.requestorHcp.toJSON() : <any>undefined;
    data["recipientHcpId"] = this.recipientHcpId;
    data["recipientHcp"] = this.recipientHcp ? this.recipientHcp.toJSON() : <any>undefined;
    data["secondaryValidationFlag"] = this.secondaryValidationFlag;
    data["requestorPharmacistId"] = this.requestorPharmacistId;
    data["requestorPharmacist"] = this.requestorPharmacist ? this.requestorPharmacist.toJSON() : <any>undefined;
    data["recipientPharmacistId"] = this.recipientPharmacistId;
    data["recipientPharmacist"] = this.recipientPharmacist ? this.recipientPharmacist.toJSON() : <any>undefined;
    data["moduleId"] = this.moduleId;
    data["programId"] = this.programId;
    data["program"] = this.program ? this.program.toJSON() : <any>undefined;
    data["recipientHcpAddressId"] = this.recipientHcpAddressId;
    data["recipientHcpAddress"] = this.recipientHcpAddress ? this.recipientHcpAddress.toJSON() : <any>undefined;
    data["requestorHcpAddressId"] = this.requestorHcpAddressId;
    data["requestorHcpAddress"] = this.requestorHcpAddress ? this.requestorHcpAddress.toJSON() : <any>undefined;
    data["salesRepId"] = this.salesRepId;
    data["salesRep"] = this.salesRep ? this.salesRep.toJSON() : <any>undefined;
    data["orderSourceId"] = this.orderSourceId;
    data["orderStatusId"] = this.orderStatusId;
    data["orderStatusLastModifiedTime"] = this.orderStatusLastModifiedTime ? this.orderStatusLastModifiedTime.toISOString() : <any>undefined;
    data["offerId"] = this.offerId;
    data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
    data["requestorClientTargetId"] = this.requestorClientTargetId;
    data["requestorCompanyName"] = this.requestorCompanyName;
    data["requestorFirstName"] = this.requestorFirstName;
    data["requestorMiddleName"] = this.requestorMiddleName;
    data["requestorLastName"] = this.requestorLastName;
    data["requestorSuffix"] = this.requestorSuffix;
    data["requestorSuffixClassificationValueId"] = this.requestorSuffixClassificationValueId;
    data["requestorProfessionalDesignationValueCode"] = this.requestorProfessionalDesignationValueCode;
    data["requestorProfessionalDesignationId"] = this.requestorProfessionalDesignationId;
    data["requestorSpecialityCode"] = this.requestorSpecialityCode;
    data["requestorSpecialityClassificationValueId"] = this.requestorSpecialityClassificationValueId;
    data["requestorStateLicenceNbr"] = this.requestorStateLicenceNbr;
    data["requestorStateLicenceStateCodeId"] = this.requestorStateLicenceStateCodeId;
    data["requestorStateLicenceStateCode"] = this.requestorStateLicenceStateCode;
    data["requestorDeaNbr"] = this.requestorDeaNbr;
    data["requestorSan"] = this.requestorSan;
    data["requestorAddressId"] = this.requestorAddressId;
    data["requestorAddress1Text"] = this.requestorAddress1Text;
    data["requestorAddress2Text"] = this.requestorAddress2Text;
    data["requestorAddress3Text"] = this.requestorAddress3Text;
    data["requestorAddress4Text"] = this.requestorAddress4Text;
    data["requestorCityName"] = this.requestorCityName;
    data["requestorZipCode"] = this.requestorZipCode;
    data["requestorStateCodeId"] = this.requestorStateCodeId;
    data["requestorStateCode"] = this.requestorStateCode;
    data["requestorCountryCodeId"] = this.requestorCountryCodeId;
    data["requestorCountryCode"] = this.requestorCountryCode;
    data["requestorEmailAddressText"] = this.requestorEmailAddressText;
    data["requestorPhoneNbr"] = this.requestorPhoneNbr;
    data["requestorPhoneExtensionNbr"] = this.requestorPhoneExtensionNbr;
    data["requestorMobileNbr"] = this.requestorMobileNbr;
    data["requestorFaxNbr"] = this.requestorFaxNbr;
    data["requestorSANExemption"] = this.requestorSANExemption;
    data["recipientAttentionToName"] = this.recipientAttentionToName;
    data["recipientSANExemption"] = this.recipientSANExemption;
    data["recipientCompanyName"] = this.recipientCompanyName;
    data["recipientTitleClassificationValueId"] = this.recipientTitleClassificationValueId;
    data["recipientFirstName"] = this.recipientFirstName;
    data["recipientMiddleName"] = this.recipientMiddleName;
    data["recipientLastName"] = this.recipientLastName;
    data["recipientSuffix"] = this.recipientSuffix;
    data["recipientSuffixClassificationValueId"] = this.recipientSuffixClassificationValueId;
    data["recipientProfessionDesignationValueCode"] = this.recipientProfessionDesignationValueCode;
    data["recipientProfessionDesignationId"] = this.recipientProfessionDesignationId;
    data["recipientSpecialityCode"] = this.recipientSpecialityCode;
    data["recipientSpecialityClassificationValueId"] = this.recipientSpecialityClassificationValueId;
    data["recipientStateLicenceNbr"] = this.recipientStateLicenceNbr;
    data["recipientStateLicenceStateCodeId"] = this.recipientStateLicenceStateCodeId;
    data["recipientStateLicenceStateCode"] = this.recipientStateLicenceStateCode;
    data["recipientDeaNbr"] = this.recipientDeaNbr;
    data["recipientSan"] = this.recipientSan;
    data["recipientAddressId"] = this.recipientAddressId;
    data["recipientAddress1Text"] = this.recipientAddress1Text;
    data["recipientAddress2Text"] = this.recipientAddress2Text;
    data["recipientAddress3Text"] = this.recipientAddress3Text;
    data["recipientAddress4Text"] = this.recipientAddress4Text;
    data["recipientCityName"] = this.recipientCityName;
    data["recipientZipCode"] = this.recipientZipCode;
    data["recipientStateCodeId"] = this.recipientStateCodeId;
    data["recipientStateCode"] = this.recipientStateCode;
    data["recipientCountryCodeId"] = this.recipientCountryCodeId;
    data["recipientCountryCode"] = this.recipientCountryCode;
    data["recipientEmailAddressText"] = this.recipientEmailAddressText;
    data["recipientPhoneNbr"] = this.recipientPhoneNbr;
    data["recipientPhoneExtensionNbr"] = this.recipientPhoneExtensionNbr;
    data["recipientMobileNumber"] = this.recipientMobileNumber;
    data["recipientFaxNbr"] = this.recipientFaxNbr;
    data["salesRepNbr"] = this.salesRepNbr;
    data["salesRepFirstName"] = this.salesRepFirstName;
    data["salesRepMiddleName"] = this.salesRepMiddleName;
    data["salesRepLastName"] = this.salesRepLastName;
    data["salesRepEmailAddressText"] = this.salesRepEmailAddressText;
    data["territoryCode"] = this.territoryCode;
    data["postValidationFlag"] = this.postValidationFlag;
    data["lockedByUserId"] = this.lockedByUserId;
    data["lockTimestamp"] = this.lockTimestamp ? this.lockTimestamp.toISOString() : <any>undefined;
    data["unlockedByUserId"] = this.unlockedByUserId;
    data["unlockTimestamp"] = this.unlockTimestamp ? this.unlockTimestamp.toISOString() : <any>undefined;
    data["unlockReasonId"] = this.unlockReasonId;
    data["lockExpiryTimestamp"] = this.lockExpiryTimestamp ? this.lockExpiryTimestamp.toISOString() : <any>undefined;
    data["blackoutHoldReleaseReasonClassificationValueId"] = this.blackoutHoldReleaseReasonClassificationValueId;
    data["blackoutHoldReleaseReasonDescription"] = this.blackoutHoldReleaseReasonDescription;
    data["requestorNpiNbr"] = this.requestorNpiNbr;
    data["caseId"] = this.caseId;
    data["sourceCode"] = this.sourceCode;
    data["deAuditRequired"] = this.deAuditRequired;
    data["salesforceId"] = this.salesforceId;
    data["recipientInstitutionTerritoryNumber"] = this.recipientInstitutionTerritoryNumber;
    data["customerId"] = this.customerId;
    data["customerTypeClassificationValueId"] = this.customerTypeClassificationValueId;
    data["salesOrderTypeClassificationValueId"] = this.salesOrderTypeClassificationValueId;
    data["externalNotes"] = this.externalNotes;
    if (Array.isArray(this.replacementOrders)) {
      data["replacementOrders"] = [];
      for (let item of this.replacementOrders)
        data["replacementOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.childOrders)) {
      data["childOrders"] = [];
      for (let item of this.childOrders)
        data["childOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.orderLines)) {
      data["orderLines"] = [];
      for (let item of this.orderLines)
        data["orderLines"].push(item.toJSON());
    }
    if (Array.isArray(this.orderStatusReasons)) {
      data["orderStatusReasons"] = [];
      for (let item of this.orderStatusReasons)
        data["orderStatusReasons"].push(item.toJSON());
    }
    if (Array.isArray(this.orderAttachments)) {
      data["orderAttachments"] = [];
      for (let item of this.orderAttachments)
        data["orderAttachments"].push(item.toJSON());
    }
    if (Array.isArray(this.orderComments)) {
      data["orderComments"] = [];
      for (let item of this.orderComments)
        data["orderComments"].push(item.toJSON());
    }
    if (Array.isArray(this.orderContexts)) {
      data["orderContexts"] = [];
      for (let item of this.orderContexts)
        data["orderContexts"].push(item.toJSON());
    }
    if (Array.isArray(this.orderStatusHistories)) {
      data["orderStatusHistories"] = [];
      for (let item of this.orderStatusHistories)
        data["orderStatusHistories"].push(item.toJSON());
    }
    if (Array.isArray(this.shipments)) {
      data["shipments"] = [];
      for (let item of this.shipments)
        data["shipments"].push(item.toJSON());
    }
    if (Array.isArray(this.orderInvestigations)) {
      data["orderInvestigations"] = [];
      for (let item of this.orderInvestigations)
        data["orderInvestigations"].push(item.toJSON());
    }
    if (Array.isArray(this.orderValidations)) {
      data["orderValidations"] = [];
      for (let item of this.orderValidations)
        data["orderValidations"].push(item.toJSON());
    }
    if (Array.isArray(this.aocs)) {
      data["aocs"] = [];
      for (let item of this.aocs)
        data["aocs"].push(item.toJSON());
    }
    if (Array.isArray(this.svls)) {
      data["svls"] = [];
      for (let item of this.svls)
        data["svls"].push(item.toJSON());
    }
    if (Array.isArray(this.orderFormFields)) {
      data["orderFormFields"] = [];
      for (let item of this.orderFormFields)
        data["orderFormFields"].push(item.toJSON());
    }
    if (Array.isArray(this.orderPlitInvestigations)) {
      data["orderPlitInvestigations"] = [];
      for (let item of this.orderPlitInvestigations)
        data["orderPlitInvestigations"].push(item.toJSON());
    }
    if (Array.isArray(this.orderSelectDayVerifications)) {
      data["orderSelectDayVerifications"] = [];
      for (let item of this.orderSelectDayVerifications)
        data["orderSelectDayVerifications"].push(item.toJSON());
    }
    if (Array.isArray(this.returns)) {
      data["returns"] = [];
      for (let item of this.returns)
        data["returns"].push(item.toJSON());
    }
    if (Array.isArray(this.rrofrOrders)) {
      data["rrofrOrders"] = [];
      for (let item of this.rrofrOrders)
        data["rrofrOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.hcpDoNotHonorExclusions)) {
      data["hcpDoNotHonorExclusions"] = [];
      for (let item of this.hcpDoNotHonorExclusions)
        data["hcpDoNotHonorExclusions"].push(item.toJSON());
    }
    if (Array.isArray(this.orderInvoices)) {
      data["orderInvoices"] = [];
      for (let item of this.orderInvoices)
        data["orderInvoices"].push(item.toJSON());
    }
    data["dtpOrder"] = this.dtpOrder ? this.dtpOrder.toJSON() : <any>undefined;
    data["fgOrder"] = this.fgOrder ? this.fgOrder.toJSON() : <any>undefined;
    data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
    data["patientOrder"] = this.patientOrder ? this.patientOrder.toJSON() : <any>undefined;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
    data["paymentMethodClassificationValueId"] = this.paymentMethodClassificationValueId;
    data["billingAddressId"] = this.billingAddressId;
    data["billToEmail"] = this.billToEmail;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Order {
    const json = this.toJSON();
    let result = new Order();
    result.init(json);
    return result;
  }
}

export interface IOrder {
  orderedByUserProfileId: string | undefined;
  territoryId: string | undefined;
  territory: Territory | undefined;
  orderTypeClassificationValueId: string | undefined;
  approvedByUserProfileId: string | undefined;
  cancelledByUserProfileId: string | undefined;
  orderNumberText: string | undefined;
  kid: string | undefined;
  externalOrderNbr: string | undefined;
  externalFormId: string | undefined;
  internalFormId: string | undefined;
  orderDate: Date | undefined;
  needByDate: Date | undefined;
  rushFlag: boolean | undefined;
  approvedDate: Date | undefined;
  addressVerifiedFlag: boolean | undefined;
  orderInternalNbr: number | undefined;
  orderFulfillmentId: string | undefined;
  isPostProcessedFlag: boolean | undefined;
  parentOrderId: string | undefined;
  parentOrder: Order | undefined;
  replacementOrderId: string | undefined;
  replacementOrder: Order | undefined;
  originalOrderId: string | undefined;
  originalOrder: Order | undefined;
  requestorHcpId: string | undefined;
  requestorHcp: Hcp | undefined;
  recipientHcpId: string | undefined;
  recipientHcp: Hcp | undefined;
  secondaryValidationFlag: boolean | undefined;
  requestorPharmacistId: string | undefined;
  requestorPharmacist: Pharmacist | undefined;
  recipientPharmacistId: string | undefined;
  recipientPharmacist: Pharmacist | undefined;
  moduleId: string | undefined;
  programId: string | undefined;
  program: Program | undefined;
  recipientHcpAddressId: string | undefined;
  recipientHcpAddress: HcpAddress | undefined;
  requestorHcpAddressId: string | undefined;
  requestorHcpAddress: HcpAddress | undefined;
  salesRepId: string | undefined;
  salesRep: SalesRep | undefined;
  orderSourceId: string | undefined;
  orderStatusId: string | undefined;
  orderStatusLastModifiedTime: Date | undefined;
  offerId: string | undefined;
  offer: Offer | undefined;
  requestorClientTargetId: string | undefined;
  requestorCompanyName: string | undefined;
  requestorFirstName: string | undefined;
  requestorMiddleName: string | undefined;
  requestorLastName: string | undefined;
  requestorSuffix: string | undefined;
  requestorSuffixClassificationValueId: string | undefined;
  requestorProfessionalDesignationValueCode: string | undefined;
  requestorProfessionalDesignationId: string | undefined;
  requestorSpecialityCode: string | undefined;
  requestorSpecialityClassificationValueId: string | undefined;
  requestorStateLicenceNbr: string | undefined;
  requestorStateLicenceStateCodeId: string | undefined;
  requestorStateLicenceStateCode: string | undefined;
  requestorDeaNbr: string | undefined;
  requestorSan: string | undefined;
  requestorAddressId: string | undefined;
  requestorAddress1Text: string | undefined;
  requestorAddress2Text: string | undefined;
  requestorAddress3Text: string | undefined;
  requestorAddress4Text: string | undefined;
  requestorCityName: string | undefined;
  requestorZipCode: string | undefined;
  requestorStateCodeId: string | undefined;
  requestorStateCode: string | undefined;
  requestorCountryCodeId: string | undefined;
  requestorCountryCode: string | undefined;
  requestorEmailAddressText: string | undefined;
  requestorPhoneNbr: string | undefined;
  requestorPhoneExtensionNbr: string | undefined;
  requestorMobileNbr: string | undefined;
  requestorFaxNbr: string | undefined;
  requestorSANExemption: boolean | undefined;
  recipientAttentionToName: string | undefined;
  recipientSANExemption: boolean | undefined;
  recipientCompanyName: string | undefined;
  recipientTitleClassificationValueId: string | undefined;
  recipientFirstName: string | undefined;
  recipientMiddleName: string | undefined;
  recipientLastName: string | undefined;
  recipientSuffix: string | undefined;
  recipientSuffixClassificationValueId: string | undefined;
  recipientProfessionDesignationValueCode: string | undefined;
  recipientProfessionDesignationId: string | undefined;
  recipientSpecialityCode: string | undefined;
  recipientSpecialityClassificationValueId: string | undefined;
  recipientStateLicenceNbr: string | undefined;
  recipientStateLicenceStateCodeId: string | undefined;
  recipientStateLicenceStateCode: string | undefined;
  recipientDeaNbr: string | undefined;
  recipientSan: string | undefined;
  recipientAddressId: string | undefined;
  recipientAddress1Text: string | undefined;
  recipientAddress2Text: string | undefined;
  recipientAddress3Text: string | undefined;
  recipientAddress4Text: string | undefined;
  recipientCityName: string | undefined;
  recipientZipCode: string | undefined;
  recipientStateCodeId: string | undefined;
  recipientStateCode: string | undefined;
  recipientCountryCodeId: string | undefined;
  recipientCountryCode: string | undefined;
  recipientEmailAddressText: string | undefined;
  recipientPhoneNbr: string | undefined;
  recipientPhoneExtensionNbr: string | undefined;
  recipientMobileNumber: string | undefined;
  recipientFaxNbr: string | undefined;
  salesRepNbr: string | undefined;
  salesRepFirstName: string | undefined;
  salesRepMiddleName: string | undefined;
  salesRepLastName: string | undefined;
  salesRepEmailAddressText: string | undefined;
  territoryCode: string | undefined;
  postValidationFlag: boolean | undefined;
  lockedByUserId: number | undefined;
  lockTimestamp: Date | undefined;
  unlockedByUserId: number | undefined;
  unlockTimestamp: Date | undefined;
  unlockReasonId: string | undefined;
  lockExpiryTimestamp: Date | undefined;
  blackoutHoldReleaseReasonClassificationValueId: string | undefined;
  blackoutHoldReleaseReasonDescription: string | undefined;
  requestorNpiNbr: string | undefined;
  caseId: string | undefined;
  sourceCode: string | undefined;
  deAuditRequired: boolean | undefined;
  salesforceId: string | undefined;
  recipientInstitutionTerritoryNumber: string | undefined;
  customerId: string | undefined;
  customerTypeClassificationValueId: string | undefined;
  salesOrderTypeClassificationValueId: string | undefined;
  externalNotes: string | undefined;
  replacementOrders: Order[] | undefined;
  childOrders: Order[] | undefined;
  orderLines: OrderLine[] | undefined;
  orderStatusReasons: OrderStatusReason[] | undefined;
  orderAttachments: OrderAttachment[] | undefined;
  orderComments: OrderComment[] | undefined;
  orderContexts: OrderContext[] | undefined;
  orderStatusHistories: OrderStatusHistory[] | undefined;
  shipments: Shipment[] | undefined;
  orderInvestigations: OrderInvestigation[] | undefined;
  orderValidations: OrderValidation[] | undefined;
  aocs: Aoc[] | undefined;
  svls: Svl[] | undefined;
  orderFormFields: OrderFormField[] | undefined;
  orderPlitInvestigations: OrderPlitInvestigation[] | undefined;
  orderSelectDayVerifications: OrderSelectDayVerification[] | undefined;
  returns: OrderReturn[] | undefined;
  rrofrOrders: RrofrOrder[] | undefined;
  hcpDoNotHonorExclusions: HcpDoNotHonorExclusion[] | undefined;
  orderInvoices: OrderInvoice[] | undefined;
  dtpOrder: TplOrder | undefined;
  fgOrder: FgOrder | undefined;
  orderStatus: ReferencedClassification | undefined;
  patientOrder: PatientOrder | undefined;
  requestDate: Date | undefined;
  customer: Customer | undefined;
  paymentMethodClassificationValueId: string | undefined;
  billingAddressId: string | undefined;
  billToEmail: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ValidationResult implements IValidationResult {
  readonly isValid: boolean | undefined;
  readonly errors: ValidationFailure[] | undefined;

  constructor(data?: IValidationResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).isValid = _data["isValid"];
      if (Array.isArray(_data["errors"])) {
        (<any>this).errors = [] as any;
        for (let item of _data["errors"])
          (<any>this).errors.push(ValidationFailure.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ValidationResult {
    data = typeof data === 'object' ? data : {};
    let result = new ValidationResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isValid"] = this.isValid;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors)
        data["errors"].push(item.toJSON());
    }
    return data;
  }

  clone(): ValidationResult {
    const json = this.toJSON();
    let result = new ValidationResult();
    result.init(json);
    return result;
  }
}

export interface IValidationResult {
  isValid: boolean | undefined;
  errors: ValidationFailure[] | undefined;
}

export class Territory implements ITerritory {
  rootTerritoryId: string | undefined;
  parentTerritoryId: string | undefined;
  territoryTypeClassificationValueId: string | undefined;
  positionTypeClassificationValueId: string | undefined;
  employeeRoleClassificationValueId: string | undefined;
  territoryCode: string | undefined;
  territoryName: string | undefined;
  territoryDescription: string | undefined;
  startDate: Date | undefined;
  expiryDate: Date | undefined;
  commentsText: string | undefined;
  clientSalesForceCode: string | undefined;
  clientSalesForceName: string | undefined;
  currentStatusDate: Date | undefined;
  rootTerritory: Territory | undefined;
  parentTerritory: Territory | undefined;
  childTerritories: Territory[] | undefined;
  zipCoverages: TerritoryZipCoverage[] | undefined;
  salesRepCoverages: SalesRepTerritoryCoverage[] | undefined;
  offers: Offer[] | undefined;
  orders: Order[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITerritory) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rootTerritoryId = _data["rootTerritoryId"];
      this.parentTerritoryId = _data["parentTerritoryId"];
      this.territoryTypeClassificationValueId = _data["territoryTypeClassificationValueId"];
      this.positionTypeClassificationValueId = _data["positionTypeClassificationValueId"];
      this.employeeRoleClassificationValueId = _data["employeeRoleClassificationValueId"];
      this.territoryCode = _data["territoryCode"];
      this.territoryName = _data["territoryName"];
      this.territoryDescription = _data["territoryDescription"];
      this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
      this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
      this.commentsText = _data["commentsText"];
      this.clientSalesForceCode = _data["clientSalesForceCode"];
      this.clientSalesForceName = _data["clientSalesForceName"];
      this.currentStatusDate = _data["currentStatusDate"] ? new Date(_data["currentStatusDate"].toString()) : <any>undefined;
      this.rootTerritory = _data["rootTerritory"] ? Territory.fromJS(_data["rootTerritory"]) : <any>undefined;
      this.parentTerritory = _data["parentTerritory"] ? Territory.fromJS(_data["parentTerritory"]) : <any>undefined;
      if (Array.isArray(_data["childTerritories"])) {
        this.childTerritories = [] as any;
        for (let item of _data["childTerritories"])
          this.childTerritories.push(Territory.fromJS(item));
      }
      if (Array.isArray(_data["zipCoverages"])) {
        this.zipCoverages = [] as any;
        for (let item of _data["zipCoverages"])
          this.zipCoverages.push(TerritoryZipCoverage.fromJS(item));
      }
      if (Array.isArray(_data["salesRepCoverages"])) {
        this.salesRepCoverages = [] as any;
        for (let item of _data["salesRepCoverages"])
          this.salesRepCoverages.push(SalesRepTerritoryCoverage.fromJS(item));
      }
      if (Array.isArray(_data["offers"])) {
        this.offers = [] as any;
        for (let item of _data["offers"])
          this.offers.push(Offer.fromJS(item));
      }
      if (Array.isArray(_data["orders"])) {
        this.orders = [] as any;
        for (let item of _data["orders"])
          this.orders.push(Order.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Territory {
    data = typeof data === 'object' ? data : {};
    let result = new Territory();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["rootTerritoryId"] = this.rootTerritoryId;
    data["parentTerritoryId"] = this.parentTerritoryId;
    data["territoryTypeClassificationValueId"] = this.territoryTypeClassificationValueId;
    data["positionTypeClassificationValueId"] = this.positionTypeClassificationValueId;
    data["employeeRoleClassificationValueId"] = this.employeeRoleClassificationValueId;
    data["territoryCode"] = this.territoryCode;
    data["territoryName"] = this.territoryName;
    data["territoryDescription"] = this.territoryDescription;
    data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
    data["commentsText"] = this.commentsText;
    data["clientSalesForceCode"] = this.clientSalesForceCode;
    data["clientSalesForceName"] = this.clientSalesForceName;
    data["currentStatusDate"] = this.currentStatusDate ? this.currentStatusDate.toISOString() : <any>undefined;
    data["rootTerritory"] = this.rootTerritory ? this.rootTerritory.toJSON() : <any>undefined;
    data["parentTerritory"] = this.parentTerritory ? this.parentTerritory.toJSON() : <any>undefined;
    if (Array.isArray(this.childTerritories)) {
      data["childTerritories"] = [];
      for (let item of this.childTerritories)
        data["childTerritories"].push(item.toJSON());
    }
    if (Array.isArray(this.zipCoverages)) {
      data["zipCoverages"] = [];
      for (let item of this.zipCoverages)
        data["zipCoverages"].push(item.toJSON());
    }
    if (Array.isArray(this.salesRepCoverages)) {
      data["salesRepCoverages"] = [];
      for (let item of this.salesRepCoverages)
        data["salesRepCoverages"].push(item.toJSON());
    }
    if (Array.isArray(this.offers)) {
      data["offers"] = [];
      for (let item of this.offers)
        data["offers"].push(item.toJSON());
    }
    if (Array.isArray(this.orders)) {
      data["orders"] = [];
      for (let item of this.orders)
        data["orders"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Territory {
    const json = this.toJSON();
    let result = new Territory();
    result.init(json);
    return result;
  }
}

export interface ITerritory {
  rootTerritoryId: string | undefined;
  parentTerritoryId: string | undefined;
  territoryTypeClassificationValueId: string | undefined;
  positionTypeClassificationValueId: string | undefined;
  employeeRoleClassificationValueId: string | undefined;
  territoryCode: string | undefined;
  territoryName: string | undefined;
  territoryDescription: string | undefined;
  startDate: Date | undefined;
  expiryDate: Date | undefined;
  commentsText: string | undefined;
  clientSalesForceCode: string | undefined;
  clientSalesForceName: string | undefined;
  currentStatusDate: Date | undefined;
  rootTerritory: Territory | undefined;
  parentTerritory: Territory | undefined;
  childTerritories: Territory[] | undefined;
  zipCoverages: TerritoryZipCoverage[] | undefined;
  salesRepCoverages: SalesRepTerritoryCoverage[] | undefined;
  offers: Offer[] | undefined;
  orders: Order[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Hcp implements IHcp {
  suffixClassificationValueId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  primarySpecialtyClassificationValueId: string | undefined;
  secondarySpecialtyClassificationValueId: string | undefined;
  userProfileId: string | undefined;
  clientHcpId: string | undefined;
  oldClientHcpId: string | undefined;
  knipperHcpId: string | undefined;
  oldKnipperHcpId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  knipperHcpCreateFlag: boolean | undefined;
  npiNbr: string | undefined;
  variableField1Text: string | undefined;
  variableField2Text: string | undefined;
  variableField3Text: string | undefined;
  kcmActionId: string | undefined;
  institutionTerritoryNumber: string | undefined;
  nbrOfForgivenChances: number | undefined;
  contactMethods: HcpContactMethod[] | undefined;
  addresses: HcpAddress[] | undefined;
  professionalDesignations: HcpProfessionalDesignation[] | undefined;
  licenses: HcpLicense[] | undefined;
  doNotHonorExclusions: HcpDoNotHonorExclusion[] | undefined;
  recipientOffers: Offer[] | undefined;
  requestorOffers: Offer[] | undefined;
  recipientOrders: Order[] | undefined;
  requestorOrders: Order[] | undefined;
  programHcps: ProgramHcp[] | undefined;
  hcpProductGroups: ProgramHcpProductGroup[] | undefined;
  currentStatus: ReferencedClassification | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHcp) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.suffixClassificationValueId = _data["suffixClassificationValueId"];
      this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
      this.primarySpecialtyClassificationValueId = _data["primarySpecialtyClassificationValueId"];
      this.secondarySpecialtyClassificationValueId = _data["secondarySpecialtyClassificationValueId"];
      this.userProfileId = _data["userProfileId"];
      this.clientHcpId = _data["clientHcpId"];
      this.oldClientHcpId = _data["oldClientHcpId"];
      this.knipperHcpId = _data["knipperHcpId"];
      this.oldKnipperHcpId = _data["oldKnipperHcpId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.knipperHcpCreateFlag = _data["knipperHcpCreateFlag"];
      this.npiNbr = _data["npiNbr"];
      this.variableField1Text = _data["variableField1Text"];
      this.variableField2Text = _data["variableField2Text"];
      this.variableField3Text = _data["variableField3Text"];
      this.kcmActionId = _data["kcmActionId"];
      this.institutionTerritoryNumber = _data["institutionTerritoryNumber"];
      this.nbrOfForgivenChances = _data["nbrOfForgivenChances"];
      if (Array.isArray(_data["contactMethods"])) {
        this.contactMethods = [] as any;
        for (let item of _data["contactMethods"])
          this.contactMethods.push(HcpContactMethod.fromJS(item));
      }
      if (Array.isArray(_data["addresses"])) {
        this.addresses = [] as any;
        for (let item of _data["addresses"])
          this.addresses.push(HcpAddress.fromJS(item));
      }
      if (Array.isArray(_data["professionalDesignations"])) {
        this.professionalDesignations = [] as any;
        for (let item of _data["professionalDesignations"])
          this.professionalDesignations.push(HcpProfessionalDesignation.fromJS(item));
      }
      if (Array.isArray(_data["licenses"])) {
        this.licenses = [] as any;
        for (let item of _data["licenses"])
          this.licenses.push(HcpLicense.fromJS(item));
      }
      if (Array.isArray(_data["doNotHonorExclusions"])) {
        this.doNotHonorExclusions = [] as any;
        for (let item of _data["doNotHonorExclusions"])
          this.doNotHonorExclusions.push(HcpDoNotHonorExclusion.fromJS(item));
      }
      if (Array.isArray(_data["recipientOffers"])) {
        this.recipientOffers = [] as any;
        for (let item of _data["recipientOffers"])
          this.recipientOffers.push(Offer.fromJS(item));
      }
      if (Array.isArray(_data["requestorOffers"])) {
        this.requestorOffers = [] as any;
        for (let item of _data["requestorOffers"])
          this.requestorOffers.push(Offer.fromJS(item));
      }
      if (Array.isArray(_data["recipientOrders"])) {
        this.recipientOrders = [] as any;
        for (let item of _data["recipientOrders"])
          this.recipientOrders.push(Order.fromJS(item));
      }
      if (Array.isArray(_data["requestorOrders"])) {
        this.requestorOrders = [] as any;
        for (let item of _data["requestorOrders"])
          this.requestorOrders.push(Order.fromJS(item));
      }
      if (Array.isArray(_data["programHcps"])) {
        this.programHcps = [] as any;
        for (let item of _data["programHcps"])
          this.programHcps.push(ProgramHcp.fromJS(item));
      }
      if (Array.isArray(_data["hcpProductGroups"])) {
        this.hcpProductGroups = [] as any;
        for (let item of _data["hcpProductGroups"])
          this.hcpProductGroups.push(ProgramHcpProductGroup.fromJS(item));
      }
      this.currentStatus = _data["currentStatus"] ? ReferencedClassification.fromJS(_data["currentStatus"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Hcp {
    data = typeof data === 'object' ? data : {};
    let result = new Hcp();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["suffixClassificationValueId"] = this.suffixClassificationValueId;
    data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
    data["primarySpecialtyClassificationValueId"] = this.primarySpecialtyClassificationValueId;
    data["secondarySpecialtyClassificationValueId"] = this.secondarySpecialtyClassificationValueId;
    data["userProfileId"] = this.userProfileId;
    data["clientHcpId"] = this.clientHcpId;
    data["oldClientHcpId"] = this.oldClientHcpId;
    data["knipperHcpId"] = this.knipperHcpId;
    data["oldKnipperHcpId"] = this.oldKnipperHcpId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["knipperHcpCreateFlag"] = this.knipperHcpCreateFlag;
    data["npiNbr"] = this.npiNbr;
    data["variableField1Text"] = this.variableField1Text;
    data["variableField2Text"] = this.variableField2Text;
    data["variableField3Text"] = this.variableField3Text;
    data["kcmActionId"] = this.kcmActionId;
    data["institutionTerritoryNumber"] = this.institutionTerritoryNumber;
    data["nbrOfForgivenChances"] = this.nbrOfForgivenChances;
    if (Array.isArray(this.contactMethods)) {
      data["contactMethods"] = [];
      for (let item of this.contactMethods)
        data["contactMethods"].push(item.toJSON());
    }
    if (Array.isArray(this.addresses)) {
      data["addresses"] = [];
      for (let item of this.addresses)
        data["addresses"].push(item.toJSON());
    }
    if (Array.isArray(this.professionalDesignations)) {
      data["professionalDesignations"] = [];
      for (let item of this.professionalDesignations)
        data["professionalDesignations"].push(item.toJSON());
    }
    if (Array.isArray(this.licenses)) {
      data["licenses"] = [];
      for (let item of this.licenses)
        data["licenses"].push(item.toJSON());
    }
    if (Array.isArray(this.doNotHonorExclusions)) {
      data["doNotHonorExclusions"] = [];
      for (let item of this.doNotHonorExclusions)
        data["doNotHonorExclusions"].push(item.toJSON());
    }
    if (Array.isArray(this.recipientOffers)) {
      data["recipientOffers"] = [];
      for (let item of this.recipientOffers)
        data["recipientOffers"].push(item.toJSON());
    }
    if (Array.isArray(this.requestorOffers)) {
      data["requestorOffers"] = [];
      for (let item of this.requestorOffers)
        data["requestorOffers"].push(item.toJSON());
    }
    if (Array.isArray(this.recipientOrders)) {
      data["recipientOrders"] = [];
      for (let item of this.recipientOrders)
        data["recipientOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.requestorOrders)) {
      data["requestorOrders"] = [];
      for (let item of this.requestorOrders)
        data["requestorOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.programHcps)) {
      data["programHcps"] = [];
      for (let item of this.programHcps)
        data["programHcps"].push(item.toJSON());
    }
    if (Array.isArray(this.hcpProductGroups)) {
      data["hcpProductGroups"] = [];
      for (let item of this.hcpProductGroups)
        data["hcpProductGroups"].push(item.toJSON());
    }
    data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Hcp {
    const json = this.toJSON();
    let result = new Hcp();
    result.init(json);
    return result;
  }
}

export interface IHcp {
  suffixClassificationValueId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  primarySpecialtyClassificationValueId: string | undefined;
  secondarySpecialtyClassificationValueId: string | undefined;
  userProfileId: string | undefined;
  clientHcpId: string | undefined;
  oldClientHcpId: string | undefined;
  knipperHcpId: string | undefined;
  oldKnipperHcpId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  knipperHcpCreateFlag: boolean | undefined;
  npiNbr: string | undefined;
  variableField1Text: string | undefined;
  variableField2Text: string | undefined;
  variableField3Text: string | undefined;
  kcmActionId: string | undefined;
  institutionTerritoryNumber: string | undefined;
  nbrOfForgivenChances: number | undefined;
  contactMethods: HcpContactMethod[] | undefined;
  addresses: HcpAddress[] | undefined;
  professionalDesignations: HcpProfessionalDesignation[] | undefined;
  licenses: HcpLicense[] | undefined;
  doNotHonorExclusions: HcpDoNotHonorExclusion[] | undefined;
  recipientOffers: Offer[] | undefined;
  requestorOffers: Offer[] | undefined;
  recipientOrders: Order[] | undefined;
  requestorOrders: Order[] | undefined;
  programHcps: ProgramHcp[] | undefined;
  hcpProductGroups: ProgramHcpProductGroup[] | undefined;
  currentStatus: ReferencedClassification | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Pharmacist implements IPharmacist {
  knipperId: string | undefined;
  clientPharmacistId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  userProfileId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  knipperCreateFlag: boolean | undefined;
  npiNbr: string | undefined;
  kcmActionId: string | undefined;
  contactMethods: PharmacistContactMethod[] | undefined;
  pharmacistPharmacy: PharmacistPharmacy[] | undefined;
  pharmacistHospital: PharmacistHospital[] | undefined;
  licenses: PharmacistLicense[] | undefined;
  doNotHonorExclusions: PharmacistDoNotHonorExclusion[] | undefined;
  professionalDesignations: PharmacistProfessionalDesignation[] | undefined;
  recipientOrders: Order[] | undefined;
  requestorOrders: Order[] | undefined;
  currentStatus: ReferencedClassification | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacist) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.knipperId = _data["knipperId"];
      this.clientPharmacistId = _data["clientPharmacistId"];
      this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
      this.userProfileId = _data["userProfileId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.npiNbr = _data["npiNbr"];
      this.kcmActionId = _data["kcmActionId"];
      if (Array.isArray(_data["contactMethods"])) {
        this.contactMethods = [] as any;
        for (let item of _data["contactMethods"])
          this.contactMethods.push(PharmacistContactMethod.fromJS(item));
      }
      if (Array.isArray(_data["pharmacistPharmacy"])) {
        this.pharmacistPharmacy = [] as any;
        for (let item of _data["pharmacistPharmacy"])
          this.pharmacistPharmacy.push(PharmacistPharmacy.fromJS(item));
      }
      if (Array.isArray(_data["pharmacistHospital"])) {
        this.pharmacistHospital = [] as any;
        for (let item of _data["pharmacistHospital"])
          this.pharmacistHospital.push(PharmacistHospital.fromJS(item));
      }
      if (Array.isArray(_data["licenses"])) {
        this.licenses = [] as any;
        for (let item of _data["licenses"])
          this.licenses.push(PharmacistLicense.fromJS(item));
      }
      if (Array.isArray(_data["doNotHonorExclusions"])) {
        this.doNotHonorExclusions = [] as any;
        for (let item of _data["doNotHonorExclusions"])
          this.doNotHonorExclusions.push(PharmacistDoNotHonorExclusion.fromJS(item));
      }
      if (Array.isArray(_data["professionalDesignations"])) {
        this.professionalDesignations = [] as any;
        for (let item of _data["professionalDesignations"])
          this.professionalDesignations.push(PharmacistProfessionalDesignation.fromJS(item));
      }
      if (Array.isArray(_data["recipientOrders"])) {
        this.recipientOrders = [] as any;
        for (let item of _data["recipientOrders"])
          this.recipientOrders.push(Order.fromJS(item));
      }
      if (Array.isArray(_data["requestorOrders"])) {
        this.requestorOrders = [] as any;
        for (let item of _data["requestorOrders"])
          this.requestorOrders.push(Order.fromJS(item));
      }
      this.currentStatus = _data["currentStatus"] ? ReferencedClassification.fromJS(_data["currentStatus"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Pharmacist {
    data = typeof data === 'object' ? data : {};
    let result = new Pharmacist();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["knipperId"] = this.knipperId;
    data["clientPharmacistId"] = this.clientPharmacistId;
    data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
    data["userProfileId"] = this.userProfileId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["npiNbr"] = this.npiNbr;
    data["kcmActionId"] = this.kcmActionId;
    if (Array.isArray(this.contactMethods)) {
      data["contactMethods"] = [];
      for (let item of this.contactMethods)
        data["contactMethods"].push(item.toJSON());
    }
    if (Array.isArray(this.pharmacistPharmacy)) {
      data["pharmacistPharmacy"] = [];
      for (let item of this.pharmacistPharmacy)
        data["pharmacistPharmacy"].push(item.toJSON());
    }
    if (Array.isArray(this.pharmacistHospital)) {
      data["pharmacistHospital"] = [];
      for (let item of this.pharmacistHospital)
        data["pharmacistHospital"].push(item.toJSON());
    }
    if (Array.isArray(this.licenses)) {
      data["licenses"] = [];
      for (let item of this.licenses)
        data["licenses"].push(item.toJSON());
    }
    if (Array.isArray(this.doNotHonorExclusions)) {
      data["doNotHonorExclusions"] = [];
      for (let item of this.doNotHonorExclusions)
        data["doNotHonorExclusions"].push(item.toJSON());
    }
    if (Array.isArray(this.professionalDesignations)) {
      data["professionalDesignations"] = [];
      for (let item of this.professionalDesignations)
        data["professionalDesignations"].push(item.toJSON());
    }
    if (Array.isArray(this.recipientOrders)) {
      data["recipientOrders"] = [];
      for (let item of this.recipientOrders)
        data["recipientOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.requestorOrders)) {
      data["requestorOrders"] = [];
      for (let item of this.requestorOrders)
        data["requestorOrders"].push(item.toJSON());
    }
    data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Pharmacist {
    const json = this.toJSON();
    let result = new Pharmacist();
    result.init(json);
    return result;
  }
}

export interface IPharmacist {
  knipperId: string | undefined;
  clientPharmacistId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  userProfileId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  knipperCreateFlag: boolean | undefined;
  npiNbr: string | undefined;
  kcmActionId: string | undefined;
  contactMethods: PharmacistContactMethod[] | undefined;
  pharmacistPharmacy: PharmacistPharmacy[] | undefined;
  pharmacistHospital: PharmacistHospital[] | undefined;
  licenses: PharmacistLicense[] | undefined;
  doNotHonorExclusions: PharmacistDoNotHonorExclusion[] | undefined;
  professionalDesignations: PharmacistProfessionalDesignation[] | undefined;
  recipientOrders: Order[] | undefined;
  requestorOrders: Order[] | undefined;
  currentStatus: ReferencedClassification | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Program implements IProgram {
  tenantIdFk: string | undefined;
  moduleId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  programName: string | undefined;
  programDesc: string | undefined;
  projectDesc: string | undefined;
  repDrivenFlag: boolean | undefined;
  institutionFlag: boolean | undefined;
  projectedStartDate: Date | undefined;
  projectedEndDate: Date | undefined;
  actualStartDate: Date | undefined;
  actualEndDate: Date | undefined;
  shutdownStartDate: Date | undefined;
  reactivationDate: Date | undefined;
  commentsText: string | undefined;
  jobId: string | undefined;
  projectId: string | undefined;
  lastEditedDateTime: Date | undefined;
  lastEditedUserId: number | undefined;
  statusUpdatedDateTime: Date | undefined;
  statusUpdatedUserId: number | undefined;
  patientSamplingJobId: string | undefined;
  patientSamplingFlag: boolean | undefined;
  hcpBrandSpecialtyFlag: boolean | undefined;
  updateOrderByHcpProfileFlag: boolean | undefined;
  targetFileByBrandFlag: boolean | undefined;
  slnValidationSourceClassificationValueId: string | undefined;
  deaValidationSourceClassificationValueId: string | undefined;
  dtpProgramConfigurations: TplProgramConfiguration[] | undefined;
  programContactMethods: ProgramContactMethod[] | undefined;
  programContacts: ProgramContact[] | undefined;
  programAttachments: ProgramAttachment[] | undefined;
  programHcps: ProgramHcp[] | undefined;
  hcpProductGroups: ProgramHcpProductGroup[] | undefined;
  hcpAddressPrograms: HcpAddressProgram[] | undefined;
  programSettings: ProgramSetting[] | undefined;
  certificationDetail: CertificationDetail[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProgram) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantIdFk = _data["tenantIdFk"];
      this.moduleId = _data["moduleId"];
      this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
      this.programName = _data["programName"];
      this.programDesc = _data["programDesc"];
      this.projectDesc = _data["projectDesc"];
      this.repDrivenFlag = _data["repDrivenFlag"];
      this.institutionFlag = _data["institutionFlag"];
      this.projectedStartDate = _data["projectedStartDate"] ? new Date(_data["projectedStartDate"].toString()) : <any>undefined;
      this.projectedEndDate = _data["projectedEndDate"] ? new Date(_data["projectedEndDate"].toString()) : <any>undefined;
      this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : <any>undefined;
      this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : <any>undefined;
      this.shutdownStartDate = _data["shutdownStartDate"] ? new Date(_data["shutdownStartDate"].toString()) : <any>undefined;
      this.reactivationDate = _data["reactivationDate"] ? new Date(_data["reactivationDate"].toString()) : <any>undefined;
      this.commentsText = _data["commentsText"];
      this.jobId = _data["jobId"];
      this.projectId = _data["projectId"];
      this.lastEditedDateTime = _data["lastEditedDateTime"] ? new Date(_data["lastEditedDateTime"].toString()) : <any>undefined;
      this.lastEditedUserId = _data["lastEditedUserId"];
      this.statusUpdatedDateTime = _data["statusUpdatedDateTime"] ? new Date(_data["statusUpdatedDateTime"].toString()) : <any>undefined;
      this.statusUpdatedUserId = _data["statusUpdatedUserId"];
      this.patientSamplingJobId = _data["patientSamplingJobId"];
      this.patientSamplingFlag = _data["patientSamplingFlag"];
      this.hcpBrandSpecialtyFlag = _data["hcpBrandSpecialtyFlag"];
      this.updateOrderByHcpProfileFlag = _data["updateOrderByHcpProfileFlag"];
      this.targetFileByBrandFlag = _data["targetFileByBrandFlag"];
      this.slnValidationSourceClassificationValueId = _data["slnValidationSourceClassificationValueId"];
      this.deaValidationSourceClassificationValueId = _data["deaValidationSourceClassificationValueId"];
      if (Array.isArray(_data["dtpProgramConfigurations"])) {
        this.dtpProgramConfigurations = [] as any;
        for (let item of _data["dtpProgramConfigurations"])
          this.dtpProgramConfigurations.push(TplProgramConfiguration.fromJS(item));
      }
      if (Array.isArray(_data["programContactMethods"])) {
        this.programContactMethods = [] as any;
        for (let item of _data["programContactMethods"])
          this.programContactMethods.push(ProgramContactMethod.fromJS(item));
      }
      if (Array.isArray(_data["programContacts"])) {
        this.programContacts = [] as any;
        for (let item of _data["programContacts"])
          this.programContacts.push(ProgramContact.fromJS(item));
      }
      if (Array.isArray(_data["programAttachments"])) {
        this.programAttachments = [] as any;
        for (let item of _data["programAttachments"])
          this.programAttachments.push(ProgramAttachment.fromJS(item));
      }
      if (Array.isArray(_data["programHcps"])) {
        this.programHcps = [] as any;
        for (let item of _data["programHcps"])
          this.programHcps.push(ProgramHcp.fromJS(item));
      }
      if (Array.isArray(_data["hcpProductGroups"])) {
        this.hcpProductGroups = [] as any;
        for (let item of _data["hcpProductGroups"])
          this.hcpProductGroups.push(ProgramHcpProductGroup.fromJS(item));
      }
      if (Array.isArray(_data["hcpAddressPrograms"])) {
        this.hcpAddressPrograms = [] as any;
        for (let item of _data["hcpAddressPrograms"])
          this.hcpAddressPrograms.push(HcpAddressProgram.fromJS(item));
      }
      if (Array.isArray(_data["programSettings"])) {
        this.programSettings = [] as any;
        for (let item of _data["programSettings"])
          this.programSettings.push(ProgramSetting.fromJS(item));
      }
      if (Array.isArray(_data["certificationDetail"])) {
        this.certificationDetail = [] as any;
        for (let item of _data["certificationDetail"])
          this.certificationDetail.push(CertificationDetail.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Program {
    data = typeof data === 'object' ? data : {};
    let result = new Program();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantIdFk"] = this.tenantIdFk;
    data["moduleId"] = this.moduleId;
    data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
    data["programName"] = this.programName;
    data["programDesc"] = this.programDesc;
    data["projectDesc"] = this.projectDesc;
    data["repDrivenFlag"] = this.repDrivenFlag;
    data["institutionFlag"] = this.institutionFlag;
    data["projectedStartDate"] = this.projectedStartDate ? this.projectedStartDate.toISOString() : <any>undefined;
    data["projectedEndDate"] = this.projectedEndDate ? this.projectedEndDate.toISOString() : <any>undefined;
    data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : <any>undefined;
    data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : <any>undefined;
    data["shutdownStartDate"] = this.shutdownStartDate ? this.shutdownStartDate.toISOString() : <any>undefined;
    data["reactivationDate"] = this.reactivationDate ? this.reactivationDate.toISOString() : <any>undefined;
    data["commentsText"] = this.commentsText;
    data["jobId"] = this.jobId;
    data["projectId"] = this.projectId;
    data["lastEditedDateTime"] = this.lastEditedDateTime ? this.lastEditedDateTime.toISOString() : <any>undefined;
    data["lastEditedUserId"] = this.lastEditedUserId;
    data["statusUpdatedDateTime"] = this.statusUpdatedDateTime ? this.statusUpdatedDateTime.toISOString() : <any>undefined;
    data["statusUpdatedUserId"] = this.statusUpdatedUserId;
    data["patientSamplingJobId"] = this.patientSamplingJobId;
    data["patientSamplingFlag"] = this.patientSamplingFlag;
    data["hcpBrandSpecialtyFlag"] = this.hcpBrandSpecialtyFlag;
    data["updateOrderByHcpProfileFlag"] = this.updateOrderByHcpProfileFlag;
    data["targetFileByBrandFlag"] = this.targetFileByBrandFlag;
    data["slnValidationSourceClassificationValueId"] = this.slnValidationSourceClassificationValueId;
    data["deaValidationSourceClassificationValueId"] = this.deaValidationSourceClassificationValueId;
    if (Array.isArray(this.dtpProgramConfigurations)) {
      data["dtpProgramConfigurations"] = [];
      for (let item of this.dtpProgramConfigurations)
        data["dtpProgramConfigurations"].push(item.toJSON());
    }
    if (Array.isArray(this.programContactMethods)) {
      data["programContactMethods"] = [];
      for (let item of this.programContactMethods)
        data["programContactMethods"].push(item.toJSON());
    }
    if (Array.isArray(this.programContacts)) {
      data["programContacts"] = [];
      for (let item of this.programContacts)
        data["programContacts"].push(item.toJSON());
    }
    if (Array.isArray(this.programAttachments)) {
      data["programAttachments"] = [];
      for (let item of this.programAttachments)
        data["programAttachments"].push(item.toJSON());
    }
    if (Array.isArray(this.programHcps)) {
      data["programHcps"] = [];
      for (let item of this.programHcps)
        data["programHcps"].push(item.toJSON());
    }
    if (Array.isArray(this.hcpProductGroups)) {
      data["hcpProductGroups"] = [];
      for (let item of this.hcpProductGroups)
        data["hcpProductGroups"].push(item.toJSON());
    }
    if (Array.isArray(this.hcpAddressPrograms)) {
      data["hcpAddressPrograms"] = [];
      for (let item of this.hcpAddressPrograms)
        data["hcpAddressPrograms"].push(item.toJSON());
    }
    if (Array.isArray(this.programSettings)) {
      data["programSettings"] = [];
      for (let item of this.programSettings)
        data["programSettings"].push(item.toJSON());
    }
    if (Array.isArray(this.certificationDetail)) {
      data["certificationDetail"] = [];
      for (let item of this.certificationDetail)
        data["certificationDetail"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Program {
    const json = this.toJSON();
    let result = new Program();
    result.init(json);
    return result;
  }
}

export interface IProgram {
  tenantIdFk: string | undefined;
  moduleId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  programName: string | undefined;
  programDesc: string | undefined;
  projectDesc: string | undefined;
  repDrivenFlag: boolean | undefined;
  institutionFlag: boolean | undefined;
  projectedStartDate: Date | undefined;
  projectedEndDate: Date | undefined;
  actualStartDate: Date | undefined;
  actualEndDate: Date | undefined;
  shutdownStartDate: Date | undefined;
  reactivationDate: Date | undefined;
  commentsText: string | undefined;
  jobId: string | undefined;
  projectId: string | undefined;
  lastEditedDateTime: Date | undefined;
  lastEditedUserId: number | undefined;
  statusUpdatedDateTime: Date | undefined;
  statusUpdatedUserId: number | undefined;
  patientSamplingJobId: string | undefined;
  patientSamplingFlag: boolean | undefined;
  hcpBrandSpecialtyFlag: boolean | undefined;
  updateOrderByHcpProfileFlag: boolean | undefined;
  targetFileByBrandFlag: boolean | undefined;
  slnValidationSourceClassificationValueId: string | undefined;
  deaValidationSourceClassificationValueId: string | undefined;
  dtpProgramConfigurations: TplProgramConfiguration[] | undefined;
  programContactMethods: ProgramContactMethod[] | undefined;
  programContacts: ProgramContact[] | undefined;
  programAttachments: ProgramAttachment[] | undefined;
  programHcps: ProgramHcp[] | undefined;
  hcpProductGroups: ProgramHcpProductGroup[] | undefined;
  hcpAddressPrograms: HcpAddressProgram[] | undefined;
  programSettings: ProgramSetting[] | undefined;
  certificationDetail: CertificationDetail[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HcpAddress implements IHcpAddress {
  hcpId: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  institutionAddressFlag: boolean | undefined;
  primaryAddressFlag: boolean | undefined;
  badAddressFlag: boolean | undefined;
  clientAddressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  groupPracticeName: string | undefined;
  sanExpirationDate: Date | undefined;
  sanExemptionFlag: boolean | undefined;
  activeFlag: boolean | undefined;
  deaNbr: string | undefined;
  knipperCreateFlag: boolean | undefined;
  hcp: Hcp | undefined;
  contactMethods: HcpContactMethod[] | undefined;
  recipientOffers: Offer[] | undefined;
  requestorOffers: Offer[] | undefined;
  recipientOrders: Order[] | undefined;
  requestorOrders: Order[] | undefined;
  hcpAddressPrograms: HcpAddressProgram[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHcpAddress) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hcpId = _data["hcpId"];
      this.stateCode = _data["stateCode"];
      this.countryCode = _data["countryCode"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.address3Text = _data["address3Text"];
      this.address4Text = _data["address4Text"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.institutionAddressFlag = _data["institutionAddressFlag"];
      this.primaryAddressFlag = _data["primaryAddressFlag"];
      this.badAddressFlag = _data["badAddressFlag"];
      this.clientAddressId = _data["clientAddressId"];
      this.companyName = _data["companyName"];
      this.san = _data["san"];
      this.groupPracticeName = _data["groupPracticeName"];
      this.sanExpirationDate = _data["sanExpirationDate"] ? new Date(_data["sanExpirationDate"].toString()) : <any>undefined;
      this.sanExemptionFlag = _data["sanExemptionFlag"];
      this.activeFlag = _data["activeFlag"];
      this.deaNbr = _data["deaNbr"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.hcp = _data["hcp"] ? Hcp.fromJS(_data["hcp"]) : <any>undefined;
      if (Array.isArray(_data["contactMethods"])) {
        this.contactMethods = [] as any;
        for (let item of _data["contactMethods"])
          this.contactMethods.push(HcpContactMethod.fromJS(item));
      }
      if (Array.isArray(_data["recipientOffers"])) {
        this.recipientOffers = [] as any;
        for (let item of _data["recipientOffers"])
          this.recipientOffers.push(Offer.fromJS(item));
      }
      if (Array.isArray(_data["requestorOffers"])) {
        this.requestorOffers = [] as any;
        for (let item of _data["requestorOffers"])
          this.requestorOffers.push(Offer.fromJS(item));
      }
      if (Array.isArray(_data["recipientOrders"])) {
        this.recipientOrders = [] as any;
        for (let item of _data["recipientOrders"])
          this.recipientOrders.push(Order.fromJS(item));
      }
      if (Array.isArray(_data["requestorOrders"])) {
        this.requestorOrders = [] as any;
        for (let item of _data["requestorOrders"])
          this.requestorOrders.push(Order.fromJS(item));
      }
      if (Array.isArray(_data["hcpAddressPrograms"])) {
        this.hcpAddressPrograms = [] as any;
        for (let item of _data["hcpAddressPrograms"])
          this.hcpAddressPrograms.push(HcpAddressProgram.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HcpAddress {
    data = typeof data === 'object' ? data : {};
    let result = new HcpAddress();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hcpId"] = this.hcpId;
    data["stateCode"] = this.stateCode;
    data["countryCode"] = this.countryCode;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["address3Text"] = this.address3Text;
    data["address4Text"] = this.address4Text;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["institutionAddressFlag"] = this.institutionAddressFlag;
    data["primaryAddressFlag"] = this.primaryAddressFlag;
    data["badAddressFlag"] = this.badAddressFlag;
    data["clientAddressId"] = this.clientAddressId;
    data["companyName"] = this.companyName;
    data["san"] = this.san;
    data["groupPracticeName"] = this.groupPracticeName;
    data["sanExpirationDate"] = this.sanExpirationDate ? this.sanExpirationDate.toISOString() : <any>undefined;
    data["sanExemptionFlag"] = this.sanExemptionFlag;
    data["activeFlag"] = this.activeFlag;
    data["deaNbr"] = this.deaNbr;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["hcp"] = this.hcp ? this.hcp.toJSON() : <any>undefined;
    if (Array.isArray(this.contactMethods)) {
      data["contactMethods"] = [];
      for (let item of this.contactMethods)
        data["contactMethods"].push(item.toJSON());
    }
    if (Array.isArray(this.recipientOffers)) {
      data["recipientOffers"] = [];
      for (let item of this.recipientOffers)
        data["recipientOffers"].push(item.toJSON());
    }
    if (Array.isArray(this.requestorOffers)) {
      data["requestorOffers"] = [];
      for (let item of this.requestorOffers)
        data["requestorOffers"].push(item.toJSON());
    }
    if (Array.isArray(this.recipientOrders)) {
      data["recipientOrders"] = [];
      for (let item of this.recipientOrders)
        data["recipientOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.requestorOrders)) {
      data["requestorOrders"] = [];
      for (let item of this.requestorOrders)
        data["requestorOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.hcpAddressPrograms)) {
      data["hcpAddressPrograms"] = [];
      for (let item of this.hcpAddressPrograms)
        data["hcpAddressPrograms"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HcpAddress {
    const json = this.toJSON();
    let result = new HcpAddress();
    result.init(json);
    return result;
  }
}

export interface IHcpAddress {
  hcpId: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  institutionAddressFlag: boolean | undefined;
  primaryAddressFlag: boolean | undefined;
  badAddressFlag: boolean | undefined;
  clientAddressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  groupPracticeName: string | undefined;
  sanExpirationDate: Date | undefined;
  sanExemptionFlag: boolean | undefined;
  activeFlag: boolean | undefined;
  deaNbr: string | undefined;
  knipperCreateFlag: boolean | undefined;
  hcp: Hcp | undefined;
  contactMethods: HcpContactMethod[] | undefined;
  recipientOffers: Offer[] | undefined;
  requestorOffers: Offer[] | undefined;
  recipientOrders: Order[] | undefined;
  requestorOrders: Order[] | undefined;
  hcpAddressPrograms: HcpAddressProgram[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class SalesRep implements ISalesRep {
  userProfileId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  emailAddressText: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  clientRepNbrCode: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
  mobilePhoneNbr: string | undefined;
  productGroupCoverages: SalesRepProductGroupCoverage[] | undefined;
  territoryCoverages: SalesRepTerritoryCoverage[] | undefined;
  offers: Offer[] | undefined;
  orders: Order[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ISalesRep) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userProfileId = _data["userProfileId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.emailAddressText = _data["emailAddressText"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.address3Text = _data["address3Text"];
      this.address4Text = _data["address4Text"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.stateCode = _data["stateCode"];
      this.countryCode = _data["countryCode"];
      this.clientRepNbrCode = _data["clientRepNbrCode"];
      this.phoneNbr = _data["phoneNbr"];
      this.phoneExtensionNbr = _data["phoneExtensionNbr"];
      this.faxNbr = _data["faxNbr"];
      this.mobilePhoneNbr = _data["mobilePhoneNbr"];
      if (Array.isArray(_data["productGroupCoverages"])) {
        this.productGroupCoverages = [] as any;
        for (let item of _data["productGroupCoverages"])
          this.productGroupCoverages.push(SalesRepProductGroupCoverage.fromJS(item));
      }
      if (Array.isArray(_data["territoryCoverages"])) {
        this.territoryCoverages = [] as any;
        for (let item of _data["territoryCoverages"])
          this.territoryCoverages.push(SalesRepTerritoryCoverage.fromJS(item));
      }
      if (Array.isArray(_data["offers"])) {
        this.offers = [] as any;
        for (let item of _data["offers"])
          this.offers.push(Offer.fromJS(item));
      }
      if (Array.isArray(_data["orders"])) {
        this.orders = [] as any;
        for (let item of _data["orders"])
          this.orders.push(Order.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): SalesRep {
    data = typeof data === 'object' ? data : {};
    let result = new SalesRep();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userProfileId"] = this.userProfileId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["emailAddressText"] = this.emailAddressText;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["address3Text"] = this.address3Text;
    data["address4Text"] = this.address4Text;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["stateCode"] = this.stateCode;
    data["countryCode"] = this.countryCode;
    data["clientRepNbrCode"] = this.clientRepNbrCode;
    data["phoneNbr"] = this.phoneNbr;
    data["phoneExtensionNbr"] = this.phoneExtensionNbr;
    data["faxNbr"] = this.faxNbr;
    data["mobilePhoneNbr"] = this.mobilePhoneNbr;
    if (Array.isArray(this.productGroupCoverages)) {
      data["productGroupCoverages"] = [];
      for (let item of this.productGroupCoverages)
        data["productGroupCoverages"].push(item.toJSON());
    }
    if (Array.isArray(this.territoryCoverages)) {
      data["territoryCoverages"] = [];
      for (let item of this.territoryCoverages)
        data["territoryCoverages"].push(item.toJSON());
    }
    if (Array.isArray(this.offers)) {
      data["offers"] = [];
      for (let item of this.offers)
        data["offers"].push(item.toJSON());
    }
    if (Array.isArray(this.orders)) {
      data["orders"] = [];
      for (let item of this.orders)
        data["orders"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): SalesRep {
    const json = this.toJSON();
    let result = new SalesRep();
    result.init(json);
    return result;
  }
}

export interface ISalesRep {
  userProfileId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  emailAddressText: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  clientRepNbrCode: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
  mobilePhoneNbr: string | undefined;
  productGroupCoverages: SalesRepProductGroupCoverage[] | undefined;
  territoryCoverages: SalesRepTerritoryCoverage[] | undefined;
  offers: Offer[] | undefined;
  orders: Order[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Offer implements IOffer {
  parentOfferId: string | undefined;
  salesRepId: string | undefined;
  territoryId: string | undefined;
  recipientHCPId: string | undefined;
  recipientHCPAddressId: string | undefined;
  requestorHCPId: string | undefined;
  requestorHCPAddressId: string | undefined;
  offerStatusClassificationValueId: string | undefined;
  offerSourceClassificationValueId: string | undefined;
  offerSrfGenerationSourceClassificationValueId: string | undefined;
  moduleId: string | undefined;
  programId: string | undefined;
  offerId: number | undefined;
  offerNumberText: string | undefined;
  externalOfferId: string | undefined;
  externalFormId: string | undefined;
  internalFormId: string | undefined;
  offerInternalNbr: number | undefined;
  requestDate: Date | undefined;
  expirationDate: Date | undefined;
  salesforceId: string | undefined;
  requestorCompanyName: string | undefined;
  requestorFirstName: string | undefined;
  requestorMiddleName: string | undefined;
  requestorLastName: string | undefined;
  requestorSuffix: string | undefined;
  requestorSuffixClassificationValueId: string | undefined;
  requestorProfessionalDesignationValueCode: string | undefined;
  requestorProfessionalDesignationId: string | undefined;
  requestorSpecialityCode: string | undefined;
  requestorSpecialtyClassificationValueId: string | undefined;
  requestorStateLicenseNbr: string | undefined;
  requestorStateLicenseStateCode: string | undefined;
  requestorStateLicenseStateCodeId: string | undefined;
  requestorDEANbr: string | undefined;
  requestorSAN: string | undefined;
  requestorAddress1Text: string | undefined;
  requestorAddress2Text: string | undefined;
  requestorAddress3Text: string | undefined;
  requestorAddress4Text: string | undefined;
  requestorCityName: string | undefined;
  requestorZipCode: string | undefined;
  requestorStateCode: string | undefined;
  requestorStateCodeId: string | undefined;
  requestorCountryCode: string | undefined;
  requestorCountryCodeId: string | undefined;
  requestorEmailAddressText: string | undefined;
  requestorPhoneNbr: string | undefined;
  requestorPhoneExtensionNbr: string | undefined;
  requestorMobileNbr: string | undefined;
  requestorFaxNbr: string | undefined;
  requestorNpiNbr: string | undefined;
  recipientAttentionToName: string | undefined;
  recipientCompanyName: string | undefined;
  recipientFirstName: string | undefined;
  recipientMiddleName: string | undefined;
  recipientLastName: string | undefined;
  recipientSuffix: string | undefined;
  recipientSuffixClassificationValueId: string | undefined;
  recipientProfessionalDesignationValueCode: string | undefined;
  recipientProfessionalDesignationId: string | undefined;
  recipientSpecialityCode: string | undefined;
  recipientSpecialtyClassificationValueId: string | undefined;
  recipientStateLicenseNbr: string | undefined;
  recipientStateLicenseStateCode: string | undefined;
  recipientStateLicenseStateCodeId: string | undefined;
  recipientDEANbr: string | undefined;
  recipientSAN: string | undefined;
  recipientAddress1Text: string | undefined;
  recipientAddress2Text: string | undefined;
  recipientAddress3Text: string | undefined;
  recipientAddress4Text: string | undefined;
  recipientCityName: string | undefined;
  recipientZipCode: string | undefined;
  recipientStateCode: string | undefined;
  recipientStateCodeId: string | undefined;
  recipientCountryCode: string | undefined;
  recipientCountryCodeId: string | undefined;
  recipientEmailAddressText: string | undefined;
  recipientPhoneNbr: string | undefined;
  recipientPhoneExtensionNbr: string | undefined;
  recipientMobileNumber: string | undefined;
  recipientFaxNbr: string | undefined;
  salesRepFirstName: string | undefined;
  salesRepMiddleName: string | undefined;
  salesRepLastName: string | undefined;
  salesRepEmailAddressText: string | undefined;
  salesRepNbr: string | undefined;
  territoryCode: string | undefined;
  srfResendCount: number | undefined;
  fulfillmentMode: string | undefined;
  recipientInstitutionTerritoryNumber: string | undefined;
  offerStatuses: OfferStatus[] | undefined;
  offerLines: OfferLine[] | undefined;
  childOffers: Offer[] | undefined;
  parentOffer: Offer | undefined;
  salesRep: SalesRep | undefined;
  territory: Territory | undefined;
  recipientHCP: Hcp | undefined;
  requestorHCP: Hcp | undefined;
  recipientHCPAddress: HcpAddress | undefined;
  requestorHCPAddress: HcpAddress | undefined;
  program: Program | undefined;
  offerStatus: ReferencedClassification | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOffer) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parentOfferId = _data["parentOfferId"];
      this.salesRepId = _data["salesRepId"];
      this.territoryId = _data["territoryId"];
      this.recipientHCPId = _data["recipientHCPId"];
      this.recipientHCPAddressId = _data["recipientHCPAddressId"];
      this.requestorHCPId = _data["requestorHCPId"];
      this.requestorHCPAddressId = _data["requestorHCPAddressId"];
      this.offerStatusClassificationValueId = _data["offerStatusClassificationValueId"];
      this.offerSourceClassificationValueId = _data["offerSourceClassificationValueId"];
      this.offerSrfGenerationSourceClassificationValueId = _data["offerSrfGenerationSourceClassificationValueId"];
      this.moduleId = _data["moduleId"];
      this.programId = _data["programId"];
      this.offerId = _data["offerId"];
      this.offerNumberText = _data["offerNumberText"];
      this.externalOfferId = _data["externalOfferId"];
      this.externalFormId = _data["externalFormId"];
      this.internalFormId = _data["internalFormId"];
      this.offerInternalNbr = _data["offerInternalNbr"];
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
      this.salesforceId = _data["salesforceId"];
      this.requestorCompanyName = _data["requestorCompanyName"];
      this.requestorFirstName = _data["requestorFirstName"];
      this.requestorMiddleName = _data["requestorMiddleName"];
      this.requestorLastName = _data["requestorLastName"];
      this.requestorSuffix = _data["requestorSuffix"];
      this.requestorSuffixClassificationValueId = _data["requestorSuffixClassificationValueId"];
      this.requestorProfessionalDesignationValueCode = _data["requestorProfessionalDesignationValueCode"];
      this.requestorProfessionalDesignationId = _data["requestorProfessionalDesignationId"];
      this.requestorSpecialityCode = _data["requestorSpecialityCode"];
      this.requestorSpecialtyClassificationValueId = _data["requestorSpecialtyClassificationValueId"];
      this.requestorStateLicenseNbr = _data["requestorStateLicenseNbr"];
      this.requestorStateLicenseStateCode = _data["requestorStateLicenseStateCode"];
      this.requestorStateLicenseStateCodeId = _data["requestorStateLicenseStateCodeId"];
      this.requestorDEANbr = _data["requestorDEANbr"];
      this.requestorSAN = _data["requestorSAN"];
      this.requestorAddress1Text = _data["requestorAddress1Text"];
      this.requestorAddress2Text = _data["requestorAddress2Text"];
      this.requestorAddress3Text = _data["requestorAddress3Text"];
      this.requestorAddress4Text = _data["requestorAddress4Text"];
      this.requestorCityName = _data["requestorCityName"];
      this.requestorZipCode = _data["requestorZipCode"];
      this.requestorStateCode = _data["requestorStateCode"];
      this.requestorStateCodeId = _data["requestorStateCodeId"];
      this.requestorCountryCode = _data["requestorCountryCode"];
      this.requestorCountryCodeId = _data["requestorCountryCodeId"];
      this.requestorEmailAddressText = _data["requestorEmailAddressText"];
      this.requestorPhoneNbr = _data["requestorPhoneNbr"];
      this.requestorPhoneExtensionNbr = _data["requestorPhoneExtensionNbr"];
      this.requestorMobileNbr = _data["requestorMobileNbr"];
      this.requestorFaxNbr = _data["requestorFaxNbr"];
      this.requestorNpiNbr = _data["requestorNpiNbr"];
      this.recipientAttentionToName = _data["recipientAttentionToName"];
      this.recipientCompanyName = _data["recipientCompanyName"];
      this.recipientFirstName = _data["recipientFirstName"];
      this.recipientMiddleName = _data["recipientMiddleName"];
      this.recipientLastName = _data["recipientLastName"];
      this.recipientSuffix = _data["recipientSuffix"];
      this.recipientSuffixClassificationValueId = _data["recipientSuffixClassificationValueId"];
      this.recipientProfessionalDesignationValueCode = _data["recipientProfessionalDesignationValueCode"];
      this.recipientProfessionalDesignationId = _data["recipientProfessionalDesignationId"];
      this.recipientSpecialityCode = _data["recipientSpecialityCode"];
      this.recipientSpecialtyClassificationValueId = _data["recipientSpecialtyClassificationValueId"];
      this.recipientStateLicenseNbr = _data["recipientStateLicenseNbr"];
      this.recipientStateLicenseStateCode = _data["recipientStateLicenseStateCode"];
      this.recipientStateLicenseStateCodeId = _data["recipientStateLicenseStateCodeId"];
      this.recipientDEANbr = _data["recipientDEANbr"];
      this.recipientSAN = _data["recipientSAN"];
      this.recipientAddress1Text = _data["recipientAddress1Text"];
      this.recipientAddress2Text = _data["recipientAddress2Text"];
      this.recipientAddress3Text = _data["recipientAddress3Text"];
      this.recipientAddress4Text = _data["recipientAddress4Text"];
      this.recipientCityName = _data["recipientCityName"];
      this.recipientZipCode = _data["recipientZipCode"];
      this.recipientStateCode = _data["recipientStateCode"];
      this.recipientStateCodeId = _data["recipientStateCodeId"];
      this.recipientCountryCode = _data["recipientCountryCode"];
      this.recipientCountryCodeId = _data["recipientCountryCodeId"];
      this.recipientEmailAddressText = _data["recipientEmailAddressText"];
      this.recipientPhoneNbr = _data["recipientPhoneNbr"];
      this.recipientPhoneExtensionNbr = _data["recipientPhoneExtensionNbr"];
      this.recipientMobileNumber = _data["recipientMobileNumber"];
      this.recipientFaxNbr = _data["recipientFaxNbr"];
      this.salesRepFirstName = _data["salesRepFirstName"];
      this.salesRepMiddleName = _data["salesRepMiddleName"];
      this.salesRepLastName = _data["salesRepLastName"];
      this.salesRepEmailAddressText = _data["salesRepEmailAddressText"];
      this.salesRepNbr = _data["salesRepNbr"];
      this.territoryCode = _data["territoryCode"];
      this.srfResendCount = _data["srfResendCount"];
      this.fulfillmentMode = _data["fulfillmentMode"];
      this.recipientInstitutionTerritoryNumber = _data["recipientInstitutionTerritoryNumber"];
      if (Array.isArray(_data["offerStatuses"])) {
        this.offerStatuses = [] as any;
        for (let item of _data["offerStatuses"])
          this.offerStatuses.push(OfferStatus.fromJS(item));
      }
      if (Array.isArray(_data["offerLines"])) {
        this.offerLines = [] as any;
        for (let item of _data["offerLines"])
          this.offerLines.push(OfferLine.fromJS(item));
      }
      if (Array.isArray(_data["childOffers"])) {
        this.childOffers = [] as any;
        for (let item of _data["childOffers"])
          this.childOffers.push(Offer.fromJS(item));
      }
      this.parentOffer = _data["parentOffer"] ? Offer.fromJS(_data["parentOffer"]) : <any>undefined;
      this.salesRep = _data["salesRep"] ? SalesRep.fromJS(_data["salesRep"]) : <any>undefined;
      this.territory = _data["territory"] ? Territory.fromJS(_data["territory"]) : <any>undefined;
      this.recipientHCP = _data["recipientHCP"] ? Hcp.fromJS(_data["recipientHCP"]) : <any>undefined;
      this.requestorHCP = _data["requestorHCP"] ? Hcp.fromJS(_data["requestorHCP"]) : <any>undefined;
      this.recipientHCPAddress = _data["recipientHCPAddress"] ? HcpAddress.fromJS(_data["recipientHCPAddress"]) : <any>undefined;
      this.requestorHCPAddress = _data["requestorHCPAddress"] ? HcpAddress.fromJS(_data["requestorHCPAddress"]) : <any>undefined;
      this.program = _data["program"] ? Program.fromJS(_data["program"]) : <any>undefined;
      this.offerStatus = _data["offerStatus"] ? ReferencedClassification.fromJS(_data["offerStatus"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Offer {
    data = typeof data === 'object' ? data : {};
    let result = new Offer();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["parentOfferId"] = this.parentOfferId;
    data["salesRepId"] = this.salesRepId;
    data["territoryId"] = this.territoryId;
    data["recipientHCPId"] = this.recipientHCPId;
    data["recipientHCPAddressId"] = this.recipientHCPAddressId;
    data["requestorHCPId"] = this.requestorHCPId;
    data["requestorHCPAddressId"] = this.requestorHCPAddressId;
    data["offerStatusClassificationValueId"] = this.offerStatusClassificationValueId;
    data["offerSourceClassificationValueId"] = this.offerSourceClassificationValueId;
    data["offerSrfGenerationSourceClassificationValueId"] = this.offerSrfGenerationSourceClassificationValueId;
    data["moduleId"] = this.moduleId;
    data["programId"] = this.programId;
    data["offerId"] = this.offerId;
    data["offerNumberText"] = this.offerNumberText;
    data["externalOfferId"] = this.externalOfferId;
    data["externalFormId"] = this.externalFormId;
    data["internalFormId"] = this.internalFormId;
    data["offerInternalNbr"] = this.offerInternalNbr;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
    data["salesforceId"] = this.salesforceId;
    data["requestorCompanyName"] = this.requestorCompanyName;
    data["requestorFirstName"] = this.requestorFirstName;
    data["requestorMiddleName"] = this.requestorMiddleName;
    data["requestorLastName"] = this.requestorLastName;
    data["requestorSuffix"] = this.requestorSuffix;
    data["requestorSuffixClassificationValueId"] = this.requestorSuffixClassificationValueId;
    data["requestorProfessionalDesignationValueCode"] = this.requestorProfessionalDesignationValueCode;
    data["requestorProfessionalDesignationId"] = this.requestorProfessionalDesignationId;
    data["requestorSpecialityCode"] = this.requestorSpecialityCode;
    data["requestorSpecialtyClassificationValueId"] = this.requestorSpecialtyClassificationValueId;
    data["requestorStateLicenseNbr"] = this.requestorStateLicenseNbr;
    data["requestorStateLicenseStateCode"] = this.requestorStateLicenseStateCode;
    data["requestorStateLicenseStateCodeId"] = this.requestorStateLicenseStateCodeId;
    data["requestorDEANbr"] = this.requestorDEANbr;
    data["requestorSAN"] = this.requestorSAN;
    data["requestorAddress1Text"] = this.requestorAddress1Text;
    data["requestorAddress2Text"] = this.requestorAddress2Text;
    data["requestorAddress3Text"] = this.requestorAddress3Text;
    data["requestorAddress4Text"] = this.requestorAddress4Text;
    data["requestorCityName"] = this.requestorCityName;
    data["requestorZipCode"] = this.requestorZipCode;
    data["requestorStateCode"] = this.requestorStateCode;
    data["requestorStateCodeId"] = this.requestorStateCodeId;
    data["requestorCountryCode"] = this.requestorCountryCode;
    data["requestorCountryCodeId"] = this.requestorCountryCodeId;
    data["requestorEmailAddressText"] = this.requestorEmailAddressText;
    data["requestorPhoneNbr"] = this.requestorPhoneNbr;
    data["requestorPhoneExtensionNbr"] = this.requestorPhoneExtensionNbr;
    data["requestorMobileNbr"] = this.requestorMobileNbr;
    data["requestorFaxNbr"] = this.requestorFaxNbr;
    data["requestorNpiNbr"] = this.requestorNpiNbr;
    data["recipientAttentionToName"] = this.recipientAttentionToName;
    data["recipientCompanyName"] = this.recipientCompanyName;
    data["recipientFirstName"] = this.recipientFirstName;
    data["recipientMiddleName"] = this.recipientMiddleName;
    data["recipientLastName"] = this.recipientLastName;
    data["recipientSuffix"] = this.recipientSuffix;
    data["recipientSuffixClassificationValueId"] = this.recipientSuffixClassificationValueId;
    data["recipientProfessionalDesignationValueCode"] = this.recipientProfessionalDesignationValueCode;
    data["recipientProfessionalDesignationId"] = this.recipientProfessionalDesignationId;
    data["recipientSpecialityCode"] = this.recipientSpecialityCode;
    data["recipientSpecialtyClassificationValueId"] = this.recipientSpecialtyClassificationValueId;
    data["recipientStateLicenseNbr"] = this.recipientStateLicenseNbr;
    data["recipientStateLicenseStateCode"] = this.recipientStateLicenseStateCode;
    data["recipientStateLicenseStateCodeId"] = this.recipientStateLicenseStateCodeId;
    data["recipientDEANbr"] = this.recipientDEANbr;
    data["recipientSAN"] = this.recipientSAN;
    data["recipientAddress1Text"] = this.recipientAddress1Text;
    data["recipientAddress2Text"] = this.recipientAddress2Text;
    data["recipientAddress3Text"] = this.recipientAddress3Text;
    data["recipientAddress4Text"] = this.recipientAddress4Text;
    data["recipientCityName"] = this.recipientCityName;
    data["recipientZipCode"] = this.recipientZipCode;
    data["recipientStateCode"] = this.recipientStateCode;
    data["recipientStateCodeId"] = this.recipientStateCodeId;
    data["recipientCountryCode"] = this.recipientCountryCode;
    data["recipientCountryCodeId"] = this.recipientCountryCodeId;
    data["recipientEmailAddressText"] = this.recipientEmailAddressText;
    data["recipientPhoneNbr"] = this.recipientPhoneNbr;
    data["recipientPhoneExtensionNbr"] = this.recipientPhoneExtensionNbr;
    data["recipientMobileNumber"] = this.recipientMobileNumber;
    data["recipientFaxNbr"] = this.recipientFaxNbr;
    data["salesRepFirstName"] = this.salesRepFirstName;
    data["salesRepMiddleName"] = this.salesRepMiddleName;
    data["salesRepLastName"] = this.salesRepLastName;
    data["salesRepEmailAddressText"] = this.salesRepEmailAddressText;
    data["salesRepNbr"] = this.salesRepNbr;
    data["territoryCode"] = this.territoryCode;
    data["srfResendCount"] = this.srfResendCount;
    data["fulfillmentMode"] = this.fulfillmentMode;
    data["recipientInstitutionTerritoryNumber"] = this.recipientInstitutionTerritoryNumber;
    if (Array.isArray(this.offerStatuses)) {
      data["offerStatuses"] = [];
      for (let item of this.offerStatuses)
        data["offerStatuses"].push(item.toJSON());
    }
    if (Array.isArray(this.offerLines)) {
      data["offerLines"] = [];
      for (let item of this.offerLines)
        data["offerLines"].push(item.toJSON());
    }
    if (Array.isArray(this.childOffers)) {
      data["childOffers"] = [];
      for (let item of this.childOffers)
        data["childOffers"].push(item.toJSON());
    }
    data["parentOffer"] = this.parentOffer ? this.parentOffer.toJSON() : <any>undefined;
    data["salesRep"] = this.salesRep ? this.salesRep.toJSON() : <any>undefined;
    data["territory"] = this.territory ? this.territory.toJSON() : <any>undefined;
    data["recipientHCP"] = this.recipientHCP ? this.recipientHCP.toJSON() : <any>undefined;
    data["requestorHCP"] = this.requestorHCP ? this.requestorHCP.toJSON() : <any>undefined;
    data["recipientHCPAddress"] = this.recipientHCPAddress ? this.recipientHCPAddress.toJSON() : <any>undefined;
    data["requestorHCPAddress"] = this.requestorHCPAddress ? this.requestorHCPAddress.toJSON() : <any>undefined;
    data["program"] = this.program ? this.program.toJSON() : <any>undefined;
    data["offerStatus"] = this.offerStatus ? this.offerStatus.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Offer {
    const json = this.toJSON();
    let result = new Offer();
    result.init(json);
    return result;
  }
}

export interface IOffer {
  parentOfferId: string | undefined;
  salesRepId: string | undefined;
  territoryId: string | undefined;
  recipientHCPId: string | undefined;
  recipientHCPAddressId: string | undefined;
  requestorHCPId: string | undefined;
  requestorHCPAddressId: string | undefined;
  offerStatusClassificationValueId: string | undefined;
  offerSourceClassificationValueId: string | undefined;
  offerSrfGenerationSourceClassificationValueId: string | undefined;
  moduleId: string | undefined;
  programId: string | undefined;
  offerId: number | undefined;
  offerNumberText: string | undefined;
  externalOfferId: string | undefined;
  externalFormId: string | undefined;
  internalFormId: string | undefined;
  offerInternalNbr: number | undefined;
  requestDate: Date | undefined;
  expirationDate: Date | undefined;
  salesforceId: string | undefined;
  requestorCompanyName: string | undefined;
  requestorFirstName: string | undefined;
  requestorMiddleName: string | undefined;
  requestorLastName: string | undefined;
  requestorSuffix: string | undefined;
  requestorSuffixClassificationValueId: string | undefined;
  requestorProfessionalDesignationValueCode: string | undefined;
  requestorProfessionalDesignationId: string | undefined;
  requestorSpecialityCode: string | undefined;
  requestorSpecialtyClassificationValueId: string | undefined;
  requestorStateLicenseNbr: string | undefined;
  requestorStateLicenseStateCode: string | undefined;
  requestorStateLicenseStateCodeId: string | undefined;
  requestorDEANbr: string | undefined;
  requestorSAN: string | undefined;
  requestorAddress1Text: string | undefined;
  requestorAddress2Text: string | undefined;
  requestorAddress3Text: string | undefined;
  requestorAddress4Text: string | undefined;
  requestorCityName: string | undefined;
  requestorZipCode: string | undefined;
  requestorStateCode: string | undefined;
  requestorStateCodeId: string | undefined;
  requestorCountryCode: string | undefined;
  requestorCountryCodeId: string | undefined;
  requestorEmailAddressText: string | undefined;
  requestorPhoneNbr: string | undefined;
  requestorPhoneExtensionNbr: string | undefined;
  requestorMobileNbr: string | undefined;
  requestorFaxNbr: string | undefined;
  requestorNpiNbr: string | undefined;
  recipientAttentionToName: string | undefined;
  recipientCompanyName: string | undefined;
  recipientFirstName: string | undefined;
  recipientMiddleName: string | undefined;
  recipientLastName: string | undefined;
  recipientSuffix: string | undefined;
  recipientSuffixClassificationValueId: string | undefined;
  recipientProfessionalDesignationValueCode: string | undefined;
  recipientProfessionalDesignationId: string | undefined;
  recipientSpecialityCode: string | undefined;
  recipientSpecialtyClassificationValueId: string | undefined;
  recipientStateLicenseNbr: string | undefined;
  recipientStateLicenseStateCode: string | undefined;
  recipientStateLicenseStateCodeId: string | undefined;
  recipientDEANbr: string | undefined;
  recipientSAN: string | undefined;
  recipientAddress1Text: string | undefined;
  recipientAddress2Text: string | undefined;
  recipientAddress3Text: string | undefined;
  recipientAddress4Text: string | undefined;
  recipientCityName: string | undefined;
  recipientZipCode: string | undefined;
  recipientStateCode: string | undefined;
  recipientStateCodeId: string | undefined;
  recipientCountryCode: string | undefined;
  recipientCountryCodeId: string | undefined;
  recipientEmailAddressText: string | undefined;
  recipientPhoneNbr: string | undefined;
  recipientPhoneExtensionNbr: string | undefined;
  recipientMobileNumber: string | undefined;
  recipientFaxNbr: string | undefined;
  salesRepFirstName: string | undefined;
  salesRepMiddleName: string | undefined;
  salesRepLastName: string | undefined;
  salesRepEmailAddressText: string | undefined;
  salesRepNbr: string | undefined;
  territoryCode: string | undefined;
  srfResendCount: number | undefined;
  fulfillmentMode: string | undefined;
  recipientInstitutionTerritoryNumber: string | undefined;
  offerStatuses: OfferStatus[] | undefined;
  offerLines: OfferLine[] | undefined;
  childOffers: Offer[] | undefined;
  parentOffer: Offer | undefined;
  salesRep: SalesRep | undefined;
  territory: Territory | undefined;
  recipientHCP: Hcp | undefined;
  requestorHCP: Hcp | undefined;
  recipientHCPAddress: HcpAddress | undefined;
  requestorHCPAddress: HcpAddress | undefined;
  program: Program | undefined;
  offerStatus: ReferencedClassification | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderLine implements IOrderLine {
  orderId: string | undefined;
  order: Order | undefined;
  productId: string | undefined;
  product: Product | undefined;
  orderLineStatusClassificationValueId: string | undefined;
  orderLineNbr: number | undefined;
  orderQty: number | undefined;
  offeredQty: number | undefined;
  shippedQty: number | undefined;
  deliveredQty: number | undefined;
  canceledQty: number | undefined;
  backorderedQty: number | undefined;
  returnedQty: number | undefined;
  purchasePrice: number | undefined;
  purchaseUOMClassificationValueId: string | undefined;
  isAutoIncluded: boolean | undefined;
  parentOrderLineId: string | undefined;
  parentOrderLine: OrderLine | undefined;
  adjustedOrderQty: number | undefined;
  adjustedDeliveredQty: number | undefined;
  autoIncludeLevelTypeClassificationValueId: string | undefined;
  autoIncludeLevelId: string | undefined;
  isIncluded: boolean | undefined;
  missingOrderQty: boolean | undefined;
  reasonForModificationFromOffer: string | undefined;
  modifiedProductFlag: boolean | undefined;
  modifiedQuantityOrderedFlag: boolean | undefined;
  externalOrderLineId: string | undefined;
  customOrderType: string | undefined;
  customOrderValue: string | undefined;
  therapeuticClass: string | undefined;
  cancellationCommentText: string | undefined;
  childOrderLines: OrderLine[] | undefined;
  rrofrOrderLines: RrofrOrderLine[] | undefined;
  shipmentContainerSerialNumbers: ShipmentContainerSerialNumber[] | undefined;
  shipmentContainerOrderLines: ShipmentContainerOrderLine[] | undefined;
  fgHcpOrderLines: FgOrderHcpOrderLine[] | undefined;
  adjustedPurchasePrice: number | undefined;
  onHoldQty: number | undefined;
  releasedQty: number | undefined;
  yetToReleaseQty: number | undefined;
  quatityRejected: number | undefined;
  somStatusCode: string | undefined;
  isOnHoldQtyAdjusted: boolean | undefined;
  clientProductCode: string | undefined;
  isPartOrderReleased: boolean | undefined;
  isPartOrderCancelled: boolean | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderLine) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.productId = _data["productId"];
      this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
      this.orderLineStatusClassificationValueId = _data["orderLineStatusClassificationValueId"];
      this.orderLineNbr = _data["orderLineNbr"];
      this.orderQty = _data["orderQty"];
      this.offeredQty = _data["offeredQty"];
      this.shippedQty = _data["shippedQty"];
      this.deliveredQty = _data["deliveredQty"];
      this.canceledQty = _data["canceledQty"];
      this.backorderedQty = _data["backorderedQty"];
      this.returnedQty = _data["returnedQty"];
      this.purchasePrice = _data["purchasePrice"];
      this.purchaseUOMClassificationValueId = _data["purchaseUOMClassificationValueId"];
      this.isAutoIncluded = _data["isAutoIncluded"];
      this.parentOrderLineId = _data["parentOrderLineId"];
      this.parentOrderLine = _data["parentOrderLine"] ? OrderLine.fromJS(_data["parentOrderLine"]) : <any>undefined;
      this.adjustedOrderQty = _data["adjustedOrderQty"];
      this.adjustedDeliveredQty = _data["adjustedDeliveredQty"];
      this.autoIncludeLevelTypeClassificationValueId = _data["autoIncludeLevelTypeClassificationValueId"];
      this.autoIncludeLevelId = _data["autoIncludeLevelId"];
      this.isIncluded = _data["isIncluded"];
      this.missingOrderQty = _data["missingOrderQty"];
      this.reasonForModificationFromOffer = _data["reasonForModificationFromOffer"];
      this.modifiedProductFlag = _data["modifiedProductFlag"];
      this.modifiedQuantityOrderedFlag = _data["modifiedQuantityOrderedFlag"];
      this.externalOrderLineId = _data["externalOrderLineId"];
      this.customOrderType = _data["customOrderType"];
      this.customOrderValue = _data["customOrderValue"];
      this.therapeuticClass = _data["therapeuticClass"];
      this.cancellationCommentText = _data["cancellationCommentText"];
      if (Array.isArray(_data["childOrderLines"])) {
        this.childOrderLines = [] as any;
        for (let item of _data["childOrderLines"])
          this.childOrderLines.push(OrderLine.fromJS(item));
      }
      if (Array.isArray(_data["rrofrOrderLines"])) {
        this.rrofrOrderLines = [] as any;
        for (let item of _data["rrofrOrderLines"])
          this.rrofrOrderLines.push(RrofrOrderLine.fromJS(item));
      }
      if (Array.isArray(_data["shipmentContainerSerialNumbers"])) {
        this.shipmentContainerSerialNumbers = [] as any;
        for (let item of _data["shipmentContainerSerialNumbers"])
          this.shipmentContainerSerialNumbers.push(ShipmentContainerSerialNumber.fromJS(item));
      }
      if (Array.isArray(_data["shipmentContainerOrderLines"])) {
        this.shipmentContainerOrderLines = [] as any;
        for (let item of _data["shipmentContainerOrderLines"])
          this.shipmentContainerOrderLines.push(ShipmentContainerOrderLine.fromJS(item));
      }
      if (Array.isArray(_data["fgHcpOrderLines"])) {
        this.fgHcpOrderLines = [] as any;
        for (let item of _data["fgHcpOrderLines"])
          this.fgHcpOrderLines.push(FgOrderHcpOrderLine.fromJS(item));
      }
      this.adjustedPurchasePrice = _data["adjustedPurchasePrice"];
      this.onHoldQty = _data["onHoldQty"];
      this.releasedQty = _data["releasedQty"];
      this.yetToReleaseQty = _data["yetToReleaseQty"];
      this.quatityRejected = _data["quatityRejected"];
      this.somStatusCode = _data["somStatusCode"];
      this.isOnHoldQtyAdjusted = _data["isOnHoldQtyAdjusted"];
      this.clientProductCode = _data["clientProductCode"];
      this.isPartOrderReleased = _data["isPartOrderReleased"];
      this.isPartOrderCancelled = _data["isPartOrderCancelled"];
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderLine {
    data = typeof data === 'object' ? data : {};
    let result = new OrderLine();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["productId"] = this.productId;
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["orderLineStatusClassificationValueId"] = this.orderLineStatusClassificationValueId;
    data["orderLineNbr"] = this.orderLineNbr;
    data["orderQty"] = this.orderQty;
    data["offeredQty"] = this.offeredQty;
    data["shippedQty"] = this.shippedQty;
    data["deliveredQty"] = this.deliveredQty;
    data["canceledQty"] = this.canceledQty;
    data["backorderedQty"] = this.backorderedQty;
    data["returnedQty"] = this.returnedQty;
    data["purchasePrice"] = this.purchasePrice;
    data["purchaseUOMClassificationValueId"] = this.purchaseUOMClassificationValueId;
    data["isAutoIncluded"] = this.isAutoIncluded;
    data["parentOrderLineId"] = this.parentOrderLineId;
    data["parentOrderLine"] = this.parentOrderLine ? this.parentOrderLine.toJSON() : <any>undefined;
    data["adjustedOrderQty"] = this.adjustedOrderQty;
    data["adjustedDeliveredQty"] = this.adjustedDeliveredQty;
    data["autoIncludeLevelTypeClassificationValueId"] = this.autoIncludeLevelTypeClassificationValueId;
    data["autoIncludeLevelId"] = this.autoIncludeLevelId;
    data["isIncluded"] = this.isIncluded;
    data["missingOrderQty"] = this.missingOrderQty;
    data["reasonForModificationFromOffer"] = this.reasonForModificationFromOffer;
    data["modifiedProductFlag"] = this.modifiedProductFlag;
    data["modifiedQuantityOrderedFlag"] = this.modifiedQuantityOrderedFlag;
    data["externalOrderLineId"] = this.externalOrderLineId;
    data["customOrderType"] = this.customOrderType;
    data["customOrderValue"] = this.customOrderValue;
    data["therapeuticClass"] = this.therapeuticClass;
    data["cancellationCommentText"] = this.cancellationCommentText;
    if (Array.isArray(this.childOrderLines)) {
      data["childOrderLines"] = [];
      for (let item of this.childOrderLines)
        data["childOrderLines"].push(item.toJSON());
    }
    if (Array.isArray(this.rrofrOrderLines)) {
      data["rrofrOrderLines"] = [];
      for (let item of this.rrofrOrderLines)
        data["rrofrOrderLines"].push(item.toJSON());
    }
    if (Array.isArray(this.shipmentContainerSerialNumbers)) {
      data["shipmentContainerSerialNumbers"] = [];
      for (let item of this.shipmentContainerSerialNumbers)
        data["shipmentContainerSerialNumbers"].push(item.toJSON());
    }
    if (Array.isArray(this.shipmentContainerOrderLines)) {
      data["shipmentContainerOrderLines"] = [];
      for (let item of this.shipmentContainerOrderLines)
        data["shipmentContainerOrderLines"].push(item.toJSON());
    }
    if (Array.isArray(this.fgHcpOrderLines)) {
      data["fgHcpOrderLines"] = [];
      for (let item of this.fgHcpOrderLines)
        data["fgHcpOrderLines"].push(item.toJSON());
    }
    data["adjustedPurchasePrice"] = this.adjustedPurchasePrice;
    data["onHoldQty"] = this.onHoldQty;
    data["releasedQty"] = this.releasedQty;
    data["yetToReleaseQty"] = this.yetToReleaseQty;
    data["quatityRejected"] = this.quatityRejected;
    data["somStatusCode"] = this.somStatusCode;
    data["isOnHoldQtyAdjusted"] = this.isOnHoldQtyAdjusted;
    data["clientProductCode"] = this.clientProductCode;
    data["isPartOrderReleased"] = this.isPartOrderReleased;
    data["isPartOrderCancelled"] = this.isPartOrderCancelled;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderLine {
    const json = this.toJSON();
    let result = new OrderLine();
    result.init(json);
    return result;
  }
}

export interface IOrderLine {
  orderId: string | undefined;
  order: Order | undefined;
  productId: string | undefined;
  product: Product | undefined;
  orderLineStatusClassificationValueId: string | undefined;
  orderLineNbr: number | undefined;
  orderQty: number | undefined;
  offeredQty: number | undefined;
  shippedQty: number | undefined;
  deliveredQty: number | undefined;
  canceledQty: number | undefined;
  backorderedQty: number | undefined;
  returnedQty: number | undefined;
  purchasePrice: number | undefined;
  purchaseUOMClassificationValueId: string | undefined;
  isAutoIncluded: boolean | undefined;
  parentOrderLineId: string | undefined;
  parentOrderLine: OrderLine | undefined;
  adjustedOrderQty: number | undefined;
  adjustedDeliveredQty: number | undefined;
  autoIncludeLevelTypeClassificationValueId: string | undefined;
  autoIncludeLevelId: string | undefined;
  isIncluded: boolean | undefined;
  missingOrderQty: boolean | undefined;
  reasonForModificationFromOffer: string | undefined;
  modifiedProductFlag: boolean | undefined;
  modifiedQuantityOrderedFlag: boolean | undefined;
  externalOrderLineId: string | undefined;
  customOrderType: string | undefined;
  customOrderValue: string | undefined;
  therapeuticClass: string | undefined;
  cancellationCommentText: string | undefined;
  childOrderLines: OrderLine[] | undefined;
  rrofrOrderLines: RrofrOrderLine[] | undefined;
  shipmentContainerSerialNumbers: ShipmentContainerSerialNumber[] | undefined;
  shipmentContainerOrderLines: ShipmentContainerOrderLine[] | undefined;
  fgHcpOrderLines: FgOrderHcpOrderLine[] | undefined;
  adjustedPurchasePrice: number | undefined;
  onHoldQty: number | undefined;
  releasedQty: number | undefined;
  yetToReleaseQty: number | undefined;
  quatityRejected: number | undefined;
  somStatusCode: string | undefined;
  isOnHoldQtyAdjusted: boolean | undefined;
  clientProductCode: string | undefined;
  isPartOrderReleased: boolean | undefined;
  isPartOrderCancelled: boolean | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderStatusReason implements IOrderStatusReason {
  orderId: string | undefined;
  order: Order | undefined;
  currentStatusFlag: boolean | undefined;
  orderStatusReasonTypeId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderStatusReason) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.currentStatusFlag = _data["currentStatusFlag"];
      this.orderStatusReasonTypeId = _data["orderStatusReasonTypeId"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderStatusReason {
    data = typeof data === 'object' ? data : {};
    let result = new OrderStatusReason();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["currentStatusFlag"] = this.currentStatusFlag;
    data["orderStatusReasonTypeId"] = this.orderStatusReasonTypeId;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderStatusReason {
    const json = this.toJSON();
    let result = new OrderStatusReason();
    result.init(json);
    return result;
  }
}

export interface IOrderStatusReason {
  orderId: string | undefined;
  order: Order | undefined;
  currentStatusFlag: boolean | undefined;
  orderStatusReasonTypeId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderAttachment implements IOrderAttachment {
  orderId: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  attachmentName: string | undefined;
  attachmentLocation: string | undefined;
  commentsText: string | undefined;
  attachmentDesc: string | undefined;
  referenceEntityId: string | undefined;
  order: Order | undefined;
  orderPlitInvestigationId: string | undefined;
  orderPlitInvestigation: OrderPlitInvestigation | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderAttachment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.attachmentTypeClassificationValueId = _data["attachmentTypeClassificationValueId"];
      this.attachmentName = _data["attachmentName"];
      this.attachmentLocation = _data["attachmentLocation"];
      this.commentsText = _data["commentsText"];
      this.attachmentDesc = _data["attachmentDesc"];
      this.referenceEntityId = _data["referenceEntityId"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.orderPlitInvestigationId = _data["orderPlitInvestigationId"];
      this.orderPlitInvestigation = _data["orderPlitInvestigation"] ? OrderPlitInvestigation.fromJS(_data["orderPlitInvestigation"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderAttachment {
    data = typeof data === 'object' ? data : {};
    let result = new OrderAttachment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["attachmentTypeClassificationValueId"] = this.attachmentTypeClassificationValueId;
    data["attachmentName"] = this.attachmentName;
    data["attachmentLocation"] = this.attachmentLocation;
    data["commentsText"] = this.commentsText;
    data["attachmentDesc"] = this.attachmentDesc;
    data["referenceEntityId"] = this.referenceEntityId;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["orderPlitInvestigationId"] = this.orderPlitInvestigationId;
    data["orderPlitInvestigation"] = this.orderPlitInvestigation ? this.orderPlitInvestigation.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderAttachment {
    const json = this.toJSON();
    let result = new OrderAttachment();
    result.init(json);
    return result;
  }
}

export interface IOrderAttachment {
  orderId: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  attachmentName: string | undefined;
  attachmentLocation: string | undefined;
  commentsText: string | undefined;
  attachmentDesc: string | undefined;
  referenceEntityId: string | undefined;
  order: Order | undefined;
  orderPlitInvestigationId: string | undefined;
  orderPlitInvestigation: OrderPlitInvestigation | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderComment implements IOrderComment {
  orderId: string | undefined;
  commentTypeClassificationValueId: string | undefined;
  commentsText: string | undefined;
  commentDate: Date | undefined;
  commentedByName: string | undefined;
  orderStatusId: string | undefined;
  referenceEntityId: string | undefined;
  srfAdverseEventFlag: boolean | undefined;
  order: Order | undefined;
  orderPlitInvestigationId: string | undefined;
  orderPlitInvestigation: OrderPlitInvestigation | undefined;
  orderSelectDayVerificationId: string | undefined;
  orderSelectDayVerification: OrderSelectDayVerification | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderComment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.commentTypeClassificationValueId = _data["commentTypeClassificationValueId"];
      this.commentsText = _data["commentsText"];
      this.commentDate = _data["commentDate"] ? new Date(_data["commentDate"].toString()) : <any>undefined;
      this.commentedByName = _data["commentedByName"];
      this.orderStatusId = _data["orderStatusId"];
      this.referenceEntityId = _data["referenceEntityId"];
      this.srfAdverseEventFlag = _data["srfAdverseEventFlag"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.orderPlitInvestigationId = _data["orderPlitInvestigationId"];
      this.orderPlitInvestigation = _data["orderPlitInvestigation"] ? OrderPlitInvestigation.fromJS(_data["orderPlitInvestigation"]) : <any>undefined;
      this.orderSelectDayVerificationId = _data["orderSelectDayVerificationId"];
      this.orderSelectDayVerification = _data["orderSelectDayVerification"] ? OrderSelectDayVerification.fromJS(_data["orderSelectDayVerification"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderComment {
    data = typeof data === 'object' ? data : {};
    let result = new OrderComment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["commentTypeClassificationValueId"] = this.commentTypeClassificationValueId;
    data["commentsText"] = this.commentsText;
    data["commentDate"] = this.commentDate ? this.commentDate.toISOString() : <any>undefined;
    data["commentedByName"] = this.commentedByName;
    data["orderStatusId"] = this.orderStatusId;
    data["referenceEntityId"] = this.referenceEntityId;
    data["srfAdverseEventFlag"] = this.srfAdverseEventFlag;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["orderPlitInvestigationId"] = this.orderPlitInvestigationId;
    data["orderPlitInvestigation"] = this.orderPlitInvestigation ? this.orderPlitInvestigation.toJSON() : <any>undefined;
    data["orderSelectDayVerificationId"] = this.orderSelectDayVerificationId;
    data["orderSelectDayVerification"] = this.orderSelectDayVerification ? this.orderSelectDayVerification.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderComment {
    const json = this.toJSON();
    let result = new OrderComment();
    result.init(json);
    return result;
  }
}

export interface IOrderComment {
  orderId: string | undefined;
  commentTypeClassificationValueId: string | undefined;
  commentsText: string | undefined;
  commentDate: Date | undefined;
  commentedByName: string | undefined;
  orderStatusId: string | undefined;
  referenceEntityId: string | undefined;
  srfAdverseEventFlag: boolean | undefined;
  order: Order | undefined;
  orderPlitInvestigationId: string | undefined;
  orderPlitInvestigation: OrderPlitInvestigation | undefined;
  orderSelectDayVerificationId: string | undefined;
  orderSelectDayVerification: OrderSelectDayVerification | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderContext implements IOrderContext {
  orderId: string | undefined;
  orderInvestigationDetailId: string | undefined;
  referencedEntityId: string | undefined;
  tagTypeClassificationValueId: string | undefined;
  order: Order | undefined;
  orderInvestigationDetail: OrderInvestigationDetail | undefined;
  referencedEntity: ReferencedEntity | undefined;
  tagTypeClassification: ReferencedClassification | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderContext) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderInvestigationDetailId = _data["orderInvestigationDetailId"];
      this.referencedEntityId = _data["referencedEntityId"];
      this.tagTypeClassificationValueId = _data["tagTypeClassificationValueId"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.orderInvestigationDetail = _data["orderInvestigationDetail"] ? OrderInvestigationDetail.fromJS(_data["orderInvestigationDetail"]) : <any>undefined;
      this.referencedEntity = _data["referencedEntity"] ? ReferencedEntity.fromJS(_data["referencedEntity"]) : <any>undefined;
      this.tagTypeClassification = _data["tagTypeClassification"] ? ReferencedClassification.fromJS(_data["tagTypeClassification"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderContext {
    data = typeof data === 'object' ? data : {};
    let result = new OrderContext();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderInvestigationDetailId"] = this.orderInvestigationDetailId;
    data["referencedEntityId"] = this.referencedEntityId;
    data["tagTypeClassificationValueId"] = this.tagTypeClassificationValueId;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["orderInvestigationDetail"] = this.orderInvestigationDetail ? this.orderInvestigationDetail.toJSON() : <any>undefined;
    data["referencedEntity"] = this.referencedEntity ? this.referencedEntity.toJSON() : <any>undefined;
    data["tagTypeClassification"] = this.tagTypeClassification ? this.tagTypeClassification.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderContext {
    const json = this.toJSON();
    let result = new OrderContext();
    result.init(json);
    return result;
  }
}

export interface IOrderContext {
  orderId: string | undefined;
  orderInvestigationDetailId: string | undefined;
  referencedEntityId: string | undefined;
  tagTypeClassificationValueId: string | undefined;
  order: Order | undefined;
  orderInvestigationDetail: OrderInvestigationDetail | undefined;
  referencedEntity: ReferencedEntity | undefined;
  tagTypeClassification: ReferencedClassification | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderStatusHistory implements IOrderStatusHistory {
  orderId: string | undefined;
  orderStatusClassificationValueId: string | undefined;
  currentStatusFlag: boolean | undefined;
  order: Order | undefined;
  orderStatusHistoryReasons: OrderStatusHistoryReason[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderStatusHistory) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderStatusClassificationValueId = _data["orderStatusClassificationValueId"];
      this.currentStatusFlag = _data["currentStatusFlag"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      if (Array.isArray(_data["orderStatusHistoryReasons"])) {
        this.orderStatusHistoryReasons = [] as any;
        for (let item of _data["orderStatusHistoryReasons"])
          this.orderStatusHistoryReasons.push(OrderStatusHistoryReason.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderStatusHistory {
    data = typeof data === 'object' ? data : {};
    let result = new OrderStatusHistory();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderStatusClassificationValueId"] = this.orderStatusClassificationValueId;
    data["currentStatusFlag"] = this.currentStatusFlag;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    if (Array.isArray(this.orderStatusHistoryReasons)) {
      data["orderStatusHistoryReasons"] = [];
      for (let item of this.orderStatusHistoryReasons)
        data["orderStatusHistoryReasons"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderStatusHistory {
    const json = this.toJSON();
    let result = new OrderStatusHistory();
    result.init(json);
    return result;
  }
}

export interface IOrderStatusHistory {
  orderId: string | undefined;
  orderStatusClassificationValueId: string | undefined;
  currentStatusFlag: boolean | undefined;
  order: Order | undefined;
  orderStatusHistoryReasons: OrderStatusHistoryReason[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Shipment implements IShipment {
  orderId: string | undefined;
  shippedDate: Date | undefined;
  carrierName: string | undefined;
  shipmentMethodName: string | undefined;
  deliveryDate: Date | undefined;
  shipmentId: string | undefined;
  carrierId: string | undefined;
  carrierServiceTypeId: string | undefined;
  deliveryStatusClassificationValueId: string | undefined;
  trackingNumberText: string | undefined;
  actualDeliveryDate: Date | undefined;
  deliveryStatusClassificationValue: ReferencedClassification | undefined;
  order: Order | undefined;
  aocs: Aoc[] | undefined;
  svls: Svl[] | undefined;
  shipmentContainers: ShipmentContainer[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IShipment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.shippedDate = _data["shippedDate"] ? new Date(_data["shippedDate"].toString()) : <any>undefined;
      this.carrierName = _data["carrierName"];
      this.shipmentMethodName = _data["shipmentMethodName"];
      this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
      this.shipmentId = _data["shipmentId"];
      this.carrierId = _data["carrierId"];
      this.carrierServiceTypeId = _data["carrierServiceTypeId"];
      this.deliveryStatusClassificationValueId = _data["deliveryStatusClassificationValueId"];
      this.trackingNumberText = _data["trackingNumberText"];
      this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
      this.deliveryStatusClassificationValue = _data["deliveryStatusClassificationValue"] ? ReferencedClassification.fromJS(_data["deliveryStatusClassificationValue"]) : <any>undefined;
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      if (Array.isArray(_data["aocs"])) {
        this.aocs = [] as any;
        for (let item of _data["aocs"])
          this.aocs.push(Aoc.fromJS(item));
      }
      if (Array.isArray(_data["svls"])) {
        this.svls = [] as any;
        for (let item of _data["svls"])
          this.svls.push(Svl.fromJS(item));
      }
      if (Array.isArray(_data["shipmentContainers"])) {
        this.shipmentContainers = [] as any;
        for (let item of _data["shipmentContainers"])
          this.shipmentContainers.push(ShipmentContainer.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Shipment {
    data = typeof data === 'object' ? data : {};
    let result = new Shipment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["shippedDate"] = this.shippedDate ? this.shippedDate.toISOString() : <any>undefined;
    data["carrierName"] = this.carrierName;
    data["shipmentMethodName"] = this.shipmentMethodName;
    data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
    data["shipmentId"] = this.shipmentId;
    data["carrierId"] = this.carrierId;
    data["carrierServiceTypeId"] = this.carrierServiceTypeId;
    data["deliveryStatusClassificationValueId"] = this.deliveryStatusClassificationValueId;
    data["trackingNumberText"] = this.trackingNumberText;
    data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
    data["deliveryStatusClassificationValue"] = this.deliveryStatusClassificationValue ? this.deliveryStatusClassificationValue.toJSON() : <any>undefined;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    if (Array.isArray(this.aocs)) {
      data["aocs"] = [];
      for (let item of this.aocs)
        data["aocs"].push(item.toJSON());
    }
    if (Array.isArray(this.svls)) {
      data["svls"] = [];
      for (let item of this.svls)
        data["svls"].push(item.toJSON());
    }
    if (Array.isArray(this.shipmentContainers)) {
      data["shipmentContainers"] = [];
      for (let item of this.shipmentContainers)
        data["shipmentContainers"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Shipment {
    const json = this.toJSON();
    let result = new Shipment();
    result.init(json);
    return result;
  }
}

export interface IShipment {
  orderId: string | undefined;
  shippedDate: Date | undefined;
  carrierName: string | undefined;
  shipmentMethodName: string | undefined;
  deliveryDate: Date | undefined;
  shipmentId: string | undefined;
  carrierId: string | undefined;
  carrierServiceTypeId: string | undefined;
  deliveryStatusClassificationValueId: string | undefined;
  trackingNumberText: string | undefined;
  actualDeliveryDate: Date | undefined;
  deliveryStatusClassificationValue: ReferencedClassification | undefined;
  order: Order | undefined;
  aocs: Aoc[] | undefined;
  svls: Svl[] | undefined;
  shipmentContainers: ShipmentContainer[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderInvestigation implements IOrderInvestigation {
  orderId: string | undefined;
  orderValidationId: string | undefined;
  mitigatedByUserId: number | undefined;
  mitigationSubmissionTimestamp: Date | undefined;
  mitigationCompleteFlag: boolean | undefined;
  mitigationTierTypeClassificationValueId: string | undefined;
  order: Order | undefined;
  orderValidation: OrderValidation | undefined;
  orderInvestigationDetails: OrderInvestigationDetail[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderInvestigation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderValidationId = _data["orderValidationId"];
      this.mitigatedByUserId = _data["mitigatedByUserId"];
      this.mitigationSubmissionTimestamp = _data["mitigationSubmissionTimestamp"] ? new Date(_data["mitigationSubmissionTimestamp"].toString()) : <any>undefined;
      this.mitigationCompleteFlag = _data["mitigationCompleteFlag"];
      this.mitigationTierTypeClassificationValueId = _data["mitigationTierTypeClassificationValueId"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.orderValidation = _data["orderValidation"] ? OrderValidation.fromJS(_data["orderValidation"]) : <any>undefined;
      if (Array.isArray(_data["orderInvestigationDetails"])) {
        this.orderInvestigationDetails = [] as any;
        for (let item of _data["orderInvestigationDetails"])
          this.orderInvestigationDetails.push(OrderInvestigationDetail.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderInvestigation {
    data = typeof data === 'object' ? data : {};
    let result = new OrderInvestigation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderValidationId"] = this.orderValidationId;
    data["mitigatedByUserId"] = this.mitigatedByUserId;
    data["mitigationSubmissionTimestamp"] = this.mitigationSubmissionTimestamp ? this.mitigationSubmissionTimestamp.toISOString() : <any>undefined;
    data["mitigationCompleteFlag"] = this.mitigationCompleteFlag;
    data["mitigationTierTypeClassificationValueId"] = this.mitigationTierTypeClassificationValueId;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["orderValidation"] = this.orderValidation ? this.orderValidation.toJSON() : <any>undefined;
    if (Array.isArray(this.orderInvestigationDetails)) {
      data["orderInvestigationDetails"] = [];
      for (let item of this.orderInvestigationDetails)
        data["orderInvestigationDetails"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderInvestigation {
    const json = this.toJSON();
    let result = new OrderInvestigation();
    result.init(json);
    return result;
  }
}

export interface IOrderInvestigation {
  orderId: string | undefined;
  orderValidationId: string | undefined;
  mitigatedByUserId: number | undefined;
  mitigationSubmissionTimestamp: Date | undefined;
  mitigationCompleteFlag: boolean | undefined;
  mitigationTierTypeClassificationValueId: string | undefined;
  order: Order | undefined;
  orderValidation: OrderValidation | undefined;
  orderInvestigationDetails: OrderInvestigationDetail[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderValidation implements IOrderValidation {
  orderId: string | undefined;
  ruleConfigurationId: string | undefined;
  orderValidationDate: Date | undefined;
  orderValidationOutputJson: string | undefined;
  passedFlag: boolean | undefined;
  orderValidationFailureOutcomeClassificationValueId: string | undefined;
  mitigatedFlag: boolean | undefined;
  latestFlag: boolean | undefined;
  order: Order | undefined;
  orderValidationRuleOutcomes: OrderValidationRuleOutcome[] | undefined;
  orderInvestigations: OrderInvestigation[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderValidation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.ruleConfigurationId = _data["ruleConfigurationId"];
      this.orderValidationDate = _data["orderValidationDate"] ? new Date(_data["orderValidationDate"].toString()) : <any>undefined;
      this.orderValidationOutputJson = _data["orderValidationOutputJson"];
      this.passedFlag = _data["passedFlag"];
      this.orderValidationFailureOutcomeClassificationValueId = _data["orderValidationFailureOutcomeClassificationValueId"];
      this.mitigatedFlag = _data["mitigatedFlag"];
      this.latestFlag = _data["latestFlag"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      if (Array.isArray(_data["orderValidationRuleOutcomes"])) {
        this.orderValidationRuleOutcomes = [] as any;
        for (let item of _data["orderValidationRuleOutcomes"])
          this.orderValidationRuleOutcomes.push(OrderValidationRuleOutcome.fromJS(item));
      }
      if (Array.isArray(_data["orderInvestigations"])) {
        this.orderInvestigations = [] as any;
        for (let item of _data["orderInvestigations"])
          this.orderInvestigations.push(OrderInvestigation.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderValidation {
    data = typeof data === 'object' ? data : {};
    let result = new OrderValidation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["ruleConfigurationId"] = this.ruleConfigurationId;
    data["orderValidationDate"] = this.orderValidationDate ? this.orderValidationDate.toISOString() : <any>undefined;
    data["orderValidationOutputJson"] = this.orderValidationOutputJson;
    data["passedFlag"] = this.passedFlag;
    data["orderValidationFailureOutcomeClassificationValueId"] = this.orderValidationFailureOutcomeClassificationValueId;
    data["mitigatedFlag"] = this.mitigatedFlag;
    data["latestFlag"] = this.latestFlag;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    if (Array.isArray(this.orderValidationRuleOutcomes)) {
      data["orderValidationRuleOutcomes"] = [];
      for (let item of this.orderValidationRuleOutcomes)
        data["orderValidationRuleOutcomes"].push(item.toJSON());
    }
    if (Array.isArray(this.orderInvestigations)) {
      data["orderInvestigations"] = [];
      for (let item of this.orderInvestigations)
        data["orderInvestigations"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderValidation {
    const json = this.toJSON();
    let result = new OrderValidation();
    result.init(json);
    return result;
  }
}

export interface IOrderValidation {
  orderId: string | undefined;
  ruleConfigurationId: string | undefined;
  orderValidationDate: Date | undefined;
  orderValidationOutputJson: string | undefined;
  passedFlag: boolean | undefined;
  orderValidationFailureOutcomeClassificationValueId: string | undefined;
  mitigatedFlag: boolean | undefined;
  latestFlag: boolean | undefined;
  order: Order | undefined;
  orderValidationRuleOutcomes: OrderValidationRuleOutcome[] | undefined;
  orderInvestigations: OrderInvestigation[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Aoc implements IAoc {
  orderId: string | undefined;
  orderIdText: string | undefined;
  aocTypeClassificationValueId: string | undefined;
  shipmentId: string | undefined;
  shipmentIdText: string | undefined;
  signedByFirstName: string | undefined;
  signedByLastName: string | undefined;
  signedByName: string | undefined;
  signedByTypeClassificationValueId: string | undefined;
  signedByTypeText: string | undefined;
  signedByProfessionalDesignationId: string | undefined;
  signedByProfessionDesignationText: string | undefined;
  signedByTitleClassificationValueId: string | undefined;
  signedByTitleText: string | undefined;
  signedDate: Date | undefined;
  receivedDate: Date | undefined;
  stampedSignature: boolean | undefined;
  samplesNotReceived: boolean | undefined;
  handwrittenNotesFlag: boolean | undefined;
  dateStamped: boolean | undefined;
  practitionerCommentsText: string | undefined;
  otherDescription: string | undefined;
  signatureImage: string | undefined;
  investigationResultFlag: boolean | undefined;
  investigationComment: string | undefined;
  validFlag: boolean | undefined;
  isConfirmedLitEventFlag: boolean | undefined;
  signaturePresentFlag: boolean | undefined;
  externalHcpId: string | undefined;
  hcpStateLicenseNumber: string | undefined;
  externalOrderLocationId: string | undefined;
  externalOrderRlId: string | undefined;
  externalShipToLocationId: string | undefined;
  externalShipToRlId: string | undefined;
  externalAocId: string | undefined;
  externalAocLineItemId: string | undefined;
  packingSlipNumber: string | undefined;
  shipToLastName: string | undefined;
  isPackingSlip: boolean | undefined;
  samplesReceived: boolean | undefined;
  samplesQuestions: boolean | undefined;
  order: Order | undefined;
  shipment: Shipment | undefined;
  aocInvestigationReasons: AocInvestigationReason[] | undefined;
  svls: Svl[] | undefined;
  aocLines: AocLine[] | undefined;
  anyDocBatchNumber: string | undefined;
  anyDocBatchDateTime: Date | undefined;
  anyDocFormFamily: string | undefined;
  anyDocTemplateName: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAoc) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderIdText = _data["orderIdText"];
      this.aocTypeClassificationValueId = _data["aocTypeClassificationValueId"];
      this.shipmentId = _data["shipmentId"];
      this.shipmentIdText = _data["shipmentIdText"];
      this.signedByFirstName = _data["signedByFirstName"];
      this.signedByLastName = _data["signedByLastName"];
      this.signedByName = _data["signedByName"];
      this.signedByTypeClassificationValueId = _data["signedByTypeClassificationValueId"];
      this.signedByTypeText = _data["signedByTypeText"];
      this.signedByProfessionalDesignationId = _data["signedByProfessionalDesignationId"];
      this.signedByProfessionDesignationText = _data["signedByProfessionDesignationText"];
      this.signedByTitleClassificationValueId = _data["signedByTitleClassificationValueId"];
      this.signedByTitleText = _data["signedByTitleText"];
      this.signedDate = _data["signedDate"] ? new Date(_data["signedDate"].toString()) : <any>undefined;
      this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
      this.stampedSignature = _data["stampedSignature"];
      this.samplesNotReceived = _data["samplesNotReceived"];
      this.handwrittenNotesFlag = _data["handwrittenNotesFlag"];
      this.dateStamped = _data["dateStamped"];
      this.practitionerCommentsText = _data["practitionerCommentsText"];
      this.otherDescription = _data["otherDescription"];
      this.signatureImage = _data["signatureImage"];
      this.investigationResultFlag = _data["investigationResultFlag"];
      this.investigationComment = _data["investigationComment"];
      this.validFlag = _data["validFlag"];
      this.isConfirmedLitEventFlag = _data["isConfirmedLitEventFlag"];
      this.signaturePresentFlag = _data["signaturePresentFlag"];
      this.externalHcpId = _data["externalHcpId"];
      this.hcpStateLicenseNumber = _data["hcpStateLicenseNumber"];
      this.externalOrderLocationId = _data["externalOrderLocationId"];
      this.externalOrderRlId = _data["externalOrderRlId"];
      this.externalShipToLocationId = _data["externalShipToLocationId"];
      this.externalShipToRlId = _data["externalShipToRlId"];
      this.externalAocId = _data["externalAocId"];
      this.externalAocLineItemId = _data["externalAocLineItemId"];
      this.packingSlipNumber = _data["packingSlipNumber"];
      this.shipToLastName = _data["shipToLastName"];
      this.isPackingSlip = _data["isPackingSlip"];
      this.samplesReceived = _data["samplesReceived"];
      this.samplesQuestions = _data["samplesQuestions"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.shipment = _data["shipment"] ? Shipment.fromJS(_data["shipment"]) : <any>undefined;
      if (Array.isArray(_data["aocInvestigationReasons"])) {
        this.aocInvestigationReasons = [] as any;
        for (let item of _data["aocInvestigationReasons"])
          this.aocInvestigationReasons.push(AocInvestigationReason.fromJS(item));
      }
      if (Array.isArray(_data["svls"])) {
        this.svls = [] as any;
        for (let item of _data["svls"])
          this.svls.push(Svl.fromJS(item));
      }
      if (Array.isArray(_data["aocLines"])) {
        this.aocLines = [] as any;
        for (let item of _data["aocLines"])
          this.aocLines.push(AocLine.fromJS(item));
      }
      this.anyDocBatchNumber = _data["anyDocBatchNumber"];
      this.anyDocBatchDateTime = _data["anyDocBatchDateTime"] ? new Date(_data["anyDocBatchDateTime"].toString()) : <any>undefined;
      this.anyDocFormFamily = _data["anyDocFormFamily"];
      this.anyDocTemplateName = _data["anyDocTemplateName"];
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Aoc {
    data = typeof data === 'object' ? data : {};
    let result = new Aoc();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderIdText"] = this.orderIdText;
    data["aocTypeClassificationValueId"] = this.aocTypeClassificationValueId;
    data["shipmentId"] = this.shipmentId;
    data["shipmentIdText"] = this.shipmentIdText;
    data["signedByFirstName"] = this.signedByFirstName;
    data["signedByLastName"] = this.signedByLastName;
    data["signedByName"] = this.signedByName;
    data["signedByTypeClassificationValueId"] = this.signedByTypeClassificationValueId;
    data["signedByTypeText"] = this.signedByTypeText;
    data["signedByProfessionalDesignationId"] = this.signedByProfessionalDesignationId;
    data["signedByProfessionDesignationText"] = this.signedByProfessionDesignationText;
    data["signedByTitleClassificationValueId"] = this.signedByTitleClassificationValueId;
    data["signedByTitleText"] = this.signedByTitleText;
    data["signedDate"] = this.signedDate ? this.signedDate.toISOString() : <any>undefined;
    data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
    data["stampedSignature"] = this.stampedSignature;
    data["samplesNotReceived"] = this.samplesNotReceived;
    data["handwrittenNotesFlag"] = this.handwrittenNotesFlag;
    data["dateStamped"] = this.dateStamped;
    data["practitionerCommentsText"] = this.practitionerCommentsText;
    data["otherDescription"] = this.otherDescription;
    data["signatureImage"] = this.signatureImage;
    data["investigationResultFlag"] = this.investigationResultFlag;
    data["investigationComment"] = this.investigationComment;
    data["validFlag"] = this.validFlag;
    data["isConfirmedLitEventFlag"] = this.isConfirmedLitEventFlag;
    data["signaturePresentFlag"] = this.signaturePresentFlag;
    data["externalHcpId"] = this.externalHcpId;
    data["hcpStateLicenseNumber"] = this.hcpStateLicenseNumber;
    data["externalOrderLocationId"] = this.externalOrderLocationId;
    data["externalOrderRlId"] = this.externalOrderRlId;
    data["externalShipToLocationId"] = this.externalShipToLocationId;
    data["externalShipToRlId"] = this.externalShipToRlId;
    data["externalAocId"] = this.externalAocId;
    data["externalAocLineItemId"] = this.externalAocLineItemId;
    data["packingSlipNumber"] = this.packingSlipNumber;
    data["shipToLastName"] = this.shipToLastName;
    data["isPackingSlip"] = this.isPackingSlip;
    data["samplesReceived"] = this.samplesReceived;
    data["samplesQuestions"] = this.samplesQuestions;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["shipment"] = this.shipment ? this.shipment.toJSON() : <any>undefined;
    if (Array.isArray(this.aocInvestigationReasons)) {
      data["aocInvestigationReasons"] = [];
      for (let item of this.aocInvestigationReasons)
        data["aocInvestigationReasons"].push(item.toJSON());
    }
    if (Array.isArray(this.svls)) {
      data["svls"] = [];
      for (let item of this.svls)
        data["svls"].push(item.toJSON());
    }
    if (Array.isArray(this.aocLines)) {
      data["aocLines"] = [];
      for (let item of this.aocLines)
        data["aocLines"].push(item.toJSON());
    }
    data["anyDocBatchNumber"] = this.anyDocBatchNumber;
    data["anyDocBatchDateTime"] = this.anyDocBatchDateTime ? this.anyDocBatchDateTime.toISOString() : <any>undefined;
    data["anyDocFormFamily"] = this.anyDocFormFamily;
    data["anyDocTemplateName"] = this.anyDocTemplateName;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Aoc {
    const json = this.toJSON();
    let result = new Aoc();
    result.init(json);
    return result;
  }
}

export interface IAoc {
  orderId: string | undefined;
  orderIdText: string | undefined;
  aocTypeClassificationValueId: string | undefined;
  shipmentId: string | undefined;
  shipmentIdText: string | undefined;
  signedByFirstName: string | undefined;
  signedByLastName: string | undefined;
  signedByName: string | undefined;
  signedByTypeClassificationValueId: string | undefined;
  signedByTypeText: string | undefined;
  signedByProfessionalDesignationId: string | undefined;
  signedByProfessionDesignationText: string | undefined;
  signedByTitleClassificationValueId: string | undefined;
  signedByTitleText: string | undefined;
  signedDate: Date | undefined;
  receivedDate: Date | undefined;
  stampedSignature: boolean | undefined;
  samplesNotReceived: boolean | undefined;
  handwrittenNotesFlag: boolean | undefined;
  dateStamped: boolean | undefined;
  practitionerCommentsText: string | undefined;
  otherDescription: string | undefined;
  signatureImage: string | undefined;
  investigationResultFlag: boolean | undefined;
  investigationComment: string | undefined;
  validFlag: boolean | undefined;
  isConfirmedLitEventFlag: boolean | undefined;
  signaturePresentFlag: boolean | undefined;
  externalHcpId: string | undefined;
  hcpStateLicenseNumber: string | undefined;
  externalOrderLocationId: string | undefined;
  externalOrderRlId: string | undefined;
  externalShipToLocationId: string | undefined;
  externalShipToRlId: string | undefined;
  externalAocId: string | undefined;
  externalAocLineItemId: string | undefined;
  packingSlipNumber: string | undefined;
  shipToLastName: string | undefined;
  isPackingSlip: boolean | undefined;
  samplesReceived: boolean | undefined;
  samplesQuestions: boolean | undefined;
  order: Order | undefined;
  shipment: Shipment | undefined;
  aocInvestigationReasons: AocInvestigationReason[] | undefined;
  svls: Svl[] | undefined;
  aocLines: AocLine[] | undefined;
  anyDocBatchNumber: string | undefined;
  anyDocBatchDateTime: Date | undefined;
  anyDocFormFamily: string | undefined;
  anyDocTemplateName: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Svl implements ISvl {
  formId: string | undefined;
  shipmentIdText: string | undefined;
  orderId: string | undefined;
  shipmentId: string | undefined;
  aocId: string | undefined;
  svlTypeClassificationValueId: string | undefined;
  signatureFlag: boolean | undefined;
  mySignatureFlag: boolean | undefined;
  notMySignatureFlag: boolean | undefined;
  alternateSignatureFlag: boolean | undefined;
  signatureDate: Date | undefined;
  signatureStampedFlag: boolean | undefined;
  signatureDateStampedFlag: boolean | undefined;
  signerFirstName: string | undefined;
  signerLastName: string | undefined;
  signerTitle: string | undefined;
  samplesNotReceivedFlag: boolean | undefined;
  handwrittenNotesFlag: boolean | undefined;
  investigationComment: string | undefined;
  investigationResultFlag: boolean | undefined;
  validFlag: boolean | undefined;
  signatureMatchFlag: boolean | undefined;
  signedByTypeClassificationValueId: string | undefined;
  signedByTypeText: string | undefined;
  shipToLastName: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  svlInvestigationReasons: SvlInvestigationReason[] | undefined;
  svlNegativeResponseComments: SvlNegativeResponseComment[] | undefined;
  order: Order | undefined;
  shipment: Shipment | undefined;
  aoc: Aoc | undefined;
  anyDocBatchNumber: string | undefined;
  anyDocBatchDateTime: Date | undefined;
  anyDocFormFamily: string | undefined;
  anyDocTemplateName: string | undefined;
  samplesQuestions: boolean | undefined;
  samplesReceived: boolean | undefined;
  target: string | undefined;
  listName: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ISvl) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.formId = _data["formId"];
      this.shipmentIdText = _data["shipmentIdText"];
      this.orderId = _data["orderId"];
      this.shipmentId = _data["shipmentId"];
      this.aocId = _data["aocId"];
      this.svlTypeClassificationValueId = _data["svlTypeClassificationValueId"];
      this.signatureFlag = _data["signatureFlag"];
      this.mySignatureFlag = _data["mySignatureFlag"];
      this.notMySignatureFlag = _data["notMySignatureFlag"];
      this.alternateSignatureFlag = _data["alternateSignatureFlag"];
      this.signatureDate = _data["signatureDate"] ? new Date(_data["signatureDate"].toString()) : <any>undefined;
      this.signatureStampedFlag = _data["signatureStampedFlag"];
      this.signatureDateStampedFlag = _data["signatureDateStampedFlag"];
      this.signerFirstName = _data["signerFirstName"];
      this.signerLastName = _data["signerLastName"];
      this.signerTitle = _data["signerTitle"];
      this.samplesNotReceivedFlag = _data["samplesNotReceivedFlag"];
      this.handwrittenNotesFlag = _data["handwrittenNotesFlag"];
      this.investigationComment = _data["investigationComment"];
      this.investigationResultFlag = _data["investigationResultFlag"];
      this.validFlag = _data["validFlag"];
      this.signatureMatchFlag = _data["signatureMatchFlag"];
      this.signedByTypeClassificationValueId = _data["signedByTypeClassificationValueId"];
      this.signedByTypeText = _data["signedByTypeText"];
      this.shipToLastName = _data["shipToLastName"];
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      if (Array.isArray(_data["svlInvestigationReasons"])) {
        this.svlInvestigationReasons = [] as any;
        for (let item of _data["svlInvestigationReasons"])
          this.svlInvestigationReasons.push(SvlInvestigationReason.fromJS(item));
      }
      if (Array.isArray(_data["svlNegativeResponseComments"])) {
        this.svlNegativeResponseComments = [] as any;
        for (let item of _data["svlNegativeResponseComments"])
          this.svlNegativeResponseComments.push(SvlNegativeResponseComment.fromJS(item));
      }
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.shipment = _data["shipment"] ? Shipment.fromJS(_data["shipment"]) : <any>undefined;
      this.aoc = _data["aoc"] ? Aoc.fromJS(_data["aoc"]) : <any>undefined;
      this.anyDocBatchNumber = _data["anyDocBatchNumber"];
      this.anyDocBatchDateTime = _data["anyDocBatchDateTime"] ? new Date(_data["anyDocBatchDateTime"].toString()) : <any>undefined;
      this.anyDocFormFamily = _data["anyDocFormFamily"];
      this.anyDocTemplateName = _data["anyDocTemplateName"];
      this.samplesQuestions = _data["samplesQuestions"];
      this.samplesReceived = _data["samplesReceived"];
      this.target = _data["target"];
      this.listName = _data["listName"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Svl {
    data = typeof data === 'object' ? data : {};
    let result = new Svl();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["formId"] = this.formId;
    data["shipmentIdText"] = this.shipmentIdText;
    data["orderId"] = this.orderId;
    data["shipmentId"] = this.shipmentId;
    data["aocId"] = this.aocId;
    data["svlTypeClassificationValueId"] = this.svlTypeClassificationValueId;
    data["signatureFlag"] = this.signatureFlag;
    data["mySignatureFlag"] = this.mySignatureFlag;
    data["notMySignatureFlag"] = this.notMySignatureFlag;
    data["alternateSignatureFlag"] = this.alternateSignatureFlag;
    data["signatureDate"] = this.signatureDate ? this.signatureDate.toISOString() : <any>undefined;
    data["signatureStampedFlag"] = this.signatureStampedFlag;
    data["signatureDateStampedFlag"] = this.signatureDateStampedFlag;
    data["signerFirstName"] = this.signerFirstName;
    data["signerLastName"] = this.signerLastName;
    data["signerTitle"] = this.signerTitle;
    data["samplesNotReceivedFlag"] = this.samplesNotReceivedFlag;
    data["handwrittenNotesFlag"] = this.handwrittenNotesFlag;
    data["investigationComment"] = this.investigationComment;
    data["investigationResultFlag"] = this.investigationResultFlag;
    data["validFlag"] = this.validFlag;
    data["signatureMatchFlag"] = this.signatureMatchFlag;
    data["signedByTypeClassificationValueId"] = this.signedByTypeClassificationValueId;
    data["signedByTypeText"] = this.signedByTypeText;
    data["shipToLastName"] = this.shipToLastName;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    if (Array.isArray(this.svlInvestigationReasons)) {
      data["svlInvestigationReasons"] = [];
      for (let item of this.svlInvestigationReasons)
        data["svlInvestigationReasons"].push(item.toJSON());
    }
    if (Array.isArray(this.svlNegativeResponseComments)) {
      data["svlNegativeResponseComments"] = [];
      for (let item of this.svlNegativeResponseComments)
        data["svlNegativeResponseComments"].push(item.toJSON());
    }
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["shipment"] = this.shipment ? this.shipment.toJSON() : <any>undefined;
    data["aoc"] = this.aoc ? this.aoc.toJSON() : <any>undefined;
    data["anyDocBatchNumber"] = this.anyDocBatchNumber;
    data["anyDocBatchDateTime"] = this.anyDocBatchDateTime ? this.anyDocBatchDateTime.toISOString() : <any>undefined;
    data["anyDocFormFamily"] = this.anyDocFormFamily;
    data["anyDocTemplateName"] = this.anyDocTemplateName;
    data["samplesQuestions"] = this.samplesQuestions;
    data["samplesReceived"] = this.samplesReceived;
    data["target"] = this.target;
    data["listName"] = this.listName;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Svl {
    const json = this.toJSON();
    let result = new Svl();
    result.init(json);
    return result;
  }
}

export interface ISvl {
  formId: string | undefined;
  shipmentIdText: string | undefined;
  orderId: string | undefined;
  shipmentId: string | undefined;
  aocId: string | undefined;
  svlTypeClassificationValueId: string | undefined;
  signatureFlag: boolean | undefined;
  mySignatureFlag: boolean | undefined;
  notMySignatureFlag: boolean | undefined;
  alternateSignatureFlag: boolean | undefined;
  signatureDate: Date | undefined;
  signatureStampedFlag: boolean | undefined;
  signatureDateStampedFlag: boolean | undefined;
  signerFirstName: string | undefined;
  signerLastName: string | undefined;
  signerTitle: string | undefined;
  samplesNotReceivedFlag: boolean | undefined;
  handwrittenNotesFlag: boolean | undefined;
  investigationComment: string | undefined;
  investigationResultFlag: boolean | undefined;
  validFlag: boolean | undefined;
  signatureMatchFlag: boolean | undefined;
  signedByTypeClassificationValueId: string | undefined;
  signedByTypeText: string | undefined;
  shipToLastName: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  svlInvestigationReasons: SvlInvestigationReason[] | undefined;
  svlNegativeResponseComments: SvlNegativeResponseComment[] | undefined;
  order: Order | undefined;
  shipment: Shipment | undefined;
  aoc: Aoc | undefined;
  anyDocBatchNumber: string | undefined;
  anyDocBatchDateTime: Date | undefined;
  anyDocFormFamily: string | undefined;
  anyDocTemplateName: string | undefined;
  samplesQuestions: boolean | undefined;
  samplesReceived: boolean | undefined;
  target: string | undefined;
  listName: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderFormField implements IOrderFormField {
  orderId: string | undefined;
  srfFormFieldClassificationValueId: string | undefined;
  missingFlag: boolean | undefined;
  modificationFlag: boolean | undefined;
  modificationReason: string | undefined;
  order: Order | undefined;
  srfFormField: ReferencedClassification | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderFormField) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.srfFormFieldClassificationValueId = _data["srfFormFieldClassificationValueId"];
      this.missingFlag = _data["missingFlag"];
      this.modificationFlag = _data["modificationFlag"];
      this.modificationReason = _data["modificationReason"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.srfFormField = _data["srfFormField"] ? ReferencedClassification.fromJS(_data["srfFormField"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderFormField {
    data = typeof data === 'object' ? data : {};
    let result = new OrderFormField();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["srfFormFieldClassificationValueId"] = this.srfFormFieldClassificationValueId;
    data["missingFlag"] = this.missingFlag;
    data["modificationFlag"] = this.modificationFlag;
    data["modificationReason"] = this.modificationReason;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["srfFormField"] = this.srfFormField ? this.srfFormField.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderFormField {
    const json = this.toJSON();
    let result = new OrderFormField();
    result.init(json);
    return result;
  }
}

export interface IOrderFormField {
  orderId: string | undefined;
  srfFormFieldClassificationValueId: string | undefined;
  missingFlag: boolean | undefined;
  modificationFlag: boolean | undefined;
  modificationReason: string | undefined;
  order: Order | undefined;
  srfFormField: ReferencedClassification | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderPlitInvestigation implements IOrderPlitInvestigation {
  orderId: string | undefined;
  order: Order | undefined;
  orderPlitInvestigationClassificationValueId: string | undefined;
  actualDeliveryDate: Date | undefined;
  investigationDate: Date | undefined;
  signedBy: string | undefined;
  orderAttachments: OrderAttachment[] | undefined;
  orderComments: OrderComment[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderPlitInvestigation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.orderPlitInvestigationClassificationValueId = _data["orderPlitInvestigationClassificationValueId"];
      this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
      this.investigationDate = _data["investigationDate"] ? new Date(_data["investigationDate"].toString()) : <any>undefined;
      this.signedBy = _data["signedBy"];
      if (Array.isArray(_data["orderAttachments"])) {
        this.orderAttachments = [] as any;
        for (let item of _data["orderAttachments"])
          this.orderAttachments.push(OrderAttachment.fromJS(item));
      }
      if (Array.isArray(_data["orderComments"])) {
        this.orderComments = [] as any;
        for (let item of _data["orderComments"])
          this.orderComments.push(OrderComment.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderPlitInvestigation {
    data = typeof data === 'object' ? data : {};
    let result = new OrderPlitInvestigation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["orderPlitInvestigationClassificationValueId"] = this.orderPlitInvestigationClassificationValueId;
    data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
    data["investigationDate"] = this.investigationDate ? this.investigationDate.toISOString() : <any>undefined;
    data["signedBy"] = this.signedBy;
    if (Array.isArray(this.orderAttachments)) {
      data["orderAttachments"] = [];
      for (let item of this.orderAttachments)
        data["orderAttachments"].push(item.toJSON());
    }
    if (Array.isArray(this.orderComments)) {
      data["orderComments"] = [];
      for (let item of this.orderComments)
        data["orderComments"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderPlitInvestigation {
    const json = this.toJSON();
    let result = new OrderPlitInvestigation();
    result.init(json);
    return result;
  }
}

export interface IOrderPlitInvestigation {
  orderId: string | undefined;
  order: Order | undefined;
  orderPlitInvestigationClassificationValueId: string | undefined;
  actualDeliveryDate: Date | undefined;
  investigationDate: Date | undefined;
  signedBy: string | undefined;
  orderAttachments: OrderAttachment[] | undefined;
  orderComments: OrderComment[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderSelectDayVerification implements IOrderSelectDayVerification {
  orderId: string | undefined;
  order: Order | undefined;
  desiredDeliveryDate: Date | undefined;
  hcpCouldNotBeReachedFlag: boolean | undefined;
  selectDayVerificationDate: Date | undefined;
  orderComments: OrderComment[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderSelectDayVerification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.desiredDeliveryDate = _data["desiredDeliveryDate"] ? new Date(_data["desiredDeliveryDate"].toString()) : <any>undefined;
      this.hcpCouldNotBeReachedFlag = _data["hcpCouldNotBeReachedFlag"];
      this.selectDayVerificationDate = _data["selectDayVerificationDate"] ? new Date(_data["selectDayVerificationDate"].toString()) : <any>undefined;
      if (Array.isArray(_data["orderComments"])) {
        this.orderComments = [] as any;
        for (let item of _data["orderComments"])
          this.orderComments.push(OrderComment.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderSelectDayVerification {
    data = typeof data === 'object' ? data : {};
    let result = new OrderSelectDayVerification();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["desiredDeliveryDate"] = this.desiredDeliveryDate ? this.desiredDeliveryDate.toISOString() : <any>undefined;
    data["hcpCouldNotBeReachedFlag"] = this.hcpCouldNotBeReachedFlag;
    data["selectDayVerificationDate"] = this.selectDayVerificationDate ? this.selectDayVerificationDate.toISOString() : <any>undefined;
    if (Array.isArray(this.orderComments)) {
      data["orderComments"] = [];
      for (let item of this.orderComments)
        data["orderComments"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderSelectDayVerification {
    const json = this.toJSON();
    let result = new OrderSelectDayVerification();
    result.init(json);
    return result;
  }
}

export interface IOrderSelectDayVerification {
  orderId: string | undefined;
  order: Order | undefined;
  desiredDeliveryDate: Date | undefined;
  hcpCouldNotBeReachedFlag: boolean | undefined;
  selectDayVerificationDate: Date | undefined;
  orderComments: OrderComment[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderReturn implements IOrderReturn {
  orderId: string | undefined;
  returnDate: Date | undefined;
  returnReasonClassificationValueId: string | undefined;
  wmsReturnReason: string | undefined;
  orderReturnLines: OrderReturnLine[] | undefined;
  isConfirmedLitEventFlag: boolean | undefined;
  order: Order | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderReturn) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.returnDate = _data["returnDate"] ? new Date(_data["returnDate"].toString()) : <any>undefined;
      this.returnReasonClassificationValueId = _data["returnReasonClassificationValueId"];
      this.wmsReturnReason = _data["wmsReturnReason"];
      if (Array.isArray(_data["orderReturnLines"])) {
        this.orderReturnLines = [] as any;
        for (let item of _data["orderReturnLines"])
          this.orderReturnLines.push(OrderReturnLine.fromJS(item));
      }
      this.isConfirmedLitEventFlag = _data["isConfirmedLitEventFlag"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderReturn {
    data = typeof data === 'object' ? data : {};
    let result = new OrderReturn();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
    data["returnReasonClassificationValueId"] = this.returnReasonClassificationValueId;
    data["wmsReturnReason"] = this.wmsReturnReason;
    if (Array.isArray(this.orderReturnLines)) {
      data["orderReturnLines"] = [];
      for (let item of this.orderReturnLines)
        data["orderReturnLines"].push(item.toJSON());
    }
    data["isConfirmedLitEventFlag"] = this.isConfirmedLitEventFlag;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderReturn {
    const json = this.toJSON();
    let result = new OrderReturn();
    result.init(json);
    return result;
  }
}

export interface IOrderReturn {
  orderId: string | undefined;
  returnDate: Date | undefined;
  returnReasonClassificationValueId: string | undefined;
  wmsReturnReason: string | undefined;
  orderReturnLines: OrderReturnLine[] | undefined;
  isConfirmedLitEventFlag: boolean | undefined;
  order: Order | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class RrofrOrder implements IRrofrOrder {
  order_FK: string | undefined;
  salesRepOrderRefusalStatusClassificatonId: string | undefined;
  salesRepEmailStatusClassificationId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  emailAddress: string | undefined;
  isProcessed: boolean | undefined;
  salesRepOrderRefusalStatus: ReferencedClassification | undefined;
  salesRepEmailStatus: ReferencedClassification | undefined;
  order: Order | undefined;
  rrofrOrderLines: RrofrOrderLine[] | undefined;
  rrofrOrderStatusHistories: RrofrOrderStatusHistory[] | undefined;
  rrofrRespones: RrofrRespone[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IRrofrOrder) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.order_FK = _data["order_FK"];
      this.salesRepOrderRefusalStatusClassificatonId = _data["salesRepOrderRefusalStatusClassificatonId"];
      this.salesRepEmailStatusClassificationId = _data["salesRepEmailStatusClassificationId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.emailAddress = _data["emailAddress"];
      this.isProcessed = _data["isProcessed"];
      this.salesRepOrderRefusalStatus = _data["salesRepOrderRefusalStatus"] ? ReferencedClassification.fromJS(_data["salesRepOrderRefusalStatus"]) : <any>undefined;
      this.salesRepEmailStatus = _data["salesRepEmailStatus"] ? ReferencedClassification.fromJS(_data["salesRepEmailStatus"]) : <any>undefined;
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      if (Array.isArray(_data["rrofrOrderLines"])) {
        this.rrofrOrderLines = [] as any;
        for (let item of _data["rrofrOrderLines"])
          this.rrofrOrderLines.push(RrofrOrderLine.fromJS(item));
      }
      if (Array.isArray(_data["rrofrOrderStatusHistories"])) {
        this.rrofrOrderStatusHistories = [] as any;
        for (let item of _data["rrofrOrderStatusHistories"])
          this.rrofrOrderStatusHistories.push(RrofrOrderStatusHistory.fromJS(item));
      }
      if (Array.isArray(_data["rrofrRespones"])) {
        this.rrofrRespones = [] as any;
        for (let item of _data["rrofrRespones"])
          this.rrofrRespones.push(RrofrRespone.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RrofrOrder {
    data = typeof data === 'object' ? data : {};
    let result = new RrofrOrder();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["order_FK"] = this.order_FK;
    data["salesRepOrderRefusalStatusClassificatonId"] = this.salesRepOrderRefusalStatusClassificatonId;
    data["salesRepEmailStatusClassificationId"] = this.salesRepEmailStatusClassificationId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["emailAddress"] = this.emailAddress;
    data["isProcessed"] = this.isProcessed;
    data["salesRepOrderRefusalStatus"] = this.salesRepOrderRefusalStatus ? this.salesRepOrderRefusalStatus.toJSON() : <any>undefined;
    data["salesRepEmailStatus"] = this.salesRepEmailStatus ? this.salesRepEmailStatus.toJSON() : <any>undefined;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    if (Array.isArray(this.rrofrOrderLines)) {
      data["rrofrOrderLines"] = [];
      for (let item of this.rrofrOrderLines)
        data["rrofrOrderLines"].push(item.toJSON());
    }
    if (Array.isArray(this.rrofrOrderStatusHistories)) {
      data["rrofrOrderStatusHistories"] = [];
      for (let item of this.rrofrOrderStatusHistories)
        data["rrofrOrderStatusHistories"].push(item.toJSON());
    }
    if (Array.isArray(this.rrofrRespones)) {
      data["rrofrRespones"] = [];
      for (let item of this.rrofrRespones)
        data["rrofrRespones"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): RrofrOrder {
    const json = this.toJSON();
    let result = new RrofrOrder();
    result.init(json);
    return result;
  }
}

export interface IRrofrOrder {
  order_FK: string | undefined;
  salesRepOrderRefusalStatusClassificatonId: string | undefined;
  salesRepEmailStatusClassificationId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  emailAddress: string | undefined;
  isProcessed: boolean | undefined;
  salesRepOrderRefusalStatus: ReferencedClassification | undefined;
  salesRepEmailStatus: ReferencedClassification | undefined;
  order: Order | undefined;
  rrofrOrderLines: RrofrOrderLine[] | undefined;
  rrofrOrderStatusHistories: RrofrOrderStatusHistory[] | undefined;
  rrofrRespones: RrofrRespone[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HcpDoNotHonorExclusion implements IHcpDoNotHonorExclusion {
  hcpId: string | undefined;
  hcp: Hcp | undefined;
  programId: string | undefined;
  productGroupId: string | undefined;
  productGroup: ProductGroup | undefined;
  productId: string | undefined;
  product: Product | undefined;
  doNotHonorExclusionReasonId: string | undefined;
  hcpDoNotHonorExclusionAttachmentId: string | undefined;
  addedDate: Date | undefined;
  commentsText: string | undefined;
  deletionReasonText: string | undefined;
  attachment: HcpDoNotHonorExclusionAttachment | undefined;
  sourceClassificationValueId: string | undefined;
  requestedDate: Date | undefined;
  orderId: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHcpDoNotHonorExclusion) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hcpId = _data["hcpId"];
      this.hcp = _data["hcp"] ? Hcp.fromJS(_data["hcp"]) : <any>undefined;
      this.programId = _data["programId"];
      this.productGroupId = _data["productGroupId"];
      this.productGroup = _data["productGroup"] ? ProductGroup.fromJS(_data["productGroup"]) : <any>undefined;
      this.productId = _data["productId"];
      this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
      this.doNotHonorExclusionReasonId = _data["doNotHonorExclusionReasonId"];
      this.hcpDoNotHonorExclusionAttachmentId = _data["hcpDoNotHonorExclusionAttachmentId"];
      this.addedDate = _data["addedDate"] ? new Date(_data["addedDate"].toString()) : <any>undefined;
      this.commentsText = _data["commentsText"];
      this.deletionReasonText = _data["deletionReasonText"];
      this.attachment = _data["attachment"] ? HcpDoNotHonorExclusionAttachment.fromJS(_data["attachment"]) : <any>undefined;
      this.sourceClassificationValueId = _data["sourceClassificationValueId"];
      this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
      this.orderId = _data["orderId"];
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HcpDoNotHonorExclusion {
    data = typeof data === 'object' ? data : {};
    let result = new HcpDoNotHonorExclusion();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hcpId"] = this.hcpId;
    data["hcp"] = this.hcp ? this.hcp.toJSON() : <any>undefined;
    data["programId"] = this.programId;
    data["productGroupId"] = this.productGroupId;
    data["productGroup"] = this.productGroup ? this.productGroup.toJSON() : <any>undefined;
    data["productId"] = this.productId;
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["doNotHonorExclusionReasonId"] = this.doNotHonorExclusionReasonId;
    data["hcpDoNotHonorExclusionAttachmentId"] = this.hcpDoNotHonorExclusionAttachmentId;
    data["addedDate"] = this.addedDate ? this.addedDate.toISOString() : <any>undefined;
    data["commentsText"] = this.commentsText;
    data["deletionReasonText"] = this.deletionReasonText;
    data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
    data["sourceClassificationValueId"] = this.sourceClassificationValueId;
    data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
    data["orderId"] = this.orderId;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HcpDoNotHonorExclusion {
    const json = this.toJSON();
    let result = new HcpDoNotHonorExclusion();
    result.init(json);
    return result;
  }
}

export interface IHcpDoNotHonorExclusion {
  hcpId: string | undefined;
  hcp: Hcp | undefined;
  programId: string | undefined;
  productGroupId: string | undefined;
  productGroup: ProductGroup | undefined;
  productId: string | undefined;
  product: Product | undefined;
  doNotHonorExclusionReasonId: string | undefined;
  hcpDoNotHonorExclusionAttachmentId: string | undefined;
  addedDate: Date | undefined;
  commentsText: string | undefined;
  deletionReasonText: string | undefined;
  attachment: HcpDoNotHonorExclusionAttachment | undefined;
  sourceClassificationValueId: string | undefined;
  requestedDate: Date | undefined;
  orderId: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderInvoice implements IOrderInvoice {
  customerAddressId: string | undefined;
  orderId: string | undefined;
  stateCode: string | undefined;
  invoiceNumber: string | undefined;
  invoiceDate: Date | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  addressLine1: string | undefined;
  addressLine2: string | undefined;
  city: string | undefined;
  companyName: string | undefined;
  zipCode: string | undefined;
  attachmentFileName: string | undefined;
  attachmentFileLocationText: string | undefined;
  order: Order | undefined;
  customerAddress: CustomerDeliveryAddress | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderInvoice) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerAddressId = _data["customerAddressId"];
      this.orderId = _data["orderId"];
      this.stateCode = _data["stateCode"];
      this.invoiceNumber = _data["invoiceNumber"];
      this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.addressLine1 = _data["addressLine1"];
      this.addressLine2 = _data["addressLine2"];
      this.city = _data["city"];
      this.companyName = _data["companyName"];
      this.zipCode = _data["zipCode"];
      this.attachmentFileName = _data["attachmentFileName"];
      this.attachmentFileLocationText = _data["attachmentFileLocationText"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.customerAddress = _data["customerAddress"] ? CustomerDeliveryAddress.fromJS(_data["customerAddress"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderInvoice {
    data = typeof data === 'object' ? data : {};
    let result = new OrderInvoice();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["customerAddressId"] = this.customerAddressId;
    data["orderId"] = this.orderId;
    data["stateCode"] = this.stateCode;
    data["invoiceNumber"] = this.invoiceNumber;
    data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["addressLine1"] = this.addressLine1;
    data["addressLine2"] = this.addressLine2;
    data["city"] = this.city;
    data["companyName"] = this.companyName;
    data["zipCode"] = this.zipCode;
    data["attachmentFileName"] = this.attachmentFileName;
    data["attachmentFileLocationText"] = this.attachmentFileLocationText;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderInvoice {
    const json = this.toJSON();
    let result = new OrderInvoice();
    result.init(json);
    return result;
  }
}

export interface IOrderInvoice {
  customerAddressId: string | undefined;
  orderId: string | undefined;
  stateCode: string | undefined;
  invoiceNumber: string | undefined;
  invoiceDate: Date | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  addressLine1: string | undefined;
  addressLine2: string | undefined;
  city: string | undefined;
  companyName: string | undefined;
  zipCode: string | undefined;
  attachmentFileName: string | undefined;
  attachmentFileLocationText: string | undefined;
  order: Order | undefined;
  customerAddress: CustomerDeliveryAddress | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplOrder implements ITplOrder {
  hcpCouldNotBeReachedFlag: boolean | undefined;
  hcpSignaturePresentFlag: boolean | undefined;
  hcpSignatureStampedFlag: boolean | undefined;
  hcpSignatureMatchFlag: boolean | undefined;
  hcpSignatureDateStampedFlag: boolean | undefined;
  hcpSignedDatePresentFlag: boolean | undefined;
  hcpSignatureDate: Date | undefined;
  hcpSignatureMissingFlag: boolean | undefined;
  hcpSignature: string | undefined;
  exportToDynamicsPath: string | undefined;
  asnFilePath: string | undefined;
  somStatusCode: string | undefined;
  isPriceCheckMitigated: boolean | undefined;
  isCreditCheckMitigated: boolean | undefined;
  externalBillingNbr: string | undefined;
  exportOrderToDynamicsStatus: number | undefined;
  exportOrderImportToDynamicsStatus: number | undefined;
  orderType: string | undefined;
  department: string | undefined;
  dcNumber: string | undefined;
  shipmentPayment: string | undefined;
  poShipTo: string | undefined;
  orderCancellationReasonClassificationValueId: string | undefined;
  order: Order | undefined;
  externalOrderId: string | undefined;
  externalFormId: string | undefined;
  wmsOrderId: string | undefined;
  mondayDeliveryFlag: boolean | undefined;
  tuesdayDeliveryFlag: boolean | undefined;
  wednesdayDeliveryFlag: boolean | undefined;
  thursdayDeliveryFlag: boolean | undefined;
  fridayDeliveryFlag: boolean | undefined;
  saturdayDeliveryFlag: boolean | undefined;
  sundayDeliveryFlag: boolean | undefined;
  missingFlag: boolean | undefined;
  reformattedRecipientFirstName: string | undefined;
  reformattedRecipientMiddleName: string | undefined;
  reformattedRecipientLastName: string | undefined;
  reformattedRecipientSuffixClassificationValueId: string | undefined;
  reformattedRecipientCompanyName: string | undefined;
  reformattedRecipientAddress1Text: string | undefined;
  reformattedRecipientAddress2Text: string | undefined;
  reformattedRecipientAddress3Text: string | undefined;
  reformattedRecipientAddress4Text: string | undefined;
  reformattedRecipientCityName: string | undefined;
  reformattedRecipientZipCode: string | undefined;
  reformattedRecipientStateCodeId: string | undefined;
  reformattedRecipientCountryCodeId: string | undefined;
  requestorComment: string | undefined;
  srfAdverseEventFlag: boolean | undefined;
  srfAdverseEventComment: string | undefined;
  optOutFlag: boolean | undefined;
  ohioTDDDExemptionFlag: boolean | undefined;
  scheduledShipDate: Date | undefined;
  scheduledDeliveryDate: Date | undefined;
  desiredDeliveryDate: Date | undefined;
  anticipatedLatestDeliveryDate: Date | undefined;
  anticipatedCarrierId: string | undefined;
  anticipatedCarrierServiceTypeId: string | undefined;
  wmsOrderType: string | undefined;
  cancellationInWmsRequestedByUserId: number | undefined;
  cancellationInWmsRequestedTimestamp: Date | undefined;
  noExceptionActionFlag: boolean | undefined;
  formIdMissingFlag: boolean | undefined;
  formIdNotApplicableFlag: boolean | undefined;
  formIdUnmatchedFlag: boolean | undefined;
  anyDocBatchNumber: string | undefined;
  anyDocBatchDateTime: Date | undefined;
  anyDocFormFamily: string | undefined;
  anyDocTemplateName: string | undefined;
  openAocRulePassedTempFlag: boolean | undefined;
  exceededTerritoryAllocationRuleIsApplicapleFlag: boolean | undefined;
  exceededTerritoryAllocationRulePassedFlag: boolean | undefined;
  exceededPractitionerAllocationRuleIsApplicapleFlag: boolean | undefined;
  exceededPractitionerAllocationRulePassedFlag: boolean | undefined;
  firstAOCDateTime: Date | undefined;
  secondAOCDateTime: Date | undefined;
  thirdAOCDateTime: Date | undefined;
  firstAOCSentDateTime: Date | undefined;
  secondAOCSentDateTime: Date | undefined;
  thirdAOCSentDateTime: Date | undefined;
  svlGeneratedDateTime: Date | undefined;
  generatedSvlType: string | undefined;
  externalClientId: string | undefined;
  externalOrderSfaId: string | undefined;
  readonly acceptableDeliveryDays: AcceptableDeliveryDays[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplOrder) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hcpCouldNotBeReachedFlag = _data["hcpCouldNotBeReachedFlag"];
      this.hcpSignaturePresentFlag = _data["hcpSignaturePresentFlag"];
      this.hcpSignatureStampedFlag = _data["hcpSignatureStampedFlag"];
      this.hcpSignatureMatchFlag = _data["hcpSignatureMatchFlag"];
      this.hcpSignatureDateStampedFlag = _data["hcpSignatureDateStampedFlag"];
      this.hcpSignedDatePresentFlag = _data["hcpSignedDatePresentFlag"];
      this.hcpSignatureDate = _data["hcpSignatureDate"] ? new Date(_data["hcpSignatureDate"].toString()) : <any>undefined;
      this.hcpSignatureMissingFlag = _data["hcpSignatureMissingFlag"];
      this.hcpSignature = _data["hcpSignature"];
      this.exportToDynamicsPath = _data["exportToDynamicsPath"];
      this.asnFilePath = _data["asnFilePath"];
      this.somStatusCode = _data["somStatusCode"];
      this.isPriceCheckMitigated = _data["isPriceCheckMitigated"];
      this.isCreditCheckMitigated = _data["isCreditCheckMitigated"];
      this.externalBillingNbr = _data["externalBillingNbr"];
      this.exportOrderToDynamicsStatus = _data["exportOrderToDynamicsStatus"];
      this.exportOrderImportToDynamicsStatus = _data["exportOrderImportToDynamicsStatus"];
      this.orderType = _data["orderType"];
      this.department = _data["department"];
      this.dcNumber = _data["dcNumber"];
      this.shipmentPayment = _data["shipmentPayment"];
      this.poShipTo = _data["poShipTo"];
      this.orderCancellationReasonClassificationValueId = _data["orderCancellationReasonClassificationValueId"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.externalOrderId = _data["externalOrderId"];
      this.externalFormId = _data["externalFormId"];
      this.wmsOrderId = _data["wmsOrderId"];
      this.mondayDeliveryFlag = _data["mondayDeliveryFlag"];
      this.tuesdayDeliveryFlag = _data["tuesdayDeliveryFlag"];
      this.wednesdayDeliveryFlag = _data["wednesdayDeliveryFlag"];
      this.thursdayDeliveryFlag = _data["thursdayDeliveryFlag"];
      this.fridayDeliveryFlag = _data["fridayDeliveryFlag"];
      this.saturdayDeliveryFlag = _data["saturdayDeliveryFlag"];
      this.sundayDeliveryFlag = _data["sundayDeliveryFlag"];
      this.missingFlag = _data["missingFlag"];
      this.reformattedRecipientFirstName = _data["reformattedRecipientFirstName"];
      this.reformattedRecipientMiddleName = _data["reformattedRecipientMiddleName"];
      this.reformattedRecipientLastName = _data["reformattedRecipientLastName"];
      this.reformattedRecipientSuffixClassificationValueId = _data["reformattedRecipientSuffixClassificationValueId"];
      this.reformattedRecipientCompanyName = _data["reformattedRecipientCompanyName"];
      this.reformattedRecipientAddress1Text = _data["reformattedRecipientAddress1Text"];
      this.reformattedRecipientAddress2Text = _data["reformattedRecipientAddress2Text"];
      this.reformattedRecipientAddress3Text = _data["reformattedRecipientAddress3Text"];
      this.reformattedRecipientAddress4Text = _data["reformattedRecipientAddress4Text"];
      this.reformattedRecipientCityName = _data["reformattedRecipientCityName"];
      this.reformattedRecipientZipCode = _data["reformattedRecipientZipCode"];
      this.reformattedRecipientStateCodeId = _data["reformattedRecipientStateCodeId"];
      this.reformattedRecipientCountryCodeId = _data["reformattedRecipientCountryCodeId"];
      this.requestorComment = _data["requestorComment"];
      this.srfAdverseEventFlag = _data["srfAdverseEventFlag"];
      this.srfAdverseEventComment = _data["srfAdverseEventComment"];
      this.optOutFlag = _data["optOutFlag"];
      this.ohioTDDDExemptionFlag = _data["ohioTDDDExemptionFlag"];
      this.scheduledShipDate = _data["scheduledShipDate"] ? new Date(_data["scheduledShipDate"].toString()) : <any>undefined;
      this.scheduledDeliveryDate = _data["scheduledDeliveryDate"] ? new Date(_data["scheduledDeliveryDate"].toString()) : <any>undefined;
      this.desiredDeliveryDate = _data["desiredDeliveryDate"] ? new Date(_data["desiredDeliveryDate"].toString()) : <any>undefined;
      this.anticipatedLatestDeliveryDate = _data["anticipatedLatestDeliveryDate"] ? new Date(_data["anticipatedLatestDeliveryDate"].toString()) : <any>undefined;
      this.anticipatedCarrierId = _data["anticipatedCarrierId"];
      this.anticipatedCarrierServiceTypeId = _data["anticipatedCarrierServiceTypeId"];
      this.wmsOrderType = _data["wmsOrderType"];
      this.cancellationInWmsRequestedByUserId = _data["cancellationInWmsRequestedByUserId"];
      this.cancellationInWmsRequestedTimestamp = _data["cancellationInWmsRequestedTimestamp"] ? new Date(_data["cancellationInWmsRequestedTimestamp"].toString()) : <any>undefined;
      this.noExceptionActionFlag = _data["noExceptionActionFlag"];
      this.formIdMissingFlag = _data["formIdMissingFlag"];
      this.formIdNotApplicableFlag = _data["formIdNotApplicableFlag"];
      this.formIdUnmatchedFlag = _data["formIdUnmatchedFlag"];
      this.anyDocBatchNumber = _data["anyDocBatchNumber"];
      this.anyDocBatchDateTime = _data["anyDocBatchDateTime"] ? new Date(_data["anyDocBatchDateTime"].toString()) : <any>undefined;
      this.anyDocFormFamily = _data["anyDocFormFamily"];
      this.anyDocTemplateName = _data["anyDocTemplateName"];
      this.openAocRulePassedTempFlag = _data["openAocRulePassedTempFlag"];
      this.exceededTerritoryAllocationRuleIsApplicapleFlag = _data["exceededTerritoryAllocationRuleIsApplicapleFlag"];
      this.exceededTerritoryAllocationRulePassedFlag = _data["exceededTerritoryAllocationRulePassedFlag"];
      this.exceededPractitionerAllocationRuleIsApplicapleFlag = _data["exceededPractitionerAllocationRuleIsApplicapleFlag"];
      this.exceededPractitionerAllocationRulePassedFlag = _data["exceededPractitionerAllocationRulePassedFlag"];
      this.firstAOCDateTime = _data["firstAOCDateTime"] ? new Date(_data["firstAOCDateTime"].toString()) : <any>undefined;
      this.secondAOCDateTime = _data["secondAOCDateTime"] ? new Date(_data["secondAOCDateTime"].toString()) : <any>undefined;
      this.thirdAOCDateTime = _data["thirdAOCDateTime"] ? new Date(_data["thirdAOCDateTime"].toString()) : <any>undefined;
      this.firstAOCSentDateTime = _data["firstAOCSentDateTime"] ? new Date(_data["firstAOCSentDateTime"].toString()) : <any>undefined;
      this.secondAOCSentDateTime = _data["secondAOCSentDateTime"] ? new Date(_data["secondAOCSentDateTime"].toString()) : <any>undefined;
      this.thirdAOCSentDateTime = _data["thirdAOCSentDateTime"] ? new Date(_data["thirdAOCSentDateTime"].toString()) : <any>undefined;
      this.svlGeneratedDateTime = _data["svlGeneratedDateTime"] ? new Date(_data["svlGeneratedDateTime"].toString()) : <any>undefined;
      this.generatedSvlType = _data["generatedSvlType"];
      this.externalClientId = _data["externalClientId"];
      this.externalOrderSfaId = _data["externalOrderSfaId"];
      if (Array.isArray(_data["acceptableDeliveryDays"])) {
        (<any>this).acceptableDeliveryDays = [] as any;
        for (let item of _data["acceptableDeliveryDays"])
          (<any>this).acceptableDeliveryDays.push(item);
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplOrder {
    data = typeof data === 'object' ? data : {};
    let result = new TplOrder();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hcpCouldNotBeReachedFlag"] = this.hcpCouldNotBeReachedFlag;
    data["hcpSignaturePresentFlag"] = this.hcpSignaturePresentFlag;
    data["hcpSignatureStampedFlag"] = this.hcpSignatureStampedFlag;
    data["hcpSignatureMatchFlag"] = this.hcpSignatureMatchFlag;
    data["hcpSignatureDateStampedFlag"] = this.hcpSignatureDateStampedFlag;
    data["hcpSignedDatePresentFlag"] = this.hcpSignedDatePresentFlag;
    data["hcpSignatureDate"] = this.hcpSignatureDate ? this.hcpSignatureDate.toISOString() : <any>undefined;
    data["hcpSignatureMissingFlag"] = this.hcpSignatureMissingFlag;
    data["hcpSignature"] = this.hcpSignature;
    data["exportToDynamicsPath"] = this.exportToDynamicsPath;
    data["asnFilePath"] = this.asnFilePath;
    data["somStatusCode"] = this.somStatusCode;
    data["isPriceCheckMitigated"] = this.isPriceCheckMitigated;
    data["isCreditCheckMitigated"] = this.isCreditCheckMitigated;
    data["externalBillingNbr"] = this.externalBillingNbr;
    data["exportOrderToDynamicsStatus"] = this.exportOrderToDynamicsStatus;
    data["exportOrderImportToDynamicsStatus"] = this.exportOrderImportToDynamicsStatus;
    data["orderType"] = this.orderType;
    data["department"] = this.department;
    data["dcNumber"] = this.dcNumber;
    data["shipmentPayment"] = this.shipmentPayment;
    data["poShipTo"] = this.poShipTo;
    data["orderCancellationReasonClassificationValueId"] = this.orderCancellationReasonClassificationValueId;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["externalOrderId"] = this.externalOrderId;
    data["externalFormId"] = this.externalFormId;
    data["wmsOrderId"] = this.wmsOrderId;
    data["mondayDeliveryFlag"] = this.mondayDeliveryFlag;
    data["tuesdayDeliveryFlag"] = this.tuesdayDeliveryFlag;
    data["wednesdayDeliveryFlag"] = this.wednesdayDeliveryFlag;
    data["thursdayDeliveryFlag"] = this.thursdayDeliveryFlag;
    data["fridayDeliveryFlag"] = this.fridayDeliveryFlag;
    data["saturdayDeliveryFlag"] = this.saturdayDeliveryFlag;
    data["sundayDeliveryFlag"] = this.sundayDeliveryFlag;
    data["missingFlag"] = this.missingFlag;
    data["reformattedRecipientFirstName"] = this.reformattedRecipientFirstName;
    data["reformattedRecipientMiddleName"] = this.reformattedRecipientMiddleName;
    data["reformattedRecipientLastName"] = this.reformattedRecipientLastName;
    data["reformattedRecipientSuffixClassificationValueId"] = this.reformattedRecipientSuffixClassificationValueId;
    data["reformattedRecipientCompanyName"] = this.reformattedRecipientCompanyName;
    data["reformattedRecipientAddress1Text"] = this.reformattedRecipientAddress1Text;
    data["reformattedRecipientAddress2Text"] = this.reformattedRecipientAddress2Text;
    data["reformattedRecipientAddress3Text"] = this.reformattedRecipientAddress3Text;
    data["reformattedRecipientAddress4Text"] = this.reformattedRecipientAddress4Text;
    data["reformattedRecipientCityName"] = this.reformattedRecipientCityName;
    data["reformattedRecipientZipCode"] = this.reformattedRecipientZipCode;
    data["reformattedRecipientStateCodeId"] = this.reformattedRecipientStateCodeId;
    data["reformattedRecipientCountryCodeId"] = this.reformattedRecipientCountryCodeId;
    data["requestorComment"] = this.requestorComment;
    data["srfAdverseEventFlag"] = this.srfAdverseEventFlag;
    data["srfAdverseEventComment"] = this.srfAdverseEventComment;
    data["optOutFlag"] = this.optOutFlag;
    data["ohioTDDDExemptionFlag"] = this.ohioTDDDExemptionFlag;
    data["scheduledShipDate"] = this.scheduledShipDate ? this.scheduledShipDate.toISOString() : <any>undefined;
    data["scheduledDeliveryDate"] = this.scheduledDeliveryDate ? this.scheduledDeliveryDate.toISOString() : <any>undefined;
    data["desiredDeliveryDate"] = this.desiredDeliveryDate ? this.desiredDeliveryDate.toISOString() : <any>undefined;
    data["anticipatedLatestDeliveryDate"] = this.anticipatedLatestDeliveryDate ? this.anticipatedLatestDeliveryDate.toISOString() : <any>undefined;
    data["anticipatedCarrierId"] = this.anticipatedCarrierId;
    data["anticipatedCarrierServiceTypeId"] = this.anticipatedCarrierServiceTypeId;
    data["wmsOrderType"] = this.wmsOrderType;
    data["cancellationInWmsRequestedByUserId"] = this.cancellationInWmsRequestedByUserId;
    data["cancellationInWmsRequestedTimestamp"] = this.cancellationInWmsRequestedTimestamp ? this.cancellationInWmsRequestedTimestamp.toISOString() : <any>undefined;
    data["noExceptionActionFlag"] = this.noExceptionActionFlag;
    data["formIdMissingFlag"] = this.formIdMissingFlag;
    data["formIdNotApplicableFlag"] = this.formIdNotApplicableFlag;
    data["formIdUnmatchedFlag"] = this.formIdUnmatchedFlag;
    data["anyDocBatchNumber"] = this.anyDocBatchNumber;
    data["anyDocBatchDateTime"] = this.anyDocBatchDateTime ? this.anyDocBatchDateTime.toISOString() : <any>undefined;
    data["anyDocFormFamily"] = this.anyDocFormFamily;
    data["anyDocTemplateName"] = this.anyDocTemplateName;
    data["openAocRulePassedTempFlag"] = this.openAocRulePassedTempFlag;
    data["exceededTerritoryAllocationRuleIsApplicapleFlag"] = this.exceededTerritoryAllocationRuleIsApplicapleFlag;
    data["exceededTerritoryAllocationRulePassedFlag"] = this.exceededTerritoryAllocationRulePassedFlag;
    data["exceededPractitionerAllocationRuleIsApplicapleFlag"] = this.exceededPractitionerAllocationRuleIsApplicapleFlag;
    data["exceededPractitionerAllocationRulePassedFlag"] = this.exceededPractitionerAllocationRulePassedFlag;
    data["firstAOCDateTime"] = this.firstAOCDateTime ? this.firstAOCDateTime.toISOString() : <any>undefined;
    data["secondAOCDateTime"] = this.secondAOCDateTime ? this.secondAOCDateTime.toISOString() : <any>undefined;
    data["thirdAOCDateTime"] = this.thirdAOCDateTime ? this.thirdAOCDateTime.toISOString() : <any>undefined;
    data["firstAOCSentDateTime"] = this.firstAOCSentDateTime ? this.firstAOCSentDateTime.toISOString() : <any>undefined;
    data["secondAOCSentDateTime"] = this.secondAOCSentDateTime ? this.secondAOCSentDateTime.toISOString() : <any>undefined;
    data["thirdAOCSentDateTime"] = this.thirdAOCSentDateTime ? this.thirdAOCSentDateTime.toISOString() : <any>undefined;
    data["svlGeneratedDateTime"] = this.svlGeneratedDateTime ? this.svlGeneratedDateTime.toISOString() : <any>undefined;
    data["generatedSvlType"] = this.generatedSvlType;
    data["externalClientId"] = this.externalClientId;
    data["externalOrderSfaId"] = this.externalOrderSfaId;
    if (Array.isArray(this.acceptableDeliveryDays)) {
      data["acceptableDeliveryDays"] = [];
      for (let item of this.acceptableDeliveryDays)
        data["acceptableDeliveryDays"].push(item);
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplOrder {
    const json = this.toJSON();
    let result = new TplOrder();
    result.init(json);
    return result;
  }
}

export interface ITplOrder {
  hcpCouldNotBeReachedFlag: boolean | undefined;
  hcpSignaturePresentFlag: boolean | undefined;
  hcpSignatureStampedFlag: boolean | undefined;
  hcpSignatureMatchFlag: boolean | undefined;
  hcpSignatureDateStampedFlag: boolean | undefined;
  hcpSignedDatePresentFlag: boolean | undefined;
  hcpSignatureDate: Date | undefined;
  hcpSignatureMissingFlag: boolean | undefined;
  hcpSignature: string | undefined;
  exportToDynamicsPath: string | undefined;
  asnFilePath: string | undefined;
  somStatusCode: string | undefined;
  isPriceCheckMitigated: boolean | undefined;
  isCreditCheckMitigated: boolean | undefined;
  externalBillingNbr: string | undefined;
  exportOrderToDynamicsStatus: number | undefined;
  exportOrderImportToDynamicsStatus: number | undefined;
  orderType: string | undefined;
  department: string | undefined;
  dcNumber: string | undefined;
  shipmentPayment: string | undefined;
  poShipTo: string | undefined;
  orderCancellationReasonClassificationValueId: string | undefined;
  order: Order | undefined;
  externalOrderId: string | undefined;
  externalFormId: string | undefined;
  wmsOrderId: string | undefined;
  mondayDeliveryFlag: boolean | undefined;
  tuesdayDeliveryFlag: boolean | undefined;
  wednesdayDeliveryFlag: boolean | undefined;
  thursdayDeliveryFlag: boolean | undefined;
  fridayDeliveryFlag: boolean | undefined;
  saturdayDeliveryFlag: boolean | undefined;
  sundayDeliveryFlag: boolean | undefined;
  missingFlag: boolean | undefined;
  reformattedRecipientFirstName: string | undefined;
  reformattedRecipientMiddleName: string | undefined;
  reformattedRecipientLastName: string | undefined;
  reformattedRecipientSuffixClassificationValueId: string | undefined;
  reformattedRecipientCompanyName: string | undefined;
  reformattedRecipientAddress1Text: string | undefined;
  reformattedRecipientAddress2Text: string | undefined;
  reformattedRecipientAddress3Text: string | undefined;
  reformattedRecipientAddress4Text: string | undefined;
  reformattedRecipientCityName: string | undefined;
  reformattedRecipientZipCode: string | undefined;
  reformattedRecipientStateCodeId: string | undefined;
  reformattedRecipientCountryCodeId: string | undefined;
  requestorComment: string | undefined;
  srfAdverseEventFlag: boolean | undefined;
  srfAdverseEventComment: string | undefined;
  optOutFlag: boolean | undefined;
  ohioTDDDExemptionFlag: boolean | undefined;
  scheduledShipDate: Date | undefined;
  scheduledDeliveryDate: Date | undefined;
  desiredDeliveryDate: Date | undefined;
  anticipatedLatestDeliveryDate: Date | undefined;
  anticipatedCarrierId: string | undefined;
  anticipatedCarrierServiceTypeId: string | undefined;
  wmsOrderType: string | undefined;
  cancellationInWmsRequestedByUserId: number | undefined;
  cancellationInWmsRequestedTimestamp: Date | undefined;
  noExceptionActionFlag: boolean | undefined;
  formIdMissingFlag: boolean | undefined;
  formIdNotApplicableFlag: boolean | undefined;
  formIdUnmatchedFlag: boolean | undefined;
  anyDocBatchNumber: string | undefined;
  anyDocBatchDateTime: Date | undefined;
  anyDocFormFamily: string | undefined;
  anyDocTemplateName: string | undefined;
  openAocRulePassedTempFlag: boolean | undefined;
  exceededTerritoryAllocationRuleIsApplicapleFlag: boolean | undefined;
  exceededTerritoryAllocationRulePassedFlag: boolean | undefined;
  exceededPractitionerAllocationRuleIsApplicapleFlag: boolean | undefined;
  exceededPractitionerAllocationRulePassedFlag: boolean | undefined;
  firstAOCDateTime: Date | undefined;
  secondAOCDateTime: Date | undefined;
  thirdAOCDateTime: Date | undefined;
  firstAOCSentDateTime: Date | undefined;
  secondAOCSentDateTime: Date | undefined;
  thirdAOCSentDateTime: Date | undefined;
  svlGeneratedDateTime: Date | undefined;
  generatedSvlType: string | undefined;
  externalClientId: string | undefined;
  externalOrderSfaId: string | undefined;
  acceptableDeliveryDays: AcceptableDeliveryDays[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class FgOrder implements IFgOrder {
  recipientPharmacy: Pharmacy | undefined;
  affiliatedHospital: Hospital | undefined;
  pharmacyId: string | undefined;
  hospitalId: string | undefined;
  pharmacistCouldNotBeReachedFlag: boolean | undefined;
  hcps: FgOrderHcp[] | undefined;
  pharmacyContactFirstName: string | undefined;
  pharmacyContactLastName: string | undefined;
  pharmacyContactEmail: string | undefined;
  pharmacyContactPhone: string | undefined;
  pharmacyContactFax: string | undefined;
  order: Order | undefined;
  externalOrderId: string | undefined;
  externalFormId: string | undefined;
  wmsOrderId: string | undefined;
  mondayDeliveryFlag: boolean | undefined;
  tuesdayDeliveryFlag: boolean | undefined;
  wednesdayDeliveryFlag: boolean | undefined;
  thursdayDeliveryFlag: boolean | undefined;
  fridayDeliveryFlag: boolean | undefined;
  saturdayDeliveryFlag: boolean | undefined;
  sundayDeliveryFlag: boolean | undefined;
  missingFlag: boolean | undefined;
  reformattedRecipientFirstName: string | undefined;
  reformattedRecipientMiddleName: string | undefined;
  reformattedRecipientLastName: string | undefined;
  reformattedRecipientSuffixClassificationValueId: string | undefined;
  reformattedRecipientCompanyName: string | undefined;
  reformattedRecipientAddress1Text: string | undefined;
  reformattedRecipientAddress2Text: string | undefined;
  reformattedRecipientAddress3Text: string | undefined;
  reformattedRecipientAddress4Text: string | undefined;
  reformattedRecipientCityName: string | undefined;
  reformattedRecipientZipCode: string | undefined;
  reformattedRecipientStateCodeId: string | undefined;
  reformattedRecipientCountryCodeId: string | undefined;
  requestorComment: string | undefined;
  srfAdverseEventFlag: boolean | undefined;
  srfAdverseEventComment: string | undefined;
  optOutFlag: boolean | undefined;
  ohioTDDDExemptionFlag: boolean | undefined;
  scheduledShipDate: Date | undefined;
  scheduledDeliveryDate: Date | undefined;
  desiredDeliveryDate: Date | undefined;
  anticipatedLatestDeliveryDate: Date | undefined;
  anticipatedCarrierId: string | undefined;
  anticipatedCarrierServiceTypeId: string | undefined;
  wmsOrderType: string | undefined;
  cancellationInWmsRequestedByUserId: number | undefined;
  cancellationInWmsRequestedTimestamp: Date | undefined;
  noExceptionActionFlag: boolean | undefined;
  formIdMissingFlag: boolean | undefined;
  formIdNotApplicableFlag: boolean | undefined;
  formIdUnmatchedFlag: boolean | undefined;
  anyDocBatchNumber: string | undefined;
  anyDocBatchDateTime: Date | undefined;
  anyDocFormFamily: string | undefined;
  anyDocTemplateName: string | undefined;
  openAocRulePassedTempFlag: boolean | undefined;
  exceededTerritoryAllocationRuleIsApplicapleFlag: boolean | undefined;
  exceededTerritoryAllocationRulePassedFlag: boolean | undefined;
  exceededPractitionerAllocationRuleIsApplicapleFlag: boolean | undefined;
  exceededPractitionerAllocationRulePassedFlag: boolean | undefined;
  firstAOCDateTime: Date | undefined;
  secondAOCDateTime: Date | undefined;
  thirdAOCDateTime: Date | undefined;
  firstAOCSentDateTime: Date | undefined;
  secondAOCSentDateTime: Date | undefined;
  thirdAOCSentDateTime: Date | undefined;
  svlGeneratedDateTime: Date | undefined;
  generatedSvlType: string | undefined;
  externalClientId: string | undefined;
  externalOrderSfaId: string | undefined;
  readonly acceptableDeliveryDays: acceptableDeliveryDays[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IFgOrder) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.recipientPharmacy = _data["recipientPharmacy"] ? Pharmacy.fromJS(_data["recipientPharmacy"]) : <any>undefined;
      this.affiliatedHospital = _data["affiliatedHospital"] ? Hospital.fromJS(_data["affiliatedHospital"]) : <any>undefined;
      this.pharmacyId = _data["pharmacyId"];
      this.hospitalId = _data["hospitalId"];
      this.pharmacistCouldNotBeReachedFlag = _data["pharmacistCouldNotBeReachedFlag"];
      if (Array.isArray(_data["hcps"])) {
        this.hcps = [] as any;
        for (let item of _data["hcps"])
          this.hcps.push(FgOrderHcp.fromJS(item));
      }
      this.pharmacyContactFirstName = _data["pharmacyContactFirstName"];
      this.pharmacyContactLastName = _data["pharmacyContactLastName"];
      this.pharmacyContactEmail = _data["pharmacyContactEmail"];
      this.pharmacyContactPhone = _data["pharmacyContactPhone"];
      this.pharmacyContactFax = _data["pharmacyContactFax"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.externalOrderId = _data["externalOrderId"];
      this.externalFormId = _data["externalFormId"];
      this.wmsOrderId = _data["wmsOrderId"];
      this.mondayDeliveryFlag = _data["mondayDeliveryFlag"];
      this.tuesdayDeliveryFlag = _data["tuesdayDeliveryFlag"];
      this.wednesdayDeliveryFlag = _data["wednesdayDeliveryFlag"];
      this.thursdayDeliveryFlag = _data["thursdayDeliveryFlag"];
      this.fridayDeliveryFlag = _data["fridayDeliveryFlag"];
      this.saturdayDeliveryFlag = _data["saturdayDeliveryFlag"];
      this.sundayDeliveryFlag = _data["sundayDeliveryFlag"];
      this.missingFlag = _data["missingFlag"];
      this.reformattedRecipientFirstName = _data["reformattedRecipientFirstName"];
      this.reformattedRecipientMiddleName = _data["reformattedRecipientMiddleName"];
      this.reformattedRecipientLastName = _data["reformattedRecipientLastName"];
      this.reformattedRecipientSuffixClassificationValueId = _data["reformattedRecipientSuffixClassificationValueId"];
      this.reformattedRecipientCompanyName = _data["reformattedRecipientCompanyName"];
      this.reformattedRecipientAddress1Text = _data["reformattedRecipientAddress1Text"];
      this.reformattedRecipientAddress2Text = _data["reformattedRecipientAddress2Text"];
      this.reformattedRecipientAddress3Text = _data["reformattedRecipientAddress3Text"];
      this.reformattedRecipientAddress4Text = _data["reformattedRecipientAddress4Text"];
      this.reformattedRecipientCityName = _data["reformattedRecipientCityName"];
      this.reformattedRecipientZipCode = _data["reformattedRecipientZipCode"];
      this.reformattedRecipientStateCodeId = _data["reformattedRecipientStateCodeId"];
      this.reformattedRecipientCountryCodeId = _data["reformattedRecipientCountryCodeId"];
      this.requestorComment = _data["requestorComment"];
      this.srfAdverseEventFlag = _data["srfAdverseEventFlag"];
      this.srfAdverseEventComment = _data["srfAdverseEventComment"];
      this.optOutFlag = _data["optOutFlag"];
      this.ohioTDDDExemptionFlag = _data["ohioTDDDExemptionFlag"];
      this.scheduledShipDate = _data["scheduledShipDate"] ? new Date(_data["scheduledShipDate"].toString()) : <any>undefined;
      this.scheduledDeliveryDate = _data["scheduledDeliveryDate"] ? new Date(_data["scheduledDeliveryDate"].toString()) : <any>undefined;
      this.desiredDeliveryDate = _data["desiredDeliveryDate"] ? new Date(_data["desiredDeliveryDate"].toString()) : <any>undefined;
      this.anticipatedLatestDeliveryDate = _data["anticipatedLatestDeliveryDate"] ? new Date(_data["anticipatedLatestDeliveryDate"].toString()) : <any>undefined;
      this.anticipatedCarrierId = _data["anticipatedCarrierId"];
      this.anticipatedCarrierServiceTypeId = _data["anticipatedCarrierServiceTypeId"];
      this.wmsOrderType = _data["wmsOrderType"];
      this.cancellationInWmsRequestedByUserId = _data["cancellationInWmsRequestedByUserId"];
      this.cancellationInWmsRequestedTimestamp = _data["cancellationInWmsRequestedTimestamp"] ? new Date(_data["cancellationInWmsRequestedTimestamp"].toString()) : <any>undefined;
      this.noExceptionActionFlag = _data["noExceptionActionFlag"];
      this.formIdMissingFlag = _data["formIdMissingFlag"];
      this.formIdNotApplicableFlag = _data["formIdNotApplicableFlag"];
      this.formIdUnmatchedFlag = _data["formIdUnmatchedFlag"];
      this.anyDocBatchNumber = _data["anyDocBatchNumber"];
      this.anyDocBatchDateTime = _data["anyDocBatchDateTime"] ? new Date(_data["anyDocBatchDateTime"].toString()) : <any>undefined;
      this.anyDocFormFamily = _data["anyDocFormFamily"];
      this.anyDocTemplateName = _data["anyDocTemplateName"];
      this.openAocRulePassedTempFlag = _data["openAocRulePassedTempFlag"];
      this.exceededTerritoryAllocationRuleIsApplicapleFlag = _data["exceededTerritoryAllocationRuleIsApplicapleFlag"];
      this.exceededTerritoryAllocationRulePassedFlag = _data["exceededTerritoryAllocationRulePassedFlag"];
      this.exceededPractitionerAllocationRuleIsApplicapleFlag = _data["exceededPractitionerAllocationRuleIsApplicapleFlag"];
      this.exceededPractitionerAllocationRulePassedFlag = _data["exceededPractitionerAllocationRulePassedFlag"];
      this.firstAOCDateTime = _data["firstAOCDateTime"] ? new Date(_data["firstAOCDateTime"].toString()) : <any>undefined;
      this.secondAOCDateTime = _data["secondAOCDateTime"] ? new Date(_data["secondAOCDateTime"].toString()) : <any>undefined;
      this.thirdAOCDateTime = _data["thirdAOCDateTime"] ? new Date(_data["thirdAOCDateTime"].toString()) : <any>undefined;
      this.firstAOCSentDateTime = _data["firstAOCSentDateTime"] ? new Date(_data["firstAOCSentDateTime"].toString()) : <any>undefined;
      this.secondAOCSentDateTime = _data["secondAOCSentDateTime"] ? new Date(_data["secondAOCSentDateTime"].toString()) : <any>undefined;
      this.thirdAOCSentDateTime = _data["thirdAOCSentDateTime"] ? new Date(_data["thirdAOCSentDateTime"].toString()) : <any>undefined;
      this.svlGeneratedDateTime = _data["svlGeneratedDateTime"] ? new Date(_data["svlGeneratedDateTime"].toString()) : <any>undefined;
      this.generatedSvlType = _data["generatedSvlType"];
      this.externalClientId = _data["externalClientId"];
      this.externalOrderSfaId = _data["externalOrderSfaId"];
      if (Array.isArray(_data["acceptableDeliveryDays"])) {
        (<any>this).acceptableDeliveryDays = [] as any;
        for (let item of _data["acceptableDeliveryDays"])
          (<any>this).acceptableDeliveryDays.push(item);
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): FgOrder {
    data = typeof data === 'object' ? data : {};
    let result = new FgOrder();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["recipientPharmacy"] = this.recipientPharmacy ? this.recipientPharmacy.toJSON() : <any>undefined;
    data["affiliatedHospital"] = this.affiliatedHospital ? this.affiliatedHospital.toJSON() : <any>undefined;
    data["pharmacyId"] = this.pharmacyId;
    data["hospitalId"] = this.hospitalId;
    data["pharmacistCouldNotBeReachedFlag"] = this.pharmacistCouldNotBeReachedFlag;
    if (Array.isArray(this.hcps)) {
      data["hcps"] = [];
      for (let item of this.hcps)
        data["hcps"].push(item.toJSON());
    }
    data["pharmacyContactFirstName"] = this.pharmacyContactFirstName;
    data["pharmacyContactLastName"] = this.pharmacyContactLastName;
    data["pharmacyContactEmail"] = this.pharmacyContactEmail;
    data["pharmacyContactPhone"] = this.pharmacyContactPhone;
    data["pharmacyContactFax"] = this.pharmacyContactFax;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["externalOrderId"] = this.externalOrderId;
    data["externalFormId"] = this.externalFormId;
    data["wmsOrderId"] = this.wmsOrderId;
    data["mondayDeliveryFlag"] = this.mondayDeliveryFlag;
    data["tuesdayDeliveryFlag"] = this.tuesdayDeliveryFlag;
    data["wednesdayDeliveryFlag"] = this.wednesdayDeliveryFlag;
    data["thursdayDeliveryFlag"] = this.thursdayDeliveryFlag;
    data["fridayDeliveryFlag"] = this.fridayDeliveryFlag;
    data["saturdayDeliveryFlag"] = this.saturdayDeliveryFlag;
    data["sundayDeliveryFlag"] = this.sundayDeliveryFlag;
    data["missingFlag"] = this.missingFlag;
    data["reformattedRecipientFirstName"] = this.reformattedRecipientFirstName;
    data["reformattedRecipientMiddleName"] = this.reformattedRecipientMiddleName;
    data["reformattedRecipientLastName"] = this.reformattedRecipientLastName;
    data["reformattedRecipientSuffixClassificationValueId"] = this.reformattedRecipientSuffixClassificationValueId;
    data["reformattedRecipientCompanyName"] = this.reformattedRecipientCompanyName;
    data["reformattedRecipientAddress1Text"] = this.reformattedRecipientAddress1Text;
    data["reformattedRecipientAddress2Text"] = this.reformattedRecipientAddress2Text;
    data["reformattedRecipientAddress3Text"] = this.reformattedRecipientAddress3Text;
    data["reformattedRecipientAddress4Text"] = this.reformattedRecipientAddress4Text;
    data["reformattedRecipientCityName"] = this.reformattedRecipientCityName;
    data["reformattedRecipientZipCode"] = this.reformattedRecipientZipCode;
    data["reformattedRecipientStateCodeId"] = this.reformattedRecipientStateCodeId;
    data["reformattedRecipientCountryCodeId"] = this.reformattedRecipientCountryCodeId;
    data["requestorComment"] = this.requestorComment;
    data["srfAdverseEventFlag"] = this.srfAdverseEventFlag;
    data["srfAdverseEventComment"] = this.srfAdverseEventComment;
    data["optOutFlag"] = this.optOutFlag;
    data["ohioTDDDExemptionFlag"] = this.ohioTDDDExemptionFlag;
    data["scheduledShipDate"] = this.scheduledShipDate ? this.scheduledShipDate.toISOString() : <any>undefined;
    data["scheduledDeliveryDate"] = this.scheduledDeliveryDate ? this.scheduledDeliveryDate.toISOString() : <any>undefined;
    data["desiredDeliveryDate"] = this.desiredDeliveryDate ? this.desiredDeliveryDate.toISOString() : <any>undefined;
    data["anticipatedLatestDeliveryDate"] = this.anticipatedLatestDeliveryDate ? this.anticipatedLatestDeliveryDate.toISOString() : <any>undefined;
    data["anticipatedCarrierId"] = this.anticipatedCarrierId;
    data["anticipatedCarrierServiceTypeId"] = this.anticipatedCarrierServiceTypeId;
    data["wmsOrderType"] = this.wmsOrderType;
    data["cancellationInWmsRequestedByUserId"] = this.cancellationInWmsRequestedByUserId;
    data["cancellationInWmsRequestedTimestamp"] = this.cancellationInWmsRequestedTimestamp ? this.cancellationInWmsRequestedTimestamp.toISOString() : <any>undefined;
    data["noExceptionActionFlag"] = this.noExceptionActionFlag;
    data["formIdMissingFlag"] = this.formIdMissingFlag;
    data["formIdNotApplicableFlag"] = this.formIdNotApplicableFlag;
    data["formIdUnmatchedFlag"] = this.formIdUnmatchedFlag;
    data["anyDocBatchNumber"] = this.anyDocBatchNumber;
    data["anyDocBatchDateTime"] = this.anyDocBatchDateTime ? this.anyDocBatchDateTime.toISOString() : <any>undefined;
    data["anyDocFormFamily"] = this.anyDocFormFamily;
    data["anyDocTemplateName"] = this.anyDocTemplateName;
    data["openAocRulePassedTempFlag"] = this.openAocRulePassedTempFlag;
    data["exceededTerritoryAllocationRuleIsApplicapleFlag"] = this.exceededTerritoryAllocationRuleIsApplicapleFlag;
    data["exceededTerritoryAllocationRulePassedFlag"] = this.exceededTerritoryAllocationRulePassedFlag;
    data["exceededPractitionerAllocationRuleIsApplicapleFlag"] = this.exceededPractitionerAllocationRuleIsApplicapleFlag;
    data["exceededPractitionerAllocationRulePassedFlag"] = this.exceededPractitionerAllocationRulePassedFlag;
    data["firstAOCDateTime"] = this.firstAOCDateTime ? this.firstAOCDateTime.toISOString() : <any>undefined;
    data["secondAOCDateTime"] = this.secondAOCDateTime ? this.secondAOCDateTime.toISOString() : <any>undefined;
    data["thirdAOCDateTime"] = this.thirdAOCDateTime ? this.thirdAOCDateTime.toISOString() : <any>undefined;
    data["firstAOCSentDateTime"] = this.firstAOCSentDateTime ? this.firstAOCSentDateTime.toISOString() : <any>undefined;
    data["secondAOCSentDateTime"] = this.secondAOCSentDateTime ? this.secondAOCSentDateTime.toISOString() : <any>undefined;
    data["thirdAOCSentDateTime"] = this.thirdAOCSentDateTime ? this.thirdAOCSentDateTime.toISOString() : <any>undefined;
    data["svlGeneratedDateTime"] = this.svlGeneratedDateTime ? this.svlGeneratedDateTime.toISOString() : <any>undefined;
    data["generatedSvlType"] = this.generatedSvlType;
    data["externalClientId"] = this.externalClientId;
    data["externalOrderSfaId"] = this.externalOrderSfaId;
    if (Array.isArray(this.acceptableDeliveryDays)) {
      data["acceptableDeliveryDays"] = [];
      for (let item of this.acceptableDeliveryDays)
        data["acceptableDeliveryDays"].push(item);
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): FgOrder {
    const json = this.toJSON();
    let result = new FgOrder();
    result.init(json);
    return result;
  }
}

export interface IFgOrder {
  recipientPharmacy: Pharmacy | undefined;
  affiliatedHospital: Hospital | undefined;
  pharmacyId: string | undefined;
  hospitalId: string | undefined;
  pharmacistCouldNotBeReachedFlag: boolean | undefined;
  hcps: FgOrderHcp[] | undefined;
  pharmacyContactFirstName: string | undefined;
  pharmacyContactLastName: string | undefined;
  pharmacyContactEmail: string | undefined;
  pharmacyContactPhone: string | undefined;
  pharmacyContactFax: string | undefined;
  order: Order | undefined;
  externalOrderId: string | undefined;
  externalFormId: string | undefined;
  wmsOrderId: string | undefined;
  mondayDeliveryFlag: boolean | undefined;
  tuesdayDeliveryFlag: boolean | undefined;
  wednesdayDeliveryFlag: boolean | undefined;
  thursdayDeliveryFlag: boolean | undefined;
  fridayDeliveryFlag: boolean | undefined;
  saturdayDeliveryFlag: boolean | undefined;
  sundayDeliveryFlag: boolean | undefined;
  missingFlag: boolean | undefined;
  reformattedRecipientFirstName: string | undefined;
  reformattedRecipientMiddleName: string | undefined;
  reformattedRecipientLastName: string | undefined;
  reformattedRecipientSuffixClassificationValueId: string | undefined;
  reformattedRecipientCompanyName: string | undefined;
  reformattedRecipientAddress1Text: string | undefined;
  reformattedRecipientAddress2Text: string | undefined;
  reformattedRecipientAddress3Text: string | undefined;
  reformattedRecipientAddress4Text: string | undefined;
  reformattedRecipientCityName: string | undefined;
  reformattedRecipientZipCode: string | undefined;
  reformattedRecipientStateCodeId: string | undefined;
  reformattedRecipientCountryCodeId: string | undefined;
  requestorComment: string | undefined;
  srfAdverseEventFlag: boolean | undefined;
  srfAdverseEventComment: string | undefined;
  optOutFlag: boolean | undefined;
  ohioTDDDExemptionFlag: boolean | undefined;
  scheduledShipDate: Date | undefined;
  scheduledDeliveryDate: Date | undefined;
  desiredDeliveryDate: Date | undefined;
  anticipatedLatestDeliveryDate: Date | undefined;
  anticipatedCarrierId: string | undefined;
  anticipatedCarrierServiceTypeId: string | undefined;
  wmsOrderType: string | undefined;
  cancellationInWmsRequestedByUserId: number | undefined;
  cancellationInWmsRequestedTimestamp: Date | undefined;
  noExceptionActionFlag: boolean | undefined;
  formIdMissingFlag: boolean | undefined;
  formIdNotApplicableFlag: boolean | undefined;
  formIdUnmatchedFlag: boolean | undefined;
  anyDocBatchNumber: string | undefined;
  anyDocBatchDateTime: Date | undefined;
  anyDocFormFamily: string | undefined;
  anyDocTemplateName: string | undefined;
  openAocRulePassedTempFlag: boolean | undefined;
  exceededTerritoryAllocationRuleIsApplicapleFlag: boolean | undefined;
  exceededTerritoryAllocationRulePassedFlag: boolean | undefined;
  exceededPractitionerAllocationRuleIsApplicapleFlag: boolean | undefined;
  exceededPractitionerAllocationRulePassedFlag: boolean | undefined;
  firstAOCDateTime: Date | undefined;
  secondAOCDateTime: Date | undefined;
  thirdAOCDateTime: Date | undefined;
  firstAOCSentDateTime: Date | undefined;
  secondAOCSentDateTime: Date | undefined;
  thirdAOCSentDateTime: Date | undefined;
  svlGeneratedDateTime: Date | undefined;
  generatedSvlType: string | undefined;
  externalClientId: string | undefined;
  externalOrderSfaId: string | undefined;
  acceptableDeliveryDays: acceptableDeliveryDays[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ReferencedClassification implements IReferencedClassification {
  code: string | undefined;
  name: string | undefined;
  originatingSchema: string | undefined;
  originatingTable: string | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IReferencedClassification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.name = _data["name"];
      this.originatingSchema = _data["originatingSchema"];
      this.originatingTable = _data["originatingTable"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ReferencedClassification {
    data = typeof data === 'object' ? data : {};
    let result = new ReferencedClassification();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["code"] = this.code;
    data["name"] = this.name;
    data["originatingSchema"] = this.originatingSchema;
    data["originatingTable"] = this.originatingTable;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ReferencedClassification {
    const json = this.toJSON();
    let result = new ReferencedClassification();
    result.init(json);
    return result;
  }
}

export interface IReferencedClassification {
  code: string | undefined;
  name: string | undefined;
  originatingSchema: string | undefined;
  originatingTable: string | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PatientOrder implements IPatientOrder {
  patientFirstName: string | undefined;
  patientLastName: string | undefined;
  patientAddressLine1: string | undefined;
  patientAddressLine2: string | undefined;
  patientCity: string | undefined;
  patientState: string | undefined;
  patientZipCode: string | undefined;
  patientPhone: string | undefined;
  patientDateOfBirth: string | undefined;
  directToPatientConsent: string | undefined;
  patientReceiptConsent: string | undefined;
  patientId: string | undefined;
  order: Order | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPatientOrder) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.patientFirstName = _data["patientFirstName"];
      this.patientLastName = _data["patientLastName"];
      this.patientAddressLine1 = _data["patientAddressLine1"];
      this.patientAddressLine2 = _data["patientAddressLine2"];
      this.patientCity = _data["patientCity"];
      this.patientState = _data["patientState"];
      this.patientZipCode = _data["patientZipCode"];
      this.patientPhone = _data["patientPhone"];
      this.patientDateOfBirth = _data["patientDateOfBirth"];
      this.directToPatientConsent = _data["directToPatientConsent"];
      this.patientReceiptConsent = _data["patientReceiptConsent"];
      this.patientId = _data["patientId"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PatientOrder {
    data = typeof data === 'object' ? data : {};
    let result = new PatientOrder();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["patientFirstName"] = this.patientFirstName;
    data["patientLastName"] = this.patientLastName;
    data["patientAddressLine1"] = this.patientAddressLine1;
    data["patientAddressLine2"] = this.patientAddressLine2;
    data["patientCity"] = this.patientCity;
    data["patientState"] = this.patientState;
    data["patientZipCode"] = this.patientZipCode;
    data["patientPhone"] = this.patientPhone;
    data["patientDateOfBirth"] = this.patientDateOfBirth;
    data["directToPatientConsent"] = this.directToPatientConsent;
    data["patientReceiptConsent"] = this.patientReceiptConsent;
    data["patientId"] = this.patientId;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PatientOrder {
    const json = this.toJSON();
    let result = new PatientOrder();
    result.init(json);
    return result;
  }
}

export interface IPatientOrder {
  patientFirstName: string | undefined;
  patientLastName: string | undefined;
  patientAddressLine1: string | undefined;
  patientAddressLine2: string | undefined;
  patientCity: string | undefined;
  patientState: string | undefined;
  patientZipCode: string | undefined;
  patientPhone: string | undefined;
  patientDateOfBirth: string | undefined;
  directToPatientConsent: string | undefined;
  patientReceiptConsent: string | undefined;
  patientId: string | undefined;
  order: Order | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Customer implements ICustomer {
  isActive: boolean | undefined;
  customerTypeClassificationValueId: string | undefined;
  customerAccountNbr: string | undefined;
  customerName: string | undefined;
  invoiceAccountNumber: string | undefined;
  primaryContactEmail: string | undefined;
  customerClassificationId: string | undefined;
  customerGroupId: string | undefined;
  lineOfBusinessCode: string | undefined;
  paymentTermsCode: string | undefined;
  paymentMethodCode: string | undefined;
  lineDiscountGroup: string | undefined;
  multilineDiscountGroup: string | undefined;
  totalDiscountGroup: string | undefined;
  priceGroup: string | undefined;
  clientCustomerNumber: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ICustomer) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isActive = _data["isActive"];
      this.customerTypeClassificationValueId = _data["customerTypeClassificationValueId"];
      this.customerAccountNbr = _data["customerAccountNbr"];
      this.customerName = _data["customerName"];
      this.invoiceAccountNumber = _data["invoiceAccountNumber"];
      this.primaryContactEmail = _data["primaryContactEmail"];
      this.customerClassificationId = _data["customerClassificationId"];
      this.customerGroupId = _data["customerGroupId"];
      this.lineOfBusinessCode = _data["lineOfBusinessCode"];
      this.paymentTermsCode = _data["paymentTermsCode"];
      this.paymentMethodCode = _data["paymentMethodCode"];
      this.lineDiscountGroup = _data["lineDiscountGroup"];
      this.multilineDiscountGroup = _data["multilineDiscountGroup"];
      this.totalDiscountGroup = _data["totalDiscountGroup"];
      this.priceGroup = _data["priceGroup"];
      this.clientCustomerNumber = _data["clientCustomerNumber"];
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Customer {
    data = typeof data === 'object' ? data : {};
    let result = new Customer();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isActive"] = this.isActive;
    data["customerTypeClassificationValueId"] = this.customerTypeClassificationValueId;
    data["customerAccountNbr"] = this.customerAccountNbr;
    data["customerName"] = this.customerName;
    data["invoiceAccountNumber"] = this.invoiceAccountNumber;
    data["primaryContactEmail"] = this.primaryContactEmail;
    data["customerClassificationId"] = this.customerClassificationId;
    data["customerGroupId"] = this.customerGroupId;
    data["lineOfBusinessCode"] = this.lineOfBusinessCode;
    data["paymentTermsCode"] = this.paymentTermsCode;
    data["paymentMethodCode"] = this.paymentMethodCode;
    data["lineDiscountGroup"] = this.lineDiscountGroup;
    data["multilineDiscountGroup"] = this.multilineDiscountGroup;
    data["totalDiscountGroup"] = this.totalDiscountGroup;
    data["priceGroup"] = this.priceGroup;
    data["clientCustomerNumber"] = this.clientCustomerNumber;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Customer {
    const json = this.toJSON();
    let result = new Customer();
    result.init(json);
    return result;
  }
}

export interface ICustomer {
  isActive: boolean | undefined;
  customerTypeClassificationValueId: string | undefined;
  customerAccountNbr: string | undefined;
  customerName: string | undefined;
  invoiceAccountNumber: string | undefined;
  primaryContactEmail: string | undefined;
  customerClassificationId: string | undefined;
  customerGroupId: string | undefined;
  lineOfBusinessCode: string | undefined;
  paymentTermsCode: string | undefined;
  paymentMethodCode: string | undefined;
  lineDiscountGroup: string | undefined;
  multilineDiscountGroup: string | undefined;
  totalDiscountGroup: string | undefined;
  priceGroup: string | undefined;
  clientCustomerNumber: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ValidationFailure implements IValidationFailure {
  propertyName: string | undefined;
  errorMessage: string | undefined;
  attemptedValue: any | undefined;
  customState: any | undefined;
  severity: ValidationFailureSeverity | undefined;
  errorCode: string | undefined;
  formattedMessageArguments: any[] | undefined;
  formattedMessagePlaceholderValues: { [key: string]: any; } | undefined;
  resourceName: string | undefined;

  constructor(data?: IValidationFailure) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.propertyName = _data["propertyName"];
      this.errorMessage = _data["errorMessage"];
      this.attemptedValue = _data["attemptedValue"];
      this.customState = _data["customState"];
      this.severity = _data["severity"];
      this.errorCode = _data["errorCode"];
      if (Array.isArray(_data["formattedMessageArguments"])) {
        this.formattedMessageArguments = [] as any;
        for (let item of _data["formattedMessageArguments"])
          this.formattedMessageArguments.push(item);
      }
      if (_data["formattedMessagePlaceholderValues"]) {
        this.formattedMessagePlaceholderValues = {} as any;
        for (let key in _data["formattedMessagePlaceholderValues"]) {
          if (_data["formattedMessagePlaceholderValues"].hasOwnProperty(key))
            (<any>this.formattedMessagePlaceholderValues)[key] = _data["formattedMessagePlaceholderValues"][key];
        }
      }
      this.resourceName = _data["resourceName"];
    }
  }

  static fromJS(data: any): ValidationFailure {
    data = typeof data === 'object' ? data : {};
    let result = new ValidationFailure();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["propertyName"] = this.propertyName;
    data["errorMessage"] = this.errorMessage;
    data["attemptedValue"] = this.attemptedValue;
    data["customState"] = this.customState;
    data["severity"] = this.severity;
    data["errorCode"] = this.errorCode;
    if (Array.isArray(this.formattedMessageArguments)) {
      data["formattedMessageArguments"] = [];
      for (let item of this.formattedMessageArguments)
        data["formattedMessageArguments"].push(item);
    }
    if (this.formattedMessagePlaceholderValues) {
      data["formattedMessagePlaceholderValues"] = {};
      for (let key in this.formattedMessagePlaceholderValues) {
        if (this.formattedMessagePlaceholderValues.hasOwnProperty(key))
          (<any>data["formattedMessagePlaceholderValues"])[key] = (<any>this.formattedMessagePlaceholderValues)[key];
      }
    }
    data["resourceName"] = this.resourceName;
    return data;
  }

  clone(): ValidationFailure {
    const json = this.toJSON();
    let result = new ValidationFailure();
    result.init(json);
    return result;
  }
}

export interface IValidationFailure {
  propertyName: string | undefined;
  errorMessage: string | undefined;
  attemptedValue: any | undefined;
  customState: any | undefined;
  severity: ValidationFailureSeverity | undefined;
  errorCode: string | undefined;
  formattedMessageArguments: any[] | undefined;
  formattedMessagePlaceholderValues: { [key: string]: any; } | undefined;
  resourceName: string | undefined;
}

export class TerritoryZipCoverage implements ITerritoryZipCoverage {
  territoryId: string | undefined;
  zipCode: string | undefined;
  brandCodesJson: string | undefined;
  territory: Territory | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITerritoryZipCoverage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.territoryId = _data["territoryId"];
      this.zipCode = _data["zipCode"];
      this.brandCodesJson = _data["brandCodesJson"];
      this.territory = _data["territory"] ? Territory.fromJS(_data["territory"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TerritoryZipCoverage {
    data = typeof data === 'object' ? data : {};
    let result = new TerritoryZipCoverage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["territoryId"] = this.territoryId;
    data["zipCode"] = this.zipCode;
    data["brandCodesJson"] = this.brandCodesJson;
    data["territory"] = this.territory ? this.territory.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TerritoryZipCoverage {
    const json = this.toJSON();
    let result = new TerritoryZipCoverage();
    result.init(json);
    return result;
  }
}

export interface ITerritoryZipCoverage {
  territoryId: string | undefined;
  zipCode: string | undefined;
  brandCodesJson: string | undefined;
  territory: Territory | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class SalesRepTerritoryCoverage implements ISalesRepTerritoryCoverage {
  salesRepId: string | undefined;
  territoryId: string | undefined;
  salesRep: SalesRep | undefined;
  territory: Territory | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ISalesRepTerritoryCoverage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.salesRepId = _data["salesRepId"];
      this.territoryId = _data["territoryId"];
      this.salesRep = _data["salesRep"] ? SalesRep.fromJS(_data["salesRep"]) : <any>undefined;
      this.territory = _data["territory"] ? Territory.fromJS(_data["territory"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): SalesRepTerritoryCoverage {
    data = typeof data === 'object' ? data : {};
    let result = new SalesRepTerritoryCoverage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["salesRepId"] = this.salesRepId;
    data["territoryId"] = this.territoryId;
    data["salesRep"] = this.salesRep ? this.salesRep.toJSON() : <any>undefined;
    data["territory"] = this.territory ? this.territory.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): SalesRepTerritoryCoverage {
    const json = this.toJSON();
    let result = new SalesRepTerritoryCoverage();
    result.init(json);
    return result;
  }
}

export interface ISalesRepTerritoryCoverage {
  salesRepId: string | undefined;
  territoryId: string | undefined;
  salesRep: SalesRep | undefined;
  territory: Territory | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HcpContactMethod implements IHcpContactMethod {
  hcpId: string | undefined;
  hcpAddressId: string | undefined;
  contactMethodTypeId: string | undefined;
  contactDetailText: string | undefined;
  contactDetailExtensionText: string | undefined;
  knipperCreateFlag: boolean | undefined;
  primaryContactMethodFlag: boolean | undefined;
  hcp: Hcp | undefined;
  address: HcpAddress | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHcpContactMethod) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hcpId = _data["hcpId"];
      this.hcpAddressId = _data["hcpAddressId"];
      this.contactMethodTypeId = _data["contactMethodTypeId"];
      this.contactDetailText = _data["contactDetailText"];
      this.contactDetailExtensionText = _data["contactDetailExtensionText"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.primaryContactMethodFlag = _data["primaryContactMethodFlag"];
      this.hcp = _data["hcp"] ? Hcp.fromJS(_data["hcp"]) : <any>undefined;
      this.address = _data["address"] ? HcpAddress.fromJS(_data["address"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HcpContactMethod {
    data = typeof data === 'object' ? data : {};
    let result = new HcpContactMethod();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hcpId"] = this.hcpId;
    data["hcpAddressId"] = this.hcpAddressId;
    data["contactMethodTypeId"] = this.contactMethodTypeId;
    data["contactDetailText"] = this.contactDetailText;
    data["contactDetailExtensionText"] = this.contactDetailExtensionText;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["primaryContactMethodFlag"] = this.primaryContactMethodFlag;
    data["hcp"] = this.hcp ? this.hcp.toJSON() : <any>undefined;
    data["address"] = this.address ? this.address.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HcpContactMethod {
    const json = this.toJSON();
    let result = new HcpContactMethod();
    result.init(json);
    return result;
  }
}

export interface IHcpContactMethod {
  hcpId: string | undefined;
  hcpAddressId: string | undefined;
  contactMethodTypeId: string | undefined;
  contactDetailText: string | undefined;
  contactDetailExtensionText: string | undefined;
  knipperCreateFlag: boolean | undefined;
  primaryContactMethodFlag: boolean | undefined;
  hcp: Hcp | undefined;
  address: HcpAddress | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HcpProfessionalDesignation implements IHcpProfessionalDesignation {
  hcpId: string | undefined;
  professionalDesignationId: string | undefined;
  primaryFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  hcp: Hcp | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHcpProfessionalDesignation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hcpId = _data["hcpId"];
      this.professionalDesignationId = _data["professionalDesignationId"];
      this.primaryFlag = _data["primaryFlag"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.hcp = _data["hcp"] ? Hcp.fromJS(_data["hcp"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HcpProfessionalDesignation {
    data = typeof data === 'object' ? data : {};
    let result = new HcpProfessionalDesignation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hcpId"] = this.hcpId;
    data["professionalDesignationId"] = this.professionalDesignationId;
    data["primaryFlag"] = this.primaryFlag;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["hcp"] = this.hcp ? this.hcp.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HcpProfessionalDesignation {
    const json = this.toJSON();
    let result = new HcpProfessionalDesignation();
    result.init(json);
    return result;
  }
}

export interface IHcpProfessionalDesignation {
  hcpId: string | undefined;
  professionalDesignationId: string | undefined;
  primaryFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  hcp: Hcp | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HcpLicense implements IHcpLicense {
  hcpId: string | undefined;
  stateCode: string | undefined;
  stateLicenseNbr: string | undefined;
  sampleEligibilityFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  licenseExpirationDate: Date | undefined;
  hcp: Hcp | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHcpLicense) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hcpId = _data["hcpId"];
      this.stateCode = _data["stateCode"];
      this.stateLicenseNbr = _data["stateLicenseNbr"];
      this.sampleEligibilityFlag = _data["sampleEligibilityFlag"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.licenseExpirationDate = _data["licenseExpirationDate"] ? new Date(_data["licenseExpirationDate"].toString()) : <any>undefined;
      this.hcp = _data["hcp"] ? Hcp.fromJS(_data["hcp"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HcpLicense {
    data = typeof data === 'object' ? data : {};
    let result = new HcpLicense();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hcpId"] = this.hcpId;
    data["stateCode"] = this.stateCode;
    data["stateLicenseNbr"] = this.stateLicenseNbr;
    data["sampleEligibilityFlag"] = this.sampleEligibilityFlag;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
    data["hcp"] = this.hcp ? this.hcp.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HcpLicense {
    const json = this.toJSON();
    let result = new HcpLicense();
    result.init(json);
    return result;
  }
}

export interface IHcpLicense {
  hcpId: string | undefined;
  stateCode: string | undefined;
  stateLicenseNbr: string | undefined;
  sampleEligibilityFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  licenseExpirationDate: Date | undefined;
  hcp: Hcp | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProgramHcp implements IProgramHcp {
  programId: string | undefined;
  hcpId: string | undefined;
  hcp: Hcp | undefined;
  programHcpProducts: ProgramHcpProduct[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProgramHcp) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.hcpId = _data["hcpId"];
      this.hcp = _data["hcp"] ? Hcp.fromJS(_data["hcp"]) : <any>undefined;
      if (Array.isArray(_data["programHcpProducts"])) {
        this.programHcpProducts = [] as any;
        for (let item of _data["programHcpProducts"])
          this.programHcpProducts.push(ProgramHcpProduct.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProgramHcp {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramHcp();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programId"] = this.programId;
    data["hcpId"] = this.hcpId;
    data["hcp"] = this.hcp ? this.hcp.toJSON() : <any>undefined;
    if (Array.isArray(this.programHcpProducts)) {
      data["programHcpProducts"] = [];
      for (let item of this.programHcpProducts)
        data["programHcpProducts"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProgramHcp {
    const json = this.toJSON();
    let result = new ProgramHcp();
    result.init(json);
    return result;
  }
}

export interface IProgramHcp {
  programId: string | undefined;
  hcpId: string | undefined;
  hcp: Hcp | undefined;
  programHcpProducts: ProgramHcpProduct[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProgramHcpProductGroup implements IProgramHcpProductGroup {
  productGroupId: string | undefined;
  programId: string | undefined;
  hcpId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProgramHcpProductGroup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productGroupId = _data["productGroupId"];
      this.programId = _data["programId"];
      this.hcpId = _data["hcpId"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProgramHcpProductGroup {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramHcpProductGroup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["productGroupId"] = this.productGroupId;
    data["programId"] = this.programId;
    data["hcpId"] = this.hcpId;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProgramHcpProductGroup {
    const json = this.toJSON();
    let result = new ProgramHcpProductGroup();
    result.init(json);
    return result;
  }
}

export interface IProgramHcpProductGroup {
  productGroupId: string | undefined;
  programId: string | undefined;
  hcpId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacistContactMethod implements IPharmacistContactMethod {
  pharmacistId: string | undefined;
  pharmacistAddressId: string | undefined;
  contactMethodTypeId: string | undefined;
  contactDetailText: string | undefined;
  contactDetailExtensionText: string | undefined;
  knipperCreateFlag: boolean | undefined;
  primaryContactMethodFlag: boolean | undefined;
  pharmacist: Pharmacist | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacistContactMethod) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacistId = _data["pharmacistId"];
      this.pharmacistAddressId = _data["pharmacistAddressId"];
      this.contactMethodTypeId = _data["contactMethodTypeId"];
      this.contactDetailText = _data["contactDetailText"];
      this.contactDetailExtensionText = _data["contactDetailExtensionText"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.primaryContactMethodFlag = _data["primaryContactMethodFlag"];
      this.pharmacist = _data["pharmacist"] ? Pharmacist.fromJS(_data["pharmacist"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacistContactMethod {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacistContactMethod();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacistId"] = this.pharmacistId;
    data["pharmacistAddressId"] = this.pharmacistAddressId;
    data["contactMethodTypeId"] = this.contactMethodTypeId;
    data["contactDetailText"] = this.contactDetailText;
    data["contactDetailExtensionText"] = this.contactDetailExtensionText;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["primaryContactMethodFlag"] = this.primaryContactMethodFlag;
    data["pharmacist"] = this.pharmacist ? this.pharmacist.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacistContactMethod {
    const json = this.toJSON();
    let result = new PharmacistContactMethod();
    result.init(json);
    return result;
  }
}

export interface IPharmacistContactMethod {
  pharmacistId: string | undefined;
  pharmacistAddressId: string | undefined;
  contactMethodTypeId: string | undefined;
  contactDetailText: string | undefined;
  contactDetailExtensionText: string | undefined;
  knipperCreateFlag: boolean | undefined;
  primaryContactMethodFlag: boolean | undefined;
  pharmacist: Pharmacist | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacistPharmacy implements IPharmacistPharmacy {
  pharmacistId: string | undefined;
  pharmacyId: string | undefined;
  programId: string | undefined;
  pharmacist: Pharmacist | undefined;
  pharmacy: Pharmacy | undefined;
  program: Program | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacistPharmacy) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacistId = _data["pharmacistId"];
      this.pharmacyId = _data["pharmacyId"];
      this.programId = _data["programId"];
      this.pharmacist = _data["pharmacist"] ? Pharmacist.fromJS(_data["pharmacist"]) : <any>undefined;
      this.pharmacy = _data["pharmacy"] ? Pharmacy.fromJS(_data["pharmacy"]) : <any>undefined;
      this.program = _data["program"] ? Program.fromJS(_data["program"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacistPharmacy {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacistPharmacy();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacistId"] = this.pharmacistId;
    data["pharmacyId"] = this.pharmacyId;
    data["programId"] = this.programId;
    data["pharmacist"] = this.pharmacist ? this.pharmacist.toJSON() : <any>undefined;
    data["pharmacy"] = this.pharmacy ? this.pharmacy.toJSON() : <any>undefined;
    data["program"] = this.program ? this.program.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacistPharmacy {
    const json = this.toJSON();
    let result = new PharmacistPharmacy();
    result.init(json);
    return result;
  }
}

export interface IPharmacistPharmacy {
  pharmacistId: string | undefined;
  pharmacyId: string | undefined;
  programId: string | undefined;
  pharmacist: Pharmacist | undefined;
  pharmacy: Pharmacy | undefined;
  program: Program | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacistHospital implements IPharmacistHospital {
  pharmacistId: string | undefined;
  hospitalId: string | undefined;
  hospitalProgramId: string | undefined;
  pharmacist: Pharmacist | undefined;
  hospital: Hospital | undefined;
  hospitalProgram: HospitalProgram | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacistHospital) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacistId = _data["pharmacistId"];
      this.hospitalId = _data["hospitalId"];
      this.hospitalProgramId = _data["hospitalProgramId"];
      this.pharmacist = _data["pharmacist"] ? Pharmacist.fromJS(_data["pharmacist"]) : <any>undefined;
      this.hospital = _data["hospital"] ? Hospital.fromJS(_data["hospital"]) : <any>undefined;
      this.hospitalProgram = _data["hospitalProgram"] ? HospitalProgram.fromJS(_data["hospitalProgram"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacistHospital {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacistHospital();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacistId"] = this.pharmacistId;
    data["hospitalId"] = this.hospitalId;
    data["hospitalProgramId"] = this.hospitalProgramId;
    data["pharmacist"] = this.pharmacist ? this.pharmacist.toJSON() : <any>undefined;
    data["hospital"] = this.hospital ? this.hospital.toJSON() : <any>undefined;
    data["hospitalProgram"] = this.hospitalProgram ? this.hospitalProgram.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacistHospital {
    const json = this.toJSON();
    let result = new PharmacistHospital();
    result.init(json);
    return result;
  }
}

export interface IPharmacistHospital {
  pharmacistId: string | undefined;
  hospitalId: string | undefined;
  hospitalProgramId: string | undefined;
  pharmacist: Pharmacist | undefined;
  hospital: Hospital | undefined;
  hospitalProgram: HospitalProgram | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacistLicense implements IPharmacistLicense {
  pharmacistId: string | undefined;
  stateCode: string | undefined;
  stateLicenseNbr: string | undefined;
  sampleEligibilityFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  licenseExpirationDate: Date | undefined;
  pharmacist: Pharmacist | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacistLicense) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacistId = _data["pharmacistId"];
      this.stateCode = _data["stateCode"];
      this.stateLicenseNbr = _data["stateLicenseNbr"];
      this.sampleEligibilityFlag = _data["sampleEligibilityFlag"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.licenseExpirationDate = _data["licenseExpirationDate"] ? new Date(_data["licenseExpirationDate"].toString()) : <any>undefined;
      this.pharmacist = _data["pharmacist"] ? Pharmacist.fromJS(_data["pharmacist"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacistLicense {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacistLicense();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacistId"] = this.pharmacistId;
    data["stateCode"] = this.stateCode;
    data["stateLicenseNbr"] = this.stateLicenseNbr;
    data["sampleEligibilityFlag"] = this.sampleEligibilityFlag;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
    data["pharmacist"] = this.pharmacist ? this.pharmacist.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacistLicense {
    const json = this.toJSON();
    let result = new PharmacistLicense();
    result.init(json);
    return result;
  }
}

export interface IPharmacistLicense {
  pharmacistId: string | undefined;
  stateCode: string | undefined;
  stateLicenseNbr: string | undefined;
  sampleEligibilityFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  licenseExpirationDate: Date | undefined;
  pharmacist: Pharmacist | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacistDoNotHonorExclusion implements IPharmacistDoNotHonorExclusion {
  pharmacistId: string | undefined;
  pharmacist: Pharmacist | undefined;
  programId: string | undefined;
  productGroupId: string | undefined;
  productGroup: ProductGroup | undefined;
  productId: string | undefined;
  product: Product | undefined;
  doNotHonorExclusionReasonId: string | undefined;
  addedDate: Date | undefined;
  commentsText: string | undefined;
  deletionReasonText: string | undefined;
  sourceClassificationValueId: string | undefined;
  requestedDate: Date | undefined;
  orderId: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacistDoNotHonorExclusion) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacistId = _data["pharmacistId"];
      this.pharmacist = _data["pharmacist"] ? Pharmacist.fromJS(_data["pharmacist"]) : <any>undefined;
      this.programId = _data["programId"];
      this.productGroupId = _data["productGroupId"];
      this.productGroup = _data["productGroup"] ? ProductGroup.fromJS(_data["productGroup"]) : <any>undefined;
      this.productId = _data["productId"];
      this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
      this.doNotHonorExclusionReasonId = _data["doNotHonorExclusionReasonId"];
      this.addedDate = _data["addedDate"] ? new Date(_data["addedDate"].toString()) : <any>undefined;
      this.commentsText = _data["commentsText"];
      this.deletionReasonText = _data["deletionReasonText"];
      this.sourceClassificationValueId = _data["sourceClassificationValueId"];
      this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : <any>undefined;
      this.orderId = _data["orderId"];
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacistDoNotHonorExclusion {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacistDoNotHonorExclusion();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacistId"] = this.pharmacistId;
    data["pharmacist"] = this.pharmacist ? this.pharmacist.toJSON() : <any>undefined;
    data["programId"] = this.programId;
    data["productGroupId"] = this.productGroupId;
    data["productGroup"] = this.productGroup ? this.productGroup.toJSON() : <any>undefined;
    data["productId"] = this.productId;
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["doNotHonorExclusionReasonId"] = this.doNotHonorExclusionReasonId;
    data["addedDate"] = this.addedDate ? this.addedDate.toISOString() : <any>undefined;
    data["commentsText"] = this.commentsText;
    data["deletionReasonText"] = this.deletionReasonText;
    data["sourceClassificationValueId"] = this.sourceClassificationValueId;
    data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
    data["orderId"] = this.orderId;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacistDoNotHonorExclusion {
    const json = this.toJSON();
    let result = new PharmacistDoNotHonorExclusion();
    result.init(json);
    return result;
  }
}

export interface IPharmacistDoNotHonorExclusion {
  pharmacistId: string | undefined;
  pharmacist: Pharmacist | undefined;
  programId: string | undefined;
  productGroupId: string | undefined;
  productGroup: ProductGroup | undefined;
  productId: string | undefined;
  product: Product | undefined;
  doNotHonorExclusionReasonId: string | undefined;
  addedDate: Date | undefined;
  commentsText: string | undefined;
  deletionReasonText: string | undefined;
  sourceClassificationValueId: string | undefined;
  requestedDate: Date | undefined;
  orderId: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacistProfessionalDesignation implements IPharmacistProfessionalDesignation {
  pharmacistId: string | undefined;
  professionalDesignationId: string | undefined;
  primaryFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  pharmacist: Pharmacist | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacistProfessionalDesignation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacistId = _data["pharmacistId"];
      this.professionalDesignationId = _data["professionalDesignationId"];
      this.primaryFlag = _data["primaryFlag"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.pharmacist = _data["pharmacist"] ? Pharmacist.fromJS(_data["pharmacist"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacistProfessionalDesignation {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacistProfessionalDesignation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacistId"] = this.pharmacistId;
    data["professionalDesignationId"] = this.professionalDesignationId;
    data["primaryFlag"] = this.primaryFlag;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["pharmacist"] = this.pharmacist ? this.pharmacist.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacistProfessionalDesignation {
    const json = this.toJSON();
    let result = new PharmacistProfessionalDesignation();
    result.init(json);
    return result;
  }
}

export interface IPharmacistProfessionalDesignation {
  pharmacistId: string | undefined;
  professionalDesignationId: string | undefined;
  primaryFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  pharmacist: Pharmacist | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfiguration implements ITplProgramConfiguration {
  programId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  currentLogoId: string | undefined;
  currentLogoSourceClassificationValueId: string | undefined;
  insufficientInventoryActionClassificationValueId: string | undefined;
  aocFollowUpLettersCountClassificationValueId: string | undefined;
  copiedFromConfigurationDate: Date | undefined;
  priorityFlag: boolean | undefined;
  activationDate: Date | undefined;
  onHoldRejectionDaysCount: number | undefined;
  exceptionStatusExpiresDaysCount: number | undefined;
  minimumInventoryThresholdPercent: number | undefined;
  applicableSelectDayMondayFlag: boolean | undefined;
  applicableSelectDayTuesdayFlag: boolean | undefined;
  applicableSelectDayWednesdayFlag: boolean | undefined;
  applicableSelectDayThursdayFlag: boolean | undefined;
  applicableSelectDayFridayFlag: boolean | undefined;
  applicableSelectDaySaturdayFlag: boolean | undefined;
  applicableSelectDaySundayFlag: boolean | undefined;
  callCenterSelectDayVerificationFlag: boolean | undefined;
  verifyAllSelectDayOrdersFlag: boolean | undefined;
  orderFulfillmentSLADaysCount: number | undefined;
  orderReceivedCutoffTime: Date | undefined;
  aocFollowUpLetterFlag: boolean | undefined;
  aocFollowUpCallFlag: boolean | undefined;
  aocFollowUpCallDaysCount: number | undefined;
  invalidAOCCallFlag: boolean | undefined;
  openAOCDoNotHonorListDaysCount: number | undefined;
  automaticBadAddressHandlingFlag: boolean | undefined;
  svlRequiredFlag: boolean | undefined;
  orderRequestSVLApplicableFlag: boolean | undefined;
  aocsvlApplicableFlag: boolean | undefined;
  eaocApplicableFlag: boolean | undefined;
  monthlySVLOrderSelectionGoalPercent: number | undefined;
  minimumSVLOrderSelectionOrderCount: number | undefined;
  minimumSVLResponseThresholdPercent: number | undefined;
  negativeSVLResponseOrderSelectionGoalPercent: number | undefined;
  clientSignatureBlockText: string | undefined;
  emailClientSignatureBlockText: string | undefined;
  badAddressMarkingCount: number | undefined;
  splitOrderCarrierServiceTypeId: string | undefined;
  orderTurnaroundDays: number | undefined;
  programCycleId: string | undefined;
  srfExpirationDateIncludeFlag: boolean | undefined;
  deaIncludeFlag: boolean | undefined;
  specialtyIncludeFlag: boolean | undefined;
  sanIncludeFlag: boolean | undefined;
  professionalDesignationMdIncludeFlag: boolean | undefined;
  professionalDesignationDoIncludeFlag: boolean | undefined;
  professionalDesignationNpIncludeFlag: boolean | undefined;
  professionalDesignationPaIncludeFlag: boolean | undefined;
  professionalDesignationOtherIncludeFlag: boolean | undefined;
  knipperDeaNumberClassificationValueId: string | undefined;
  lastEditedDateTime: Date | undefined;
  lastEditedUserId: number | undefined;
  statusUpdatedDateTime: Date | undefined;
  statusUpdatedUserId: number | undefined;
  contactCenterFollowUpSelectFlag: boolean | undefined;
  missedYouSelectFlag: boolean | undefined;
  sourceCodeListJson: string | undefined;
  sourceCodeFlag: boolean | undefined;
  productIncludeFlag: boolean | undefined;
  invalidAocCallsProgramCycleId: string | undefined;
  customConfigurationJson: string | undefined;
  clientAllocationReviewFlag: boolean | undefined;
  somCheckFlag: boolean | undefined;
  useD365Integration: boolean | undefined;
  isCustomerCreateUpdateFromOrderLoad: boolean | undefined;
  opProgramUrl: string | undefined;
  opProgramURLFlag: boolean | undefined;
  applicableShippingDayMondayFlag: boolean | undefined;
  applicableShippingDayTuesdayFlag: boolean | undefined;
  applicableShippingDayWednesdayFlag: boolean | undefined;
  applicableShippingDayThursdayFlag: boolean | undefined;
  applicableShippingDayFridayFlag: boolean | undefined;
  isSendOrderToD365: boolean | undefined;
  byPassAllocationReview: boolean | undefined;
  dtpProgramConfigurationProducts: TplProgramConfigurationProduct[] | undefined;
  dtpProgramConfigurationSrfs: TplProgramConfigurationSrf[] | undefined;
  dtpProgramConfigurationProductTypes: TplProgramConfigurationProductType[] | undefined;
  ruleConfigurations: RuleConfiguration[] | undefined;
  dtpProgramConfigurationCellSheetEmails: TplProgramConfigurationCellSheetEmail[] | undefined;
  dtpProgramConfigurationAocs: TplProgramConfigurationAoc[] | undefined;
  dtpProgramConfigNonCompliantAocs: TplProgramConfigurationNonCompliantAoc[] | undefined;
  dtpProgramConfigurationCommunicationMethods: TplProgramConfigurationCommunicationMethod[] | undefined;
  dtpProgramConfigurationNotifications: TplProgramConfigurationNotification[] | undefined;
  dtpProgramConfigurationCommunications: TplProgramConfigurationCommunication[] | undefined;
  dtpProgramConfigurationLetterTemplateTypes: TplProgramConfigurationLetterTemplateType[] | undefined;
  dtpProgramConfigurationDocumentTemplates: TplProgramConfigurationDocumentTemplate[] | undefined;
  dtpProgramConfigurationOrderSources: TplProgramConfigurationOrderSource[] | undefined;
  dtpProgramConfigurationComments: TplProgramConfigurationComment[] | undefined;
  splitGroups: SplitGroup[] | undefined;
  splitGroupProducts: SplitGroupProducts[] | undefined;
  dtpProgramConfigurationAttachments: TplProgramConfigurationAttachment[] | undefined;
  autoIncludeBrandLevels: AutoIncludeBrandLevel[] | undefined;
  autoIncludeOrderLevels: AutoIncludeOrderLevel[] | undefined;
  autoIncludeProductLevels: AutoIncludeProductLevel[] | undefined;
  dtpProgramConfigurationLetterPrintEmails: TplProgramConfigurationLetterPrintEmail[] | undefined;
  dtpProgramConfigurationOfferSources: TplProgramConfigurationOfferSource[] | undefined;
  programConfigurationCertifications: ProgramConfigurationCertification[] | undefined;
  programConfigurationOnHoldActions: TplProgramConfigurationOnHoldAction[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfiguration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
      this.currentLogoId = _data["currentLogoId"];
      this.currentLogoSourceClassificationValueId = _data["currentLogoSourceClassificationValueId"];
      this.insufficientInventoryActionClassificationValueId = _data["insufficientInventoryActionClassificationValueId"];
      this.aocFollowUpLettersCountClassificationValueId = _data["aocFollowUpLettersCountClassificationValueId"];
      this.copiedFromConfigurationDate = _data["copiedFromConfigurationDate"] ? new Date(_data["copiedFromConfigurationDate"].toString()) : <any>undefined;
      this.priorityFlag = _data["priorityFlag"];
      this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>undefined;
      this.onHoldRejectionDaysCount = _data["onHoldRejectionDaysCount"];
      this.exceptionStatusExpiresDaysCount = _data["exceptionStatusExpiresDaysCount"];
      this.minimumInventoryThresholdPercent = _data["minimumInventoryThresholdPercent"];
      this.applicableSelectDayMondayFlag = _data["applicableSelectDayMondayFlag"];
      this.applicableSelectDayTuesdayFlag = _data["applicableSelectDayTuesdayFlag"];
      this.applicableSelectDayWednesdayFlag = _data["applicableSelectDayWednesdayFlag"];
      this.applicableSelectDayThursdayFlag = _data["applicableSelectDayThursdayFlag"];
      this.applicableSelectDayFridayFlag = _data["applicableSelectDayFridayFlag"];
      this.applicableSelectDaySaturdayFlag = _data["applicableSelectDaySaturdayFlag"];
      this.applicableSelectDaySundayFlag = _data["applicableSelectDaySundayFlag"];
      this.callCenterSelectDayVerificationFlag = _data["callCenterSelectDayVerificationFlag"];
      this.verifyAllSelectDayOrdersFlag = _data["verifyAllSelectDayOrdersFlag"];
      this.orderFulfillmentSLADaysCount = _data["orderFulfillmentSLADaysCount"];
      this.orderReceivedCutoffTime = _data["orderReceivedCutoffTime"] ? new Date(_data["orderReceivedCutoffTime"].toString()) : <any>undefined;
      this.aocFollowUpLetterFlag = _data["aocFollowUpLetterFlag"];
      this.aocFollowUpCallFlag = _data["aocFollowUpCallFlag"];
      this.aocFollowUpCallDaysCount = _data["aocFollowUpCallDaysCount"];
      this.invalidAOCCallFlag = _data["invalidAOCCallFlag"];
      this.openAOCDoNotHonorListDaysCount = _data["openAOCDoNotHonorListDaysCount"];
      this.automaticBadAddressHandlingFlag = _data["automaticBadAddressHandlingFlag"];
      this.svlRequiredFlag = _data["svlRequiredFlag"];
      this.orderRequestSVLApplicableFlag = _data["orderRequestSVLApplicableFlag"];
      this.aocsvlApplicableFlag = _data["aocsvlApplicableFlag"];
      this.eaocApplicableFlag = _data["eaocApplicableFlag"];
      this.monthlySVLOrderSelectionGoalPercent = _data["monthlySVLOrderSelectionGoalPercent"];
      this.minimumSVLOrderSelectionOrderCount = _data["minimumSVLOrderSelectionOrderCount"];
      this.minimumSVLResponseThresholdPercent = _data["minimumSVLResponseThresholdPercent"];
      this.negativeSVLResponseOrderSelectionGoalPercent = _data["negativeSVLResponseOrderSelectionGoalPercent"];
      this.clientSignatureBlockText = _data["clientSignatureBlockText"];
      this.emailClientSignatureBlockText = _data["emailClientSignatureBlockText"];
      this.badAddressMarkingCount = _data["badAddressMarkingCount"];
      this.splitOrderCarrierServiceTypeId = _data["splitOrderCarrierServiceTypeId"];
      this.orderTurnaroundDays = _data["orderTurnaroundDays"];
      this.programCycleId = _data["programCycleId"];
      this.srfExpirationDateIncludeFlag = _data["srfExpirationDateIncludeFlag"];
      this.deaIncludeFlag = _data["deaIncludeFlag"];
      this.specialtyIncludeFlag = _data["specialtyIncludeFlag"];
      this.sanIncludeFlag = _data["sanIncludeFlag"];
      this.professionalDesignationMdIncludeFlag = _data["professionalDesignationMdIncludeFlag"];
      this.professionalDesignationDoIncludeFlag = _data["professionalDesignationDoIncludeFlag"];
      this.professionalDesignationNpIncludeFlag = _data["professionalDesignationNpIncludeFlag"];
      this.professionalDesignationPaIncludeFlag = _data["professionalDesignationPaIncludeFlag"];
      this.professionalDesignationOtherIncludeFlag = _data["professionalDesignationOtherIncludeFlag"];
      this.knipperDeaNumberClassificationValueId = _data["knipperDeaNumberClassificationValueId"];
      this.lastEditedDateTime = _data["lastEditedDateTime"] ? new Date(_data["lastEditedDateTime"].toString()) : <any>undefined;
      this.lastEditedUserId = _data["lastEditedUserId"];
      this.statusUpdatedDateTime = _data["statusUpdatedDateTime"] ? new Date(_data["statusUpdatedDateTime"].toString()) : <any>undefined;
      this.statusUpdatedUserId = _data["statusUpdatedUserId"];
      this.contactCenterFollowUpSelectFlag = _data["contactCenterFollowUpSelectFlag"];
      this.missedYouSelectFlag = _data["missedYouSelectFlag"];
      this.sourceCodeListJson = _data["sourceCodeListJson"];
      this.sourceCodeFlag = _data["sourceCodeFlag"];
      this.productIncludeFlag = _data["productIncludeFlag"];
      this.invalidAocCallsProgramCycleId = _data["invalidAocCallsProgramCycleId"];
      this.customConfigurationJson = _data["customConfigurationJson"];
      this.clientAllocationReviewFlag = _data["clientAllocationReviewFlag"];
      this.somCheckFlag = _data["somCheckFlag"];
      this.useD365Integration = _data["useD365Integration"];
      this.isCustomerCreateUpdateFromOrderLoad = _data["isCustomerCreateUpdateFromOrderLoad"];
      this.opProgramUrl = _data["opProgramUrl"];
      this.opProgramURLFlag = _data["opProgramURLFlag"];
      this.applicableShippingDayMondayFlag = _data["applicableShippingDayMondayFlag"];
      this.applicableShippingDayTuesdayFlag = _data["applicableShippingDayTuesdayFlag"];
      this.applicableShippingDayWednesdayFlag = _data["applicableShippingDayWednesdayFlag"];
      this.applicableShippingDayThursdayFlag = _data["applicableShippingDayThursdayFlag"];
      this.applicableShippingDayFridayFlag = _data["applicableShippingDayFridayFlag"];
      this.isSendOrderToD365 = _data["isSendOrderToD365"];
      this.byPassAllocationReview = _data["byPassAllocationReview"];
      if (Array.isArray(_data["dtpProgramConfigurationProducts"])) {
        this.dtpProgramConfigurationProducts = [] as any;
        for (let item of _data["dtpProgramConfigurationProducts"])
          this.dtpProgramConfigurationProducts.push(TplProgramConfigurationProduct.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationSrfs"])) {
        this.dtpProgramConfigurationSrfs = [] as any;
        for (let item of _data["dtpProgramConfigurationSrfs"])
          this.dtpProgramConfigurationSrfs.push(TplProgramConfigurationSrf.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationProductTypes"])) {
        this.dtpProgramConfigurationProductTypes = [] as any;
        for (let item of _data["dtpProgramConfigurationProductTypes"])
          this.dtpProgramConfigurationProductTypes.push(TplProgramConfigurationProductType.fromJS(item));
      }
      if (Array.isArray(_data["ruleConfigurations"])) {
        this.ruleConfigurations = [] as any;
        for (let item of _data["ruleConfigurations"])
          this.ruleConfigurations.push(RuleConfiguration.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationCellSheetEmails"])) {
        this.dtpProgramConfigurationCellSheetEmails = [] as any;
        for (let item of _data["dtpProgramConfigurationCellSheetEmails"])
          this.dtpProgramConfigurationCellSheetEmails.push(TplProgramConfigurationCellSheetEmail.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationAocs"])) {
        this.dtpProgramConfigurationAocs = [] as any;
        for (let item of _data["dtpProgramConfigurationAocs"])
          this.dtpProgramConfigurationAocs.push(TplProgramConfigurationAoc.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigNonCompliantAocs"])) {
        this.dtpProgramConfigNonCompliantAocs = [] as any;
        for (let item of _data["dtpProgramConfigNonCompliantAocs"])
          this.dtpProgramConfigNonCompliantAocs.push(TplProgramConfigurationNonCompliantAoc.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationCommunicationMethods"])) {
        this.dtpProgramConfigurationCommunicationMethods = [] as any;
        for (let item of _data["dtpProgramConfigurationCommunicationMethods"])
          this.dtpProgramConfigurationCommunicationMethods.push(TplProgramConfigurationCommunicationMethod.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationNotifications"])) {
        this.dtpProgramConfigurationNotifications = [] as any;
        for (let item of _data["dtpProgramConfigurationNotifications"])
          this.dtpProgramConfigurationNotifications.push(TplProgramConfigurationNotification.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationCommunications"])) {
        this.dtpProgramConfigurationCommunications = [] as any;
        for (let item of _data["dtpProgramConfigurationCommunications"])
          this.dtpProgramConfigurationCommunications.push(TplProgramConfigurationCommunication.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationLetterTemplateTypes"])) {
        this.dtpProgramConfigurationLetterTemplateTypes = [] as any;
        for (let item of _data["dtpProgramConfigurationLetterTemplateTypes"])
          this.dtpProgramConfigurationLetterTemplateTypes.push(TplProgramConfigurationLetterTemplateType.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationDocumentTemplates"])) {
        this.dtpProgramConfigurationDocumentTemplates = [] as any;
        for (let item of _data["dtpProgramConfigurationDocumentTemplates"])
          this.dtpProgramConfigurationDocumentTemplates.push(TplProgramConfigurationDocumentTemplate.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationOrderSources"])) {
        this.dtpProgramConfigurationOrderSources = [] as any;
        for (let item of _data["dtpProgramConfigurationOrderSources"])
          this.dtpProgramConfigurationOrderSources.push(TplProgramConfigurationOrderSource.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationComments"])) {
        this.dtpProgramConfigurationComments = [] as any;
        for (let item of _data["dtpProgramConfigurationComments"])
          this.dtpProgramConfigurationComments.push(TplProgramConfigurationComment.fromJS(item));
      }
      if (Array.isArray(_data["splitGroups"])) {
        this.splitGroups = [] as any;
        for (let item of _data["splitGroups"])
          this.splitGroups.push(SplitGroup.fromJS(item));
      }
      if (Array.isArray(_data["splitGroupProducts"])) {
        this.splitGroupProducts = [] as any;
        for (let item of _data["splitGroupProducts"])
          this.splitGroupProducts.push(SplitGroupProducts.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationAttachments"])) {
        this.dtpProgramConfigurationAttachments = [] as any;
        for (let item of _data["dtpProgramConfigurationAttachments"])
          this.dtpProgramConfigurationAttachments.push(TplProgramConfigurationAttachment.fromJS(item));
      }
      if (Array.isArray(_data["autoIncludeBrandLevels"])) {
        this.autoIncludeBrandLevels = [] as any;
        for (let item of _data["autoIncludeBrandLevels"])
          this.autoIncludeBrandLevels.push(AutoIncludeBrandLevel.fromJS(item));
      }
      if (Array.isArray(_data["autoIncludeOrderLevels"])) {
        this.autoIncludeOrderLevels = [] as any;
        for (let item of _data["autoIncludeOrderLevels"])
          this.autoIncludeOrderLevels.push(AutoIncludeOrderLevel.fromJS(item));
      }
      if (Array.isArray(_data["autoIncludeProductLevels"])) {
        this.autoIncludeProductLevels = [] as any;
        for (let item of _data["autoIncludeProductLevels"])
          this.autoIncludeProductLevels.push(AutoIncludeProductLevel.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationLetterPrintEmails"])) {
        this.dtpProgramConfigurationLetterPrintEmails = [] as any;
        for (let item of _data["dtpProgramConfigurationLetterPrintEmails"])
          this.dtpProgramConfigurationLetterPrintEmails.push(TplProgramConfigurationLetterPrintEmail.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationOfferSources"])) {
        this.dtpProgramConfigurationOfferSources = [] as any;
        for (let item of _data["dtpProgramConfigurationOfferSources"])
          this.dtpProgramConfigurationOfferSources.push(TplProgramConfigurationOfferSource.fromJS(item));
      }
      if (Array.isArray(_data["programConfigurationCertifications"])) {
        this.programConfigurationCertifications = [] as any;
        for (let item of _data["programConfigurationCertifications"])
          this.programConfigurationCertifications.push(ProgramConfigurationCertification.fromJS(item));
      }
      if (Array.isArray(_data["programConfigurationOnHoldActions"])) {
        this.programConfigurationOnHoldActions = [] as any;
        for (let item of _data["programConfigurationOnHoldActions"])
          this.programConfigurationOnHoldActions.push(TplProgramConfigurationOnHoldAction.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfiguration {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfiguration();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programId"] = this.programId;
    data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
    data["currentLogoId"] = this.currentLogoId;
    data["currentLogoSourceClassificationValueId"] = this.currentLogoSourceClassificationValueId;
    data["insufficientInventoryActionClassificationValueId"] = this.insufficientInventoryActionClassificationValueId;
    data["aocFollowUpLettersCountClassificationValueId"] = this.aocFollowUpLettersCountClassificationValueId;
    data["copiedFromConfigurationDate"] = this.copiedFromConfigurationDate ? this.copiedFromConfigurationDate.toISOString() : <any>undefined;
    data["priorityFlag"] = this.priorityFlag;
    data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
    data["onHoldRejectionDaysCount"] = this.onHoldRejectionDaysCount;
    data["exceptionStatusExpiresDaysCount"] = this.exceptionStatusExpiresDaysCount;
    data["minimumInventoryThresholdPercent"] = this.minimumInventoryThresholdPercent;
    data["applicableSelectDayMondayFlag"] = this.applicableSelectDayMondayFlag;
    data["applicableSelectDayTuesdayFlag"] = this.applicableSelectDayTuesdayFlag;
    data["applicableSelectDayWednesdayFlag"] = this.applicableSelectDayWednesdayFlag;
    data["applicableSelectDayThursdayFlag"] = this.applicableSelectDayThursdayFlag;
    data["applicableSelectDayFridayFlag"] = this.applicableSelectDayFridayFlag;
    data["applicableSelectDaySaturdayFlag"] = this.applicableSelectDaySaturdayFlag;
    data["applicableSelectDaySundayFlag"] = this.applicableSelectDaySundayFlag;
    data["callCenterSelectDayVerificationFlag"] = this.callCenterSelectDayVerificationFlag;
    data["verifyAllSelectDayOrdersFlag"] = this.verifyAllSelectDayOrdersFlag;
    data["orderFulfillmentSLADaysCount"] = this.orderFulfillmentSLADaysCount;
    data["orderReceivedCutoffTime"] = this.orderReceivedCutoffTime ? this.orderReceivedCutoffTime.toISOString() : <any>undefined;
    data["aocFollowUpLetterFlag"] = this.aocFollowUpLetterFlag;
    data["aocFollowUpCallFlag"] = this.aocFollowUpCallFlag;
    data["aocFollowUpCallDaysCount"] = this.aocFollowUpCallDaysCount;
    data["invalidAOCCallFlag"] = this.invalidAOCCallFlag;
    data["openAOCDoNotHonorListDaysCount"] = this.openAOCDoNotHonorListDaysCount;
    data["automaticBadAddressHandlingFlag"] = this.automaticBadAddressHandlingFlag;
    data["svlRequiredFlag"] = this.svlRequiredFlag;
    data["orderRequestSVLApplicableFlag"] = this.orderRequestSVLApplicableFlag;
    data["aocsvlApplicableFlag"] = this.aocsvlApplicableFlag;
    data["eaocApplicableFlag"] = this.eaocApplicableFlag;
    data["monthlySVLOrderSelectionGoalPercent"] = this.monthlySVLOrderSelectionGoalPercent;
    data["minimumSVLOrderSelectionOrderCount"] = this.minimumSVLOrderSelectionOrderCount;
    data["minimumSVLResponseThresholdPercent"] = this.minimumSVLResponseThresholdPercent;
    data["negativeSVLResponseOrderSelectionGoalPercent"] = this.negativeSVLResponseOrderSelectionGoalPercent;
    data["clientSignatureBlockText"] = this.clientSignatureBlockText;
    data["emailClientSignatureBlockText"] = this.emailClientSignatureBlockText;
    data["badAddressMarkingCount"] = this.badAddressMarkingCount;
    data["splitOrderCarrierServiceTypeId"] = this.splitOrderCarrierServiceTypeId;
    data["orderTurnaroundDays"] = this.orderTurnaroundDays;
    data["programCycleId"] = this.programCycleId;
    data["srfExpirationDateIncludeFlag"] = this.srfExpirationDateIncludeFlag;
    data["deaIncludeFlag"] = this.deaIncludeFlag;
    data["specialtyIncludeFlag"] = this.specialtyIncludeFlag;
    data["sanIncludeFlag"] = this.sanIncludeFlag;
    data["professionalDesignationMdIncludeFlag"] = this.professionalDesignationMdIncludeFlag;
    data["professionalDesignationDoIncludeFlag"] = this.professionalDesignationDoIncludeFlag;
    data["professionalDesignationNpIncludeFlag"] = this.professionalDesignationNpIncludeFlag;
    data["professionalDesignationPaIncludeFlag"] = this.professionalDesignationPaIncludeFlag;
    data["professionalDesignationOtherIncludeFlag"] = this.professionalDesignationOtherIncludeFlag;
    data["knipperDeaNumberClassificationValueId"] = this.knipperDeaNumberClassificationValueId;
    data["lastEditedDateTime"] = this.lastEditedDateTime ? this.lastEditedDateTime.toISOString() : <any>undefined;
    data["lastEditedUserId"] = this.lastEditedUserId;
    data["statusUpdatedDateTime"] = this.statusUpdatedDateTime ? this.statusUpdatedDateTime.toISOString() : <any>undefined;
    data["statusUpdatedUserId"] = this.statusUpdatedUserId;
    data["contactCenterFollowUpSelectFlag"] = this.contactCenterFollowUpSelectFlag;
    data["missedYouSelectFlag"] = this.missedYouSelectFlag;
    data["sourceCodeListJson"] = this.sourceCodeListJson;
    data["sourceCodeFlag"] = this.sourceCodeFlag;
    data["productIncludeFlag"] = this.productIncludeFlag;
    data["invalidAocCallsProgramCycleId"] = this.invalidAocCallsProgramCycleId;
    data["customConfigurationJson"] = this.customConfigurationJson;
    data["clientAllocationReviewFlag"] = this.clientAllocationReviewFlag;
    data["somCheckFlag"] = this.somCheckFlag;
    data["useD365Integration"] = this.useD365Integration;
    data["isCustomerCreateUpdateFromOrderLoad"] = this.isCustomerCreateUpdateFromOrderLoad;
    data["opProgramUrl"] = this.opProgramUrl;
    data["opProgramURLFlag"] = this.opProgramURLFlag;
    data["applicableShippingDayMondayFlag"] = this.applicableShippingDayMondayFlag;
    data["applicableShippingDayTuesdayFlag"] = this.applicableShippingDayTuesdayFlag;
    data["applicableShippingDayWednesdayFlag"] = this.applicableShippingDayWednesdayFlag;
    data["applicableShippingDayThursdayFlag"] = this.applicableShippingDayThursdayFlag;
    data["applicableShippingDayFridayFlag"] = this.applicableShippingDayFridayFlag;
    data["isSendOrderToD365"] = this.isSendOrderToD365;
    data["byPassAllocationReview"] = this.byPassAllocationReview;
    if (Array.isArray(this.dtpProgramConfigurationProducts)) {
      data["dtpProgramConfigurationProducts"] = [];
      for (let item of this.dtpProgramConfigurationProducts)
        data["dtpProgramConfigurationProducts"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationSrfs)) {
      data["dtpProgramConfigurationSrfs"] = [];
      for (let item of this.dtpProgramConfigurationSrfs)
        data["dtpProgramConfigurationSrfs"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationProductTypes)) {
      data["dtpProgramConfigurationProductTypes"] = [];
      for (let item of this.dtpProgramConfigurationProductTypes)
        data["dtpProgramConfigurationProductTypes"].push(item.toJSON());
    }
    if (Array.isArray(this.ruleConfigurations)) {
      data["ruleConfigurations"] = [];
      for (let item of this.ruleConfigurations)
        data["ruleConfigurations"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationCellSheetEmails)) {
      data["dtpProgramConfigurationCellSheetEmails"] = [];
      for (let item of this.dtpProgramConfigurationCellSheetEmails)
        data["dtpProgramConfigurationCellSheetEmails"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationAocs)) {
      data["dtpProgramConfigurationAocs"] = [];
      for (let item of this.dtpProgramConfigurationAocs)
        data["dtpProgramConfigurationAocs"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigNonCompliantAocs)) {
      data["dtpProgramConfigNonCompliantAocs"] = [];
      for (let item of this.dtpProgramConfigNonCompliantAocs)
        data["dtpProgramConfigNonCompliantAocs"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationCommunicationMethods)) {
      data["dtpProgramConfigurationCommunicationMethods"] = [];
      for (let item of this.dtpProgramConfigurationCommunicationMethods)
        data["dtpProgramConfigurationCommunicationMethods"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationNotifications)) {
      data["dtpProgramConfigurationNotifications"] = [];
      for (let item of this.dtpProgramConfigurationNotifications)
        data["dtpProgramConfigurationNotifications"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationCommunications)) {
      data["dtpProgramConfigurationCommunications"] = [];
      for (let item of this.dtpProgramConfigurationCommunications)
        data["dtpProgramConfigurationCommunications"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationLetterTemplateTypes)) {
      data["dtpProgramConfigurationLetterTemplateTypes"] = [];
      for (let item of this.dtpProgramConfigurationLetterTemplateTypes)
        data["dtpProgramConfigurationLetterTemplateTypes"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationDocumentTemplates)) {
      data["dtpProgramConfigurationDocumentTemplates"] = [];
      for (let item of this.dtpProgramConfigurationDocumentTemplates)
        data["dtpProgramConfigurationDocumentTemplates"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationOrderSources)) {
      data["dtpProgramConfigurationOrderSources"] = [];
      for (let item of this.dtpProgramConfigurationOrderSources)
        data["dtpProgramConfigurationOrderSources"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationComments)) {
      data["dtpProgramConfigurationComments"] = [];
      for (let item of this.dtpProgramConfigurationComments)
        data["dtpProgramConfigurationComments"].push(item.toJSON());
    }
    if (Array.isArray(this.splitGroups)) {
      data["splitGroups"] = [];
      for (let item of this.splitGroups)
        data["splitGroups"].push(item.toJSON());
    }
    if (Array.isArray(this.splitGroupProducts)) {
      data["splitGroupProducts"] = [];
      for (let item of this.splitGroupProducts)
        data["splitGroupProducts"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationAttachments)) {
      data["dtpProgramConfigurationAttachments"] = [];
      for (let item of this.dtpProgramConfigurationAttachments)
        data["dtpProgramConfigurationAttachments"].push(item.toJSON());
    }
    if (Array.isArray(this.autoIncludeBrandLevels)) {
      data["autoIncludeBrandLevels"] = [];
      for (let item of this.autoIncludeBrandLevels)
        data["autoIncludeBrandLevels"].push(item.toJSON());
    }
    if (Array.isArray(this.autoIncludeOrderLevels)) {
      data["autoIncludeOrderLevels"] = [];
      for (let item of this.autoIncludeOrderLevels)
        data["autoIncludeOrderLevels"].push(item.toJSON());
    }
    if (Array.isArray(this.autoIncludeProductLevels)) {
      data["autoIncludeProductLevels"] = [];
      for (let item of this.autoIncludeProductLevels)
        data["autoIncludeProductLevels"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationLetterPrintEmails)) {
      data["dtpProgramConfigurationLetterPrintEmails"] = [];
      for (let item of this.dtpProgramConfigurationLetterPrintEmails)
        data["dtpProgramConfigurationLetterPrintEmails"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationOfferSources)) {
      data["dtpProgramConfigurationOfferSources"] = [];
      for (let item of this.dtpProgramConfigurationOfferSources)
        data["dtpProgramConfigurationOfferSources"].push(item.toJSON());
    }
    if (Array.isArray(this.programConfigurationCertifications)) {
      data["programConfigurationCertifications"] = [];
      for (let item of this.programConfigurationCertifications)
        data["programConfigurationCertifications"].push(item.toJSON());
    }
    if (Array.isArray(this.programConfigurationOnHoldActions)) {
      data["programConfigurationOnHoldActions"] = [];
      for (let item of this.programConfigurationOnHoldActions)
        data["programConfigurationOnHoldActions"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfiguration {
    const json = this.toJSON();
    let result = new TplProgramConfiguration();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfiguration {
  programId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  currentLogoId: string | undefined;
  currentLogoSourceClassificationValueId: string | undefined;
  insufficientInventoryActionClassificationValueId: string | undefined;
  aocFollowUpLettersCountClassificationValueId: string | undefined;
  copiedFromConfigurationDate: Date | undefined;
  priorityFlag: boolean | undefined;
  activationDate: Date | undefined;
  onHoldRejectionDaysCount: number | undefined;
  exceptionStatusExpiresDaysCount: number | undefined;
  minimumInventoryThresholdPercent: number | undefined;
  applicableSelectDayMondayFlag: boolean | undefined;
  applicableSelectDayTuesdayFlag: boolean | undefined;
  applicableSelectDayWednesdayFlag: boolean | undefined;
  applicableSelectDayThursdayFlag: boolean | undefined;
  applicableSelectDayFridayFlag: boolean | undefined;
  applicableSelectDaySaturdayFlag: boolean | undefined;
  applicableSelectDaySundayFlag: boolean | undefined;
  callCenterSelectDayVerificationFlag: boolean | undefined;
  verifyAllSelectDayOrdersFlag: boolean | undefined;
  orderFulfillmentSLADaysCount: number | undefined;
  orderReceivedCutoffTime: Date | undefined;
  aocFollowUpLetterFlag: boolean | undefined;
  aocFollowUpCallFlag: boolean | undefined;
  aocFollowUpCallDaysCount: number | undefined;
  invalidAOCCallFlag: boolean | undefined;
  openAOCDoNotHonorListDaysCount: number | undefined;
  automaticBadAddressHandlingFlag: boolean | undefined;
  svlRequiredFlag: boolean | undefined;
  orderRequestSVLApplicableFlag: boolean | undefined;
  aocsvlApplicableFlag: boolean | undefined;
  eaocApplicableFlag: boolean | undefined;
  monthlySVLOrderSelectionGoalPercent: number | undefined;
  minimumSVLOrderSelectionOrderCount: number | undefined;
  minimumSVLResponseThresholdPercent: number | undefined;
  negativeSVLResponseOrderSelectionGoalPercent: number | undefined;
  clientSignatureBlockText: string | undefined;
  emailClientSignatureBlockText: string | undefined;
  badAddressMarkingCount: number | undefined;
  splitOrderCarrierServiceTypeId: string | undefined;
  orderTurnaroundDays: number | undefined;
  programCycleId: string | undefined;
  srfExpirationDateIncludeFlag: boolean | undefined;
  deaIncludeFlag: boolean | undefined;
  specialtyIncludeFlag: boolean | undefined;
  sanIncludeFlag: boolean | undefined;
  professionalDesignationMdIncludeFlag: boolean | undefined;
  professionalDesignationDoIncludeFlag: boolean | undefined;
  professionalDesignationNpIncludeFlag: boolean | undefined;
  professionalDesignationPaIncludeFlag: boolean | undefined;
  professionalDesignationOtherIncludeFlag: boolean | undefined;
  knipperDeaNumberClassificationValueId: string | undefined;
  lastEditedDateTime: Date | undefined;
  lastEditedUserId: number | undefined;
  statusUpdatedDateTime: Date | undefined;
  statusUpdatedUserId: number | undefined;
  contactCenterFollowUpSelectFlag: boolean | undefined;
  missedYouSelectFlag: boolean | undefined;
  sourceCodeListJson: string | undefined;
  sourceCodeFlag: boolean | undefined;
  productIncludeFlag: boolean | undefined;
  invalidAocCallsProgramCycleId: string | undefined;
  customConfigurationJson: string | undefined;
  clientAllocationReviewFlag: boolean | undefined;
  somCheckFlag: boolean | undefined;
  useD365Integration: boolean | undefined;
  isCustomerCreateUpdateFromOrderLoad: boolean | undefined;
  opProgramUrl: string | undefined;
  opProgramURLFlag: boolean | undefined;
  applicableShippingDayMondayFlag: boolean | undefined;
  applicableShippingDayTuesdayFlag: boolean | undefined;
  applicableShippingDayWednesdayFlag: boolean | undefined;
  applicableShippingDayThursdayFlag: boolean | undefined;
  applicableShippingDayFridayFlag: boolean | undefined;
  isSendOrderToD365: boolean | undefined;
  byPassAllocationReview: boolean | undefined;
  dtpProgramConfigurationProducts: TplProgramConfigurationProduct[] | undefined;
  dtpProgramConfigurationSrfs: TplProgramConfigurationSrf[] | undefined;
  dtpProgramConfigurationProductTypes: TplProgramConfigurationProductType[] | undefined;
  ruleConfigurations: RuleConfiguration[] | undefined;
  dtpProgramConfigurationCellSheetEmails: TplProgramConfigurationCellSheetEmail[] | undefined;
  dtpProgramConfigurationAocs: TplProgramConfigurationAoc[] | undefined;
  dtpProgramConfigNonCompliantAocs: TplProgramConfigurationNonCompliantAoc[] | undefined;
  dtpProgramConfigurationCommunicationMethods: TplProgramConfigurationCommunicationMethod[] | undefined;
  dtpProgramConfigurationNotifications: TplProgramConfigurationNotification[] | undefined;
  dtpProgramConfigurationCommunications: TplProgramConfigurationCommunication[] | undefined;
  dtpProgramConfigurationLetterTemplateTypes: TplProgramConfigurationLetterTemplateType[] | undefined;
  dtpProgramConfigurationDocumentTemplates: TplProgramConfigurationDocumentTemplate[] | undefined;
  dtpProgramConfigurationOrderSources: TplProgramConfigurationOrderSource[] | undefined;
  dtpProgramConfigurationComments: TplProgramConfigurationComment[] | undefined;
  splitGroups: SplitGroup[] | undefined;
  splitGroupProducts: SplitGroupProducts[] | undefined;
  dtpProgramConfigurationAttachments: TplProgramConfigurationAttachment[] | undefined;
  autoIncludeBrandLevels: AutoIncludeBrandLevel[] | undefined;
  autoIncludeOrderLevels: AutoIncludeOrderLevel[] | undefined;
  autoIncludeProductLevels: AutoIncludeProductLevel[] | undefined;
  dtpProgramConfigurationLetterPrintEmails: TplProgramConfigurationLetterPrintEmail[] | undefined;
  dtpProgramConfigurationOfferSources: TplProgramConfigurationOfferSource[] | undefined;
  programConfigurationCertifications: ProgramConfigurationCertification[] | undefined;
  programConfigurationOnHoldActions: TplProgramConfigurationOnHoldAction[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProgramContactMethod implements IProgramContactMethod {
  programId: string | undefined;
  contactMethodTypeId: string | undefined;
  contactDetailText: string | undefined;
  contactDetailExtensionText: string | undefined;
  primaryFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProgramContactMethod) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.contactMethodTypeId = _data["contactMethodTypeId"];
      this.contactDetailText = _data["contactDetailText"];
      this.contactDetailExtensionText = _data["contactDetailExtensionText"];
      this.primaryFlag = _data["primaryFlag"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProgramContactMethod {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramContactMethod();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programId"] = this.programId;
    data["contactMethodTypeId"] = this.contactMethodTypeId;
    data["contactDetailText"] = this.contactDetailText;
    data["contactDetailExtensionText"] = this.contactDetailExtensionText;
    data["primaryFlag"] = this.primaryFlag;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProgramContactMethod {
    const json = this.toJSON();
    let result = new ProgramContactMethod();
    result.init(json);
    return result;
  }
}

export interface IProgramContactMethod {
  programId: string | undefined;
  contactMethodTypeId: string | undefined;
  contactDetailText: string | undefined;
  contactDetailExtensionText: string | undefined;
  primaryFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProgramContact implements IProgramContact {
  programId: string | undefined;
  roleClassificationValueId: string | undefined;
  userProfileId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProgramContact) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.roleClassificationValueId = _data["roleClassificationValueId"];
      this.userProfileId = _data["userProfileId"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProgramContact {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramContact();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programId"] = this.programId;
    data["roleClassificationValueId"] = this.roleClassificationValueId;
    data["userProfileId"] = this.userProfileId;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProgramContact {
    const json = this.toJSON();
    let result = new ProgramContact();
    result.init(json);
    return result;
  }
}

export interface IProgramContact {
  programId: string | undefined;
  roleClassificationValueId: string | undefined;
  userProfileId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProgramAttachment implements IProgramAttachment {
  programId: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  attachmentLocationText: string | undefined;
  commentsText: string | undefined;
  attachmentFileName: string | undefined;
  sequenceNumber: number | undefined;
  attachmentDescription: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProgramAttachment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.attachmentTypeClassificationValueId = _data["attachmentTypeClassificationValueId"];
      this.attachmentLocationText = _data["attachmentLocationText"];
      this.commentsText = _data["commentsText"];
      this.attachmentFileName = _data["attachmentFileName"];
      this.sequenceNumber = _data["sequenceNumber"];
      this.attachmentDescription = _data["attachmentDescription"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProgramAttachment {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramAttachment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programId"] = this.programId;
    data["attachmentTypeClassificationValueId"] = this.attachmentTypeClassificationValueId;
    data["attachmentLocationText"] = this.attachmentLocationText;
    data["commentsText"] = this.commentsText;
    data["attachmentFileName"] = this.attachmentFileName;
    data["sequenceNumber"] = this.sequenceNumber;
    data["attachmentDescription"] = this.attachmentDescription;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProgramAttachment {
    const json = this.toJSON();
    let result = new ProgramAttachment();
    result.init(json);
    return result;
  }
}

export interface IProgramAttachment {
  programId: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  attachmentLocationText: string | undefined;
  commentsText: string | undefined;
  attachmentFileName: string | undefined;
  sequenceNumber: number | undefined;
  attachmentDescription: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HcpAddressProgram implements IHcpAddressProgram {
  hcpAddressId: string | undefined;
  programId: string | undefined;
  activeFlag: boolean | undefined;
  addressSourceText: string | undefined;
  addressSourceNoteText: string | undefined;
  addressSourceUpdateDatetime: Date | undefined;
  hcpAddress: HcpAddress | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHcpAddressProgram) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hcpAddressId = _data["hcpAddressId"];
      this.programId = _data["programId"];
      this.activeFlag = _data["activeFlag"];
      this.addressSourceText = _data["addressSourceText"];
      this.addressSourceNoteText = _data["addressSourceNoteText"];
      this.addressSourceUpdateDatetime = _data["addressSourceUpdateDatetime"] ? new Date(_data["addressSourceUpdateDatetime"].toString()) : <any>undefined;
      this.hcpAddress = _data["hcpAddress"] ? HcpAddress.fromJS(_data["hcpAddress"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HcpAddressProgram {
    data = typeof data === 'object' ? data : {};
    let result = new HcpAddressProgram();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hcpAddressId"] = this.hcpAddressId;
    data["programId"] = this.programId;
    data["activeFlag"] = this.activeFlag;
    data["addressSourceText"] = this.addressSourceText;
    data["addressSourceNoteText"] = this.addressSourceNoteText;
    data["addressSourceUpdateDatetime"] = this.addressSourceUpdateDatetime ? this.addressSourceUpdateDatetime.toISOString() : <any>undefined;
    data["hcpAddress"] = this.hcpAddress ? this.hcpAddress.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HcpAddressProgram {
    const json = this.toJSON();
    let result = new HcpAddressProgram();
    result.init(json);
    return result;
  }
}

export interface IHcpAddressProgram {
  hcpAddressId: string | undefined;
  programId: string | undefined;
  activeFlag: boolean | undefined;
  addressSourceText: string | undefined;
  addressSourceNoteText: string | undefined;
  addressSourceUpdateDatetime: Date | undefined;
  hcpAddress: HcpAddress | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProgramSetting implements IProgramSetting {
  programId: string | undefined;
  key: string | undefined;
  value: string | undefined;
  description: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProgramSetting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.key = _data["key"];
      this.value = _data["value"];
      this.description = _data["description"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProgramSetting {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramSetting();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programId"] = this.programId;
    data["key"] = this.key;
    data["value"] = this.value;
    data["description"] = this.description;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProgramSetting {
    const json = this.toJSON();
    let result = new ProgramSetting();
    result.init(json);
    return result;
  }
}

export interface IProgramSetting {
  programId: string | undefined;
  key: string | undefined;
  value: string | undefined;
  description: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class CertificationDetail implements ICertificationDetail {
  tenantName: string | undefined;
  communicationId: string | undefined;
  communicationRecievedDate: Date | undefined;
  batchDate: Date | undefined;
  batchNumber: string | undefined;
  formId: string | undefined;
  certificationCreationDate: Date | undefined;
  programName: string | undefined;
  recordType: string | undefined;
  lockedFlag: boolean | undefined;
  approvedByUserProfileId: string | undefined;
  programId: string | undefined;
  hospitalId: string | undefined;
  pharmacyHospitalId: string | undefined;
  pharmacyId: string | undefined;
  jobNumber: string | undefined;
  pharmacyContactFirstName: string | undefined;
  pharmacyContactLastName: string | undefined;
  pharmacyName: string | undefined;
  pharmacyAddress1Text: string | undefined;
  pharmacyAddress2Text: string | undefined;
  pharmacyAddress3Text: string | undefined;
  pharmacyAddress4Text: string | undefined;
  pharmacyCityName: string | undefined;
  pharmacyStateCode: string | undefined;
  pharmacyCountryCode: string | undefined;
  pharmacyZipCode: string | undefined;
  pharmacyContactFirstNameCheck: boolean | undefined;
  pharmacyContactLastNameCheck: boolean | undefined;
  pharmacyFirstNameCheck: boolean | undefined;
  pharmacyAddress1TextCheck: boolean | undefined;
  pharmacyAddress2TextCheck: boolean | undefined;
  pharmacyStateCodeIdCheck: boolean | undefined;
  pharmacyCityNameCheck: boolean | undefined;
  pharmacyZipCodeCheck: boolean | undefined;
  reasonForModification: string | undefined;
  isSignature: boolean | undefined;
  isSignatureStamped: boolean | undefined;
  signedDate: Date | undefined;
  contactComments: string | undefined;
  isAdverseEvent: boolean | undefined;
  lockedByUserId: number | undefined;
  lockTimestamp: Date | undefined;
  unlockedByUserId: number | undefined;
  unlockTimestamp: Date | undefined;
  unlockReasonId: string | undefined;
  lockExpiryTimestamp: Date | undefined;
  program: Program | undefined;
  pharmacy: Pharmacy | undefined;
  pharmacyHospital: PharmacyHospital | undefined;
  hospital: Hospital | undefined;
  certificateStatusId: string | undefined;
  certificateStatusLastModifiedTime: Date | undefined;
  certificateStatus: ReferencedClassification | undefined;
  formIdMissingFlag: boolean | undefined;
  formIdNotApplicableFlag: boolean | undefined;
  formIdUnmatchedFlag: boolean | undefined;
  anyDocBatchNumber: string | undefined;
  anyDocBatchDateTime: Date | undefined;
  anyDocFormFamily: string | undefined;
  anyDocTemplateName: string | undefined;
  certificateNumberText: string | undefined;
  certificateInternalNbr: number | undefined;
  certificateAttachments: CertificateAttachment[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ICertificationDetail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantName = _data["tenantName"];
      this.communicationId = _data["communicationId"];
      this.communicationRecievedDate = _data["communicationRecievedDate"] ? new Date(_data["communicationRecievedDate"].toString()) : <any>undefined;
      this.batchDate = _data["batchDate"] ? new Date(_data["batchDate"].toString()) : <any>undefined;
      this.batchNumber = _data["batchNumber"];
      this.formId = _data["formId"];
      this.certificationCreationDate = _data["certificationCreationDate"] ? new Date(_data["certificationCreationDate"].toString()) : <any>undefined;
      this.programName = _data["programName"];
      this.recordType = _data["recordType"];
      this.lockedFlag = _data["lockedFlag"];
      this.approvedByUserProfileId = _data["approvedByUserProfileId"];
      this.programId = _data["programId"];
      this.hospitalId = _data["hospitalId"];
      this.pharmacyHospitalId = _data["pharmacyHospitalId"];
      this.pharmacyId = _data["pharmacyId"];
      this.jobNumber = _data["jobNumber"];
      this.pharmacyContactFirstName = _data["pharmacyContactFirstName"];
      this.pharmacyContactLastName = _data["pharmacyContactLastName"];
      this.pharmacyName = _data["pharmacyName"];
      this.pharmacyAddress1Text = _data["pharmacyAddress1Text"];
      this.pharmacyAddress2Text = _data["pharmacyAddress2Text"];
      this.pharmacyAddress3Text = _data["pharmacyAddress3Text"];
      this.pharmacyAddress4Text = _data["pharmacyAddress4Text"];
      this.pharmacyCityName = _data["pharmacyCityName"];
      this.pharmacyStateCode = _data["pharmacyStateCode"];
      this.pharmacyCountryCode = _data["pharmacyCountryCode"];
      this.pharmacyZipCode = _data["pharmacyZipCode"];
      this.pharmacyContactFirstNameCheck = _data["pharmacyContactFirstNameCheck"];
      this.pharmacyContactLastNameCheck = _data["pharmacyContactLastNameCheck"];
      this.pharmacyFirstNameCheck = _data["pharmacyFirstNameCheck"];
      this.pharmacyAddress1TextCheck = _data["pharmacyAddress1TextCheck"];
      this.pharmacyAddress2TextCheck = _data["pharmacyAddress2TextCheck"];
      this.pharmacyStateCodeIdCheck = _data["pharmacyStateCodeIdCheck"];
      this.pharmacyCityNameCheck = _data["pharmacyCityNameCheck"];
      this.pharmacyZipCodeCheck = _data["pharmacyZipCodeCheck"];
      this.reasonForModification = _data["reasonForModification"];
      this.isSignature = _data["isSignature"];
      this.isSignatureStamped = _data["isSignatureStamped"];
      this.signedDate = _data["signedDate"] ? new Date(_data["signedDate"].toString()) : <any>undefined;
      this.contactComments = _data["contactComments"];
      this.isAdverseEvent = _data["isAdverseEvent"];
      this.lockedByUserId = _data["lockedByUserId"];
      this.lockTimestamp = _data["lockTimestamp"] ? new Date(_data["lockTimestamp"].toString()) : <any>undefined;
      this.unlockedByUserId = _data["unlockedByUserId"];
      this.unlockTimestamp = _data["unlockTimestamp"] ? new Date(_data["unlockTimestamp"].toString()) : <any>undefined;
      this.unlockReasonId = _data["unlockReasonId"];
      this.lockExpiryTimestamp = _data["lockExpiryTimestamp"] ? new Date(_data["lockExpiryTimestamp"].toString()) : <any>undefined;
      this.program = _data["program"] ? Program.fromJS(_data["program"]) : <any>undefined;
      this.pharmacy = _data["pharmacy"] ? Pharmacy.fromJS(_data["pharmacy"]) : <any>undefined;
      this.pharmacyHospital = _data["pharmacyHospital"] ? PharmacyHospital.fromJS(_data["pharmacyHospital"]) : <any>undefined;
      this.hospital = _data["hospital"] ? Hospital.fromJS(_data["hospital"]) : <any>undefined;
      this.certificateStatusId = _data["certificateStatusId"];
      this.certificateStatusLastModifiedTime = _data["certificateStatusLastModifiedTime"] ? new Date(_data["certificateStatusLastModifiedTime"].toString()) : <any>undefined;
      this.certificateStatus = _data["certificateStatus"] ? ReferencedClassification.fromJS(_data["certificateStatus"]) : <any>undefined;
      this.formIdMissingFlag = _data["formIdMissingFlag"];
      this.formIdNotApplicableFlag = _data["formIdNotApplicableFlag"];
      this.formIdUnmatchedFlag = _data["formIdUnmatchedFlag"];
      this.anyDocBatchNumber = _data["anyDocBatchNumber"];
      this.anyDocBatchDateTime = _data["anyDocBatchDateTime"] ? new Date(_data["anyDocBatchDateTime"].toString()) : <any>undefined;
      this.anyDocFormFamily = _data["anyDocFormFamily"];
      this.anyDocTemplateName = _data["anyDocTemplateName"];
      this.certificateNumberText = _data["certificateNumberText"];
      this.certificateInternalNbr = _data["certificateInternalNbr"];
      if (Array.isArray(_data["certificateAttachments"])) {
        this.certificateAttachments = [] as any;
        for (let item of _data["certificateAttachments"])
          this.certificateAttachments.push(CertificateAttachment.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CertificationDetail {
    data = typeof data === 'object' ? data : {};
    let result = new CertificationDetail();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantName"] = this.tenantName;
    data["communicationId"] = this.communicationId;
    data["communicationRecievedDate"] = this.communicationRecievedDate ? this.communicationRecievedDate.toISOString() : <any>undefined;
    data["batchDate"] = this.batchDate ? this.batchDate.toISOString() : <any>undefined;
    data["batchNumber"] = this.batchNumber;
    data["formId"] = this.formId;
    data["certificationCreationDate"] = this.certificationCreationDate ? this.certificationCreationDate.toISOString() : <any>undefined;
    data["programName"] = this.programName;
    data["recordType"] = this.recordType;
    data["lockedFlag"] = this.lockedFlag;
    data["approvedByUserProfileId"] = this.approvedByUserProfileId;
    data["programId"] = this.programId;
    data["hospitalId"] = this.hospitalId;
    data["pharmacyHospitalId"] = this.pharmacyHospitalId;
    data["pharmacyId"] = this.pharmacyId;
    data["jobNumber"] = this.jobNumber;
    data["pharmacyContactFirstName"] = this.pharmacyContactFirstName;
    data["pharmacyContactLastName"] = this.pharmacyContactLastName;
    data["pharmacyName"] = this.pharmacyName;
    data["pharmacyAddress1Text"] = this.pharmacyAddress1Text;
    data["pharmacyAddress2Text"] = this.pharmacyAddress2Text;
    data["pharmacyAddress3Text"] = this.pharmacyAddress3Text;
    data["pharmacyAddress4Text"] = this.pharmacyAddress4Text;
    data["pharmacyCityName"] = this.pharmacyCityName;
    data["pharmacyStateCode"] = this.pharmacyStateCode;
    data["pharmacyCountryCode"] = this.pharmacyCountryCode;
    data["pharmacyZipCode"] = this.pharmacyZipCode;
    data["pharmacyContactFirstNameCheck"] = this.pharmacyContactFirstNameCheck;
    data["pharmacyContactLastNameCheck"] = this.pharmacyContactLastNameCheck;
    data["pharmacyFirstNameCheck"] = this.pharmacyFirstNameCheck;
    data["pharmacyAddress1TextCheck"] = this.pharmacyAddress1TextCheck;
    data["pharmacyAddress2TextCheck"] = this.pharmacyAddress2TextCheck;
    data["pharmacyStateCodeIdCheck"] = this.pharmacyStateCodeIdCheck;
    data["pharmacyCityNameCheck"] = this.pharmacyCityNameCheck;
    data["pharmacyZipCodeCheck"] = this.pharmacyZipCodeCheck;
    data["reasonForModification"] = this.reasonForModification;
    data["isSignature"] = this.isSignature;
    data["isSignatureStamped"] = this.isSignatureStamped;
    data["signedDate"] = this.signedDate ? this.signedDate.toISOString() : <any>undefined;
    data["contactComments"] = this.contactComments;
    data["isAdverseEvent"] = this.isAdverseEvent;
    data["lockedByUserId"] = this.lockedByUserId;
    data["lockTimestamp"] = this.lockTimestamp ? this.lockTimestamp.toISOString() : <any>undefined;
    data["unlockedByUserId"] = this.unlockedByUserId;
    data["unlockTimestamp"] = this.unlockTimestamp ? this.unlockTimestamp.toISOString() : <any>undefined;
    data["unlockReasonId"] = this.unlockReasonId;
    data["lockExpiryTimestamp"] = this.lockExpiryTimestamp ? this.lockExpiryTimestamp.toISOString() : <any>undefined;
    data["program"] = this.program ? this.program.toJSON() : <any>undefined;
    data["pharmacy"] = this.pharmacy ? this.pharmacy.toJSON() : <any>undefined;
    data["pharmacyHospital"] = this.pharmacyHospital ? this.pharmacyHospital.toJSON() : <any>undefined;
    data["hospital"] = this.hospital ? this.hospital.toJSON() : <any>undefined;
    data["certificateStatusId"] = this.certificateStatusId;
    data["certificateStatusLastModifiedTime"] = this.certificateStatusLastModifiedTime ? this.certificateStatusLastModifiedTime.toISOString() : <any>undefined;
    data["certificateStatus"] = this.certificateStatus ? this.certificateStatus.toJSON() : <any>undefined;
    data["formIdMissingFlag"] = this.formIdMissingFlag;
    data["formIdNotApplicableFlag"] = this.formIdNotApplicableFlag;
    data["formIdUnmatchedFlag"] = this.formIdUnmatchedFlag;
    data["anyDocBatchNumber"] = this.anyDocBatchNumber;
    data["anyDocBatchDateTime"] = this.anyDocBatchDateTime ? this.anyDocBatchDateTime.toISOString() : <any>undefined;
    data["anyDocFormFamily"] = this.anyDocFormFamily;
    data["anyDocTemplateName"] = this.anyDocTemplateName;
    data["certificateNumberText"] = this.certificateNumberText;
    data["certificateInternalNbr"] = this.certificateInternalNbr;
    if (Array.isArray(this.certificateAttachments)) {
      data["certificateAttachments"] = [];
      for (let item of this.certificateAttachments)
        data["certificateAttachments"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): CertificationDetail {
    const json = this.toJSON();
    let result = new CertificationDetail();
    result.init(json);
    return result;
  }
}

export interface ICertificationDetail {
  tenantName: string | undefined;
  communicationId: string | undefined;
  communicationRecievedDate: Date | undefined;
  batchDate: Date | undefined;
  batchNumber: string | undefined;
  formId: string | undefined;
  certificationCreationDate: Date | undefined;
  programName: string | undefined;
  recordType: string | undefined;
  lockedFlag: boolean | undefined;
  approvedByUserProfileId: string | undefined;
  programId: string | undefined;
  hospitalId: string | undefined;
  pharmacyHospitalId: string | undefined;
  pharmacyId: string | undefined;
  jobNumber: string | undefined;
  pharmacyContactFirstName: string | undefined;
  pharmacyContactLastName: string | undefined;
  pharmacyName: string | undefined;
  pharmacyAddress1Text: string | undefined;
  pharmacyAddress2Text: string | undefined;
  pharmacyAddress3Text: string | undefined;
  pharmacyAddress4Text: string | undefined;
  pharmacyCityName: string | undefined;
  pharmacyStateCode: string | undefined;
  pharmacyCountryCode: string | undefined;
  pharmacyZipCode: string | undefined;
  pharmacyContactFirstNameCheck: boolean | undefined;
  pharmacyContactLastNameCheck: boolean | undefined;
  pharmacyFirstNameCheck: boolean | undefined;
  pharmacyAddress1TextCheck: boolean | undefined;
  pharmacyAddress2TextCheck: boolean | undefined;
  pharmacyStateCodeIdCheck: boolean | undefined;
  pharmacyCityNameCheck: boolean | undefined;
  pharmacyZipCodeCheck: boolean | undefined;
  reasonForModification: string | undefined;
  isSignature: boolean | undefined;
  isSignatureStamped: boolean | undefined;
  signedDate: Date | undefined;
  contactComments: string | undefined;
  isAdverseEvent: boolean | undefined;
  lockedByUserId: number | undefined;
  lockTimestamp: Date | undefined;
  unlockedByUserId: number | undefined;
  unlockTimestamp: Date | undefined;
  unlockReasonId: string | undefined;
  lockExpiryTimestamp: Date | undefined;
  program: Program | undefined;
  pharmacy: Pharmacy | undefined;
  pharmacyHospital: PharmacyHospital | undefined;
  hospital: Hospital | undefined;
  certificateStatusId: string | undefined;
  certificateStatusLastModifiedTime: Date | undefined;
  certificateStatus: ReferencedClassification | undefined;
  formIdMissingFlag: boolean | undefined;
  formIdNotApplicableFlag: boolean | undefined;
  formIdUnmatchedFlag: boolean | undefined;
  anyDocBatchNumber: string | undefined;
  anyDocBatchDateTime: Date | undefined;
  anyDocFormFamily: string | undefined;
  anyDocTemplateName: string | undefined;
  certificateNumberText: string | undefined;
  certificateInternalNbr: number | undefined;
  certificateAttachments: CertificateAttachment[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class SalesRepProductGroupCoverage implements ISalesRepProductGroupCoverage {
  salesRepId: string | undefined;
  productGroupId: string | undefined;
  salesRep: SalesRep | undefined;
  productGroup: ProductGroup | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ISalesRepProductGroupCoverage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.salesRepId = _data["salesRepId"];
      this.productGroupId = _data["productGroupId"];
      this.salesRep = _data["salesRep"] ? SalesRep.fromJS(_data["salesRep"]) : <any>undefined;
      this.productGroup = _data["productGroup"] ? ProductGroup.fromJS(_data["productGroup"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): SalesRepProductGroupCoverage {
    data = typeof data === 'object' ? data : {};
    let result = new SalesRepProductGroupCoverage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["salesRepId"] = this.salesRepId;
    data["productGroupId"] = this.productGroupId;
    data["salesRep"] = this.salesRep ? this.salesRep.toJSON() : <any>undefined;
    data["productGroup"] = this.productGroup ? this.productGroup.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): SalesRepProductGroupCoverage {
    const json = this.toJSON();
    let result = new SalesRepProductGroupCoverage();
    result.init(json);
    return result;
  }
}

export interface ISalesRepProductGroupCoverage {
  salesRepId: string | undefined;
  productGroupId: string | undefined;
  salesRep: SalesRep | undefined;
  productGroup: ProductGroup | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OfferStatus implements IOfferStatus {
  offerId: string | undefined;
  offerStatusClassificationValueId: string | undefined;
  activityTypeClassificationValueId: string | undefined;
  contactMethodDescription: string | undefined;
  currentStatusFlag: boolean | undefined;
  offer: Offer | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOfferStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offerId = _data["offerId"];
      this.offerStatusClassificationValueId = _data["offerStatusClassificationValueId"];
      this.activityTypeClassificationValueId = _data["activityTypeClassificationValueId"];
      this.contactMethodDescription = _data["contactMethodDescription"];
      this.currentStatusFlag = _data["currentStatusFlag"];
      this.offer = _data["offer"] ? Offer.fromJS(_data["offer"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OfferStatus {
    data = typeof data === 'object' ? data : {};
    let result = new OfferStatus();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["offerId"] = this.offerId;
    data["offerStatusClassificationValueId"] = this.offerStatusClassificationValueId;
    data["activityTypeClassificationValueId"] = this.activityTypeClassificationValueId;
    data["contactMethodDescription"] = this.contactMethodDescription;
    data["currentStatusFlag"] = this.currentStatusFlag;
    data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OfferStatus {
    const json = this.toJSON();
    let result = new OfferStatus();
    result.init(json);
    return result;
  }
}

export interface IOfferStatus {
  offerId: string | undefined;
  offerStatusClassificationValueId: string | undefined;
  activityTypeClassificationValueId: string | undefined;
  contactMethodDescription: string | undefined;
  currentStatusFlag: boolean | undefined;
  offer: Offer | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OfferLine implements IOfferLine {
  offerId: string | undefined;
  productId: string | undefined;
  offeredQty: number | undefined;
  handwrittenQtyFlag: boolean | undefined;
  product: Product | undefined;
  offer: Offer | undefined;
  externalOfferLineId: string | undefined;
  therapeuticClass: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOfferLine) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offerId = _data["offerId"];
      this.productId = _data["productId"];
      this.offeredQty = _data["offeredQty"];
      this.handwrittenQtyFlag = _data["handwrittenQtyFlag"];
      this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
      this.offer = _data["offer"] ? Offer.fromJS(_data["offer"]) : <any>undefined;
      this.externalOfferLineId = _data["externalOfferLineId"];
      this.therapeuticClass = _data["therapeuticClass"];
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OfferLine {
    data = typeof data === 'object' ? data : {};
    let result = new OfferLine();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["offerId"] = this.offerId;
    data["productId"] = this.productId;
    data["offeredQty"] = this.offeredQty;
    data["handwrittenQtyFlag"] = this.handwrittenQtyFlag;
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
    data["externalOfferLineId"] = this.externalOfferLineId;
    data["therapeuticClass"] = this.therapeuticClass;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OfferLine {
    const json = this.toJSON();
    let result = new OfferLine();
    result.init(json);
    return result;
  }
}

export interface IOfferLine {
  offerId: string | undefined;
  productId: string | undefined;
  offeredQty: number | undefined;
  handwrittenQtyFlag: boolean | undefined;
  product: Product | undefined;
  offer: Offer | undefined;
  externalOfferLineId: string | undefined;
  therapeuticClass: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Product implements IProduct {
  productCode: string | undefined;
  productName: string | undefined;
  productShortDesc: string | undefined;
  productLongDescNote: string | undefined;
  multiplyingFactorNbr: number | undefined;
  clientProvidedCode: string | undefined;
  currentStatusDate: Date | undefined;
  latestProductCommentId: string | undefined;
  uomClassificationValueId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  mainImageProductAttachmentId: string | undefined;
  ndcCode: string | undefined;
  isReplacableProduct: boolean | undefined;
  productExpiryDate: Date | undefined;
  distributedBy: string | undefined;
  wmsProductId: string | undefined;
  wmsProductName: string | undefined;
  wmsProductDescription: string | undefined;
  clientProductName: string | undefined;
  clientProductId: string | undefined;
  productTypeId: string | undefined;
  minOrderQuantity: number | undefined;
  productAttachment: ProductAttachment | undefined;
  dtpProduct: TplProduct | undefined;
  productInventory: ProductInventory | undefined;
  productGroupProducts: ProductGroupProduct[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProduct) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productCode = _data["productCode"];
      this.productName = _data["productName"];
      this.productShortDesc = _data["productShortDesc"];
      this.productLongDescNote = _data["productLongDescNote"];
      this.multiplyingFactorNbr = _data["multiplyingFactorNbr"];
      this.clientProvidedCode = _data["clientProvidedCode"];
      this.currentStatusDate = _data["currentStatusDate"] ? new Date(_data["currentStatusDate"].toString()) : <any>undefined;
      this.latestProductCommentId = _data["latestProductCommentId"];
      this.uomClassificationValueId = _data["uomClassificationValueId"];
      this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
      this.mainImageProductAttachmentId = _data["mainImageProductAttachmentId"];
      this.ndcCode = _data["ndcCode"];
      this.isReplacableProduct = _data["isReplacableProduct"];
      this.productExpiryDate = _data["productExpiryDate"] ? new Date(_data["productExpiryDate"].toString()) : <any>undefined;
      this.distributedBy = _data["distributedBy"];
      this.wmsProductId = _data["wmsProductId"];
      this.wmsProductName = _data["wmsProductName"];
      this.wmsProductDescription = _data["wmsProductDescription"];
      this.clientProductName = _data["clientProductName"];
      this.clientProductId = _data["clientProductId"];
      this.productTypeId = _data["productTypeId"];
      this.minOrderQuantity = _data["minOrderQuantity"];
      this.productAttachment = _data["productAttachment"] ? ProductAttachment.fromJS(_data["productAttachment"]) : <any>undefined;
      this.dtpProduct = _data["dtpProduct"] ? TplProduct.fromJS(_data["dtpProduct"]) : <any>undefined;
      this.productInventory = _data["productInventory"] ? ProductInventory.fromJS(_data["productInventory"]) : <any>undefined;
      if (Array.isArray(_data["productGroupProducts"])) {
        this.productGroupProducts = [] as any;
        for (let item of _data["productGroupProducts"])
          this.productGroupProducts.push(ProductGroupProduct.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Product {
    data = typeof data === 'object' ? data : {};
    let result = new Product();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["productCode"] = this.productCode;
    data["productName"] = this.productName;
    data["productShortDesc"] = this.productShortDesc;
    data["productLongDescNote"] = this.productLongDescNote;
    data["multiplyingFactorNbr"] = this.multiplyingFactorNbr;
    data["clientProvidedCode"] = this.clientProvidedCode;
    data["currentStatusDate"] = this.currentStatusDate ? this.currentStatusDate.toISOString() : <any>undefined;
    data["latestProductCommentId"] = this.latestProductCommentId;
    data["uomClassificationValueId"] = this.uomClassificationValueId;
    data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
    data["mainImageProductAttachmentId"] = this.mainImageProductAttachmentId;
    data["ndcCode"] = this.ndcCode;
    data["isReplacableProduct"] = this.isReplacableProduct;
    data["productExpiryDate"] = this.productExpiryDate ? this.productExpiryDate.toISOString() : <any>undefined;
    data["distributedBy"] = this.distributedBy;
    data["wmsProductId"] = this.wmsProductId;
    data["wmsProductName"] = this.wmsProductName;
    data["wmsProductDescription"] = this.wmsProductDescription;
    data["clientProductName"] = this.clientProductName;
    data["clientProductId"] = this.clientProductId;
    data["productTypeId"] = this.productTypeId;
    data["minOrderQuantity"] = this.minOrderQuantity;
    data["productAttachment"] = this.productAttachment ? this.productAttachment.toJSON() : <any>undefined;
    data["dtpProduct"] = this.dtpProduct ? this.dtpProduct.toJSON() : <any>undefined;
    data["productInventory"] = this.productInventory ? this.productInventory.toJSON() : <any>undefined;
    if (Array.isArray(this.productGroupProducts)) {
      data["productGroupProducts"] = [];
      for (let item of this.productGroupProducts)
        data["productGroupProducts"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Product {
    const json = this.toJSON();
    let result = new Product();
    result.init(json);
    return result;
  }
}

export interface IProduct {
  productCode: string | undefined;
  productName: string | undefined;
  productShortDesc: string | undefined;
  productLongDescNote: string | undefined;
  multiplyingFactorNbr: number | undefined;
  clientProvidedCode: string | undefined;
  currentStatusDate: Date | undefined;
  latestProductCommentId: string | undefined;
  uomClassificationValueId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  mainImageProductAttachmentId: string | undefined;
  ndcCode: string | undefined;
  isReplacableProduct: boolean | undefined;
  productExpiryDate: Date | undefined;
  distributedBy: string | undefined;
  wmsProductId: string | undefined;
  wmsProductName: string | undefined;
  wmsProductDescription: string | undefined;
  clientProductName: string | undefined;
  clientProductId: string | undefined;
  productTypeId: string | undefined;
  minOrderQuantity: number | undefined;
  productAttachment: ProductAttachment | undefined;
  dtpProduct: TplProduct | undefined;
  productInventory: ProductInventory | undefined;
  productGroupProducts: ProductGroupProduct[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class RrofrOrderLine implements IRrofrOrderLine {
  rrofrOrderId: string | undefined;
  orderLineId: string | undefined;
  salesRepOrderLineRefusalStatusClassificatonId: string | undefined;
  salesRepOrderLineRefusalStatus: ReferencedClassification | undefined;
  orderLine: OrderLine | undefined;
  rrofrOrder: RrofrOrder | undefined;
  rrofrOrderLineStatusHistories: RrofrOrderLineStatusHistory[] | undefined;
  rrofrRespones: RrofrRespone[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IRrofrOrderLine) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rrofrOrderId = _data["rrofrOrderId"];
      this.orderLineId = _data["orderLineId"];
      this.salesRepOrderLineRefusalStatusClassificatonId = _data["salesRepOrderLineRefusalStatusClassificatonId"];
      this.salesRepOrderLineRefusalStatus = _data["salesRepOrderLineRefusalStatus"] ? ReferencedClassification.fromJS(_data["salesRepOrderLineRefusalStatus"]) : <any>undefined;
      this.orderLine = _data["orderLine"] ? OrderLine.fromJS(_data["orderLine"]) : <any>undefined;
      this.rrofrOrder = _data["rrofrOrder"] ? RrofrOrder.fromJS(_data["rrofrOrder"]) : <any>undefined;
      if (Array.isArray(_data["rrofrOrderLineStatusHistories"])) {
        this.rrofrOrderLineStatusHistories = [] as any;
        for (let item of _data["rrofrOrderLineStatusHistories"])
          this.rrofrOrderLineStatusHistories.push(RrofrOrderLineStatusHistory.fromJS(item));
      }
      if (Array.isArray(_data["rrofrRespones"])) {
        this.rrofrRespones = [] as any;
        for (let item of _data["rrofrRespones"])
          this.rrofrRespones.push(RrofrRespone.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RrofrOrderLine {
    data = typeof data === 'object' ? data : {};
    let result = new RrofrOrderLine();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["rrofrOrderId"] = this.rrofrOrderId;
    data["orderLineId"] = this.orderLineId;
    data["salesRepOrderLineRefusalStatusClassificatonId"] = this.salesRepOrderLineRefusalStatusClassificatonId;
    data["salesRepOrderLineRefusalStatus"] = this.salesRepOrderLineRefusalStatus ? this.salesRepOrderLineRefusalStatus.toJSON() : <any>undefined;
    data["orderLine"] = this.orderLine ? this.orderLine.toJSON() : <any>undefined;
    data["rrofrOrder"] = this.rrofrOrder ? this.rrofrOrder.toJSON() : <any>undefined;
    if (Array.isArray(this.rrofrOrderLineStatusHistories)) {
      data["rrofrOrderLineStatusHistories"] = [];
      for (let item of this.rrofrOrderLineStatusHistories)
        data["rrofrOrderLineStatusHistories"].push(item.toJSON());
    }
    if (Array.isArray(this.rrofrRespones)) {
      data["rrofrRespones"] = [];
      for (let item of this.rrofrRespones)
        data["rrofrRespones"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): RrofrOrderLine {
    const json = this.toJSON();
    let result = new RrofrOrderLine();
    result.init(json);
    return result;
  }
}

export interface IRrofrOrderLine {
  rrofrOrderId: string | undefined;
  orderLineId: string | undefined;
  salesRepOrderLineRefusalStatusClassificatonId: string | undefined;
  salesRepOrderLineRefusalStatus: ReferencedClassification | undefined;
  orderLine: OrderLine | undefined;
  rrofrOrder: RrofrOrder | undefined;
  rrofrOrderLineStatusHistories: RrofrOrderLineStatusHistory[] | undefined;
  rrofrRespones: RrofrRespone[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ShipmentContainerSerialNumber implements IShipmentContainerSerialNumber {
  orderLineId: string | undefined;
  shipmentContainerId: string | undefined;
  serialNumberText: string | undefined;
  orderLine: OrderLine | undefined;
  shipmentContainer: ShipmentContainer | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IShipmentContainerSerialNumber) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderLineId = _data["orderLineId"];
      this.shipmentContainerId = _data["shipmentContainerId"];
      this.serialNumberText = _data["serialNumberText"];
      this.orderLine = _data["orderLine"] ? OrderLine.fromJS(_data["orderLine"]) : <any>undefined;
      this.shipmentContainer = _data["shipmentContainer"] ? ShipmentContainer.fromJS(_data["shipmentContainer"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ShipmentContainerSerialNumber {
    data = typeof data === 'object' ? data : {};
    let result = new ShipmentContainerSerialNumber();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderLineId"] = this.orderLineId;
    data["shipmentContainerId"] = this.shipmentContainerId;
    data["serialNumberText"] = this.serialNumberText;
    data["orderLine"] = this.orderLine ? this.orderLine.toJSON() : <any>undefined;
    data["shipmentContainer"] = this.shipmentContainer ? this.shipmentContainer.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ShipmentContainerSerialNumber {
    const json = this.toJSON();
    let result = new ShipmentContainerSerialNumber();
    result.init(json);
    return result;
  }
}

export interface IShipmentContainerSerialNumber {
  orderLineId: string | undefined;
  shipmentContainerId: string | undefined;
  serialNumberText: string | undefined;
  orderLine: OrderLine | undefined;
  shipmentContainer: ShipmentContainer | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ShipmentContainerOrderLine implements IShipmentContainerOrderLine {
  orderLineId: string | undefined;
  shipmentContainerLineId: string | undefined;
  orderLine: OrderLine | undefined;
  shipmentContainerLine: ShipmentContainerLine | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IShipmentContainerOrderLine) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderLineId = _data["orderLineId"];
      this.shipmentContainerLineId = _data["shipmentContainerLineId"];
      this.orderLine = _data["orderLine"] ? OrderLine.fromJS(_data["orderLine"]) : <any>undefined;
      this.shipmentContainerLine = _data["shipmentContainerLine"] ? ShipmentContainerLine.fromJS(_data["shipmentContainerLine"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ShipmentContainerOrderLine {
    data = typeof data === 'object' ? data : {};
    let result = new ShipmentContainerOrderLine();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderLineId"] = this.orderLineId;
    data["shipmentContainerLineId"] = this.shipmentContainerLineId;
    data["orderLine"] = this.orderLine ? this.orderLine.toJSON() : <any>undefined;
    data["shipmentContainerLine"] = this.shipmentContainerLine ? this.shipmentContainerLine.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ShipmentContainerOrderLine {
    const json = this.toJSON();
    let result = new ShipmentContainerOrderLine();
    result.init(json);
    return result;
  }
}

export interface IShipmentContainerOrderLine {
  orderLineId: string | undefined;
  shipmentContainerLineId: string | undefined;
  orderLine: OrderLine | undefined;
  shipmentContainerLine: ShipmentContainerLine | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class FgOrderHcpOrderLine implements IFgOrderHcpOrderLine {
  orderHcpId: string | undefined;
  orderLineId: string | undefined;
  orderHcp: FgOrderHcp | undefined;
  orderLine: OrderLine | undefined;
  dispensedQty: number | undefined;
  disributionUintOfMeasure: string | undefined;
  dispensedFrom: Date | undefined;
  dispensedTill: Date | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IFgOrderHcpOrderLine) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderHcpId = _data["orderHcpId"];
      this.orderLineId = _data["orderLineId"];
      this.orderHcp = _data["orderHcp"] ? FgOrderHcp.fromJS(_data["orderHcp"]) : <any>undefined;
      this.orderLine = _data["orderLine"] ? OrderLine.fromJS(_data["orderLine"]) : <any>undefined;
      this.dispensedQty = _data["dispensedQty"];
      this.disributionUintOfMeasure = _data["disributionUintOfMeasure"];
      this.dispensedFrom = _data["dispensedFrom"] ? new Date(_data["dispensedFrom"].toString()) : <any>undefined;
      this.dispensedTill = _data["dispensedTill"] ? new Date(_data["dispensedTill"].toString()) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): FgOrderHcpOrderLine {
    data = typeof data === 'object' ? data : {};
    let result = new FgOrderHcpOrderLine();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderHcpId"] = this.orderHcpId;
    data["orderLineId"] = this.orderLineId;
    data["orderHcp"] = this.orderHcp ? this.orderHcp.toJSON() : <any>undefined;
    data["orderLine"] = this.orderLine ? this.orderLine.toJSON() : <any>undefined;
    data["dispensedQty"] = this.dispensedQty;
    data["disributionUintOfMeasure"] = this.disributionUintOfMeasure;
    data["dispensedFrom"] = this.dispensedFrom ? this.dispensedFrom.toISOString() : <any>undefined;
    data["dispensedTill"] = this.dispensedTill ? this.dispensedTill.toISOString() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): FgOrderHcpOrderLine {
    const json = this.toJSON();
    let result = new FgOrderHcpOrderLine();
    result.init(json);
    return result;
  }
}

export interface IFgOrderHcpOrderLine {
  orderHcpId: string | undefined;
  orderLineId: string | undefined;
  orderHcp: FgOrderHcp | undefined;
  orderLine: OrderLine | undefined;
  dispensedQty: number | undefined;
  disributionUintOfMeasure: string | undefined;
  dispensedFrom: Date | undefined;
  dispensedTill: Date | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderInvestigationDetail implements IOrderInvestigationDetail {
  orderInvestigationId: string | undefined;
  orderValidationRuleOutcomeId: string | undefined;
  investigationActionValue: string | undefined;
  investigationResolutionClassificationValueId: string | undefined;
  orderInvestigation: OrderInvestigation | undefined;
  orderValidationRuleOutcome: OrderValidationRuleOutcome | undefined;
  orderContexts: OrderContext[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderInvestigationDetail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderInvestigationId = _data["orderInvestigationId"];
      this.orderValidationRuleOutcomeId = _data["orderValidationRuleOutcomeId"];
      this.investigationActionValue = _data["investigationActionValue"];
      this.investigationResolutionClassificationValueId = _data["investigationResolutionClassificationValueId"];
      this.orderInvestigation = _data["orderInvestigation"] ? OrderInvestigation.fromJS(_data["orderInvestigation"]) : <any>undefined;
      this.orderValidationRuleOutcome = _data["orderValidationRuleOutcome"] ? OrderValidationRuleOutcome.fromJS(_data["orderValidationRuleOutcome"]) : <any>undefined;
      if (Array.isArray(_data["orderContexts"])) {
        this.orderContexts = [] as any;
        for (let item of _data["orderContexts"])
          this.orderContexts.push(OrderContext.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderInvestigationDetail {
    data = typeof data === 'object' ? data : {};
    let result = new OrderInvestigationDetail();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderInvestigationId"] = this.orderInvestigationId;
    data["orderValidationRuleOutcomeId"] = this.orderValidationRuleOutcomeId;
    data["investigationActionValue"] = this.investigationActionValue;
    data["investigationResolutionClassificationValueId"] = this.investigationResolutionClassificationValueId;
    data["orderInvestigation"] = this.orderInvestigation ? this.orderInvestigation.toJSON() : <any>undefined;
    data["orderValidationRuleOutcome"] = this.orderValidationRuleOutcome ? this.orderValidationRuleOutcome.toJSON() : <any>undefined;
    if (Array.isArray(this.orderContexts)) {
      data["orderContexts"] = [];
      for (let item of this.orderContexts)
        data["orderContexts"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderInvestigationDetail {
    const json = this.toJSON();
    let result = new OrderInvestigationDetail();
    result.init(json);
    return result;
  }
}

export interface IOrderInvestigationDetail {
  orderInvestigationId: string | undefined;
  orderValidationRuleOutcomeId: string | undefined;
  investigationActionValue: string | undefined;
  investigationResolutionClassificationValueId: string | undefined;
  orderInvestigation: OrderInvestigation | undefined;
  orderValidationRuleOutcome: OrderValidationRuleOutcome | undefined;
  orderContexts: OrderContext[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ReferencedEntity implements IReferencedEntity {
  referencedEntityId: string | undefined;
  referencedEntityTypeClassificationValueId: string | undefined;
  referencedEntityType: ReferencedClassification | undefined;
  attributes: ReferencedEntityAttribute[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IReferencedEntity) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.referencedEntityId = _data["referencedEntityId"];
      this.referencedEntityTypeClassificationValueId = _data["referencedEntityTypeClassificationValueId"];
      this.referencedEntityType = _data["referencedEntityType"] ? ReferencedClassification.fromJS(_data["referencedEntityType"]) : <any>undefined;
      if (Array.isArray(_data["attributes"])) {
        this.attributes = [] as any;
        for (let item of _data["attributes"])
          this.attributes.push(ReferencedEntityAttribute.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ReferencedEntity {
    data = typeof data === 'object' ? data : {};
    let result = new ReferencedEntity();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["referencedEntityId"] = this.referencedEntityId;
    data["referencedEntityTypeClassificationValueId"] = this.referencedEntityTypeClassificationValueId;
    data["referencedEntityType"] = this.referencedEntityType ? this.referencedEntityType.toJSON() : <any>undefined;
    if (Array.isArray(this.attributes)) {
      data["attributes"] = [];
      for (let item of this.attributes)
        data["attributes"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ReferencedEntity {
    const json = this.toJSON();
    let result = new ReferencedEntity();
    result.init(json);
    return result;
  }
}

export interface IReferencedEntity {
  referencedEntityId: string | undefined;
  referencedEntityTypeClassificationValueId: string | undefined;
  referencedEntityType: ReferencedClassification | undefined;
  attributes: ReferencedEntityAttribute[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderStatusHistoryReason implements IOrderStatusHistoryReason {
  orderStatusHistoryId: string | undefined;
  orderStatusReasonTypeId: string | undefined;
  orderStatusHistory: OrderStatusHistory | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderStatusHistoryReason) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderStatusHistoryId = _data["orderStatusHistoryId"];
      this.orderStatusReasonTypeId = _data["orderStatusReasonTypeId"];
      this.orderStatusHistory = _data["orderStatusHistory"] ? OrderStatusHistory.fromJS(_data["orderStatusHistory"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderStatusHistoryReason {
    data = typeof data === 'object' ? data : {};
    let result = new OrderStatusHistoryReason();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderStatusHistoryId"] = this.orderStatusHistoryId;
    data["orderStatusReasonTypeId"] = this.orderStatusReasonTypeId;
    data["orderStatusHistory"] = this.orderStatusHistory ? this.orderStatusHistory.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderStatusHistoryReason {
    const json = this.toJSON();
    let result = new OrderStatusHistoryReason();
    result.init(json);
    return result;
  }
}

export interface IOrderStatusHistoryReason {
  orderStatusHistoryId: string | undefined;
  orderStatusReasonTypeId: string | undefined;
  orderStatusHistory: OrderStatusHistory | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ShipmentContainer implements IShipmentContainer {
  shipmentId: string | undefined;
  deliveryStatusClassificationValueId: string | undefined;
  containerId: string | undefined;
  trackingNumberText: string | undefined;
  returnReasonText: string | undefined;
  actualDeliveryDate: Date | undefined;
  podFilePath: string | undefined;
  shipment: Shipment | undefined;
  shipmentContainerSerialNumbers: ShipmentContainerSerialNumber[] | undefined;
  shipmentContainerLines: ShipmentContainerLine[] | undefined;
  aods: Aod[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IShipmentContainer) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.shipmentId = _data["shipmentId"];
      this.deliveryStatusClassificationValueId = _data["deliveryStatusClassificationValueId"];
      this.containerId = _data["containerId"];
      this.trackingNumberText = _data["trackingNumberText"];
      this.returnReasonText = _data["returnReasonText"];
      this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
      this.podFilePath = _data["podFilePath"];
      this.shipment = _data["shipment"] ? Shipment.fromJS(_data["shipment"]) : <any>undefined;
      if (Array.isArray(_data["shipmentContainerSerialNumbers"])) {
        this.shipmentContainerSerialNumbers = [] as any;
        for (let item of _data["shipmentContainerSerialNumbers"])
          this.shipmentContainerSerialNumbers.push(ShipmentContainerSerialNumber.fromJS(item));
      }
      if (Array.isArray(_data["shipmentContainerLines"])) {
        this.shipmentContainerLines = [] as any;
        for (let item of _data["shipmentContainerLines"])
          this.shipmentContainerLines.push(ShipmentContainerLine.fromJS(item));
      }
      if (Array.isArray(_data["aods"])) {
        this.aods = [] as any;
        for (let item of _data["aods"])
          this.aods.push(Aod.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ShipmentContainer {
    data = typeof data === 'object' ? data : {};
    let result = new ShipmentContainer();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["shipmentId"] = this.shipmentId;
    data["deliveryStatusClassificationValueId"] = this.deliveryStatusClassificationValueId;
    data["containerId"] = this.containerId;
    data["trackingNumberText"] = this.trackingNumberText;
    data["returnReasonText"] = this.returnReasonText;
    data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
    data["podFilePath"] = this.podFilePath;
    data["shipment"] = this.shipment ? this.shipment.toJSON() : <any>undefined;
    if (Array.isArray(this.shipmentContainerSerialNumbers)) {
      data["shipmentContainerSerialNumbers"] = [];
      for (let item of this.shipmentContainerSerialNumbers)
        data["shipmentContainerSerialNumbers"].push(item.toJSON());
    }
    if (Array.isArray(this.shipmentContainerLines)) {
      data["shipmentContainerLines"] = [];
      for (let item of this.shipmentContainerLines)
        data["shipmentContainerLines"].push(item.toJSON());
    }
    if (Array.isArray(this.aods)) {
      data["aods"] = [];
      for (let item of this.aods)
        data["aods"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ShipmentContainer {
    const json = this.toJSON();
    let result = new ShipmentContainer();
    result.init(json);
    return result;
  }
}

export interface IShipmentContainer {
  shipmentId: string | undefined;
  deliveryStatusClassificationValueId: string | undefined;
  containerId: string | undefined;
  trackingNumberText: string | undefined;
  returnReasonText: string | undefined;
  actualDeliveryDate: Date | undefined;
  podFilePath: string | undefined;
  shipment: Shipment | undefined;
  shipmentContainerSerialNumbers: ShipmentContainerSerialNumber[] | undefined;
  shipmentContainerLines: ShipmentContainerLine[] | undefined;
  aods: Aod[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderValidationRuleOutcome implements IOrderValidationRuleOutcome {
  orderValidationId: string | undefined;
  orderId: string | undefined;
  orderLineId: string | undefined;
  ruleId: string | undefined;
  orderValidationFailureOutcomeClassificationValueId: string | undefined;
  ruleFailureTypeClassificationValidId: string | undefined;
  passedFlag: boolean | undefined;
  processedFlag: boolean | undefined;
  overrideFlag: boolean | undefined;
  statusText: string | undefined;
  ruleOutcomeJson: string | undefined;
  orderValidation: OrderValidation | undefined;
  order: Order | undefined;
  orderLine: OrderLine | undefined;
  rule: Rule | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderValidationRuleOutcome) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderValidationId = _data["orderValidationId"];
      this.orderId = _data["orderId"];
      this.orderLineId = _data["orderLineId"];
      this.ruleId = _data["ruleId"];
      this.orderValidationFailureOutcomeClassificationValueId = _data["orderValidationFailureOutcomeClassificationValueId"];
      this.ruleFailureTypeClassificationValidId = _data["ruleFailureTypeClassificationValidId"];
      this.passedFlag = _data["passedFlag"];
      this.processedFlag = _data["processedFlag"];
      this.overrideFlag = _data["overrideFlag"];
      this.statusText = _data["statusText"];
      this.ruleOutcomeJson = _data["ruleOutcomeJson"];
      this.orderValidation = _data["orderValidation"] ? OrderValidation.fromJS(_data["orderValidation"]) : <any>undefined;
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.orderLine = _data["orderLine"] ? OrderLine.fromJS(_data["orderLine"]) : <any>undefined;
      this.rule = _data["rule"] ? Rule.fromJS(_data["rule"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderValidationRuleOutcome {
    data = typeof data === 'object' ? data : {};
    let result = new OrderValidationRuleOutcome();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderValidationId"] = this.orderValidationId;
    data["orderId"] = this.orderId;
    data["orderLineId"] = this.orderLineId;
    data["ruleId"] = this.ruleId;
    data["orderValidationFailureOutcomeClassificationValueId"] = this.orderValidationFailureOutcomeClassificationValueId;
    data["ruleFailureTypeClassificationValidId"] = this.ruleFailureTypeClassificationValidId;
    data["passedFlag"] = this.passedFlag;
    data["processedFlag"] = this.processedFlag;
    data["overrideFlag"] = this.overrideFlag;
    data["statusText"] = this.statusText;
    data["ruleOutcomeJson"] = this.ruleOutcomeJson;
    data["orderValidation"] = this.orderValidation ? this.orderValidation.toJSON() : <any>undefined;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["orderLine"] = this.orderLine ? this.orderLine.toJSON() : <any>undefined;
    data["rule"] = this.rule ? this.rule.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderValidationRuleOutcome {
    const json = this.toJSON();
    let result = new OrderValidationRuleOutcome();
    result.init(json);
    return result;
  }
}

export interface IOrderValidationRuleOutcome {
  orderValidationId: string | undefined;
  orderId: string | undefined;
  orderLineId: string | undefined;
  ruleId: string | undefined;
  orderValidationFailureOutcomeClassificationValueId: string | undefined;
  ruleFailureTypeClassificationValidId: string | undefined;
  passedFlag: boolean | undefined;
  processedFlag: boolean | undefined;
  overrideFlag: boolean | undefined;
  statusText: string | undefined;
  ruleOutcomeJson: string | undefined;
  orderValidation: OrderValidation | undefined;
  order: Order | undefined;
  orderLine: OrderLine | undefined;
  rule: Rule | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AocInvestigationReason implements IAocInvestigationReason {
  aocId: string | undefined;
  aocInvestigationReasonClassificationValueId: string | undefined;
  aoc: Aoc | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAocInvestigationReason) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.aocId = _data["aocId"];
      this.aocInvestigationReasonClassificationValueId = _data["aocInvestigationReasonClassificationValueId"];
      this.aoc = _data["aoc"] ? Aoc.fromJS(_data["aoc"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AocInvestigationReason {
    data = typeof data === 'object' ? data : {};
    let result = new AocInvestigationReason();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["aocId"] = this.aocId;
    data["aocInvestigationReasonClassificationValueId"] = this.aocInvestigationReasonClassificationValueId;
    data["aoc"] = this.aoc ? this.aoc.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AocInvestigationReason {
    const json = this.toJSON();
    let result = new AocInvestigationReason();
    result.init(json);
    return result;
  }
}

export interface IAocInvestigationReason {
  aocId: string | undefined;
  aocInvestigationReasonClassificationValueId: string | undefined;
  aoc: Aoc | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AocLine implements IAocLine {
  aocId: string | undefined;
  externalLineItemId: string | undefined;
  productIdText: string | undefined;
  productId: string | undefined;
  productDescription: string | undefined;
  lotNumber: string | undefined;
  lotExpirationDate: Date | undefined;
  qty: number | undefined;
  aoc: Aoc | undefined;
  product: Product | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAocLine) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.aocId = _data["aocId"];
      this.externalLineItemId = _data["externalLineItemId"];
      this.productIdText = _data["productIdText"];
      this.productId = _data["productId"];
      this.productDescription = _data["productDescription"];
      this.lotNumber = _data["lotNumber"];
      this.lotExpirationDate = _data["lotExpirationDate"] ? new Date(_data["lotExpirationDate"].toString()) : <any>undefined;
      this.qty = _data["qty"];
      this.aoc = _data["aoc"] ? Aoc.fromJS(_data["aoc"]) : <any>undefined;
      this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AocLine {
    data = typeof data === 'object' ? data : {};
    let result = new AocLine();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["aocId"] = this.aocId;
    data["externalLineItemId"] = this.externalLineItemId;
    data["productIdText"] = this.productIdText;
    data["productId"] = this.productId;
    data["productDescription"] = this.productDescription;
    data["lotNumber"] = this.lotNumber;
    data["lotExpirationDate"] = this.lotExpirationDate ? this.lotExpirationDate.toISOString() : <any>undefined;
    data["qty"] = this.qty;
    data["aoc"] = this.aoc ? this.aoc.toJSON() : <any>undefined;
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AocLine {
    const json = this.toJSON();
    let result = new AocLine();
    result.init(json);
    return result;
  }
}

export interface IAocLine {
  aocId: string | undefined;
  externalLineItemId: string | undefined;
  productIdText: string | undefined;
  productId: string | undefined;
  productDescription: string | undefined;
  lotNumber: string | undefined;
  lotExpirationDate: Date | undefined;
  qty: number | undefined;
  aoc: Aoc | undefined;
  product: Product | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class SvlInvestigationReason implements ISvlInvestigationReason {
  svlId: string | undefined;
  svlInvestigationReasonClassificationValueId: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  svl: Svl | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ISvlInvestigationReason) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.svlId = _data["svlId"];
      this.svlInvestigationReasonClassificationValueId = _data["svlInvestigationReasonClassificationValueId"];
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.svl = _data["svl"] ? Svl.fromJS(_data["svl"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): SvlInvestigationReason {
    data = typeof data === 'object' ? data : {};
    let result = new SvlInvestigationReason();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["svlId"] = this.svlId;
    data["svlInvestigationReasonClassificationValueId"] = this.svlInvestigationReasonClassificationValueId;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["svl"] = this.svl ? this.svl.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): SvlInvestigationReason {
    const json = this.toJSON();
    let result = new SvlInvestigationReason();
    result.init(json);
    return result;
  }
}

export interface ISvlInvestigationReason {
  svlId: string | undefined;
  svlInvestigationReasonClassificationValueId: string | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  svl: Svl | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class SvlNegativeResponseComment implements ISvlNegativeResponseComment {
  svlId: string | undefined;
  negativeResponseComment: string | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  svl: Svl | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ISvlNegativeResponseComment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.svlId = _data["svlId"];
      this.negativeResponseComment = _data["negativeResponseComment"];
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.svl = _data["svl"] ? Svl.fromJS(_data["svl"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): SvlNegativeResponseComment {
    data = typeof data === 'object' ? data : {};
    let result = new SvlNegativeResponseComment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["svlId"] = this.svlId;
    data["negativeResponseComment"] = this.negativeResponseComment;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["svl"] = this.svl ? this.svl.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): SvlNegativeResponseComment {
    const json = this.toJSON();
    let result = new SvlNegativeResponseComment();
    result.init(json);
    return result;
  }
}

export interface ISvlNegativeResponseComment {
  svlId: string | undefined;
  negativeResponseComment: string | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  svl: Svl | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderReturnLine implements IOrderReturnLine {
  orderReturnId: string | undefined;
  wmsProductId: string | undefined;
  productId: string | undefined;
  returnedQuantity: number | undefined;
  serialNumbers: string | undefined;
  orderReturn: OrderReturn | undefined;
  product: Product | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderReturnLine) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderReturnId = _data["orderReturnId"];
      this.wmsProductId = _data["wmsProductId"];
      this.productId = _data["productId"];
      this.returnedQuantity = _data["returnedQuantity"];
      this.serialNumbers = _data["serialNumbers"];
      this.orderReturn = _data["orderReturn"] ? OrderReturn.fromJS(_data["orderReturn"]) : <any>undefined;
      this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderReturnLine {
    data = typeof data === 'object' ? data : {};
    let result = new OrderReturnLine();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderReturnId"] = this.orderReturnId;
    data["wmsProductId"] = this.wmsProductId;
    data["productId"] = this.productId;
    data["returnedQuantity"] = this.returnedQuantity;
    data["serialNumbers"] = this.serialNumbers;
    data["orderReturn"] = this.orderReturn ? this.orderReturn.toJSON() : <any>undefined;
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderReturnLine {
    const json = this.toJSON();
    let result = new OrderReturnLine();
    result.init(json);
    return result;
  }
}

export interface IOrderReturnLine {
  orderReturnId: string | undefined;
  wmsProductId: string | undefined;
  productId: string | undefined;
  returnedQuantity: number | undefined;
  serialNumbers: string | undefined;
  orderReturn: OrderReturn | undefined;
  product: Product | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class RrofrOrderStatusHistory implements IRrofrOrderStatusHistory {
  rrofrOrderId: string | undefined;
  rrofrOrderStatusClassificatonId: string | undefined;
  rrofrOrderStatus: ReferencedClassification | undefined;
  rrofrOrder: RrofrOrder | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IRrofrOrderStatusHistory) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rrofrOrderId = _data["rrofrOrderId"];
      this.rrofrOrderStatusClassificatonId = _data["rrofrOrderStatusClassificatonId"];
      this.rrofrOrderStatus = _data["rrofrOrderStatus"] ? ReferencedClassification.fromJS(_data["rrofrOrderStatus"]) : <any>undefined;
      this.rrofrOrder = _data["rrofrOrder"] ? RrofrOrder.fromJS(_data["rrofrOrder"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RrofrOrderStatusHistory {
    data = typeof data === 'object' ? data : {};
    let result = new RrofrOrderStatusHistory();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["rrofrOrderId"] = this.rrofrOrderId;
    data["rrofrOrderStatusClassificatonId"] = this.rrofrOrderStatusClassificatonId;
    data["rrofrOrderStatus"] = this.rrofrOrderStatus ? this.rrofrOrderStatus.toJSON() : <any>undefined;
    data["rrofrOrder"] = this.rrofrOrder ? this.rrofrOrder.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): RrofrOrderStatusHistory {
    const json = this.toJSON();
    let result = new RrofrOrderStatusHistory();
    result.init(json);
    return result;
  }
}

export interface IRrofrOrderStatusHistory {
  rrofrOrderId: string | undefined;
  rrofrOrderStatusClassificatonId: string | undefined;
  rrofrOrderStatus: ReferencedClassification | undefined;
  rrofrOrder: RrofrOrder | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class RrofrRespone implements IRrofrRespone {
  rrofrOrderLineId: string | undefined;
  rrofrOrderId: string | undefined;
  inboundRequest: string | undefined;
  outboundResponse: string | undefined;
  rrofrOrder: RrofrOrder | undefined;
  rrofrOrderLine: RrofrOrderLine | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IRrofrRespone) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rrofrOrderLineId = _data["rrofrOrderLineId"];
      this.rrofrOrderId = _data["rrofrOrderId"];
      this.inboundRequest = _data["inboundRequest"];
      this.outboundResponse = _data["outboundResponse"];
      this.rrofrOrder = _data["rrofrOrder"] ? RrofrOrder.fromJS(_data["rrofrOrder"]) : <any>undefined;
      this.rrofrOrderLine = _data["rrofrOrderLine"] ? RrofrOrderLine.fromJS(_data["rrofrOrderLine"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RrofrRespone {
    data = typeof data === 'object' ? data : {};
    let result = new RrofrRespone();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["rrofrOrderLineId"] = this.rrofrOrderLineId;
    data["rrofrOrderId"] = this.rrofrOrderId;
    data["inboundRequest"] = this.inboundRequest;
    data["outboundResponse"] = this.outboundResponse;
    data["rrofrOrder"] = this.rrofrOrder ? this.rrofrOrder.toJSON() : <any>undefined;
    data["rrofrOrderLine"] = this.rrofrOrderLine ? this.rrofrOrderLine.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): RrofrRespone {
    const json = this.toJSON();
    let result = new RrofrRespone();
    result.init(json);
    return result;
  }
}

export interface IRrofrRespone {
  rrofrOrderLineId: string | undefined;
  rrofrOrderId: string | undefined;
  inboundRequest: string | undefined;
  outboundResponse: string | undefined;
  rrofrOrder: RrofrOrder | undefined;
  rrofrOrderLine: RrofrOrderLine | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProductGroup implements IProductGroup {
  parentProductGroupId: string | undefined;
  rootProductGroupId: string | undefined;
  mainImageProductAttachmentId: string | undefined;
  productGroupCode: string | undefined;
  productGroupName: string | undefined;
  productGroupDesc: string | undefined;
  sortOrderNumber: number | undefined;
  topFlag: boolean | undefined;
  bottomFlag: boolean | undefined;
  commentsText: string | undefined;
  currentStatusDate: Date | undefined;
  currentStatusClassificationValueId: string | undefined;
  productGroupTypeClassificationValueId: string | undefined;
  sortPriorityFlag: boolean | undefined;
  hasBeenActivatedFlag: boolean | undefined;
  clientProductGroupId: string | undefined;
  clientBrandAbbreviation: string | undefined;
  distributedBy: string | undefined;
  manufacturedBy: string | undefined;
  therapeuticClassListJson: string | undefined;
  productAttachments: ProductAttachment[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProductGroup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parentProductGroupId = _data["parentProductGroupId"];
      this.rootProductGroupId = _data["rootProductGroupId"];
      this.mainImageProductAttachmentId = _data["mainImageProductAttachmentId"];
      this.productGroupCode = _data["productGroupCode"];
      this.productGroupName = _data["productGroupName"];
      this.productGroupDesc = _data["productGroupDesc"];
      this.sortOrderNumber = _data["sortOrderNumber"];
      this.topFlag = _data["topFlag"];
      this.bottomFlag = _data["bottomFlag"];
      this.commentsText = _data["commentsText"];
      this.currentStatusDate = _data["currentStatusDate"] ? new Date(_data["currentStatusDate"].toString()) : <any>undefined;
      this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
      this.productGroupTypeClassificationValueId = _data["productGroupTypeClassificationValueId"];
      this.sortPriorityFlag = _data["sortPriorityFlag"];
      this.hasBeenActivatedFlag = _data["hasBeenActivatedFlag"];
      this.clientProductGroupId = _data["clientProductGroupId"];
      this.clientBrandAbbreviation = _data["clientBrandAbbreviation"];
      this.distributedBy = _data["distributedBy"];
      this.manufacturedBy = _data["manufacturedBy"];
      this.therapeuticClassListJson = _data["therapeuticClassListJson"];
      if (Array.isArray(_data["productAttachments"])) {
        this.productAttachments = [] as any;
        for (let item of _data["productAttachments"])
          this.productAttachments.push(ProductAttachment.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProductGroup {
    data = typeof data === 'object' ? data : {};
    let result = new ProductGroup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["parentProductGroupId"] = this.parentProductGroupId;
    data["rootProductGroupId"] = this.rootProductGroupId;
    data["mainImageProductAttachmentId"] = this.mainImageProductAttachmentId;
    data["productGroupCode"] = this.productGroupCode;
    data["productGroupName"] = this.productGroupName;
    data["productGroupDesc"] = this.productGroupDesc;
    data["sortOrderNumber"] = this.sortOrderNumber;
    data["topFlag"] = this.topFlag;
    data["bottomFlag"] = this.bottomFlag;
    data["commentsText"] = this.commentsText;
    data["currentStatusDate"] = this.currentStatusDate ? this.currentStatusDate.toISOString() : <any>undefined;
    data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
    data["productGroupTypeClassificationValueId"] = this.productGroupTypeClassificationValueId;
    data["sortPriorityFlag"] = this.sortPriorityFlag;
    data["hasBeenActivatedFlag"] = this.hasBeenActivatedFlag;
    data["clientProductGroupId"] = this.clientProductGroupId;
    data["clientBrandAbbreviation"] = this.clientBrandAbbreviation;
    data["distributedBy"] = this.distributedBy;
    data["manufacturedBy"] = this.manufacturedBy;
    data["therapeuticClassListJson"] = this.therapeuticClassListJson;
    if (Array.isArray(this.productAttachments)) {
      data["productAttachments"] = [];
      for (let item of this.productAttachments)
        data["productAttachments"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProductGroup {
    const json = this.toJSON();
    let result = new ProductGroup();
    result.init(json);
    return result;
  }
}

export interface IProductGroup {
  parentProductGroupId: string | undefined;
  rootProductGroupId: string | undefined;
  mainImageProductAttachmentId: string | undefined;
  productGroupCode: string | undefined;
  productGroupName: string | undefined;
  productGroupDesc: string | undefined;
  sortOrderNumber: number | undefined;
  topFlag: boolean | undefined;
  bottomFlag: boolean | undefined;
  commentsText: string | undefined;
  currentStatusDate: Date | undefined;
  currentStatusClassificationValueId: string | undefined;
  productGroupTypeClassificationValueId: string | undefined;
  sortPriorityFlag: boolean | undefined;
  hasBeenActivatedFlag: boolean | undefined;
  clientProductGroupId: string | undefined;
  clientBrandAbbreviation: string | undefined;
  distributedBy: string | undefined;
  manufacturedBy: string | undefined;
  therapeuticClassListJson: string | undefined;
  productAttachments: ProductAttachment[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HcpDoNotHonorExclusionAttachment implements IHcpDoNotHonorExclusionAttachment {
  attachmentLocationText: string | undefined;
  commentsText: string | undefined;
  attachmentName: string | undefined;
  sequenceNbr: number | undefined;
  attachmentDesc: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHcpDoNotHonorExclusionAttachment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.attachmentLocationText = _data["attachmentLocationText"];
      this.commentsText = _data["commentsText"];
      this.attachmentName = _data["attachmentName"];
      this.sequenceNbr = _data["sequenceNbr"];
      this.attachmentDesc = _data["attachmentDesc"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HcpDoNotHonorExclusionAttachment {
    data = typeof data === 'object' ? data : {};
    let result = new HcpDoNotHonorExclusionAttachment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["attachmentLocationText"] = this.attachmentLocationText;
    data["commentsText"] = this.commentsText;
    data["attachmentName"] = this.attachmentName;
    data["sequenceNbr"] = this.sequenceNbr;
    data["attachmentDesc"] = this.attachmentDesc;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HcpDoNotHonorExclusionAttachment {
    const json = this.toJSON();
    let result = new HcpDoNotHonorExclusionAttachment();
    result.init(json);
    return result;
  }
}

export interface IHcpDoNotHonorExclusionAttachment {
  attachmentLocationText: string | undefined;
  commentsText: string | undefined;
  attachmentName: string | undefined;
  sequenceNbr: number | undefined;
  attachmentDesc: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class CustomerDeliveryAddress implements ICustomerDeliveryAddress {
  isActive: boolean | undefined;
  customerId: string | undefined;
  addressLocationId: string | undefined;
  addressLocationRoles: string | undefined;
  addressDescription: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  lineOfBusinessCode: string | undefined;
  customerTypeClassificationValueId: string | undefined;
  attention: string | undefined;
  customerShipToNumber: string | undefined;
  shipToEmail: string | undefined;
  orderInvoices: OrderInvoice[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ICustomerDeliveryAddress) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isActive = _data["isActive"];
      this.customerId = _data["customerId"];
      this.addressLocationId = _data["addressLocationId"];
      this.addressLocationRoles = _data["addressLocationRoles"];
      this.addressDescription = _data["addressDescription"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.address3Text = _data["address3Text"];
      this.address4Text = _data["address4Text"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.stateCode = _data["stateCode"];
      this.countryCode = _data["countryCode"];
      this.lineOfBusinessCode = _data["lineOfBusinessCode"];
      this.customerTypeClassificationValueId = _data["customerTypeClassificationValueId"];
      this.attention = _data["attention"];
      this.customerShipToNumber = _data["customerShipToNumber"];
      this.shipToEmail = _data["shipToEmail"];
      if (Array.isArray(_data["orderInvoices"])) {
        this.orderInvoices = [] as any;
        for (let item of _data["orderInvoices"])
          this.orderInvoices.push(OrderInvoice.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CustomerDeliveryAddress {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerDeliveryAddress();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isActive"] = this.isActive;
    data["customerId"] = this.customerId;
    data["addressLocationId"] = this.addressLocationId;
    data["addressLocationRoles"] = this.addressLocationRoles;
    data["addressDescription"] = this.addressDescription;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["address3Text"] = this.address3Text;
    data["address4Text"] = this.address4Text;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["stateCode"] = this.stateCode;
    data["countryCode"] = this.countryCode;
    data["lineOfBusinessCode"] = this.lineOfBusinessCode;
    data["customerTypeClassificationValueId"] = this.customerTypeClassificationValueId;
    data["attention"] = this.attention;
    data["customerShipToNumber"] = this.customerShipToNumber;
    data["shipToEmail"] = this.shipToEmail;
    if (Array.isArray(this.orderInvoices)) {
      data["orderInvoices"] = [];
      for (let item of this.orderInvoices)
        data["orderInvoices"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): CustomerDeliveryAddress {
    const json = this.toJSON();
    let result = new CustomerDeliveryAddress();
    result.init(json);
    return result;
  }
}

export interface ICustomerDeliveryAddress {
  isActive: boolean | undefined;
  customerId: string | undefined;
  addressLocationId: string | undefined;
  addressLocationRoles: string | undefined;
  addressDescription: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  lineOfBusinessCode: string | undefined;
  customerTypeClassificationValueId: string | undefined;
  attention: string | undefined;
  customerShipToNumber: string | undefined;
  shipToEmail: string | undefined;
  orderInvoices: OrderInvoice[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Pharmacy implements IPharmacy {
  pharmacyName: string | undefined;
  knipperId: string | undefined;
  clientPharmacyId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  knipperCreateFlag: boolean | undefined;
  contactMethods: PharmacyContactMethod[] | undefined;
  addresses: PharmacyAddress[] | undefined;
  licenses: PharmacyLicense[] | undefined;
  pharmacyHospital: PharmacyHospital[] | undefined;
  pharmacistPharmacy: PharmacistPharmacy[] | undefined;
  pharmacyProgram: PharmacyProgram[] | undefined;
  currentStatus: ReferencedClassification | undefined;
  certificationDetail: CertificationDetail[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacy) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacyName = _data["pharmacyName"];
      this.knipperId = _data["knipperId"];
      this.clientPharmacyId = _data["clientPharmacyId"];
      this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      if (Array.isArray(_data["contactMethods"])) {
        this.contactMethods = [] as any;
        for (let item of _data["contactMethods"])
          this.contactMethods.push(PharmacyContactMethod.fromJS(item));
      }
      if (Array.isArray(_data["addresses"])) {
        this.addresses = [] as any;
        for (let item of _data["addresses"])
          this.addresses.push(PharmacyAddress.fromJS(item));
      }
      if (Array.isArray(_data["licenses"])) {
        this.licenses = [] as any;
        for (let item of _data["licenses"])
          this.licenses.push(PharmacyLicense.fromJS(item));
      }
      if (Array.isArray(_data["pharmacyHospital"])) {
        this.pharmacyHospital = [] as any;
        for (let item of _data["pharmacyHospital"])
          this.pharmacyHospital.push(PharmacyHospital.fromJS(item));
      }
      if (Array.isArray(_data["pharmacistPharmacy"])) {
        this.pharmacistPharmacy = [] as any;
        for (let item of _data["pharmacistPharmacy"])
          this.pharmacistPharmacy.push(PharmacistPharmacy.fromJS(item));
      }
      if (Array.isArray(_data["pharmacyProgram"])) {
        this.pharmacyProgram = [] as any;
        for (let item of _data["pharmacyProgram"])
          this.pharmacyProgram.push(PharmacyProgram.fromJS(item));
      }
      this.currentStatus = _data["currentStatus"] ? ReferencedClassification.fromJS(_data["currentStatus"]) : <any>undefined;
      if (Array.isArray(_data["certificationDetail"])) {
        this.certificationDetail = [] as any;
        for (let item of _data["certificationDetail"])
          this.certificationDetail.push(CertificationDetail.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Pharmacy {
    data = typeof data === 'object' ? data : {};
    let result = new Pharmacy();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacyName"] = this.pharmacyName;
    data["knipperId"] = this.knipperId;
    data["clientPharmacyId"] = this.clientPharmacyId;
    data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    if (Array.isArray(this.contactMethods)) {
      data["contactMethods"] = [];
      for (let item of this.contactMethods)
        data["contactMethods"].push(item.toJSON());
    }
    if (Array.isArray(this.addresses)) {
      data["addresses"] = [];
      for (let item of this.addresses)
        data["addresses"].push(item.toJSON());
    }
    if (Array.isArray(this.licenses)) {
      data["licenses"] = [];
      for (let item of this.licenses)
        data["licenses"].push(item.toJSON());
    }
    if (Array.isArray(this.pharmacyHospital)) {
      data["pharmacyHospital"] = [];
      for (let item of this.pharmacyHospital)
        data["pharmacyHospital"].push(item.toJSON());
    }
    if (Array.isArray(this.pharmacistPharmacy)) {
      data["pharmacistPharmacy"] = [];
      for (let item of this.pharmacistPharmacy)
        data["pharmacistPharmacy"].push(item.toJSON());
    }
    if (Array.isArray(this.pharmacyProgram)) {
      data["pharmacyProgram"] = [];
      for (let item of this.pharmacyProgram)
        data["pharmacyProgram"].push(item.toJSON());
    }
    data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
    if (Array.isArray(this.certificationDetail)) {
      data["certificationDetail"] = [];
      for (let item of this.certificationDetail)
        data["certificationDetail"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Pharmacy {
    const json = this.toJSON();
    let result = new Pharmacy();
    result.init(json);
    return result;
  }
}

export interface IPharmacy {
  pharmacyName: string | undefined;
  knipperId: string | undefined;
  clientPharmacyId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  knipperCreateFlag: boolean | undefined;
  contactMethods: PharmacyContactMethod[] | undefined;
  addresses: PharmacyAddress[] | undefined;
  licenses: PharmacyLicense[] | undefined;
  pharmacyHospital: PharmacyHospital[] | undefined;
  pharmacistPharmacy: PharmacistPharmacy[] | undefined;
  pharmacyProgram: PharmacyProgram[] | undefined;
  currentStatus: ReferencedClassification | undefined;
  certificationDetail: CertificationDetail[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Hospital implements IHospital {
  knipperId: string | undefined;
  clientHospitalId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  programEnrolled: string | undefined;
  enrollmentId: string | undefined;
  hospitalName: string | undefined;
  knipperCreateFlag: boolean | undefined;
  pharmacyHospital: PharmacyHospital[] | undefined;
  pharmacistHospital: PharmacistHospital[] | undefined;
  contactMethods: HospitalContactMethod[] | undefined;
  addresses: HospitalAddress[] | undefined;
  licenses: HospitalLicense[] | undefined;
  hospitalPrograms: HospitalProgram[] | undefined;
  currentStatus: ReferencedClassification | undefined;
  certificationDetail: CertificationDetail[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHospital) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.knipperId = _data["knipperId"];
      this.clientHospitalId = _data["clientHospitalId"];
      this.currentStatusClassificationValueId = _data["currentStatusClassificationValueId"];
      this.programEnrolled = _data["programEnrolled"];
      this.enrollmentId = _data["enrollmentId"];
      this.hospitalName = _data["hospitalName"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      if (Array.isArray(_data["pharmacyHospital"])) {
        this.pharmacyHospital = [] as any;
        for (let item of _data["pharmacyHospital"])
          this.pharmacyHospital.push(PharmacyHospital.fromJS(item));
      }
      if (Array.isArray(_data["pharmacistHospital"])) {
        this.pharmacistHospital = [] as any;
        for (let item of _data["pharmacistHospital"])
          this.pharmacistHospital.push(PharmacistHospital.fromJS(item));
      }
      if (Array.isArray(_data["contactMethods"])) {
        this.contactMethods = [] as any;
        for (let item of _data["contactMethods"])
          this.contactMethods.push(HospitalContactMethod.fromJS(item));
      }
      if (Array.isArray(_data["addresses"])) {
        this.addresses = [] as any;
        for (let item of _data["addresses"])
          this.addresses.push(HospitalAddress.fromJS(item));
      }
      if (Array.isArray(_data["licenses"])) {
        this.licenses = [] as any;
        for (let item of _data["licenses"])
          this.licenses.push(HospitalLicense.fromJS(item));
      }
      if (Array.isArray(_data["hospitalPrograms"])) {
        this.hospitalPrograms = [] as any;
        for (let item of _data["hospitalPrograms"])
          this.hospitalPrograms.push(HospitalProgram.fromJS(item));
      }
      this.currentStatus = _data["currentStatus"] ? ReferencedClassification.fromJS(_data["currentStatus"]) : <any>undefined;
      if (Array.isArray(_data["certificationDetail"])) {
        this.certificationDetail = [] as any;
        for (let item of _data["certificationDetail"])
          this.certificationDetail.push(CertificationDetail.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Hospital {
    data = typeof data === 'object' ? data : {};
    let result = new Hospital();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["knipperId"] = this.knipperId;
    data["clientHospitalId"] = this.clientHospitalId;
    data["currentStatusClassificationValueId"] = this.currentStatusClassificationValueId;
    data["programEnrolled"] = this.programEnrolled;
    data["enrollmentId"] = this.enrollmentId;
    data["hospitalName"] = this.hospitalName;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    if (Array.isArray(this.pharmacyHospital)) {
      data["pharmacyHospital"] = [];
      for (let item of this.pharmacyHospital)
        data["pharmacyHospital"].push(item.toJSON());
    }
    if (Array.isArray(this.pharmacistHospital)) {
      data["pharmacistHospital"] = [];
      for (let item of this.pharmacistHospital)
        data["pharmacistHospital"].push(item.toJSON());
    }
    if (Array.isArray(this.contactMethods)) {
      data["contactMethods"] = [];
      for (let item of this.contactMethods)
        data["contactMethods"].push(item.toJSON());
    }
    if (Array.isArray(this.addresses)) {
      data["addresses"] = [];
      for (let item of this.addresses)
        data["addresses"].push(item.toJSON());
    }
    if (Array.isArray(this.licenses)) {
      data["licenses"] = [];
      for (let item of this.licenses)
        data["licenses"].push(item.toJSON());
    }
    if (Array.isArray(this.hospitalPrograms)) {
      data["hospitalPrograms"] = [];
      for (let item of this.hospitalPrograms)
        data["hospitalPrograms"].push(item.toJSON());
    }
    data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
    if (Array.isArray(this.certificationDetail)) {
      data["certificationDetail"] = [];
      for (let item of this.certificationDetail)
        data["certificationDetail"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Hospital {
    const json = this.toJSON();
    let result = new Hospital();
    result.init(json);
    return result;
  }
}

export interface IHospital {
  knipperId: string | undefined;
  clientHospitalId: string | undefined;
  currentStatusClassificationValueId: string | undefined;
  programEnrolled: string | undefined;
  enrollmentId: string | undefined;
  hospitalName: string | undefined;
  knipperCreateFlag: boolean | undefined;
  pharmacyHospital: PharmacyHospital[] | undefined;
  pharmacistHospital: PharmacistHospital[] | undefined;
  contactMethods: HospitalContactMethod[] | undefined;
  addresses: HospitalAddress[] | undefined;
  licenses: HospitalLicense[] | undefined;
  hospitalPrograms: HospitalProgram[] | undefined;
  currentStatus: ReferencedClassification | undefined;
  certificationDetail: CertificationDetail[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class FgOrderHcp implements IFgOrderHcp {
  orderId: string | undefined;
  hcpId: string | undefined;
  order: Order | undefined;
  hcp: Hcp | undefined;
  orderLines: FgOrderHcpOrderLine[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IFgOrderHcp) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.hcpId = _data["hcpId"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.hcp = _data["hcp"] ? Hcp.fromJS(_data["hcp"]) : <any>undefined;
      if (Array.isArray(_data["orderLines"])) {
        this.orderLines = [] as any;
        for (let item of _data["orderLines"])
          this.orderLines.push(FgOrderHcpOrderLine.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): FgOrderHcp {
    data = typeof data === 'object' ? data : {};
    let result = new FgOrderHcp();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["hcpId"] = this.hcpId;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["hcp"] = this.hcp ? this.hcp.toJSON() : <any>undefined;
    if (Array.isArray(this.orderLines)) {
      data["orderLines"] = [];
      for (let item of this.orderLines)
        data["orderLines"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): FgOrderHcp {
    const json = this.toJSON();
    let result = new FgOrderHcp();
    result.init(json);
    return result;
  }
}

export interface IFgOrderHcp {
  orderId: string | undefined;
  hcpId: string | undefined;
  order: Order | undefined;
  hcp: Hcp | undefined;
  orderLines: FgOrderHcpOrderLine[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProgramHcpProduct implements IProgramHcpProduct {
  productId: string | undefined;
  programHcpId: string | undefined;
  decileClassificationValueId: string | undefined;
  product: Product | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProgramHcpProduct) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productId = _data["productId"];
      this.programHcpId = _data["programHcpId"];
      this.decileClassificationValueId = _data["decileClassificationValueId"];
      this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProgramHcpProduct {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramHcpProduct();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["productId"] = this.productId;
    data["programHcpId"] = this.programHcpId;
    data["decileClassificationValueId"] = this.decileClassificationValueId;
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProgramHcpProduct {
    const json = this.toJSON();
    let result = new ProgramHcpProduct();
    result.init(json);
    return result;
  }
}

export interface IProgramHcpProduct {
  productId: string | undefined;
  programHcpId: string | undefined;
  decileClassificationValueId: string | undefined;
  product: Product | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HospitalProgram implements IHospitalProgram {
  hospitalId: string | undefined;
  programId: string | undefined;
  program: Program | undefined;
  hospital: Hospital | undefined;
  readonly programName: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHospitalProgram) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hospitalId = _data["hospitalId"];
      this.programId = _data["programId"];
      this.program = _data["program"] ? Program.fromJS(_data["program"]) : <any>undefined;
      this.hospital = _data["hospital"] ? Hospital.fromJS(_data["hospital"]) : <any>undefined;
      (<any>this).programName = _data["programName"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HospitalProgram {
    data = typeof data === 'object' ? data : {};
    let result = new HospitalProgram();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hospitalId"] = this.hospitalId;
    data["programId"] = this.programId;
    data["program"] = this.program ? this.program.toJSON() : <any>undefined;
    data["hospital"] = this.hospital ? this.hospital.toJSON() : <any>undefined;
    data["programName"] = this.programName;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HospitalProgram {
    const json = this.toJSON();
    let result = new HospitalProgram();
    result.init(json);
    return result;
  }
}

export interface IHospitalProgram {
  hospitalId: string | undefined;
  programId: string | undefined;
  program: Program | undefined;
  hospital: Hospital | undefined;
  programName: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationProduct implements ITplProgramConfigurationProduct {
  dtpProgramConfigurationId: string | undefined;
  productId: string | undefined;
  handwrittenQtyFlag: boolean | undefined;
  offeredQty: number | undefined;
  pageNbr: number | undefined;
  displayOrderNbr: number | undefined;
  srfIncludeFlag: boolean | undefined;
  product: Product | undefined;
  dtpProgramConfigurationProductDeciles: TplProgramConfigurationProductDecile[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationProduct) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.productId = _data["productId"];
      this.handwrittenQtyFlag = _data["handwrittenQtyFlag"];
      this.offeredQty = _data["offeredQty"];
      this.pageNbr = _data["pageNbr"];
      this.displayOrderNbr = _data["displayOrderNbr"];
      this.srfIncludeFlag = _data["srfIncludeFlag"];
      this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
      if (Array.isArray(_data["dtpProgramConfigurationProductDeciles"])) {
        this.dtpProgramConfigurationProductDeciles = [] as any;
        for (let item of _data["dtpProgramConfigurationProductDeciles"])
          this.dtpProgramConfigurationProductDeciles.push(TplProgramConfigurationProductDecile.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationProduct {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationProduct();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["productId"] = this.productId;
    data["handwrittenQtyFlag"] = this.handwrittenQtyFlag;
    data["offeredQty"] = this.offeredQty;
    data["pageNbr"] = this.pageNbr;
    data["displayOrderNbr"] = this.displayOrderNbr;
    data["srfIncludeFlag"] = this.srfIncludeFlag;
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    if (Array.isArray(this.dtpProgramConfigurationProductDeciles)) {
      data["dtpProgramConfigurationProductDeciles"] = [];
      for (let item of this.dtpProgramConfigurationProductDeciles)
        data["dtpProgramConfigurationProductDeciles"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationProduct {
    const json = this.toJSON();
    let result = new TplProgramConfigurationProduct();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationProduct {
  dtpProgramConfigurationId: string | undefined;
  productId: string | undefined;
  handwrittenQtyFlag: boolean | undefined;
  offeredQty: number | undefined;
  pageNbr: number | undefined;
  displayOrderNbr: number | undefined;
  srfIncludeFlag: boolean | undefined;
  product: Product | undefined;
  dtpProgramConfigurationProductDeciles: TplProgramConfigurationProductDecile[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationSrf implements ITplProgramConfigurationSrf {
  dtpProgramConfigurationId: string | undefined;
  generatorClassificationValueId: string | undefined;
  srfTypeClassificationValueId: string | undefined;
  sourceClassificationValueId: string | undefined;
  offerTypeClassificationValueId: string | undefined;
  paperSourceNbr: number | undefined;
  receiveOfferDataFlag: boolean | undefined;
  paperSourceName: string | undefined;
  srfResentFlag: boolean | undefined;
  srfResentBusinessDays: number | undefined;
  maxSrfResentCount: number | undefined;
  dtpProgramConfigurationDocumentTemplates: TplProgramConfigurationDocumentTemplate[] | undefined;
  dtpProgramConfigurationOfferSources: TplProgramConfigurationOfferSource[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationSrf) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.generatorClassificationValueId = _data["generatorClassificationValueId"];
      this.srfTypeClassificationValueId = _data["srfTypeClassificationValueId"];
      this.sourceClassificationValueId = _data["sourceClassificationValueId"];
      this.offerTypeClassificationValueId = _data["offerTypeClassificationValueId"];
      this.paperSourceNbr = _data["paperSourceNbr"];
      this.receiveOfferDataFlag = _data["receiveOfferDataFlag"];
      this.paperSourceName = _data["paperSourceName"];
      this.srfResentFlag = _data["srfResentFlag"];
      this.srfResentBusinessDays = _data["srfResentBusinessDays"];
      this.maxSrfResentCount = _data["maxSrfResentCount"];
      if (Array.isArray(_data["dtpProgramConfigurationDocumentTemplates"])) {
        this.dtpProgramConfigurationDocumentTemplates = [] as any;
        for (let item of _data["dtpProgramConfigurationDocumentTemplates"])
          this.dtpProgramConfigurationDocumentTemplates.push(TplProgramConfigurationDocumentTemplate.fromJS(item));
      }
      if (Array.isArray(_data["dtpProgramConfigurationOfferSources"])) {
        this.dtpProgramConfigurationOfferSources = [] as any;
        for (let item of _data["dtpProgramConfigurationOfferSources"])
          this.dtpProgramConfigurationOfferSources.push(TplProgramConfigurationOfferSource.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationSrf {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationSrf();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["generatorClassificationValueId"] = this.generatorClassificationValueId;
    data["srfTypeClassificationValueId"] = this.srfTypeClassificationValueId;
    data["sourceClassificationValueId"] = this.sourceClassificationValueId;
    data["offerTypeClassificationValueId"] = this.offerTypeClassificationValueId;
    data["paperSourceNbr"] = this.paperSourceNbr;
    data["receiveOfferDataFlag"] = this.receiveOfferDataFlag;
    data["paperSourceName"] = this.paperSourceName;
    data["srfResentFlag"] = this.srfResentFlag;
    data["srfResentBusinessDays"] = this.srfResentBusinessDays;
    data["maxSrfResentCount"] = this.maxSrfResentCount;
    if (Array.isArray(this.dtpProgramConfigurationDocumentTemplates)) {
      data["dtpProgramConfigurationDocumentTemplates"] = [];
      for (let item of this.dtpProgramConfigurationDocumentTemplates)
        data["dtpProgramConfigurationDocumentTemplates"].push(item.toJSON());
    }
    if (Array.isArray(this.dtpProgramConfigurationOfferSources)) {
      data["dtpProgramConfigurationOfferSources"] = [];
      for (let item of this.dtpProgramConfigurationOfferSources)
        data["dtpProgramConfigurationOfferSources"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationSrf {
    const json = this.toJSON();
    let result = new TplProgramConfigurationSrf();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationSrf {
  dtpProgramConfigurationId: string | undefined;
  generatorClassificationValueId: string | undefined;
  srfTypeClassificationValueId: string | undefined;
  sourceClassificationValueId: string | undefined;
  offerTypeClassificationValueId: string | undefined;
  paperSourceNbr: number | undefined;
  receiveOfferDataFlag: boolean | undefined;
  paperSourceName: string | undefined;
  srfResentFlag: boolean | undefined;
  srfResentBusinessDays: number | undefined;
  maxSrfResentCount: number | undefined;
  dtpProgramConfigurationDocumentTemplates: TplProgramConfigurationDocumentTemplate[] | undefined;
  dtpProgramConfigurationOfferSources: TplProgramConfigurationOfferSource[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationProductType implements ITplProgramConfigurationProductType {
  dtpProgramConfigurationId: string | undefined;
  productTypeId: string | undefined;
  carrierId: string | undefined;
  carrierServiceTypeId: string | undefined;
  secondaryCarrierServiceTypeId: string | undefined;
  nationalBlackoutHoldFlag: boolean | undefined;
  secondaryCarrierServiceStatesJson: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationProductType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.productTypeId = _data["productTypeId"];
      this.carrierId = _data["carrierId"];
      this.carrierServiceTypeId = _data["carrierServiceTypeId"];
      this.secondaryCarrierServiceTypeId = _data["secondaryCarrierServiceTypeId"];
      this.nationalBlackoutHoldFlag = _data["nationalBlackoutHoldFlag"];
      this.secondaryCarrierServiceStatesJson = _data["secondaryCarrierServiceStatesJson"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationProductType {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationProductType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["productTypeId"] = this.productTypeId;
    data["carrierId"] = this.carrierId;
    data["carrierServiceTypeId"] = this.carrierServiceTypeId;
    data["secondaryCarrierServiceTypeId"] = this.secondaryCarrierServiceTypeId;
    data["nationalBlackoutHoldFlag"] = this.nationalBlackoutHoldFlag;
    data["secondaryCarrierServiceStatesJson"] = this.secondaryCarrierServiceStatesJson;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationProductType {
    const json = this.toJSON();
    let result = new TplProgramConfigurationProductType();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationProductType {
  dtpProgramConfigurationId: string | undefined;
  productTypeId: string | undefined;
  carrierId: string | undefined;
  carrierServiceTypeId: string | undefined;
  secondaryCarrierServiceTypeId: string | undefined;
  nationalBlackoutHoldFlag: boolean | undefined;
  secondaryCarrierServiceStatesJson: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class RuleConfiguration implements IRuleConfiguration {
  dtpProgramConfigurationId: string | undefined;
  configurationTypeClassificationValueId: string | undefined;
  configurationCode: string | undefined;
  configurationName: string | undefined;
  commentsText: string | undefined;
  ruleCriteriaJson: string | undefined;
  activeFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IRuleConfiguration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.configurationTypeClassificationValueId = _data["configurationTypeClassificationValueId"];
      this.configurationCode = _data["configurationCode"];
      this.configurationName = _data["configurationName"];
      this.commentsText = _data["commentsText"];
      this.ruleCriteriaJson = _data["ruleCriteriaJson"];
      this.activeFlag = _data["activeFlag"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RuleConfiguration {
    data = typeof data === 'object' ? data : {};
    let result = new RuleConfiguration();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["configurationTypeClassificationValueId"] = this.configurationTypeClassificationValueId;
    data["configurationCode"] = this.configurationCode;
    data["configurationName"] = this.configurationName;
    data["commentsText"] = this.commentsText;
    data["ruleCriteriaJson"] = this.ruleCriteriaJson;
    data["activeFlag"] = this.activeFlag;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): RuleConfiguration {
    const json = this.toJSON();
    let result = new RuleConfiguration();
    result.init(json);
    return result;
  }
}

export interface IRuleConfiguration {
  dtpProgramConfigurationId: string | undefined;
  configurationTypeClassificationValueId: string | undefined;
  configurationCode: string | undefined;
  configurationName: string | undefined;
  commentsText: string | undefined;
  ruleCriteriaJson: string | undefined;
  activeFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationCellSheetEmail implements ITplProgramConfigurationCellSheetEmail {
  dtpProgramConfigurationId: string | undefined;
  emailAddressText: string | undefined;
  dtpProgramConfiguration: TplProgramConfiguration | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationCellSheetEmail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.emailAddressText = _data["emailAddressText"];
      this.dtpProgramConfiguration = _data["dtpProgramConfiguration"] ? TplProgramConfiguration.fromJS(_data["dtpProgramConfiguration"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationCellSheetEmail {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationCellSheetEmail();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["emailAddressText"] = this.emailAddressText;
    data["dtpProgramConfiguration"] = this.dtpProgramConfiguration ? this.dtpProgramConfiguration.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationCellSheetEmail {
    const json = this.toJSON();
    let result = new TplProgramConfigurationCellSheetEmail();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationCellSheetEmail {
  dtpProgramConfigurationId: string | undefined;
  emailAddressText: string | undefined;
  dtpProgramConfiguration: TplProgramConfiguration | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationAoc implements ITplProgramConfigurationAoc {
  dtpProgramConfigurationId: string | undefined;
  aocFollowUpLettersCountClassificationValueId: string | undefined;
  triggerDaysCount: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationAoc) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.aocFollowUpLettersCountClassificationValueId = _data["aocFollowUpLettersCountClassificationValueId"];
      this.triggerDaysCount = _data["triggerDaysCount"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationAoc {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationAoc();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["aocFollowUpLettersCountClassificationValueId"] = this.aocFollowUpLettersCountClassificationValueId;
    data["triggerDaysCount"] = this.triggerDaysCount;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationAoc {
    const json = this.toJSON();
    let result = new TplProgramConfigurationAoc();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationAoc {
  dtpProgramConfigurationId: string | undefined;
  aocFollowUpLettersCountClassificationValueId: string | undefined;
  triggerDaysCount: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationNonCompliantAoc implements ITplProgramConfigurationNonCompliantAoc {
  dtpProgramConfigurationId: string | undefined;
  hcpForgivenessFlag: boolean | undefined;
  hcpForgivenessMonthsCount: number | undefined;
  numberOfHcpForgiveChances: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationNonCompliantAoc) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.hcpForgivenessFlag = _data["hcpForgivenessFlag"];
      this.hcpForgivenessMonthsCount = _data["hcpForgivenessMonthsCount"];
      this.numberOfHcpForgiveChances = _data["numberOfHcpForgiveChances"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationNonCompliantAoc {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationNonCompliantAoc();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["hcpForgivenessFlag"] = this.hcpForgivenessFlag;
    data["hcpForgivenessMonthsCount"] = this.hcpForgivenessMonthsCount;
    data["numberOfHcpForgiveChances"] = this.numberOfHcpForgiveChances;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationNonCompliantAoc {
    const json = this.toJSON();
    let result = new TplProgramConfigurationNonCompliantAoc();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationNonCompliantAoc {
  dtpProgramConfigurationId: string | undefined;
  hcpForgivenessFlag: boolean | undefined;
  hcpForgivenessMonthsCount: number | undefined;
  numberOfHcpForgiveChances: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationCommunicationMethod implements ITplProgramConfigurationCommunicationMethod {
  dtpProgramConfigurationId: string | undefined;
  communicationCategoryClassificationValueId: string | undefined;
  communicationTypeClassificationValueId: string | undefined;
  communicationMethodClassificationValueId: string | undefined;
  hcpCommunicationPreferenceFlag: boolean | undefined;
  repCommunicationPreferenceFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationCommunicationMethod) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.communicationCategoryClassificationValueId = _data["communicationCategoryClassificationValueId"];
      this.communicationTypeClassificationValueId = _data["communicationTypeClassificationValueId"];
      this.communicationMethodClassificationValueId = _data["communicationMethodClassificationValueId"];
      this.hcpCommunicationPreferenceFlag = _data["hcpCommunicationPreferenceFlag"];
      this.repCommunicationPreferenceFlag = _data["repCommunicationPreferenceFlag"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationCommunicationMethod {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationCommunicationMethod();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["communicationCategoryClassificationValueId"] = this.communicationCategoryClassificationValueId;
    data["communicationTypeClassificationValueId"] = this.communicationTypeClassificationValueId;
    data["communicationMethodClassificationValueId"] = this.communicationMethodClassificationValueId;
    data["hcpCommunicationPreferenceFlag"] = this.hcpCommunicationPreferenceFlag;
    data["repCommunicationPreferenceFlag"] = this.repCommunicationPreferenceFlag;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationCommunicationMethod {
    const json = this.toJSON();
    let result = new TplProgramConfigurationCommunicationMethod();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationCommunicationMethod {
  dtpProgramConfigurationId: string | undefined;
  communicationCategoryClassificationValueId: string | undefined;
  communicationTypeClassificationValueId: string | undefined;
  communicationMethodClassificationValueId: string | undefined;
  hcpCommunicationPreferenceFlag: boolean | undefined;
  repCommunicationPreferenceFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationNotification implements ITplProgramConfigurationNotification {
  dtpProgramConfigurationId: string | undefined;
  notificationTypeId: string | undefined;
  orderSourceExclusionJson: string | undefined;
  dtpProgramConfigurationNotificationRecipients: TplProgramConfigurationNotificationRecipient[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationNotification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.notificationTypeId = _data["notificationTypeId"];
      this.orderSourceExclusionJson = _data["orderSourceExclusionJson"];
      if (Array.isArray(_data["dtpProgramConfigurationNotificationRecipients"])) {
        this.dtpProgramConfigurationNotificationRecipients = [] as any;
        for (let item of _data["dtpProgramConfigurationNotificationRecipients"])
          this.dtpProgramConfigurationNotificationRecipients.push(TplProgramConfigurationNotificationRecipient.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationNotification {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationNotification();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["notificationTypeId"] = this.notificationTypeId;
    data["orderSourceExclusionJson"] = this.orderSourceExclusionJson;
    if (Array.isArray(this.dtpProgramConfigurationNotificationRecipients)) {
      data["dtpProgramConfigurationNotificationRecipients"] = [];
      for (let item of this.dtpProgramConfigurationNotificationRecipients)
        data["dtpProgramConfigurationNotificationRecipients"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationNotification {
    const json = this.toJSON();
    let result = new TplProgramConfigurationNotification();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationNotification {
  dtpProgramConfigurationId: string | undefined;
  notificationTypeId: string | undefined;
  orderSourceExclusionJson: string | undefined;
  dtpProgramConfigurationNotificationRecipients: TplProgramConfigurationNotificationRecipient[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationCommunication implements ITplProgramConfigurationCommunication {
  dtpProgramConfigurationId: string | undefined;
  orderCommunicationTypeId: string | undefined;
  directionClassificationValueId: string | undefined;
  dtpProgramConfigurationCommunicationRecipients: TplProgramConfigurationCommunicationRecipient[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationCommunication) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.orderCommunicationTypeId = _data["orderCommunicationTypeId"];
      this.directionClassificationValueId = _data["directionClassificationValueId"];
      if (Array.isArray(_data["dtpProgramConfigurationCommunicationRecipients"])) {
        this.dtpProgramConfigurationCommunicationRecipients = [] as any;
        for (let item of _data["dtpProgramConfigurationCommunicationRecipients"])
          this.dtpProgramConfigurationCommunicationRecipients.push(TplProgramConfigurationCommunicationRecipient.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationCommunication {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationCommunication();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["orderCommunicationTypeId"] = this.orderCommunicationTypeId;
    data["directionClassificationValueId"] = this.directionClassificationValueId;
    if (Array.isArray(this.dtpProgramConfigurationCommunicationRecipients)) {
      data["dtpProgramConfigurationCommunicationRecipients"] = [];
      for (let item of this.dtpProgramConfigurationCommunicationRecipients)
        data["dtpProgramConfigurationCommunicationRecipients"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationCommunication {
    const json = this.toJSON();
    let result = new TplProgramConfigurationCommunication();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationCommunication {
  dtpProgramConfigurationId: string | undefined;
  orderCommunicationTypeId: string | undefined;
  directionClassificationValueId: string | undefined;
  dtpProgramConfigurationCommunicationRecipients: TplProgramConfigurationCommunicationRecipient[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationLetterTemplateType implements ITplProgramConfigurationLetterTemplateType {
  dtpProgramConfigurationId: string | undefined;
  templateClassificationValueId: string | undefined;
  returnToStockProductId: string | undefined;
  cellSheetId: string | undefined;
  cellSheetPrintInstructionsText: string | undefined;
  cellSheetOperationsInstructionsText: string | undefined;
  letterName: string | undefined;
  returnToStockProduct: Product | undefined;
  dtpProgramConfigurationLetterTemplateTypeAutoIncludes: TplProgramConfigurationLetterTemplateTypeAutoInclude[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationLetterTemplateType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.templateClassificationValueId = _data["templateClassificationValueId"];
      this.returnToStockProductId = _data["returnToStockProductId"];
      this.cellSheetId = _data["cellSheetId"];
      this.cellSheetPrintInstructionsText = _data["cellSheetPrintInstructionsText"];
      this.cellSheetOperationsInstructionsText = _data["cellSheetOperationsInstructionsText"];
      this.letterName = _data["letterName"];
      this.returnToStockProduct = _data["returnToStockProduct"] ? Product.fromJS(_data["returnToStockProduct"]) : <any>undefined;
      if (Array.isArray(_data["dtpProgramConfigurationLetterTemplateTypeAutoIncludes"])) {
        this.dtpProgramConfigurationLetterTemplateTypeAutoIncludes = [] as any;
        for (let item of _data["dtpProgramConfigurationLetterTemplateTypeAutoIncludes"])
          this.dtpProgramConfigurationLetterTemplateTypeAutoIncludes.push(TplProgramConfigurationLetterTemplateTypeAutoInclude.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationLetterTemplateType {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationLetterTemplateType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["templateClassificationValueId"] = this.templateClassificationValueId;
    data["returnToStockProductId"] = this.returnToStockProductId;
    data["cellSheetId"] = this.cellSheetId;
    data["cellSheetPrintInstructionsText"] = this.cellSheetPrintInstructionsText;
    data["cellSheetOperationsInstructionsText"] = this.cellSheetOperationsInstructionsText;
    data["letterName"] = this.letterName;
    data["returnToStockProduct"] = this.returnToStockProduct ? this.returnToStockProduct.toJSON() : <any>undefined;
    if (Array.isArray(this.dtpProgramConfigurationLetterTemplateTypeAutoIncludes)) {
      data["dtpProgramConfigurationLetterTemplateTypeAutoIncludes"] = [];
      for (let item of this.dtpProgramConfigurationLetterTemplateTypeAutoIncludes)
        data["dtpProgramConfigurationLetterTemplateTypeAutoIncludes"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationLetterTemplateType {
    const json = this.toJSON();
    let result = new TplProgramConfigurationLetterTemplateType();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationLetterTemplateType {
  dtpProgramConfigurationId: string | undefined;
  templateClassificationValueId: string | undefined;
  returnToStockProductId: string | undefined;
  cellSheetId: string | undefined;
  cellSheetPrintInstructionsText: string | undefined;
  cellSheetOperationsInstructionsText: string | undefined;
  letterName: string | undefined;
  returnToStockProduct: Product | undefined;
  dtpProgramConfigurationLetterTemplateTypeAutoIncludes: TplProgramConfigurationLetterTemplateTypeAutoInclude[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationDocumentTemplate implements ITplProgramConfigurationDocumentTemplate {
  dtpProgramConfigurationId: string | undefined;
  templateTypeClassificationValueId: string | undefined;
  dtpProgramConfigurationSrfId: string | undefined;
  aocFollowUpLetterTypeId: string | undefined;
  documentTemplateId: string | undefined;
  ocrCode: string | undefined;
  templateIdText: string | undefined;
  paperTemplateIdText: string | undefined;
  electronicTemplateIdText: string | undefined;
  mscTemplateIdText: string | undefined;
  maxProductsPerSrfCount: number | undefined;
  programTermsConditionBlockText: string | undefined;
  footerText: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationDocumentTemplate) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.templateTypeClassificationValueId = _data["templateTypeClassificationValueId"];
      this.dtpProgramConfigurationSrfId = _data["dtpProgramConfigurationSrfId"];
      this.aocFollowUpLetterTypeId = _data["aocFollowUpLetterTypeId"];
      this.documentTemplateId = _data["documentTemplateId"];
      this.ocrCode = _data["ocrCode"];
      this.templateIdText = _data["templateIdText"];
      this.paperTemplateIdText = _data["paperTemplateIdText"];
      this.electronicTemplateIdText = _data["electronicTemplateIdText"];
      this.mscTemplateIdText = _data["mscTemplateIdText"];
      this.maxProductsPerSrfCount = _data["maxProductsPerSrfCount"];
      this.programTermsConditionBlockText = _data["programTermsConditionBlockText"];
      this.footerText = _data["footerText"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationDocumentTemplate {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationDocumentTemplate();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["templateTypeClassificationValueId"] = this.templateTypeClassificationValueId;
    data["dtpProgramConfigurationSrfId"] = this.dtpProgramConfigurationSrfId;
    data["aocFollowUpLetterTypeId"] = this.aocFollowUpLetterTypeId;
    data["documentTemplateId"] = this.documentTemplateId;
    data["ocrCode"] = this.ocrCode;
    data["templateIdText"] = this.templateIdText;
    data["paperTemplateIdText"] = this.paperTemplateIdText;
    data["electronicTemplateIdText"] = this.electronicTemplateIdText;
    data["mscTemplateIdText"] = this.mscTemplateIdText;
    data["maxProductsPerSrfCount"] = this.maxProductsPerSrfCount;
    data["programTermsConditionBlockText"] = this.programTermsConditionBlockText;
    data["footerText"] = this.footerText;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationDocumentTemplate {
    const json = this.toJSON();
    let result = new TplProgramConfigurationDocumentTemplate();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationDocumentTemplate {
  dtpProgramConfigurationId: string | undefined;
  templateTypeClassificationValueId: string | undefined;
  dtpProgramConfigurationSrfId: string | undefined;
  aocFollowUpLetterTypeId: string | undefined;
  documentTemplateId: string | undefined;
  ocrCode: string | undefined;
  templateIdText: string | undefined;
  paperTemplateIdText: string | undefined;
  electronicTemplateIdText: string | undefined;
  mscTemplateIdText: string | undefined;
  maxProductsPerSrfCount: number | undefined;
  programTermsConditionBlockText: string | undefined;
  footerText: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationOrderSource implements ITplProgramConfigurationOrderSource {
  dtpProgramConfigurationId: string | undefined;
  orderSourceId: string | undefined;
  exceptionActionClassificationValueId: string | undefined;
  sendRejectionLetterFlag: boolean | undefined;
  eaocApplicableFlag: boolean | undefined;
  isDataEntryAuditRequired: boolean | undefined;
  dataEntryAuditPercentage: number | undefined;
  minDataEntryAuditPerDay: number | undefined;
  offeredQtyFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationOrderSource) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.orderSourceId = _data["orderSourceId"];
      this.exceptionActionClassificationValueId = _data["exceptionActionClassificationValueId"];
      this.sendRejectionLetterFlag = _data["sendRejectionLetterFlag"];
      this.eaocApplicableFlag = _data["eaocApplicableFlag"];
      this.isDataEntryAuditRequired = _data["isDataEntryAuditRequired"];
      this.dataEntryAuditPercentage = _data["dataEntryAuditPercentage"];
      this.minDataEntryAuditPerDay = _data["minDataEntryAuditPerDay"];
      this.offeredQtyFlag = _data["offeredQtyFlag"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationOrderSource {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationOrderSource();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["orderSourceId"] = this.orderSourceId;
    data["exceptionActionClassificationValueId"] = this.exceptionActionClassificationValueId;
    data["sendRejectionLetterFlag"] = this.sendRejectionLetterFlag;
    data["eaocApplicableFlag"] = this.eaocApplicableFlag;
    data["isDataEntryAuditRequired"] = this.isDataEntryAuditRequired;
    data["dataEntryAuditPercentage"] = this.dataEntryAuditPercentage;
    data["minDataEntryAuditPerDay"] = this.minDataEntryAuditPerDay;
    data["offeredQtyFlag"] = this.offeredQtyFlag;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationOrderSource {
    const json = this.toJSON();
    let result = new TplProgramConfigurationOrderSource();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationOrderSource {
  dtpProgramConfigurationId: string | undefined;
  orderSourceId: string | undefined;
  exceptionActionClassificationValueId: string | undefined;
  sendRejectionLetterFlag: boolean | undefined;
  eaocApplicableFlag: boolean | undefined;
  isDataEntryAuditRequired: boolean | undefined;
  dataEntryAuditPercentage: number | undefined;
  minDataEntryAuditPerDay: number | undefined;
  offeredQtyFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationComment implements ITplProgramConfigurationComment {
  dtpProgramConfigurationId: string | undefined;
  commentsText: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationComment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.commentsText = _data["commentsText"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationComment {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationComment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["commentsText"] = this.commentsText;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationComment {
    const json = this.toJSON();
    let result = new TplProgramConfigurationComment();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationComment {
  dtpProgramConfigurationId: string | undefined;
  commentsText: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class SplitGroup implements ISplitGroup {
  name: string | undefined;
  description: string | undefined;
  splitGroupNumber: number | undefined;
  dtpProgramConfigurationId: string | undefined;
  splitGroupProduct: SplitGroupProducts[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ISplitGroup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.description = _data["description"];
      this.splitGroupNumber = _data["splitGroupNumber"];
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      if (Array.isArray(_data["splitGroupProduct"])) {
        this.splitGroupProduct = [] as any;
        for (let item of _data["splitGroupProduct"])
          this.splitGroupProduct.push(SplitGroupProducts.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): SplitGroup {
    data = typeof data === 'object' ? data : {};
    let result = new SplitGroup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["description"] = this.description;
    data["splitGroupNumber"] = this.splitGroupNumber;
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    if (Array.isArray(this.splitGroupProduct)) {
      data["splitGroupProduct"] = [];
      for (let item of this.splitGroupProduct)
        data["splitGroupProduct"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): SplitGroup {
    const json = this.toJSON();
    let result = new SplitGroup();
    result.init(json);
    return result;
  }
}

export interface ISplitGroup {
  name: string | undefined;
  description: string | undefined;
  splitGroupNumber: number | undefined;
  dtpProgramConfigurationId: string | undefined;
  splitGroupProduct: SplitGroupProducts[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class SplitGroupProducts implements ISplitGroupProducts {
  productId: string | undefined;
  splitGroupId: string | undefined;
  dtpProgramConfigurationId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ISplitGroupProducts) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productId = _data["productId"];
      this.splitGroupId = _data["splitGroupId"];
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): SplitGroupProducts {
    data = typeof data === 'object' ? data : {};
    let result = new SplitGroupProducts();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["productId"] = this.productId;
    data["splitGroupId"] = this.splitGroupId;
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): SplitGroupProducts {
    const json = this.toJSON();
    let result = new SplitGroupProducts();
    result.init(json);
    return result;
  }
}

export interface ISplitGroupProducts {
  productId: string | undefined;
  splitGroupId: string | undefined;
  dtpProgramConfigurationId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationAttachment implements ITplProgramConfigurationAttachment {
  dtpProgramConfigurationId: string | undefined;
  dtpProgramConfigurationSrfId: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  attachmentLocationText: string | undefined;
  commentsText: string | undefined;
  attachmentFileName: string | undefined;
  sequenceNbr: number | undefined;
  attachmentDesc: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationAttachment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.dtpProgramConfigurationSrfId = _data["dtpProgramConfigurationSrfId"];
      this.attachmentTypeClassificationValueId = _data["attachmentTypeClassificationValueId"];
      this.attachmentLocationText = _data["attachmentLocationText"];
      this.commentsText = _data["commentsText"];
      this.attachmentFileName = _data["attachmentFileName"];
      this.sequenceNbr = _data["sequenceNbr"];
      this.attachmentDesc = _data["attachmentDesc"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationAttachment {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationAttachment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["dtpProgramConfigurationSrfId"] = this.dtpProgramConfigurationSrfId;
    data["attachmentTypeClassificationValueId"] = this.attachmentTypeClassificationValueId;
    data["attachmentLocationText"] = this.attachmentLocationText;
    data["commentsText"] = this.commentsText;
    data["attachmentFileName"] = this.attachmentFileName;
    data["sequenceNbr"] = this.sequenceNbr;
    data["attachmentDesc"] = this.attachmentDesc;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationAttachment {
    const json = this.toJSON();
    let result = new TplProgramConfigurationAttachment();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationAttachment {
  dtpProgramConfigurationId: string | undefined;
  dtpProgramConfigurationSrfId: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  attachmentLocationText: string | undefined;
  commentsText: string | undefined;
  attachmentFileName: string | undefined;
  sequenceNbr: number | undefined;
  attachmentDesc: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeBrandLevel implements IAutoIncludeBrandLevel {
  dtpProgramConfigurationId: string | undefined;
  specifiedProductGroupId: string | undefined;
  autoIncludedProductId: string | undefined;
  dateRangeTypeClassificationValueId: string | undefined;
  quantityRangeTypeClassificationValueId: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  productRequiredForShippingFlag: boolean | undefined;
  roundAutoIncludeQuantityFlag: boolean | undefined;
  perOrderIncludedQty: number | undefined;
  ratioIncludedQty: number | undefined;
  ratioBaseQty: number | undefined;
  maximumIncludedQty: number | undefined;
  ruleNumber: number | undefined;
  description: string | undefined;
  hcpSelectedTagsJson: string | undefined;
  therapeuticClassJson: string | undefined;
  specificProductGroup: ProductGroup | undefined;
  autoIncludedProduct: Product | undefined;
  autoIncludeBrandLevelOrderSources: AutoIncludeBrandLevelOrderSource[] | undefined;
  autoIncludeBrandLevelProductTypeExclusions: AutoIncludeBrandLevelProductTypeExclusion[] | undefined;
  autoIncludeBrandLevelQuantityRanges: AutoIncludeBrandLevelQuantityRange[] | undefined;
  autoIncludeBrandLevelStates: AutoIncludeBrandLevelState[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeBrandLevel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.specifiedProductGroupId = _data["specifiedProductGroupId"];
      this.autoIncludedProductId = _data["autoIncludedProductId"];
      this.dateRangeTypeClassificationValueId = _data["dateRangeTypeClassificationValueId"];
      this.quantityRangeTypeClassificationValueId = _data["quantityRangeTypeClassificationValueId"];
      this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
      this.productRequiredForShippingFlag = _data["productRequiredForShippingFlag"];
      this.roundAutoIncludeQuantityFlag = _data["roundAutoIncludeQuantityFlag"];
      this.perOrderIncludedQty = _data["perOrderIncludedQty"];
      this.ratioIncludedQty = _data["ratioIncludedQty"];
      this.ratioBaseQty = _data["ratioBaseQty"];
      this.maximumIncludedQty = _data["maximumIncludedQty"];
      this.ruleNumber = _data["ruleNumber"];
      this.description = _data["description"];
      this.hcpSelectedTagsJson = _data["hcpSelectedTagsJson"];
      this.therapeuticClassJson = _data["therapeuticClassJson"];
      this.specificProductGroup = _data["specificProductGroup"] ? ProductGroup.fromJS(_data["specificProductGroup"]) : <any>undefined;
      this.autoIncludedProduct = _data["autoIncludedProduct"] ? Product.fromJS(_data["autoIncludedProduct"]) : <any>undefined;
      if (Array.isArray(_data["autoIncludeBrandLevelOrderSources"])) {
        this.autoIncludeBrandLevelOrderSources = [] as any;
        for (let item of _data["autoIncludeBrandLevelOrderSources"])
          this.autoIncludeBrandLevelOrderSources.push(AutoIncludeBrandLevelOrderSource.fromJS(item));
      }
      if (Array.isArray(_data["autoIncludeBrandLevelProductTypeExclusions"])) {
        this.autoIncludeBrandLevelProductTypeExclusions = [] as any;
        for (let item of _data["autoIncludeBrandLevelProductTypeExclusions"])
          this.autoIncludeBrandLevelProductTypeExclusions.push(AutoIncludeBrandLevelProductTypeExclusion.fromJS(item));
      }
      if (Array.isArray(_data["autoIncludeBrandLevelQuantityRanges"])) {
        this.autoIncludeBrandLevelQuantityRanges = [] as any;
        for (let item of _data["autoIncludeBrandLevelQuantityRanges"])
          this.autoIncludeBrandLevelQuantityRanges.push(AutoIncludeBrandLevelQuantityRange.fromJS(item));
      }
      if (Array.isArray(_data["autoIncludeBrandLevelStates"])) {
        this.autoIncludeBrandLevelStates = [] as any;
        for (let item of _data["autoIncludeBrandLevelStates"])
          this.autoIncludeBrandLevelStates.push(AutoIncludeBrandLevelState.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeBrandLevel {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeBrandLevel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["specifiedProductGroupId"] = this.specifiedProductGroupId;
    data["autoIncludedProductId"] = this.autoIncludedProductId;
    data["dateRangeTypeClassificationValueId"] = this.dateRangeTypeClassificationValueId;
    data["quantityRangeTypeClassificationValueId"] = this.quantityRangeTypeClassificationValueId;
    data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    data["productRequiredForShippingFlag"] = this.productRequiredForShippingFlag;
    data["roundAutoIncludeQuantityFlag"] = this.roundAutoIncludeQuantityFlag;
    data["perOrderIncludedQty"] = this.perOrderIncludedQty;
    data["ratioIncludedQty"] = this.ratioIncludedQty;
    data["ratioBaseQty"] = this.ratioBaseQty;
    data["maximumIncludedQty"] = this.maximumIncludedQty;
    data["ruleNumber"] = this.ruleNumber;
    data["description"] = this.description;
    data["hcpSelectedTagsJson"] = this.hcpSelectedTagsJson;
    data["therapeuticClassJson"] = this.therapeuticClassJson;
    data["specificProductGroup"] = this.specificProductGroup ? this.specificProductGroup.toJSON() : <any>undefined;
    data["autoIncludedProduct"] = this.autoIncludedProduct ? this.autoIncludedProduct.toJSON() : <any>undefined;
    if (Array.isArray(this.autoIncludeBrandLevelOrderSources)) {
      data["autoIncludeBrandLevelOrderSources"] = [];
      for (let item of this.autoIncludeBrandLevelOrderSources)
        data["autoIncludeBrandLevelOrderSources"].push(item.toJSON());
    }
    if (Array.isArray(this.autoIncludeBrandLevelProductTypeExclusions)) {
      data["autoIncludeBrandLevelProductTypeExclusions"] = [];
      for (let item of this.autoIncludeBrandLevelProductTypeExclusions)
        data["autoIncludeBrandLevelProductTypeExclusions"].push(item.toJSON());
    }
    if (Array.isArray(this.autoIncludeBrandLevelQuantityRanges)) {
      data["autoIncludeBrandLevelQuantityRanges"] = [];
      for (let item of this.autoIncludeBrandLevelQuantityRanges)
        data["autoIncludeBrandLevelQuantityRanges"].push(item.toJSON());
    }
    if (Array.isArray(this.autoIncludeBrandLevelStates)) {
      data["autoIncludeBrandLevelStates"] = [];
      for (let item of this.autoIncludeBrandLevelStates)
        data["autoIncludeBrandLevelStates"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeBrandLevel {
    const json = this.toJSON();
    let result = new AutoIncludeBrandLevel();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeBrandLevel {
  dtpProgramConfigurationId: string | undefined;
  specifiedProductGroupId: string | undefined;
  autoIncludedProductId: string | undefined;
  dateRangeTypeClassificationValueId: string | undefined;
  quantityRangeTypeClassificationValueId: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  productRequiredForShippingFlag: boolean | undefined;
  roundAutoIncludeQuantityFlag: boolean | undefined;
  perOrderIncludedQty: number | undefined;
  ratioIncludedQty: number | undefined;
  ratioBaseQty: number | undefined;
  maximumIncludedQty: number | undefined;
  ruleNumber: number | undefined;
  description: string | undefined;
  hcpSelectedTagsJson: string | undefined;
  therapeuticClassJson: string | undefined;
  specificProductGroup: ProductGroup | undefined;
  autoIncludedProduct: Product | undefined;
  autoIncludeBrandLevelOrderSources: AutoIncludeBrandLevelOrderSource[] | undefined;
  autoIncludeBrandLevelProductTypeExclusions: AutoIncludeBrandLevelProductTypeExclusion[] | undefined;
  autoIncludeBrandLevelQuantityRanges: AutoIncludeBrandLevelQuantityRange[] | undefined;
  autoIncludeBrandLevelStates: AutoIncludeBrandLevelState[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeOrderLevel implements IAutoIncludeOrderLevel {
  dtpProgramConfigurationId: string | undefined;
  autoIncludedProductId: string | undefined;
  dateRangeTypeClassificationValueId: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  productRequiredForShippingFlag: boolean | undefined;
  perOrderIncludedQty: number | undefined;
  ruleNumber: number | undefined;
  description: string | undefined;
  hcpSelectedTagsJson: string | undefined;
  therapeuticClassJson: string | undefined;
  autoIncludedProduct: Product | undefined;
  autoIncludeOrderLevelSources: AutoIncludeOrderLevelSource[] | undefined;
  autoIncludeOrderLevelStates: AutoIncludeOrderLevelState[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeOrderLevel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.autoIncludedProductId = _data["autoIncludedProductId"];
      this.dateRangeTypeClassificationValueId = _data["dateRangeTypeClassificationValueId"];
      this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
      this.productRequiredForShippingFlag = _data["productRequiredForShippingFlag"];
      this.perOrderIncludedQty = _data["perOrderIncludedQty"];
      this.ruleNumber = _data["ruleNumber"];
      this.description = _data["description"];
      this.hcpSelectedTagsJson = _data["hcpSelectedTagsJson"];
      this.therapeuticClassJson = _data["therapeuticClassJson"];
      this.autoIncludedProduct = _data["autoIncludedProduct"] ? Product.fromJS(_data["autoIncludedProduct"]) : <any>undefined;
      if (Array.isArray(_data["autoIncludeOrderLevelSources"])) {
        this.autoIncludeOrderLevelSources = [] as any;
        for (let item of _data["autoIncludeOrderLevelSources"])
          this.autoIncludeOrderLevelSources.push(AutoIncludeOrderLevelSource.fromJS(item));
      }
      if (Array.isArray(_data["autoIncludeOrderLevelStates"])) {
        this.autoIncludeOrderLevelStates = [] as any;
        for (let item of _data["autoIncludeOrderLevelStates"])
          this.autoIncludeOrderLevelStates.push(AutoIncludeOrderLevelState.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeOrderLevel {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeOrderLevel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["autoIncludedProductId"] = this.autoIncludedProductId;
    data["dateRangeTypeClassificationValueId"] = this.dateRangeTypeClassificationValueId;
    data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    data["productRequiredForShippingFlag"] = this.productRequiredForShippingFlag;
    data["perOrderIncludedQty"] = this.perOrderIncludedQty;
    data["ruleNumber"] = this.ruleNumber;
    data["description"] = this.description;
    data["hcpSelectedTagsJson"] = this.hcpSelectedTagsJson;
    data["therapeuticClassJson"] = this.therapeuticClassJson;
    data["autoIncludedProduct"] = this.autoIncludedProduct ? this.autoIncludedProduct.toJSON() : <any>undefined;
    if (Array.isArray(this.autoIncludeOrderLevelSources)) {
      data["autoIncludeOrderLevelSources"] = [];
      for (let item of this.autoIncludeOrderLevelSources)
        data["autoIncludeOrderLevelSources"].push(item.toJSON());
    }
    if (Array.isArray(this.autoIncludeOrderLevelStates)) {
      data["autoIncludeOrderLevelStates"] = [];
      for (let item of this.autoIncludeOrderLevelStates)
        data["autoIncludeOrderLevelStates"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeOrderLevel {
    const json = this.toJSON();
    let result = new AutoIncludeOrderLevel();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeOrderLevel {
  dtpProgramConfigurationId: string | undefined;
  autoIncludedProductId: string | undefined;
  dateRangeTypeClassificationValueId: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  productRequiredForShippingFlag: boolean | undefined;
  perOrderIncludedQty: number | undefined;
  ruleNumber: number | undefined;
  description: string | undefined;
  hcpSelectedTagsJson: string | undefined;
  therapeuticClassJson: string | undefined;
  autoIncludedProduct: Product | undefined;
  autoIncludeOrderLevelSources: AutoIncludeOrderLevelSource[] | undefined;
  autoIncludeOrderLevelStates: AutoIncludeOrderLevelState[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeProductLevel implements IAutoIncludeProductLevel {
  dtpProgramConfigurationId: string | undefined;
  specifiedProductId: string | undefined;
  autoIncludedProductId: string | undefined;
  dateRangeTypeClassificationValueId: string | undefined;
  quantityRangeTypeClassificationValueId: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  productRequiredForShippingFlag: boolean | undefined;
  roundAutoIncludeQuantityFlag: boolean | undefined;
  perOrderIncludedQty: number | undefined;
  ratioIncludedQty: number | undefined;
  ratioBaseQty: number | undefined;
  maximumIncludedQty: number | undefined;
  ruleNumber: number | undefined;
  description: string | undefined;
  hcpSelectedTagsJson: string | undefined;
  therapeuticClassJson: string | undefined;
  specifiedProduct: Product | undefined;
  autoIncludedProduct: Product | undefined;
  autoIncludeProductLevelSources: AutoIncludeProductLevelSource[] | undefined;
  autoIncludeProductLevelQuantityRanges: AutoIncludeProductLevelQuantityRange[] | undefined;
  autoIncludeProductLevelStates: AutoIncludeProductLevelState[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeProductLevel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.specifiedProductId = _data["specifiedProductId"];
      this.autoIncludedProductId = _data["autoIncludedProductId"];
      this.dateRangeTypeClassificationValueId = _data["dateRangeTypeClassificationValueId"];
      this.quantityRangeTypeClassificationValueId = _data["quantityRangeTypeClassificationValueId"];
      this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
      this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
      this.productRequiredForShippingFlag = _data["productRequiredForShippingFlag"];
      this.roundAutoIncludeQuantityFlag = _data["roundAutoIncludeQuantityFlag"];
      this.perOrderIncludedQty = _data["perOrderIncludedQty"];
      this.ratioIncludedQty = _data["ratioIncludedQty"];
      this.ratioBaseQty = _data["ratioBaseQty"];
      this.maximumIncludedQty = _data["maximumIncludedQty"];
      this.ruleNumber = _data["ruleNumber"];
      this.description = _data["description"];
      this.hcpSelectedTagsJson = _data["hcpSelectedTagsJson"];
      this.therapeuticClassJson = _data["therapeuticClassJson"];
      this.specifiedProduct = _data["specifiedProduct"] ? Product.fromJS(_data["specifiedProduct"]) : <any>undefined;
      this.autoIncludedProduct = _data["autoIncludedProduct"] ? Product.fromJS(_data["autoIncludedProduct"]) : <any>undefined;
      if (Array.isArray(_data["autoIncludeProductLevelSources"])) {
        this.autoIncludeProductLevelSources = [] as any;
        for (let item of _data["autoIncludeProductLevelSources"])
          this.autoIncludeProductLevelSources.push(AutoIncludeProductLevelSource.fromJS(item));
      }
      if (Array.isArray(_data["autoIncludeProductLevelQuantityRanges"])) {
        this.autoIncludeProductLevelQuantityRanges = [] as any;
        for (let item of _data["autoIncludeProductLevelQuantityRanges"])
          this.autoIncludeProductLevelQuantityRanges.push(AutoIncludeProductLevelQuantityRange.fromJS(item));
      }
      if (Array.isArray(_data["autoIncludeProductLevelStates"])) {
        this.autoIncludeProductLevelStates = [] as any;
        for (let item of _data["autoIncludeProductLevelStates"])
          this.autoIncludeProductLevelStates.push(AutoIncludeProductLevelState.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeProductLevel {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeProductLevel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["specifiedProductId"] = this.specifiedProductId;
    data["autoIncludedProductId"] = this.autoIncludedProductId;
    data["dateRangeTypeClassificationValueId"] = this.dateRangeTypeClassificationValueId;
    data["quantityRangeTypeClassificationValueId"] = this.quantityRangeTypeClassificationValueId;
    data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    data["productRequiredForShippingFlag"] = this.productRequiredForShippingFlag;
    data["roundAutoIncludeQuantityFlag"] = this.roundAutoIncludeQuantityFlag;
    data["perOrderIncludedQty"] = this.perOrderIncludedQty;
    data["ratioIncludedQty"] = this.ratioIncludedQty;
    data["ratioBaseQty"] = this.ratioBaseQty;
    data["maximumIncludedQty"] = this.maximumIncludedQty;
    data["ruleNumber"] = this.ruleNumber;
    data["description"] = this.description;
    data["hcpSelectedTagsJson"] = this.hcpSelectedTagsJson;
    data["therapeuticClassJson"] = this.therapeuticClassJson;
    data["specifiedProduct"] = this.specifiedProduct ? this.specifiedProduct.toJSON() : <any>undefined;
    data["autoIncludedProduct"] = this.autoIncludedProduct ? this.autoIncludedProduct.toJSON() : <any>undefined;
    if (Array.isArray(this.autoIncludeProductLevelSources)) {
      data["autoIncludeProductLevelSources"] = [];
      for (let item of this.autoIncludeProductLevelSources)
        data["autoIncludeProductLevelSources"].push(item.toJSON());
    }
    if (Array.isArray(this.autoIncludeProductLevelQuantityRanges)) {
      data["autoIncludeProductLevelQuantityRanges"] = [];
      for (let item of this.autoIncludeProductLevelQuantityRanges)
        data["autoIncludeProductLevelQuantityRanges"].push(item.toJSON());
    }
    if (Array.isArray(this.autoIncludeProductLevelStates)) {
      data["autoIncludeProductLevelStates"] = [];
      for (let item of this.autoIncludeProductLevelStates)
        data["autoIncludeProductLevelStates"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeProductLevel {
    const json = this.toJSON();
    let result = new AutoIncludeProductLevel();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeProductLevel {
  dtpProgramConfigurationId: string | undefined;
  specifiedProductId: string | undefined;
  autoIncludedProductId: string | undefined;
  dateRangeTypeClassificationValueId: string | undefined;
  quantityRangeTypeClassificationValueId: string | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  productRequiredForShippingFlag: boolean | undefined;
  roundAutoIncludeQuantityFlag: boolean | undefined;
  perOrderIncludedQty: number | undefined;
  ratioIncludedQty: number | undefined;
  ratioBaseQty: number | undefined;
  maximumIncludedQty: number | undefined;
  ruleNumber: number | undefined;
  description: string | undefined;
  hcpSelectedTagsJson: string | undefined;
  therapeuticClassJson: string | undefined;
  specifiedProduct: Product | undefined;
  autoIncludedProduct: Product | undefined;
  autoIncludeProductLevelSources: AutoIncludeProductLevelSource[] | undefined;
  autoIncludeProductLevelQuantityRanges: AutoIncludeProductLevelQuantityRange[] | undefined;
  autoIncludeProductLevelStates: AutoIncludeProductLevelState[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationLetterPrintEmail implements ITplProgramConfigurationLetterPrintEmail {
  dtpProgramConfigurationId: string | undefined;
  emailAddress: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationLetterPrintEmail) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.emailAddress = _data["emailAddress"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationLetterPrintEmail {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationLetterPrintEmail();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["emailAddress"] = this.emailAddress;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationLetterPrintEmail {
    const json = this.toJSON();
    let result = new TplProgramConfigurationLetterPrintEmail();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationLetterPrintEmail {
  dtpProgramConfigurationId: string | undefined;
  emailAddress: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationOfferSource implements ITplProgramConfigurationOfferSource {
  dtpProgramConfigurationId: string | undefined;
  offerSourceClassificationValueId: string | undefined;
  dtpProgramConfigurationSrfValueId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationOfferSource) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.offerSourceClassificationValueId = _data["offerSourceClassificationValueId"];
      this.dtpProgramConfigurationSrfValueId = _data["dtpProgramConfigurationSrfValueId"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationOfferSource {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationOfferSource();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["offerSourceClassificationValueId"] = this.offerSourceClassificationValueId;
    data["dtpProgramConfigurationSrfValueId"] = this.dtpProgramConfigurationSrfValueId;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationOfferSource {
    const json = this.toJSON();
    let result = new TplProgramConfigurationOfferSource();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationOfferSource {
  dtpProgramConfigurationId: string | undefined;
  offerSourceClassificationValueId: string | undefined;
  dtpProgramConfigurationSrfValueId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProgramConfigurationCertification implements IProgramConfigurationCertification {
  hospitalCertificationsFlag: boolean | undefined;
  hospitalCertificationsPeriodCount: number | undefined;
  followUpFlag: boolean | undefined;
  certificationFollowUpTriggerDayCount: number | undefined;
  programCycleId: string | undefined;
  tplProgramConfigurationId: string | undefined;
  tplProgramConfiguration: TplProgramConfiguration | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProgramConfigurationCertification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hospitalCertificationsFlag = _data["hospitalCertificationsFlag"];
      this.hospitalCertificationsPeriodCount = _data["hospitalCertificationsPeriodCount"];
      this.followUpFlag = _data["followUpFlag"];
      this.certificationFollowUpTriggerDayCount = _data["certificationFollowUpTriggerDayCount"];
      this.programCycleId = _data["programCycleId"];
      this.tplProgramConfigurationId = _data["tplProgramConfigurationId"];
      this.tplProgramConfiguration = _data["tplProgramConfiguration"] ? TplProgramConfiguration.fromJS(_data["tplProgramConfiguration"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProgramConfigurationCertification {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramConfigurationCertification();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hospitalCertificationsFlag"] = this.hospitalCertificationsFlag;
    data["hospitalCertificationsPeriodCount"] = this.hospitalCertificationsPeriodCount;
    data["followUpFlag"] = this.followUpFlag;
    data["certificationFollowUpTriggerDayCount"] = this.certificationFollowUpTriggerDayCount;
    data["programCycleId"] = this.programCycleId;
    data["tplProgramConfigurationId"] = this.tplProgramConfigurationId;
    data["tplProgramConfiguration"] = this.tplProgramConfiguration ? this.tplProgramConfiguration.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProgramConfigurationCertification {
    const json = this.toJSON();
    let result = new ProgramConfigurationCertification();
    result.init(json);
    return result;
  }
}

export interface IProgramConfigurationCertification {
  hospitalCertificationsFlag: boolean | undefined;
  hospitalCertificationsPeriodCount: number | undefined;
  followUpFlag: boolean | undefined;
  certificationFollowUpTriggerDayCount: number | undefined;
  programCycleId: string | undefined;
  tplProgramConfigurationId: string | undefined;
  tplProgramConfiguration: TplProgramConfiguration | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationOnHoldAction implements ITplProgramConfigurationOnHoldAction {
  programConfigurationId: string | undefined;
  statusReasonTypeId: string | undefined;
  singleValueFlag: boolean | undefined;
  isAutomaticRejectionEnabled: boolean | undefined;
  maxOnHoldDaysCountBeforeRejection: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationOnHoldAction) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programConfigurationId = _data["programConfigurationId"];
      this.statusReasonTypeId = _data["statusReasonTypeId"];
      this.singleValueFlag = _data["singleValueFlag"];
      this.isAutomaticRejectionEnabled = _data["isAutomaticRejectionEnabled"];
      this.maxOnHoldDaysCountBeforeRejection = _data["maxOnHoldDaysCountBeforeRejection"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationOnHoldAction {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationOnHoldAction();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programConfigurationId"] = this.programConfigurationId;
    data["statusReasonTypeId"] = this.statusReasonTypeId;
    data["singleValueFlag"] = this.singleValueFlag;
    data["isAutomaticRejectionEnabled"] = this.isAutomaticRejectionEnabled;
    data["maxOnHoldDaysCountBeforeRejection"] = this.maxOnHoldDaysCountBeforeRejection;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationOnHoldAction {
    const json = this.toJSON();
    let result = new TplProgramConfigurationOnHoldAction();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationOnHoldAction {
  programConfigurationId: string | undefined;
  statusReasonTypeId: string | undefined;
  singleValueFlag: boolean | undefined;
  isAutomaticRejectionEnabled: boolean | undefined;
  maxOnHoldDaysCountBeforeRejection: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacyHospital implements IPharmacyHospital {
  hospitalProgramId: string | undefined;
  pharmacyProgramId: string | undefined;
  affiliationTypeClassificationValueId: string | undefined;
  certificationStatusClassificationValueId: string | undefined;
  hospitalProgram: HospitalProgram | undefined;
  pharmacyProgram: PharmacyProgram | undefined;
  affiliationType: ReferencedClassification | undefined;
  certificationStatus: ReferencedClassification | undefined;
  certificationDetail: CertificationDetail[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacyHospital) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hospitalProgramId = _data["hospitalProgramId"];
      this.pharmacyProgramId = _data["pharmacyProgramId"];
      this.affiliationTypeClassificationValueId = _data["affiliationTypeClassificationValueId"];
      this.certificationStatusClassificationValueId = _data["certificationStatusClassificationValueId"];
      this.hospitalProgram = _data["hospitalProgram"] ? HospitalProgram.fromJS(_data["hospitalProgram"]) : <any>undefined;
      this.pharmacyProgram = _data["pharmacyProgram"] ? PharmacyProgram.fromJS(_data["pharmacyProgram"]) : <any>undefined;
      this.affiliationType = _data["affiliationType"] ? ReferencedClassification.fromJS(_data["affiliationType"]) : <any>undefined;
      this.certificationStatus = _data["certificationStatus"] ? ReferencedClassification.fromJS(_data["certificationStatus"]) : <any>undefined;
      if (Array.isArray(_data["certificationDetail"])) {
        this.certificationDetail = [] as any;
        for (let item of _data["certificationDetail"])
          this.certificationDetail.push(CertificationDetail.fromJS(item));
      }
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacyHospital {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacyHospital();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hospitalProgramId"] = this.hospitalProgramId;
    data["pharmacyProgramId"] = this.pharmacyProgramId;
    data["affiliationTypeClassificationValueId"] = this.affiliationTypeClassificationValueId;
    data["certificationStatusClassificationValueId"] = this.certificationStatusClassificationValueId;
    data["hospitalProgram"] = this.hospitalProgram ? this.hospitalProgram.toJSON() : <any>undefined;
    data["pharmacyProgram"] = this.pharmacyProgram ? this.pharmacyProgram.toJSON() : <any>undefined;
    data["affiliationType"] = this.affiliationType ? this.affiliationType.toJSON() : <any>undefined;
    data["certificationStatus"] = this.certificationStatus ? this.certificationStatus.toJSON() : <any>undefined;
    if (Array.isArray(this.certificationDetail)) {
      data["certificationDetail"] = [];
      for (let item of this.certificationDetail)
        data["certificationDetail"].push(item.toJSON());
    }
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacyHospital {
    const json = this.toJSON();
    let result = new PharmacyHospital();
    result.init(json);
    return result;
  }
}

export interface IPharmacyHospital {
  hospitalProgramId: string | undefined;
  pharmacyProgramId: string | undefined;
  affiliationTypeClassificationValueId: string | undefined;
  certificationStatusClassificationValueId: string | undefined;
  hospitalProgram: HospitalProgram | undefined;
  pharmacyProgram: PharmacyProgram | undefined;
  affiliationType: ReferencedClassification | undefined;
  certificationStatus: ReferencedClassification | undefined;
  certificationDetail: CertificationDetail[] | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class CertificateAttachment implements ICertificateAttachment {
  certificateId: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  attachmentName: string | undefined;
  attachmentLocation: string | undefined;
  commentsText: string | undefined;
  attachmentDesc: string | undefined;
  referenceEntityId: string | undefined;
  certificate: CertificationDetail | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ICertificateAttachment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.certificateId = _data["certificateId"];
      this.attachmentTypeClassificationValueId = _data["attachmentTypeClassificationValueId"];
      this.attachmentName = _data["attachmentName"];
      this.attachmentLocation = _data["attachmentLocation"];
      this.commentsText = _data["commentsText"];
      this.attachmentDesc = _data["attachmentDesc"];
      this.referenceEntityId = _data["referenceEntityId"];
      this.certificate = _data["certificate"] ? CertificationDetail.fromJS(_data["certificate"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CertificateAttachment {
    data = typeof data === 'object' ? data : {};
    let result = new CertificateAttachment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["certificateId"] = this.certificateId;
    data["attachmentTypeClassificationValueId"] = this.attachmentTypeClassificationValueId;
    data["attachmentName"] = this.attachmentName;
    data["attachmentLocation"] = this.attachmentLocation;
    data["commentsText"] = this.commentsText;
    data["attachmentDesc"] = this.attachmentDesc;
    data["referenceEntityId"] = this.referenceEntityId;
    data["certificate"] = this.certificate ? this.certificate.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): CertificateAttachment {
    const json = this.toJSON();
    let result = new CertificateAttachment();
    result.init(json);
    return result;
  }
}

export interface ICertificateAttachment {
  certificateId: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  attachmentName: string | undefined;
  attachmentLocation: string | undefined;
  commentsText: string | undefined;
  attachmentDesc: string | undefined;
  referenceEntityId: string | undefined;
  certificate: CertificationDetail | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProductAttachment implements IProductAttachment {
  productId: string | undefined;
  productGroupId: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  attachmentLocationText: string | undefined;
  commentsText: string | undefined;
  attachmentFileName: string | undefined;
  attachmentDescription: string | undefined;
  sequenceNumber: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProductAttachment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productId = _data["productId"];
      this.productGroupId = _data["productGroupId"];
      this.attachmentTypeClassificationValueId = _data["attachmentTypeClassificationValueId"];
      this.attachmentLocationText = _data["attachmentLocationText"];
      this.commentsText = _data["commentsText"];
      this.attachmentFileName = _data["attachmentFileName"];
      this.attachmentDescription = _data["attachmentDescription"];
      this.sequenceNumber = _data["sequenceNumber"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProductAttachment {
    data = typeof data === 'object' ? data : {};
    let result = new ProductAttachment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["productId"] = this.productId;
    data["productGroupId"] = this.productGroupId;
    data["attachmentTypeClassificationValueId"] = this.attachmentTypeClassificationValueId;
    data["attachmentLocationText"] = this.attachmentLocationText;
    data["commentsText"] = this.commentsText;
    data["attachmentFileName"] = this.attachmentFileName;
    data["attachmentDescription"] = this.attachmentDescription;
    data["sequenceNumber"] = this.sequenceNumber;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProductAttachment {
    const json = this.toJSON();
    let result = new ProductAttachment();
    result.init(json);
    return result;
  }
}

export interface IProductAttachment {
  productId: string | undefined;
  productGroupId: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  attachmentLocationText: string | undefined;
  commentsText: string | undefined;
  attachmentFileName: string | undefined;
  attachmentDescription: string | undefined;
  sequenceNumber: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProduct implements ITplProduct {
  productId: string | undefined;
  genericProductName: string | undefined;
  productStrengthText: string | undefined;
  productCostAmt: number | undefined;
  deaScheduleName: string | undefined;
  aocRequiredFlag: boolean | undefined;
  lotControlledFlag: boolean | undefined;
  temperatureControlledFlag: boolean | undefined;
  selectDayShippingFlag: boolean | undefined;
  antibioticFlag: boolean | undefined;
  hazardousFlag: boolean | undefined;
  serialTrackedFlag: boolean | undefined;
  smallOrderDepartmentFlag: boolean | undefined;
  orderSplitFlag: boolean | undefined;
  signatureRequiredFlag: boolean | undefined;
  autoIncludedFlag: boolean | undefined;
  orderableFlag: boolean | undefined;
  opioidFlag: boolean | undefined;
  knipperProductFlag: boolean | undefined;
  displayQtyText: string | undefined;
  animalHealthFlag: boolean | undefined;
  remsCheckFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  externalProductSfaId: string | undefined;
  allocationMultiplier: number | undefined;
  productReplacementFlag: boolean | undefined;
  somNationalDrugCode: string | undefined;
  strength: number | undefined;
  strengthUnits: string | undefined;
  fluidProductFlag: boolean | undefined;
  dose: number | undefined;
  packageSize: number | undefined;
  activeIngredientId: string | undefined;

  constructor(data?: ITplProduct) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productId = _data["productId"];
      this.genericProductName = _data["genericProductName"];
      this.productStrengthText = _data["productStrengthText"];
      this.productCostAmt = _data["productCostAmt"];
      this.deaScheduleName = _data["deaScheduleName"];
      this.aocRequiredFlag = _data["aocRequiredFlag"];
      this.lotControlledFlag = _data["lotControlledFlag"];
      this.temperatureControlledFlag = _data["temperatureControlledFlag"];
      this.selectDayShippingFlag = _data["selectDayShippingFlag"];
      this.antibioticFlag = _data["antibioticFlag"];
      this.hazardousFlag = _data["hazardousFlag"];
      this.serialTrackedFlag = _data["serialTrackedFlag"];
      this.smallOrderDepartmentFlag = _data["smallOrderDepartmentFlag"];
      this.orderSplitFlag = _data["orderSplitFlag"];
      this.signatureRequiredFlag = _data["signatureRequiredFlag"];
      this.autoIncludedFlag = _data["autoIncludedFlag"];
      this.orderableFlag = _data["orderableFlag"];
      this.opioidFlag = _data["opioidFlag"];
      this.knipperProductFlag = _data["knipperProductFlag"];
      this.displayQtyText = _data["displayQtyText"];
      this.animalHealthFlag = _data["animalHealthFlag"];
      this.remsCheckFlag = _data["remsCheckFlag"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.externalProductSfaId = _data["externalProductSfaId"];
      this.allocationMultiplier = _data["allocationMultiplier"];
      this.productReplacementFlag = _data["productReplacementFlag"];
      this.somNationalDrugCode = _data["somNationalDrugCode"];
      this.strength = _data["strength"];
      this.strengthUnits = _data["strengthUnits"];
      this.fluidProductFlag = _data["fluidProductFlag"];
      this.dose = _data["dose"];
      this.packageSize = _data["packageSize"];
      this.activeIngredientId = _data["activeIngredientId"];
    }
  }

  static fromJS(data: any): TplProduct {
    data = typeof data === 'object' ? data : {};
    let result = new TplProduct();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["productId"] = this.productId;
    data["genericProductName"] = this.genericProductName;
    data["productStrengthText"] = this.productStrengthText;
    data["productCostAmt"] = this.productCostAmt;
    data["deaScheduleName"] = this.deaScheduleName;
    data["aocRequiredFlag"] = this.aocRequiredFlag;
    data["lotControlledFlag"] = this.lotControlledFlag;
    data["temperatureControlledFlag"] = this.temperatureControlledFlag;
    data["selectDayShippingFlag"] = this.selectDayShippingFlag;
    data["antibioticFlag"] = this.antibioticFlag;
    data["hazardousFlag"] = this.hazardousFlag;
    data["serialTrackedFlag"] = this.serialTrackedFlag;
    data["smallOrderDepartmentFlag"] = this.smallOrderDepartmentFlag;
    data["orderSplitFlag"] = this.orderSplitFlag;
    data["signatureRequiredFlag"] = this.signatureRequiredFlag;
    data["autoIncludedFlag"] = this.autoIncludedFlag;
    data["orderableFlag"] = this.orderableFlag;
    data["opioidFlag"] = this.opioidFlag;
    data["knipperProductFlag"] = this.knipperProductFlag;
    data["displayQtyText"] = this.displayQtyText;
    data["animalHealthFlag"] = this.animalHealthFlag;
    data["remsCheckFlag"] = this.remsCheckFlag;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["externalProductSfaId"] = this.externalProductSfaId;
    data["allocationMultiplier"] = this.allocationMultiplier;
    data["productReplacementFlag"] = this.productReplacementFlag;
    data["somNationalDrugCode"] = this.somNationalDrugCode;
    data["strength"] = this.strength;
    data["strengthUnits"] = this.strengthUnits;
    data["fluidProductFlag"] = this.fluidProductFlag;
    data["dose"] = this.dose;
    data["packageSize"] = this.packageSize;
    data["activeIngredientId"] = this.activeIngredientId;
    return data;
  }

  clone(): TplProduct {
    const json = this.toJSON();
    let result = new TplProduct();
    result.init(json);
    return result;
  }
}

export interface ITplProduct {
  productId: string | undefined;
  genericProductName: string | undefined;
  productStrengthText: string | undefined;
  productCostAmt: number | undefined;
  deaScheduleName: string | undefined;
  aocRequiredFlag: boolean | undefined;
  lotControlledFlag: boolean | undefined;
  temperatureControlledFlag: boolean | undefined;
  selectDayShippingFlag: boolean | undefined;
  antibioticFlag: boolean | undefined;
  hazardousFlag: boolean | undefined;
  serialTrackedFlag: boolean | undefined;
  smallOrderDepartmentFlag: boolean | undefined;
  orderSplitFlag: boolean | undefined;
  signatureRequiredFlag: boolean | undefined;
  autoIncludedFlag: boolean | undefined;
  orderableFlag: boolean | undefined;
  opioidFlag: boolean | undefined;
  knipperProductFlag: boolean | undefined;
  displayQtyText: string | undefined;
  animalHealthFlag: boolean | undefined;
  remsCheckFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  externalProductSfaId: string | undefined;
  allocationMultiplier: number | undefined;
  productReplacementFlag: boolean | undefined;
  somNationalDrugCode: string | undefined;
  strength: number | undefined;
  strengthUnits: string | undefined;
  fluidProductFlag: boolean | undefined;
  dose: number | undefined;
  packageSize: number | undefined;
  activeIngredientId: string | undefined;
}

export class ProductInventory implements IProductInventory {
  inventoryCount: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProductInventory) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.inventoryCount = _data["inventoryCount"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProductInventory {
    data = typeof data === 'object' ? data : {};
    let result = new ProductInventory();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["inventoryCount"] = this.inventoryCount;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProductInventory {
    const json = this.toJSON();
    let result = new ProductInventory();
    result.init(json);
    return result;
  }
}

export interface IProductInventory {
  inventoryCount: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ProductGroupProduct implements IProductGroupProduct {
  productId: string | undefined;
  productGroupId: string | undefined;
  productGroup: ProductGroup | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IProductGroupProduct) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productId = _data["productId"];
      this.productGroupId = _data["productGroupId"];
      this.productGroup = _data["productGroup"] ? ProductGroup.fromJS(_data["productGroup"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ProductGroupProduct {
    data = typeof data === 'object' ? data : {};
    let result = new ProductGroupProduct();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["productId"] = this.productId;
    data["productGroupId"] = this.productGroupId;
    data["productGroup"] = this.productGroup ? this.productGroup.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ProductGroupProduct {
    const json = this.toJSON();
    let result = new ProductGroupProduct();
    result.init(json);
    return result;
  }
}

export interface IProductGroupProduct {
  productId: string | undefined;
  productGroupId: string | undefined;
  productGroup: ProductGroup | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class RrofrOrderLineStatusHistory implements IRrofrOrderLineStatusHistory {
  rrofrOrderLineId: string | undefined;
  rrofrOrderLineStatusClassificatonId: string | undefined;
  rrofrOrderLineStatus: ReferencedClassification | undefined;
  rrofrOrderLine: RrofrOrderLine | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IRrofrOrderLineStatusHistory) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rrofrOrderLineId = _data["rrofrOrderLineId"];
      this.rrofrOrderLineStatusClassificatonId = _data["rrofrOrderLineStatusClassificatonId"];
      this.rrofrOrderLineStatus = _data["rrofrOrderLineStatus"] ? ReferencedClassification.fromJS(_data["rrofrOrderLineStatus"]) : <any>undefined;
      this.rrofrOrderLine = _data["rrofrOrderLine"] ? RrofrOrderLine.fromJS(_data["rrofrOrderLine"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RrofrOrderLineStatusHistory {
    data = typeof data === 'object' ? data : {};
    let result = new RrofrOrderLineStatusHistory();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["rrofrOrderLineId"] = this.rrofrOrderLineId;
    data["rrofrOrderLineStatusClassificatonId"] = this.rrofrOrderLineStatusClassificatonId;
    data["rrofrOrderLineStatus"] = this.rrofrOrderLineStatus ? this.rrofrOrderLineStatus.toJSON() : <any>undefined;
    data["rrofrOrderLine"] = this.rrofrOrderLine ? this.rrofrOrderLine.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): RrofrOrderLineStatusHistory {
    const json = this.toJSON();
    let result = new RrofrOrderLineStatusHistory();
    result.init(json);
    return result;
  }
}

export interface IRrofrOrderLineStatusHistory {
  rrofrOrderLineId: string | undefined;
  rrofrOrderLineStatusClassificatonId: string | undefined;
  rrofrOrderLineStatus: ReferencedClassification | undefined;
  rrofrOrderLine: RrofrOrderLine | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ShipmentContainerLine implements IShipmentContainerLine {
  shipmentContainerId: string | undefined;
  productId: string | undefined;
  shippedQty: number | undefined;
  returnedQty: number | undefined;
  deliveredQty: number | undefined;
  lotId: string | undefined;
  uom: string | undefined;
  lotExpirationDate: Date | undefined;
  shipmentContainerOrderLines: ShipmentContainerOrderLine[] | undefined;
  shipmentContainer: ShipmentContainer | undefined;
  product: Product | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IShipmentContainerLine) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.shipmentContainerId = _data["shipmentContainerId"];
      this.productId = _data["productId"];
      this.shippedQty = _data["shippedQty"];
      this.returnedQty = _data["returnedQty"];
      this.deliveredQty = _data["deliveredQty"];
      this.lotId = _data["lotId"];
      this.uom = _data["uom"];
      this.lotExpirationDate = _data["lotExpirationDate"] ? new Date(_data["lotExpirationDate"].toString()) : <any>undefined;
      if (Array.isArray(_data["shipmentContainerOrderLines"])) {
        this.shipmentContainerOrderLines = [] as any;
        for (let item of _data["shipmentContainerOrderLines"])
          this.shipmentContainerOrderLines.push(ShipmentContainerOrderLine.fromJS(item));
      }
      this.shipmentContainer = _data["shipmentContainer"] ? ShipmentContainer.fromJS(_data["shipmentContainer"]) : <any>undefined;
      this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ShipmentContainerLine {
    data = typeof data === 'object' ? data : {};
    let result = new ShipmentContainerLine();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["shipmentContainerId"] = this.shipmentContainerId;
    data["productId"] = this.productId;
    data["shippedQty"] = this.shippedQty;
    data["returnedQty"] = this.returnedQty;
    data["deliveredQty"] = this.deliveredQty;
    data["lotId"] = this.lotId;
    data["uom"] = this.uom;
    data["lotExpirationDate"] = this.lotExpirationDate ? this.lotExpirationDate.toISOString() : <any>undefined;
    if (Array.isArray(this.shipmentContainerOrderLines)) {
      data["shipmentContainerOrderLines"] = [];
      for (let item of this.shipmentContainerOrderLines)
        data["shipmentContainerOrderLines"].push(item.toJSON());
    }
    data["shipmentContainer"] = this.shipmentContainer ? this.shipmentContainer.toJSON() : <any>undefined;
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ShipmentContainerLine {
    const json = this.toJSON();
    let result = new ShipmentContainerLine();
    result.init(json);
    return result;
  }
}

export interface IShipmentContainerLine {
  shipmentContainerId: string | undefined;
  productId: string | undefined;
  shippedQty: number | undefined;
  returnedQty: number | undefined;
  deliveredQty: number | undefined;
  lotId: string | undefined;
  uom: string | undefined;
  lotExpirationDate: Date | undefined;
  shipmentContainerOrderLines: ShipmentContainerOrderLine[] | undefined;
  shipmentContainer: ShipmentContainer | undefined;
  product: Product | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class ReferencedEntityAttribute implements IReferencedEntityAttribute {
  referencedEntityId: string | undefined;
  attributeTypeClassificationValueId: string | undefined;
  attributeType: ReferencedClassification | undefined;
  referencedEntity: ReferencedEntity | undefined;
  attributeValueText: string | undefined;
  readonly attributeDateValue: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IReferencedEntityAttribute) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.referencedEntityId = _data["referencedEntityId"];
      this.attributeTypeClassificationValueId = _data["attributeTypeClassificationValueId"];
      this.attributeType = _data["attributeType"] ? ReferencedClassification.fromJS(_data["attributeType"]) : <any>undefined;
      this.referencedEntity = _data["referencedEntity"] ? ReferencedEntity.fromJS(_data["referencedEntity"]) : <any>undefined;
      this.attributeValueText = _data["attributeValueText"];
      (<any>this).attributeDateValue = _data["attributeDateValue"] ? new Date(_data["attributeDateValue"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ReferencedEntityAttribute {
    data = typeof data === 'object' ? data : {};
    let result = new ReferencedEntityAttribute();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["referencedEntityId"] = this.referencedEntityId;
    data["attributeTypeClassificationValueId"] = this.attributeTypeClassificationValueId;
    data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : <any>undefined;
    data["referencedEntity"] = this.referencedEntity ? this.referencedEntity.toJSON() : <any>undefined;
    data["attributeValueText"] = this.attributeValueText;
    data["attributeDateValue"] = this.attributeDateValue ? this.attributeDateValue.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ReferencedEntityAttribute {
    const json = this.toJSON();
    let result = new ReferencedEntityAttribute();
    result.init(json);
    return result;
  }
}

export interface IReferencedEntityAttribute {
  referencedEntityId: string | undefined;
  attributeTypeClassificationValueId: string | undefined;
  attributeType: ReferencedClassification | undefined;
  referencedEntity: ReferencedEntity | undefined;
  attributeValueText: string | undefined;
  attributeDateValue: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Aod implements IAod {
  orderId: string | undefined;
  shipmentContainerId: string | undefined;
  actualDeliveryDate: Date | undefined;
  deliverySignatureName: string | undefined;
  isConfirmedLitEventFlag: boolean | undefined;
  order: Order | undefined;
  shipmentContainer: ShipmentContainer | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAod) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.shipmentContainerId = _data["shipmentContainerId"];
      this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
      this.deliverySignatureName = _data["deliverySignatureName"];
      this.isConfirmedLitEventFlag = _data["isConfirmedLitEventFlag"];
      this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
      this.shipmentContainer = _data["shipmentContainer"] ? ShipmentContainer.fromJS(_data["shipmentContainer"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Aod {
    data = typeof data === 'object' ? data : {};
    let result = new Aod();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["shipmentContainerId"] = this.shipmentContainerId;
    data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
    data["deliverySignatureName"] = this.deliverySignatureName;
    data["isConfirmedLitEventFlag"] = this.isConfirmedLitEventFlag;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["shipmentContainer"] = this.shipmentContainer ? this.shipmentContainer.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Aod {
    const json = this.toJSON();
    let result = new Aod();
    result.init(json);
    return result;
  }
}

export interface IAod {
  orderId: string | undefined;
  shipmentContainerId: string | undefined;
  actualDeliveryDate: Date | undefined;
  deliverySignatureName: string | undefined;
  isConfirmedLitEventFlag: boolean | undefined;
  order: Order | undefined;
  shipmentContainer: ShipmentContainer | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class Rule implements IRule {
  ruleCode: string | undefined;
  ruleGroupCode: string | undefined;
  ruleName: string | undefined;
  commentsText: string | undefined;
  ruleCriteriaJson: string | undefined;
  repDrivenApplicabilityFlag: boolean | undefined;
  institutionDrivenApplicabilityFlag: boolean | undefined;
  electronicApplicabilityFlag: boolean | undefined;
  paperApplicabilityFlag: boolean | undefined;
  baseDtpFlag: boolean | undefined;
  baseTplFlag: boolean | undefined;
  mitigationLookupFlag: boolean | undefined;
  mitigationProcessingFlag: boolean | undefined;
  linkToSourceFlag: boolean | undefined;
  orderValidationFailureOutcomeClassificationValueId: string | undefined;
  relatedRuleId: string | undefined;
  relatedRule: Rule | undefined;
  mandatoryFlag: boolean | undefined;
  printReasonFlag: boolean | undefined;
  defaultPrintReasonText: string | undefined;
  displaySortOrder: number | undefined;
  displayGroupCode: string | undefined;
  patientApplicabiltyFlag: boolean | undefined;
  orderStatusReasonTypeId: string | undefined;
  secondaryValidationFlag: boolean | undefined;
  defaultSecondaryValidationValue: boolean | undefined;
  baseFGFlag: boolean | undefined;
  relatedRules: Rule[] | undefined;
  ruleContexts: RuleContext[] | undefined;
  customerTypeSpecificFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IRule) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleCode = _data["ruleCode"];
      this.ruleGroupCode = _data["ruleGroupCode"];
      this.ruleName = _data["ruleName"];
      this.commentsText = _data["commentsText"];
      this.ruleCriteriaJson = _data["ruleCriteriaJson"];
      this.repDrivenApplicabilityFlag = _data["repDrivenApplicabilityFlag"];
      this.institutionDrivenApplicabilityFlag = _data["institutionDrivenApplicabilityFlag"];
      this.electronicApplicabilityFlag = _data["electronicApplicabilityFlag"];
      this.paperApplicabilityFlag = _data["paperApplicabilityFlag"];
      this.baseDtpFlag = _data["baseDtpFlag"];
      this.baseTplFlag = _data["baseTplFlag"];
      this.mitigationLookupFlag = _data["mitigationLookupFlag"];
      this.mitigationProcessingFlag = _data["mitigationProcessingFlag"];
      this.linkToSourceFlag = _data["linkToSourceFlag"];
      this.orderValidationFailureOutcomeClassificationValueId = _data["orderValidationFailureOutcomeClassificationValueId"];
      this.relatedRuleId = _data["relatedRuleId"];
      this.relatedRule = _data["relatedRule"] ? Rule.fromJS(_data["relatedRule"]) : <any>undefined;
      this.mandatoryFlag = _data["mandatoryFlag"];
      this.printReasonFlag = _data["printReasonFlag"];
      this.defaultPrintReasonText = _data["defaultPrintReasonText"];
      this.displaySortOrder = _data["displaySortOrder"];
      this.displayGroupCode = _data["displayGroupCode"];
      this.patientApplicabiltyFlag = _data["patientApplicabiltyFlag"];
      this.orderStatusReasonTypeId = _data["orderStatusReasonTypeId"];
      this.secondaryValidationFlag = _data["secondaryValidationFlag"];
      this.defaultSecondaryValidationValue = _data["defaultSecondaryValidationValue"];
      this.baseFGFlag = _data["baseFGFlag"];
      if (Array.isArray(_data["relatedRules"])) {
        this.relatedRules = [] as any;
        for (let item of _data["relatedRules"])
          this.relatedRules.push(Rule.fromJS(item));
      }
      if (Array.isArray(_data["ruleContexts"])) {
        this.ruleContexts = [] as any;
        for (let item of _data["ruleContexts"])
          this.ruleContexts.push(RuleContext.fromJS(item));
      }
      this.customerTypeSpecificFlag = _data["customerTypeSpecificFlag"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): Rule {
    data = typeof data === 'object' ? data : {};
    let result = new Rule();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ruleCode"] = this.ruleCode;
    data["ruleGroupCode"] = this.ruleGroupCode;
    data["ruleName"] = this.ruleName;
    data["commentsText"] = this.commentsText;
    data["ruleCriteriaJson"] = this.ruleCriteriaJson;
    data["repDrivenApplicabilityFlag"] = this.repDrivenApplicabilityFlag;
    data["institutionDrivenApplicabilityFlag"] = this.institutionDrivenApplicabilityFlag;
    data["electronicApplicabilityFlag"] = this.electronicApplicabilityFlag;
    data["paperApplicabilityFlag"] = this.paperApplicabilityFlag;
    data["baseDtpFlag"] = this.baseDtpFlag;
    data["baseTplFlag"] = this.baseTplFlag;
    data["mitigationLookupFlag"] = this.mitigationLookupFlag;
    data["mitigationProcessingFlag"] = this.mitigationProcessingFlag;
    data["linkToSourceFlag"] = this.linkToSourceFlag;
    data["orderValidationFailureOutcomeClassificationValueId"] = this.orderValidationFailureOutcomeClassificationValueId;
    data["relatedRuleId"] = this.relatedRuleId;
    data["relatedRule"] = this.relatedRule ? this.relatedRule.toJSON() : <any>undefined;
    data["mandatoryFlag"] = this.mandatoryFlag;
    data["printReasonFlag"] = this.printReasonFlag;
    data["defaultPrintReasonText"] = this.defaultPrintReasonText;
    data["displaySortOrder"] = this.displaySortOrder;
    data["displayGroupCode"] = this.displayGroupCode;
    data["patientApplicabiltyFlag"] = this.patientApplicabiltyFlag;
    data["orderStatusReasonTypeId"] = this.orderStatusReasonTypeId;
    data["secondaryValidationFlag"] = this.secondaryValidationFlag;
    data["defaultSecondaryValidationValue"] = this.defaultSecondaryValidationValue;
    data["baseFGFlag"] = this.baseFGFlag;
    if (Array.isArray(this.relatedRules)) {
      data["relatedRules"] = [];
      for (let item of this.relatedRules)
        data["relatedRules"].push(item.toJSON());
    }
    if (Array.isArray(this.ruleContexts)) {
      data["ruleContexts"] = [];
      for (let item of this.ruleContexts)
        data["ruleContexts"].push(item.toJSON());
    }
    data["customerTypeSpecificFlag"] = this.customerTypeSpecificFlag;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): Rule {
    const json = this.toJSON();
    let result = new Rule();
    result.init(json);
    return result;
  }
}

export interface IRule {
  ruleCode: string | undefined;
  ruleGroupCode: string | undefined;
  ruleName: string | undefined;
  commentsText: string | undefined;
  ruleCriteriaJson: string | undefined;
  repDrivenApplicabilityFlag: boolean | undefined;
  institutionDrivenApplicabilityFlag: boolean | undefined;
  electronicApplicabilityFlag: boolean | undefined;
  paperApplicabilityFlag: boolean | undefined;
  baseDtpFlag: boolean | undefined;
  baseTplFlag: boolean | undefined;
  mitigationLookupFlag: boolean | undefined;
  mitigationProcessingFlag: boolean | undefined;
  linkToSourceFlag: boolean | undefined;
  orderValidationFailureOutcomeClassificationValueId: string | undefined;
  relatedRuleId: string | undefined;
  relatedRule: Rule | undefined;
  mandatoryFlag: boolean | undefined;
  printReasonFlag: boolean | undefined;
  defaultPrintReasonText: string | undefined;
  displaySortOrder: number | undefined;
  displayGroupCode: string | undefined;
  patientApplicabiltyFlag: boolean | undefined;
  orderStatusReasonTypeId: string | undefined;
  secondaryValidationFlag: boolean | undefined;
  defaultSecondaryValidationValue: boolean | undefined;
  baseFGFlag: boolean | undefined;
  relatedRules: Rule[] | undefined;
  ruleContexts: RuleContext[] | undefined;
  customerTypeSpecificFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacyContactMethod implements IPharmacyContactMethod {
  pharmacyId: string | undefined;
  pharmacyAddressId: string | undefined;
  contactMethodTypeId: string | undefined;
  contactDetailText: string | undefined;
  contactDetailExtensionText: string | undefined;
  knipperCreateFlag: boolean | undefined;
  primaryContactMethodFlag: boolean | undefined;
  pharmacy: Pharmacy | undefined;
  address: PharmacyAddress | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacyContactMethod) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacyId = _data["pharmacyId"];
      this.pharmacyAddressId = _data["pharmacyAddressId"];
      this.contactMethodTypeId = _data["contactMethodTypeId"];
      this.contactDetailText = _data["contactDetailText"];
      this.contactDetailExtensionText = _data["contactDetailExtensionText"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.primaryContactMethodFlag = _data["primaryContactMethodFlag"];
      this.pharmacy = _data["pharmacy"] ? Pharmacy.fromJS(_data["pharmacy"]) : <any>undefined;
      this.address = _data["address"] ? PharmacyAddress.fromJS(_data["address"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacyContactMethod {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacyContactMethod();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacyId"] = this.pharmacyId;
    data["pharmacyAddressId"] = this.pharmacyAddressId;
    data["contactMethodTypeId"] = this.contactMethodTypeId;
    data["contactDetailText"] = this.contactDetailText;
    data["contactDetailExtensionText"] = this.contactDetailExtensionText;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["primaryContactMethodFlag"] = this.primaryContactMethodFlag;
    data["pharmacy"] = this.pharmacy ? this.pharmacy.toJSON() : <any>undefined;
    data["address"] = this.address ? this.address.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacyContactMethod {
    const json = this.toJSON();
    let result = new PharmacyContactMethod();
    result.init(json);
    return result;
  }
}

export interface IPharmacyContactMethod {
  pharmacyId: string | undefined;
  pharmacyAddressId: string | undefined;
  contactMethodTypeId: string | undefined;
  contactDetailText: string | undefined;
  contactDetailExtensionText: string | undefined;
  knipperCreateFlag: boolean | undefined;
  primaryContactMethodFlag: boolean | undefined;
  pharmacy: Pharmacy | undefined;
  address: PharmacyAddress | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacyAddress implements IPharmacyAddress {
  pharmacyId: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  institutionAddressFlag: boolean | undefined;
  primaryAddressFlag: boolean | undefined;
  badAddressFlag: boolean | undefined;
  companyName: string | undefined;
  san: string | undefined;
  groupPracticeName: string | undefined;
  sanExpirationDate: Date | undefined;
  sanExemptionFlag: boolean | undefined;
  activeFlag: boolean | undefined;
  deaNbr: string | undefined;
  knipperCreateFlag: boolean | undefined;
  pharmacy: Pharmacy | undefined;
  contactMethods: PharmacyContactMethod[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacyAddress) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacyId = _data["pharmacyId"];
      this.stateCode = _data["stateCode"];
      this.countryCode = _data["countryCode"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.address3Text = _data["address3Text"];
      this.address4Text = _data["address4Text"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.institutionAddressFlag = _data["institutionAddressFlag"];
      this.primaryAddressFlag = _data["primaryAddressFlag"];
      this.badAddressFlag = _data["badAddressFlag"];
      this.companyName = _data["companyName"];
      this.san = _data["san"];
      this.groupPracticeName = _data["groupPracticeName"];
      this.sanExpirationDate = _data["sanExpirationDate"] ? new Date(_data["sanExpirationDate"].toString()) : <any>undefined;
      this.sanExemptionFlag = _data["sanExemptionFlag"];
      this.activeFlag = _data["activeFlag"];
      this.deaNbr = _data["deaNbr"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.pharmacy = _data["pharmacy"] ? Pharmacy.fromJS(_data["pharmacy"]) : <any>undefined;
      if (Array.isArray(_data["contactMethods"])) {
        this.contactMethods = [] as any;
        for (let item of _data["contactMethods"])
          this.contactMethods.push(PharmacyContactMethod.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacyAddress {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacyAddress();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacyId"] = this.pharmacyId;
    data["stateCode"] = this.stateCode;
    data["countryCode"] = this.countryCode;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["address3Text"] = this.address3Text;
    data["address4Text"] = this.address4Text;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["institutionAddressFlag"] = this.institutionAddressFlag;
    data["primaryAddressFlag"] = this.primaryAddressFlag;
    data["badAddressFlag"] = this.badAddressFlag;
    data["companyName"] = this.companyName;
    data["san"] = this.san;
    data["groupPracticeName"] = this.groupPracticeName;
    data["sanExpirationDate"] = this.sanExpirationDate ? this.sanExpirationDate.toISOString() : <any>undefined;
    data["sanExemptionFlag"] = this.sanExemptionFlag;
    data["activeFlag"] = this.activeFlag;
    data["deaNbr"] = this.deaNbr;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["pharmacy"] = this.pharmacy ? this.pharmacy.toJSON() : <any>undefined;
    if (Array.isArray(this.contactMethods)) {
      data["contactMethods"] = [];
      for (let item of this.contactMethods)
        data["contactMethods"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacyAddress {
    const json = this.toJSON();
    let result = new PharmacyAddress();
    result.init(json);
    return result;
  }
}

export interface IPharmacyAddress {
  pharmacyId: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  institutionAddressFlag: boolean | undefined;
  primaryAddressFlag: boolean | undefined;
  badAddressFlag: boolean | undefined;
  companyName: string | undefined;
  san: string | undefined;
  groupPracticeName: string | undefined;
  sanExpirationDate: Date | undefined;
  sanExemptionFlag: boolean | undefined;
  activeFlag: boolean | undefined;
  deaNbr: string | undefined;
  knipperCreateFlag: boolean | undefined;
  pharmacy: Pharmacy | undefined;
  contactMethods: PharmacyContactMethod[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacyLicense implements IPharmacyLicense {
  pharmacyId: string | undefined;
  stateCode: string | undefined;
  stateLicenseNbr: string | undefined;
  sampleEligibilityFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  licenseExpirationDate: Date | undefined;
  pharmacy: Pharmacy | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacyLicense) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacyId = _data["pharmacyId"];
      this.stateCode = _data["stateCode"];
      this.stateLicenseNbr = _data["stateLicenseNbr"];
      this.sampleEligibilityFlag = _data["sampleEligibilityFlag"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.licenseExpirationDate = _data["licenseExpirationDate"] ? new Date(_data["licenseExpirationDate"].toString()) : <any>undefined;
      this.pharmacy = _data["pharmacy"] ? Pharmacy.fromJS(_data["pharmacy"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacyLicense {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacyLicense();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacyId"] = this.pharmacyId;
    data["stateCode"] = this.stateCode;
    data["stateLicenseNbr"] = this.stateLicenseNbr;
    data["sampleEligibilityFlag"] = this.sampleEligibilityFlag;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
    data["pharmacy"] = this.pharmacy ? this.pharmacy.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacyLicense {
    const json = this.toJSON();
    let result = new PharmacyLicense();
    result.init(json);
    return result;
  }
}

export interface IPharmacyLicense {
  pharmacyId: string | undefined;
  stateCode: string | undefined;
  stateLicenseNbr: string | undefined;
  sampleEligibilityFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  licenseExpirationDate: Date | undefined;
  pharmacy: Pharmacy | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class PharmacyProgram implements IPharmacyProgram {
  pharmacyId: string | undefined;
  programId: string | undefined;
  program: Program | undefined;
  pharmacy: Pharmacy | undefined;
  readonly programName: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IPharmacyProgram) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacyId = _data["pharmacyId"];
      this.programId = _data["programId"];
      this.program = _data["program"] ? Program.fromJS(_data["program"]) : <any>undefined;
      this.pharmacy = _data["pharmacy"] ? Pharmacy.fromJS(_data["pharmacy"]) : <any>undefined;
      (<any>this).programName = _data["programName"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): PharmacyProgram {
    data = typeof data === 'object' ? data : {};
    let result = new PharmacyProgram();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacyId"] = this.pharmacyId;
    data["programId"] = this.programId;
    data["program"] = this.program ? this.program.toJSON() : <any>undefined;
    data["pharmacy"] = this.pharmacy ? this.pharmacy.toJSON() : <any>undefined;
    data["programName"] = this.programName;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): PharmacyProgram {
    const json = this.toJSON();
    let result = new PharmacyProgram();
    result.init(json);
    return result;
  }
}

export interface IPharmacyProgram {
  pharmacyId: string | undefined;
  programId: string | undefined;
  program: Program | undefined;
  pharmacy: Pharmacy | undefined;
  programName: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HospitalContactMethod implements IHospitalContactMethod {
  hospitalId: string | undefined;
  hospitalAddressId: string | undefined;
  contactMethodTypeId: string | undefined;
  contactDetailText: string | undefined;
  contactDetailExtensionText: string | undefined;
  knipperCreateFlag: boolean | undefined;
  primaryContactMethodFlag: boolean | undefined;
  hospital: Hospital | undefined;
  address: HospitalAddress | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHospitalContactMethod) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hospitalId = _data["hospitalId"];
      this.hospitalAddressId = _data["hospitalAddressId"];
      this.contactMethodTypeId = _data["contactMethodTypeId"];
      this.contactDetailText = _data["contactDetailText"];
      this.contactDetailExtensionText = _data["contactDetailExtensionText"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.primaryContactMethodFlag = _data["primaryContactMethodFlag"];
      this.hospital = _data["hospital"] ? Hospital.fromJS(_data["hospital"]) : <any>undefined;
      this.address = _data["address"] ? HospitalAddress.fromJS(_data["address"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HospitalContactMethod {
    data = typeof data === 'object' ? data : {};
    let result = new HospitalContactMethod();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hospitalId"] = this.hospitalId;
    data["hospitalAddressId"] = this.hospitalAddressId;
    data["contactMethodTypeId"] = this.contactMethodTypeId;
    data["contactDetailText"] = this.contactDetailText;
    data["contactDetailExtensionText"] = this.contactDetailExtensionText;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["primaryContactMethodFlag"] = this.primaryContactMethodFlag;
    data["hospital"] = this.hospital ? this.hospital.toJSON() : <any>undefined;
    data["address"] = this.address ? this.address.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HospitalContactMethod {
    const json = this.toJSON();
    let result = new HospitalContactMethod();
    result.init(json);
    return result;
  }
}

export interface IHospitalContactMethod {
  hospitalId: string | undefined;
  hospitalAddressId: string | undefined;
  contactMethodTypeId: string | undefined;
  contactDetailText: string | undefined;
  contactDetailExtensionText: string | undefined;
  knipperCreateFlag: boolean | undefined;
  primaryContactMethodFlag: boolean | undefined;
  hospital: Hospital | undefined;
  address: HospitalAddress | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HospitalAddress implements IHospitalAddress {
  hospitalId: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  institutionAddressFlag: boolean | undefined;
  primaryAddressFlag: boolean | undefined;
  badAddressFlag: boolean | undefined;
  clientAddressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  groupPracticeName: string | undefined;
  sanExpirationDate: Date | undefined;
  sanExemptionFlag: boolean | undefined;
  activeFlag: boolean | undefined;
  deaNbr: string | undefined;
  knipperCreateFlag: boolean | undefined;
  hospital: Hospital | undefined;
  contactMethods: HospitalContactMethod[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHospitalAddress) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hospitalId = _data["hospitalId"];
      this.stateCode = _data["stateCode"];
      this.countryCode = _data["countryCode"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.address3Text = _data["address3Text"];
      this.address4Text = _data["address4Text"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.institutionAddressFlag = _data["institutionAddressFlag"];
      this.primaryAddressFlag = _data["primaryAddressFlag"];
      this.badAddressFlag = _data["badAddressFlag"];
      this.clientAddressId = _data["clientAddressId"];
      this.companyName = _data["companyName"];
      this.san = _data["san"];
      this.groupPracticeName = _data["groupPracticeName"];
      this.sanExpirationDate = _data["sanExpirationDate"] ? new Date(_data["sanExpirationDate"].toString()) : <any>undefined;
      this.sanExemptionFlag = _data["sanExemptionFlag"];
      this.activeFlag = _data["activeFlag"];
      this.deaNbr = _data["deaNbr"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.hospital = _data["hospital"] ? Hospital.fromJS(_data["hospital"]) : <any>undefined;
      if (Array.isArray(_data["contactMethods"])) {
        this.contactMethods = [] as any;
        for (let item of _data["contactMethods"])
          this.contactMethods.push(HospitalContactMethod.fromJS(item));
      }
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HospitalAddress {
    data = typeof data === 'object' ? data : {};
    let result = new HospitalAddress();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hospitalId"] = this.hospitalId;
    data["stateCode"] = this.stateCode;
    data["countryCode"] = this.countryCode;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["address3Text"] = this.address3Text;
    data["address4Text"] = this.address4Text;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["institutionAddressFlag"] = this.institutionAddressFlag;
    data["primaryAddressFlag"] = this.primaryAddressFlag;
    data["badAddressFlag"] = this.badAddressFlag;
    data["clientAddressId"] = this.clientAddressId;
    data["companyName"] = this.companyName;
    data["san"] = this.san;
    data["groupPracticeName"] = this.groupPracticeName;
    data["sanExpirationDate"] = this.sanExpirationDate ? this.sanExpirationDate.toISOString() : <any>undefined;
    data["sanExemptionFlag"] = this.sanExemptionFlag;
    data["activeFlag"] = this.activeFlag;
    data["deaNbr"] = this.deaNbr;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["hospital"] = this.hospital ? this.hospital.toJSON() : <any>undefined;
    if (Array.isArray(this.contactMethods)) {
      data["contactMethods"] = [];
      for (let item of this.contactMethods)
        data["contactMethods"].push(item.toJSON());
    }
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HospitalAddress {
    const json = this.toJSON();
    let result = new HospitalAddress();
    result.init(json);
    return result;
  }
}

export interface IHospitalAddress {
  hospitalId: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  institutionAddressFlag: boolean | undefined;
  primaryAddressFlag: boolean | undefined;
  badAddressFlag: boolean | undefined;
  clientAddressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  groupPracticeName: string | undefined;
  sanExpirationDate: Date | undefined;
  sanExemptionFlag: boolean | undefined;
  activeFlag: boolean | undefined;
  deaNbr: string | undefined;
  knipperCreateFlag: boolean | undefined;
  hospital: Hospital | undefined;
  contactMethods: HospitalContactMethod[] | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class HospitalLicense implements IHospitalLicense {
  hospitalId: string | undefined;
  stateCode: string | undefined;
  stateLicenseNbr: string | undefined;
  sampleEligibilityFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  licenseExpirationDate: Date | undefined;
  pharmacist: Hospital | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IHospitalLicense) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hospitalId = _data["hospitalId"];
      this.stateCode = _data["stateCode"];
      this.stateLicenseNbr = _data["stateLicenseNbr"];
      this.sampleEligibilityFlag = _data["sampleEligibilityFlag"];
      this.knipperCreateFlag = _data["knipperCreateFlag"];
      this.licenseExpirationDate = _data["licenseExpirationDate"] ? new Date(_data["licenseExpirationDate"].toString()) : <any>undefined;
      this.pharmacist = _data["pharmacist"] ? Hospital.fromJS(_data["pharmacist"]) : <any>undefined;
      this.sourceText = _data["sourceText"];
      this.sourceNoteText = _data["sourceNoteText"];
      this.sourceUpdateDateTime = _data["sourceUpdateDateTime"] ? new Date(_data["sourceUpdateDateTime"].toString()) : <any>undefined;
      this.deletionSourceText = _data["deletionSourceText"];
      this.deletionSourceNoteText = _data["deletionSourceNoteText"];
      this.deletionSourceDateTime = _data["deletionSourceDateTime"] ? new Date(_data["deletionSourceDateTime"].toString()) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HospitalLicense {
    data = typeof data === 'object' ? data : {};
    let result = new HospitalLicense();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hospitalId"] = this.hospitalId;
    data["stateCode"] = this.stateCode;
    data["stateLicenseNbr"] = this.stateLicenseNbr;
    data["sampleEligibilityFlag"] = this.sampleEligibilityFlag;
    data["knipperCreateFlag"] = this.knipperCreateFlag;
    data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
    data["pharmacist"] = this.pharmacist ? this.pharmacist.toJSON() : <any>undefined;
    data["sourceText"] = this.sourceText;
    data["sourceNoteText"] = this.sourceNoteText;
    data["sourceUpdateDateTime"] = this.sourceUpdateDateTime ? this.sourceUpdateDateTime.toISOString() : <any>undefined;
    data["deletionSourceText"] = this.deletionSourceText;
    data["deletionSourceNoteText"] = this.deletionSourceNoteText;
    data["deletionSourceDateTime"] = this.deletionSourceDateTime ? this.deletionSourceDateTime.toISOString() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): HospitalLicense {
    const json = this.toJSON();
    let result = new HospitalLicense();
    result.init(json);
    return result;
  }
}

export interface IHospitalLicense {
  hospitalId: string | undefined;
  stateCode: string | undefined;
  stateLicenseNbr: string | undefined;
  sampleEligibilityFlag: boolean | undefined;
  knipperCreateFlag: boolean | undefined;
  licenseExpirationDate: Date | undefined;
  pharmacist: Hospital | undefined;
  sourceText: string | undefined;
  sourceNoteText: string | undefined;
  sourceUpdateDateTime: Date | undefined;
  deletionSourceText: string | undefined;
  deletionSourceNoteText: string | undefined;
  deletionSourceDateTime: Date | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationProductDecile implements ITplProgramConfigurationProductDecile {
  dtpProgramConfigurationProductId: string | undefined;
  decileClassificationValueId: string | undefined;
  offeredQty: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationProductDecile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationProductId = _data["dtpProgramConfigurationProductId"];
      this.decileClassificationValueId = _data["decileClassificationValueId"];
      this.offeredQty = _data["offeredQty"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationProductDecile {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationProductDecile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationProductId"] = this.dtpProgramConfigurationProductId;
    data["decileClassificationValueId"] = this.decileClassificationValueId;
    data["offeredQty"] = this.offeredQty;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationProductDecile {
    const json = this.toJSON();
    let result = new TplProgramConfigurationProductDecile();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationProductDecile {
  dtpProgramConfigurationProductId: string | undefined;
  decileClassificationValueId: string | undefined;
  offeredQty: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationNotificationRecipient implements ITplProgramConfigurationNotificationRecipient {
  dtpProgramConfigurationNotificationId: string | undefined;
  recipientTypeClassificationValueId: string | undefined;
  receiveFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationNotificationRecipient) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationNotificationId = _data["dtpProgramConfigurationNotificationId"];
      this.recipientTypeClassificationValueId = _data["recipientTypeClassificationValueId"];
      this.receiveFlag = _data["receiveFlag"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationNotificationRecipient {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationNotificationRecipient();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationNotificationId"] = this.dtpProgramConfigurationNotificationId;
    data["recipientTypeClassificationValueId"] = this.recipientTypeClassificationValueId;
    data["receiveFlag"] = this.receiveFlag;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationNotificationRecipient {
    const json = this.toJSON();
    let result = new TplProgramConfigurationNotificationRecipient();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationNotificationRecipient {
  dtpProgramConfigurationNotificationId: string | undefined;
  recipientTypeClassificationValueId: string | undefined;
  receiveFlag: boolean | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationCommunicationRecipient implements ITplProgramConfigurationCommunicationRecipient {
  dtpProgramConfigurationCommunicationId: string | undefined;
  recipientSenderTypeClassificationValueId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationCommunicationRecipient) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationCommunicationId = _data["dtpProgramConfigurationCommunicationId"];
      this.recipientSenderTypeClassificationValueId = _data["recipientSenderTypeClassificationValueId"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationCommunicationRecipient {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationCommunicationRecipient();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationCommunicationId"] = this.dtpProgramConfigurationCommunicationId;
    data["recipientSenderTypeClassificationValueId"] = this.recipientSenderTypeClassificationValueId;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationCommunicationRecipient {
    const json = this.toJSON();
    let result = new TplProgramConfigurationCommunicationRecipient();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationCommunicationRecipient {
  dtpProgramConfigurationCommunicationId: string | undefined;
  recipientSenderTypeClassificationValueId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class TplProgramConfigurationLetterTemplateTypeAutoInclude implements ITplProgramConfigurationLetterTemplateTypeAutoInclude {
  dtpProgramConfigurationLetterTemplateTypeId: string | undefined;
  autoIncludeProductId: string | undefined;
  autoIncludeProductQty: number | undefined;
  autoIncludeRequiredFlag: boolean | undefined;
  ruleNumber: number | undefined;
  autoIncludeProduct: Product | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: ITplProgramConfigurationLetterTemplateTypeAutoInclude) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationLetterTemplateTypeId = _data["dtpProgramConfigurationLetterTemplateTypeId"];
      this.autoIncludeProductId = _data["autoIncludeProductId"];
      this.autoIncludeProductQty = _data["autoIncludeProductQty"];
      this.autoIncludeRequiredFlag = _data["autoIncludeRequiredFlag"];
      this.ruleNumber = _data["ruleNumber"];
      this.autoIncludeProduct = _data["autoIncludeProduct"] ? Product.fromJS(_data["autoIncludeProduct"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TplProgramConfigurationLetterTemplateTypeAutoInclude {
    data = typeof data === 'object' ? data : {};
    let result = new TplProgramConfigurationLetterTemplateTypeAutoInclude();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationLetterTemplateTypeId"] = this.dtpProgramConfigurationLetterTemplateTypeId;
    data["autoIncludeProductId"] = this.autoIncludeProductId;
    data["autoIncludeProductQty"] = this.autoIncludeProductQty;
    data["autoIncludeRequiredFlag"] = this.autoIncludeRequiredFlag;
    data["ruleNumber"] = this.ruleNumber;
    data["autoIncludeProduct"] = this.autoIncludeProduct ? this.autoIncludeProduct.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): TplProgramConfigurationLetterTemplateTypeAutoInclude {
    const json = this.toJSON();
    let result = new TplProgramConfigurationLetterTemplateTypeAutoInclude();
    result.init(json);
    return result;
  }
}

export interface ITplProgramConfigurationLetterTemplateTypeAutoInclude {
  dtpProgramConfigurationLetterTemplateTypeId: string | undefined;
  autoIncludeProductId: string | undefined;
  autoIncludeProductQty: number | undefined;
  autoIncludeRequiredFlag: boolean | undefined;
  ruleNumber: number | undefined;
  autoIncludeProduct: Product | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeBrandLevelOrderSource implements IAutoIncludeBrandLevelOrderSource {
  autoIncludeBrandLevelId: string | undefined;
  orderSourceId: string | undefined;
  orderTypeJson: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeBrandLevelOrderSource) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.autoIncludeBrandLevelId = _data["autoIncludeBrandLevelId"];
      this.orderSourceId = _data["orderSourceId"];
      this.orderTypeJson = _data["orderTypeJson"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeBrandLevelOrderSource {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeBrandLevelOrderSource();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["autoIncludeBrandLevelId"] = this.autoIncludeBrandLevelId;
    data["orderSourceId"] = this.orderSourceId;
    data["orderTypeJson"] = this.orderTypeJson;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeBrandLevelOrderSource {
    const json = this.toJSON();
    let result = new AutoIncludeBrandLevelOrderSource();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeBrandLevelOrderSource {
  autoIncludeBrandLevelId: string | undefined;
  orderSourceId: string | undefined;
  orderTypeJson: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeBrandLevelProductTypeExclusion implements IAutoIncludeBrandLevelProductTypeExclusion {
  autoIncludeBrandLevelId: string | undefined;
  productTypeId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeBrandLevelProductTypeExclusion) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.autoIncludeBrandLevelId = _data["autoIncludeBrandLevelId"];
      this.productTypeId = _data["productTypeId"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeBrandLevelProductTypeExclusion {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeBrandLevelProductTypeExclusion();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["autoIncludeBrandLevelId"] = this.autoIncludeBrandLevelId;
    data["productTypeId"] = this.productTypeId;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeBrandLevelProductTypeExclusion {
    const json = this.toJSON();
    let result = new AutoIncludeBrandLevelProductTypeExclusion();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeBrandLevelProductTypeExclusion {
  autoIncludeBrandLevelId: string | undefined;
  productTypeId: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeBrandLevelQuantityRange implements IAutoIncludeBrandLevelQuantityRange {
  autoIncludeBrandLevelId: string | undefined;
  rangeMinimumQty: number | undefined;
  rangeMaximumQty: number | undefined;
  perOrderIncludedQty: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeBrandLevelQuantityRange) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.autoIncludeBrandLevelId = _data["autoIncludeBrandLevelId"];
      this.rangeMinimumQty = _data["rangeMinimumQty"];
      this.rangeMaximumQty = _data["rangeMaximumQty"];
      this.perOrderIncludedQty = _data["perOrderIncludedQty"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeBrandLevelQuantityRange {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeBrandLevelQuantityRange();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["autoIncludeBrandLevelId"] = this.autoIncludeBrandLevelId;
    data["rangeMinimumQty"] = this.rangeMinimumQty;
    data["rangeMaximumQty"] = this.rangeMaximumQty;
    data["perOrderIncludedQty"] = this.perOrderIncludedQty;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeBrandLevelQuantityRange {
    const json = this.toJSON();
    let result = new AutoIncludeBrandLevelQuantityRange();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeBrandLevelQuantityRange {
  autoIncludeBrandLevelId: string | undefined;
  rangeMinimumQty: number | undefined;
  rangeMaximumQty: number | undefined;
  perOrderIncludedQty: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeBrandLevelState implements IAutoIncludeBrandLevelState {
  autoIncludeBrandLevelId: string | undefined;
  stateCode: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeBrandLevelState) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.autoIncludeBrandLevelId = _data["autoIncludeBrandLevelId"];
      this.stateCode = _data["stateCode"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeBrandLevelState {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeBrandLevelState();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["autoIncludeBrandLevelId"] = this.autoIncludeBrandLevelId;
    data["stateCode"] = this.stateCode;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeBrandLevelState {
    const json = this.toJSON();
    let result = new AutoIncludeBrandLevelState();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeBrandLevelState {
  autoIncludeBrandLevelId: string | undefined;
  stateCode: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeOrderLevelSource implements IAutoIncludeOrderLevelSource {
  autoIncludeOrderLevelId: string | undefined;
  orderSourceId: string | undefined;
  orderTypeJson: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeOrderLevelSource) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.autoIncludeOrderLevelId = _data["autoIncludeOrderLevelId"];
      this.orderSourceId = _data["orderSourceId"];
      this.orderTypeJson = _data["orderTypeJson"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeOrderLevelSource {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeOrderLevelSource();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["autoIncludeOrderLevelId"] = this.autoIncludeOrderLevelId;
    data["orderSourceId"] = this.orderSourceId;
    data["orderTypeJson"] = this.orderTypeJson;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeOrderLevelSource {
    const json = this.toJSON();
    let result = new AutoIncludeOrderLevelSource();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeOrderLevelSource {
  autoIncludeOrderLevelId: string | undefined;
  orderSourceId: string | undefined;
  orderTypeJson: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeOrderLevelState implements IAutoIncludeOrderLevelState {
  autoIncludeOrderLevelId: string | undefined;
  stateCode: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeOrderLevelState) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.autoIncludeOrderLevelId = _data["autoIncludeOrderLevelId"];
      this.stateCode = _data["stateCode"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeOrderLevelState {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeOrderLevelState();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["autoIncludeOrderLevelId"] = this.autoIncludeOrderLevelId;
    data["stateCode"] = this.stateCode;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeOrderLevelState {
    const json = this.toJSON();
    let result = new AutoIncludeOrderLevelState();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeOrderLevelState {
  autoIncludeOrderLevelId: string | undefined;
  stateCode: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeProductLevelSource implements IAutoIncludeProductLevelSource {
  autoIncludeProductLevelId: string | undefined;
  orderSourceId: string | undefined;
  orderTypeJson: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeProductLevelSource) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.autoIncludeProductLevelId = _data["autoIncludeProductLevelId"];
      this.orderSourceId = _data["orderSourceId"];
      this.orderTypeJson = _data["orderTypeJson"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeProductLevelSource {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeProductLevelSource();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["autoIncludeProductLevelId"] = this.autoIncludeProductLevelId;
    data["orderSourceId"] = this.orderSourceId;
    data["orderTypeJson"] = this.orderTypeJson;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeProductLevelSource {
    const json = this.toJSON();
    let result = new AutoIncludeProductLevelSource();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeProductLevelSource {
  autoIncludeProductLevelId: string | undefined;
  orderSourceId: string | undefined;
  orderTypeJson: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeProductLevelQuantityRange implements IAutoIncludeProductLevelQuantityRange {
  autoIncludeProductLevelId: string | undefined;
  rangeMinimumQty: number | undefined;
  rangeMaximumQty: number | undefined;
  perOrderIncludedQty: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeProductLevelQuantityRange) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.autoIncludeProductLevelId = _data["autoIncludeProductLevelId"];
      this.rangeMinimumQty = _data["rangeMinimumQty"];
      this.rangeMaximumQty = _data["rangeMaximumQty"];
      this.perOrderIncludedQty = _data["perOrderIncludedQty"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeProductLevelQuantityRange {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeProductLevelQuantityRange();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["autoIncludeProductLevelId"] = this.autoIncludeProductLevelId;
    data["rangeMinimumQty"] = this.rangeMinimumQty;
    data["rangeMaximumQty"] = this.rangeMaximumQty;
    data["perOrderIncludedQty"] = this.perOrderIncludedQty;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeProductLevelQuantityRange {
    const json = this.toJSON();
    let result = new AutoIncludeProductLevelQuantityRange();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeProductLevelQuantityRange {
  autoIncludeProductLevelId: string | undefined;
  rangeMinimumQty: number | undefined;
  rangeMaximumQty: number | undefined;
  perOrderIncludedQty: number | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class AutoIncludeProductLevelState implements IAutoIncludeProductLevelState {
  autoIncludeProductLevelId: string | undefined;
  stateCode: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IAutoIncludeProductLevelState) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.autoIncludeProductLevelId = _data["autoIncludeProductLevelId"];
      this.stateCode = _data["stateCode"];
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): AutoIncludeProductLevelState {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeProductLevelState();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["autoIncludeProductLevelId"] = this.autoIncludeProductLevelId;
    data["stateCode"] = this.stateCode;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): AutoIncludeProductLevelState {
    const json = this.toJSON();
    let result = new AutoIncludeProductLevelState();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeProductLevelState {
  autoIncludeProductLevelId: string | undefined;
  stateCode: string | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class RuleContext implements IRuleContext {
  ruleId: string | undefined;
  tagTypeClassificationValueId: string | undefined;
  contextTagValueText: string | undefined;
  rule: Rule | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IRuleContext) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleId = _data["ruleId"];
      this.tagTypeClassificationValueId = _data["tagTypeClassificationValueId"];
      this.contextTagValueText = _data["contextTagValueText"];
      this.rule = _data["rule"] ? Rule.fromJS(_data["rule"]) : <any>undefined;
      this.tenantId = _data["tenantId"];
      this.rowVersion = _data["rowVersion"];
      this.isDeleted = _data["isDeleted"];
      this.deleterUserId = _data["deleterUserId"];
      this.deletionTime = _data["deletionTime"] ? new Date(_data["deletionTime"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): RuleContext {
    data = typeof data === 'object' ? data : {};
    let result = new RuleContext();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ruleId"] = this.ruleId;
    data["tagTypeClassificationValueId"] = this.tagTypeClassificationValueId;
    data["contextTagValueText"] = this.contextTagValueText;
    data["rule"] = this.rule ? this.rule.toJSON() : <any>undefined;
    data["tenantId"] = this.tenantId;
    data["rowVersion"] = this.rowVersion;
    data["isDeleted"] = this.isDeleted;
    data["deleterUserId"] = this.deleterUserId;
    data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): RuleContext {
    const json = this.toJSON();
    let result = new RuleContext();
    result.init(json);
    return result;
  }
}

export interface IRuleContext {
  ruleId: string | undefined;
  tagTypeClassificationValueId: string | undefined;
  contextTagValueText: string | undefined;
  rule: Rule | undefined;
  tenantId: number | undefined;
  rowVersion: string | undefined;
  isDeleted: boolean | undefined;
  deleterUserId: number | undefined;
  deletionTime: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  id: string | undefined;
}

export class OrderSearchFilterDto implements IOrderSearchFilterDto {
  programName: string | undefined;
  jobNumber: string | undefined;
  formId: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  customerTypeId: string[] | undefined;
  customerIds: string[] | undefined;
  orderStatusIds: string[] | undefined;
  orderSourceIds: string[] | undefined;
  orderStatusReasonTypeIds: string[] | undefined;
  orderCancellationReasonIds: string[] | undefined;
  orderDateFrom: Date | undefined;
  orderDateTo: Date | undefined;
  companyName: string | undefined;
  hcpFirstName: string | undefined;
  hcpLastName: string | undefined;
  hcpKidNumber: string | undefined;
  countryIds: string[] | undefined;
  stateIds: string[] | undefined;
  repFirstName: string | undefined;
  repLastName: string | undefined;
  repId: string | undefined;
  repTerritoryCode: string | undefined;
  institutionName: string | undefined;
  brandName: string | undefined;
  productName: string | undefined;
  productId: string | undefined;
  rush: boolean | undefined;
  /** For getting the data for pharmacy knipper ID. */
  pharmacyKID: string | undefined;
  /** For getting the data for hospital knipper ID. */
  hospitalKID: string | undefined;
  /** For attaining the type of service offerings from the filter. */
  moduleIds: string[] | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;

  constructor(data?: IOrderSearchFilterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programName = _data["programName"];
      this.jobNumber = _data["jobNumber"];
      this.formId = _data["formId"];
      this.orderNumber = _data["orderNumber"];
      this.externalOrderNumber = _data["externalOrderNumber"];
      if (Array.isArray(_data["customerTypeId"])) {
        this.customerTypeId = [] as any;
        for (let item of _data["customerTypeId"])
          this.customerTypeId.push(item);
      }
      if (Array.isArray(_data["customerIds"])) {
        this.customerIds = [] as any;
        for (let item of _data["customerIds"])
          this.customerIds.push(item);
      }
      if (Array.isArray(_data["orderStatusIds"])) {
        this.orderStatusIds = [] as any;
        for (let item of _data["orderStatusIds"])
          this.orderStatusIds.push(item);
      }
      if (Array.isArray(_data["orderSourceIds"])) {
        this.orderSourceIds = [] as any;
        for (let item of _data["orderSourceIds"])
          this.orderSourceIds.push(item);
      }
      if (Array.isArray(_data["orderStatusReasonTypeIds"])) {
        this.orderStatusReasonTypeIds = [] as any;
        for (let item of _data["orderStatusReasonTypeIds"])
          this.orderStatusReasonTypeIds.push(item);
      }
      if (Array.isArray(_data["orderCancellationReasonIds"])) {
        this.orderCancellationReasonIds = [] as any;
        for (let item of _data["orderCancellationReasonIds"])
          this.orderCancellationReasonIds.push(item);
      }
      this.orderDateFrom = _data["orderDateFrom"] ? new Date(_data["orderDateFrom"].toString()) : <any>undefined;
      this.orderDateTo = _data["orderDateTo"] ? new Date(_data["orderDateTo"].toString()) : <any>undefined;
      this.companyName = _data["companyName"];
      this.hcpFirstName = _data["hcpFirstName"];
      this.hcpLastName = _data["hcpLastName"];
      this.hcpKidNumber = _data["hcpKidNumber"];
      if (Array.isArray(_data["countryIds"])) {
        this.countryIds = [] as any;
        for (let item of _data["countryIds"])
          this.countryIds.push(item);
      }
      if (Array.isArray(_data["stateIds"])) {
        this.stateIds = [] as any;
        for (let item of _data["stateIds"])
          this.stateIds.push(item);
      }
      this.repFirstName = _data["repFirstName"];
      this.repLastName = _data["repLastName"];
      this.repId = _data["repId"];
      this.repTerritoryCode = _data["repTerritoryCode"];
      this.institutionName = _data["institutionName"];
      this.brandName = _data["brandName"];
      this.productName = _data["productName"];
      this.productId = _data["productId"];
      this.rush = _data["rush"];
      this.pharmacyKID = _data["pharmacyKID"];
      this.hospitalKID = _data["hospitalKID"];
      if (Array.isArray(_data["moduleIds"])) {
        this.moduleIds = [] as any;
        for (let item of _data["moduleIds"])
          this.moduleIds.push(item);
      }
      this.pageSize = _data["pageSize"];
      this.pageNumber = _data["pageNumber"];
      this.sortBy = _data["sortBy"];
      this.filterString = _data["filterString"];
    }
  }

  static fromJS(data: any): OrderSearchFilterDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderSearchFilterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programName"] = this.programName;
    data["jobNumber"] = this.jobNumber;
    data["formId"] = this.formId;
    data["orderNumber"] = this.orderNumber;
    data["externalOrderNumber"] = this.externalOrderNumber;
    if (Array.isArray(this.customerTypeId)) {
      data["customerTypeId"] = [];
      for (let item of this.customerTypeId)
        data["customerTypeId"].push(item);
    }
    if (Array.isArray(this.customerIds)) {
      data["customerIds"] = [];
      for (let item of this.customerIds)
        data["customerIds"].push(item);
    }
    if (Array.isArray(this.orderStatusIds)) {
      data["orderStatusIds"] = [];
      for (let item of this.orderStatusIds)
        data["orderStatusIds"].push(item);
    }
    if (Array.isArray(this.orderSourceIds)) {
      data["orderSourceIds"] = [];
      for (let item of this.orderSourceIds)
        data["orderSourceIds"].push(item);
    }

    if (Array.isArray(this.orderStatusReasonTypeIds)) {
      data["orderStatusReasonTypeIds"] = [];
      for (let item of this.orderStatusReasonTypeIds)
        data["orderStatusReasonTypeIds"].push(item);
    }
    if (Array.isArray(this.orderCancellationReasonIds)) {
      data["orderCancellationReasonIds"] = [];
      for (let item of this.orderCancellationReasonIds)
        data["orderCancellationReasonIds"].push(item);
    }
    data["orderDateFrom"] = this.orderDateFrom ? this.orderDateFrom.toISOString() : <any>undefined;
    data["orderDateTo"] = this.orderDateTo ? this.orderDateTo.toISOString() : <any>undefined;
    data["companyName"] = this.companyName;
    data["hcpFirstName"] = this.hcpFirstName;
    data["hcpLastName"] = this.hcpLastName;
    data["hcpKidNumber"] = this.hcpKidNumber;
    if (Array.isArray(this.countryIds)) {
      data["countryIds"] = [];
      for (let item of this.countryIds)
        data["countryIds"].push(item);
    }
    if (Array.isArray(this.stateIds)) {
      data["stateIds"] = [];
      for (let item of this.stateIds)
        data["stateIds"].push(item);
    }
    data["repFirstName"] = this.repFirstName;
    data["repLastName"] = this.repLastName;
    data["repId"] = this.repId;
    data["repTerritoryCode"] = this.repTerritoryCode;
    data["institutionName"] = this.institutionName;
    data["brandName"] = this.brandName;
    data["productName"] = this.productName;
    data["productId"] = this.productId;
    data["rush"] = this.rush;
    data["pharmacyKID"] = this.pharmacyKID;
    data["hospitalKID"] = this.hospitalKID;
    if (Array.isArray(this.moduleIds)) {
      data["moduleIds"] = [];
      for (let item of this.moduleIds)
        data["moduleIds"].push(item);
    }
    data["pageSize"] = this.pageSize;
    data["pageNumber"] = this.pageNumber;
    data["sortBy"] = this.sortBy;
    data["filterString"] = this.filterString;
    return data;
  }

  clone(): OrderSearchFilterDto {
    const json = this.toJSON();
    let result = new OrderSearchFilterDto();
    result.init(json);
    return result;
  }
}

export interface IOrderSearchFilterDto {
  programName: string | undefined;
  jobNumber: string | undefined;
  formId: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  customerTypeId: string[] | undefined;
  customerIds: string[] | undefined;
  orderStatusIds: string[] | undefined;
  orderSourceIds: string[] | undefined;
  orderStatusReasonTypeIds: string[] | undefined;
  orderCancellationReasonIds: string[] | undefined;
  orderDateFrom: Date | undefined;
  orderDateTo: Date | undefined;
  companyName: string | undefined;
  hcpFirstName: string | undefined;
  hcpLastName: string | undefined;
  hcpKidNumber: string | undefined;
  countryIds: string[] | undefined;
  stateIds: string[] | undefined;
  repFirstName: string | undefined;
  repLastName: string | undefined;
  repId: string | undefined;
  repTerritoryCode: string | undefined;
  institutionName: string | undefined;
  brandName: string | undefined;
  productName: string | undefined;
  productId: string | undefined;
  rush: boolean | undefined;
  /** For getting the data for pharmacy knipper ID. */
  pharmacyKID: string | undefined;
  /** For getting the data for hospital knipper ID. */
  hospitalKID: string | undefined;
  /** For attaining the type of service offerings from the filter. */
  moduleIds: string[] | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;
}

export class AjaxResponseOfPagedResultOfOrderSearchDto implements IAjaxResponseOfPagedResultOfOrderSearchDto {
  result: PagedResultOfOrderSearchDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfPagedResultOfOrderSearchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? PagedResultOfOrderSearchDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfPagedResultOfOrderSearchDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfPagedResultOfOrderSearchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfPagedResultOfOrderSearchDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfPagedResultOfOrderSearchDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfPagedResultOfOrderSearchDto {
  result: PagedResultOfOrderSearchDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class PagedResultOfOrderSearchDto implements IPagedResultOfOrderSearchDto {
  totalCount: number | undefined;
  items: OrderSearchDto[] | undefined;

  constructor(data?: IPagedResultOfOrderSearchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(OrderSearchDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultOfOrderSearchDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultOfOrderSearchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultOfOrderSearchDto {
    const json = this.toJSON();
    let result = new PagedResultOfOrderSearchDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultOfOrderSearchDto {
  totalCount: number | undefined;
  items: OrderSearchDto[] | undefined;
}

export class OrderSearchDto implements IOrderSearchDto {
  id: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  orderDate: Date | undefined;
  hcpNameAndKid: string | undefined;
  program: string | undefined;
  orderStatusId: string | undefined;
  orderStatusReasonTypeId: string[] | undefined;
  rush: boolean | undefined;
  stateId: string | undefined;
  salesRep: string | undefined;
  salesRepTerritories: string[] | undefined;
  readonly salesRepTerritoryCode: string | undefined;
  institutionName: string | undefined;
  locked: boolean | undefined;
  lockedByUserId: number | undefined;
  hcpKid: string | undefined;
  programJobId: string | undefined;
  salesRepId: string | undefined;
  isSelectableForCancel: boolean | undefined;
  newFlag: boolean | undefined;
  /** For getting the data for pharmacy knipper ID. */
  pharmacyKID: string | undefined;
  /** For getting the data for hospital knipper ID. */
  hospitalKID: string | undefined;
  customerName: string | undefined;
  daxId: string | undefined;
  kid: string | undefined;
  customerType: string | undefined;
  customerTypeId: string | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;

  constructor(data?: IOrderSearchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.orderNumber = _data["orderNumber"];
      this.externalOrderNumber = _data["externalOrderNumber"];
      this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
      this.hcpNameAndKid = _data["hcpNameAndKid"];
      this.program = _data["program"];
      this.orderStatusId = _data["orderStatusId"];
      if (Array.isArray(_data["orderStatusReasonTypeId"])) {
        this.orderStatusReasonTypeId = [] as any;
        for (let item of _data["orderStatusReasonTypeId"])
          this.orderStatusReasonTypeId.push(item);
      }
      this.rush = _data["rush"];
      this.stateId = _data["stateId"];
      this.salesRep = _data["salesRep"];
      if (Array.isArray(_data["salesRepTerritories"])) {
        this.salesRepTerritories = [] as any;
        for (let item of _data["salesRepTerritories"])
          this.salesRepTerritories.push(item);
      }
      (<any>this).salesRepTerritoryCode = _data["salesRepTerritoryCode"];
      this.institutionName = _data["institutionName"];
      this.locked = _data["locked"];
      this.lockedByUserId = _data["lockedByUserId"];
      this.hcpKid = _data["hcpKid"];
      this.programJobId = _data["programJobId"];
      this.salesRepId = _data["salesRepId"];
      this.isSelectableForCancel = _data["isSelectableForCancel"];
      this.newFlag = _data["newFlag"];
      this.pharmacyKID = _data["pharmacyKID"];
      this.hospitalKID = _data["hospitalKID"];
      this.customerName = _data["customerName"];
      this.daxId = _data["daxId"];
      this.kid = _data["kid"];
      this.customerType = _data["customerType"];
      this.customerTypeId = _data["customerTypeId"];
      this.pageSize = _data["pageSize"];
      this.pageNumber = _data["pageNumber"];
      this.sortBy = _data["sortBy"];
      this.filterString = _data["filterString"];
    }
  }

  static fromJS(data: any): OrderSearchDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderSearchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["orderNumber"] = this.orderNumber;
    data["externalOrderNumber"] = this.externalOrderNumber;
    data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
    data["hcpNameAndKid"] = this.hcpNameAndKid;
    data["program"] = this.program;
    data["orderStatusId"] = this.orderStatusId;
    if (Array.isArray(this.orderStatusReasonTypeId)) {
      data["orderStatusReasonTypeId"] = [];
      for (let item of this.orderStatusReasonTypeId)
        data["orderStatusReasonTypeId"].push(item);
    }
    data["rush"] = this.rush;
    data["stateId"] = this.stateId;
    data["salesRep"] = this.salesRep;
    if (Array.isArray(this.salesRepTerritories)) {
      data["salesRepTerritories"] = [];
      for (let item of this.salesRepTerritories)
        data["salesRepTerritories"].push(item);
    }
    data["salesRepTerritoryCode"] = this.salesRepTerritoryCode;
    data["institutionName"] = this.institutionName;
    data["locked"] = this.locked;
    data["lockedByUserId"] = this.lockedByUserId;
    data["hcpKid"] = this.hcpKid;
    data["programJobId"] = this.programJobId;
    data["salesRepId"] = this.salesRepId;
    data["isSelectableForCancel"] = this.isSelectableForCancel;
    data["newFlag"] = this.newFlag;
    data["pharmacyKID"] = this.pharmacyKID;
    data["hospitalKID"] = this.hospitalKID;
    data["customerName"] = this.customerName;
    data["daxId"] = this.daxId;
    data["kid"] = this.kid;
    data["customerType"] = this.customerType;
    data["customerTypeId"] = this.customerTypeId;
    data["pageSize"] = this.pageSize;
    data["pageNumber"] = this.pageNumber;
    data["sortBy"] = this.sortBy;
    data["filterString"] = this.filterString;
    return data;
  }

  clone(): OrderSearchDto {
    const json = this.toJSON();
    let result = new OrderSearchDto();
    result.init(json);
    return result;
  }
}

export interface IOrderSearchDto {
  id: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  orderDate: Date | undefined;
  hcpNameAndKid: string | undefined;
  program: string | undefined;
  orderStatusId: string | undefined;
  orderStatusReasonTypeId: string[] | undefined;
  rush: boolean | undefined;
  stateId: string | undefined;
  salesRep: string | undefined;
  salesRepTerritories: string[] | undefined;
  salesRepTerritoryCode: string | undefined;
  institutionName: string | undefined;
  locked: boolean | undefined;
  lockedByUserId: number | undefined;
  hcpKid: string | undefined;
  programJobId: string | undefined;
  salesRepId: string | undefined;
  isSelectableForCancel: boolean | undefined;
  newFlag: boolean | undefined;
  /** For getting the data for pharmacy knipper ID. */
  pharmacyKID: string | undefined;
  /** For getting the data for hospital knipper ID. */
  hospitalKID: string | undefined;
  customerName: string | undefined;
  daxId: string | undefined;
  kid: string | undefined;
  customerType: string | undefined;
  customerTypeId: string | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;
}

export class MitigationOrderSearchFilterDto implements IMitigationOrderSearchFilterDto {
  programId: string | undefined;
  formId: string | undefined;
  orderNumber: string | undefined;
  statusReasonTypeClassificationValueIds: string[] | undefined;
  orderReceivedFrom: Date | undefined;
  orderReceivedTo: Date | undefined;
  requestorLastName: string | undefined;
  requestorFirstName: string | undefined;
  requestorKID: string | undefined;
  rushOrderFlag: boolean | undefined;
  unlockedForEditingFlag: boolean | undefined;
  customerIds: string[] | undefined;
  companyName: string | undefined;
  customerTypeId: string[] | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;

  constructor(data?: IMitigationOrderSearchFilterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.formId = _data["formId"];
      this.orderNumber = _data["orderNumber"];
      if (Array.isArray(_data["statusReasonTypeClassificationValueIds"])) {
        this.statusReasonTypeClassificationValueIds = [] as any;
        for (let item of _data["statusReasonTypeClassificationValueIds"])
          this.statusReasonTypeClassificationValueIds.push(item);
      }
      this.orderReceivedFrom = _data["orderReceivedFrom"] ? new Date(_data["orderReceivedFrom"].toString()) : <any>undefined;
      this.orderReceivedTo = _data["orderReceivedTo"] ? new Date(_data["orderReceivedTo"].toString()) : <any>undefined;
      this.requestorLastName = _data["requestorLastName"];
      this.requestorFirstName = _data["requestorFirstName"];
      this.requestorKID = _data["requestorKID"];
      this.rushOrderFlag = _data["rushOrderFlag"];
      this.unlockedForEditingFlag = _data["unlockedForEditingFlag"];
      if (Array.isArray(_data["customerIds"])) {
        this.customerIds = [] as any;
        for (let item of _data["customerIds"])
          this.customerIds.push(item);
      }
      this.companyName = _data["companyName"];
      if (Array.isArray(_data["customerTypeId"])) {
        this.customerTypeId = [] as any;
        for (let item of _data["customerTypeId"])
          this.customerTypeId.push(item);
      }
      this.pageSize = _data["pageSize"];
      this.pageNumber = _data["pageNumber"];
      this.sortBy = _data["sortBy"];
      this.filterString = _data["filterString"];
    }
  }

  static fromJS(data: any): MitigationOrderSearchFilterDto {
    data = typeof data === 'object' ? data : {};
    let result = new MitigationOrderSearchFilterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programId"] = this.programId;
    data["formId"] = this.formId;
    data["orderNumber"] = this.orderNumber;
    if (Array.isArray(this.statusReasonTypeClassificationValueIds)) {
      data["statusReasonTypeClassificationValueIds"] = [];
      for (let item of this.statusReasonTypeClassificationValueIds)
        data["statusReasonTypeClassificationValueIds"].push(item);
    }
    data["orderReceivedFrom"] = this.orderReceivedFrom ? this.orderReceivedFrom.toISOString() : <any>undefined;
    data["orderReceivedTo"] = this.orderReceivedTo ? this.orderReceivedTo.toISOString() : <any>undefined;
    data["requestorLastName"] = this.requestorLastName;
    data["requestorFirstName"] = this.requestorFirstName;
    data["requestorKID"] = this.requestorKID;
    data["rushOrderFlag"] = this.rushOrderFlag;
    data["unlockedForEditingFlag"] = this.unlockedForEditingFlag;
    if (Array.isArray(this.customerIds)) {
      data["customerIds"] = [];
      for (let item of this.customerIds)
        data["customerIds"].push(item);
    }
    data["companyName"] = this.companyName;
    if (Array.isArray(this.customerTypeId)) {
      data["customerTypeId"] = [];
      for (let item of this.customerTypeId)
        data["customerTypeId"].push(item);
    }
    data["pageSize"] = this.pageSize;
    data["pageNumber"] = this.pageNumber;
    data["sortBy"] = this.sortBy;
    data["filterString"] = this.filterString;
    return data;
  }

  clone(): MitigationOrderSearchFilterDto {
    const json = this.toJSON();
    let result = new MitigationOrderSearchFilterDto();
    result.init(json);
    return result;
  }
}

export interface IMitigationOrderSearchFilterDto {
  programId: string | undefined;
  formId: string | undefined;
  orderNumber: string | undefined;
  statusReasonTypeClassificationValueIds: string[] | undefined;
  orderReceivedFrom: Date | undefined;
  orderReceivedTo: Date | undefined;
  requestorLastName: string | undefined;
  requestorFirstName: string | undefined;
  requestorKID: string | undefined;
  rushOrderFlag: boolean | undefined;
  unlockedForEditingFlag: boolean | undefined;
  customerIds: string[] | undefined;
  companyName: string | undefined;
  customerTypeId: string[] | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;
}

export class AjaxResponseOfPagedResultOfMitigationOrderDto implements IAjaxResponseOfPagedResultOfMitigationOrderDto {
  result: PagedResultOfMitigationOrderDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfPagedResultOfMitigationOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? PagedResultOfMitigationOrderDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfPagedResultOfMitigationOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfPagedResultOfMitigationOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfPagedResultOfMitigationOrderDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfPagedResultOfMitigationOrderDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfPagedResultOfMitigationOrderDto {
  result: PagedResultOfMitigationOrderDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class PagedResultOfMitigationOrderDto implements IPagedResultOfMitigationOrderDto {
  totalCount: number | undefined;
  items: MitigationOrderDto[] | undefined;

  constructor(data?: IPagedResultOfMitigationOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(MitigationOrderDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultOfMitigationOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultOfMitigationOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultOfMitigationOrderDto {
    const json = this.toJSON();
    let result = new PagedResultOfMitigationOrderDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultOfMitigationOrderDto {
  totalCount: number | undefined;
  items: MitigationOrderDto[] | undefined;
}

export class MitigationOrderDto implements IMitigationOrderDto {
  id: string | undefined;
  receivedDate: Date | undefined;
  orderNumber: string | undefined;
  requestorName: string | undefined;
  requestorKID: string | undefined;
  statusReasonTypeClassificationValueIds: string[] | undefined;
  rushOrderFlag: boolean | undefined;
  lockedForEditingFlag: boolean | undefined;
  customerDaxId: string | undefined;
  customerName: string | undefined;
  customerType: string | undefined;
  customerTypeId: string | undefined;

  constructor(data?: IMitigationOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
      this.orderNumber = _data["orderNumber"];
      this.requestorName = _data["requestorName"];
      this.requestorKID = _data["requestorKID"];
      if (Array.isArray(_data["statusReasonTypeClassificationValueIds"])) {
        this.statusReasonTypeClassificationValueIds = [] as any;
        for (let item of _data["statusReasonTypeClassificationValueIds"])
          this.statusReasonTypeClassificationValueIds.push(item);
      }
      this.rushOrderFlag = _data["rushOrderFlag"];
      this.lockedForEditingFlag = _data["lockedForEditingFlag"];
      this.customerDaxId = _data["customerDaxId"];
      this.customerName = _data["customerName"];
      this.customerType = _data["customerType"];
      this.customerTypeId = _data["customerTypeId"];
    }

  }

  static fromJS(data: any): MitigationOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new MitigationOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
    data["orderNumber"] = this.orderNumber;
    data["requestorName"] = this.requestorName;
    data["requestorKID"] = this.requestorKID;
    if (Array.isArray(this.statusReasonTypeClassificationValueIds)) {
      data["statusReasonTypeClassificationValueIds"] = [];
      for (let item of this.statusReasonTypeClassificationValueIds)
        data["statusReasonTypeClassificationValueIds"].push(item);
    }
    data["rushOrderFlag"] = this.rushOrderFlag;
    data["lockedForEditingFlag"] = this.lockedForEditingFlag;
    data["customerDaxId"] = this.customerDaxId;
    data["customerName"] = this.customerName;
    data["customerType"] = this.customerType;
    data["customerTypeId"] = this.customerTypeId;
    return data;
  }

  clone(): MitigationOrderDto {
    const json = this.toJSON();
    let result = new MitigationOrderDto();
    result.init(json);
    return result;
  }
}

export interface IMitigationOrderDto {
  id: string | undefined;
  receivedDate: Date | undefined;
  orderNumber: string | undefined;
  requestorName: string | undefined;
  requestorKID: string | undefined;
  statusReasonTypeClassificationValueIds: string[] | undefined;
  rushOrderFlag: boolean | undefined;
  lockedForEditingFlag: boolean | undefined;
  customerDaxId: string | undefined;
  customerName: string | undefined;
  customerType: string | undefined;
  customerTypeId: string | undefined;
}

export class MitigationOnHoldOrderFilterDto implements IMitigationOnHoldOrderFilterDto {
  externalOrderNumber: string | undefined;
  desiredDeliveryDateFrom: Date | undefined;
  desiredDeliveryDateTo: Date | undefined;
  customerTypeId: string[] | undefined;
  programId: string | undefined;
  formId: string | undefined;
  orderNumber: string | undefined;
  statusReasonTypeClassificationValueIds: string[] | undefined;
  orderReceivedFrom: Date | undefined;
  orderReceivedTo: Date | undefined;
  requestorLastName: string | undefined;
  requestorFirstName: string | undefined;
  requestorKID: string | undefined;
  rushOrderFlag: boolean | undefined;
  unlockedForEditingFlag: boolean | undefined;
  customerIds: string[] | undefined;
  companyName: string | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;

  constructor(data?: IMitigationOnHoldOrderFilterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.externalOrderNumber = _data["externalOrderNumber"];
      this.desiredDeliveryDateFrom = _data["desiredDeliveryDateFrom"] ? new Date(_data["desiredDeliveryDateFrom"].toString()) : <any>undefined;
      this.desiredDeliveryDateTo = _data["desiredDeliveryDateTo"] ? new Date(_data["desiredDeliveryDateTo"].toString()) : <any>undefined;
      if (Array.isArray(_data["customerTypeId"])) {
        this.customerTypeId = [] as any;
        for (let item of _data["customerTypeId"])
          this.customerTypeId.push(item);
      }
      this.programId = _data["programId"];
      this.formId = _data["formId"];
      this.orderNumber = _data["orderNumber"];
      if (Array.isArray(_data["statusReasonTypeClassificationValueIds"])) {
        this.statusReasonTypeClassificationValueIds = [] as any;
        for (let item of _data["statusReasonTypeClassificationValueIds"])
          this.statusReasonTypeClassificationValueIds.push(item);
      }
      this.orderReceivedFrom = _data["orderReceivedFrom"] ? new Date(_data["orderReceivedFrom"].toString()) : <any>undefined;
      this.orderReceivedTo = _data["orderReceivedTo"] ? new Date(_data["orderReceivedTo"].toString()) : <any>undefined;
      this.requestorLastName = _data["requestorLastName"];
      this.requestorFirstName = _data["requestorFirstName"];
      this.requestorKID = _data["requestorKID"];
      this.rushOrderFlag = _data["rushOrderFlag"];
      this.unlockedForEditingFlag = _data["unlockedForEditingFlag"];
      if (Array.isArray(_data["customerIds"])) {
        this.customerIds = [] as any;
        for (let item of _data["customerIds"])
          this.customerIds.push(item);
      }
      this.companyName = _data["companyName"];
      this.pageSize = _data["pageSize"];
      this.pageNumber = _data["pageNumber"];
      this.sortBy = _data["sortBy"];
      this.filterString = _data["filterString"];
    }
  }

  static fromJS(data: any): MitigationOnHoldOrderFilterDto {
    data = typeof data === 'object' ? data : {};
    let result = new MitigationOnHoldOrderFilterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["externalOrderNumber"] = this.externalOrderNumber;
    data["desiredDeliveryDateFrom"] = this.desiredDeliveryDateFrom ? this.desiredDeliveryDateFrom.toISOString() : <any>undefined;
    data["desiredDeliveryDateTo"] = this.desiredDeliveryDateTo ? this.desiredDeliveryDateTo.toISOString() : <any>undefined;
    if (Array.isArray(this.customerTypeId)) {
      data["customerTypeId"] = [];
      for (let item of this.customerTypeId)
        data["customerTypeId"].push(item);
    }
    data["programId"] = this.programId;
    data["formId"] = this.formId;
    data["orderNumber"] = this.orderNumber;
    if (Array.isArray(this.statusReasonTypeClassificationValueIds)) {
      data["statusReasonTypeClassificationValueIds"] = [];
      for (let item of this.statusReasonTypeClassificationValueIds)
        data["statusReasonTypeClassificationValueIds"].push(item);
    }
    data["orderReceivedFrom"] = this.orderReceivedFrom ? this.orderReceivedFrom.toISOString() : <any>undefined;
    data["orderReceivedTo"] = this.orderReceivedTo ? this.orderReceivedTo.toISOString() : <any>undefined;
    data["requestorLastName"] = this.requestorLastName;
    data["requestorFirstName"] = this.requestorFirstName;
    data["requestorKID"] = this.requestorKID;
    data["rushOrderFlag"] = this.rushOrderFlag;
    data["unlockedForEditingFlag"] = this.unlockedForEditingFlag;
    if (Array.isArray(this.customerIds)) {
      data["customerIds"] = [];
      for (let item of this.customerIds)
        data["customerIds"].push(item);
    }
    data["companyName"] = this.companyName;
    data["pageSize"] = this.pageSize;
    data["pageNumber"] = this.pageNumber;
    data["sortBy"] = this.sortBy;
    data["filterString"] = this.filterString;
    return data;
  }

  clone(): MitigationOnHoldOrderFilterDto {
    const json = this.toJSON();
    let result = new MitigationOnHoldOrderFilterDto();
    result.init(json);
    return result;
  }
}

export interface IMitigationOnHoldOrderFilterDto {
  externalOrderNumber: string | undefined;
  desiredDeliveryDateFrom: Date | undefined;
  desiredDeliveryDateTo: Date | undefined;
  customerTypeId: string[] | undefined;
  programId: string | undefined;
  formId: string | undefined;
  orderNumber: string | undefined;
  statusReasonTypeClassificationValueIds: string[] | undefined;
  orderReceivedFrom: Date | undefined;
  orderReceivedTo: Date | undefined;
  requestorLastName: string | undefined;
  requestorFirstName: string | undefined;
  requestorKID: string | undefined;
  rushOrderFlag: boolean | undefined;
  unlockedForEditingFlag: boolean | undefined;
  customerIds: string[] | undefined;
  companyName: string | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;
}

export class AjaxResponseOfPagedResultOfMitigationOnHoldOrderDto implements IAjaxResponseOfPagedResultOfMitigationOnHoldOrderDto {
  result: PagedResultOfMitigationOnHoldOrderDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfPagedResultOfMitigationOnHoldOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? PagedResultOfMitigationOnHoldOrderDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfPagedResultOfMitigationOnHoldOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfPagedResultOfMitigationOnHoldOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfPagedResultOfMitigationOnHoldOrderDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfPagedResultOfMitigationOnHoldOrderDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfPagedResultOfMitigationOnHoldOrderDto {
  result: PagedResultOfMitigationOnHoldOrderDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class PagedResultOfMitigationOnHoldOrderDto implements IPagedResultOfMitigationOnHoldOrderDto {
  totalCount: number | undefined;
  items: MitigationOnHoldOrderDto[] | undefined;

  constructor(data?: IPagedResultOfMitigationOnHoldOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(MitigationOnHoldOrderDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultOfMitigationOnHoldOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultOfMitigationOnHoldOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultOfMitigationOnHoldOrderDto {
    const json = this.toJSON();
    let result = new PagedResultOfMitigationOnHoldOrderDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultOfMitigationOnHoldOrderDto {
  totalCount: number | undefined;
  items: MitigationOnHoldOrderDto[] | undefined;
}

export class MitigationOnHoldOrderDto implements IMitigationOnHoldOrderDto {
  desiredDeliveryDate: Date | undefined;
  externalOrderNumber: string | undefined;
  associatedOrders: number | undefined;
  isSelectable: boolean | undefined;
  customerTypeId: string | undefined;
  customerType: string | undefined;
  id: string | undefined;
  receivedDate: Date | undefined;
  orderNumber: string | undefined;
  requestorName: string | undefined;
  requestorKID: string | undefined;
  statusReasonTypeClassificationValueIds: string[] | undefined;
  rushOrderFlag: boolean | undefined;
  lockedForEditingFlag: boolean | undefined;
  customerDaxId: string | undefined;
  customerName: string | undefined;

  constructor(data?: IMitigationOnHoldOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.desiredDeliveryDate = _data["desiredDeliveryDate"] ? new Date(_data["desiredDeliveryDate"].toString()) : <any>undefined;
      this.externalOrderNumber = _data["externalOrderNumber"];
      this.associatedOrders = _data["associatedOrders"];
      this.isSelectable = _data["isSelectable"];
      this.customerTypeId = _data["customerTypeId"];
      this.customerType = _data["customerType"];
      this.id = _data["id"];
      this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
      this.orderNumber = _data["orderNumber"];
      this.requestorName = _data["requestorName"];
      this.requestorKID = _data["requestorKID"];
      if (Array.isArray(_data["statusReasonTypeClassificationValueIds"])) {
        this.statusReasonTypeClassificationValueIds = [] as any;
        for (let item of _data["statusReasonTypeClassificationValueIds"])
          this.statusReasonTypeClassificationValueIds.push(item);
      }
      this.rushOrderFlag = _data["rushOrderFlag"];
      this.lockedForEditingFlag = _data["lockedForEditingFlag"];
      this.customerDaxId = _data["customerDaxId"];
      this.customerName = _data["customerName"];
    }
  }

  static fromJS(data: any): MitigationOnHoldOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new MitigationOnHoldOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["desiredDeliveryDate"] = this.desiredDeliveryDate ? this.desiredDeliveryDate.toISOString() : <any>undefined;
    data["externalOrderNumber"] = this.externalOrderNumber;
    data["associatedOrders"] = this.associatedOrders;
    data["isSelectable"] = this.isSelectable;
    data["customerTypeId"] = this.customerTypeId;
    data["customerType"] = this.customerType;
    data["id"] = this.id;
    data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
    data["orderNumber"] = this.orderNumber;
    data["requestorName"] = this.requestorName;
    data["requestorKID"] = this.requestorKID;
    if (Array.isArray(this.statusReasonTypeClassificationValueIds)) {
      data["statusReasonTypeClassificationValueIds"] = [];
      for (let item of this.statusReasonTypeClassificationValueIds)
        data["statusReasonTypeClassificationValueIds"].push(item);
    }
    data["rushOrderFlag"] = this.rushOrderFlag;
    data["lockedForEditingFlag"] = this.lockedForEditingFlag;
    data["customerDaxId"] = this.customerDaxId;
    data["customerName"] = this.customerName;
    return data;
  }

  clone(): MitigationOnHoldOrderDto {
    const json = this.toJSON();
    let result = new MitigationOnHoldOrderDto();
    result.init(json);
    return result;
  }
}

export interface IMitigationOnHoldOrderDto {
  desiredDeliveryDate: Date | undefined;
  externalOrderNumber: string | undefined;
  associatedOrders: number | undefined;
  isSelectable: boolean | undefined;
  customerTypeId: string | undefined;
  customerType: string | undefined;
  id: string | undefined;
  receivedDate: Date | undefined;
  orderNumber: string | undefined;
  requestorName: string | undefined;
  requestorKID: string | undefined;
  statusReasonTypeClassificationValueIds: string[] | undefined;
  rushOrderFlag: boolean | undefined;
  lockedForEditingFlag: boolean | undefined;
  customerDaxId: string | undefined;
  customerName: string | undefined;
}

export class DataEntryOrdersSearchFilterDto implements IDataEntryOrdersSearchFilterDto {
  programName: string | undefined;
  jobNumber: string | undefined;
  formId: string | undefined;
  orderNumber: string | undefined;
  orderDateFrom: Date | undefined;
  orderDateTo: Date | undefined;
  hcpFirstName: string | undefined;
  hcpLastName: string | undefined;
  hcpKidNumber: string | undefined;
  rushFlag: boolean | undefined;
  unlockedForEditingFlag: boolean | undefined;
  deletedOrderFlag: boolean | undefined;
  orderStatusIds: string[] | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;

  constructor(data?: IDataEntryOrdersSearchFilterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programName = _data["programName"];
      this.jobNumber = _data["jobNumber"];
      this.formId = _data["formId"];
      this.orderNumber = _data["orderNumber"];
      this.orderDateFrom = _data["orderDateFrom"] ? new Date(_data["orderDateFrom"].toString()) : <any>undefined;
      this.orderDateTo = _data["orderDateTo"] ? new Date(_data["orderDateTo"].toString()) : <any>undefined;
      this.hcpFirstName = _data["hcpFirstName"];
      this.hcpLastName = _data["hcpLastName"];
      this.hcpKidNumber = _data["hcpKidNumber"];
      this.rushFlag = _data["rushFlag"];
      this.unlockedForEditingFlag = _data["unlockedForEditingFlag"];
      this.deletedOrderFlag = _data["deletedOrderFlag"];
      if (Array.isArray(_data["orderStatusIds"])) {
        this.orderStatusIds = [] as any;
        for (let item of _data["orderStatusIds"])
          this.orderStatusIds.push(item);
      }
      this.pageSize = _data["pageSize"];
      this.pageNumber = _data["pageNumber"];
      this.sortBy = _data["sortBy"];
      this.filterString = _data["filterString"];
    }
  }

  static fromJS(data: any): DataEntryOrdersSearchFilterDto {
    data = typeof data === 'object' ? data : {};
    let result = new DataEntryOrdersSearchFilterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programName"] = this.programName;
    data["jobNumber"] = this.jobNumber;
    data["formId"] = this.formId;
    data["orderNumber"] = this.orderNumber;
    data["orderDateFrom"] = this.orderDateFrom ? this.orderDateFrom.toISOString() : <any>undefined;
    data["orderDateTo"] = this.orderDateTo ? this.orderDateTo.toISOString() : <any>undefined;
    data["hcpFirstName"] = this.hcpFirstName;
    data["hcpLastName"] = this.hcpLastName;
    data["hcpKidNumber"] = this.hcpKidNumber;
    data["rushFlag"] = this.rushFlag;
    data["unlockedForEditingFlag"] = this.unlockedForEditingFlag;
    data["deletedOrderFlag"] = this.deletedOrderFlag;
    if (Array.isArray(this.orderStatusIds)) {
      data["orderStatusIds"] = [];
      for (let item of this.orderStatusIds)
        data["orderStatusIds"].push(item);
    }
    data["pageSize"] = this.pageSize;
    data["pageNumber"] = this.pageNumber;
    data["sortBy"] = this.sortBy;
    data["filterString"] = this.filterString;
    return data;
  }

  clone(): DataEntryOrdersSearchFilterDto {
    const json = this.toJSON();
    let result = new DataEntryOrdersSearchFilterDto();
    result.init(json);
    return result;
  }
}

export interface IDataEntryOrdersSearchFilterDto {
  programName: string | undefined;
  jobNumber: string | undefined;
  formId: string | undefined;
  orderNumber: string | undefined;
  orderDateFrom: Date | undefined;
  orderDateTo: Date | undefined;
  hcpFirstName: string | undefined;
  hcpLastName: string | undefined;
  hcpKidNumber: string | undefined;
  rushFlag: boolean | undefined;
  unlockedForEditingFlag: boolean | undefined;
  deletedOrderFlag: boolean | undefined;
  orderStatusIds: string[] | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;
}

export class AjaxResponseOfPagedResultOfDataEntryOrderSearchDto implements IAjaxResponseOfPagedResultOfDataEntryOrderSearchDto {
  result: PagedResultOfDataEntryOrderSearchDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfPagedResultOfDataEntryOrderSearchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? PagedResultOfDataEntryOrderSearchDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfPagedResultOfDataEntryOrderSearchDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfPagedResultOfDataEntryOrderSearchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfPagedResultOfDataEntryOrderSearchDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfPagedResultOfDataEntryOrderSearchDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfPagedResultOfDataEntryOrderSearchDto {
  result: PagedResultOfDataEntryOrderSearchDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class PagedResultOfDataEntryOrderSearchDto implements IPagedResultOfDataEntryOrderSearchDto {
  totalCount: number | undefined;
  items: DataEntryOrderSearchDto[] | undefined;

  constructor(data?: IPagedResultOfDataEntryOrderSearchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(DataEntryOrderSearchDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultOfDataEntryOrderSearchDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultOfDataEntryOrderSearchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalCount"] = this.totalCount;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultOfDataEntryOrderSearchDto {
    const json = this.toJSON();
    let result = new PagedResultOfDataEntryOrderSearchDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultOfDataEntryOrderSearchDto {
  totalCount: number | undefined;
  items: DataEntryOrderSearchDto[] | undefined;
}

export class DataEntryOrderSearchDto implements IDataEntryOrderSearchDto {
  id: string | undefined;
  orderNumber: string | undefined;
  formId: string | undefined;
  program: string | undefined;
  programJobId: string | undefined;
  orderReceivedDate: Date | undefined;
  hcpName: string | undefined;
  hcpKid: string | undefined;
  modifiedBy: number | undefined;
  rush: boolean | undefined;
  locked: boolean | undefined;
  orderStatus: string | undefined;
  orderDeleteComment: string | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;

  constructor(data?: IDataEntryOrderSearchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.orderNumber = _data["orderNumber"];
      this.formId = _data["formId"];
      this.program = _data["program"];
      this.programJobId = _data["programJobId"];
      this.orderReceivedDate = _data["orderReceivedDate"] ? new Date(_data["orderReceivedDate"].toString()) : <any>undefined;
      this.hcpName = _data["hcpName"];
      this.hcpKid = _data["hcpKid"];
      this.modifiedBy = _data["modifiedBy"];
      this.rush = _data["rush"];
      this.locked = _data["locked"];
      this.orderStatus = _data["orderStatus"];
      this.orderDeleteComment = _data["orderDeleteComment"];
      this.pageSize = _data["pageSize"];
      this.pageNumber = _data["pageNumber"];
      this.sortBy = _data["sortBy"];
      this.filterString = _data["filterString"];
    }
  }

  static fromJS(data: any): DataEntryOrderSearchDto {
    data = typeof data === 'object' ? data : {};
    let result = new DataEntryOrderSearchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["orderNumber"] = this.orderNumber;
    data["formId"] = this.formId;
    data["program"] = this.program;
    data["programJobId"] = this.programJobId;
    data["orderReceivedDate"] = this.orderReceivedDate ? this.orderReceivedDate.toISOString() : <any>undefined;
    data["hcpName"] = this.hcpName;
    data["hcpKid"] = this.hcpKid;
    data["modifiedBy"] = this.modifiedBy;
    data["rush"] = this.rush;
    data["locked"] = this.locked;
    data["orderStatus"] = this.orderStatus;
    data["orderDeleteComment"] = this.orderDeleteComment;
    data["pageSize"] = this.pageSize;
    data["pageNumber"] = this.pageNumber;
    data["sortBy"] = this.sortBy;
    data["filterString"] = this.filterString;
    return data;
  }

  clone(): DataEntryOrderSearchDto {
    const json = this.toJSON();
    let result = new DataEntryOrderSearchDto();
    result.init(json);
    return result;
  }
}

export interface IDataEntryOrderSearchDto {
  id: string | undefined;
  orderNumber: string | undefined;
  formId: string | undefined;
  program: string | undefined;
  programJobId: string | undefined;
  orderReceivedDate: Date | undefined;
  hcpName: string | undefined;
  hcpKid: string | undefined;
  modifiedBy: number | undefined;
  rush: boolean | undefined;
  locked: boolean | undefined;
  orderStatus: string | undefined;
  orderDeleteComment: string | undefined;
  pageSize: number | undefined;
  pageNumber: number | undefined;
  sortBy: string | undefined;
  filterString: string | undefined;
}

export class AjaxResponseOfPageValidationOfInvestigationDto implements IAjaxResponseOfPageValidationOfInvestigationDto {
  result: PageValidationOfInvestigationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfPageValidationOfInvestigationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? PageValidationOfInvestigationDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfPageValidationOfInvestigationDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfPageValidationOfInvestigationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfPageValidationOfInvestigationDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfPageValidationOfInvestigationDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfPageValidationOfInvestigationDto {
  result: PageValidationOfInvestigationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class PageValidationOfInvestigationDto implements IPageValidationOfInvestigationDto {
  dataDto: InvestigationDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;

  constructor(data?: IPageValidationOfInvestigationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dataDto = _data["dataDto"] ? InvestigationDto.fromJS(_data["dataDto"]) : <any>undefined;
      if (Array.isArray(_data["sectionValidations"])) {
        this.sectionValidations = [] as any;
        for (let item of _data["sectionValidations"])
          this.sectionValidations.push(SectionValidation.fromJS(item));
      }
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): PageValidationOfInvestigationDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageValidationOfInvestigationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dataDto"] = this.dataDto ? this.dataDto.toJSON() : <any>undefined;
    if (Array.isArray(this.sectionValidations)) {
      data["sectionValidations"] = [];
      for (let item of this.sectionValidations)
        data["sectionValidations"].push(item.toJSON());
    }
    data["state"] = this.state;
    return data;
  }

  clone(): PageValidationOfInvestigationDto {
    const json = this.toJSON();
    let result = new PageValidationOfInvestigationDto();
    result.init(json);
    return result;
  }
}

export interface IPageValidationOfInvestigationDto {
  dataDto: InvestigationDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;
}

/** DTO for Order Mitigation Screen */
export class InvestigationDto implements IInvestigationDto {
  orderId: string | undefined;
  orderStatusID: string | undefined;
  orderValidationId: string | undefined;
  summary: InvestigationSummaryDto | undefined;
  orderLevelValidationResults: InvestigationValidationResultDto[] | undefined;
  productLevelValidationResults: InvestigationValidationResultDto[] | undefined;
  unauthorizedFormChanges: OrderUnauthorizedFormChangeValidationDto | undefined;
  orderAttachment: OrderAttachmentDto | undefined;
  mitigationTierTypeId: string | undefined;
  mitigationComment: string | undefined;
  mitigatedBy: number | undefined;
  mitigationSubmissionDateTime: Date | undefined;
  moduleId: string | undefined;
  salesOrderTypeClassificationValueId: string | undefined;
  orderStatusReasonTypeId: string[] | undefined;
  externalNotes: string | undefined;
  autoMitigatePriceCheckEnabled: boolean | undefined;
  mitigateRemsDetailsCheckEnabled: boolean | undefined;

  constructor(data?: IInvestigationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderStatusID = _data["orderStatusID"];
      this.orderValidationId = _data["orderValidationId"];
      this.summary = _data["summary"] ? InvestigationSummaryDto.fromJS(_data["summary"]) : <any>undefined;
      if (Array.isArray(_data["orderLevelValidationResults"])) {
        this.orderLevelValidationResults = [] as any;
        for (let item of _data["orderLevelValidationResults"])
          this.orderLevelValidationResults.push(InvestigationValidationResultDto.fromJS(item));
      }
      if (Array.isArray(_data["productLevelValidationResults"])) {
        this.productLevelValidationResults = [] as any;
        for (let item of _data["productLevelValidationResults"])
          this.productLevelValidationResults.push(InvestigationValidationResultDto.fromJS(item));
      }
      this.unauthorizedFormChanges = _data["unauthorizedFormChanges"] ? OrderUnauthorizedFormChangeValidationDto.fromJS(_data["unauthorizedFormChanges"]) : <any>undefined;
      this.orderAttachment = _data["orderAttachment"] ? OrderAttachmentDto.fromJS(_data["orderAttachment"]) : <any>undefined;
      this.mitigationTierTypeId = _data["mitigationTierTypeId"];
      this.mitigationComment = _data["mitigationComment"];
      this.mitigatedBy = _data["mitigatedBy"];
      this.mitigationSubmissionDateTime = _data["mitigationSubmissionDateTime"] ? new Date(_data["mitigationSubmissionDateTime"].toString()) : <any>undefined;
      this.moduleId = _data["moduleId"];
      this.salesOrderTypeClassificationValueId = _data["salesOrderTypeClassificationValueId"];
      if (Array.isArray(_data["orderStatusReasonTypeId"])) {
        this.orderStatusReasonTypeId = [] as any;
        for (let item of _data["orderStatusReasonTypeId"])
          this.orderStatusReasonTypeId.push(item);
      }
      this.externalNotes = _data["externalNotes"];
      this.autoMitigatePriceCheckEnabled = _data["autoMitigatePriceCheckEnabled"];
      this.mitigateRemsDetailsCheckEnabled = _data["mitigateRemsDetailsCheckEnabled"];
    }
  }

  static fromJS(data: any): InvestigationDto {
    data = typeof data === 'object' ? data : {};
    let result = new InvestigationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderStatusID"] = this.orderStatusID;
    data["orderValidationId"] = this.orderValidationId;
    data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
    if (Array.isArray(this.orderLevelValidationResults)) {
      data["orderLevelValidationResults"] = [];
      for (let item of this.orderLevelValidationResults)
        data["orderLevelValidationResults"].push(item.toJSON());
    }
    if (Array.isArray(this.productLevelValidationResults)) {
      data["productLevelValidationResults"] = [];
      for (let item of this.productLevelValidationResults)
        data["productLevelValidationResults"].push(item.toJSON());
    }
    data["unauthorizedFormChanges"] = this.unauthorizedFormChanges ? this.unauthorizedFormChanges.toJSON() : <any>undefined;
    data["orderAttachment"] = this.orderAttachment ? this.orderAttachment.toJSON() : <any>undefined;
    data["mitigationTierTypeId"] = this.mitigationTierTypeId;
    data["mitigationComment"] = this.mitigationComment;
    data["mitigatedBy"] = this.mitigatedBy;
    data["mitigationSubmissionDateTime"] = this.mitigationSubmissionDateTime ? this.mitigationSubmissionDateTime.toISOString() : <any>undefined;
    data["moduleId"] = this.moduleId;
    data["salesOrderTypeClassificationValueId"] = this.salesOrderTypeClassificationValueId;
    if (Array.isArray(this.orderStatusReasonTypeId)) {
      data["orderStatusReasonTypeId"] = [];
      for (let item of this.orderStatusReasonTypeId)
        data["orderStatusReasonTypeId"].push(item);
    }
    data["externalNotes"] = this.externalNotes;
    data["autoMitigatePriceCheckEnabled"] = this.autoMitigatePriceCheckEnabled;
    data["mitigateRemsDetailsCheckEnabled"] = this.mitigateRemsDetailsCheckEnabled;
    return data;
  }

  clone(): InvestigationDto {
    const json = this.toJSON();
    let result = new InvestigationDto();
    result.init(json);
    return result;
  }
}

/** DTO for Order Mitigation Screen */
export interface IInvestigationDto {
  orderId: string | undefined;
  orderStatusID: string | undefined;
  orderValidationId: string | undefined;
  summary: InvestigationSummaryDto | undefined;
  orderLevelValidationResults: InvestigationValidationResultDto[] | undefined;
  productLevelValidationResults: InvestigationValidationResultDto[] | undefined;
  unauthorizedFormChanges: OrderUnauthorizedFormChangeValidationDto | undefined;
  orderAttachment: OrderAttachmentDto | undefined;
  mitigationTierTypeId: string | undefined;
  mitigationComment: string | undefined;
  mitigatedBy: number | undefined;
  mitigationSubmissionDateTime: Date | undefined;
  moduleId: string | undefined;
  salesOrderTypeClassificationValueId: string | undefined;
  orderStatusReasonTypeId: string[] | undefined;
  externalNotes: string | undefined;
  autoMitigatePriceCheckEnabled: boolean | undefined;
  mitigateRemsDetailsCheckEnabled: boolean | undefined;
}

export class SectionValidation implements ISectionValidation {
  parent: SectionValidation | undefined;
  state: string | undefined;
  name: string | undefined;
  selectedFlag: boolean | undefined;
  crossPageError: boolean | undefined;
  omitValidation: boolean | undefined;
  ruleValidation: boolean | undefined;

  constructor(data?: ISectionValidation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.parent = _data["parent"] ? SectionValidation.fromJS(_data["parent"]) : <any>undefined;
      this.state = _data["state"];
      this.name = _data["name"];
      this.selectedFlag = _data["selectedFlag"];
      this.crossPageError = _data["crossPageError"];
      this.omitValidation = _data["omitValidation"];
      this.ruleValidation = _data["ruleValidation"];
    }
  }

  static fromJS(data: any): SectionValidation {
    data = typeof data === 'object' ? data : {};
    let result = new SectionValidation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
    data["state"] = this.state;
    data["name"] = this.name;
    data["selectedFlag"] = this.selectedFlag;
    data["crossPageError"] = this.crossPageError;
    data["omitValidation"] = this.omitValidation;
    data["ruleValidation"] = this.ruleValidation;
    return data;
  }

  clone(): SectionValidation {
    const json = this.toJSON();
    let result = new SectionValidation();
    result.init(json);
    return result;
  }
}

export interface ISectionValidation {
  parent: SectionValidation | undefined;
  state: string | undefined;
  name: string | undefined;
  selectedFlag: boolean | undefined;
  crossPageError: boolean | undefined;
  omitValidation: boolean | undefined;
  ruleValidation: boolean | undefined;
}

export class InvestigationSummaryDto implements IInvestigationSummaryDto {
  failedRuleCount: number | undefined;
  relatedRulesForReviewCount: number | undefined;

  constructor(data?: IInvestigationSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.failedRuleCount = _data["failedRuleCount"];
      this.relatedRulesForReviewCount = _data["relatedRulesForReviewCount"];
    }
  }

  static fromJS(data: any): InvestigationSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new InvestigationSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["failedRuleCount"] = this.failedRuleCount;
    data["relatedRulesForReviewCount"] = this.relatedRulesForReviewCount;
    return data;
  }

  clone(): InvestigationSummaryDto {
    const json = this.toJSON();
    let result = new InvestigationSummaryDto();
    result.init(json);
    return result;
  }
}

export interface IInvestigationSummaryDto {
  failedRuleCount: number | undefined;
  relatedRulesForReviewCount: number | undefined;
}

export class InvestigationValidationResultDto implements IInvestigationValidationResultDto {
  ruleCode: string | undefined;
  ruleName: string | undefined;
  wmsProductId: string | undefined;
  orderId: string | undefined;
  orderLineId: string | undefined;
  orderValidationRuleOutcomeId: string | undefined;
  ruleFailureTypeId: string | undefined;
  submittedValue: InvestigationSubmittedValueDto | undefined;
  validationReference: InvestigationValidationReferenceDto | undefined;
  investigationAction: InvestigationActionDto | undefined;
  investigationResolutionId: string | undefined;

  constructor(data?: IInvestigationValidationResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleCode = _data["ruleCode"];
      this.ruleName = _data["ruleName"];
      this.wmsProductId = _data["wmsProductId"];
      this.orderId = _data["orderId"];
      this.orderLineId = _data["orderLineId"];
      this.orderValidationRuleOutcomeId = _data["orderValidationRuleOutcomeId"];
      this.ruleFailureTypeId = _data["ruleFailureTypeId"];
      this.submittedValue = _data["submittedValue"] ? InvestigationSubmittedValueDto.fromJS(_data["submittedValue"]) : <any>undefined;
      this.validationReference = _data["validationReference"] ? InvestigationValidationReferenceDto.fromJS(_data["validationReference"]) : <any>undefined;
      this.investigationAction = _data["investigationAction"] ? InvestigationActionDto.fromJS(_data["investigationAction"]) : <any>undefined;
      this.investigationResolutionId = _data["investigationResolutionId"];
    }
  }

  static fromJS(data: any): InvestigationValidationResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new InvestigationValidationResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ruleCode"] = this.ruleCode;
    data["ruleName"] = this.ruleName;
    data["wmsProductId"] = this.wmsProductId;
    data["orderId"] = this.orderId;
    data["orderLineId"] = this.orderLineId;
    data["orderValidationRuleOutcomeId"] = this.orderValidationRuleOutcomeId;
    data["ruleFailureTypeId"] = this.ruleFailureTypeId;
    data["submittedValue"] = this.submittedValue ? this.submittedValue.toJSON() : <any>undefined;
    data["validationReference"] = this.validationReference ? this.validationReference.toJSON() : <any>undefined;
    data["investigationAction"] = this.investigationAction ? this.investigationAction.toJSON() : <any>undefined;
    data["investigationResolutionId"] = this.investigationResolutionId;
    return data;
  }

  clone(): InvestigationValidationResultDto {
    const json = this.toJSON();
    let result = new InvestigationValidationResultDto();
    result.init(json);
    return result;
  }
}

export interface IInvestigationValidationResultDto {
  ruleCode: string | undefined;
  ruleName: string | undefined;
  wmsProductId: string | undefined;
  orderId: string | undefined;
  orderLineId: string | undefined;
  orderValidationRuleOutcomeId: string | undefined;
  ruleFailureTypeId: string | undefined;
  submittedValue: InvestigationSubmittedValueDto | undefined;
  validationReference: InvestigationValidationReferenceDto | undefined;
  investigationAction: InvestigationActionDto | undefined;
  investigationResolutionId: string | undefined;
}

export class OrderUnauthorizedFormChangeValidationDto implements IOrderUnauthorizedFormChangeValidationDto {
  formFields: OrderUnauthorizedFormChangeValidationItemDto[] | undefined;
  orderValidationRuleOutcomeId: string | undefined;
  investigationResolutionId: string | undefined;

  constructor(data?: IOrderUnauthorizedFormChangeValidationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["formFields"])) {
        this.formFields = [] as any;
        for (let item of _data["formFields"])
          this.formFields.push(OrderUnauthorizedFormChangeValidationItemDto.fromJS(item));
      }
      this.orderValidationRuleOutcomeId = _data["orderValidationRuleOutcomeId"];
      this.investigationResolutionId = _data["investigationResolutionId"];
    }
  }

  static fromJS(data: any): OrderUnauthorizedFormChangeValidationDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderUnauthorizedFormChangeValidationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.formFields)) {
      data["formFields"] = [];
      for (let item of this.formFields)
        data["formFields"].push(item.toJSON());
    }
    data["orderValidationRuleOutcomeId"] = this.orderValidationRuleOutcomeId;
    data["investigationResolutionId"] = this.investigationResolutionId;
    return data;
  }

  clone(): OrderUnauthorizedFormChangeValidationDto {
    const json = this.toJSON();
    let result = new OrderUnauthorizedFormChangeValidationDto();
    result.init(json);
    return result;
  }
}

export interface IOrderUnauthorizedFormChangeValidationDto {
  formFields: OrderUnauthorizedFormChangeValidationItemDto[] | undefined;
  orderValidationRuleOutcomeId: string | undefined;
  investigationResolutionId: string | undefined;
}

export class OrderAttachmentDto implements IOrderAttachmentDto {
  orderId: string | undefined;
  location: string | undefined;
  comments: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  sequenceNumber: number | undefined;
  newFlag: boolean | undefined;
  fileUpload: FileUpload | undefined;
  creatorUserId: number | undefined;
  creationTime: Date | undefined;
  id: string | undefined;

  constructor(data?: IOrderAttachmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.location = _data["location"];
      this.comments = _data["comments"];
      this.attachmentTypeClassificationValueId = _data["attachmentTypeClassificationValueId"];
      this.sequenceNumber = _data["sequenceNumber"];
      this.newFlag = _data["newFlag"];
      this.fileUpload = _data["fileUpload"] ? FileUpload.fromJS(_data["fileUpload"]) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderAttachmentDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderAttachmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["location"] = this.location;
    data["comments"] = this.comments;
    data["attachmentTypeClassificationValueId"] = this.attachmentTypeClassificationValueId;
    data["sequenceNumber"] = this.sequenceNumber;
    data["newFlag"] = this.newFlag;
    data["fileUpload"] = this.fileUpload ? this.fileUpload.toJSON() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderAttachmentDto {
    const json = this.toJSON();
    let result = new OrderAttachmentDto();
    result.init(json);
    return result;
  }
}

export interface IOrderAttachmentDto {
  orderId: string | undefined;
  location: string | undefined;
  comments: string | undefined;
  attachmentTypeClassificationValueId: string | undefined;
  sequenceNumber: number | undefined;
  newFlag: boolean | undefined;
  fileUpload: FileUpload | undefined;
  creatorUserId: number | undefined;
  creationTime: Date | undefined;
  id: string | undefined;
}

export class InvestigationSubmittedValueDto implements IInvestigationSubmittedValueDto {
  textValue: TextInvestigationValue | undefined;
  booleanValue: BooleanInvestigationValue | undefined;
  dateTimeValue: DateTimeInvestigationValue | undefined;
  lookupValue: LookupInvestigationValue | undefined;
  addressValue: AddressInvestigationValue | undefined;
  readonly mode: InvestigationSubmittedValueDtoMode | undefined;

  constructor(data?: IInvestigationSubmittedValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.textValue = _data["textValue"] ? TextInvestigationValue.fromJS(_data["textValue"]) : <any>undefined;
      this.booleanValue = _data["booleanValue"] ? BooleanInvestigationValue.fromJS(_data["booleanValue"]) : <any>undefined;
      this.dateTimeValue = _data["dateTimeValue"] ? DateTimeInvestigationValue.fromJS(_data["dateTimeValue"]) : <any>undefined;
      this.lookupValue = _data["lookupValue"] ? LookupInvestigationValue.fromJS(_data["lookupValue"]) : <any>undefined;
      this.addressValue = _data["addressValue"] ? AddressInvestigationValue.fromJS(_data["addressValue"]) : <any>undefined;
      (<any>this).mode = _data["mode"];
    }
  }

  static fromJS(data: any): InvestigationSubmittedValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new InvestigationSubmittedValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["textValue"] = this.textValue ? this.textValue.toJSON() : <any>undefined;
    data["booleanValue"] = this.booleanValue ? this.booleanValue.toJSON() : <any>undefined;
    data["dateTimeValue"] = this.dateTimeValue ? this.dateTimeValue.toJSON() : <any>undefined;
    data["lookupValue"] = this.lookupValue ? this.lookupValue.toJSON() : <any>undefined;
    data["addressValue"] = this.addressValue ? this.addressValue.toJSON() : <any>undefined;
    data["mode"] = this.mode;
    return data;
  }

  clone(): InvestigationSubmittedValueDto {
    const json = this.toJSON();
    let result = new InvestigationSubmittedValueDto();
    result.init(json);
    return result;
  }
}

export interface IInvestigationSubmittedValueDto {
  textValue: TextInvestigationValue | undefined;
  booleanValue: BooleanInvestigationValue | undefined;
  dateTimeValue: DateTimeInvestigationValue | undefined;
  lookupValue: LookupInvestigationValue | undefined;
  addressValue: AddressInvestigationValue | undefined;
  mode: InvestigationSubmittedValueDtoMode | undefined;
}

export class InvestigationValidationReferenceDto implements IInvestigationValidationReferenceDto {
  textValue: TextInvestigationValue | undefined;
  lookups: LookupsInvestigationValue | undefined;
  lookup: LookupInvestigationValue | undefined;
  dateTime: DateTimeInvestigationValue | undefined;
  address: AddressInvestigationValue | undefined;
  sourceSystem: string | undefined;
  showViewCurrentValueLink: boolean | undefined;
  readonly mode: InvestigationValidationReferenceDtoMode | undefined;

  constructor(data?: IInvestigationValidationReferenceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.textValue = _data["textValue"] ? TextInvestigationValue.fromJS(_data["textValue"]) : <any>undefined;
      this.lookups = _data["lookups"] ? LookupsInvestigationValue.fromJS(_data["lookups"]) : <any>undefined;
      this.lookup = _data["lookup"] ? LookupInvestigationValue.fromJS(_data["lookup"]) : <any>undefined;
      this.dateTime = _data["dateTime"] ? DateTimeInvestigationValue.fromJS(_data["dateTime"]) : <any>undefined;
      this.address = _data["address"] ? AddressInvestigationValue.fromJS(_data["address"]) : <any>undefined;
      this.sourceSystem = _data["sourceSystem"];
      this.showViewCurrentValueLink = _data["showViewCurrentValueLink"];
      (<any>this).mode = _data["mode"];
    }
  }

  static fromJS(data: any): InvestigationValidationReferenceDto {
    data = typeof data === 'object' ? data : {};
    let result = new InvestigationValidationReferenceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["textValue"] = this.textValue ? this.textValue.toJSON() : <any>undefined;
    data["lookups"] = this.lookups ? this.lookups.toJSON() : <any>undefined;
    data["lookup"] = this.lookup ? this.lookup.toJSON() : <any>undefined;
    data["dateTime"] = this.dateTime ? this.dateTime.toJSON() : <any>undefined;
    data["address"] = this.address ? this.address.toJSON() : <any>undefined;
    data["sourceSystem"] = this.sourceSystem;
    data["showViewCurrentValueLink"] = this.showViewCurrentValueLink;
    data["mode"] = this.mode;
    return data;
  }

  clone(): InvestigationValidationReferenceDto {
    const json = this.toJSON();
    let result = new InvestigationValidationReferenceDto();
    result.init(json);
    return result;
  }
}

export interface IInvestigationValidationReferenceDto {
  textValue: TextInvestigationValue | undefined;
  lookups: LookupsInvestigationValue | undefined;
  lookup: LookupInvestigationValue | undefined;
  dateTime: DateTimeInvestigationValue | undefined;
  address: AddressInvestigationValue | undefined;
  sourceSystem: string | undefined;
  showViewCurrentValueLink: boolean | undefined;
  mode: InvestigationValidationReferenceDtoMode | undefined;
}

export class InvestigationActionDto implements IInvestigationActionDto {
  textValue: TextInvestigationValue | undefined;
  lookupValue: LookupInvestigationValue | undefined;
  dateTimeValue: DateTimeInvestigationValue | undefined;
  booleanValue: BooleanInvestigationValue | undefined;
  addressValue: AddressInvestigationValue | undefined;
  formSignatureFlagsValue: FormSignatureInvestigationValue | undefined;
  readonly mode: InvestigationActionDtoMode | undefined;

  constructor(data?: IInvestigationActionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.textValue = _data["textValue"] ? TextInvestigationValue.fromJS(_data["textValue"]) : <any>undefined;
      this.lookupValue = _data["lookupValue"] ? LookupInvestigationValue.fromJS(_data["lookupValue"]) : <any>undefined;
      this.dateTimeValue = _data["dateTimeValue"] ? DateTimeInvestigationValue.fromJS(_data["dateTimeValue"]) : <any>undefined;
      this.booleanValue = _data["booleanValue"] ? BooleanInvestigationValue.fromJS(_data["booleanValue"]) : <any>undefined;
      this.addressValue = _data["addressValue"] ? AddressInvestigationValue.fromJS(_data["addressValue"]) : <any>undefined;
      this.formSignatureFlagsValue = _data["formSignatureFlagsValue"] ? FormSignatureInvestigationValue.fromJS(_data["formSignatureFlagsValue"]) : <any>undefined;
      (<any>this).mode = _data["mode"];
    }
  }

  static fromJS(data: any): InvestigationActionDto {
    data = typeof data === 'object' ? data : {};
    let result = new InvestigationActionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["textValue"] = this.textValue ? this.textValue.toJSON() : <any>undefined;
    data["lookupValue"] = this.lookupValue ? this.lookupValue.toJSON() : <any>undefined;
    data["dateTimeValue"] = this.dateTimeValue ? this.dateTimeValue.toJSON() : <any>undefined;
    data["booleanValue"] = this.booleanValue ? this.booleanValue.toJSON() : <any>undefined;
    data["addressValue"] = this.addressValue ? this.addressValue.toJSON() : <any>undefined;
    data["formSignatureFlagsValue"] = this.formSignatureFlagsValue ? this.formSignatureFlagsValue.toJSON() : <any>undefined;
    data["mode"] = this.mode;
    return data;
  }

  clone(): InvestigationActionDto {
    const json = this.toJSON();
    let result = new InvestigationActionDto();
    result.init(json);
    return result;
  }
}

export interface IInvestigationActionDto {
  textValue: TextInvestigationValue | undefined;
  lookupValue: LookupInvestigationValue | undefined;
  dateTimeValue: DateTimeInvestigationValue | undefined;
  booleanValue: BooleanInvestigationValue | undefined;
  addressValue: AddressInvestigationValue | undefined;
  formSignatureFlagsValue: FormSignatureInvestigationValue | undefined;
  mode: InvestigationActionDtoMode | undefined;
}

export class OrderUnauthorizedFormChangeValidationItemDto implements IOrderUnauthorizedFormChangeValidationItemDto {
  orderId: string | undefined;
  orderLineId: string | undefined;
  srfFormFieldId: string | undefined;
  productId: string | undefined;
  productName: string | undefined;
  submittedFormModValue: boolean | undefined;
  prohibitedConfigAtValidation: boolean | undefined;
  prohibitedConfigCurrent: boolean | undefined;
  formModFlag: boolean | undefined;

  constructor(data?: IOrderUnauthorizedFormChangeValidationItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderLineId = _data["orderLineId"];
      this.srfFormFieldId = _data["srfFormFieldId"];
      this.productId = _data["productId"];
      this.productName = _data["productName"];
      this.submittedFormModValue = _data["submittedFormModValue"];
      this.prohibitedConfigAtValidation = _data["prohibitedConfigAtValidation"];
      this.prohibitedConfigCurrent = _data["prohibitedConfigCurrent"];
      this.formModFlag = _data["formModFlag"];
    }
  }

  static fromJS(data: any): OrderUnauthorizedFormChangeValidationItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderUnauthorizedFormChangeValidationItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderLineId"] = this.orderLineId;
    data["srfFormFieldId"] = this.srfFormFieldId;
    data["productId"] = this.productId;
    data["productName"] = this.productName;
    data["submittedFormModValue"] = this.submittedFormModValue;
    data["prohibitedConfigAtValidation"] = this.prohibitedConfigAtValidation;
    data["prohibitedConfigCurrent"] = this.prohibitedConfigCurrent;
    data["formModFlag"] = this.formModFlag;
    return data;
  }

  clone(): OrderUnauthorizedFormChangeValidationItemDto {
    const json = this.toJSON();
    let result = new OrderUnauthorizedFormChangeValidationItemDto();
    result.init(json);
    return result;
  }
}

export interface IOrderUnauthorizedFormChangeValidationItemDto {
  orderId: string | undefined;
  orderLineId: string | undefined;
  srfFormFieldId: string | undefined;
  productId: string | undefined;
  productName: string | undefined;
  submittedFormModValue: boolean | undefined;
  prohibitedConfigAtValidation: boolean | undefined;
  prohibitedConfigCurrent: boolean | undefined;
  formModFlag: boolean | undefined;
}

export class FileUpload implements IFileUpload {
  fileName: string | undefined;
  fileDescription: string | undefined;
  fileType: string | undefined;
  base64FileContent: string | undefined;
  location: string | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  newFlag: boolean | undefined;
  duplicateFileName: boolean | undefined;

  constructor(data?: IFileUpload) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileName = _data["fileName"];
      this.fileDescription = _data["fileDescription"];
      this.fileType = _data["fileType"];
      this.base64FileContent = _data["base64FileContent"];
      this.location = _data["location"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.newFlag = _data["newFlag"];
      this.duplicateFileName = _data["duplicateFileName"];
    }
  }

  static fromJS(data: any): FileUpload {
    data = typeof data === 'object' ? data : {};
    let result = new FileUpload();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fileName"] = this.fileName;
    data["fileDescription"] = this.fileDescription;
    data["fileType"] = this.fileType;
    data["base64FileContent"] = this.base64FileContent;
    data["location"] = this.location;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["newFlag"] = this.newFlag;
    data["duplicateFileName"] = this.duplicateFileName;
    return data;
  }

  clone(): FileUpload {
    const json = this.toJSON();
    let result = new FileUpload();
    result.init(json);
    return result;
  }
}

export interface IFileUpload {
  fileName: string | undefined;
  fileDescription: string | undefined;
  fileType: string | undefined;
  base64FileContent: string | undefined;
  location: string | undefined;
  creationTime: Date | undefined;
  creatorUserId: number | undefined;
  newFlag: boolean | undefined;
  duplicateFileName: boolean | undefined;
}

export class TextInvestigationValue implements ITextInvestigationValue {
  readonly value: string | undefined;
  readonly doubleEntryValue: string | undefined;
  readonly mask: TextInvestigationValueMask | undefined;
  readonly isDoubleEntry: boolean | undefined;
  readonly maxLength: number | undefined;
  readonly label: string | undefined;

  constructor(data?: ITextInvestigationValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).value = _data["value"];
      (<any>this).doubleEntryValue = _data["doubleEntryValue"];
      (<any>this).mask = _data["mask"];
      (<any>this).isDoubleEntry = _data["isDoubleEntry"];
      (<any>this).maxLength = _data["maxLength"];
      (<any>this).label = _data["label"];
    }
  }

  static fromJS(data: any): TextInvestigationValue {
    data = typeof data === 'object' ? data : {};
    let result = new TextInvestigationValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value;
    data["doubleEntryValue"] = this.doubleEntryValue;
    data["mask"] = this.mask;
    data["isDoubleEntry"] = this.isDoubleEntry;
    data["maxLength"] = this.maxLength;
    data["label"] = this.label;
    return data;
  }

  clone(): TextInvestigationValue {
    const json = this.toJSON();
    let result = new TextInvestigationValue();
    result.init(json);
    return result;
  }
}

export interface ITextInvestigationValue {
  value: string | undefined;
  doubleEntryValue: string | undefined;
  mask: TextInvestigationValueMask | undefined;
  isDoubleEntry: boolean | undefined;
  maxLength: number | undefined;
  label: string | undefined;
}

export class BooleanInvestigationValue implements IBooleanInvestigationValue {
  readonly value: boolean | undefined;
  readonly label: string | undefined;

  constructor(data?: IBooleanInvestigationValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).value = _data["value"];
      (<any>this).label = _data["label"];
    }
  }

  static fromJS(data: any): BooleanInvestigationValue {
    data = typeof data === 'object' ? data : {};
    let result = new BooleanInvestigationValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value;
    data["label"] = this.label;
    return data;
  }

  clone(): BooleanInvestigationValue {
    const json = this.toJSON();
    let result = new BooleanInvestigationValue();
    result.init(json);
    return result;
  }
}

export interface IBooleanInvestigationValue {
  value: boolean | undefined;
  label: string | undefined;
}

export class DateTimeInvestigationValue implements IDateTimeInvestigationValue {
  readonly value: Date | undefined;
  readonly restrictedDateTime: Date | undefined;
  readonly isRestrictedDateTime: boolean | undefined;
  readonly label: string | undefined;

  constructor(data?: IDateTimeInvestigationValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
      (<any>this).restrictedDateTime = _data["restrictedDateTime"] ? new Date(_data["restrictedDateTime"].toString()) : <any>undefined;
      (<any>this).isRestrictedDateTime = _data["isRestrictedDateTime"];
      (<any>this).label = _data["label"];
    }
  }

  static fromJS(data: any): DateTimeInvestigationValue {
    data = typeof data === 'object' ? data : {};
    let result = new DateTimeInvestigationValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value ? this.value.toISOString() : <any>undefined;
    data["restrictedDateTime"] = this.restrictedDateTime ? this.restrictedDateTime.toISOString() : <any>undefined;
    data["isRestrictedDateTime"] = this.isRestrictedDateTime;
    data["label"] = this.label;
    return data;
  }

  clone(): DateTimeInvestigationValue {
    const json = this.toJSON();
    let result = new DateTimeInvestigationValue();
    result.init(json);
    return result;
  }
}

export interface IDateTimeInvestigationValue {
  value: Date | undefined;
  restrictedDateTime: Date | undefined;
  isRestrictedDateTime: boolean | undefined;
  label: string | undefined;
}

export class LookupInvestigationValue implements ILookupInvestigationValue {
  id: string | undefined;
  code: string | undefined;
  readonly dataType: LookupInvestigationValueDataType | undefined;
  readonly formType: LookupInvestigationValueFormType | undefined;
  readonly label: string | undefined;

  constructor(data?: ILookupInvestigationValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      (<any>this).dataType = _data["dataType"];
      (<any>this).formType = _data["formType"];
      (<any>this).label = _data["label"];
    }
  }

  static fromJS(data: any): LookupInvestigationValue {
    data = typeof data === 'object' ? data : {};
    let result = new LookupInvestigationValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["dataType"] = this.dataType;
    data["formType"] = this.formType;
    data["label"] = this.label;
    return data;
  }

  clone(): LookupInvestigationValue {
    const json = this.toJSON();
    let result = new LookupInvestigationValue();
    result.init(json);
    return result;
  }
}

export interface ILookupInvestigationValue {
  id: string | undefined;
  code: string | undefined;
  dataType: LookupInvestigationValueDataType | undefined;
  formType: LookupInvestigationValueFormType | undefined;
  label: string | undefined;
}

export class AddressInvestigationValue implements IAddressInvestigationValue {
  readonly addressLine1Label: string | undefined;
  readonly addressLine2Label: string | undefined;
  readonly cityLabel: string | undefined;
  readonly stateLabel: string | undefined;
  readonly zipCodeLabel: string | undefined;
  addressLine1: string | undefined;
  addressLine2: string | undefined;
  city: string | undefined;
  state: string | undefined;
  zipCode: string | undefined;
  readonly simpleAddress: SimpleAddress | undefined;
  readonly addressLine1Mismatch: boolean | undefined;
  readonly addressLine2Mismatch: boolean | undefined;
  readonly cityMismatch: boolean | undefined;
  readonly stateMismatch: boolean | undefined;
  readonly zipCodeMismatch: boolean | undefined;

  constructor(data?: IAddressInvestigationValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).addressLine1Label = _data["addressLine1Label"];
      (<any>this).addressLine2Label = _data["addressLine2Label"];
      (<any>this).cityLabel = _data["cityLabel"];
      (<any>this).stateLabel = _data["stateLabel"];
      (<any>this).zipCodeLabel = _data["zipCodeLabel"];
      this.addressLine1 = _data["addressLine1"];
      this.addressLine2 = _data["addressLine2"];
      this.city = _data["city"];
      this.state = _data["state"];
      this.zipCode = _data["zipCode"];
      (<any>this).simpleAddress = _data["simpleAddress"] ? SimpleAddress.fromJS(_data["simpleAddress"]) : <any>undefined;
      (<any>this).addressLine1Mismatch = _data["addressLine1Mismatch"];
      (<any>this).addressLine2Mismatch = _data["addressLine2Mismatch"];
      (<any>this).cityMismatch = _data["cityMismatch"];
      (<any>this).stateMismatch = _data["stateMismatch"];
      (<any>this).zipCodeMismatch = _data["zipCodeMismatch"];
    }
  }

  static fromJS(data: any): AddressInvestigationValue {
    data = typeof data === 'object' ? data : {};
    let result = new AddressInvestigationValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["addressLine1Label"] = this.addressLine1Label;
    data["addressLine2Label"] = this.addressLine2Label;
    data["cityLabel"] = this.cityLabel;
    data["stateLabel"] = this.stateLabel;
    data["zipCodeLabel"] = this.zipCodeLabel;
    data["addressLine1"] = this.addressLine1;
    data["addressLine2"] = this.addressLine2;
    data["city"] = this.city;
    data["state"] = this.state;
    data["zipCode"] = this.zipCode;
    data["simpleAddress"] = this.simpleAddress ? this.simpleAddress.toJSON() : <any>undefined;
    data["addressLine1Mismatch"] = this.addressLine1Mismatch;
    data["addressLine2Mismatch"] = this.addressLine2Mismatch;
    data["cityMismatch"] = this.cityMismatch;
    data["stateMismatch"] = this.stateMismatch;
    data["zipCodeMismatch"] = this.zipCodeMismatch;
    return data;
  }

  clone(): AddressInvestigationValue {
    const json = this.toJSON();
    let result = new AddressInvestigationValue();
    result.init(json);
    return result;
  }
}

export interface IAddressInvestigationValue {
  addressLine1Label: string | undefined;
  addressLine2Label: string | undefined;
  cityLabel: string | undefined;
  stateLabel: string | undefined;
  zipCodeLabel: string | undefined;
  addressLine1: string | undefined;
  addressLine2: string | undefined;
  city: string | undefined;
  state: string | undefined;
  zipCode: string | undefined;
  simpleAddress: SimpleAddress | undefined;
  addressLine1Mismatch: boolean | undefined;
  addressLine2Mismatch: boolean | undefined;
  cityMismatch: boolean | undefined;
  stateMismatch: boolean | undefined;
  zipCodeMismatch: boolean | undefined;
}

export class LookupsInvestigationValue implements ILookupsInvestigationValue {
  readonly ids: string[] | undefined;
  readonly codes: string[] | undefined;
  readonly dataType: LookupsInvestigationValueDataType | undefined;
  readonly formType: LookupsInvestigationValueFormType | undefined;
  readonly label: string | undefined;

  constructor(data?: ILookupsInvestigationValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["ids"])) {
        (<any>this).ids = [] as any;
        for (let item of _data["ids"])
          (<any>this).ids.push(item);
      }
      if (Array.isArray(_data["codes"])) {
        (<any>this).codes = [] as any;
        for (let item of _data["codes"])
          (<any>this).codes.push(item);
      }
      (<any>this).dataType = _data["dataType"];
      (<any>this).formType = _data["formType"];
      (<any>this).label = _data["label"];
    }
  }

  static fromJS(data: any): LookupsInvestigationValue {
    data = typeof data === 'object' ? data : {};
    let result = new LookupsInvestigationValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.ids)) {
      data["ids"] = [];
      for (let item of this.ids)
        data["ids"].push(item);
    }
    if (Array.isArray(this.codes)) {
      data["codes"] = [];
      for (let item of this.codes)
        data["codes"].push(item);
    }
    data["dataType"] = this.dataType;
    data["formType"] = this.formType;
    data["label"] = this.label;
    return data;
  }

  clone(): LookupsInvestigationValue {
    const json = this.toJSON();
    let result = new LookupsInvestigationValue();
    result.init(json);
    return result;
  }
}

export interface ILookupsInvestigationValue {
  ids: string[] | undefined;
  codes: string[] | undefined;
  dataType: LookupsInvestigationValueDataType | undefined;
  formType: LookupsInvestigationValueFormType | undefined;
  label: string | undefined;
}

export class FormSignatureInvestigationValue implements IFormSignatureInvestigationValue {
  readonly isSignaturePresentLabel: string | undefined;
  readonly isSignatureStampedLabel: string | undefined;
  readonly isSignatureMatchLabel: string | undefined;
  isSignaturePresent: boolean | undefined;
  isSignatureStamped: boolean | undefined;
  isSignatureMatch: boolean | undefined;

  constructor(data?: IFormSignatureInvestigationValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).isSignaturePresentLabel = _data["isSignaturePresentLabel"];
      (<any>this).isSignatureStampedLabel = _data["isSignatureStampedLabel"];
      (<any>this).isSignatureMatchLabel = _data["isSignatureMatchLabel"];
      this.isSignaturePresent = _data["isSignaturePresent"];
      this.isSignatureStamped = _data["isSignatureStamped"];
      this.isSignatureMatch = _data["isSignatureMatch"];
    }
  }

  static fromJS(data: any): FormSignatureInvestigationValue {
    data = typeof data === 'object' ? data : {};
    let result = new FormSignatureInvestigationValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isSignaturePresentLabel"] = this.isSignaturePresentLabel;
    data["isSignatureStampedLabel"] = this.isSignatureStampedLabel;
    data["isSignatureMatchLabel"] = this.isSignatureMatchLabel;
    data["isSignaturePresent"] = this.isSignaturePresent;
    data["isSignatureStamped"] = this.isSignatureStamped;
    data["isSignatureMatch"] = this.isSignatureMatch;
    return data;
  }

  clone(): FormSignatureInvestigationValue {
    const json = this.toJSON();
    let result = new FormSignatureInvestigationValue();
    result.init(json);
    return result;
  }
}

export interface IFormSignatureInvestigationValue {
  isSignaturePresentLabel: string | undefined;
  isSignatureStampedLabel: string | undefined;
  isSignatureMatchLabel: string | undefined;
  isSignaturePresent: boolean | undefined;
  isSignatureStamped: boolean | undefined;
  isSignatureMatch: boolean | undefined;
}

export class SimpleAddress implements ISimpleAddress {
  addressLine1: string | undefined;
  addressLine2: string | undefined;
  city: string | undefined;
  state: string | undefined;
  zipCode: string | undefined;

  constructor(data?: ISimpleAddress) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.addressLine1 = _data["addressLine1"];
      this.addressLine2 = _data["addressLine2"];
      this.city = _data["city"];
      this.state = _data["state"];
      this.zipCode = _data["zipCode"];
    }
  }

  static fromJS(data: any): SimpleAddress {
    data = typeof data === 'object' ? data : {};
    let result = new SimpleAddress();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["addressLine1"] = this.addressLine1;
    data["addressLine2"] = this.addressLine2;
    data["city"] = this.city;
    data["state"] = this.state;
    data["zipCode"] = this.zipCode;
    return data;
  }

  clone(): SimpleAddress {
    const json = this.toJSON();
    let result = new SimpleAddress();
    result.init(json);
    return result;
  }
}

export interface ISimpleAddress {
  addressLine1: string | undefined;
  addressLine2: string | undefined;
  city: string | undefined;
  state: string | undefined;
  zipCode: string | undefined;
}

export class AjaxResponseOfString implements IAjaxResponseOfString {
  result: string | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfString) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfString {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfString();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfString {
    const json = this.toJSON();
    let result = new AjaxResponseOfString();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfString {
  result: string | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class AjaxResponseOfInvestigationCurrentValueDto implements IAjaxResponseOfInvestigationCurrentValueDto {
  result: InvestigationCurrentValueDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfInvestigationCurrentValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? InvestigationCurrentValueDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfInvestigationCurrentValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfInvestigationCurrentValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfInvestigationCurrentValueDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfInvestigationCurrentValueDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfInvestigationCurrentValueDto {
  result: InvestigationCurrentValueDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class InvestigationCurrentValueDto implements IInvestigationCurrentValueDto {
  ruleCode: string | undefined;
  ruleName: string | undefined;
  isNoLongerEnabledInLiveConfig: boolean | undefined;
  isNoLongerAppliesToProductInLiveConfig: boolean | undefined;
  textValue: TextInvestigationValue | undefined;
  lookupValue: LookupInvestigationValue | undefined;
  addressValue: AddressInvestigationValue | undefined;
  lookupsValue: LookupsInvestigationValue | undefined;
  dateTimeValue: DateTimeInvestigationValue | undefined;
  readonly mode: InvestigationCurrentValueDtoMode | undefined;

  constructor(data?: IInvestigationCurrentValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleCode = _data["ruleCode"];
      this.ruleName = _data["ruleName"];
      this.isNoLongerEnabledInLiveConfig = _data["isNoLongerEnabledInLiveConfig"];
      this.isNoLongerAppliesToProductInLiveConfig = _data["isNoLongerAppliesToProductInLiveConfig"];
      this.textValue = _data["textValue"] ? TextInvestigationValue.fromJS(_data["textValue"]) : <any>undefined;
      this.lookupValue = _data["lookupValue"] ? LookupInvestigationValue.fromJS(_data["lookupValue"]) : <any>undefined;
      this.addressValue = _data["addressValue"] ? AddressInvestigationValue.fromJS(_data["addressValue"]) : <any>undefined;
      this.lookupsValue = _data["lookupsValue"] ? LookupsInvestigationValue.fromJS(_data["lookupsValue"]) : <any>undefined;
      this.dateTimeValue = _data["dateTimeValue"] ? DateTimeInvestigationValue.fromJS(_data["dateTimeValue"]) : <any>undefined;
      (<any>this).mode = _data["mode"];
    }
  }

  static fromJS(data: any): InvestigationCurrentValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new InvestigationCurrentValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ruleCode"] = this.ruleCode;
    data["ruleName"] = this.ruleName;
    data["isNoLongerEnabledInLiveConfig"] = this.isNoLongerEnabledInLiveConfig;
    data["isNoLongerAppliesToProductInLiveConfig"] = this.isNoLongerAppliesToProductInLiveConfig;
    data["textValue"] = this.textValue ? this.textValue.toJSON() : <any>undefined;
    data["lookupValue"] = this.lookupValue ? this.lookupValue.toJSON() : <any>undefined;
    data["addressValue"] = this.addressValue ? this.addressValue.toJSON() : <any>undefined;
    data["lookupsValue"] = this.lookupsValue ? this.lookupsValue.toJSON() : <any>undefined;
    data["dateTimeValue"] = this.dateTimeValue ? this.dateTimeValue.toJSON() : <any>undefined;
    data["mode"] = this.mode;
    return data;
  }

  clone(): InvestigationCurrentValueDto {
    const json = this.toJSON();
    let result = new InvestigationCurrentValueDto();
    result.init(json);
    return result;
  }
}

export interface IInvestigationCurrentValueDto {
  ruleCode: string | undefined;
  ruleName: string | undefined;
  isNoLongerEnabledInLiveConfig: boolean | undefined;
  isNoLongerAppliesToProductInLiveConfig: boolean | undefined;
  textValue: TextInvestigationValue | undefined;
  lookupValue: LookupInvestigationValue | undefined;
  addressValue: AddressInvestigationValue | undefined;
  lookupsValue: LookupsInvestigationValue | undefined;
  dateTimeValue: DateTimeInvestigationValue | undefined;
  mode: InvestigationCurrentValueDtoMode | undefined;
}

export class AjaxResponseOfPageValidationOfOrderDto implements IAjaxResponseOfPageValidationOfOrderDto {
  result: PageValidationOfOrderDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfPageValidationOfOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? PageValidationOfOrderDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfPageValidationOfOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfPageValidationOfOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfPageValidationOfOrderDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfPageValidationOfOrderDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfPageValidationOfOrderDto {
  result: PageValidationOfOrderDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class PageValidationOfOrderDto implements IPageValidationOfOrderDto {
  dataDto: OrderDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;

  constructor(data?: IPageValidationOfOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dataDto = _data["dataDto"] ? OrderDto.fromJS(_data["dataDto"]) : <any>undefined;
      if (Array.isArray(_data["sectionValidations"])) {
        this.sectionValidations = [] as any;
        for (let item of _data["sectionValidations"])
          this.sectionValidations.push(SectionValidation.fromJS(item));
      }
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): PageValidationOfOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageValidationOfOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dataDto"] = this.dataDto ? this.dataDto.toJSON() : <any>undefined;
    if (Array.isArray(this.sectionValidations)) {
      data["sectionValidations"] = [];
      for (let item of this.sectionValidations)
        data["sectionValidations"].push(item.toJSON());
    }
    data["state"] = this.state;
    return data;
  }

  clone(): PageValidationOfOrderDto {
    const json = this.toJSON();
    let result = new PageValidationOfOrderDto();
    result.init(json);
    return result;
  }
}

export interface IPageValidationOfOrderDto {
  dataDto: OrderDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;
}

export class OrderDto implements IOrderDto {
  id: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  orderDate: Date | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  parentOrderNumber: string | undefined;
  parentOrderId: string | undefined;
  replacementOrderNumber: string | undefined;
  replacementOrderId: string | undefined;
  originalOrderNumber: string | undefined;
  originalOrderId: string | undefined;
  orderStatusId: string | undefined;
  readonly orderStatusTimeDiff: number | undefined;
  orderStatusLastModifiedTime: Date | undefined;
  program: string | undefined;
  jobId: string | undefined;
  sourceCode: string | undefined;
  sourceCodeFlag: boolean | undefined;
  programStatusId: string | undefined;
  customerType: string | undefined;
  /** The program Id */
  programId: string | undefined;
  /** The program module Id */
  programModuleId: string | undefined;
  modifiedBy: number | undefined;
  modifiedTime: Date | undefined;
  orderSourceId: string | undefined;
  relatedOfferId: string | undefined;
  relatedOfferNumber: string | undefined;
  formId: string | undefined;
  batchNumber: string | undefined;
  batchDate: Date | undefined;
  showStatusReasonTypeModalLink: boolean | undefined;
  itemsReturned: boolean | undefined;
  /** Gets or sets the salesforceId for order. */
  salesforceId: string | undefined;
  lockInfo: LockDto | undefined;
  childOrders: SimpleOrderDto[] | undefined;
  orderStatusReasonTypeId: string[] | undefined;
  lifeCycle: StepperLifeCycleStageDto[] | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  desiredDeliveryDate: Date | undefined;
  orderTypeClassificationValueId: string | undefined;
  scheduledShipDate: Date | undefined;
  exportToDynamicsPath: string | undefined;
  asnBlobFilePath: string | undefined;
  documentAttachment: string | undefined;
  invoceId: string | undefined;
  invoiceDate: string | undefined;
  associatedOrderLines: OrderLineDto[] | undefined;
  salesOrderTypeId: string | undefined;
  externalNotes: string | undefined;
  paymentMethodClassificationValueId: string | undefined;
  orderCancellationReasonClassificationValueId: string | undefined;
  autoMitigatePriceCheckEnabled: boolean | undefined;
  externalBillingNbr: string | undefined;
  createdName: string | undefined;
  createdBy: number | undefined;
  names: LocalizedValue[] | undefined;
  customerOrderType: string | undefined;
  isERPIntegrationEnabled: boolean | undefined;

  constructor(data?: IOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.orderNumber = _data["orderNumber"];
      this.externalOrderNumber = _data["externalOrderNumber"];
      this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.missingRequestDate = _data["missingRequestDate"];
      this.parentOrderNumber = _data["parentOrderNumber"];
      this.parentOrderId = _data["parentOrderId"];
      this.replacementOrderNumber = _data["replacementOrderNumber"];
      this.replacementOrderId = _data["replacementOrderId"];
      this.originalOrderNumber = _data["originalOrderNumber"];
      this.originalOrderId = _data["originalOrderId"];
      this.orderStatusId = _data["orderStatusId"];
      (<any>this).orderStatusTimeDiff = _data["orderStatusTimeDiff"];
      this.orderStatusLastModifiedTime = _data["orderStatusLastModifiedTime"] ? new Date(_data["orderStatusLastModifiedTime"].toString()) : <any>undefined;
      this.program = _data["program"];
      this.jobId = _data["jobId"];
      this.sourceCode = _data["sourceCode"];
      this.sourceCodeFlag = _data["sourceCodeFlag"];
      this.programStatusId = _data["programStatusId"];
      this.customerType = _data["customerType"];
      this.programId = _data["programId"];
      this.programModuleId = _data["programModuleId"];
      this.modifiedBy = _data["modifiedBy"];
      this.modifiedTime = _data["modifiedTime"] ? new Date(_data["modifiedTime"].toString()) : <any>undefined;
      this.orderSourceId = _data["orderSourceId"];
      this.relatedOfferId = _data["relatedOfferId"];
      this.relatedOfferNumber = _data["relatedOfferNumber"];
      this.formId = _data["formId"];
      this.batchNumber = _data["batchNumber"];
      this.batchDate = _data["batchDate"] ? new Date(_data["batchDate"].toString()) : <any>undefined;
      this.showStatusReasonTypeModalLink = _data["showStatusReasonTypeModalLink"];
      this.itemsReturned = _data["itemsReturned"];
      this.salesforceId = _data["salesforceId"];
      this.lockInfo = _data["lockInfo"] ? LockDto.fromJS(_data["lockInfo"]) : <any>undefined;
      if (Array.isArray(_data["childOrders"])) {
        this.childOrders = [] as any;
        for (let item of _data["childOrders"])
          this.childOrders.push(SimpleOrderDto.fromJS(item));
      }
      if (Array.isArray(_data["orderStatusReasonTypeId"])) {
        this.orderStatusReasonTypeId = [] as any;
        for (let item of _data["orderStatusReasonTypeId"])
          this.orderStatusReasonTypeId.push(item);
      }
      if (Array.isArray(_data["lifeCycle"])) {
        this.lifeCycle = [] as any;
        for (let item of _data["lifeCycle"])
          this.lifeCycle.push(StepperLifeCycleStageDto.fromJS(item));
      }
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.desiredDeliveryDate = _data["desiredDeliveryDate"] ? new Date(_data["desiredDeliveryDate"].toString()) : <any>undefined;
      this.orderTypeClassificationValueId = _data["orderTypeClassificationValueId"];
      this.scheduledShipDate = _data["scheduledShipDate"] ? new Date(_data["scheduledShipDate"].toString()) : <any>undefined;
      this.exportToDynamicsPath = _data["exportToDynamicsPath"];
      this.asnBlobFilePath = _data["asnBlobFilePath"];
      this.documentAttachment = _data["documentAttachment"];
      this.invoceId = _data["invoceId"];
      this.invoiceDate = _data["invoiceDate"];
      if (Array.isArray(_data["associatedOrderLines"])) {
        this.associatedOrderLines = [] as any;
        for (let item of _data["associatedOrderLines"])
          this.associatedOrderLines.push(OrderLineDto.fromJS(item));
      }
      this.salesOrderTypeId = _data["salesOrderTypeId"];
      this.externalNotes = _data["externalNotes"];
      this.paymentMethodClassificationValueId = _data["paymentMethodClassificationValueId"];
      this.orderCancellationReasonClassificationValueId = _data["orderCancellationReasonClassificationValueId"];
      this.autoMitigatePriceCheckEnabled = _data["autoMitigatePriceCheckEnabled"];
      this.externalBillingNbr = _data["externalBillingNbr"];
      this.createdName = _data["createdName"];
      this.createdBy = _data["createdBy"];
      if (Array.isArray(_data["names"])) {
        this.names = [] as any;
        for (let item of _data["names"])
          this.names.push(LocalizedValue.fromJS(item));
      }
      this.customerOrderType = _data["customerOrderType"];
      this.isERPIntegrationEnabled = _data["isERPIntegrationEnabled"];
    }
  }

  static fromJS(data: any): OrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["orderNumber"] = this.orderNumber;
    data["externalOrderNumber"] = this.externalOrderNumber;
    data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["missingRequestDate"] = this.missingRequestDate;
    data["parentOrderNumber"] = this.parentOrderNumber;
    data["parentOrderId"] = this.parentOrderId;
    data["replacementOrderNumber"] = this.replacementOrderNumber;
    data["replacementOrderId"] = this.replacementOrderId;
    data["originalOrderNumber"] = this.originalOrderNumber;
    data["originalOrderId"] = this.originalOrderId;
    data["orderStatusId"] = this.orderStatusId;
    data["orderStatusTimeDiff"] = this.orderStatusTimeDiff;
    data["orderStatusLastModifiedTime"] = this.orderStatusLastModifiedTime ? this.orderStatusLastModifiedTime.toISOString() : <any>undefined;
    data["program"] = this.program;
    data["jobId"] = this.jobId;
    data["sourceCode"] = this.sourceCode;
    data["sourceCodeFlag"] = this.sourceCodeFlag;
    data["programStatusId"] = this.programStatusId;
    data["customerType"] = this.customerType;
    data["programId"] = this.programId;
    data["programModuleId"] = this.programModuleId;
    data["modifiedBy"] = this.modifiedBy;
    data["modifiedTime"] = this.modifiedTime ? this.modifiedTime.toISOString() : <any>undefined;
    data["orderSourceId"] = this.orderSourceId;
    data["relatedOfferId"] = this.relatedOfferId;
    data["relatedOfferNumber"] = this.relatedOfferNumber;
    data["formId"] = this.formId;
    data["batchNumber"] = this.batchNumber;
    data["batchDate"] = this.batchDate ? this.batchDate.toISOString() : <any>undefined;
    data["showStatusReasonTypeModalLink"] = this.showStatusReasonTypeModalLink;
    data["itemsReturned"] = this.itemsReturned;
    data["salesforceId"] = this.salesforceId;
    data["lockInfo"] = this.lockInfo ? this.lockInfo.toJSON() : <any>undefined;
    if (Array.isArray(this.childOrders)) {
      data["childOrders"] = [];
      for (let item of this.childOrders)
        data["childOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.orderStatusReasonTypeId)) {
      data["orderStatusReasonTypeId"] = [];
      for (let item of this.orderStatusReasonTypeId)
        data["orderStatusReasonTypeId"].push(item);
    }
    if (Array.isArray(this.lifeCycle)) {
      data["lifeCycle"] = [];
      for (let item of this.lifeCycle)
        data["lifeCycle"].push(item.toJSON());
    }
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["desiredDeliveryDate"] = this.desiredDeliveryDate ? this.desiredDeliveryDate.toISOString() : <any>undefined;
    data["orderTypeClassificationValueId"] = this.orderTypeClassificationValueId;
    data["scheduledShipDate"] = this.scheduledShipDate ? this.scheduledShipDate.toISOString() : <any>undefined;
    data["exportToDynamicsPath"] = this.exportToDynamicsPath;
    data["asnBlobFilePath"] = this.asnBlobFilePath;
    data["documentAttachment"] = this.documentAttachment;
    data["invoceId"] = this.invoceId;
    data["invoiceDate"] = this.invoiceDate;
    if (Array.isArray(this.associatedOrderLines)) {
      data["associatedOrderLines"] = [];
      for (let item of this.associatedOrderLines)
        data["associatedOrderLines"].push(item.toJSON());
    }
    data["salesOrderTypeId"] = this.salesOrderTypeId;
    data["externalNotes"] = this.externalNotes;
    data["paymentMethodClassificationValueId"] = this.paymentMethodClassificationValueId;
    data["orderCancellationReasonClassificationValueId"] = this.orderCancellationReasonClassificationValueId;
    data["autoMitigatePriceCheckEnabled"] = this.autoMitigatePriceCheckEnabled;
    data["externalBillingNbr"] = this.externalBillingNbr;
    data["createdName"] = this.createdName;
    data["createdBy"] = this.createdBy;
    if (Array.isArray(this.names)) {
      data["names"] = [];
      for (let item of this.names)
        data["names"].push(item.toJSON());
    }
    data["customerOrderType"] = this.customerOrderType;
    data["isERPIntegrationEnabled"] = this.isERPIntegrationEnabled;
    return data;
  }

  clone(): OrderDto {
    const json = this.toJSON();
    let result = new OrderDto();
    result.init(json);
    return result;
  }
}

export interface IOrderDto {
  id: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  orderDate: Date | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  parentOrderNumber: string | undefined;
  parentOrderId: string | undefined;
  replacementOrderNumber: string | undefined;
  replacementOrderId: string | undefined;
  originalOrderNumber: string | undefined;
  originalOrderId: string | undefined;
  orderStatusId: string | undefined;
  orderStatusTimeDiff: number | undefined;
  orderStatusLastModifiedTime: Date | undefined;
  program: string | undefined;
  jobId: string | undefined;
  sourceCode: string | undefined;
  sourceCodeFlag: boolean | undefined;
  programStatusId: string | undefined;
  customerType: string | undefined;
  /** The program Id */
  programId: string | undefined;
  /** The program module Id */
  programModuleId: string | undefined;
  modifiedBy: number | undefined;
  modifiedTime: Date | undefined;
  orderSourceId: string | undefined;
  relatedOfferId: string | undefined;
  relatedOfferNumber: string | undefined;
  formId: string | undefined;
  batchNumber: string | undefined;
  batchDate: Date | undefined;
  showStatusReasonTypeModalLink: boolean | undefined;
  itemsReturned: boolean | undefined;
  /** Gets or sets the salesforceId for order. */
  salesforceId: string | undefined;
  lockInfo: LockDto | undefined;
  childOrders: SimpleOrderDto[] | undefined;
  orderStatusReasonTypeId: string[] | undefined;
  lifeCycle: StepperLifeCycleStageDto[] | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  desiredDeliveryDate: Date | undefined;
  orderTypeClassificationValueId: string | undefined;
  scheduledShipDate: Date | undefined;
  exportToDynamicsPath: string | undefined;
  asnBlobFilePath: string | undefined;
  documentAttachment: string | undefined;
  invoceId: string | undefined;
  invoiceDate: string | undefined;
  associatedOrderLines: OrderLineDto[] | undefined;
  salesOrderTypeId: string | undefined;
  externalNotes: string | undefined;
  paymentMethodClassificationValueId: string | undefined;
  orderCancellationReasonClassificationValueId: string | undefined;
  autoMitigatePriceCheckEnabled: boolean | undefined;
  externalBillingNbr: string | undefined;
  createdName: string | undefined;
  createdBy: number | undefined;
  names: LocalizedValue[] | undefined;
  customerOrderType: string | undefined;
  isERPIntegrationEnabled: boolean | undefined;
}

export class LockDto implements ILockDto {
  isLocked: boolean | undefined;
  lockedByUserId: number | undefined;
  lockTimestamp: Date | undefined;
  lockExpiryTimestamp: Date | undefined;
  unlockedByUserId: number | undefined;
  unlockTimestamp: Date | undefined;
  unlockReasonId: string | undefined;

  constructor(data?: ILockDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isLocked = _data["isLocked"];
      this.lockedByUserId = _data["lockedByUserId"];
      this.lockTimestamp = _data["lockTimestamp"] ? new Date(_data["lockTimestamp"].toString()) : <any>undefined;
      this.lockExpiryTimestamp = _data["lockExpiryTimestamp"] ? new Date(_data["lockExpiryTimestamp"].toString()) : <any>undefined;
      this.unlockedByUserId = _data["unlockedByUserId"];
      this.unlockTimestamp = _data["unlockTimestamp"] ? new Date(_data["unlockTimestamp"].toString()) : <any>undefined;
      this.unlockReasonId = _data["unlockReasonId"];
    }
  }

  static fromJS(data: any): LockDto {
    data = typeof data === 'object' ? data : {};
    let result = new LockDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isLocked"] = this.isLocked;
    data["lockedByUserId"] = this.lockedByUserId;
    data["lockTimestamp"] = this.lockTimestamp ? this.lockTimestamp.toISOString() : <any>undefined;
    data["lockExpiryTimestamp"] = this.lockExpiryTimestamp ? this.lockExpiryTimestamp.toISOString() : <any>undefined;
    data["unlockedByUserId"] = this.unlockedByUserId;
    data["unlockTimestamp"] = this.unlockTimestamp ? this.unlockTimestamp.toISOString() : <any>undefined;
    data["unlockReasonId"] = this.unlockReasonId;
    return data;
  }

  clone(): LockDto {
    const json = this.toJSON();
    let result = new LockDto();
    result.init(json);
    return result;
  }
}

export interface ILockDto {
  isLocked: boolean | undefined;
  lockedByUserId: number | undefined;
  lockTimestamp: Date | undefined;
  lockExpiryTimestamp: Date | undefined;
  unlockedByUserId: number | undefined;
  unlockTimestamp: Date | undefined;
  unlockReasonId: string | undefined;
}

export class SimpleOrderDto implements ISimpleOrderDto {
  id: string | undefined;
  orderId: string | undefined;
  orderPassedThresholdDate: Date | undefined;
  orderStatusDate: Date | undefined;
  failedRules: string | undefined;

  constructor(data?: ISimpleOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.orderId = _data["orderId"];
      this.orderPassedThresholdDate = _data["orderPassedThresholdDate"] ? new Date(_data["orderPassedThresholdDate"].toString()) : <any>undefined;
      this.orderStatusDate = _data["orderStatusDate"] ? new Date(_data["orderStatusDate"].toString()) : <any>undefined;
      this.failedRules = _data["failedRules"];
    }
  }

  static fromJS(data: any): SimpleOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new SimpleOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["orderId"] = this.orderId;
    data["orderPassedThresholdDate"] = this.orderPassedThresholdDate ? this.orderPassedThresholdDate.toISOString() : <any>undefined;
    data["orderStatusDate"] = this.orderStatusDate ? this.orderStatusDate.toISOString() : <any>undefined;
    data["failedRules"] = this.failedRules;
    return data;
  }

  clone(): SimpleOrderDto {
    const json = this.toJSON();
    let result = new SimpleOrderDto();
    result.init(json);
    return result;
  }
}

export interface ISimpleOrderDto {
  id: string | undefined;
  orderId: string | undefined;
  orderPassedThresholdDate: Date | undefined;
  orderStatusDate: Date | undefined;
  failedRules: string | undefined;
}

export class StepperLifeCycleStageDto implements IStepperLifeCycleStageDto {
  classificationValueId: string | undefined;
  index: number | undefined;
  status: StepperLifeCycleStageDtoStatus | undefined;

  constructor(data?: IStepperLifeCycleStageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.classificationValueId = _data["classificationValueId"];
      this.index = _data["index"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): StepperLifeCycleStageDto {
    data = typeof data === 'object' ? data : {};
    let result = new StepperLifeCycleStageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["classificationValueId"] = this.classificationValueId;
    data["index"] = this.index;
    data["status"] = this.status;
    return data;
  }

  clone(): StepperLifeCycleStageDto {
    const json = this.toJSON();
    let result = new StepperLifeCycleStageDto();
    result.init(json);
    return result;
  }
}

export interface IStepperLifeCycleStageDto {
  classificationValueId: string | undefined;
  index: number | undefined;
  status: StepperLifeCycleStageDtoStatus | undefined;
}

export class OrderLineDto implements IOrderLineDto {
  orderId: string | undefined;
  productId: string | undefined;
  orderLineStatusClassificationValueId: string | undefined;
  distributionUoMClassificationValueId: string | undefined;
  orderLineNbr: number | undefined;
  orderQty: number | undefined;
  offeredQty: number | undefined;
  shippedQty: number | undefined;
  deliveredQty: number | undefined;
  canceledQty: number | undefined;
  backorderedQty: number | undefined;
  returnedQty: number | undefined;
  adjustedOrderQty: number | undefined;
  adjustedDeliveredQty: number | undefined;
  autoIncludedQty: number | undefined;
  autoIncludeLevelId: string | undefined;
  autoIncludeLevelTypeClassificationValueId: string | undefined;
  wmsProductId: string | undefined;
  wmsProductName: string | undefined;
  productGroup: string | undefined;
  isEditable: boolean | undefined;
  isAdjustedDeliveredQtyEditable: boolean | undefined;
  showFormModFields: boolean | undefined;
  formModProductFlag: boolean | undefined;
  formModOrderQtyFlag: boolean | undefined;
  isAutoInclude: boolean | undefined;
  displayQuantity: string | undefined;
  quantityMultiplier: number | undefined;
  isBackOrdered: boolean | undefined;
  customOrderType: string | undefined;
  customOrderValue: string | undefined;
  /** Gets or sets FranchiseCode/TherapeuticClass for a order line. */
  therapeuticClass: string | undefined;
  purchasePrice: number | undefined;
  adjustedPurchasePrice: number | undefined;
  autoIncludeRules: SimpleAutoIncludeRuleDto[] | undefined;
  onHoldQty: number | undefined;
  allocationSubmissionDate: Date | undefined;
  productInventoryQty: number | undefined;
  productAutoIncludeQty: number | undefined;
  productAutoIncludeInventoryQty: number | undefined;
  releasedQty: number | undefined;
  yetToReleaseQty: number | undefined;
  productTypeId: string | undefined;
  quantityRejected: number | undefined;
  somStatusCode: string | undefined;
  isOnHoldQtyAdjusted: boolean | undefined;
  isPartOrderReleased: boolean | undefined;
  isPartOrderCancelled: boolean | undefined;
  minOrderQuantity: number | undefined;
  virtualKitItemInsufficientInventories: InsufficientInventoryValidationDto[] | undefined;
  id: string | undefined;

  constructor(data?: IOrderLineDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.productId = _data["productId"];
      this.orderLineStatusClassificationValueId = _data["orderLineStatusClassificationValueId"];
      this.distributionUoMClassificationValueId = _data["distributionUoMClassificationValueId"];
      this.orderLineNbr = _data["orderLineNbr"];
      this.orderQty = _data["orderQty"];
      this.offeredQty = _data["offeredQty"];
      this.shippedQty = _data["shippedQty"];
      this.deliveredQty = _data["deliveredQty"];
      this.canceledQty = _data["canceledQty"];
      this.backorderedQty = _data["backorderedQty"];
      this.returnedQty = _data["returnedQty"];
      this.adjustedOrderQty = _data["adjustedOrderQty"];
      this.adjustedDeliveredQty = _data["adjustedDeliveredQty"];
      this.autoIncludedQty = _data["autoIncludedQty"];
      this.autoIncludeLevelId = _data["autoIncludeLevelId"];
      this.autoIncludeLevelTypeClassificationValueId = _data["autoIncludeLevelTypeClassificationValueId"];
      this.wmsProductId = _data["wmsProductId"];
      this.wmsProductName = _data["wmsProductName"];
      this.productGroup = _data["productGroup"];
      this.isEditable = _data["isEditable"];
      this.isAdjustedDeliveredQtyEditable = _data["isAdjustedDeliveredQtyEditable"];
      this.showFormModFields = _data["showFormModFields"];
      this.formModProductFlag = _data["formModProductFlag"];
      this.formModOrderQtyFlag = _data["formModOrderQtyFlag"];
      this.isAutoInclude = _data["isAutoInclude"];
      this.displayQuantity = _data["displayQuantity"];
      this.quantityMultiplier = _data["quantityMultiplier"];
      this.isBackOrdered = _data["isBackOrdered"];
      this.customOrderType = _data["customOrderType"];
      this.customOrderValue = _data["customOrderValue"];
      this.therapeuticClass = _data["therapeuticClass"];
      this.purchasePrice = _data["purchasePrice"];
      this.adjustedPurchasePrice = _data["adjustedPurchasePrice"];
      if (Array.isArray(_data["autoIncludeRules"])) {
        this.autoIncludeRules = [] as any;
        for (let item of _data["autoIncludeRules"])
          this.autoIncludeRules.push(SimpleAutoIncludeRuleDto.fromJS(item));
      }
      this.onHoldQty = _data["onHoldQty"];
      this.allocationSubmissionDate = _data["allocationSubmissionDate"] ? new Date(_data["allocationSubmissionDate"].toString()) : <any>undefined;
      this.productInventoryQty = _data["productInventoryQty"];
      this.productAutoIncludeQty = _data["productAutoIncludeQty"];
      this.productAutoIncludeInventoryQty = _data["productAutoIncludeInventoryQty"];
      this.releasedQty = _data["releasedQty"];
      this.yetToReleaseQty = _data["yetToReleaseQty"];
      this.productTypeId = _data["productTypeId"];
      this.quantityRejected = _data["quantityRejected"];
      this.somStatusCode = _data["somStatusCode"];
      this.isOnHoldQtyAdjusted = _data["isOnHoldQtyAdjusted"];
      this.isPartOrderReleased = _data["isPartOrderReleased"];
      this.isPartOrderCancelled = _data["isPartOrderCancelled"];
      this.minOrderQuantity = _data["minOrderQuantity"];
      if (Array.isArray(_data["virtualKitItemInsufficientInventories"])) {
        this.virtualKitItemInsufficientInventories = [] as any;
        for (let item of _data["virtualKitItemInsufficientInventories"])
          this.virtualKitItemInsufficientInventories.push(InsufficientInventoryValidationDto.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderLineDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderLineDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["productId"] = this.productId;
    data["orderLineStatusClassificationValueId"] = this.orderLineStatusClassificationValueId;
    data["distributionUoMClassificationValueId"] = this.distributionUoMClassificationValueId;
    data["orderLineNbr"] = this.orderLineNbr;
    data["orderQty"] = this.orderQty;
    data["offeredQty"] = this.offeredQty;
    data["shippedQty"] = this.shippedQty;
    data["deliveredQty"] = this.deliveredQty;
    data["canceledQty"] = this.canceledQty;
    data["backorderedQty"] = this.backorderedQty;
    data["returnedQty"] = this.returnedQty;
    data["adjustedOrderQty"] = this.adjustedOrderQty;
    data["adjustedDeliveredQty"] = this.adjustedDeliveredQty;
    data["autoIncludedQty"] = this.autoIncludedQty;
    data["autoIncludeLevelId"] = this.autoIncludeLevelId;
    data["autoIncludeLevelTypeClassificationValueId"] = this.autoIncludeLevelTypeClassificationValueId;
    data["wmsProductId"] = this.wmsProductId;
    data["wmsProductName"] = this.wmsProductName;
    data["productGroup"] = this.productGroup;
    data["isEditable"] = this.isEditable;
    data["isAdjustedDeliveredQtyEditable"] = this.isAdjustedDeliveredQtyEditable;
    data["showFormModFields"] = this.showFormModFields;
    data["formModProductFlag"] = this.formModProductFlag;
    data["formModOrderQtyFlag"] = this.formModOrderQtyFlag;
    data["isAutoInclude"] = this.isAutoInclude;
    data["displayQuantity"] = this.displayQuantity;
    data["quantityMultiplier"] = this.quantityMultiplier;
    data["isBackOrdered"] = this.isBackOrdered;
    data["customOrderType"] = this.customOrderType;
    data["customOrderValue"] = this.customOrderValue;
    data["therapeuticClass"] = this.therapeuticClass;
    data["purchasePrice"] = this.purchasePrice;
    data["adjustedPurchasePrice"] = this.adjustedPurchasePrice;
    if (Array.isArray(this.autoIncludeRules)) {
      data["autoIncludeRules"] = [];
      for (let item of this.autoIncludeRules)
        data["autoIncludeRules"].push(item.toJSON());
    }
    data["onHoldQty"] = this.onHoldQty;
    data["allocationSubmissionDate"] = this.allocationSubmissionDate ? this.allocationSubmissionDate.toISOString() : <any>undefined;
    data["productInventoryQty"] = this.productInventoryQty;
    data["productAutoIncludeQty"] = this.productAutoIncludeQty;
    data["productAutoIncludeInventoryQty"] = this.productAutoIncludeInventoryQty;
    data["releasedQty"] = this.releasedQty;
    data["yetToReleaseQty"] = this.yetToReleaseQty;
    data["productTypeId"] = this.productTypeId;
    data["quantityRejected"] = this.quantityRejected;
    data["somStatusCode"] = this.somStatusCode;
    data["isOnHoldQtyAdjusted"] = this.isOnHoldQtyAdjusted;
    data["isPartOrderReleased"] = this.isPartOrderReleased;
    data["isPartOrderCancelled"] = this.isPartOrderCancelled;
    data["minOrderQuantity"] = this.minOrderQuantity;
    if (Array.isArray(this.virtualKitItemInsufficientInventories)) {
      data["virtualKitItemInsufficientInventories"] = [];
      for (let item of this.virtualKitItemInsufficientInventories)
        data["virtualKitItemInsufficientInventories"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }

  clone(): OrderLineDto {
    const json = this.toJSON();
    let result = new OrderLineDto();
    result.init(json);
    return result;
  }
}

export interface IOrderLineDto {
  orderId: string | undefined;
  productId: string | undefined;
  orderLineStatusClassificationValueId: string | undefined;
  distributionUoMClassificationValueId: string | undefined;
  orderLineNbr: number | undefined;
  orderQty: number | undefined;
  offeredQty: number | undefined;
  shippedQty: number | undefined;
  deliveredQty: number | undefined;
  canceledQty: number | undefined;
  backorderedQty: number | undefined;
  returnedQty: number | undefined;
  adjustedOrderQty: number | undefined;
  adjustedDeliveredQty: number | undefined;
  autoIncludedQty: number | undefined;
  autoIncludeLevelId: string | undefined;
  autoIncludeLevelTypeClassificationValueId: string | undefined;
  wmsProductId: string | undefined;
  wmsProductName: string | undefined;
  productGroup: string | undefined;
  isEditable: boolean | undefined;
  isAdjustedDeliveredQtyEditable: boolean | undefined;
  showFormModFields: boolean | undefined;
  formModProductFlag: boolean | undefined;
  formModOrderQtyFlag: boolean | undefined;
  isAutoInclude: boolean | undefined;
  displayQuantity: string | undefined;
  quantityMultiplier: number | undefined;
  isBackOrdered: boolean | undefined;
  customOrderType: string | undefined;
  customOrderValue: string | undefined;
  /** Gets or sets FranchiseCode/TherapeuticClass for a order line. */
  therapeuticClass: string | undefined;
  purchasePrice: number | undefined;
  adjustedPurchasePrice: number | undefined;
  autoIncludeRules: SimpleAutoIncludeRuleDto[] | undefined;
  onHoldQty: number | undefined;
  allocationSubmissionDate: Date | undefined;
  productInventoryQty: number | undefined;
  productAutoIncludeQty: number | undefined;
  productAutoIncludeInventoryQty: number | undefined;
  releasedQty: number | undefined;
  yetToReleaseQty: number | undefined;
  productTypeId: string | undefined;
  quantityRejected: number | undefined;
  somStatusCode: string | undefined;
  isOnHoldQtyAdjusted: boolean | undefined;
  isPartOrderReleased: boolean | undefined;
  isPartOrderCancelled: boolean | undefined;
  minOrderQuantity: number | undefined;
  virtualKitItemInsufficientInventories: InsufficientInventoryValidationDto[] | undefined;
  id: string | undefined;
}

export class LocalizedValue implements ILocalizedValue {
  language: LocalizedValueLanguage | undefined;
  value: string | undefined;

  constructor(data?: ILocalizedValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.language = _data["language"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): LocalizedValue {
    data = typeof data === 'object' ? data : {};
    let result = new LocalizedValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["language"] = this.language;
    data["value"] = this.value;
    return data;
  }

  clone(): LocalizedValue {
    const json = this.toJSON();
    let result = new LocalizedValue();
    result.init(json);
    return result;
  }
}

export interface ILocalizedValue {
  language: LocalizedValueLanguage | undefined;
  value: string | undefined;
}

export class SimpleAutoIncludeRuleDto implements ISimpleAutoIncludeRuleDto {
  programId: string | undefined;
  dtpProgramConfigId: string | undefined;
  productId: string | undefined;
  productName: string | undefined;
  ruleNumber: number | undefined;
  description: string | undefined;
  requiredQty: number | undefined;
  availableInventory: number | undefined;

  constructor(data?: ISimpleAutoIncludeRuleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.dtpProgramConfigId = _data["dtpProgramConfigId"];
      this.productId = _data["productId"];
      this.productName = _data["productName"];
      this.ruleNumber = _data["ruleNumber"];
      this.description = _data["description"];
      this.requiredQty = _data["requiredQty"];
      this.availableInventory = _data["availableInventory"];
    }
  }

  static fromJS(data: any): SimpleAutoIncludeRuleDto {
    data = typeof data === 'object' ? data : {};
    let result = new SimpleAutoIncludeRuleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programId"] = this.programId;
    data["dtpProgramConfigId"] = this.dtpProgramConfigId;
    data["productId"] = this.productId;
    data["productName"] = this.productName;
    data["ruleNumber"] = this.ruleNumber;
    data["description"] = this.description;
    data["requiredQty"] = this.requiredQty;
    data["availableInventory"] = this.availableInventory;
    return data;
  }

  clone(): SimpleAutoIncludeRuleDto {
    const json = this.toJSON();
    let result = new SimpleAutoIncludeRuleDto();
    result.init(json);
    return result;
  }
}

export interface ISimpleAutoIncludeRuleDto {
  programId: string | undefined;
  dtpProgramConfigId: string | undefined;
  productId: string | undefined;
  productName: string | undefined;
  ruleNumber: number | undefined;
  description: string | undefined;
  requiredQty: number | undefined;
  availableInventory: number | undefined;
}

export class InsufficientInventoryValidationDto implements IInsufficientInventoryValidationDto {
  wmsProductId: string | undefined;
  wmsProductName: string | undefined;
  adjustedOrderQty: number | undefined;
  productInventoryQty: number | undefined;
  lotNumber!: string | undefined;
  autoIncludeInventory: AutoIncludeInventoryDto[] | undefined;

  constructor(data?: IInsufficientInventoryValidationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.wmsProductId = _data["wmsProductId"];
      this.wmsProductName = _data["wmsProductName"];
      this.adjustedOrderQty = _data["adjustedOrderQty"];
      this.productInventoryQty = _data["productInventoryQty"];
      this.lotNumber = _data["lotNumber"];
      if (Array.isArray(_data["autoIncludeInventory"])) {
        this.autoIncludeInventory = [] as any;
        for (let item of _data["autoIncludeInventory"])
          this.autoIncludeInventory.push(AutoIncludeInventoryDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): InsufficientInventoryValidationDto {
    data = typeof data === 'object' ? data : {};
    let result = new InsufficientInventoryValidationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["wmsProductId"] = this.wmsProductId;
    data["wmsProductName"] = this.wmsProductName;
    data["adjustedOrderQty"] = this.adjustedOrderQty;
    data["productInventoryQty"] = this.productInventoryQty;
    data["lotNumber"] = this.lotNumber;
    if (Array.isArray(this.autoIncludeInventory)) {
      data["autoIncludeInventory"] = [];
      for (let item of this.autoIncludeInventory)
        data["autoIncludeInventory"].push(item.toJSON());
    }
    return data;
  }

  clone(): InsufficientInventoryValidationDto {
    const json = this.toJSON();
    let result = new InsufficientInventoryValidationDto();
    result.init(json);
    return result;
  }
}

export interface IInsufficientInventoryValidationDto {
  wmsProductId: string | undefined;
  wmsProductName: string | undefined;
  adjustedOrderQty: number | undefined;
  productInventoryQty: number | undefined;
  lotNumber: string | undefined;
  autoIncludeInventory: AutoIncludeInventoryDto[] | undefined;
}

export class AutoIncludeInventoryDto implements IAutoIncludeInventoryDto {
  productId: string | undefined;
  productName: string | undefined;
  ruleNumber: string | undefined;
  ruleDescription: string | undefined;
  requiredQty: number | undefined;
  availableInventory: number | undefined;

  constructor(data?: IAutoIncludeInventoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productId = _data["productId"];
      this.productName = _data["productName"];
      this.ruleNumber = _data["ruleNumber"];
      this.ruleDescription = _data["ruleDescription"];
      this.requiredQty = _data["requiredQty"];
      this.availableInventory = _data["availableInventory"];
    }
  }

  static fromJS(data: any): AutoIncludeInventoryDto {
    data = typeof data === 'object' ? data : {};
    let result = new AutoIncludeInventoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["productId"] = this.productId;
    data["productName"] = this.productName;
    data["ruleNumber"] = this.ruleNumber;
    data["ruleDescription"] = this.ruleDescription;
    data["requiredQty"] = this.requiredQty;
    data["availableInventory"] = this.availableInventory;
    return data;
  }

  clone(): AutoIncludeInventoryDto {
    const json = this.toJSON();
    let result = new AutoIncludeInventoryDto();
    result.init(json);
    return result;
  }
}

export interface IAutoIncludeInventoryDto {
  productId: string | undefined;
  productName: string | undefined;
  ruleNumber: string | undefined;
  ruleDescription: string | undefined;
  requiredQty: number | undefined;
  availableInventory: number | undefined;
}

export class AjaxResponseOfPageValidationOfOrderHcpSalesRepDto implements IAjaxResponseOfPageValidationOfOrderHcpSalesRepDto {
  result: PageValidationOfOrderHcpSalesRepDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfPageValidationOfOrderHcpSalesRepDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? PageValidationOfOrderHcpSalesRepDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfPageValidationOfOrderHcpSalesRepDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfPageValidationOfOrderHcpSalesRepDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfPageValidationOfOrderHcpSalesRepDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfPageValidationOfOrderHcpSalesRepDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfPageValidationOfOrderHcpSalesRepDto {
  result: PageValidationOfOrderHcpSalesRepDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class PageValidationOfOrderHcpSalesRepDto implements IPageValidationOfOrderHcpSalesRepDto {
  dataDto: OrderHcpSalesRepDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;

  constructor(data?: IPageValidationOfOrderHcpSalesRepDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dataDto = _data["dataDto"] ? OrderHcpSalesRepDto.fromJS(_data["dataDto"]) : <any>undefined;
      if (Array.isArray(_data["sectionValidations"])) {
        this.sectionValidations = [] as any;
        for (let item of _data["sectionValidations"])
          this.sectionValidations.push(SectionValidation.fromJS(item));
      }
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): PageValidationOfOrderHcpSalesRepDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageValidationOfOrderHcpSalesRepDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dataDto"] = this.dataDto ? this.dataDto.toJSON() : <any>undefined;
    if (Array.isArray(this.sectionValidations)) {
      data["sectionValidations"] = [];
      for (let item of this.sectionValidations)
        data["sectionValidations"].push(item.toJSON());
    }
    data["state"] = this.state;
    return data;
  }

  clone(): PageValidationOfOrderHcpSalesRepDto {
    const json = this.toJSON();
    let result = new PageValidationOfOrderHcpSalesRepDto();
    result.init(json);
    return result;
  }
}

export interface IPageValidationOfOrderHcpSalesRepDto {
  dataDto: OrderHcpSalesRepDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;
}

export class OrderHcpSalesRepDto implements IOrderHcpSalesRepDto {
  institutionFlag: boolean | undefined;
  repDrivenFlag: boolean | undefined;
  orderStatusId: string | undefined;
  orderSourceId: string | undefined;
  originalSalesRep: OrderSalesRepDetailsDto | undefined;
  currentSalesRep: OrderSalesRepDetailsDto | undefined;
  requestorHcpDetails: OrderHcpDetailsDto | undefined;
  recipientHcpDetails: OrderHcpDetailsDto | undefined;
  shippingAddress: ShippingAddressDto | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  advancedEditFlag: boolean | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  orderTypeClassificationValueId: string | undefined;
  customerName: string | undefined;
  customerAccountNbr: string | undefined;
  customerType: string | undefined;
  /** Program moduleId. */
  programModuleId: string | undefined;
  patientOrder: PatientOrderDto | undefined;
  /** Gets or sets the pharmacist */
  requestorPharmacist: OrderPharmacistDetailsDto | undefined;
  /** Gets or sets the pharmacy */
  recipientPharmacy: OrderPharmacyDetailsDto | undefined;
  /** Gets or sets the hospital */
  affiliatedHospital: OrderHospitalDetailsDto | undefined;
  /** Gets or sets the prescribing Hcps */
  prescribingHcps: OrderPrescribingHcpDetailsDto[] | undefined;
  id: string | undefined;

  constructor(data?: IOrderHcpSalesRepDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.institutionFlag = _data["institutionFlag"];
      this.repDrivenFlag = _data["repDrivenFlag"];
      this.orderStatusId = _data["orderStatusId"];
      this.orderSourceId = _data["orderSourceId"];
      this.originalSalesRep = _data["originalSalesRep"] ? OrderSalesRepDetailsDto.fromJS(_data["originalSalesRep"]) : <any>undefined;
      this.currentSalesRep = _data["currentSalesRep"] ? OrderSalesRepDetailsDto.fromJS(_data["currentSalesRep"]) : <any>undefined;
      this.requestorHcpDetails = _data["requestorHcpDetails"] ? OrderHcpDetailsDto.fromJS(_data["requestorHcpDetails"]) : <any>undefined;
      this.recipientHcpDetails = _data["recipientHcpDetails"] ? OrderHcpDetailsDto.fromJS(_data["recipientHcpDetails"]) : <any>undefined;
      this.shippingAddress = _data["shippingAddress"] ? ShippingAddressDto.fromJS(_data["shippingAddress"]) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.advancedEditFlag = _data["advancedEditFlag"];
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.missingRequestDate = _data["missingRequestDate"];
      this.orderTypeClassificationValueId = _data["orderTypeClassificationValueId"];
      this.customerName = _data["customerName"];
      this.customerAccountNbr = _data["customerAccountNbr"];
      this.customerType = _data["customerType"];
      this.programModuleId = _data["programModuleId"];
      this.patientOrder = _data["patientOrder"] ? PatientOrderDto.fromJS(_data["patientOrder"]) : <any>undefined;
      this.requestorPharmacist = _data["requestorPharmacist"] ? OrderPharmacistDetailsDto.fromJS(_data["requestorPharmacist"]) : <any>undefined;
      this.recipientPharmacy = _data["recipientPharmacy"] ? OrderPharmacyDetailsDto.fromJS(_data["recipientPharmacy"]) : <any>undefined;
      this.affiliatedHospital = _data["affiliatedHospital"] ? OrderHospitalDetailsDto.fromJS(_data["affiliatedHospital"]) : <any>undefined;
      if (Array.isArray(_data["prescribingHcps"])) {
        this.prescribingHcps = [] as any;
        for (let item of _data["prescribingHcps"])
          this.prescribingHcps.push(OrderPrescribingHcpDetailsDto.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderHcpSalesRepDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderHcpSalesRepDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["institutionFlag"] = this.institutionFlag;
    data["repDrivenFlag"] = this.repDrivenFlag;
    data["orderStatusId"] = this.orderStatusId;
    data["orderSourceId"] = this.orderSourceId;
    data["originalSalesRep"] = this.originalSalesRep ? this.originalSalesRep.toJSON() : <any>undefined;
    data["currentSalesRep"] = this.currentSalesRep ? this.currentSalesRep.toJSON() : <any>undefined;
    data["requestorHcpDetails"] = this.requestorHcpDetails ? this.requestorHcpDetails.toJSON() : <any>undefined;
    data["recipientHcpDetails"] = this.recipientHcpDetails ? this.recipientHcpDetails.toJSON() : <any>undefined;
    data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["advancedEditFlag"] = this.advancedEditFlag;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["missingRequestDate"] = this.missingRequestDate;
    data["orderTypeClassificationValueId"] = this.orderTypeClassificationValueId;
    data["customerName"] = this.customerName;
    data["customerAccountNbr"] = this.customerAccountNbr;
    data["customerType"] = this.customerType;
    data["programModuleId"] = this.programModuleId;
    data["patientOrder"] = this.patientOrder ? this.patientOrder.toJSON() : <any>undefined;
    data["requestorPharmacist"] = this.requestorPharmacist ? this.requestorPharmacist.toJSON() : <any>undefined;
    data["recipientPharmacy"] = this.recipientPharmacy ? this.recipientPharmacy.toJSON() : <any>undefined;
    data["affiliatedHospital"] = this.affiliatedHospital ? this.affiliatedHospital.toJSON() : <any>undefined;
    if (Array.isArray(this.prescribingHcps)) {
      data["prescribingHcps"] = [];
      for (let item of this.prescribingHcps)
        data["prescribingHcps"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }

  clone(): OrderHcpSalesRepDto {
    const json = this.toJSON();
    let result = new OrderHcpSalesRepDto();
    result.init(json);
    return result;
  }
}

export interface IOrderHcpSalesRepDto {
  institutionFlag: boolean | undefined;
  repDrivenFlag: boolean | undefined;
  orderStatusId: string | undefined;
  orderSourceId: string | undefined;
  originalSalesRep: OrderSalesRepDetailsDto | undefined;
  currentSalesRep: OrderSalesRepDetailsDto | undefined;
  requestorHcpDetails: OrderHcpDetailsDto | undefined;
  recipientHcpDetails: OrderHcpDetailsDto | undefined;
  shippingAddress: ShippingAddressDto | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  advancedEditFlag: boolean | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  orderTypeClassificationValueId: string | undefined;
  customerName: string | undefined;
  customerAccountNbr: string | undefined;
  customerType: string | undefined;
  /** Program moduleId. */
  programModuleId: string | undefined;
  patientOrder: PatientOrderDto | undefined;
  /** Gets or sets the pharmacist */
  requestorPharmacist: OrderPharmacistDetailsDto | undefined;
  /** Gets or sets the pharmacy */
  recipientPharmacy: OrderPharmacyDetailsDto | undefined;
  /** Gets or sets the hospital */
  affiliatedHospital: OrderHospitalDetailsDto | undefined;
  /** Gets or sets the prescribing Hcps */
  prescribingHcps: OrderPrescribingHcpDetailsDto[] | undefined;
  id: string | undefined;
}

export class OrderSalesRepDetailsDto implements IOrderSalesRepDetailsDto {
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  repId: string | undefined;
  territoryCode: string | undefined;
  emailAddressText: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;

  constructor(data?: IOrderSalesRepDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.repId = _data["repId"];
      this.territoryCode = _data["territoryCode"];
      this.emailAddressText = _data["emailAddressText"];
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
    }
  }

  static fromJS(data: any): OrderSalesRepDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderSalesRepDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["repId"] = this.repId;
    data["territoryCode"] = this.territoryCode;
    data["emailAddressText"] = this.emailAddressText;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    return data;
  }

  clone(): OrderSalesRepDetailsDto {
    const json = this.toJSON();
    let result = new OrderSalesRepDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IOrderSalesRepDetailsDto {
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  repId: string | undefined;
  territoryCode: string | undefined;
  emailAddressText: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
}

export class OrderHcpDetailsDto implements IOrderHcpDetailsDto {
  hcpId: string | undefined;
  knipperHcpId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  suffixId: string | undefined;
  professionalDesignationId: string | undefined;
  professionalDesignationCode: string | undefined;
  professionalSpecialtyCode: string | undefined;
  specialtyId: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  countryId: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  addressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  deaNbr: string | undefined;
  emailAddressText: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
  missingFirstNameFlag: boolean | undefined;
  missingLastNameFlag: boolean | undefined;
  missingSpecialtyCodeFlag: boolean | undefined;
  missingStateLicenseNbrFlag: boolean | undefined;
  missingAddress1TextFlag: boolean | undefined;
  missingCityNameFlag: boolean | undefined;
  missingZipCodeFlag: boolean | undefined;
  missingStateCodeFlag: boolean | undefined;
  missingProfessionalDesignationCodeFlag: boolean | undefined;
  missingStateLicenseStateCodeFlag: boolean | undefined;
  missingDeaNumberFlag: boolean | undefined;
  missingSanFlag: boolean | undefined;
  formModFirstNameFlag: boolean | undefined;
  formModMiddleNameFlag: boolean | undefined;
  formModLastNameFlag: boolean | undefined;
  formModStateLicenseNumberFlag: boolean | undefined;
  formModDeaLicenseNumberFlag: boolean | undefined;
  formModProfessionalDesignationFlag: boolean | undefined;
  formModSpecialtyFlag: boolean | undefined;
  formModCompanyFlag: boolean | undefined;
  formModAddress1Flag: boolean | undefined;
  formModAddress2Flag: boolean | undefined;
  formModCityFlag: boolean | undefined;
  formModStateFlag: boolean | undefined;
  formModZipCodeFlag: boolean | undefined;
  /** Gets or sets the institution territory number. */
  institutionTerritoryNumber: string | undefined;
  recipientAttentionToName: string | undefined;

  constructor(data?: IOrderHcpDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hcpId = _data["hcpId"];
      this.knipperHcpId = _data["knipperHcpId"];
      this.clientTargetId = _data["clientTargetId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.suffixId = _data["suffixId"];
      this.professionalDesignationId = _data["professionalDesignationId"];
      this.professionalDesignationCode = _data["professionalDesignationCode"];
      this.professionalSpecialtyCode = _data["professionalSpecialtyCode"];
      this.specialtyId = _data["specialtyId"];
      this.stateLicenseStateId = _data["stateLicenseStateId"];
      this.stateLicenseNbr = _data["stateLicenseNbr"];
      this.stateId = _data["stateId"];
      this.countryId = _data["countryId"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.addressId = _data["addressId"];
      this.companyName = _data["companyName"];
      this.san = _data["san"];
      this.deaNbr = _data["deaNbr"];
      this.emailAddressText = _data["emailAddressText"];
      this.phoneNbr = _data["phoneNbr"];
      this.phoneExtensionNbr = _data["phoneExtensionNbr"];
      this.faxNbr = _data["faxNbr"];
      this.missingFirstNameFlag = _data["missingFirstNameFlag"];
      this.missingLastNameFlag = _data["missingLastNameFlag"];
      this.missingSpecialtyCodeFlag = _data["missingSpecialtyCodeFlag"];
      this.missingStateLicenseNbrFlag = _data["missingStateLicenseNbrFlag"];
      this.missingAddress1TextFlag = _data["missingAddress1TextFlag"];
      this.missingCityNameFlag = _data["missingCityNameFlag"];
      this.missingZipCodeFlag = _data["missingZipCodeFlag"];
      this.missingStateCodeFlag = _data["missingStateCodeFlag"];
      this.missingProfessionalDesignationCodeFlag = _data["missingProfessionalDesignationCodeFlag"];
      this.missingStateLicenseStateCodeFlag = _data["missingStateLicenseStateCodeFlag"];
      this.missingDeaNumberFlag = _data["missingDeaNumberFlag"];
      this.missingSanFlag = _data["missingSanFlag"];
      this.formModFirstNameFlag = _data["formModFirstNameFlag"];
      this.formModMiddleNameFlag = _data["formModMiddleNameFlag"];
      this.formModLastNameFlag = _data["formModLastNameFlag"];
      this.formModStateLicenseNumberFlag = _data["formModStateLicenseNumberFlag"];
      this.formModDeaLicenseNumberFlag = _data["formModDeaLicenseNumberFlag"];
      this.formModProfessionalDesignationFlag = _data["formModProfessionalDesignationFlag"];
      this.formModSpecialtyFlag = _data["formModSpecialtyFlag"];
      this.formModCompanyFlag = _data["formModCompanyFlag"];
      this.formModAddress1Flag = _data["formModAddress1Flag"];
      this.formModAddress2Flag = _data["formModAddress2Flag"];
      this.formModCityFlag = _data["formModCityFlag"];
      this.formModStateFlag = _data["formModStateFlag"];
      this.formModZipCodeFlag = _data["formModZipCodeFlag"];
      this.institutionTerritoryNumber = _data["institutionTerritoryNumber"];
      this.recipientAttentionToName = _data["recipientAttentionToName"];
    }
  }

  static fromJS(data: any): OrderHcpDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderHcpDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hcpId"] = this.hcpId;
    data["knipperHcpId"] = this.knipperHcpId;
    data["clientTargetId"] = this.clientTargetId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["suffixId"] = this.suffixId;
    data["professionalDesignationId"] = this.professionalDesignationId;
    data["professionalDesignationCode"] = this.professionalDesignationCode;
    data["professionalSpecialtyCode"] = this.professionalSpecialtyCode;
    data["specialtyId"] = this.specialtyId;
    data["stateLicenseStateId"] = this.stateLicenseStateId;
    data["stateLicenseNbr"] = this.stateLicenseNbr;
    data["stateId"] = this.stateId;
    data["countryId"] = this.countryId;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["addressId"] = this.addressId;
    data["companyName"] = this.companyName;
    data["san"] = this.san;
    data["deaNbr"] = this.deaNbr;
    data["emailAddressText"] = this.emailAddressText;
    data["phoneNbr"] = this.phoneNbr;
    data["phoneExtensionNbr"] = this.phoneExtensionNbr;
    data["faxNbr"] = this.faxNbr;
    data["missingFirstNameFlag"] = this.missingFirstNameFlag;
    data["missingLastNameFlag"] = this.missingLastNameFlag;
    data["missingSpecialtyCodeFlag"] = this.missingSpecialtyCodeFlag;
    data["missingStateLicenseNbrFlag"] = this.missingStateLicenseNbrFlag;
    data["missingAddress1TextFlag"] = this.missingAddress1TextFlag;
    data["missingCityNameFlag"] = this.missingCityNameFlag;
    data["missingZipCodeFlag"] = this.missingZipCodeFlag;
    data["missingStateCodeFlag"] = this.missingStateCodeFlag;
    data["missingProfessionalDesignationCodeFlag"] = this.missingProfessionalDesignationCodeFlag;
    data["missingStateLicenseStateCodeFlag"] = this.missingStateLicenseStateCodeFlag;
    data["missingDeaNumberFlag"] = this.missingDeaNumberFlag;
    data["missingSanFlag"] = this.missingSanFlag;
    data["formModFirstNameFlag"] = this.formModFirstNameFlag;
    data["formModMiddleNameFlag"] = this.formModMiddleNameFlag;
    data["formModLastNameFlag"] = this.formModLastNameFlag;
    data["formModStateLicenseNumberFlag"] = this.formModStateLicenseNumberFlag;
    data["formModDeaLicenseNumberFlag"] = this.formModDeaLicenseNumberFlag;
    data["formModProfessionalDesignationFlag"] = this.formModProfessionalDesignationFlag;
    data["formModSpecialtyFlag"] = this.formModSpecialtyFlag;
    data["formModCompanyFlag"] = this.formModCompanyFlag;
    data["formModAddress1Flag"] = this.formModAddress1Flag;
    data["formModAddress2Flag"] = this.formModAddress2Flag;
    data["formModCityFlag"] = this.formModCityFlag;
    data["formModStateFlag"] = this.formModStateFlag;
    data["formModZipCodeFlag"] = this.formModZipCodeFlag;
    data["institutionTerritoryNumber"] = this.institutionTerritoryNumber;
    data["recipientAttentionToName"] = this.recipientAttentionToName;
    return data;
  }

  clone(): OrderHcpDetailsDto {
    const json = this.toJSON();
    let result = new OrderHcpDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IOrderHcpDetailsDto {
  hcpId: string | undefined;
  knipperHcpId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  suffixId: string | undefined;
  professionalDesignationId: string | undefined;
  professionalDesignationCode: string | undefined;
  professionalSpecialtyCode: string | undefined;
  specialtyId: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  countryId: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  addressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  deaNbr: string | undefined;
  emailAddressText: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
  missingFirstNameFlag: boolean | undefined;
  missingLastNameFlag: boolean | undefined;
  missingSpecialtyCodeFlag: boolean | undefined;
  missingStateLicenseNbrFlag: boolean | undefined;
  missingAddress1TextFlag: boolean | undefined;
  missingCityNameFlag: boolean | undefined;
  missingZipCodeFlag: boolean | undefined;
  missingStateCodeFlag: boolean | undefined;
  missingProfessionalDesignationCodeFlag: boolean | undefined;
  missingStateLicenseStateCodeFlag: boolean | undefined;
  missingDeaNumberFlag: boolean | undefined;
  missingSanFlag: boolean | undefined;
  formModFirstNameFlag: boolean | undefined;
  formModMiddleNameFlag: boolean | undefined;
  formModLastNameFlag: boolean | undefined;
  formModStateLicenseNumberFlag: boolean | undefined;
  formModDeaLicenseNumberFlag: boolean | undefined;
  formModProfessionalDesignationFlag: boolean | undefined;
  formModSpecialtyFlag: boolean | undefined;
  formModCompanyFlag: boolean | undefined;
  formModAddress1Flag: boolean | undefined;
  formModAddress2Flag: boolean | undefined;
  formModCityFlag: boolean | undefined;
  formModStateFlag: boolean | undefined;
  formModZipCodeFlag: boolean | undefined;
  /** Gets or sets the institution territory number. */
  institutionTerritoryNumber: string | undefined;
  recipientAttentionToName: string | undefined;
}

export class ShippingAddressDto implements IShippingAddressDto {
  orderId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  suffixClassificationValueId: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  externalNotes: string | undefined;
  companyName: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  addressLocationId: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;

  constructor(data?: IShippingAddressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.suffixClassificationValueId = _data["suffixClassificationValueId"];
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.missingRequestDate = _data["missingRequestDate"];
      this.externalNotes = _data["externalNotes"];
      this.companyName = _data["companyName"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.address3Text = _data["address3Text"];
      this.address4Text = _data["address4Text"];
      this.addressLocationId = _data["addressLocationId"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.stateCode = _data["stateCode"];
      this.countryCode = _data["countryCode"];
    }
  }

  static fromJS(data: any): ShippingAddressDto {
    data = typeof data === 'object' ? data : {};
    let result = new ShippingAddressDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["suffixClassificationValueId"] = this.suffixClassificationValueId;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["missingRequestDate"] = this.missingRequestDate;
    data["externalNotes"] = this.externalNotes;
    data["companyName"] = this.companyName;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["address3Text"] = this.address3Text;
    data["address4Text"] = this.address4Text;
    data["addressLocationId"] = this.addressLocationId;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["stateCode"] = this.stateCode;
    data["countryCode"] = this.countryCode;
    return data;
  }

  clone(): ShippingAddressDto {
    const json = this.toJSON();
    let result = new ShippingAddressDto();
    result.init(json);
    return result;
  }
}

export interface IShippingAddressDto {
  orderId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  suffixClassificationValueId: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  externalNotes: string | undefined;
  companyName: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  address3Text: string | undefined;
  address4Text: string | undefined;
  addressLocationId: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
}

export class PatientOrderDto implements IPatientOrderDto {
  patientFirstName: string | undefined;
  patientLastName: string | undefined;
  patientAddressLine1: string | undefined;
  patientAddressLine2: string | undefined;
  patientCity: string | undefined;
  patientState: string | undefined;
  patientZipCode: string | undefined;
  patientPhone: string | undefined;
  patientDateOfBirth: string | undefined;
  directToPatientConsent: string | undefined;
  patientReceiptConsent: string | undefined;

  constructor(data?: IPatientOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.patientFirstName = _data["patientFirstName"];
      this.patientLastName = _data["patientLastName"];
      this.patientAddressLine1 = _data["patientAddressLine1"];
      this.patientAddressLine2 = _data["patientAddressLine2"];
      this.patientCity = _data["patientCity"];
      this.patientState = _data["patientState"];
      this.patientZipCode = _data["patientZipCode"];
      this.patientPhone = _data["patientPhone"];
      this.patientDateOfBirth = _data["patientDateOfBirth"];
      this.directToPatientConsent = _data["directToPatientConsent"];
      this.patientReceiptConsent = _data["patientReceiptConsent"];
    }
  }

  static fromJS(data: any): PatientOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new PatientOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["patientFirstName"] = this.patientFirstName;
    data["patientLastName"] = this.patientLastName;
    data["patientAddressLine1"] = this.patientAddressLine1;
    data["patientAddressLine2"] = this.patientAddressLine2;
    data["patientCity"] = this.patientCity;
    data["patientState"] = this.patientState;
    data["patientZipCode"] = this.patientZipCode;
    data["patientPhone"] = this.patientPhone;
    data["patientDateOfBirth"] = this.patientDateOfBirth;
    data["directToPatientConsent"] = this.directToPatientConsent;
    data["patientReceiptConsent"] = this.patientReceiptConsent;
    return data;
  }

  clone(): PatientOrderDto {
    const json = this.toJSON();
    let result = new PatientOrderDto();
    result.init(json);
    return result;
  }
}

export interface IPatientOrderDto {
  patientFirstName: string | undefined;
  patientLastName: string | undefined;
  patientAddressLine1: string | undefined;
  patientAddressLine2: string | undefined;
  patientCity: string | undefined;
  patientState: string | undefined;
  patientZipCode: string | undefined;
  patientPhone: string | undefined;
  patientDateOfBirth: string | undefined;
  directToPatientConsent: string | undefined;
  patientReceiptConsent: string | undefined;
}

export class OrderPharmacistDetailsDto implements IOrderPharmacistDetailsDto {
  /** Gets or sets the pharmacist Id. */
  pharmacistId: string | undefined;
  knipperId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  suffixId: string | undefined;
  professionalDesignationId: string | undefined;
  professionalDesignationCode: string | undefined;
  professionalSpecialtyCode: string | undefined;
  specialtyId: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  addressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  deaNbr: string | undefined;
  emailAddressText: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
  missingFirstNameFlag: boolean | undefined;
  missingLastNameFlag: boolean | undefined;
  missingSpecialtyCodeFlag: boolean | undefined;
  missingStateLicenseNbrFlag: boolean | undefined;
  missingAddress1TextFlag: boolean | undefined;
  missingCityNameFlag: boolean | undefined;
  missingZipCodeFlag: boolean | undefined;
  missingStateCodeFlag: boolean | undefined;
  missingProfessionalDesignationCodeFlag: boolean | undefined;
  missingStateLicenseStateCodeFlag: boolean | undefined;
  missingDeaNumberFlag: boolean | undefined;
  missingSanFlag: boolean | undefined;
  formModFirstNameFlag: boolean | undefined;
  formModMiddleNameFlag: boolean | undefined;
  formModLastNameFlag: boolean | undefined;
  formModStateLicenseNumberFlag: boolean | undefined;
  formModDeaLicenseNumberFlag: boolean | undefined;
  formModProfessionalDesignationFlag: boolean | undefined;
  formModSpecialtyFlag: boolean | undefined;
  formModCompanyFlag: boolean | undefined;
  formModAddress1Flag: boolean | undefined;
  formModAddress2Flag: boolean | undefined;
  formModCityFlag: boolean | undefined;
  formModStateFlag: boolean | undefined;
  formModZipCodeFlag: boolean | undefined;
  /** Gets or sets the institution territory number. */
  institutionTerritoryNumber: string | undefined;

  constructor(data?: IOrderPharmacistDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacistId = _data["pharmacistId"];
      this.knipperId = _data["knipperId"];
      this.clientTargetId = _data["clientTargetId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.suffixId = _data["suffixId"];
      this.professionalDesignationId = _data["professionalDesignationId"];
      this.professionalDesignationCode = _data["professionalDesignationCode"];
      this.professionalSpecialtyCode = _data["professionalSpecialtyCode"];
      this.specialtyId = _data["specialtyId"];
      this.stateLicenseStateId = _data["stateLicenseStateId"];
      this.stateLicenseNbr = _data["stateLicenseNbr"];
      this.stateId = _data["stateId"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.addressId = _data["addressId"];
      this.companyName = _data["companyName"];
      this.san = _data["san"];
      this.deaNbr = _data["deaNbr"];
      this.emailAddressText = _data["emailAddressText"];
      this.phoneNbr = _data["phoneNbr"];
      this.phoneExtensionNbr = _data["phoneExtensionNbr"];
      this.faxNbr = _data["faxNbr"];
      this.missingFirstNameFlag = _data["missingFirstNameFlag"];
      this.missingLastNameFlag = _data["missingLastNameFlag"];
      this.missingSpecialtyCodeFlag = _data["missingSpecialtyCodeFlag"];
      this.missingStateLicenseNbrFlag = _data["missingStateLicenseNbrFlag"];
      this.missingAddress1TextFlag = _data["missingAddress1TextFlag"];
      this.missingCityNameFlag = _data["missingCityNameFlag"];
      this.missingZipCodeFlag = _data["missingZipCodeFlag"];
      this.missingStateCodeFlag = _data["missingStateCodeFlag"];
      this.missingProfessionalDesignationCodeFlag = _data["missingProfessionalDesignationCodeFlag"];
      this.missingStateLicenseStateCodeFlag = _data["missingStateLicenseStateCodeFlag"];
      this.missingDeaNumberFlag = _data["missingDeaNumberFlag"];
      this.missingSanFlag = _data["missingSanFlag"];
      this.formModFirstNameFlag = _data["formModFirstNameFlag"];
      this.formModMiddleNameFlag = _data["formModMiddleNameFlag"];
      this.formModLastNameFlag = _data["formModLastNameFlag"];
      this.formModStateLicenseNumberFlag = _data["formModStateLicenseNumberFlag"];
      this.formModDeaLicenseNumberFlag = _data["formModDeaLicenseNumberFlag"];
      this.formModProfessionalDesignationFlag = _data["formModProfessionalDesignationFlag"];
      this.formModSpecialtyFlag = _data["formModSpecialtyFlag"];
      this.formModCompanyFlag = _data["formModCompanyFlag"];
      this.formModAddress1Flag = _data["formModAddress1Flag"];
      this.formModAddress2Flag = _data["formModAddress2Flag"];
      this.formModCityFlag = _data["formModCityFlag"];
      this.formModStateFlag = _data["formModStateFlag"];
      this.formModZipCodeFlag = _data["formModZipCodeFlag"];
      this.institutionTerritoryNumber = _data["institutionTerritoryNumber"];
    }
  }

  static fromJS(data: any): OrderPharmacistDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderPharmacistDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacistId"] = this.pharmacistId;
    data["knipperId"] = this.knipperId;
    data["clientTargetId"] = this.clientTargetId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["suffixId"] = this.suffixId;
    data["professionalDesignationId"] = this.professionalDesignationId;
    data["professionalDesignationCode"] = this.professionalDesignationCode;
    data["professionalSpecialtyCode"] = this.professionalSpecialtyCode;
    data["specialtyId"] = this.specialtyId;
    data["stateLicenseStateId"] = this.stateLicenseStateId;
    data["stateLicenseNbr"] = this.stateLicenseNbr;
    data["stateId"] = this.stateId;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["addressId"] = this.addressId;
    data["companyName"] = this.companyName;
    data["san"] = this.san;
    data["deaNbr"] = this.deaNbr;
    data["emailAddressText"] = this.emailAddressText;
    data["phoneNbr"] = this.phoneNbr;
    data["phoneExtensionNbr"] = this.phoneExtensionNbr;
    data["faxNbr"] = this.faxNbr;
    data["missingFirstNameFlag"] = this.missingFirstNameFlag;
    data["missingLastNameFlag"] = this.missingLastNameFlag;
    data["missingSpecialtyCodeFlag"] = this.missingSpecialtyCodeFlag;
    data["missingStateLicenseNbrFlag"] = this.missingStateLicenseNbrFlag;
    data["missingAddress1TextFlag"] = this.missingAddress1TextFlag;
    data["missingCityNameFlag"] = this.missingCityNameFlag;
    data["missingZipCodeFlag"] = this.missingZipCodeFlag;
    data["missingStateCodeFlag"] = this.missingStateCodeFlag;
    data["missingProfessionalDesignationCodeFlag"] = this.missingProfessionalDesignationCodeFlag;
    data["missingStateLicenseStateCodeFlag"] = this.missingStateLicenseStateCodeFlag;
    data["missingDeaNumberFlag"] = this.missingDeaNumberFlag;
    data["missingSanFlag"] = this.missingSanFlag;
    data["formModFirstNameFlag"] = this.formModFirstNameFlag;
    data["formModMiddleNameFlag"] = this.formModMiddleNameFlag;
    data["formModLastNameFlag"] = this.formModLastNameFlag;
    data["formModStateLicenseNumberFlag"] = this.formModStateLicenseNumberFlag;
    data["formModDeaLicenseNumberFlag"] = this.formModDeaLicenseNumberFlag;
    data["formModProfessionalDesignationFlag"] = this.formModProfessionalDesignationFlag;
    data["formModSpecialtyFlag"] = this.formModSpecialtyFlag;
    data["formModCompanyFlag"] = this.formModCompanyFlag;
    data["formModAddress1Flag"] = this.formModAddress1Flag;
    data["formModAddress2Flag"] = this.formModAddress2Flag;
    data["formModCityFlag"] = this.formModCityFlag;
    data["formModStateFlag"] = this.formModStateFlag;
    data["formModZipCodeFlag"] = this.formModZipCodeFlag;
    data["institutionTerritoryNumber"] = this.institutionTerritoryNumber;
    return data;
  }

  clone(): OrderPharmacistDetailsDto {
    const json = this.toJSON();
    let result = new OrderPharmacistDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IOrderPharmacistDetailsDto {
  /** Gets or sets the pharmacist Id. */
  pharmacistId: string | undefined;
  knipperId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  suffixId: string | undefined;
  professionalDesignationId: string | undefined;
  professionalDesignationCode: string | undefined;
  professionalSpecialtyCode: string | undefined;
  specialtyId: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  addressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  deaNbr: string | undefined;
  emailAddressText: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
  missingFirstNameFlag: boolean | undefined;
  missingLastNameFlag: boolean | undefined;
  missingSpecialtyCodeFlag: boolean | undefined;
  missingStateLicenseNbrFlag: boolean | undefined;
  missingAddress1TextFlag: boolean | undefined;
  missingCityNameFlag: boolean | undefined;
  missingZipCodeFlag: boolean | undefined;
  missingStateCodeFlag: boolean | undefined;
  missingProfessionalDesignationCodeFlag: boolean | undefined;
  missingStateLicenseStateCodeFlag: boolean | undefined;
  missingDeaNumberFlag: boolean | undefined;
  missingSanFlag: boolean | undefined;
  formModFirstNameFlag: boolean | undefined;
  formModMiddleNameFlag: boolean | undefined;
  formModLastNameFlag: boolean | undefined;
  formModStateLicenseNumberFlag: boolean | undefined;
  formModDeaLicenseNumberFlag: boolean | undefined;
  formModProfessionalDesignationFlag: boolean | undefined;
  formModSpecialtyFlag: boolean | undefined;
  formModCompanyFlag: boolean | undefined;
  formModAddress1Flag: boolean | undefined;
  formModAddress2Flag: boolean | undefined;
  formModCityFlag: boolean | undefined;
  formModStateFlag: boolean | undefined;
  formModZipCodeFlag: boolean | undefined;
  /** Gets or sets the institution territory number. */
  institutionTerritoryNumber: string | undefined;
}

export class OrderPharmacyDetailsDto implements IOrderPharmacyDetailsDto {
  /** Gets or sets the pharmacy Id. */
  pharmacyId: string | undefined;
  /** Gets or sets the pharmacy name. */
  pharmacyName: string | undefined;
  /** Gets or sets the contact first name. */
  contactFirstName: string | undefined;
  /** Gets or sets the contact middle name. */
  contactMiddleName: string | undefined;
  /** Gets or sets the contact last name. */
  contactLastName: string | undefined;
  knipperId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  suffixId: string | undefined;
  professionalDesignationId: string | undefined;
  professionalDesignationCode: string | undefined;
  professionalSpecialtyCode: string | undefined;
  specialtyId: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  addressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  deaNbr: string | undefined;
  emailAddressText: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
  missingFirstNameFlag: boolean | undefined;
  missingLastNameFlag: boolean | undefined;
  missingSpecialtyCodeFlag: boolean | undefined;
  missingStateLicenseNbrFlag: boolean | undefined;
  missingAddress1TextFlag: boolean | undefined;
  missingCityNameFlag: boolean | undefined;
  missingZipCodeFlag: boolean | undefined;
  missingStateCodeFlag: boolean | undefined;
  missingProfessionalDesignationCodeFlag: boolean | undefined;
  missingStateLicenseStateCodeFlag: boolean | undefined;
  missingDeaNumberFlag: boolean | undefined;
  missingSanFlag: boolean | undefined;
  formModFirstNameFlag: boolean | undefined;
  formModMiddleNameFlag: boolean | undefined;
  formModLastNameFlag: boolean | undefined;
  formModStateLicenseNumberFlag: boolean | undefined;
  formModDeaLicenseNumberFlag: boolean | undefined;
  formModProfessionalDesignationFlag: boolean | undefined;
  formModSpecialtyFlag: boolean | undefined;
  formModCompanyFlag: boolean | undefined;
  formModAddress1Flag: boolean | undefined;
  formModAddress2Flag: boolean | undefined;
  formModCityFlag: boolean | undefined;
  formModStateFlag: boolean | undefined;
  formModZipCodeFlag: boolean | undefined;
  /** Gets or sets the institution territory number. */
  institutionTerritoryNumber: string | undefined;

  constructor(data?: IOrderPharmacyDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pharmacyId = _data["pharmacyId"];
      this.pharmacyName = _data["pharmacyName"];
      this.contactFirstName = _data["contactFirstName"];
      this.contactMiddleName = _data["contactMiddleName"];
      this.contactLastName = _data["contactLastName"];
      this.knipperId = _data["knipperId"];
      this.clientTargetId = _data["clientTargetId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.suffixId = _data["suffixId"];
      this.professionalDesignationId = _data["professionalDesignationId"];
      this.professionalDesignationCode = _data["professionalDesignationCode"];
      this.professionalSpecialtyCode = _data["professionalSpecialtyCode"];
      this.specialtyId = _data["specialtyId"];
      this.stateLicenseStateId = _data["stateLicenseStateId"];
      this.stateLicenseNbr = _data["stateLicenseNbr"];
      this.stateId = _data["stateId"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.addressId = _data["addressId"];
      this.companyName = _data["companyName"];
      this.san = _data["san"];
      this.deaNbr = _data["deaNbr"];
      this.emailAddressText = _data["emailAddressText"];
      this.phoneNbr = _data["phoneNbr"];
      this.phoneExtensionNbr = _data["phoneExtensionNbr"];
      this.faxNbr = _data["faxNbr"];
      this.missingFirstNameFlag = _data["missingFirstNameFlag"];
      this.missingLastNameFlag = _data["missingLastNameFlag"];
      this.missingSpecialtyCodeFlag = _data["missingSpecialtyCodeFlag"];
      this.missingStateLicenseNbrFlag = _data["missingStateLicenseNbrFlag"];
      this.missingAddress1TextFlag = _data["missingAddress1TextFlag"];
      this.missingCityNameFlag = _data["missingCityNameFlag"];
      this.missingZipCodeFlag = _data["missingZipCodeFlag"];
      this.missingStateCodeFlag = _data["missingStateCodeFlag"];
      this.missingProfessionalDesignationCodeFlag = _data["missingProfessionalDesignationCodeFlag"];
      this.missingStateLicenseStateCodeFlag = _data["missingStateLicenseStateCodeFlag"];
      this.missingDeaNumberFlag = _data["missingDeaNumberFlag"];
      this.missingSanFlag = _data["missingSanFlag"];
      this.formModFirstNameFlag = _data["formModFirstNameFlag"];
      this.formModMiddleNameFlag = _data["formModMiddleNameFlag"];
      this.formModLastNameFlag = _data["formModLastNameFlag"];
      this.formModStateLicenseNumberFlag = _data["formModStateLicenseNumberFlag"];
      this.formModDeaLicenseNumberFlag = _data["formModDeaLicenseNumberFlag"];
      this.formModProfessionalDesignationFlag = _data["formModProfessionalDesignationFlag"];
      this.formModSpecialtyFlag = _data["formModSpecialtyFlag"];
      this.formModCompanyFlag = _data["formModCompanyFlag"];
      this.formModAddress1Flag = _data["formModAddress1Flag"];
      this.formModAddress2Flag = _data["formModAddress2Flag"];
      this.formModCityFlag = _data["formModCityFlag"];
      this.formModStateFlag = _data["formModStateFlag"];
      this.formModZipCodeFlag = _data["formModZipCodeFlag"];
      this.institutionTerritoryNumber = _data["institutionTerritoryNumber"];
    }
  }

  static fromJS(data: any): OrderPharmacyDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderPharmacyDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["pharmacyId"] = this.pharmacyId;
    data["pharmacyName"] = this.pharmacyName;
    data["contactFirstName"] = this.contactFirstName;
    data["contactMiddleName"] = this.contactMiddleName;
    data["contactLastName"] = this.contactLastName;
    data["knipperId"] = this.knipperId;
    data["clientTargetId"] = this.clientTargetId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["suffixId"] = this.suffixId;
    data["professionalDesignationId"] = this.professionalDesignationId;
    data["professionalDesignationCode"] = this.professionalDesignationCode;
    data["professionalSpecialtyCode"] = this.professionalSpecialtyCode;
    data["specialtyId"] = this.specialtyId;
    data["stateLicenseStateId"] = this.stateLicenseStateId;
    data["stateLicenseNbr"] = this.stateLicenseNbr;
    data["stateId"] = this.stateId;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["addressId"] = this.addressId;
    data["companyName"] = this.companyName;
    data["san"] = this.san;
    data["deaNbr"] = this.deaNbr;
    data["emailAddressText"] = this.emailAddressText;
    data["phoneNbr"] = this.phoneNbr;
    data["phoneExtensionNbr"] = this.phoneExtensionNbr;
    data["faxNbr"] = this.faxNbr;
    data["missingFirstNameFlag"] = this.missingFirstNameFlag;
    data["missingLastNameFlag"] = this.missingLastNameFlag;
    data["missingSpecialtyCodeFlag"] = this.missingSpecialtyCodeFlag;
    data["missingStateLicenseNbrFlag"] = this.missingStateLicenseNbrFlag;
    data["missingAddress1TextFlag"] = this.missingAddress1TextFlag;
    data["missingCityNameFlag"] = this.missingCityNameFlag;
    data["missingZipCodeFlag"] = this.missingZipCodeFlag;
    data["missingStateCodeFlag"] = this.missingStateCodeFlag;
    data["missingProfessionalDesignationCodeFlag"] = this.missingProfessionalDesignationCodeFlag;
    data["missingStateLicenseStateCodeFlag"] = this.missingStateLicenseStateCodeFlag;
    data["missingDeaNumberFlag"] = this.missingDeaNumberFlag;
    data["missingSanFlag"] = this.missingSanFlag;
    data["formModFirstNameFlag"] = this.formModFirstNameFlag;
    data["formModMiddleNameFlag"] = this.formModMiddleNameFlag;
    data["formModLastNameFlag"] = this.formModLastNameFlag;
    data["formModStateLicenseNumberFlag"] = this.formModStateLicenseNumberFlag;
    data["formModDeaLicenseNumberFlag"] = this.formModDeaLicenseNumberFlag;
    data["formModProfessionalDesignationFlag"] = this.formModProfessionalDesignationFlag;
    data["formModSpecialtyFlag"] = this.formModSpecialtyFlag;
    data["formModCompanyFlag"] = this.formModCompanyFlag;
    data["formModAddress1Flag"] = this.formModAddress1Flag;
    data["formModAddress2Flag"] = this.formModAddress2Flag;
    data["formModCityFlag"] = this.formModCityFlag;
    data["formModStateFlag"] = this.formModStateFlag;
    data["formModZipCodeFlag"] = this.formModZipCodeFlag;
    data["institutionTerritoryNumber"] = this.institutionTerritoryNumber;
    return data;
  }

  clone(): OrderPharmacyDetailsDto {
    const json = this.toJSON();
    let result = new OrderPharmacyDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IOrderPharmacyDetailsDto {
  /** Gets or sets the pharmacy Id. */
  pharmacyId: string | undefined;
  /** Gets or sets the pharmacy name. */
  pharmacyName: string | undefined;
  /** Gets or sets the contact first name. */
  contactFirstName: string | undefined;
  /** Gets or sets the contact middle name. */
  contactMiddleName: string | undefined;
  /** Gets or sets the contact last name. */
  contactLastName: string | undefined;
  knipperId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  suffixId: string | undefined;
  professionalDesignationId: string | undefined;
  professionalDesignationCode: string | undefined;
  professionalSpecialtyCode: string | undefined;
  specialtyId: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  addressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  deaNbr: string | undefined;
  emailAddressText: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
  missingFirstNameFlag: boolean | undefined;
  missingLastNameFlag: boolean | undefined;
  missingSpecialtyCodeFlag: boolean | undefined;
  missingStateLicenseNbrFlag: boolean | undefined;
  missingAddress1TextFlag: boolean | undefined;
  missingCityNameFlag: boolean | undefined;
  missingZipCodeFlag: boolean | undefined;
  missingStateCodeFlag: boolean | undefined;
  missingProfessionalDesignationCodeFlag: boolean | undefined;
  missingStateLicenseStateCodeFlag: boolean | undefined;
  missingDeaNumberFlag: boolean | undefined;
  missingSanFlag: boolean | undefined;
  formModFirstNameFlag: boolean | undefined;
  formModMiddleNameFlag: boolean | undefined;
  formModLastNameFlag: boolean | undefined;
  formModStateLicenseNumberFlag: boolean | undefined;
  formModDeaLicenseNumberFlag: boolean | undefined;
  formModProfessionalDesignationFlag: boolean | undefined;
  formModSpecialtyFlag: boolean | undefined;
  formModCompanyFlag: boolean | undefined;
  formModAddress1Flag: boolean | undefined;
  formModAddress2Flag: boolean | undefined;
  formModCityFlag: boolean | undefined;
  formModStateFlag: boolean | undefined;
  formModZipCodeFlag: boolean | undefined;
  /** Gets or sets the institution territory number. */
  institutionTerritoryNumber: string | undefined;
}

export class OrderHospitalDetailsDto implements IOrderHospitalDetailsDto {
  knipperId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  cityName: string | undefined;
  stateCode: string | undefined;
  zipCode: string | undefined;
  addressId: string | undefined;
  hospitalName: string | undefined;
  emailAddressText: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;

  constructor(data?: IOrderHospitalDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.knipperId = _data["knipperId"];
      this.clientTargetId = _data["clientTargetId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.stateLicenseStateId = _data["stateLicenseStateId"];
      this.stateLicenseNbr = _data["stateLicenseNbr"];
      this.stateId = _data["stateId"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.cityName = _data["cityName"];
      this.stateCode = _data["stateCode"];
      this.zipCode = _data["zipCode"];
      this.addressId = _data["addressId"];
      this.hospitalName = _data["hospitalName"];
      this.emailAddressText = _data["emailAddressText"];
      this.phoneNbr = _data["phoneNbr"];
      this.phoneExtensionNbr = _data["phoneExtensionNbr"];
      this.faxNbr = _data["faxNbr"];
    }
  }

  static fromJS(data: any): OrderHospitalDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderHospitalDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["knipperId"] = this.knipperId;
    data["clientTargetId"] = this.clientTargetId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["stateLicenseStateId"] = this.stateLicenseStateId;
    data["stateLicenseNbr"] = this.stateLicenseNbr;
    data["stateId"] = this.stateId;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["cityName"] = this.cityName;
    data["stateCode"] = this.stateCode;
    data["zipCode"] = this.zipCode;
    data["addressId"] = this.addressId;
    data["hospitalName"] = this.hospitalName;
    data["emailAddressText"] = this.emailAddressText;
    data["phoneNbr"] = this.phoneNbr;
    data["phoneExtensionNbr"] = this.phoneExtensionNbr;
    data["faxNbr"] = this.faxNbr;
    return data;
  }

  clone(): OrderHospitalDetailsDto {
    const json = this.toJSON();
    let result = new OrderHospitalDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IOrderHospitalDetailsDto {
  knipperId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  cityName: string | undefined;
  stateCode: string | undefined;
  zipCode: string | undefined;
  addressId: string | undefined;
  hospitalName: string | undefined;
  emailAddressText: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
}

export class OrderPrescribingHcpDetailsDto implements IOrderPrescribingHcpDetailsDto {
  knipperId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  professionalDesignationId: string | undefined;
  professionalDesignationCode: string | undefined;
  professionalSpecialtyCode: string | undefined;

  constructor(data?: IOrderPrescribingHcpDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.knipperId = _data["knipperId"];
      this.clientTargetId = _data["clientTargetId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.stateLicenseStateId = _data["stateLicenseStateId"];
      this.stateLicenseNbr = _data["stateLicenseNbr"];
      this.stateId = _data["stateId"];
      this.professionalDesignationId = _data["professionalDesignationId"];
      this.professionalDesignationCode = _data["professionalDesignationCode"];
      this.professionalSpecialtyCode = _data["professionalSpecialtyCode"];
    }
  }

  static fromJS(data: any): OrderPrescribingHcpDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderPrescribingHcpDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["knipperId"] = this.knipperId;
    data["clientTargetId"] = this.clientTargetId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["stateLicenseStateId"] = this.stateLicenseStateId;
    data["stateLicenseNbr"] = this.stateLicenseNbr;
    data["stateId"] = this.stateId;
    data["professionalDesignationId"] = this.professionalDesignationId;
    data["professionalDesignationCode"] = this.professionalDesignationCode;
    data["professionalSpecialtyCode"] = this.professionalSpecialtyCode;
    return data;
  }

  clone(): OrderPrescribingHcpDetailsDto {
    const json = this.toJSON();
    let result = new OrderPrescribingHcpDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IOrderPrescribingHcpDetailsDto {
  knipperId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  professionalDesignationId: string | undefined;
  professionalDesignationCode: string | undefined;
  professionalSpecialtyCode: string | undefined;
}

export class AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto implements IAjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto {
  result: PageValidationOfOrderAttachmentAndCommentsDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? PageValidationOfOrderAttachmentAndCommentsDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfPageValidationOfOrderAttachmentAndCommentsDto {
  result: PageValidationOfOrderAttachmentAndCommentsDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class PageValidationOfOrderAttachmentAndCommentsDto implements IPageValidationOfOrderAttachmentAndCommentsDto {
  dataDto: OrderAttachmentAndCommentsDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;

  constructor(data?: IPageValidationOfOrderAttachmentAndCommentsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dataDto = _data["dataDto"] ? OrderAttachmentAndCommentsDto.fromJS(_data["dataDto"]) : <any>undefined;
      if (Array.isArray(_data["sectionValidations"])) {
        this.sectionValidations = [] as any;
        for (let item of _data["sectionValidations"])
          this.sectionValidations.push(SectionValidation.fromJS(item));
      }
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): PageValidationOfOrderAttachmentAndCommentsDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageValidationOfOrderAttachmentAndCommentsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dataDto"] = this.dataDto ? this.dataDto.toJSON() : <any>undefined;
    if (Array.isArray(this.sectionValidations)) {
      data["sectionValidations"] = [];
      for (let item of this.sectionValidations)
        data["sectionValidations"].push(item.toJSON());
    }
    data["state"] = this.state;
    return data;
  }

  clone(): PageValidationOfOrderAttachmentAndCommentsDto {
    const json = this.toJSON();
    let result = new PageValidationOfOrderAttachmentAndCommentsDto();
    result.init(json);
    return result;
  }
}

export interface IPageValidationOfOrderAttachmentAndCommentsDto {
  dataDto: OrderAttachmentAndCommentsDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;
}

export class OrderAttachmentAndCommentsDto implements IOrderAttachmentAndCommentsDto {
  orderAttachments: OrderAttachmentDto[] | undefined;
  orderComments: OrderCommentDto[] | undefined;
  comments: string | undefined;
  description: string | undefined;
  orderStatusId: string | undefined;
  attachment: FileUpload | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderAttachmentAndCommentsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["orderAttachments"])) {
        this.orderAttachments = [] as any;
        for (let item of _data["orderAttachments"])
          this.orderAttachments.push(OrderAttachmentDto.fromJS(item));
      }
      if (Array.isArray(_data["orderComments"])) {
        this.orderComments = [] as any;
        for (let item of _data["orderComments"])
          this.orderComments.push(OrderCommentDto.fromJS(item));
      }
      this.comments = _data["comments"];
      this.description = _data["description"];
      this.orderStatusId = _data["orderStatusId"];
      this.attachment = _data["attachment"] ? FileUpload.fromJS(_data["attachment"]) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderAttachmentAndCommentsDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderAttachmentAndCommentsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.orderAttachments)) {
      data["orderAttachments"] = [];
      for (let item of this.orderAttachments)
        data["orderAttachments"].push(item.toJSON());
    }
    if (Array.isArray(this.orderComments)) {
      data["orderComments"] = [];
      for (let item of this.orderComments)
        data["orderComments"].push(item.toJSON());
    }
    data["comments"] = this.comments;
    data["description"] = this.description;
    data["orderStatusId"] = this.orderStatusId;
    data["attachment"] = this.attachment ? this.attachment.toJSON() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderAttachmentAndCommentsDto {
    const json = this.toJSON();
    let result = new OrderAttachmentAndCommentsDto();
    result.init(json);
    return result;
  }
}

export interface IOrderAttachmentAndCommentsDto {
  orderAttachments: OrderAttachmentDto[] | undefined;
  orderComments: OrderCommentDto[] | undefined;
  comments: string | undefined;
  description: string | undefined;
  orderStatusId: string | undefined;
  attachment: FileUpload | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  id: string | undefined;
}

export class OrderCommentDto implements IOrderCommentDto {
  comments: string | undefined;
  commentedByName: string | undefined;
  orderStatusId: string | undefined;
  commentBy: number | undefined;
  commentDateTime: Date | undefined;
  srfAdverseEventFlag: boolean | undefined;
  id: string | undefined;

  constructor(data?: IOrderCommentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.comments = _data["comments"];
      this.commentedByName = _data["commentedByName"];
      this.orderStatusId = _data["orderStatusId"];
      this.commentBy = _data["commentBy"];
      this.commentDateTime = _data["commentDateTime"] ? new Date(_data["commentDateTime"].toString()) : <any>undefined;
      this.srfAdverseEventFlag = _data["srfAdverseEventFlag"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderCommentDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderCommentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["comments"] = this.comments;
    data["commentedByName"] = this.commentedByName;
    data["orderStatusId"] = this.orderStatusId;
    data["commentBy"] = this.commentBy;
    data["commentDateTime"] = this.commentDateTime ? this.commentDateTime.toISOString() : <any>undefined;
    data["srfAdverseEventFlag"] = this.srfAdverseEventFlag;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderCommentDto {
    const json = this.toJSON();
    let result = new OrderCommentDto();
    result.init(json);
    return result;
  }
}

export interface IOrderCommentDto {
  comments: string | undefined;
  commentedByName: string | undefined;
  orderStatusId: string | undefined;
  commentBy: number | undefined;
  commentDateTime: Date | undefined;
  srfAdverseEventFlag: boolean | undefined;
  id: string | undefined;
}

export class OrderAttachmentAndCommentUpdateDto implements IOrderAttachmentAndCommentUpdateDto {
  orderAttachments: OrderAttachmentDto[] | undefined;
  orderComment: OrderCommentDto | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  id: string | undefined;

  constructor(data?: IOrderAttachmentAndCommentUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["orderAttachments"])) {
        this.orderAttachments = [] as any;
        for (let item of _data["orderAttachments"])
          this.orderAttachments.push(OrderAttachmentDto.fromJS(item));
      }
      this.orderComment = _data["orderComment"] ? OrderCommentDto.fromJS(_data["orderComment"]) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.missingRequestDate = _data["missingRequestDate"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderAttachmentAndCommentUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderAttachmentAndCommentUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.orderAttachments)) {
      data["orderAttachments"] = [];
      for (let item of this.orderAttachments)
        data["orderAttachments"].push(item.toJSON());
    }
    data["orderComment"] = this.orderComment ? this.orderComment.toJSON() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["missingRequestDate"] = this.missingRequestDate;
    data["id"] = this.id;
    return data;
  }

  clone(): OrderAttachmentAndCommentUpdateDto {
    const json = this.toJSON();
    let result = new OrderAttachmentAndCommentUpdateDto();
    result.init(json);
    return result;
  }
}

export interface IOrderAttachmentAndCommentUpdateDto {
  orderAttachments: OrderAttachmentDto[] | undefined;
  orderComment: OrderCommentDto | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  id: string | undefined;
}


export class AjaxResponseOfIListOfCustomerOrderTypeDto implements IAjaxResponseOfIListOfCustomerOrderTypeDto {
  result: CustomerOrderTypeDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfIListOfCustomerOrderTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result.push(CustomerOrderTypeDto.fromJS(item));
      }
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfIListOfCustomerOrderTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfIListOfCustomerOrderTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfIListOfCustomerOrderTypeDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfIListOfCustomerOrderTypeDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfIListOfCustomerOrderTypeDto {
  result: CustomerOrderTypeDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}


export class AjaxResponseOfPageValidationOfOrderDetailsDto implements IAjaxResponseOfPageValidationOfOrderDetailsDto {
  result: PageValidationOfOrderDetailsDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfPageValidationOfOrderDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? PageValidationOfOrderDetailsDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfPageValidationOfOrderDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfPageValidationOfOrderDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfPageValidationOfOrderDetailsDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfPageValidationOfOrderDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfPageValidationOfOrderDetailsDto {
  result: PageValidationOfOrderDetailsDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class PageValidationOfOrderDetailsDto implements IPageValidationOfOrderDetailsDto {
  dataDto: OrderDetailsDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;

  constructor(data?: IPageValidationOfOrderDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dataDto = _data["dataDto"] ? OrderDetailsDto.fromJS(_data["dataDto"]) : <any>undefined;
      if (Array.isArray(_data["sectionValidations"])) {
        this.sectionValidations = [] as any;
        for (let item of _data["sectionValidations"])
          this.sectionValidations.push(SectionValidation.fromJS(item));
      }
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): PageValidationOfOrderDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageValidationOfOrderDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dataDto"] = this.dataDto ? this.dataDto.toJSON() : <any>undefined;
    if (Array.isArray(this.sectionValidations)) {
      data["sectionValidations"] = [];
      for (let item of this.sectionValidations)
        data["sectionValidations"].push(item.toJSON());
    }
    data["state"] = this.state;
    return data;
  }

  clone(): PageValidationOfOrderDetailsDto {
    const json = this.toJSON();
    let result = new PageValidationOfOrderDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IPageValidationOfOrderDetailsDto {
  dataDto: OrderDetailsDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;
}

export class OrderDetailsDto implements IOrderDetailsDto {
  optOutFlag: boolean | undefined;
  ohioTdddExemptionFlag: boolean | undefined;
  hcpSignaturePresentFlag: boolean | undefined;
  hcpSignatureStampedFlag: boolean | undefined;
  hcpSignatureMatchFlag: boolean | undefined;
  hcpSignedDatePresentFlag: boolean | undefined;
  missingHCPSignedDateFlag: boolean | undefined;
  hcpSignatureDateStampedFlag: boolean | undefined;
  offeredQtyFlag: boolean | undefined;
  hcpSignatureDate: Date | undefined;
  orderComment: string | undefined;
  srfAdverseEventFlag: boolean | undefined;
  srfAdverseEventComment: string | undefined;
  orderStatusId: string | undefined;
  orderSourceId: string | undefined;
  orderLines: OrderLineDto[] | undefined;
  hcpDispensedOrderLineDtos: DispensedOrderLineDto[] | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  formCommentHistory: OrderCommentDto[] | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  isDraftSave: boolean | undefined;
  isLineItemReleased: boolean | undefined;
  associatedOrderLines: OrderLineDto[] | undefined;
  orderDeliveryType: OrderDetailsDtoOrderDeliveryType | undefined;
  orderRecievedCutoffTime: Date | undefined;
  acceptableDaysOfDelivery: AcceptableDaysOfDelivery[] | undefined;
  programDeliverySelectDays: ProgramDeliverySelectDays[] | undefined;
  programShipDays: ProgramShipDays[] | undefined;
  turnAroundDays: number | undefined;
  desiredDeliveryDate: Date | undefined;
  actualCarrier: string | undefined;
  actualFreightCode: string | undefined;
  scheduledShipDate: Date | undefined;
  anticipatedLatestDeliveryDate: Date | undefined;
  isSelectDayVerificationRequired: boolean | undefined;
  allowNonWorkingDaysIntransit: boolean | undefined;
  carrierServiceType: CarrierServiceTypeDto | undefined;
  insufficientInventories: InsufficientInventoryValidationDto[] | undefined;
  programOrderFulfillmentDto: ProgramOrderFulfillmentDto | undefined;
  orderDate: Date | undefined;
  checkPrentLineItemSplit: boolean | undefined;
  somStatusCode: string | undefined;
  isAllNonRejectedRelease: boolean | undefined;
  isCommentRequired: boolean | undefined;
  externalBillingNbr: string | undefined;
  externalNotes: string | undefined;
  paymentMethodClassificationValueId: string | undefined;
  autoMitigatePriceCheckEnabled: boolean | undefined;
  isArkrayClient: boolean | undefined;
  isAllAdjustedQuantityZero: boolean | undefined;
  isAllOnHoldQuantityZero: boolean | undefined;
  isPartOrderReleased: boolean | undefined;
  isPartOrderCancelled: boolean | undefined;
  isCarrierServiceOptional: boolean | undefined;
  salesOrderTypeId: string | undefined;
  orderStatusReasonTypeId: string[] | undefined;
  createdName: string | undefined;
  createdBy: number | undefined;
  id: string | undefined;

  constructor(data?: IOrderDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.optOutFlag = _data["optOutFlag"];
      this.ohioTdddExemptionFlag = _data["ohioTdddExemptionFlag"];
      this.hcpSignaturePresentFlag = _data["hcpSignaturePresentFlag"];
      this.hcpSignatureStampedFlag = _data["hcpSignatureStampedFlag"];
      this.hcpSignatureMatchFlag = _data["hcpSignatureMatchFlag"];
      this.hcpSignedDatePresentFlag = _data["hcpSignedDatePresentFlag"];
      this.missingHCPSignedDateFlag = _data["missingHCPSignedDateFlag"];
      this.hcpSignatureDateStampedFlag = _data["hcpSignatureDateStampedFlag"];
      this.offeredQtyFlag = _data["offeredQtyFlag"];
      this.hcpSignatureDate = _data["hcpSignatureDate"] ? new Date(_data["hcpSignatureDate"].toString()) : <any>undefined;
      this.orderComment = _data["orderComment"];
      this.srfAdverseEventFlag = _data["srfAdverseEventFlag"];
      this.srfAdverseEventComment = _data["srfAdverseEventComment"];
      this.orderStatusId = _data["orderStatusId"];
      this.orderSourceId = _data["orderSourceId"];
      if (Array.isArray(_data["orderLines"])) {
        this.orderLines = [] as any;
        for (let item of _data["orderLines"])
          this.orderLines.push(OrderLineDto.fromJS(item));
      }
      if (Array.isArray(_data["hcpDispensedOrderLineDtos"])) {
        this.hcpDispensedOrderLineDtos = [] as any;
        for (let item of _data["hcpDispensedOrderLineDtos"])
          this.hcpDispensedOrderLineDtos.push(DispensedOrderLineDto.fromJS(item));
      }
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      if (Array.isArray(_data["formCommentHistory"])) {
        this.formCommentHistory = [] as any;
        for (let item of _data["formCommentHistory"])
          this.formCommentHistory.push(OrderCommentDto.fromJS(item));
      }
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.missingRequestDate = _data["missingRequestDate"];
      this.isDraftSave = _data["isDraftSave"];
      this.isLineItemReleased = _data["isLineItemReleased"];
      if (Array.isArray(_data["associatedOrderLines"])) {
        this.associatedOrderLines = [] as any;
        for (let item of _data["associatedOrderLines"])
          this.associatedOrderLines.push(OrderLineDto.fromJS(item));
      }
      this.orderDeliveryType = _data["orderDeliveryType"];
      this.orderRecievedCutoffTime = _data["orderRecievedCutoffTime"] ? new Date(_data["orderRecievedCutoffTime"].toString()) : <any>undefined;
      if (Array.isArray(_data["acceptableDaysOfDelivery"])) {
        this.acceptableDaysOfDelivery = [] as any;
        for (let item of _data["acceptableDaysOfDelivery"])
          this.acceptableDaysOfDelivery.push(item);
      }
      if (Array.isArray(_data["programDeliverySelectDays"])) {
        this.programDeliverySelectDays = [] as any;
        for (let item of _data["programDeliverySelectDays"])
          this.programDeliverySelectDays.push(item);
      }
      if (Array.isArray(_data["programShipDays"])) {
        this.programShipDays = [] as any;
        for (let item of _data["programShipDays"])
          this.programShipDays.push(item);
      }
      this.turnAroundDays = _data["turnAroundDays"];
      this.desiredDeliveryDate = _data["desiredDeliveryDate"] ? new Date(_data["desiredDeliveryDate"].toString()) : <any>undefined;
      this.actualCarrier = _data["actualCarrier"];
      this.actualFreightCode = _data["actualFreightCode"];
      this.scheduledShipDate = _data["scheduledShipDate"] ? new Date(_data["scheduledShipDate"].toString()) : <any>undefined;
      this.anticipatedLatestDeliveryDate = _data["anticipatedLatestDeliveryDate"] ? new Date(_data["anticipatedLatestDeliveryDate"].toString()) : <any>undefined;
      this.isSelectDayVerificationRequired = _data["isSelectDayVerificationRequired"];
      this.allowNonWorkingDaysIntransit = _data["allowNonWorkingDaysIntransit"];
      this.carrierServiceType = _data["carrierServiceType"] ? CarrierServiceTypeDto.fromJS(_data["carrierServiceType"]) : <any>undefined;
      if (Array.isArray(_data["insufficientInventories"])) {
        this.insufficientInventories = [] as any;
        for (let item of _data["insufficientInventories"])
          this.insufficientInventories.push(InsufficientInventoryValidationDto.fromJS(item));
      }
      this.programOrderFulfillmentDto = _data["programOrderFulfillmentDto"] ? ProgramOrderFulfillmentDto.fromJS(_data["programOrderFulfillmentDto"]) : <any>undefined;
      this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
      this.checkPrentLineItemSplit = _data["checkPrentLineItemSplit"];
      this.somStatusCode = _data["somStatusCode"];
      this.isAllNonRejectedRelease = _data["isAllNonRejectedRelease"];
      this.isCommentRequired = _data["isCommentRequired"];
      this.externalBillingNbr = _data["externalBillingNbr"];
      this.externalNotes = _data["externalNotes"];
      this.paymentMethodClassificationValueId = _data["paymentMethodClassificationValueId"];
      this.autoMitigatePriceCheckEnabled = _data["autoMitigatePriceCheckEnabled"];
      this.isArkrayClient = _data["isArkrayClient"];
      this.isAllAdjustedQuantityZero = _data["isAllAdjustedQuantityZero"];
      this.isAllOnHoldQuantityZero = _data["isAllOnHoldQuantityZero"];
      this.isPartOrderReleased = _data["isPartOrderReleased"];
      this.isPartOrderCancelled = _data["isPartOrderCancelled"];
      this.isCarrierServiceOptional = _data["isCarrierServiceOptional"];
      this.salesOrderTypeId = _data["salesOrderTypeId"];
      if (Array.isArray(_data["orderStatusReasonTypeId"])) {
        this.orderStatusReasonTypeId = [] as any;
        for (let item of _data["orderStatusReasonTypeId"])
          this.orderStatusReasonTypeId.push(item);
      }
      this.createdName = _data["createdName"];
      this.createdBy = _data["createdBy"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OrderDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["optOutFlag"] = this.optOutFlag;
    data["ohioTdddExemptionFlag"] = this.ohioTdddExemptionFlag;
    data["hcpSignaturePresentFlag"] = this.hcpSignaturePresentFlag;
    data["hcpSignatureStampedFlag"] = this.hcpSignatureStampedFlag;
    data["hcpSignatureMatchFlag"] = this.hcpSignatureMatchFlag;
    data["hcpSignedDatePresentFlag"] = this.hcpSignedDatePresentFlag;
    data["missingHCPSignedDateFlag"] = this.missingHCPSignedDateFlag;
    data["hcpSignatureDateStampedFlag"] = this.hcpSignatureDateStampedFlag;
    data["offeredQtyFlag"] = this.offeredQtyFlag;
    data["hcpSignatureDate"] = this.hcpSignatureDate ? this.hcpSignatureDate.toISOString() : <any>undefined;
    data["orderComment"] = this.orderComment;
    data["srfAdverseEventFlag"] = this.srfAdverseEventFlag;
    data["srfAdverseEventComment"] = this.srfAdverseEventComment;
    data["orderStatusId"] = this.orderStatusId;
    data["orderSourceId"] = this.orderSourceId;
    if (Array.isArray(this.orderLines)) {
      data["orderLines"] = [];
      for (let item of this.orderLines)
        data["orderLines"].push(item.toJSON());
    }
    if (Array.isArray(this.hcpDispensedOrderLineDtos)) {
      data["hcpDispensedOrderLineDtos"] = [];
      for (let item of this.hcpDispensedOrderLineDtos)
        data["hcpDispensedOrderLineDtos"].push(item.toJSON());
    }
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    if (Array.isArray(this.formCommentHistory)) {
      data["formCommentHistory"] = [];
      for (let item of this.formCommentHistory)
        data["formCommentHistory"].push(item.toJSON());
    }
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["missingRequestDate"] = this.missingRequestDate;
    data["isDraftSave"] = this.isDraftSave;
    data["isLineItemReleased"] = this.isLineItemReleased;
    if (Array.isArray(this.associatedOrderLines)) {
      data["associatedOrderLines"] = [];
      for (let item of this.associatedOrderLines)
        data["associatedOrderLines"].push(item.toJSON());
    }
    data["orderDeliveryType"] = this.orderDeliveryType;
    data["orderRecievedCutoffTime"] = this.orderRecievedCutoffTime ? this.orderRecievedCutoffTime.toISOString() : <any>undefined;
    if (Array.isArray(this.acceptableDaysOfDelivery)) {
      data["acceptableDaysOfDelivery"] = [];
      for (let item of this.acceptableDaysOfDelivery)
        data["acceptableDaysOfDelivery"].push(item);
    }
    if (Array.isArray(this.programDeliverySelectDays)) {
      data["programDeliverySelectDays"] = [];
      for (let item of this.programDeliverySelectDays)
        data["programDeliverySelectDays"].push(item);
    }
    if (Array.isArray(this.programShipDays)) {
      data["programShipDays"] = [];
      for (let item of this.programShipDays)
        data["programShipDays"].push(item);
    }
    data["turnAroundDays"] = this.turnAroundDays;
    data["desiredDeliveryDate"] = this.desiredDeliveryDate ? this.desiredDeliveryDate.toISOString() : <any>undefined;
    data["actualCarrier"] = this.actualCarrier;
    data["actualFreightCode"] = this.actualFreightCode;
    data["scheduledShipDate"] = this.scheduledShipDate ? this.scheduledShipDate.toISOString() : <any>undefined;
    data["anticipatedLatestDeliveryDate"] = this.anticipatedLatestDeliveryDate ? this.anticipatedLatestDeliveryDate.toISOString() : <any>undefined;
    data["isSelectDayVerificationRequired"] = this.isSelectDayVerificationRequired;
    data["allowNonWorkingDaysIntransit"] = this.allowNonWorkingDaysIntransit;
    data["carrierServiceType"] = this.carrierServiceType ? this.carrierServiceType.toJSON() : <any>undefined;
    if (Array.isArray(this.insufficientInventories)) {
      data["insufficientInventories"] = [];
      for (let item of this.insufficientInventories)
        data["insufficientInventories"].push(item.toJSON());
    }
    data["programOrderFulfillmentDto"] = this.programOrderFulfillmentDto ? this.programOrderFulfillmentDto.toJSON() : <any>undefined;
    data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
    data["checkPrentLineItemSplit"] = this.checkPrentLineItemSplit;
    data["somStatusCode"] = this.somStatusCode;
    data["isAllNonRejectedRelease"] = this.isAllNonRejectedRelease;
    data["isCommentRequired"] = this.isCommentRequired;
    data["externalBillingNbr"] = this.externalBillingNbr;
    data["externalNotes"] = this.externalNotes;
    data["paymentMethodClassificationValueId"] = this.paymentMethodClassificationValueId;
    data["autoMitigatePriceCheckEnabled"] = this.autoMitigatePriceCheckEnabled;
    data["isArkrayClient"] = this.isArkrayClient;
    data["isAllAdjustedQuantityZero"] = this.isAllAdjustedQuantityZero;
    data["isAllOnHoldQuantityZero"] = this.isAllOnHoldQuantityZero;
    data["isPartOrderReleased"] = this.isPartOrderReleased;
    data["isPartOrderCancelled"] = this.isPartOrderCancelled;
    data["isCarrierServiceOptional"] = this.isCarrierServiceOptional;
    data["salesOrderTypeId"] = this.salesOrderTypeId;
    if (Array.isArray(this.orderStatusReasonTypeId)) {
      data["orderStatusReasonTypeId"] = [];
      for (let item of this.orderStatusReasonTypeId)
        data["orderStatusReasonTypeId"].push(item);
    }
    data["createdName"] = this.createdName;
    data["createdBy"] = this.createdBy;
    data["id"] = this.id;
    data["createdName"] = this.createdName;
    data["createdBy"] = this.createdBy;
    return data;
  }

  clone(): OrderDetailsDto {
    const json = this.toJSON();
    let result = new OrderDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IOrderDetailsDto {
  optOutFlag: boolean | undefined;
  ohioTdddExemptionFlag: boolean | undefined;
  hcpSignaturePresentFlag: boolean | undefined;
  hcpSignatureStampedFlag: boolean | undefined;
  hcpSignatureMatchFlag: boolean | undefined;
  hcpSignedDatePresentFlag: boolean | undefined;
  missingHCPSignedDateFlag: boolean | undefined;
  hcpSignatureDateStampedFlag: boolean | undefined;
  offeredQtyFlag: boolean | undefined;
  hcpSignatureDate: Date | undefined;
  orderComment: string | undefined;
  srfAdverseEventFlag: boolean | undefined;
  srfAdverseEventComment: string | undefined;
  orderStatusId: string | undefined;
  orderSourceId: string | undefined;
  orderLines: OrderLineDto[] | undefined;
  hcpDispensedOrderLineDtos: DispensedOrderLineDto[] | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  formCommentHistory: OrderCommentDto[] | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  isDraftSave: boolean | undefined;
  isLineItemReleased: boolean | undefined;
  associatedOrderLines: OrderLineDto[] | undefined;
  orderDeliveryType: OrderDetailsDtoOrderDeliveryType | undefined;
  orderRecievedCutoffTime: Date | undefined;
  acceptableDaysOfDelivery: AcceptableDaysOfDelivery[] | undefined;
  programDeliverySelectDays: ProgramDeliverySelectDays[] | undefined;
  programShipDays: ProgramShipDays[] | undefined;
  turnAroundDays: number | undefined;
  desiredDeliveryDate: Date | undefined;
  actualCarrier: string | undefined;
  actualFreightCode: string | undefined;
  scheduledShipDate: Date | undefined;
  anticipatedLatestDeliveryDate: Date | undefined;
  isSelectDayVerificationRequired: boolean | undefined;
  allowNonWorkingDaysIntransit: boolean | undefined;
  carrierServiceType: CarrierServiceTypeDto | undefined;
  insufficientInventories: InsufficientInventoryValidationDto[] | undefined;
  programOrderFulfillmentDto: ProgramOrderFulfillmentDto | undefined;
  orderDate: Date | undefined;
  checkPrentLineItemSplit: boolean | undefined;
  somStatusCode: string | undefined;
  isAllNonRejectedRelease: boolean | undefined;
  isCommentRequired: boolean | undefined;
  externalBillingNbr: string | undefined;
  externalNotes: string | undefined;
  paymentMethodClassificationValueId: string | undefined;
  autoMitigatePriceCheckEnabled: boolean | undefined;
  isArkrayClient: boolean | undefined;
  isAllAdjustedQuantityZero: boolean | undefined;
  isAllOnHoldQuantityZero: boolean | undefined;
  isPartOrderReleased: boolean | undefined;
  isPartOrderCancelled: boolean | undefined;
  isCarrierServiceOptional: boolean | undefined;
  salesOrderTypeId: string | undefined;
  orderStatusReasonTypeId: string[] | undefined;
  createdName: string | undefined;
  createdBy: number | undefined;
  id: string | undefined;
}



export class DispensedOrderLineDto implements IDispensedOrderLineDto {
  hcpId: string | undefined;
  hcpOrderLines: HcpOrderLineDto[] | undefined;
  id: string | undefined;

  constructor(data?: IDispensedOrderLineDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hcpId = _data["hcpId"];
      if (Array.isArray(_data["hcpOrderLines"])) {
        this.hcpOrderLines = [] as any;
        for (let item of _data["hcpOrderLines"])
          this.hcpOrderLines.push(HcpOrderLineDto.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): DispensedOrderLineDto {
    data = typeof data === 'object' ? data : {};
    let result = new DispensedOrderLineDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hcpId"] = this.hcpId;
    if (Array.isArray(this.hcpOrderLines)) {
      data["hcpOrderLines"] = [];
      for (let item of this.hcpOrderLines)
        data["hcpOrderLines"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }

  clone(): DispensedOrderLineDto {
    const json = this.toJSON();
    let result = new DispensedOrderLineDto();
    result.init(json);
    return result;
  }
}

export interface IDispensedOrderLineDto {
  hcpId: string | undefined;
  hcpOrderLines: HcpOrderLineDto[] | undefined;
  id: string | undefined;
}

export class CarrierServiceTypeDto implements ICarrierServiceTypeDto {
  carrierServiceTypeCode: string | undefined;
  carrierServiceTypeName: string | undefined;
  carrierId: string | undefined;
  maxDaysToDeliver: number | undefined;
  names: LocalizedValue[] | undefined;
  name: string | undefined;
  code: string | undefined;
  id: string | undefined;

  constructor(data?: ICarrierServiceTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.carrierServiceTypeCode = _data["carrierServiceTypeCode"];
      this.carrierServiceTypeName = _data["carrierServiceTypeName"];
      this.carrierId = _data["carrierId"];
      this.maxDaysToDeliver = _data["maxDaysToDeliver"];
      if (Array.isArray(_data["names"])) {
        this.names = [] as any;
        for (let item of _data["names"])
          this.names.push(LocalizedValue.fromJS(item));
      }
      this.name = _data["name"];
      this.code = _data["code"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): CarrierServiceTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new CarrierServiceTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["carrierServiceTypeCode"] = this.carrierServiceTypeCode;
    data["carrierServiceTypeName"] = this.carrierServiceTypeName;
    data["carrierId"] = this.carrierId;
    data["maxDaysToDeliver"] = this.maxDaysToDeliver;
    if (Array.isArray(this.names)) {
      data["names"] = [];
      for (let item of this.names)
        data["names"].push(item.toJSON());
    }
    data["name"] = this.name;
    data["code"] = this.code;
    data["id"] = this.id;
    return data;
  }

  clone(): CarrierServiceTypeDto {
    const json = this.toJSON();
    let result = new CarrierServiceTypeDto();
    result.init(json);
    return result;
  }
}

export interface ICarrierServiceTypeDto {
  carrierServiceTypeCode: string | undefined;
  carrierServiceTypeName: string | undefined;
  carrierId: string | undefined;
  maxDaysToDeliver: number | undefined;
  names: LocalizedValue[] | undefined;
  name: string | undefined;
  code: string | undefined;
  id: string | undefined;
}

export class ProgramOrderFulfillmentDto implements IProgramOrderFulfillmentDto {
  dtpProgramConfigurationId: string | undefined;
  orderProcessableFlag: boolean | undefined;
  orderReceivedCutOffTime: Date | undefined;
  splitOrderCarrierServiceTypeId: string | undefined;
  orderTurnaroundDays: number | undefined;
  hasShipAloneProductsFlag: boolean | undefined;
  productTypes: DtpProgramConfigurationProductTypeDto[] | undefined;
  /** Is there at least one product that has "Is Select Day Shipping required?" set to true? */
  hasSelectDayShippingRequiredProduct: boolean | undefined;
  splitOrderCarrierId: string | undefined;
  isAllowedShipDaysMondayFlag: boolean | undefined;
  isAllowedShipDaysTuesdayFlag: boolean | undefined;
  isAllowedShipDaysWednesdayFlag: boolean | undefined;
  isAllowedShipDaysThursdayFlag: boolean | undefined;
  isAllowedShipDaysFridayFlag: boolean | undefined;
  applicableShippingDayMondayFlag: boolean | undefined;
  applicableShippingDayTuesdayFlag: boolean | undefined;
  applicableShippingDayWednesdayFlag: boolean | undefined;
  applicableShippingDayThursdayFlag: boolean | undefined;
  applicableShippingDayFridayFlag: boolean | undefined;
  tenantId: number | undefined;
  isCarrierServiceOptional: boolean | undefined;

  constructor(data?: IProgramOrderFulfillmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dtpProgramConfigurationId = _data["dtpProgramConfigurationId"];
      this.orderProcessableFlag = _data["orderProcessableFlag"];
      this.orderReceivedCutOffTime = _data["orderReceivedCutOffTime"] ? new Date(_data["orderReceivedCutOffTime"].toString()) : <any>undefined;
      this.splitOrderCarrierServiceTypeId = _data["splitOrderCarrierServiceTypeId"];
      this.orderTurnaroundDays = _data["orderTurnaroundDays"];
      this.hasShipAloneProductsFlag = _data["hasShipAloneProductsFlag"];
      if (Array.isArray(_data["productTypes"])) {
        this.productTypes = [] as any;
        for (let item of _data["productTypes"])
          this.productTypes.push(DtpProgramConfigurationProductTypeDto.fromJS(item));
      }
      this.hasSelectDayShippingRequiredProduct = _data["hasSelectDayShippingRequiredProduct"];
      this.splitOrderCarrierId = _data["splitOrderCarrierId"];
      this.isAllowedShipDaysMondayFlag = _data["isAllowedShipDaysMondayFlag"];
      this.isAllowedShipDaysTuesdayFlag = _data["isAllowedShipDaysTuesdayFlag"];
      this.isAllowedShipDaysWednesdayFlag = _data["isAllowedShipDaysWednesdayFlag"];
      this.isAllowedShipDaysThursdayFlag = _data["isAllowedShipDaysThursdayFlag"];
      this.isAllowedShipDaysFridayFlag = _data["isAllowedShipDaysFridayFlag"];
      this.applicableShippingDayMondayFlag = _data["applicableShippingDayMondayFlag"];
      this.applicableShippingDayTuesdayFlag = _data["applicableShippingDayTuesdayFlag"];
      this.applicableShippingDayWednesdayFlag = _data["applicableShippingDayWednesdayFlag"];
      this.applicableShippingDayThursdayFlag = _data["applicableShippingDayThursdayFlag"];
      this.applicableShippingDayFridayFlag = _data["applicableShippingDayFridayFlag"];
      this.tenantId = _data["tenantId"];
      this.isCarrierServiceOptional = _data["isCarrierServiceOptional"];
    }
  }

  static fromJS(data: any): ProgramOrderFulfillmentDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramOrderFulfillmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dtpProgramConfigurationId"] = this.dtpProgramConfigurationId;
    data["orderProcessableFlag"] = this.orderProcessableFlag;
    data["orderReceivedCutOffTime"] = this.orderReceivedCutOffTime ? this.orderReceivedCutOffTime.toISOString() : <any>undefined;
    data["splitOrderCarrierServiceTypeId"] = this.splitOrderCarrierServiceTypeId;
    data["orderTurnaroundDays"] = this.orderTurnaroundDays;
    data["hasShipAloneProductsFlag"] = this.hasShipAloneProductsFlag;
    if (Array.isArray(this.productTypes)) {
      data["productTypes"] = [];
      for (let item of this.productTypes)
        data["productTypes"].push(item.toJSON());
    }
    data["hasSelectDayShippingRequiredProduct"] = this.hasSelectDayShippingRequiredProduct;
    data["splitOrderCarrierId"] = this.splitOrderCarrierId;
    data["isAllowedShipDaysMondayFlag"] = this.isAllowedShipDaysMondayFlag;
    data["isAllowedShipDaysTuesdayFlag"] = this.isAllowedShipDaysTuesdayFlag;
    data["isAllowedShipDaysWednesdayFlag"] = this.isAllowedShipDaysWednesdayFlag;
    data["isAllowedShipDaysThursdayFlag"] = this.isAllowedShipDaysThursdayFlag;
    data["isAllowedShipDaysFridayFlag"] = this.isAllowedShipDaysFridayFlag;
    data["applicableShippingDayMondayFlag"] = this.applicableShippingDayMondayFlag;
    data["applicableShippingDayTuesdayFlag"] = this.applicableShippingDayTuesdayFlag;
    data["applicableShippingDayWednesdayFlag"] = this.applicableShippingDayWednesdayFlag;
    data["applicableShippingDayThursdayFlag"] = this.applicableShippingDayThursdayFlag;
    data["applicableShippingDayFridayFlag"] = this.applicableShippingDayFridayFlag;
    data["tenantId"] = this.tenantId;
    data["isCarrierServiceOptional"] = this.isCarrierServiceOptional;
    return data;
  }

  clone(): ProgramOrderFulfillmentDto {
    const json = this.toJSON();
    let result = new ProgramOrderFulfillmentDto();
    result.init(json);
    return result;
  }
}

export interface IProgramOrderFulfillmentDto {
  dtpProgramConfigurationId: string | undefined;
  orderProcessableFlag: boolean | undefined;
  orderReceivedCutOffTime: Date | undefined;
  splitOrderCarrierServiceTypeId: string | undefined;
  orderTurnaroundDays: number | undefined;
  hasShipAloneProductsFlag: boolean | undefined;
  productTypes: DtpProgramConfigurationProductTypeDto[] | undefined;
  /** Is there at least one product that has "Is Select Day Shipping required?" set to true? */
  hasSelectDayShippingRequiredProduct: boolean | undefined;
  splitOrderCarrierId: string | undefined;
  isAllowedShipDaysMondayFlag: boolean | undefined;
  isAllowedShipDaysTuesdayFlag: boolean | undefined;
  isAllowedShipDaysWednesdayFlag: boolean | undefined;
  isAllowedShipDaysThursdayFlag: boolean | undefined;
  isAllowedShipDaysFridayFlag: boolean | undefined;
  applicableShippingDayMondayFlag: boolean | undefined;
  applicableShippingDayTuesdayFlag: boolean | undefined;
  applicableShippingDayWednesdayFlag: boolean | undefined;
  applicableShippingDayThursdayFlag: boolean | undefined;
  applicableShippingDayFridayFlag: boolean | undefined;
  tenantId: number | undefined;
  isCarrierServiceOptional: boolean | undefined;
}

export class HcpOrderLineDto implements IHcpOrderLineDto {
  orderId: string | undefined;
  productId: string | undefined;
  distributionUoMClassificationValueId: string | undefined;
  orderLineNbr: number | undefined;
  wmsProductId: string | undefined;
  wmsProductName: string | undefined;
  /** Gets or sets the qty of orderItem dispensed by Hcp */
  dispensedQty: number | undefined;
  /** Gets or sets the from date the item dispensed 
Applicable to FreeGoods. */
  dispensedFrom: Date | undefined;
  /** Gets or sets the till dates  the item  is dispensed date 
Applicable to FreeGoods. */
  dispensedTill: Date | undefined;
  /** Gets or sets the Hcp first name */
  hcpFirstName: string | undefined;
  /** Gets or sets the Hcp middle name */
  hcpMiddleName: string | undefined;
  /** Gets or sets the Hcp last name */
  hcpLastName: string | undefined;
  /** Gets or sets the HcpId */
  hcpId: string | undefined;
  id: string | undefined;

  constructor(data?: IHcpOrderLineDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.productId = _data["productId"];
      this.distributionUoMClassificationValueId = _data["distributionUoMClassificationValueId"];
      this.orderLineNbr = _data["orderLineNbr"];
      this.wmsProductId = _data["wmsProductId"];
      this.wmsProductName = _data["wmsProductName"];
      this.dispensedQty = _data["dispensedQty"];
      this.dispensedFrom = _data["dispensedFrom"] ? new Date(_data["dispensedFrom"].toString()) : <any>undefined;
      this.dispensedTill = _data["dispensedTill"] ? new Date(_data["dispensedTill"].toString()) : <any>undefined;
      this.hcpFirstName = _data["hcpFirstName"];
      this.hcpMiddleName = _data["hcpMiddleName"];
      this.hcpLastName = _data["hcpLastName"];
      this.hcpId = _data["hcpId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): HcpOrderLineDto {
    data = typeof data === 'object' ? data : {};
    let result = new HcpOrderLineDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["productId"] = this.productId;
    data["distributionUoMClassificationValueId"] = this.distributionUoMClassificationValueId;
    data["orderLineNbr"] = this.orderLineNbr;
    data["wmsProductId"] = this.wmsProductId;
    data["wmsProductName"] = this.wmsProductName;
    data["dispensedQty"] = this.dispensedQty;
    data["dispensedFrom"] = this.dispensedFrom ? this.dispensedFrom.toISOString() : <any>undefined;
    data["dispensedTill"] = this.dispensedTill ? this.dispensedTill.toISOString() : <any>undefined;
    data["hcpFirstName"] = this.hcpFirstName;
    data["hcpMiddleName"] = this.hcpMiddleName;
    data["hcpLastName"] = this.hcpLastName;
    data["hcpId"] = this.hcpId;
    data["id"] = this.id;
    return data;
  }

  clone(): HcpOrderLineDto {
    const json = this.toJSON();
    let result = new HcpOrderLineDto();
    result.init(json);
    return result;
  }
}

export interface IHcpOrderLineDto {
  orderId: string | undefined;
  productId: string | undefined;
  distributionUoMClassificationValueId: string | undefined;
  orderLineNbr: number | undefined;
  wmsProductId: string | undefined;
  wmsProductName: string | undefined;
  /** Gets or sets the qty of orderItem dispensed by Hcp */
  dispensedQty: number | undefined;
  /** Gets or sets the from date the item dispensed 
Applicable to FreeGoods. */
  dispensedFrom: Date | undefined;
  /** Gets or sets the till dates  the item  is dispensed date 
Applicable to FreeGoods. */
  dispensedTill: Date | undefined;
  /** Gets or sets the Hcp first name */
  hcpFirstName: string | undefined;
  /** Gets or sets the Hcp middle name */
  hcpMiddleName: string | undefined;
  /** Gets or sets the Hcp last name */
  hcpLastName: string | undefined;
  /** Gets or sets the HcpId */
  hcpId: string | undefined;
  id: string | undefined;
}

export class DtpProgramConfigurationProductTypeDto implements IDtpProgramConfigurationProductTypeDto {
  id: string | undefined;
  productTypeId: string | undefined;
  carrierServiceTypeId: string | undefined;
  priority: number | undefined;
  carrierId: string | undefined;
  secondaryCarrierServiceTypeId: string | undefined;
  secondaryCarrierServiceStateCodes: string[] | undefined;
  carrierServiceTypes: ProgramReferenceDataDto[] | undefined;

  constructor(data?: IDtpProgramConfigurationProductTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.productTypeId = _data["productTypeId"];
      this.carrierServiceTypeId = _data["carrierServiceTypeId"];
      this.priority = _data["priority"];
      this.carrierId = _data["carrierId"];
      this.secondaryCarrierServiceTypeId = _data["secondaryCarrierServiceTypeId"];
      if (Array.isArray(_data["secondaryCarrierServiceStateCodes"])) {
        this.secondaryCarrierServiceStateCodes = [] as any;
        for (let item of _data["secondaryCarrierServiceStateCodes"])
          this.secondaryCarrierServiceStateCodes.push(item);
      }
      if (Array.isArray(_data["carrierServiceTypes"])) {
        this.carrierServiceTypes = [] as any;
        for (let item of _data["carrierServiceTypes"])
          this.carrierServiceTypes.push(ProgramReferenceDataDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DtpProgramConfigurationProductTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new DtpProgramConfigurationProductTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["productTypeId"] = this.productTypeId;
    data["carrierServiceTypeId"] = this.carrierServiceTypeId;
    data["priority"] = this.priority;
    data["carrierId"] = this.carrierId;
    data["secondaryCarrierServiceTypeId"] = this.secondaryCarrierServiceTypeId;
    if (Array.isArray(this.secondaryCarrierServiceStateCodes)) {
      data["secondaryCarrierServiceStateCodes"] = [];
      for (let item of this.secondaryCarrierServiceStateCodes)
        data["secondaryCarrierServiceStateCodes"].push(item);
    }
    if (Array.isArray(this.carrierServiceTypes)) {
      data["carrierServiceTypes"] = [];
      for (let item of this.carrierServiceTypes)
        data["carrierServiceTypes"].push(item.toJSON());
    }
    return data;
  }

  clone(): DtpProgramConfigurationProductTypeDto {
    const json = this.toJSON();
    let result = new DtpProgramConfigurationProductTypeDto();
    result.init(json);
    return result;
  }
}

export interface IDtpProgramConfigurationProductTypeDto {
  id: string | undefined;
  productTypeId: string | undefined;
  carrierServiceTypeId: string | undefined;
  priority: number | undefined;
  carrierId: string | undefined;
  secondaryCarrierServiceTypeId: string | undefined;
  secondaryCarrierServiceStateCodes: string[] | undefined;
  carrierServiceTypes: ProgramReferenceDataDto[] | undefined;
}

export class ProgramReferenceDataDto implements IProgramReferenceDataDto {
  id: string | undefined;
  names: LocalizedValue[] | undefined;

  constructor(data?: IProgramReferenceDataDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      if (Array.isArray(_data["names"])) {
        this.names = [] as any;
        for (let item of _data["names"])
          this.names.push(LocalizedValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProgramReferenceDataDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramReferenceDataDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    if (Array.isArray(this.names)) {
      data["names"] = [];
      for (let item of this.names)
        data["names"].push(item.toJSON());
    }
    return data;
  }

  clone(): ProgramReferenceDataDto {
    const json = this.toJSON();
    let result = new ProgramReferenceDataDto();
    result.init(json);
    return result;
  }
}

export interface IProgramReferenceDataDto {
  id: string | undefined;
  names: LocalizedValue[] | undefined;
}

export class AjaxResponseOfListOfOnHoldHistoryDto implements IAjaxResponseOfListOfOnHoldHistoryDto {
  result: OnHoldHistoryDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfListOfOnHoldHistoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result.push(OnHoldHistoryDto.fromJS(item));
      }
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfListOfOnHoldHistoryDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfListOfOnHoldHistoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfListOfOnHoldHistoryDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfListOfOnHoldHistoryDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfListOfOnHoldHistoryDto {
  result: OnHoldHistoryDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class OnHoldHistoryDto implements IOnHoldHistoryDto {
  creationTime: Date | undefined;
  modifiedBy: number | undefined;
  orderStatusType: string | undefined;
  comment: string | undefined;
  orderStatusId: string | undefined;
  orderStatusHistoryReasons: OrderReasonTypesDto[] | undefined;
  id: string | undefined;

  constructor(data?: IOnHoldHistoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.modifiedBy = _data["modifiedBy"];
      this.orderStatusType = _data["orderStatusType"];
      this.comment = _data["comment"];
      this.orderStatusId = _data["orderStatusId"];
      if (Array.isArray(_data["orderStatusHistoryReasons"])) {
        this.orderStatusHistoryReasons = [] as any;
        for (let item of _data["orderStatusHistoryReasons"])
          this.orderStatusHistoryReasons.push(OrderReasonTypesDto.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): OnHoldHistoryDto {
    data = typeof data === 'object' ? data : {};
    let result = new OnHoldHistoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["modifiedBy"] = this.modifiedBy;
    data["orderStatusType"] = this.orderStatusType;
    data["comment"] = this.comment;
    data["orderStatusId"] = this.orderStatusId;
    if (Array.isArray(this.orderStatusHistoryReasons)) {
      data["orderStatusHistoryReasons"] = [];
      for (let item of this.orderStatusHistoryReasons)
        data["orderStatusHistoryReasons"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }

  clone(): OnHoldHistoryDto {
    const json = this.toJSON();
    let result = new OnHoldHistoryDto();
    result.init(json);
    return result;
  }
}

export interface IOnHoldHistoryDto {
  creationTime: Date | undefined;
  modifiedBy: number | undefined;
  orderStatusType: string | undefined;
  comment: string | undefined;
  orderStatusId: string | undefined;
  orderStatusHistoryReasons: OrderReasonTypesDto[] | undefined;
  id: string | undefined;
}

export class OrderReasonTypesDto implements IOrderReasonTypesDto {
  orderStatusReasonTypeId: string | undefined;
  orderStatusReasonType: string | undefined;
  creationTime: Date | undefined;
  modifiedBy: number | undefined;

  constructor(data?: IOrderReasonTypesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderStatusReasonTypeId = _data["orderStatusReasonTypeId"];
      this.orderStatusReasonType = _data["orderStatusReasonType"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      this.modifiedBy = _data["modifiedBy"];
    }
  }

  static fromJS(data: any): OrderReasonTypesDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderReasonTypesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderStatusReasonTypeId"] = this.orderStatusReasonTypeId;
    data["orderStatusReasonType"] = this.orderStatusReasonType;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data["modifiedBy"] = this.modifiedBy;
    return data;
  }

  clone(): OrderReasonTypesDto {
    const json = this.toJSON();
    let result = new OrderReasonTypesDto();
    result.init(json);
    return result;
  }
}

export interface IOrderReasonTypesDto {
  orderStatusReasonTypeId: string | undefined;
  orderStatusReasonType: string | undefined;
  creationTime: Date | undefined;
  modifiedBy: number | undefined;
}

export class ProductLotInventoryValidationDto implements IProductLotInventoryValidationDto {
  tenantId: number | undefined;
  orderId: string | undefined;
  lineItems: LineItemInventoryDto[] | undefined;

  constructor(data?: IProductLotInventoryValidationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data["tenantId"];
      this.orderId = _data["orderId"];
      if (Array.isArray(_data["lineItems"])) {
        this.lineItems = [] as any;
        for (let item of _data["lineItems"])
          this.lineItems.push(LineItemInventoryDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProductLotInventoryValidationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProductLotInventoryValidationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["tenantId"] = this.tenantId;
    data["orderId"] = this.orderId;
    if (Array.isArray(this.lineItems)) {
      data["lineItems"] = [];
      for (let item of this.lineItems)
        data["lineItems"].push(item.toJSON());
    }
    return data;
  }

  clone(): ProductLotInventoryValidationDto {
    const json = this.toJSON();
    let result = new ProductLotInventoryValidationDto();
    result.init(json);
    return result;
  }
}

export interface IProductLotInventoryValidationDto {
  tenantId: number | undefined;
  orderId: string | undefined;
  lineItems: LineItemInventoryDto[] | undefined;
}

export class LineItemInventoryDto implements ILineItemInventoryDto {
  id: string | undefined;
  productId: string | undefined;
  productCode: string | undefined;
  orderQty: number | undefined;
  customOrderType: string | undefined;
  customOrderValue: string | undefined;
  isValid: boolean | undefined;
  errorMsg: string | undefined;
  adjustedOrderQty: number | undefined;

  constructor(data?: ILineItemInventoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.productId = _data["productId"];
      this.productCode = _data["productCode"];
      this.orderQty = _data["orderQty"];
      this.customOrderType = _data["customOrderType"];
      this.customOrderValue = _data["customOrderValue"];
      this.isValid = _data["isValid"];
      this.errorMsg = _data["errorMsg"];
      this.adjustedOrderQty = _data["adjustedOrderQty"];
    }
  }

  static fromJS(data: any): LineItemInventoryDto {
    data = typeof data === 'object' ? data : {};
    let result = new LineItemInventoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["productId"] = this.productId;
    data["productCode"] = this.productCode;
    data["orderQty"] = this.orderQty;
    data["customOrderType"] = this.customOrderType;
    data["customOrderValue"] = this.customOrderValue;
    data["isValid"] = this.isValid;
    data["errorMsg"] = this.errorMsg;
    data["adjustedOrderQty"] = this.adjustedOrderQty;
    return data;
  }

  clone(): LineItemInventoryDto {
    const json = this.toJSON();
    let result = new LineItemInventoryDto();
    result.init(json);
    return result;
  }
}

export interface ILineItemInventoryDto {
  id: string | undefined;
  productId: string | undefined;
  productCode: string | undefined;
  orderQty: number | undefined;
  adjustedOrderQty: number | undefined;
  customOrderType: string | undefined;
  customOrderValue: string | undefined;
  isValid: boolean | undefined;
  errorMsg: string | undefined;
}

export class AjaxResponseOfProductLotInventoryValidationDto implements IAjaxResponseOfProductLotInventoryValidationDto {
  result: ProductLotInventoryValidationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfProductLotInventoryValidationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? ProductLotInventoryValidationDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfProductLotInventoryValidationDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfProductLotInventoryValidationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfProductLotInventoryValidationDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfProductLotInventoryValidationDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfProductLotInventoryValidationDto {
  result: ProductLotInventoryValidationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class AjaxResponseOfCancelOrderRequestStatusDto implements IAjaxResponseOfCancelOrderRequestStatusDto {
  result: CancelOrderRequestStatusDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfCancelOrderRequestStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? CancelOrderRequestStatusDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfCancelOrderRequestStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfCancelOrderRequestStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfCancelOrderRequestStatusDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfCancelOrderRequestStatusDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfCancelOrderRequestStatusDto {
  result: CancelOrderRequestStatusDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class CancelOrderRequestStatusDto implements ICancelOrderRequestStatusDto {
  orderId: string | undefined;
  requestedTimestamp: Date | undefined;

  constructor(data?: ICancelOrderRequestStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.requestedTimestamp = _data["requestedTimestamp"] ? new Date(_data["requestedTimestamp"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): CancelOrderRequestStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new CancelOrderRequestStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["requestedTimestamp"] = this.requestedTimestamp ? this.requestedTimestamp.toISOString() : <any>undefined;
    return data;
  }

  clone(): CancelOrderRequestStatusDto {
    const json = this.toJSON();
    let result = new CancelOrderRequestStatusDto();
    result.init(json);
    return result;
  }
}

export interface ICancelOrderRequestStatusDto {
  orderId: string | undefined;
  requestedTimestamp: Date | undefined;
}

export class CancelOrderRequestDto implements ICancelOrderRequestDto {
  orderId: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  skipLockOrderCheck: boolean | undefined;

  constructor(data?: ICancelOrderRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.skipLockOrderCheck = _data["skipLockOrderCheck"];
    }
  }

  static fromJS(data: any): CancelOrderRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new CancelOrderRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["skipLockOrderCheck"] = this.skipLockOrderCheck;
    return data;
  }

  clone(): CancelOrderRequestDto {
    const json = this.toJSON();
    let result = new CancelOrderRequestDto();
    result.init(json);
    return result;
  }
}

export interface ICancelOrderRequestDto {
  orderId: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  skipLockOrderCheck: boolean | undefined;
}

export class CancelOrderInSamplicityRequestDto implements ICancelOrderInSamplicityRequestDto {
  orderId: string | undefined;
  commentText: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  orderCancellationReasonClassificationValueId: string | undefined;

  constructor(data?: ICancelOrderInSamplicityRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.commentText = _data["commentText"];
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.orderCancellationReasonClassificationValueId = _data["orderCancellationReasonClassificationValueId"];
    }
  }

  static fromJS(data: any): CancelOrderInSamplicityRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new CancelOrderInSamplicityRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["commentText"] = this.commentText;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["orderCancellationReasonClassificationValueId"] = this.orderCancellationReasonClassificationValueId;
    return data;
  }

  clone(): CancelOrderInSamplicityRequestDto {
    const json = this.toJSON();
    let result = new CancelOrderInSamplicityRequestDto();
    result.init(json);
    return result;
  }
}

export interface ICancelOrderInSamplicityRequestDto {
  orderId: string | undefined;
  commentText: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  orderCancellationReasonClassificationValueId: string | undefined;
}

export class AjaxResponseOfCancelOrderInSamplicityResultDto implements IAjaxResponseOfCancelOrderInSamplicityResultDto {
  result: CancelOrderInSamplicityResultDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfCancelOrderInSamplicityResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? CancelOrderInSamplicityResultDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfCancelOrderInSamplicityResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfCancelOrderInSamplicityResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfCancelOrderInSamplicityResultDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfCancelOrderInSamplicityResultDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfCancelOrderInSamplicityResultDto {
  result: CancelOrderInSamplicityResultDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class CancelOrderInSamplicityResultDto implements ICancelOrderInSamplicityResultDto {
  orderId: string | undefined;
  orderNumber: string | undefined;
  orderStatusId: string | undefined;
  isSuccessfullyCancelled: boolean | undefined;
  cancellationFailureReasonText: string | undefined;

  constructor(data?: ICancelOrderInSamplicityResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderNumber = _data["orderNumber"];
      this.orderStatusId = _data["orderStatusId"];
      this.isSuccessfullyCancelled = _data["isSuccessfullyCancelled"];
      this.cancellationFailureReasonText = _data["cancellationFailureReasonText"];
    }
  }

  static fromJS(data: any): CancelOrderInSamplicityResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new CancelOrderInSamplicityResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderNumber"] = this.orderNumber;
    data["orderStatusId"] = this.orderStatusId;
    data["isSuccessfullyCancelled"] = this.isSuccessfullyCancelled;
    data["cancellationFailureReasonText"] = this.cancellationFailureReasonText;
    return data;
  }

  clone(): CancelOrderInSamplicityResultDto {
    const json = this.toJSON();
    let result = new CancelOrderInSamplicityResultDto();
    result.init(json);
    return result;
  }
}

export interface ICancelOrderInSamplicityResultDto {
  orderId: string | undefined;
  orderNumber: string | undefined;
  orderStatusId: string | undefined;
  isSuccessfullyCancelled: boolean | undefined;
  cancellationFailureReasonText: string | undefined;
}

export class BulkCancelOrderInSamplicityRequestDto implements IBulkCancelOrderInSamplicityRequestDto {
  orderIds: string[] | undefined;
  commentText: string | undefined;
  orderCancellationReasonClassificationValueId: string | undefined;

  constructor(data?: IBulkCancelOrderInSamplicityRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["orderIds"])) {
        this.orderIds = [] as any;
        for (let item of _data["orderIds"])
          this.orderIds.push(item);
      }
      this.commentText = _data["commentText"];
      this.orderCancellationReasonClassificationValueId = _data["orderCancellationReasonClassificationValueId"];
    }
  }

  static fromJS(data: any): BulkCancelOrderInSamplicityRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new BulkCancelOrderInSamplicityRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.orderIds)) {
      data["orderIds"] = [];
      for (let item of this.orderIds)
        data["orderIds"].push(item);
    }
    data["commentText"] = this.commentText;
    data["orderCancellationReasonClassificationValueId"] = this.orderCancellationReasonClassificationValueId;
    return data;
  }

  clone(): BulkCancelOrderInSamplicityRequestDto {
    const json = this.toJSON();
    let result = new BulkCancelOrderInSamplicityRequestDto();
    result.init(json);
    return result;
  }
}

export interface IBulkCancelOrderInSamplicityRequestDto {
  orderIds: string[] | undefined;
  commentText: string | undefined;
  orderCancellationReasonClassificationValueId: string | undefined;
}

export class AjaxResponseOfBulkCancelOrderInSamplicityResponseDto implements IAjaxResponseOfBulkCancelOrderInSamplicityResponseDto {
  result: BulkCancelOrderInSamplicityResponseDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfBulkCancelOrderInSamplicityResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? BulkCancelOrderInSamplicityResponseDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfBulkCancelOrderInSamplicityResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfBulkCancelOrderInSamplicityResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfBulkCancelOrderInSamplicityResponseDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfBulkCancelOrderInSamplicityResponseDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfBulkCancelOrderInSamplicityResponseDto {
  result: BulkCancelOrderInSamplicityResponseDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class BulkCancelOrderInSamplicityResponseDto implements IBulkCancelOrderInSamplicityResponseDto {
  selectedOrderCount: number | undefined;
  cancelResults: CancelOrderInSamplicityResultDto[] | undefined;

  constructor(data?: IBulkCancelOrderInSamplicityResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.selectedOrderCount = _data["selectedOrderCount"];
      if (Array.isArray(_data["cancelResults"])) {
        this.cancelResults = [] as any;
        for (let item of _data["cancelResults"])
          this.cancelResults.push(CancelOrderInSamplicityResultDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BulkCancelOrderInSamplicityResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new BulkCancelOrderInSamplicityResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["selectedOrderCount"] = this.selectedOrderCount;
    if (Array.isArray(this.cancelResults)) {
      data["cancelResults"] = [];
      for (let item of this.cancelResults)
        data["cancelResults"].push(item.toJSON());
    }
    return data;
  }

  clone(): BulkCancelOrderInSamplicityResponseDto {
    const json = this.toJSON();
    let result = new BulkCancelOrderInSamplicityResponseDto();
    result.init(json);
    return result;
  }
}

export interface IBulkCancelOrderInSamplicityResponseDto {
  selectedOrderCount: number | undefined;
  cancelResults: CancelOrderInSamplicityResultDto[] | undefined;
}

export class SelectDayVerificationDto implements ISelectDayVerificationDto {
  desiredDeliveryDate: Date | undefined;
  /** Gets or set the flag that requestor is reached. */
  requestorReached: boolean | undefined;
  comment: OrderCommentDto | undefined;
  orderId: string | undefined;
  selectableCalendarDays: { [key: string]: boolean; } | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  institutionFlag: boolean | undefined;
  repDrivenFlag: boolean | undefined;
  orderStatusId: string | undefined;
  orderSourceId: string | undefined;
  originalSalesRep: OrderSalesRepDetailsDto | undefined;
  currentSalesRep: OrderSalesRepDetailsDto | undefined;
  requestorHcpDetails: OrderHcpDetailsDto | undefined;
  recipientHcpDetails: OrderHcpDetailsDto | undefined;
  shippingAddress: ShippingAddressDto | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  advancedEditFlag: boolean | undefined;
  orderTypeClassificationValueId: string | undefined;
  customerName: string | undefined;
  customerAccountNbr: string | undefined;
  customerType: string | undefined;
  /** Program moduleId. */
  programModuleId: string | undefined;
  patientOrder: PatientOrderDto | undefined;
  /** Gets or sets the pharmacist */
  requestorPharmacist: OrderPharmacistDetailsDto | undefined;
  /** Gets or sets the pharmacy */
  recipientPharmacy: OrderPharmacyDetailsDto | undefined;
  /** Gets or sets the hospital */
  affiliatedHospital: OrderHospitalDetailsDto | undefined;
  /** Gets or sets the prescribing Hcps */
  prescribingHcps: OrderPrescribingHcpDetailsDto[] | undefined;
  id: string | undefined;

  constructor(data?: ISelectDayVerificationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.desiredDeliveryDate = _data["desiredDeliveryDate"] ? new Date(_data["desiredDeliveryDate"].toString()) : <any>undefined;
      this.requestorReached = _data["requestorReached"];
      this.comment = _data["comment"] ? OrderCommentDto.fromJS(_data["comment"]) : <any>undefined;
      this.orderId = _data["orderId"];
      if (_data["selectableCalendarDays"]) {
        this.selectableCalendarDays = {} as any;
        for (let key in _data["selectableCalendarDays"]) {
          if (_data["selectableCalendarDays"].hasOwnProperty(key))
            (<any>this.selectableCalendarDays)[key] = _data["selectableCalendarDays"][key];
        }
      }
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.missingRequestDate = _data["missingRequestDate"];
      this.institutionFlag = _data["institutionFlag"];
      this.repDrivenFlag = _data["repDrivenFlag"];
      this.orderStatusId = _data["orderStatusId"];
      this.orderSourceId = _data["orderSourceId"];
      this.originalSalesRep = _data["originalSalesRep"] ? OrderSalesRepDetailsDto.fromJS(_data["originalSalesRep"]) : <any>undefined;
      this.currentSalesRep = _data["currentSalesRep"] ? OrderSalesRepDetailsDto.fromJS(_data["currentSalesRep"]) : <any>undefined;
      this.requestorHcpDetails = _data["requestorHcpDetails"] ? OrderHcpDetailsDto.fromJS(_data["requestorHcpDetails"]) : <any>undefined;
      this.recipientHcpDetails = _data["recipientHcpDetails"] ? OrderHcpDetailsDto.fromJS(_data["recipientHcpDetails"]) : <any>undefined;
      this.shippingAddress = _data["shippingAddress"] ? ShippingAddressDto.fromJS(_data["shippingAddress"]) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.advancedEditFlag = _data["advancedEditFlag"];
      this.orderTypeClassificationValueId = _data["orderTypeClassificationValueId"];
      this.customerName = _data["customerName"];
      this.customerAccountNbr = _data["customerAccountNbr"];
      this.customerType = _data["customerType"];
      this.programModuleId = _data["programModuleId"];
      this.patientOrder = _data["patientOrder"] ? PatientOrderDto.fromJS(_data["patientOrder"]) : <any>undefined;
      this.requestorPharmacist = _data["requestorPharmacist"] ? OrderPharmacistDetailsDto.fromJS(_data["requestorPharmacist"]) : <any>undefined;
      this.recipientPharmacy = _data["recipientPharmacy"] ? OrderPharmacyDetailsDto.fromJS(_data["recipientPharmacy"]) : <any>undefined;
      this.affiliatedHospital = _data["affiliatedHospital"] ? OrderHospitalDetailsDto.fromJS(_data["affiliatedHospital"]) : <any>undefined;
      if (Array.isArray(_data["prescribingHcps"])) {
        this.prescribingHcps = [] as any;
        for (let item of _data["prescribingHcps"])
          this.prescribingHcps.push(OrderPrescribingHcpDetailsDto.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): SelectDayVerificationDto {
    data = typeof data === 'object' ? data : {};
    let result = new SelectDayVerificationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["desiredDeliveryDate"] = this.desiredDeliveryDate ? this.desiredDeliveryDate.toISOString() : <any>undefined;
    data["requestorReached"] = this.requestorReached;
    data["comment"] = this.comment ? this.comment.toJSON() : <any>undefined;
    data["orderId"] = this.orderId;
    if (this.selectableCalendarDays) {
      data["selectableCalendarDays"] = {};
      for (let key in this.selectableCalendarDays) {
        if (this.selectableCalendarDays.hasOwnProperty(key))
          (<any>data["selectableCalendarDays"])[key] = (<any>this.selectableCalendarDays)[key];
      }
    }
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["missingRequestDate"] = this.missingRequestDate;
    data["institutionFlag"] = this.institutionFlag;
    data["repDrivenFlag"] = this.repDrivenFlag;
    data["orderStatusId"] = this.orderStatusId;
    data["orderSourceId"] = this.orderSourceId;
    data["originalSalesRep"] = this.originalSalesRep ? this.originalSalesRep.toJSON() : <any>undefined;
    data["currentSalesRep"] = this.currentSalesRep ? this.currentSalesRep.toJSON() : <any>undefined;
    data["requestorHcpDetails"] = this.requestorHcpDetails ? this.requestorHcpDetails.toJSON() : <any>undefined;
    data["recipientHcpDetails"] = this.recipientHcpDetails ? this.recipientHcpDetails.toJSON() : <any>undefined;
    data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["advancedEditFlag"] = this.advancedEditFlag;
    data["orderTypeClassificationValueId"] = this.orderTypeClassificationValueId;
    data["customerName"] = this.customerName;
    data["customerAccountNbr"] = this.customerAccountNbr;
    data["customerType"] = this.customerType;
    data["programModuleId"] = this.programModuleId;
    data["patientOrder"] = this.patientOrder ? this.patientOrder.toJSON() : <any>undefined;
    data["requestorPharmacist"] = this.requestorPharmacist ? this.requestorPharmacist.toJSON() : <any>undefined;
    data["recipientPharmacy"] = this.recipientPharmacy ? this.recipientPharmacy.toJSON() : <any>undefined;
    data["affiliatedHospital"] = this.affiliatedHospital ? this.affiliatedHospital.toJSON() : <any>undefined;
    if (Array.isArray(this.prescribingHcps)) {
      data["prescribingHcps"] = [];
      for (let item of this.prescribingHcps)
        data["prescribingHcps"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }

  clone(): SelectDayVerificationDto {
    const json = this.toJSON();
    let result = new SelectDayVerificationDto();
    result.init(json);
    return result;
  }
}

export interface ISelectDayVerificationDto {
  desiredDeliveryDate: Date | undefined;
  /** Gets or set the flag that requestor is reached. */
  requestorReached: boolean | undefined;
  comment: OrderCommentDto | undefined;
  orderId: string | undefined;
  selectableCalendarDays: { [key: string]: boolean; } | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
  institutionFlag: boolean | undefined;
  repDrivenFlag: boolean | undefined;
  orderStatusId: string | undefined;
  orderSourceId: string | undefined;
  originalSalesRep: OrderSalesRepDetailsDto | undefined;
  currentSalesRep: OrderSalesRepDetailsDto | undefined;
  requestorHcpDetails: OrderHcpDetailsDto | undefined;
  recipientHcpDetails: OrderHcpDetailsDto | undefined;
  shippingAddress: ShippingAddressDto | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  advancedEditFlag: boolean | undefined;
  orderTypeClassificationValueId: string | undefined;
  customerName: string | undefined;
  customerAccountNbr: string | undefined;
  customerType: string | undefined;
  /** Program moduleId. */
  programModuleId: string | undefined;
  patientOrder: PatientOrderDto | undefined;
  /** Gets or sets the pharmacist */
  requestorPharmacist: OrderPharmacistDetailsDto | undefined;
  /** Gets or sets the pharmacy */
  recipientPharmacy: OrderPharmacyDetailsDto | undefined;
  /** Gets or sets the hospital */
  affiliatedHospital: OrderHospitalDetailsDto | undefined;
  /** Gets or sets the prescribing Hcps */
  prescribingHcps: OrderPrescribingHcpDetailsDto[] | undefined;
  id: string | undefined;
}

export class AjaxResponseOfTask implements IAjaxResponseOfTask {
  result: Task | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfTask) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? Task.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfTask {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfTask();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfTask {
    const json = this.toJSON();
    let result = new AjaxResponseOfTask();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfTask {
  result: Task | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class Task implements ITask {
  readonly id: number | undefined;
  readonly exception: any | undefined;
  readonly status: TaskStatus | undefined;
  readonly isCanceled: boolean | undefined;
  readonly isCompleted: boolean | undefined;
  readonly isCompletedSuccessfully: boolean | undefined;
  readonly creationOptions: TaskCreationOptions | undefined;
  readonly asyncState: any | undefined;
  readonly isFaulted: boolean | undefined;

  constructor(data?: ITask) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).id = _data["id"];
      (<any>this).exception = _data["exception"];
      (<any>this).status = _data["status"];
      (<any>this).isCanceled = _data["isCanceled"];
      (<any>this).isCompleted = _data["isCompleted"];
      (<any>this).isCompletedSuccessfully = _data["isCompletedSuccessfully"];
      (<any>this).creationOptions = _data["creationOptions"];
      (<any>this).asyncState = _data["asyncState"];
      (<any>this).isFaulted = _data["isFaulted"];
    }
  }

  static fromJS(data: any): Task {
    data = typeof data === 'object' ? data : {};
    let result = new Task();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["exception"] = this.exception;
    data["status"] = this.status;
    data["isCanceled"] = this.isCanceled;
    data["isCompleted"] = this.isCompleted;
    data["isCompletedSuccessfully"] = this.isCompletedSuccessfully;
    data["creationOptions"] = this.creationOptions;
    data["asyncState"] = this.asyncState;
    data["isFaulted"] = this.isFaulted;
    return data;
  }

  clone(): Task {
    const json = this.toJSON();
    let result = new Task();
    result.init(json);
    return result;
  }
}

export interface ITask {
  id: number | undefined;
  exception: any | undefined;
  status: TaskStatus | undefined;
  isCanceled: boolean | undefined;
  isCompleted: boolean | undefined;
  isCompletedSuccessfully: boolean | undefined;
  creationOptions: TaskCreationOptions | undefined;
  asyncState: any | undefined;
  isFaulted: boolean | undefined;
}

export class AjaxResponseOfSelectDayVerificationDto implements IAjaxResponseOfSelectDayVerificationDto {
  result: SelectDayVerificationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfSelectDayVerificationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? SelectDayVerificationDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfSelectDayVerificationDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfSelectDayVerificationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfSelectDayVerificationDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfSelectDayVerificationDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfSelectDayVerificationDto {
  result: SelectDayVerificationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class OrderPlitInvestigationDto implements IOrderPlitInvestigationDto {
  orderPlitInvestigationClassificationValueId: string | undefined;
  actualDeliveryDate: Date | undefined;
  investigationDate: Date | undefined;
  signedBy: string | undefined;
  comment: OrderCommentDto | undefined;
  orderId: string | undefined;
  orderAttachments: OrderAttachmentDto[] | undefined;
  names: LocalizedValue[] | undefined;

  constructor(data?: IOrderPlitInvestigationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderPlitInvestigationClassificationValueId = _data["orderPlitInvestigationClassificationValueId"];
      this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
      this.investigationDate = _data["investigationDate"] ? new Date(_data["investigationDate"].toString()) : <any>undefined;
      this.signedBy = _data["signedBy"];
      this.comment = _data["comment"] ? OrderCommentDto.fromJS(_data["comment"]) : <any>undefined;
      this.orderId = _data["orderId"];
      if (Array.isArray(_data["orderAttachments"])) {
        this.orderAttachments = [] as any;
        for (let item of _data["orderAttachments"])
          this.orderAttachments.push(OrderAttachmentDto.fromJS(item));
      }
      if (Array.isArray(_data["names"])) {
        this.names = [] as any;
        for (let item of _data["names"])
          this.names.push(LocalizedValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): OrderPlitInvestigationDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderPlitInvestigationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderPlitInvestigationClassificationValueId"] = this.orderPlitInvestigationClassificationValueId;
    data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
    data["investigationDate"] = this.investigationDate ? this.investigationDate.toISOString() : <any>undefined;
    data["signedBy"] = this.signedBy;
    data["comment"] = this.comment ? this.comment.toJSON() : <any>undefined;
    data["orderId"] = this.orderId;
    if (Array.isArray(this.orderAttachments)) {
      data["orderAttachments"] = [];
      for (let item of this.orderAttachments)
        data["orderAttachments"].push(item.toJSON());
    }
    if (Array.isArray(this.names)) {
      data["names"] = [];
      for (let item of this.names)
        data["names"].push(item.toJSON());
    }
    return data;
  }

  clone(): OrderPlitInvestigationDto {
    const json = this.toJSON();
    let result = new OrderPlitInvestigationDto();
    result.init(json);
    return result;
  }
}

export interface IOrderPlitInvestigationDto {
  orderPlitInvestigationClassificationValueId: string | undefined;
  actualDeliveryDate: Date | undefined;
  investigationDate: Date | undefined;
  signedBy: string | undefined;
  comment: OrderCommentDto | undefined;
  orderId: string | undefined;
  orderAttachments: OrderAttachmentDto[] | undefined;
  names: LocalizedValue[] | undefined;
}

export class AjaxResponseOfLostInTransitConfirmationDto implements IAjaxResponseOfLostInTransitConfirmationDto {
  result: LostInTransitConfirmationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfLostInTransitConfirmationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? LostInTransitConfirmationDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfLostInTransitConfirmationDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfLostInTransitConfirmationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfLostInTransitConfirmationDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfLostInTransitConfirmationDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfLostInTransitConfirmationDto {
  result: LostInTransitConfirmationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class LostInTransitConfirmationDto implements ILostInTransitConfirmationDto {
  orderId: string | undefined;
  lostInTransitEvent: string | undefined;
  eventDescription: string | undefined;
  latestActualContainerShipDate: Date | undefined;
  signedBy: string | undefined;
  orderReturnLines: OrderReturnLineDto[] | undefined;
  confirmationAction: boolean | undefined;
  comment: OrderCommentDto | undefined;
  actualDeliveryDate: Date | undefined;
  containerId: string | undefined;
  trackingNumberText: string | undefined;
  trackingNumberUrl: string | undefined;
  communicationId: string | undefined;

  constructor(data?: ILostInTransitConfirmationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.lostInTransitEvent = _data["lostInTransitEvent"];
      this.eventDescription = _data["eventDescription"];
      this.latestActualContainerShipDate = _data["latestActualContainerShipDate"] ? new Date(_data["latestActualContainerShipDate"].toString()) : <any>undefined;
      this.signedBy = _data["signedBy"];
      if (Array.isArray(_data["orderReturnLines"])) {
        this.orderReturnLines = [] as any;
        for (let item of _data["orderReturnLines"])
          this.orderReturnLines.push(OrderReturnLineDto.fromJS(item));
      }
      this.confirmationAction = _data["confirmationAction"];
      this.comment = _data["comment"] ? OrderCommentDto.fromJS(_data["comment"]) : <any>undefined;
      this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
      this.containerId = _data["containerId"];
      this.trackingNumberText = _data["trackingNumberText"];
      this.trackingNumberUrl = _data["trackingNumberUrl"];
      this.communicationId = _data["communicationId"];
    }
  }

  static fromJS(data: any): LostInTransitConfirmationDto {
    data = typeof data === 'object' ? data : {};
    let result = new LostInTransitConfirmationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["lostInTransitEvent"] = this.lostInTransitEvent;
    data["eventDescription"] = this.eventDescription;
    data["latestActualContainerShipDate"] = this.latestActualContainerShipDate ? this.latestActualContainerShipDate.toISOString() : <any>undefined;
    data["signedBy"] = this.signedBy;
    if (Array.isArray(this.orderReturnLines)) {
      data["orderReturnLines"] = [];
      for (let item of this.orderReturnLines)
        data["orderReturnLines"].push(item.toJSON());
    }
    data["confirmationAction"] = this.confirmationAction;
    data["comment"] = this.comment ? this.comment.toJSON() : <any>undefined;
    data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
    data["containerId"] = this.containerId;
    data["trackingNumberText"] = this.trackingNumberText;
    data["trackingNumberUrl"] = this.trackingNumberUrl;
    data["communicationId"] = this.communicationId;
    return data;
  }

  clone(): LostInTransitConfirmationDto {
    const json = this.toJSON();
    let result = new LostInTransitConfirmationDto();
    result.init(json);
    return result;
  }
}

export interface ILostInTransitConfirmationDto {
  orderId: string | undefined;
  lostInTransitEvent: string | undefined;
  eventDescription: string | undefined;
  latestActualContainerShipDate: Date | undefined;
  signedBy: string | undefined;
  orderReturnLines: OrderReturnLineDto[] | undefined;
  confirmationAction: boolean | undefined;
  comment: OrderCommentDto | undefined;
  actualDeliveryDate: Date | undefined;
  containerId: string | undefined;
  trackingNumberText: string | undefined;
  trackingNumberUrl: string | undefined;
  communicationId: string | undefined;
}

export class OrderReturnLineDto implements IOrderReturnLineDto {
  productName: string | undefined;
  productId: string | undefined;
  returnedQuantity: number | undefined;
  displayQuantity: string | undefined;

  constructor(data?: IOrderReturnLineDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productName = _data["productName"];
      this.productId = _data["productId"];
      this.returnedQuantity = _data["returnedQuantity"];
      this.displayQuantity = _data["displayQuantity"];
    }
  }

  static fromJS(data: any): OrderReturnLineDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderReturnLineDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["productName"] = this.productName;
    data["productId"] = this.productId;
    data["returnedQuantity"] = this.returnedQuantity;
    data["displayQuantity"] = this.displayQuantity;
    return data;
  }

  clone(): OrderReturnLineDto {
    const json = this.toJSON();
    let result = new OrderReturnLineDto();
    result.init(json);
    return result;
  }
}

export interface IOrderReturnLineDto {
  productName: string | undefined;
  productId: string | undefined;
  returnedQuantity: number | undefined;
  displayQuantity: string | undefined;
}

export class AjaxResponseOfSSDCalculationResultEnum implements IAjaxResponseOfSSDCalculationResultEnum {
  result: AjaxResponseOfSSDCalculationResultEnumResult | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfSSDCalculationResultEnum) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfSSDCalculationResultEnum {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfSSDCalculationResultEnum();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfSSDCalculationResultEnum {
    const json = this.toJSON();
    let result = new AjaxResponseOfSSDCalculationResultEnum();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfSSDCalculationResultEnum {
  result: AjaxResponseOfSSDCalculationResultEnumResult | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32 implements ITupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32 {
  readonly item1: string | undefined;
  readonly item2: string | undefined;
  readonly item3: number | undefined;

  constructor(data?: ITupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).item1 = _data["item1"];
      (<any>this).item2 = _data["item2"];
      (<any>this).item3 = _data["item3"];
    }
  }

  static fromJS(data: any): TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32 {
    data = typeof data === 'object' ? data : {};
    let result = new TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["item1"] = this.item1;
    data["item2"] = this.item2;
    data["item3"] = this.item3;
    return data;
  }

  clone(): TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32 {
    const json = this.toJSON();
    let result = new TupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32();
    result.init(json);
    return result;
  }
}

export interface ITupleOfNullableOfTimeSpanAndNullableOfGuidAndNullableOfInt32 {
  item1: string | undefined;
  item2: string | undefined;
  item3: number | undefined;
}

export class AjaxResponseOfIListOfSalesOrderTypesDto implements IAjaxResponseOfIListOfSalesOrderTypesDto {
  result: SalesOrderTypesDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfIListOfSalesOrderTypesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result.push(SalesOrderTypesDto.fromJS(item));
      }
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfIListOfSalesOrderTypesDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfIListOfSalesOrderTypesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfIListOfSalesOrderTypesDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfIListOfSalesOrderTypesDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfIListOfSalesOrderTypesDto {
  result: SalesOrderTypesDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class SalesOrderTypesDto implements ISalesOrderTypesDto {
  salesOrderTypesId: string | undefined;
  code: string | undefined;
  name: string | undefined;
  isDefault: boolean | undefined;

  constructor(data?: ISalesOrderTypesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.salesOrderTypesId = _data["salesOrderTypesId"];
      this.code = _data["code"];
      this.name = _data["name"];
      this.isDefault = _data["isDefault"];
    }
  }

  static fromJS(data: any): SalesOrderTypesDto {
    data = typeof data === 'object' ? data : {};
    let result = new SalesOrderTypesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["salesOrderTypesId"] = this.salesOrderTypesId;
    data["code"] = this.code;
    data["name"] = this.name;
    data["isDefault"] = this.isDefault;
    return data;
  }

  clone(): SalesOrderTypesDto {
    const json = this.toJSON();
    let result = new SalesOrderTypesDto();
    result.init(json);
    return result;
  }
}

export interface ISalesOrderTypesDto {
  salesOrderTypesId: string | undefined;
  code: string | undefined;
  name: string | undefined;
  isDefault: boolean | undefined;
}

export class GetOrdersSalesTypesDtoRequest implements IGetOrdersSalesTypesDtoRequest {
  orderNumbers: string[] | undefined;

  constructor(data?: IGetOrdersSalesTypesDtoRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["orderNumbers"])) {
        this.orderNumbers = [] as any;
        for (let item of _data["orderNumbers"])
          this.orderNumbers.push(item);
      }
    }
  }

  static fromJS(data: any): GetOrdersSalesTypesDtoRequest {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrdersSalesTypesDtoRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.orderNumbers)) {
      data["orderNumbers"] = [];
      for (let item of this.orderNumbers)
        data["orderNumbers"].push(item);
    }
    return data;
  }

  clone(): GetOrdersSalesTypesDtoRequest {
    const json = this.toJSON();
    let result = new GetOrdersSalesTypesDtoRequest();
    result.init(json);
    return result;
  }
}

export interface IGetOrdersSalesTypesDtoRequest {
  orderNumbers: string[] | undefined;
}

export class AjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse implements IAjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse {
  result: GetOrdersSalesTypesDtoResponse[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result.push(GetOrdersSalesTypesDtoResponse.fromJS(item));
      }
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse {
    const json = this.toJSON();
    let result = new AjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfIListOfGetOrdersSalesTypesDtoResponse {
  result: GetOrdersSalesTypesDtoResponse[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class GetOrdersSalesTypesDtoResponse implements IGetOrdersSalesTypesDtoResponse {
  orderNumber: string | undefined;
  salesOrderTypeName: string | undefined;
  salesOrderTypeCode: string | undefined;
  requestorFirstName: string | undefined;
  requestorMiddleName: string | undefined;
  requestorLastName: string | undefined;
  externalOrderLineId: string | undefined;
  productCode: string | undefined;

  constructor(data?: IGetOrdersSalesTypesDtoResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderNumber = _data["orderNumber"];
      this.salesOrderTypeName = _data["salesOrderTypeName"];
      this.salesOrderTypeCode = _data["salesOrderTypeCode"];
      this.requestorFirstName = _data["requestorFirstName"];
      this.requestorMiddleName = _data["requestorMiddleName"];
      this.requestorLastName = _data["requestorLastName"];
      this.externalOrderLineId = _data["externalOrderLineId"];
      this.productCode = _data["productCode"];
    }
  }

  static fromJS(data: any): GetOrdersSalesTypesDtoResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetOrdersSalesTypesDtoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderNumber"] = this.orderNumber;
    data["salesOrderTypeName"] = this.salesOrderTypeName;
    data["salesOrderTypeCode"] = this.salesOrderTypeCode;
    data["requestorFirstName"] = this.requestorFirstName;
    data["requestorMiddleName"] = this.requestorMiddleName;
    data["requestorLastName"] = this.requestorLastName;
    data["externalOrderLineId"] = this.externalOrderLineId;
    data["productCode"] = this.productCode;
    return data;
  }

  clone(): GetOrdersSalesTypesDtoResponse {
    const json = this.toJSON();
    let result = new GetOrdersSalesTypesDtoResponse();
    result.init(json);
    return result;
  }
}

export interface IGetOrdersSalesTypesDtoResponse {
  orderNumber: string | undefined;
  salesOrderTypeName: string | undefined;
  salesOrderTypeCode: string | undefined;
  requestorFirstName: string | undefined;
  requestorMiddleName: string | undefined;
  requestorLastName: string | undefined;
  externalOrderLineId: string | undefined;
  productCode: string | undefined;
}

export class SomsOrderResponseDto implements ISomsOrderResponseDto {
  orderId: string | undefined;
  statusCode: string | undefined;
  lineItems: SomsOrderLineResponseDto[] | undefined;

  constructor(data?: ISomsOrderResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.statusCode = _data["statusCode"];
      if (Array.isArray(_data["lineItems"])) {
        this.lineItems = [] as any;
        for (let item of _data["lineItems"])
          this.lineItems.push(SomsOrderLineResponseDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SomsOrderResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new SomsOrderResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["statusCode"] = this.statusCode;
    if (Array.isArray(this.lineItems)) {
      data["lineItems"] = [];
      for (let item of this.lineItems)
        data["lineItems"].push(item.toJSON());
    }
    return data;
  }

  clone(): SomsOrderResponseDto {
    const json = this.toJSON();
    let result = new SomsOrderResponseDto();
    result.init(json);
    return result;
  }
}

export interface ISomsOrderResponseDto {
  orderId: string | undefined;
  statusCode: string | undefined;
  lineItems: SomsOrderLineResponseDto[] | undefined;
}

export class SomsOrderLineResponseDto implements ISomsOrderLineResponseDto {
  orderLineId: string | undefined;
  statusCode: string | undefined;

  constructor(data?: ISomsOrderLineResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderLineId = _data["orderLineId"];
      this.statusCode = _data["statusCode"];
    }
  }

  static fromJS(data: any): SomsOrderLineResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new SomsOrderLineResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderLineId"] = this.orderLineId;
    data["statusCode"] = this.statusCode;
    return data;
  }

  clone(): SomsOrderLineResponseDto {
    const json = this.toJSON();
    let result = new SomsOrderLineResponseDto();
    result.init(json);
    return result;
  }
}

export interface ISomsOrderLineResponseDto {
  orderLineId: string | undefined;
  statusCode: string | undefined;
}

export class AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto implements IAjaxResponseOfPageValidationOfOrderDeliveryDetailsDto {
  result: PageValidationOfOrderDeliveryDetailsDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfPageValidationOfOrderDeliveryDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? PageValidationOfOrderDeliveryDetailsDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfPageValidationOfOrderDeliveryDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfPageValidationOfOrderDeliveryDetailsDto {
  result: PageValidationOfOrderDeliveryDetailsDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class PageValidationOfOrderDeliveryDetailsDto implements IPageValidationOfOrderDeliveryDetailsDto {
  dataDto: OrderDeliveryDetailsDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;

  constructor(data?: IPageValidationOfOrderDeliveryDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dataDto = _data["dataDto"] ? OrderDeliveryDetailsDto.fromJS(_data["dataDto"]) : <any>undefined;
      if (Array.isArray(_data["sectionValidations"])) {
        this.sectionValidations = [] as any;
        for (let item of _data["sectionValidations"])
          this.sectionValidations.push(SectionValidation.fromJS(item));
      }
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): PageValidationOfOrderDeliveryDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageValidationOfOrderDeliveryDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dataDto"] = this.dataDto ? this.dataDto.toJSON() : <any>undefined;
    if (Array.isArray(this.sectionValidations)) {
      data["sectionValidations"] = [];
      for (let item of this.sectionValidations)
        data["sectionValidations"].push(item.toJSON());
    }
    data["state"] = this.state;
    return data;
  }

  clone(): PageValidationOfOrderDeliveryDetailsDto {
    const json = this.toJSON();
    let result = new PageValidationOfOrderDeliveryDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IPageValidationOfOrderDeliveryDetailsDto {
  dataDto: OrderDeliveryDetailsDto | undefined;
  sectionValidations: SectionValidation[] | undefined;
  state: string | undefined;
}

export class OrderDeliveryDetailsDto implements IOrderDeliveryDetailsDto {
  orderId: string | undefined;
  orderStatusId: string | undefined;
  orderSourceId: string | undefined;
  shipmentSourceId: string | undefined;
  mondayDeliveryFlag: boolean | undefined;
  tuesdayDeliveryFlag: boolean | undefined;
  wednesdayDeliveryFlag: boolean | undefined;
  thursdayDeliveryFlag: boolean | undefined;
  fridayDeliveryFlag: boolean | undefined;
  saturdayDeliveryFlag: boolean | undefined;
  sundayDeliveryFlag: boolean | undefined;
  allowMondayDeliveryFlag: boolean | undefined;
  allowTuesdayDeliveryFlag: boolean | undefined;
  allowWednesdayDeliveryFlag: boolean | undefined;
  allowThursdayDeliveryFlag: boolean | undefined;
  allowFridayDeliveryFlag: boolean | undefined;
  allowSaturdayDeliveryFlag: boolean | undefined;
  allowSundayDeliveryFlag: boolean | undefined;
  missingFlag: boolean | undefined;
  desiredDeliveryDate: Date | undefined;
  desiredDeliveryDay: string | undefined;
  anticipatedCarrierName: string | undefined;
  anticipatedCarrierId: string | undefined;
  anticipatedCarrierServiceTypeName: string | undefined;
  anticipatedCarrierServiceTypeId: string | undefined;
  scheduledShipDate: Date | undefined;
  anticipatedLatestDeliveryDate: Date | undefined;
  hcpCouldNotBeReachedFlag: boolean | undefined;
  rushFlag: boolean | undefined;
  selectDayShippingFlag: boolean | undefined;
  carrierName: string | undefined;
  carrierServiceTypeName: string | undefined;
  actualDeliveryDate: Date | undefined;
  deliveryStatusClassificationValueId: string | undefined;
  latestActualContainerShipDate: string | undefined;
  acceptableDaysEditFlag: boolean | undefined;
  desiredDeliveryEditFlag: boolean | undefined;
  rushOrderEditFlag: boolean | undefined;
  shipmentContainers: ShipmentContainerDto[] | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;

  constructor(data?: IOrderDeliveryDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderStatusId = _data["orderStatusId"];
      this.orderSourceId = _data["orderSourceId"];
      this.shipmentSourceId = _data["shipmentSourceId"];
      this.mondayDeliveryFlag = _data["mondayDeliveryFlag"];
      this.tuesdayDeliveryFlag = _data["tuesdayDeliveryFlag"];
      this.wednesdayDeliveryFlag = _data["wednesdayDeliveryFlag"];
      this.thursdayDeliveryFlag = _data["thursdayDeliveryFlag"];
      this.fridayDeliveryFlag = _data["fridayDeliveryFlag"];
      this.saturdayDeliveryFlag = _data["saturdayDeliveryFlag"];
      this.sundayDeliveryFlag = _data["sundayDeliveryFlag"];
      this.allowMondayDeliveryFlag = _data["allowMondayDeliveryFlag"];
      this.allowTuesdayDeliveryFlag = _data["allowTuesdayDeliveryFlag"];
      this.allowWednesdayDeliveryFlag = _data["allowWednesdayDeliveryFlag"];
      this.allowThursdayDeliveryFlag = _data["allowThursdayDeliveryFlag"];
      this.allowFridayDeliveryFlag = _data["allowFridayDeliveryFlag"];
      this.allowSaturdayDeliveryFlag = _data["allowSaturdayDeliveryFlag"];
      this.allowSundayDeliveryFlag = _data["allowSundayDeliveryFlag"];
      this.missingFlag = _data["missingFlag"];
      this.desiredDeliveryDate = _data["desiredDeliveryDate"] ? new Date(_data["desiredDeliveryDate"].toString()) : <any>undefined;
      this.desiredDeliveryDay = _data["desiredDeliveryDay"];
      this.anticipatedCarrierName = _data["anticipatedCarrierName"];
      this.anticipatedCarrierId = _data["anticipatedCarrierId"];
      this.anticipatedCarrierServiceTypeName = _data["anticipatedCarrierServiceTypeName"];
      this.anticipatedCarrierServiceTypeId = _data["anticipatedCarrierServiceTypeId"];
      this.scheduledShipDate = _data["scheduledShipDate"] ? new Date(_data["scheduledShipDate"].toString()) : <any>undefined;
      this.anticipatedLatestDeliveryDate = _data["anticipatedLatestDeliveryDate"] ? new Date(_data["anticipatedLatestDeliveryDate"].toString()) : <any>undefined;
      this.hcpCouldNotBeReachedFlag = _data["hcpCouldNotBeReachedFlag"];
      this.rushFlag = _data["rushFlag"];
      this.selectDayShippingFlag = _data["selectDayShippingFlag"];
      this.carrierName = _data["carrierName"];
      this.carrierServiceTypeName = _data["carrierServiceTypeName"];
      this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
      this.deliveryStatusClassificationValueId = _data["deliveryStatusClassificationValueId"];
      this.latestActualContainerShipDate = _data["latestActualContainerShipDate"];
      this.acceptableDaysEditFlag = _data["acceptableDaysEditFlag"];
      this.desiredDeliveryEditFlag = _data["desiredDeliveryEditFlag"];
      this.rushOrderEditFlag = _data["rushOrderEditFlag"];
      if (Array.isArray(_data["shipmentContainers"])) {
        this.shipmentContainers = [] as any;
        for (let item of _data["shipmentContainers"])
          this.shipmentContainers.push(ShipmentContainerDto.fromJS(item));
      }
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.missingRequestDate = _data["missingRequestDate"];
    }
  }

  static fromJS(data: any): OrderDeliveryDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderDeliveryDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderStatusId"] = this.orderStatusId;
    data["orderSourceId"] = this.orderSourceId;
    data["shipmentSourceId"] = this.shipmentSourceId;
    data["mondayDeliveryFlag"] = this.mondayDeliveryFlag;
    data["tuesdayDeliveryFlag"] = this.tuesdayDeliveryFlag;
    data["wednesdayDeliveryFlag"] = this.wednesdayDeliveryFlag;
    data["thursdayDeliveryFlag"] = this.thursdayDeliveryFlag;
    data["fridayDeliveryFlag"] = this.fridayDeliveryFlag;
    data["saturdayDeliveryFlag"] = this.saturdayDeliveryFlag;
    data["sundayDeliveryFlag"] = this.sundayDeliveryFlag;
    data["allowMondayDeliveryFlag"] = this.allowMondayDeliveryFlag;
    data["allowTuesdayDeliveryFlag"] = this.allowTuesdayDeliveryFlag;
    data["allowWednesdayDeliveryFlag"] = this.allowWednesdayDeliveryFlag;
    data["allowThursdayDeliveryFlag"] = this.allowThursdayDeliveryFlag;
    data["allowFridayDeliveryFlag"] = this.allowFridayDeliveryFlag;
    data["allowSaturdayDeliveryFlag"] = this.allowSaturdayDeliveryFlag;
    data["allowSundayDeliveryFlag"] = this.allowSundayDeliveryFlag;
    data["missingFlag"] = this.missingFlag;
    data["desiredDeliveryDate"] = this.desiredDeliveryDate ? this.desiredDeliveryDate.toISOString() : <any>undefined;
    data["desiredDeliveryDay"] = this.desiredDeliveryDay;
    data["anticipatedCarrierName"] = this.anticipatedCarrierName;
    data["anticipatedCarrierId"] = this.anticipatedCarrierId;
    data["anticipatedCarrierServiceTypeName"] = this.anticipatedCarrierServiceTypeName;
    data["anticipatedCarrierServiceTypeId"] = this.anticipatedCarrierServiceTypeId;
    data["scheduledShipDate"] = this.scheduledShipDate ? this.scheduledShipDate.toISOString() : <any>undefined;
    data["anticipatedLatestDeliveryDate"] = this.anticipatedLatestDeliveryDate ? this.anticipatedLatestDeliveryDate.toISOString() : <any>undefined;
    data["hcpCouldNotBeReachedFlag"] = this.hcpCouldNotBeReachedFlag;
    data["rushFlag"] = this.rushFlag;
    data["selectDayShippingFlag"] = this.selectDayShippingFlag;
    data["carrierName"] = this.carrierName;
    data["carrierServiceTypeName"] = this.carrierServiceTypeName;
    data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
    data["deliveryStatusClassificationValueId"] = this.deliveryStatusClassificationValueId;
    data["latestActualContainerShipDate"] = this.latestActualContainerShipDate;
    data["acceptableDaysEditFlag"] = this.acceptableDaysEditFlag;
    data["desiredDeliveryEditFlag"] = this.desiredDeliveryEditFlag;
    data["rushOrderEditFlag"] = this.rushOrderEditFlag;
    if (Array.isArray(this.shipmentContainers)) {
      data["shipmentContainers"] = [];
      for (let item of this.shipmentContainers)
        data["shipmentContainers"].push(item.toJSON());
    }
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["missingRequestDate"] = this.missingRequestDate;
    return data;
  }

  clone(): OrderDeliveryDetailsDto {
    const json = this.toJSON();
    let result = new OrderDeliveryDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IOrderDeliveryDetailsDto {
  orderId: string | undefined;
  orderStatusId: string | undefined;
  orderSourceId: string | undefined;
  shipmentSourceId: string | undefined;
  mondayDeliveryFlag: boolean | undefined;
  tuesdayDeliveryFlag: boolean | undefined;
  wednesdayDeliveryFlag: boolean | undefined;
  thursdayDeliveryFlag: boolean | undefined;
  fridayDeliveryFlag: boolean | undefined;
  saturdayDeliveryFlag: boolean | undefined;
  sundayDeliveryFlag: boolean | undefined;
  allowMondayDeliveryFlag: boolean | undefined;
  allowTuesdayDeliveryFlag: boolean | undefined;
  allowWednesdayDeliveryFlag: boolean | undefined;
  allowThursdayDeliveryFlag: boolean | undefined;
  allowFridayDeliveryFlag: boolean | undefined;
  allowSaturdayDeliveryFlag: boolean | undefined;
  allowSundayDeliveryFlag: boolean | undefined;
  missingFlag: boolean | undefined;
  desiredDeliveryDate: Date | undefined;
  desiredDeliveryDay: string | undefined;
  anticipatedCarrierName: string | undefined;
  anticipatedCarrierId: string | undefined;
  anticipatedCarrierServiceTypeName: string | undefined;
  anticipatedCarrierServiceTypeId: string | undefined;
  scheduledShipDate: Date | undefined;
  anticipatedLatestDeliveryDate: Date | undefined;
  hcpCouldNotBeReachedFlag: boolean | undefined;
  rushFlag: boolean | undefined;
  selectDayShippingFlag: boolean | undefined;
  carrierName: string | undefined;
  carrierServiceTypeName: string | undefined;
  actualDeliveryDate: Date | undefined;
  deliveryStatusClassificationValueId: string | undefined;
  latestActualContainerShipDate: string | undefined;
  acceptableDaysEditFlag: boolean | undefined;
  desiredDeliveryEditFlag: boolean | undefined;
  rushOrderEditFlag: boolean | undefined;
  shipmentContainers: ShipmentContainerDto[] | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
}

export class ShipmentContainerDto implements IShipmentContainerDto {
  shipmentId: string | undefined;
  deliveryStatusClassificationValueId: string | undefined;
  actualDeliveryDate: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  containerId: string | undefined;
  actualShipDate: string | undefined;
  carrierName: string | undefined;
  carrierServiceTypeName: string | undefined;
  trackingNumberText: string | undefined;
  trackingNumberUrl: string | undefined;
  returnReasonText: string | undefined;
  shipmentContainerSerialNumbers: ShipmentContainerSerialNumberDto[] | undefined;
  shipmentContainerLines: ShipmentContainerLineDto[] | undefined;
  id: string | undefined;

  constructor(data?: IShipmentContainerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.shipmentId = _data["shipmentId"];
      this.deliveryStatusClassificationValueId = _data["deliveryStatusClassificationValueId"];
      this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.containerId = _data["containerId"];
      this.actualShipDate = _data["actualShipDate"];
      this.carrierName = _data["carrierName"];
      this.carrierServiceTypeName = _data["carrierServiceTypeName"];
      this.trackingNumberText = _data["trackingNumberText"];
      this.trackingNumberUrl = _data["trackingNumberUrl"];
      this.returnReasonText = _data["returnReasonText"];
      if (Array.isArray(_data["shipmentContainerSerialNumbers"])) {
        this.shipmentContainerSerialNumbers = [] as any;
        for (let item of _data["shipmentContainerSerialNumbers"])
          this.shipmentContainerSerialNumbers.push(ShipmentContainerSerialNumberDto.fromJS(item));
      }
      if (Array.isArray(_data["shipmentContainerLines"])) {
        this.shipmentContainerLines = [] as any;
        for (let item of _data["shipmentContainerLines"])
          this.shipmentContainerLines.push(ShipmentContainerLineDto.fromJS(item));
      }
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ShipmentContainerDto {
    data = typeof data === 'object' ? data : {};
    let result = new ShipmentContainerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["shipmentId"] = this.shipmentId;
    data["deliveryStatusClassificationValueId"] = this.deliveryStatusClassificationValueId;
    data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["containerId"] = this.containerId;
    data["actualShipDate"] = this.actualShipDate;
    data["carrierName"] = this.carrierName;
    data["carrierServiceTypeName"] = this.carrierServiceTypeName;
    data["trackingNumberText"] = this.trackingNumberText;
    data["trackingNumberUrl"] = this.trackingNumberUrl;
    data["returnReasonText"] = this.returnReasonText;
    if (Array.isArray(this.shipmentContainerSerialNumbers)) {
      data["shipmentContainerSerialNumbers"] = [];
      for (let item of this.shipmentContainerSerialNumbers)
        data["shipmentContainerSerialNumbers"].push(item.toJSON());
    }
    if (Array.isArray(this.shipmentContainerLines)) {
      data["shipmentContainerLines"] = [];
      for (let item of this.shipmentContainerLines)
        data["shipmentContainerLines"].push(item.toJSON());
    }
    data["id"] = this.id;
    return data;
  }

  clone(): ShipmentContainerDto {
    const json = this.toJSON();
    let result = new ShipmentContainerDto();
    result.init(json);
    return result;
  }
}

export interface IShipmentContainerDto {
  shipmentId: string | undefined;
  deliveryStatusClassificationValueId: string | undefined;
  actualDeliveryDate: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  containerId: string | undefined;
  actualShipDate: string | undefined;
  carrierName: string | undefined;
  carrierServiceTypeName: string | undefined;
  trackingNumberText: string | undefined;
  trackingNumberUrl: string | undefined;
  returnReasonText: string | undefined;
  shipmentContainerSerialNumbers: ShipmentContainerSerialNumberDto[] | undefined;
  shipmentContainerLines: ShipmentContainerLineDto[] | undefined;
  id: string | undefined;
}

export class ShipmentContainerSerialNumberDto implements IShipmentContainerSerialNumberDto {
  orderLineId: string | undefined;
  shipmentContainerId: string | undefined;
  serialNumberText: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IShipmentContainerSerialNumberDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderLineId = _data["orderLineId"];
      this.shipmentContainerId = _data["shipmentContainerId"];
      this.serialNumberText = _data["serialNumberText"];
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ShipmentContainerSerialNumberDto {
    data = typeof data === 'object' ? data : {};
    let result = new ShipmentContainerSerialNumberDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderLineId"] = this.orderLineId;
    data["shipmentContainerId"] = this.shipmentContainerId;
    data["serialNumberText"] = this.serialNumberText;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ShipmentContainerSerialNumberDto {
    const json = this.toJSON();
    let result = new ShipmentContainerSerialNumberDto();
    result.init(json);
    return result;
  }
}

export interface IShipmentContainerSerialNumberDto {
  orderLineId: string | undefined;
  shipmentContainerId: string | undefined;
  serialNumberText: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  id: string | undefined;
}

export class ShipmentContainerLineDto implements IShipmentContainerLineDto {
  shipmentContainerId: string | undefined;
  serialNumber: string | undefined;
  lotId: string | undefined;
  lotExpirationDate: Date | undefined;
  shippedQty: number | undefined;
  returnedQty: number | undefined;
  deliveredQty: number | undefined;
  productId: string | undefined;
  productName: string | undefined;
  productIdName: string | undefined;
  uomClassificationValueId: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  id: string | undefined;

  constructor(data?: IShipmentContainerLineDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.shipmentContainerId = _data["shipmentContainerId"];
      this.serialNumber = _data["serialNumber"];
      this.lotId = _data["lotId"];
      this.lotExpirationDate = _data["lotExpirationDate"] ? new Date(_data["lotExpirationDate"].toString()) : <any>undefined;
      this.shippedQty = _data["shippedQty"];
      this.returnedQty = _data["returnedQty"];
      this.deliveredQty = _data["deliveredQty"];
      this.productId = _data["productId"];
      this.productName = _data["productName"];
      this.productIdName = _data["productIdName"];
      this.uomClassificationValueId = _data["uomClassificationValueId"];
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): ShipmentContainerLineDto {
    data = typeof data === 'object' ? data : {};
    let result = new ShipmentContainerLineDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["shipmentContainerId"] = this.shipmentContainerId;
    data["serialNumber"] = this.serialNumber;
    data["lotId"] = this.lotId;
    data["lotExpirationDate"] = this.lotExpirationDate ? this.lotExpirationDate.toISOString() : <any>undefined;
    data["shippedQty"] = this.shippedQty;
    data["returnedQty"] = this.returnedQty;
    data["deliveredQty"] = this.deliveredQty;
    data["productId"] = this.productId;
    data["productName"] = this.productName;
    data["productIdName"] = this.productIdName;
    data["uomClassificationValueId"] = this.uomClassificationValueId;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["id"] = this.id;
    return data;
  }

  clone(): ShipmentContainerLineDto {
    const json = this.toJSON();
    let result = new ShipmentContainerLineDto();
    result.init(json);
    return result;
  }
}

export interface IShipmentContainerLineDto {
  shipmentContainerId: string | undefined;
  serialNumber: string | undefined;
  lotId: string | undefined;
  lotExpirationDate: Date | undefined;
  shippedQty: number | undefined;
  returnedQty: number | undefined;
  deliveredQty: number | undefined;
  productId: string | undefined;
  productName: string | undefined;
  productIdName: string | undefined;
  uomClassificationValueId: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  id: string | undefined;
}

export class AjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid implements IAjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid {
  result: TupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? TupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid {
    const json = this.toJSON();
    let result = new AjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfTupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid {
  result: TupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class TupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid implements ITupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid {
  readonly item1: Date | undefined;
  readonly item2: Date | undefined;
  readonly item3: boolean | undefined;
  readonly item4: string | undefined;

  constructor(data?: ITupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).item1 = _data["item1"] ? new Date(_data["item1"].toString()) : <any>undefined;
      (<any>this).item2 = _data["item2"] ? new Date(_data["item2"].toString()) : <any>undefined;
      (<any>this).item3 = _data["item3"];
      (<any>this).item4 = _data["item4"];
    }
  }

  static fromJS(data: any): TupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid {
    data = typeof data === 'object' ? data : {};
    let result = new TupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["item1"] = this.item1 ? this.item1.toISOString() : <any>undefined;
    data["item2"] = this.item2 ? this.item2.toISOString() : <any>undefined;
    data["item3"] = this.item3;
    data["item4"] = this.item4;
    return data;
  }

  clone(): TupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid {
    const json = this.toJSON();
    let result = new TupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid();
    result.init(json);
    return result;
  }
}

export interface ITupleOfNullableOfDateTimeAndNullableOfDateTimeAndBooleanAndNullableOfGuid {
  item1: Date | undefined;
  item2: Date | undefined;
  item3: boolean | undefined;
  item4: string | undefined;
}

export class AjaxResponseOfShippingAddressWithFieldContraintsDto implements IAjaxResponseOfShippingAddressWithFieldContraintsDto {
  result: ShippingAddressWithFieldContraintsDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfShippingAddressWithFieldContraintsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? ShippingAddressWithFieldContraintsDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfShippingAddressWithFieldContraintsDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfShippingAddressWithFieldContraintsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfShippingAddressWithFieldContraintsDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfShippingAddressWithFieldContraintsDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfShippingAddressWithFieldContraintsDto {
  result: ShippingAddressWithFieldContraintsDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class ShippingAddressWithFieldContraintsDto implements IShippingAddressWithFieldContraintsDto {
  shippingAddress: ShippingAddressDto | undefined;
  fieldConstraints: FieldConstraint[] | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;

  constructor(data?: IShippingAddressWithFieldContraintsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.shippingAddress = _data["shippingAddress"] ? ShippingAddressDto.fromJS(_data["shippingAddress"]) : <any>undefined;
      if (Array.isArray(_data["fieldConstraints"])) {
        this.fieldConstraints = [] as any;
        for (let item of _data["fieldConstraints"])
          this.fieldConstraints.push(FieldConstraint.fromJS(item));
      }
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
    }
  }

  static fromJS(data: any): ShippingAddressWithFieldContraintsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ShippingAddressWithFieldContraintsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
    if (Array.isArray(this.fieldConstraints)) {
      data["fieldConstraints"] = [];
      for (let item of this.fieldConstraints)
        data["fieldConstraints"].push(item.toJSON());
    }
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    return data;
  }

  clone(): ShippingAddressWithFieldContraintsDto {
    const json = this.toJSON();
    let result = new ShippingAddressWithFieldContraintsDto();
    result.init(json);
    return result;
  }
}

export interface IShippingAddressWithFieldContraintsDto {
  shippingAddress: ShippingAddressDto | undefined;
  fieldConstraints: FieldConstraint[] | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
}

export class FieldConstraint implements IFieldConstraint {
  fieldName: string | undefined;
  lengthConstraint: number | undefined;

  constructor(data?: IFieldConstraint) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fieldName = _data["fieldName"];
      this.lengthConstraint = _data["lengthConstraint"];
    }
  }

  static fromJS(data: any): FieldConstraint {
    data = typeof data === 'object' ? data : {};
    let result = new FieldConstraint();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fieldName"] = this.fieldName;
    data["lengthConstraint"] = this.lengthConstraint;
    return data;
  }

  clone(): FieldConstraint {
    const json = this.toJSON();
    let result = new FieldConstraint();
    result.init(json);
    return result;
  }
}

export interface IFieldConstraint {
  fieldName: string | undefined;
  lengthConstraint: number | undefined;
}

export class AjaxResponseOfShippingAddressDto implements IAjaxResponseOfShippingAddressDto {
  result: ShippingAddressDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfShippingAddressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? ShippingAddressDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfShippingAddressDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfShippingAddressDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfShippingAddressDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfShippingAddressDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfShippingAddressDto {
  result: ShippingAddressDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class InactiveHCPOrderExceptionHandlerDto implements IInactiveHCPOrderExceptionHandlerDto {
  orderId: string | undefined;
  comments: OrderCommentDto | undefined;
  action: InactiveHCPOrderExceptionHandlerDtoAction | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;

  constructor(data?: IInactiveHCPOrderExceptionHandlerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.comments = _data["comments"] ? OrderCommentDto.fromJS(_data["comments"]) : <any>undefined;
      this.action = _data["action"];
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.missingRequestDate = _data["missingRequestDate"];
    }
  }

  static fromJS(data: any): InactiveHCPOrderExceptionHandlerDto {
    data = typeof data === 'object' ? data : {};
    let result = new InactiveHCPOrderExceptionHandlerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["comments"] = this.comments ? this.comments.toJSON() : <any>undefined;
    data["action"] = this.action;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["missingRequestDate"] = this.missingRequestDate;
    return data;
  }

  clone(): InactiveHCPOrderExceptionHandlerDto {
    const json = this.toJSON();
    let result = new InactiveHCPOrderExceptionHandlerDto();
    result.init(json);
    return result;
  }
}

export interface IInactiveHCPOrderExceptionHandlerDto {
  orderId: string | undefined;
  comments: OrderCommentDto | undefined;
  action: InactiveHCPOrderExceptionHandlerDtoAction | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
}

export class AjaxResponseOfBackorderAdjustmentDetailsDto implements IAjaxResponseOfBackorderAdjustmentDetailsDto {
  result: BackorderAdjustmentDetailsDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfBackorderAdjustmentDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? BackorderAdjustmentDetailsDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfBackorderAdjustmentDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfBackorderAdjustmentDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfBackorderAdjustmentDetailsDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfBackorderAdjustmentDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfBackorderAdjustmentDetailsDto {
  result: BackorderAdjustmentDetailsDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class BackorderAdjustmentDetailsDto implements IBackorderAdjustmentDetailsDto {
  orderId: string | undefined;
  orderLines: BackorderLineItemDto[] | undefined;
  parentOrderId: string | undefined;
  linkedOrders: LinkedBackorderOrderDto[] | undefined;

  constructor(data?: IBackorderAdjustmentDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      if (Array.isArray(_data["orderLines"])) {
        this.orderLines = [] as any;
        for (let item of _data["orderLines"])
          this.orderLines.push(BackorderLineItemDto.fromJS(item));
      }
      this.parentOrderId = _data["parentOrderId"];
      if (Array.isArray(_data["linkedOrders"])) {
        this.linkedOrders = [] as any;
        for (let item of _data["linkedOrders"])
          this.linkedOrders.push(LinkedBackorderOrderDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BackorderAdjustmentDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new BackorderAdjustmentDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    if (Array.isArray(this.orderLines)) {
      data["orderLines"] = [];
      for (let item of this.orderLines)
        data["orderLines"].push(item.toJSON());
    }
    data["parentOrderId"] = this.parentOrderId;
    if (Array.isArray(this.linkedOrders)) {
      data["linkedOrders"] = [];
      for (let item of this.linkedOrders)
        data["linkedOrders"].push(item.toJSON());
    }
    return data;
  }

  clone(): BackorderAdjustmentDetailsDto {
    const json = this.toJSON();
    let result = new BackorderAdjustmentDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IBackorderAdjustmentDetailsDto {
  orderId: string | undefined;
  orderLines: BackorderLineItemDto[] | undefined;
  parentOrderId: string | undefined;
  linkedOrders: LinkedBackorderOrderDto[] | undefined;
}

export class LinkedBackorderOrderDto implements ILinkedBackorderOrderDto {
  orderId: string | undefined;
  orderNumberText: string | undefined;
  orderStatusId: string | undefined;

  constructor(data?: ILinkedBackorderOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderNumberText = _data["orderNumberText"];
      this.orderStatusId = _data["orderStatusId"];
    }
  }

  static fromJS(data: any): LinkedBackorderOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new LinkedBackorderOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderNumberText"] = this.orderNumberText;
    data["orderStatusId"] = this.orderStatusId;
    return data;
  }

  clone(): LinkedBackorderOrderDto {
    const json = this.toJSON();
    let result = new LinkedBackorderOrderDto();
    result.init(json);
    return result;
  }
}

export interface ILinkedBackorderOrderDto {
  orderId: string | undefined;
  orderNumberText: string | undefined;
  orderStatusId: string | undefined;
}

export class BackorderLineItemDto implements IBackorderLineItemDto {
  orderLineId: string | undefined;
  productId: string | undefined;
  productCode: string | undefined;
  productName: string | undefined;
  orderQty: number | undefined;
  adjustedkOrderQty: number | undefined;
  uomClassificationValueId: string | undefined;
  isBackOrdered: boolean | undefined;
  approxWmsInventory: number | undefined;
  isLineOrderRowDisabled: boolean | undefined;
  customOrderType: string | undefined;
  customOrderValue: string | undefined;

  constructor(data?: IBackorderLineItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderLineId = _data["orderLineId"];
      this.productId = _data["productId"];
      this.productCode = _data["productCode"];
      this.productName = _data["productName"];
      this.orderQty = _data["orderQty"];
      this.adjustedkOrderQty = _data["adjustedkOrderQty"];
      this.uomClassificationValueId = _data["uomClassificationValueId"];
      this.isBackOrdered = _data["isBackOrdered"];
      this.isLineOrderRowDisabled = _data["isLineOrderRowDisabled"];
      this.approxWmsInventory = _data["approxWmsInventory"];
      this.customOrderType = _data["customOrderType"];
      this.customOrderValue = _data["customOrderValue"];
    }
  }

  static fromJS(data: any): BackorderLineItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new BackorderLineItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderLineId"] = this.orderLineId;
    data["productId"] = this.productId;
    data["productCode"] = this.productCode;
    data["productName"] = this.productName;
    data["orderQty"] = this.orderQty;
    data["adjustedkOrderQty"] = this.adjustedkOrderQty;
    data["uomClassificationValueId"] = this.uomClassificationValueId;
    data["isBackOrdered"] = this.isBackOrdered;
    data["isLineOrderRowDisabled"] = this.isLineOrderRowDisabled;
    data["approxWmsInventory"] = this.approxWmsInventory;
    data["customOrderType"] = this.customOrderType;
    data["customOrderValue"] = this.customOrderValue;
    return data;
  }

  clone(): BackorderLineItemDto {
    const json = this.toJSON();
    let result = new BackorderLineItemDto();
    result.init(json);
    return result;
  }
}

export interface IBackorderLineItemDto {
  orderLineId: string | undefined;
  productId: string | undefined;
  productCode: string | undefined;
  productName: string | undefined;
  orderQty: number | undefined;
  adjustedkOrderQty: number | undefined;
  uomClassificationValueId: string | undefined;
  isBackOrdered: boolean | undefined;
  isLineOrderRowDisabled: boolean | undefined;
  approxWmsInventory: number | undefined;
  customOrderType: string | undefined;
  customOrderValue: string | undefined;
}

export class BackorderAdjustmentSubmitForRevalidationDto implements IBackorderAdjustmentSubmitForRevalidationDto {
  orderId: string | undefined;
  comments: OrderCommentDto | undefined;
  cancelledOrderLineIds: string[] | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;

  constructor(data?: IBackorderAdjustmentSubmitForRevalidationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.comments = _data["comments"] ? OrderCommentDto.fromJS(_data["comments"]) : <any>undefined;
      if (Array.isArray(_data["cancelledOrderLineIds"])) {
        this.cancelledOrderLineIds = [] as any;
        for (let item of _data["cancelledOrderLineIds"])
          this.cancelledOrderLineIds.push(item);
      }
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      this.missingRequestDate = _data["missingRequestDate"];
    }
  }

  static fromJS(data: any): BackorderAdjustmentSubmitForRevalidationDto {
    data = typeof data === 'object' ? data : {};
    let result = new BackorderAdjustmentSubmitForRevalidationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["comments"] = this.comments ? this.comments.toJSON() : <any>undefined;
    if (Array.isArray(this.cancelledOrderLineIds)) {
      data["cancelledOrderLineIds"] = [];
      for (let item of this.cancelledOrderLineIds)
        data["cancelledOrderLineIds"].push(item);
    }
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["missingRequestDate"] = this.missingRequestDate;
    return data;
  }

  clone(): BackorderAdjustmentSubmitForRevalidationDto {
    const json = this.toJSON();
    let result = new BackorderAdjustmentSubmitForRevalidationDto();
    result.init(json);
    return result;
  }
}

export interface IBackorderAdjustmentSubmitForRevalidationDto {
  orderId: string | undefined;
  comments: OrderCommentDto | undefined;
  cancelledOrderLineIds: string[] | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  requestDate: Date | undefined;
  missingRequestDate: boolean | undefined;
}

export class AjaxResponse implements IAjaxResponse {
  result: any | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponse {
    const json = this.toJSON();
    let result = new AjaxResponse();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponse {
  result: any | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class OrderBlackoutHoldReleaseReasonDto implements IOrderBlackoutHoldReleaseReasonDto {
  orderId: string | undefined;
  blackoutHoldReleaseReasonId: string | undefined;
  blackoutHoldReleaseReasonDescription: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;

  constructor(data?: IOrderBlackoutHoldReleaseReasonDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.blackoutHoldReleaseReasonId = _data["blackoutHoldReleaseReasonId"];
      this.blackoutHoldReleaseReasonDescription = _data["blackoutHoldReleaseReasonDescription"];
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
    }
  }

  static fromJS(data: any): OrderBlackoutHoldReleaseReasonDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderBlackoutHoldReleaseReasonDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["blackoutHoldReleaseReasonId"] = this.blackoutHoldReleaseReasonId;
    data["blackoutHoldReleaseReasonDescription"] = this.blackoutHoldReleaseReasonDescription;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    return data;
  }

  clone(): OrderBlackoutHoldReleaseReasonDto {
    const json = this.toJSON();
    let result = new OrderBlackoutHoldReleaseReasonDto();
    result.init(json);
    return result;
  }
}

export interface IOrderBlackoutHoldReleaseReasonDto {
  orderId: string | undefined;
  blackoutHoldReleaseReasonId: string | undefined;
  blackoutHoldReleaseReasonDescription: string | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
}

export class OrderOnHoldReleaseReasonDto implements IOrderOnHoldReleaseReasonDto {
  orderId: string | undefined;
  onHoldReleaseReasonId: string | undefined;
  onHoldReleaseReasonDescription: string | undefined;
  onHoldScheduledShipToDate: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  externalNotes: string | undefined;
  salesOrderTypeId: string | undefined;

  constructor(data?: IOrderOnHoldReleaseReasonDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.onHoldReleaseReasonId = _data["onHoldReleaseReasonId"];
      this.onHoldReleaseReasonDescription = _data["onHoldReleaseReasonDescription"];
      this.onHoldScheduledShipToDate = _data["onHoldScheduledShipToDate"] ? new Date(_data["onHoldScheduledShipToDate"].toString()) : <any>undefined;
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      this.externalNotes = _data["externalNotes"];
      this.salesOrderTypeId = _data["salesOrderTypeId"];
    }
  }

  static fromJS(data: any): OrderOnHoldReleaseReasonDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderOnHoldReleaseReasonDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["onHoldReleaseReasonId"] = this.onHoldReleaseReasonId;
    data["onHoldReleaseReasonDescription"] = this.onHoldReleaseReasonDescription;
    data["onHoldScheduledShipToDate"] = this.onHoldScheduledShipToDate ? this.onHoldScheduledShipToDate.toISOString() : <any>undefined;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    data["externalNotes"] = this.externalNotes;
    data["salesOrderTypeId"] = this.salesOrderTypeId;
    return data;
  }

  clone(): OrderOnHoldReleaseReasonDto {
    const json = this.toJSON();
    let result = new OrderOnHoldReleaseReasonDto();
    result.init(json);
    return result;
  }
}

export interface IOrderOnHoldReleaseReasonDto {
  orderId: string | undefined;
  onHoldReleaseReasonId: string | undefined;
  onHoldReleaseReasonDescription: string | undefined;
  onHoldScheduledShipToDate: Date | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  externalNotes: string | undefined;
  salesOrderTypeId: string | undefined;
}

export class BulkReleaseOnHoldOrderRequestDto implements IBulkReleaseOnHoldOrderRequestDto {
  releaseOnHoldOrders: ReleaseOnHoldOrderDto[] | undefined;
  releaseReasonId: string | undefined;
  releaseDescription: string | undefined;

  constructor(data?: IBulkReleaseOnHoldOrderRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["releaseOnHoldOrders"])) {
        this.releaseOnHoldOrders = [] as any;
        for (let item of _data["releaseOnHoldOrders"])
          this.releaseOnHoldOrders.push(ReleaseOnHoldOrderDto.fromJS(item));
      }
      this.releaseReasonId = _data["releaseReasonId"];
      this.releaseDescription = _data["releaseDescription"];
    }
  }

  static fromJS(data: any): BulkReleaseOnHoldOrderRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new BulkReleaseOnHoldOrderRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.releaseOnHoldOrders)) {
      data["releaseOnHoldOrders"] = [];
      for (let item of this.releaseOnHoldOrders)
        data["releaseOnHoldOrders"].push(item.toJSON());
    }
    data["releaseReasonId"] = this.releaseReasonId;
    data["releaseDescription"] = this.releaseDescription;
    return data;
  }

  clone(): BulkReleaseOnHoldOrderRequestDto {
    const json = this.toJSON();
    let result = new BulkReleaseOnHoldOrderRequestDto();
    result.init(json);
    return result;
  }
}

export interface IBulkReleaseOnHoldOrderRequestDto {
  releaseOnHoldOrders: ReleaseOnHoldOrderDto[] | undefined;
  releaseReasonId: string | undefined;
  releaseDescription: string | undefined;
}

export class ReleaseOnHoldOrderDto implements IReleaseOnHoldOrderDto {
  orderNumber: string | undefined;
  orderId: string | undefined;
  statusReasonTypeId: string | undefined;

  constructor(data?: IReleaseOnHoldOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderNumber = _data["orderNumber"];
      this.orderId = _data["orderId"];
      this.statusReasonTypeId = _data["statusReasonTypeId"];
    }
  }

  static fromJS(data: any): ReleaseOnHoldOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReleaseOnHoldOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderNumber"] = this.orderNumber;
    data["orderId"] = this.orderId;
    data["statusReasonTypeId"] = this.statusReasonTypeId;
    return data;
  }

  clone(): ReleaseOnHoldOrderDto {
    const json = this.toJSON();
    let result = new ReleaseOnHoldOrderDto();
    result.init(json);
    return result;
  }
}

export interface IReleaseOnHoldOrderDto {
  orderNumber: string | undefined;
  orderId: string | undefined;
  statusReasonTypeId: string | undefined;
}

export class AjaxResponseOfBulkReleaseOnHoldOrderResponseDto implements IAjaxResponseOfBulkReleaseOnHoldOrderResponseDto {
  result: BulkReleaseOnHoldOrderResponseDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfBulkReleaseOnHoldOrderResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? BulkReleaseOnHoldOrderResponseDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfBulkReleaseOnHoldOrderResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfBulkReleaseOnHoldOrderResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfBulkReleaseOnHoldOrderResponseDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfBulkReleaseOnHoldOrderResponseDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfBulkReleaseOnHoldOrderResponseDto {
  result: BulkReleaseOnHoldOrderResponseDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class BulkReleaseOnHoldOrderResponseDto implements IBulkReleaseOnHoldOrderResponseDto {
  releasedOrderCount: number | undefined;

  constructor(data?: IBulkReleaseOnHoldOrderResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.releasedOrderCount = _data["releasedOrderCount"];
    }
  }

  static fromJS(data: any): BulkReleaseOnHoldOrderResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new BulkReleaseOnHoldOrderResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["releasedOrderCount"] = this.releasedOrderCount;
    return data;
  }

  clone(): BulkReleaseOnHoldOrderResponseDto {
    const json = this.toJSON();
    let result = new BulkReleaseOnHoldOrderResponseDto();
    result.init(json);
    return result;
  }
}

export interface IBulkReleaseOnHoldOrderResponseDto {
  releasedOrderCount: number | undefined;
}

export class AjaxResponseOfGuid implements IAjaxResponseOfGuid {
  result: string | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfGuid) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"];
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfGuid {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfGuid();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfGuid {
    const json = this.toJSON();
    let result = new AjaxResponseOfGuid();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfGuid {
  result: string | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class AjaxResponseOfAocInvestigationDto implements IAjaxResponseOfAocInvestigationDto {
  result: AocInvestigationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfAocInvestigationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? AocInvestigationDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfAocInvestigationDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfAocInvestigationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfAocInvestigationDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfAocInvestigationDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfAocInvestigationDto {
  result: AocInvestigationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class AocInvestigationDto implements IAocInvestigationDto {
  aocId: string | undefined;
  aocInvestigationReasonClassificationValueIds: string[] | undefined;
  isAocDocumentValid: boolean | undefined;
  investigationComment: string | undefined;
  isInvestigationSubmitted: boolean | undefined;

  constructor(data?: IAocInvestigationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.aocId = _data["aocId"];
      if (Array.isArray(_data["aocInvestigationReasonClassificationValueIds"])) {
        this.aocInvestigationReasonClassificationValueIds = [] as any;
        for (let item of _data["aocInvestigationReasonClassificationValueIds"])
          this.aocInvestigationReasonClassificationValueIds.push(item);
      }
      this.isAocDocumentValid = _data["isAocDocumentValid"];
      this.investigationComment = _data["investigationComment"];
      this.isInvestigationSubmitted = _data["isInvestigationSubmitted"];
    }
  }

  static fromJS(data: any): AocInvestigationDto {
    data = typeof data === 'object' ? data : {};
    let result = new AocInvestigationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["aocId"] = this.aocId;
    if (Array.isArray(this.aocInvestigationReasonClassificationValueIds)) {
      data["aocInvestigationReasonClassificationValueIds"] = [];
      for (let item of this.aocInvestigationReasonClassificationValueIds)
        data["aocInvestigationReasonClassificationValueIds"].push(item);
    }
    data["isAocDocumentValid"] = this.isAocDocumentValid;
    data["investigationComment"] = this.investigationComment;
    data["isInvestigationSubmitted"] = this.isInvestigationSubmitted;
    return data;
  }

  clone(): AocInvestigationDto {
    const json = this.toJSON();
    let result = new AocInvestigationDto();
    result.init(json);
    return result;
  }
}

export interface IAocInvestigationDto {
  aocId: string | undefined;
  aocInvestigationReasonClassificationValueIds: string[] | undefined;
  isAocDocumentValid: boolean | undefined;
  investigationComment: string | undefined;
  isInvestigationSubmitted: boolean | undefined;
}

export class AjaxResponseOfSvlInvestigationDto implements IAjaxResponseOfSvlInvestigationDto {
  result: SvlInvestigationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfSvlInvestigationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? SvlInvestigationDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfSvlInvestigationDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfSvlInvestigationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfSvlInvestigationDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfSvlInvestigationDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfSvlInvestigationDto {
  result: SvlInvestigationDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class SvlInvestigationDto implements ISvlInvestigationDto {
  svlId: string | undefined;
  svlTypeClassificationValueId: string | undefined;
  svlInvestigationReasonClassificationValueIds: string[] | undefined;
  isSvlDocumentValid: boolean | undefined;
  investigationComment: string | undefined;
  isInvestigationSubmitted: boolean | undefined;

  constructor(data?: ISvlInvestigationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.svlId = _data["svlId"];
      this.svlTypeClassificationValueId = _data["svlTypeClassificationValueId"];
      if (Array.isArray(_data["svlInvestigationReasonClassificationValueIds"])) {
        this.svlInvestigationReasonClassificationValueIds = [] as any;
        for (let item of _data["svlInvestigationReasonClassificationValueIds"])
          this.svlInvestigationReasonClassificationValueIds.push(item);
      }
      this.isSvlDocumentValid = _data["isSvlDocumentValid"];
      this.investigationComment = _data["investigationComment"];
      this.isInvestigationSubmitted = _data["isInvestigationSubmitted"];
    }
  }

  static fromJS(data: any): SvlInvestigationDto {
    data = typeof data === 'object' ? data : {};
    let result = new SvlInvestigationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["svlId"] = this.svlId;
    data["svlTypeClassificationValueId"] = this.svlTypeClassificationValueId;
    if (Array.isArray(this.svlInvestigationReasonClassificationValueIds)) {
      data["svlInvestigationReasonClassificationValueIds"] = [];
      for (let item of this.svlInvestigationReasonClassificationValueIds)
        data["svlInvestigationReasonClassificationValueIds"].push(item);
    }
    data["isSvlDocumentValid"] = this.isSvlDocumentValid;
    data["investigationComment"] = this.investigationComment;
    data["isInvestigationSubmitted"] = this.isInvestigationSubmitted;
    return data;
  }

  clone(): SvlInvestigationDto {
    const json = this.toJSON();
    let result = new SvlInvestigationDto();
    result.init(json);
    return result;
  }
}

export interface ISvlInvestigationDto {
  svlId: string | undefined;
  svlTypeClassificationValueId: string | undefined;
  svlInvestigationReasonClassificationValueIds: string[] | undefined;
  isSvlDocumentValid: boolean | undefined;
  investigationComment: string | undefined;
  isInvestigationSubmitted: boolean | undefined;
}

export class AjaxResponseOfSvlNegativeResponseCommentHistoryDto implements IAjaxResponseOfSvlNegativeResponseCommentHistoryDto {
  result: SvlNegativeResponseCommentHistoryDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfSvlNegativeResponseCommentHistoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? SvlNegativeResponseCommentHistoryDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfSvlNegativeResponseCommentHistoryDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfSvlNegativeResponseCommentHistoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfSvlNegativeResponseCommentHistoryDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfSvlNegativeResponseCommentHistoryDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfSvlNegativeResponseCommentHistoryDto {
  result: SvlNegativeResponseCommentHistoryDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class SvlNegativeResponseCommentHistoryDto implements ISvlNegativeResponseCommentHistoryDto {
  svlId: string | undefined;
  svlNegativeResponseComments: SvlNegativeResponseCommentDto[] | undefined;

  constructor(data?: ISvlNegativeResponseCommentHistoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.svlId = _data["svlId"];
      if (Array.isArray(_data["svlNegativeResponseComments"])) {
        this.svlNegativeResponseComments = [] as any;
        for (let item of _data["svlNegativeResponseComments"])
          this.svlNegativeResponseComments.push(SvlNegativeResponseCommentDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SvlNegativeResponseCommentHistoryDto {
    data = typeof data === 'object' ? data : {};
    let result = new SvlNegativeResponseCommentHistoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["svlId"] = this.svlId;
    if (Array.isArray(this.svlNegativeResponseComments)) {
      data["svlNegativeResponseComments"] = [];
      for (let item of this.svlNegativeResponseComments)
        data["svlNegativeResponseComments"].push(item.toJSON());
    }
    return data;
  }

  clone(): SvlNegativeResponseCommentHistoryDto {
    const json = this.toJSON();
    let result = new SvlNegativeResponseCommentHistoryDto();
    result.init(json);
    return result;
  }
}

export interface ISvlNegativeResponseCommentHistoryDto {
  svlId: string | undefined;
  svlNegativeResponseComments: SvlNegativeResponseCommentDto[] | undefined;
}

export class SvlNegativeResponseCommentDto implements ISvlNegativeResponseCommentDto {
  svlId: string | undefined;
  comment: string | undefined;
  creatorUserId: number | undefined;
  creationTime: Date | undefined;

  constructor(data?: ISvlNegativeResponseCommentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.svlId = _data["svlId"];
      this.comment = _data["comment"];
      this.creatorUserId = _data["creatorUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): SvlNegativeResponseCommentDto {
    data = typeof data === 'object' ? data : {};
    let result = new SvlNegativeResponseCommentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["svlId"] = this.svlId;
    data["comment"] = this.comment;
    data["creatorUserId"] = this.creatorUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    return data;
  }

  clone(): SvlNegativeResponseCommentDto {
    const json = this.toJSON();
    let result = new SvlNegativeResponseCommentDto();
    result.init(json);
    return result;
  }
}

export interface ISvlNegativeResponseCommentDto {
  svlId: string | undefined;
  comment: string | undefined;
  creatorUserId: number | undefined;
  creationTime: Date | undefined;
}

export class AjaxResponseOfDataEntryOrderDto implements IAjaxResponseOfDataEntryOrderDto {
  result: DataEntryOrderDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfDataEntryOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? DataEntryOrderDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfDataEntryOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfDataEntryOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfDataEntryOrderDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfDataEntryOrderDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfDataEntryOrderDto {
  result: DataEntryOrderDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class DataEntryOrderDto implements IDataEntryOrderDto {
  id: string | undefined;
  offerId: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  orderDate: Date | undefined;
  requestDate: Date | undefined;
  readonly orderStatusTimeDiff: number | undefined;
  orderStatusLastModifiedTime: Date | undefined;
  program: string | undefined;
  jobId: string | undefined;
  orderSourceId: string | undefined;
  relatedOfferId: string | undefined;
  relatedOfferNumber: string | undefined;
  formId: string | undefined;
  formIdMissingFlag: boolean | undefined;
  formIdNotApplicableFlag: boolean | undefined;
  formIdUnmatchedFlag: boolean | undefined;
  batchNumber: string | undefined;
  batchDate: Date | undefined;
  salesRepNbr: string | undefined;
  salesRepFirstName: string | undefined;
  salesRepLastName: string | undefined;
  territoryCode: string | undefined;
  missingSalesRepIdFlag: boolean | undefined;
  missingSalesRepFirstNameFlag: boolean | undefined;
  missingSalesRepLastNameFlag: boolean | undefined;
  missingTerritoryCodeFlag: boolean | undefined;
  reasonForModificationFromOfferSalesRepNbr: string | undefined;
  reasonForModificationFromOfferSalesRepFirstName: string | undefined;
  reasonForModificationFromOfferSalesRepLastName: string | undefined;
  reasonForModificationFromOfferTerritoryCode: string | undefined;
  missingOrderRequestDateFlag: boolean | undefined;
  reasonForModificationFromOfferOrderRequestDate: string | undefined;
  sourceCode: string | undefined;
  sourceCodeFlag: boolean | undefined;
  requestorDetails: DataEntryOrderHcpDetailsDto | undefined;
  recipientDetails: DataEntryOrderHcpDetailsDto | undefined;
  offeredQtyFlag: boolean | undefined;
  orderLines: DataEntryOrderLineDto[] | undefined;
  tuesdayDeliveryFlag: boolean | undefined;
  wednesdayDeliveryFlag: boolean | undefined;
  thursdayDeliveryFlag: boolean | undefined;
  fridayDeliveryFlag: boolean | undefined;
  acceptableDaysMissingFlag: boolean | undefined;
  rushFlag: boolean | undefined;
  optOutFlag: boolean | undefined;
  ohioTDDDExemptionFlag: boolean | undefined;
  hcpSignaturePresentFlag: boolean | undefined;
  hcpSignatureStampedFlag: boolean | undefined;
  hcpSignatureMatchFlag: boolean | undefined;
  hcpSignatureDateStampedFlag: boolean | undefined;
  hcpSignedDatePresentFlag: boolean | undefined;
  hcpSignatureDate: Date | undefined;
  hcpSignatureMissingFlag: boolean | undefined;
  requestorComment: string | undefined;
  srfAdverseEventFlag: boolean | undefined;
  srfAdverseEventComment: string | undefined;
  hasKnipperGeneratedSrf: boolean | undefined;
  hasThirdPartyGeneratedSrf: boolean | undefined;
  hasPreFilledSrf: boolean | undefined;
  hasBlankSrf: boolean | undefined;
  repDrivenFlag: boolean | undefined;
  institutionFlag: boolean | undefined;
  displayDeaFlag: boolean | undefined;
  displaySpecialtyFlag: boolean | undefined;
  displaySanFlag: boolean | undefined;
  displayTuesdayDeliveryFlag: boolean | undefined;
  displayWednesdayDeliveryFlag: boolean | undefined;
  displayThursdayDeliveryFlag: boolean | undefined;
  displayFridayDeliveryFlag: boolean | undefined;
  unauthorizedFormChanges: DataEntryOrderUnauthorizedFormChangeDto | undefined;
  lockInfo: LockDto | undefined;
  prohibitedFormModFields: string[] | undefined;
  submitFlag: boolean | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  names: LocalizedValue[] | undefined;

  constructor(data?: IDataEntryOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.offerId = _data["offerId"];
      this.orderNumber = _data["orderNumber"];
      this.externalOrderNumber = _data["externalOrderNumber"];
      this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : <any>undefined;
      (<any>this).orderStatusTimeDiff = _data["orderStatusTimeDiff"];
      this.orderStatusLastModifiedTime = _data["orderStatusLastModifiedTime"] ? new Date(_data["orderStatusLastModifiedTime"].toString()) : <any>undefined;
      this.program = _data["program"];
      this.jobId = _data["jobId"];
      this.orderSourceId = _data["orderSourceId"];
      this.relatedOfferId = _data["relatedOfferId"];
      this.relatedOfferNumber = _data["relatedOfferNumber"];
      this.formId = _data["formId"];
      this.formIdMissingFlag = _data["formIdMissingFlag"];
      this.formIdNotApplicableFlag = _data["formIdNotApplicableFlag"];
      this.formIdUnmatchedFlag = _data["formIdUnmatchedFlag"];
      this.batchNumber = _data["batchNumber"];
      this.batchDate = _data["batchDate"] ? new Date(_data["batchDate"].toString()) : <any>undefined;
      this.salesRepNbr = _data["salesRepNbr"];
      this.salesRepFirstName = _data["salesRepFirstName"];
      this.salesRepLastName = _data["salesRepLastName"];
      this.territoryCode = _data["territoryCode"];
      this.missingSalesRepIdFlag = _data["missingSalesRepIdFlag"];
      this.missingSalesRepFirstNameFlag = _data["missingSalesRepFirstNameFlag"];
      this.missingSalesRepLastNameFlag = _data["missingSalesRepLastNameFlag"];
      this.missingTerritoryCodeFlag = _data["missingTerritoryCodeFlag"];
      this.reasonForModificationFromOfferSalesRepNbr = _data["reasonForModificationFromOfferSalesRepNbr"];
      this.reasonForModificationFromOfferSalesRepFirstName = _data["reasonForModificationFromOfferSalesRepFirstName"];
      this.reasonForModificationFromOfferSalesRepLastName = _data["reasonForModificationFromOfferSalesRepLastName"];
      this.reasonForModificationFromOfferTerritoryCode = _data["reasonForModificationFromOfferTerritoryCode"];
      this.missingOrderRequestDateFlag = _data["missingOrderRequestDateFlag"];
      this.reasonForModificationFromOfferOrderRequestDate = _data["reasonForModificationFromOfferOrderRequestDate"];
      this.sourceCode = _data["sourceCode"];
      this.sourceCodeFlag = _data["sourceCodeFlag"];
      this.requestorDetails = _data["requestorDetails"] ? DataEntryOrderHcpDetailsDto.fromJS(_data["requestorDetails"]) : <any>undefined;
      this.recipientDetails = _data["recipientDetails"] ? DataEntryOrderHcpDetailsDto.fromJS(_data["recipientDetails"]) : <any>undefined;
      this.offeredQtyFlag = _data["offeredQtyFlag"];
      if (Array.isArray(_data["orderLines"])) {
        this.orderLines = [] as any;
        for (let item of _data["orderLines"])
          this.orderLines.push(DataEntryOrderLineDto.fromJS(item));
      }
      this.tuesdayDeliveryFlag = _data["tuesdayDeliveryFlag"];
      this.wednesdayDeliveryFlag = _data["wednesdayDeliveryFlag"];
      this.thursdayDeliveryFlag = _data["thursdayDeliveryFlag"];
      this.fridayDeliveryFlag = _data["fridayDeliveryFlag"];
      this.acceptableDaysMissingFlag = _data["acceptableDaysMissingFlag"];
      this.rushFlag = _data["rushFlag"];
      this.optOutFlag = _data["optOutFlag"];
      this.ohioTDDDExemptionFlag = _data["ohioTDDDExemptionFlag"];
      this.hcpSignaturePresentFlag = _data["hcpSignaturePresentFlag"];
      this.hcpSignatureStampedFlag = _data["hcpSignatureStampedFlag"];
      this.hcpSignatureMatchFlag = _data["hcpSignatureMatchFlag"];
      this.hcpSignatureDateStampedFlag = _data["hcpSignatureDateStampedFlag"];
      this.hcpSignedDatePresentFlag = _data["hcpSignedDatePresentFlag"];
      this.hcpSignatureDate = _data["hcpSignatureDate"] ? new Date(_data["hcpSignatureDate"].toString()) : <any>undefined;
      this.hcpSignatureMissingFlag = _data["hcpSignatureMissingFlag"];
      this.requestorComment = _data["requestorComment"];
      this.srfAdverseEventFlag = _data["srfAdverseEventFlag"];
      this.srfAdverseEventComment = _data["srfAdverseEventComment"];
      this.hasKnipperGeneratedSrf = _data["hasKnipperGeneratedSrf"];
      this.hasThirdPartyGeneratedSrf = _data["hasThirdPartyGeneratedSrf"];
      this.hasPreFilledSrf = _data["hasPreFilledSrf"];
      this.hasBlankSrf = _data["hasBlankSrf"];
      this.repDrivenFlag = _data["repDrivenFlag"];
      this.institutionFlag = _data["institutionFlag"];
      this.displayDeaFlag = _data["displayDeaFlag"];
      this.displaySpecialtyFlag = _data["displaySpecialtyFlag"];
      this.displaySanFlag = _data["displaySanFlag"];
      this.displayTuesdayDeliveryFlag = _data["displayTuesdayDeliveryFlag"];
      this.displayWednesdayDeliveryFlag = _data["displayWednesdayDeliveryFlag"];
      this.displayThursdayDeliveryFlag = _data["displayThursdayDeliveryFlag"];
      this.displayFridayDeliveryFlag = _data["displayFridayDeliveryFlag"];
      this.unauthorizedFormChanges = _data["unauthorizedFormChanges"] ? DataEntryOrderUnauthorizedFormChangeDto.fromJS(_data["unauthorizedFormChanges"]) : <any>undefined;
      this.lockInfo = _data["lockInfo"] ? LockDto.fromJS(_data["lockInfo"]) : <any>undefined;
      if (Array.isArray(_data["prohibitedFormModFields"])) {
        this.prohibitedFormModFields = [] as any;
        for (let item of _data["prohibitedFormModFields"])
          this.prohibitedFormModFields.push(item);
      }
      this.submitFlag = _data["submitFlag"];
      this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
      this.lastModifierUserId = _data["lastModifierUserId"];
      if (Array.isArray(_data["names"])) {
        this.names = [] as any;
        for (let item of _data["names"])
          this.names.push(LocalizedValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DataEntryOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new DataEntryOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["offerId"] = this.offerId;
    data["orderNumber"] = this.orderNumber;
    data["externalOrderNumber"] = this.externalOrderNumber;
    data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
    data["orderStatusTimeDiff"] = this.orderStatusTimeDiff;
    data["orderStatusLastModifiedTime"] = this.orderStatusLastModifiedTime ? this.orderStatusLastModifiedTime.toISOString() : <any>undefined;
    data["program"] = this.program;
    data["jobId"] = this.jobId;
    data["orderSourceId"] = this.orderSourceId;
    data["relatedOfferId"] = this.relatedOfferId;
    data["relatedOfferNumber"] = this.relatedOfferNumber;
    data["formId"] = this.formId;
    data["formIdMissingFlag"] = this.formIdMissingFlag;
    data["formIdNotApplicableFlag"] = this.formIdNotApplicableFlag;
    data["formIdUnmatchedFlag"] = this.formIdUnmatchedFlag;
    data["batchNumber"] = this.batchNumber;
    data["batchDate"] = this.batchDate ? this.batchDate.toISOString() : <any>undefined;
    data["salesRepNbr"] = this.salesRepNbr;
    data["salesRepFirstName"] = this.salesRepFirstName;
    data["salesRepLastName"] = this.salesRepLastName;
    data["territoryCode"] = this.territoryCode;
    data["missingSalesRepIdFlag"] = this.missingSalesRepIdFlag;
    data["missingSalesRepFirstNameFlag"] = this.missingSalesRepFirstNameFlag;
    data["missingSalesRepLastNameFlag"] = this.missingSalesRepLastNameFlag;
    data["missingTerritoryCodeFlag"] = this.missingTerritoryCodeFlag;
    data["reasonForModificationFromOfferSalesRepNbr"] = this.reasonForModificationFromOfferSalesRepNbr;
    data["reasonForModificationFromOfferSalesRepFirstName"] = this.reasonForModificationFromOfferSalesRepFirstName;
    data["reasonForModificationFromOfferSalesRepLastName"] = this.reasonForModificationFromOfferSalesRepLastName;
    data["reasonForModificationFromOfferTerritoryCode"] = this.reasonForModificationFromOfferTerritoryCode;
    data["missingOrderRequestDateFlag"] = this.missingOrderRequestDateFlag;
    data["reasonForModificationFromOfferOrderRequestDate"] = this.reasonForModificationFromOfferOrderRequestDate;
    data["sourceCode"] = this.sourceCode;
    data["sourceCodeFlag"] = this.sourceCodeFlag;
    data["requestorDetails"] = this.requestorDetails ? this.requestorDetails.toJSON() : <any>undefined;
    data["recipientDetails"] = this.recipientDetails ? this.recipientDetails.toJSON() : <any>undefined;
    data["offeredQtyFlag"] = this.offeredQtyFlag;
    if (Array.isArray(this.orderLines)) {
      data["orderLines"] = [];
      for (let item of this.orderLines)
        data["orderLines"].push(item.toJSON());
    }
    data["tuesdayDeliveryFlag"] = this.tuesdayDeliveryFlag;
    data["wednesdayDeliveryFlag"] = this.wednesdayDeliveryFlag;
    data["thursdayDeliveryFlag"] = this.thursdayDeliveryFlag;
    data["fridayDeliveryFlag"] = this.fridayDeliveryFlag;
    data["acceptableDaysMissingFlag"] = this.acceptableDaysMissingFlag;
    data["rushFlag"] = this.rushFlag;
    data["optOutFlag"] = this.optOutFlag;
    data["ohioTDDDExemptionFlag"] = this.ohioTDDDExemptionFlag;
    data["hcpSignaturePresentFlag"] = this.hcpSignaturePresentFlag;
    data["hcpSignatureStampedFlag"] = this.hcpSignatureStampedFlag;
    data["hcpSignatureMatchFlag"] = this.hcpSignatureMatchFlag;
    data["hcpSignatureDateStampedFlag"] = this.hcpSignatureDateStampedFlag;
    data["hcpSignedDatePresentFlag"] = this.hcpSignedDatePresentFlag;
    data["hcpSignatureDate"] = this.hcpSignatureDate ? this.hcpSignatureDate.toISOString() : <any>undefined;
    data["hcpSignatureMissingFlag"] = this.hcpSignatureMissingFlag;
    data["requestorComment"] = this.requestorComment;
    data["srfAdverseEventFlag"] = this.srfAdverseEventFlag;
    data["srfAdverseEventComment"] = this.srfAdverseEventComment;
    data["hasKnipperGeneratedSrf"] = this.hasKnipperGeneratedSrf;
    data["hasThirdPartyGeneratedSrf"] = this.hasThirdPartyGeneratedSrf;
    data["hasPreFilledSrf"] = this.hasPreFilledSrf;
    data["hasBlankSrf"] = this.hasBlankSrf;
    data["repDrivenFlag"] = this.repDrivenFlag;
    data["institutionFlag"] = this.institutionFlag;
    data["displayDeaFlag"] = this.displayDeaFlag;
    data["displaySpecialtyFlag"] = this.displaySpecialtyFlag;
    data["displaySanFlag"] = this.displaySanFlag;
    data["displayTuesdayDeliveryFlag"] = this.displayTuesdayDeliveryFlag;
    data["displayWednesdayDeliveryFlag"] = this.displayWednesdayDeliveryFlag;
    data["displayThursdayDeliveryFlag"] = this.displayThursdayDeliveryFlag;
    data["displayFridayDeliveryFlag"] = this.displayFridayDeliveryFlag;
    data["unauthorizedFormChanges"] = this.unauthorizedFormChanges ? this.unauthorizedFormChanges.toJSON() : <any>undefined;
    data["lockInfo"] = this.lockInfo ? this.lockInfo.toJSON() : <any>undefined;
    if (Array.isArray(this.prohibitedFormModFields)) {
      data["prohibitedFormModFields"] = [];
      for (let item of this.prohibitedFormModFields)
        data["prohibitedFormModFields"].push(item);
    }
    data["submitFlag"] = this.submitFlag;
    data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data["lastModifierUserId"] = this.lastModifierUserId;
    if (Array.isArray(this.names)) {
      data["names"] = [];
      for (let item of this.names)
        data["names"].push(item.toJSON());
    }
    return data;
  }

  clone(): DataEntryOrderDto {
    const json = this.toJSON();
    let result = new DataEntryOrderDto();
    result.init(json);
    return result;
  }
}

export interface IDataEntryOrderDto {
  id: string | undefined;
  offerId: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  orderDate: Date | undefined;
  requestDate: Date | undefined;
  orderStatusTimeDiff: number | undefined;
  orderStatusLastModifiedTime: Date | undefined;
  program: string | undefined;
  jobId: string | undefined;
  orderSourceId: string | undefined;
  relatedOfferId: string | undefined;
  relatedOfferNumber: string | undefined;
  formId: string | undefined;
  formIdMissingFlag: boolean | undefined;
  formIdNotApplicableFlag: boolean | undefined;
  formIdUnmatchedFlag: boolean | undefined;
  batchNumber: string | undefined;
  batchDate: Date | undefined;
  salesRepNbr: string | undefined;
  salesRepFirstName: string | undefined;
  salesRepLastName: string | undefined;
  territoryCode: string | undefined;
  missingSalesRepIdFlag: boolean | undefined;
  missingSalesRepFirstNameFlag: boolean | undefined;
  missingSalesRepLastNameFlag: boolean | undefined;
  missingTerritoryCodeFlag: boolean | undefined;
  reasonForModificationFromOfferSalesRepNbr: string | undefined;
  reasonForModificationFromOfferSalesRepFirstName: string | undefined;
  reasonForModificationFromOfferSalesRepLastName: string | undefined;
  reasonForModificationFromOfferTerritoryCode: string | undefined;
  missingOrderRequestDateFlag: boolean | undefined;
  reasonForModificationFromOfferOrderRequestDate: string | undefined;
  sourceCode: string | undefined;
  sourceCodeFlag: boolean | undefined;
  requestorDetails: DataEntryOrderHcpDetailsDto | undefined;
  recipientDetails: DataEntryOrderHcpDetailsDto | undefined;
  offeredQtyFlag: boolean | undefined;
  orderLines: DataEntryOrderLineDto[] | undefined;
  tuesdayDeliveryFlag: boolean | undefined;
  wednesdayDeliveryFlag: boolean | undefined;
  thursdayDeliveryFlag: boolean | undefined;
  fridayDeliveryFlag: boolean | undefined;
  acceptableDaysMissingFlag: boolean | undefined;
  rushFlag: boolean | undefined;
  optOutFlag: boolean | undefined;
  ohioTDDDExemptionFlag: boolean | undefined;
  hcpSignaturePresentFlag: boolean | undefined;
  hcpSignatureStampedFlag: boolean | undefined;
  hcpSignatureMatchFlag: boolean | undefined;
  hcpSignatureDateStampedFlag: boolean | undefined;
  hcpSignedDatePresentFlag: boolean | undefined;
  hcpSignatureDate: Date | undefined;
  hcpSignatureMissingFlag: boolean | undefined;
  requestorComment: string | undefined;
  srfAdverseEventFlag: boolean | undefined;
  srfAdverseEventComment: string | undefined;
  hasKnipperGeneratedSrf: boolean | undefined;
  hasThirdPartyGeneratedSrf: boolean | undefined;
  hasPreFilledSrf: boolean | undefined;
  hasBlankSrf: boolean | undefined;
  repDrivenFlag: boolean | undefined;
  institutionFlag: boolean | undefined;
  displayDeaFlag: boolean | undefined;
  displaySpecialtyFlag: boolean | undefined;
  displaySanFlag: boolean | undefined;
  displayTuesdayDeliveryFlag: boolean | undefined;
  displayWednesdayDeliveryFlag: boolean | undefined;
  displayThursdayDeliveryFlag: boolean | undefined;
  displayFridayDeliveryFlag: boolean | undefined;
  unauthorizedFormChanges: DataEntryOrderUnauthorizedFormChangeDto | undefined;
  lockInfo: LockDto | undefined;
  prohibitedFormModFields: string[] | undefined;
  submitFlag: boolean | undefined;
  lastModificationTime: Date | undefined;
  lastModifierUserId: number | undefined;
  names: LocalizedValue[] | undefined;
}

export class DataEntryOrderHcpDetailsDto implements IDataEntryOrderHcpDetailsDto {
  hcpId: string | undefined;
  knipperHcpId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  suffixId: string | undefined;
  professionalDesignationId: string | undefined;
  professionalDesignationCode: string | undefined;
  professionalSpecialtyCode: string | undefined;
  specialtyId: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  countryId: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  addressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  deaNbr: string | undefined;
  emailAddressText: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
  missingFirstNameFlag: boolean | undefined;
  missingLastNameFlag: boolean | undefined;
  missingSpecialtyCodeFlag: boolean | undefined;
  missingStateLicenseNbrFlag: boolean | undefined;
  missingAddress1TextFlag: boolean | undefined;
  missingCityNameFlag: boolean | undefined;
  missingZipCodeFlag: boolean | undefined;
  missingStateCodeFlag: boolean | undefined;
  missingProfessionalDesignationCodeFlag: boolean | undefined;
  missingStateLicenseStateCodeFlag: boolean | undefined;
  missingDeaNumberFlag: boolean | undefined;
  missingSanFlag: boolean | undefined;
  formModFirstNameFlag: boolean | undefined;
  formModMiddleNameFlag: boolean | undefined;
  formModLastNameFlag: boolean | undefined;
  formModStateLicenseNumberFlag: boolean | undefined;
  formModDeaLicenseNumberFlag: boolean | undefined;
  formModProfessionalDesignationFlag: boolean | undefined;
  formModSpecialtyFlag: boolean | undefined;
  formModCompanyFlag: boolean | undefined;
  formModAddress1Flag: boolean | undefined;
  formModAddress2Flag: boolean | undefined;
  formModCityFlag: boolean | undefined;
  formModStateFlag: boolean | undefined;
  formModZipCodeFlag: boolean | undefined;
  /** Gets or sets the institution territory number. */
  institutionTerritoryNumber: string | undefined;
  recipientAttentionToName: string | undefined;

  constructor(data?: IDataEntryOrderHcpDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hcpId = _data["hcpId"];
      this.knipperHcpId = _data["knipperHcpId"];
      this.clientTargetId = _data["clientTargetId"];
      this.firstName = _data["firstName"];
      this.middleName = _data["middleName"];
      this.lastName = _data["lastName"];
      this.suffixId = _data["suffixId"];
      this.professionalDesignationId = _data["professionalDesignationId"];
      this.professionalDesignationCode = _data["professionalDesignationCode"];
      this.professionalSpecialtyCode = _data["professionalSpecialtyCode"];
      this.specialtyId = _data["specialtyId"];
      this.stateLicenseStateId = _data["stateLicenseStateId"];
      this.stateLicenseNbr = _data["stateLicenseNbr"];
      this.stateId = _data["stateId"];
      this.countryId = _data["countryId"];
      this.address1Text = _data["address1Text"];
      this.address2Text = _data["address2Text"];
      this.cityName = _data["cityName"];
      this.zipCode = _data["zipCode"];
      this.addressId = _data["addressId"];
      this.companyName = _data["companyName"];
      this.san = _data["san"];
      this.deaNbr = _data["deaNbr"];
      this.emailAddressText = _data["emailAddressText"];
      this.phoneNbr = _data["phoneNbr"];
      this.phoneExtensionNbr = _data["phoneExtensionNbr"];
      this.faxNbr = _data["faxNbr"];
      this.missingFirstNameFlag = _data["missingFirstNameFlag"];
      this.missingLastNameFlag = _data["missingLastNameFlag"];
      this.missingSpecialtyCodeFlag = _data["missingSpecialtyCodeFlag"];
      this.missingStateLicenseNbrFlag = _data["missingStateLicenseNbrFlag"];
      this.missingAddress1TextFlag = _data["missingAddress1TextFlag"];
      this.missingCityNameFlag = _data["missingCityNameFlag"];
      this.missingZipCodeFlag = _data["missingZipCodeFlag"];
      this.missingStateCodeFlag = _data["missingStateCodeFlag"];
      this.missingProfessionalDesignationCodeFlag = _data["missingProfessionalDesignationCodeFlag"];
      this.missingStateLicenseStateCodeFlag = _data["missingStateLicenseStateCodeFlag"];
      this.missingDeaNumberFlag = _data["missingDeaNumberFlag"];
      this.missingSanFlag = _data["missingSanFlag"];
      this.formModFirstNameFlag = _data["formModFirstNameFlag"];
      this.formModMiddleNameFlag = _data["formModMiddleNameFlag"];
      this.formModLastNameFlag = _data["formModLastNameFlag"];
      this.formModStateLicenseNumberFlag = _data["formModStateLicenseNumberFlag"];
      this.formModDeaLicenseNumberFlag = _data["formModDeaLicenseNumberFlag"];
      this.formModProfessionalDesignationFlag = _data["formModProfessionalDesignationFlag"];
      this.formModSpecialtyFlag = _data["formModSpecialtyFlag"];
      this.formModCompanyFlag = _data["formModCompanyFlag"];
      this.formModAddress1Flag = _data["formModAddress1Flag"];
      this.formModAddress2Flag = _data["formModAddress2Flag"];
      this.formModCityFlag = _data["formModCityFlag"];
      this.formModStateFlag = _data["formModStateFlag"];
      this.formModZipCodeFlag = _data["formModZipCodeFlag"];
      this.institutionTerritoryNumber = _data["institutionTerritoryNumber"];
      this.recipientAttentionToName = _data["recipientAttentionToName"];
    }
  }

  static fromJS(data: any): DataEntryOrderHcpDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new DataEntryOrderHcpDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hcpId"] = this.hcpId;
    data["knipperHcpId"] = this.knipperHcpId;
    data["clientTargetId"] = this.clientTargetId;
    data["firstName"] = this.firstName;
    data["middleName"] = this.middleName;
    data["lastName"] = this.lastName;
    data["suffixId"] = this.suffixId;
    data["professionalDesignationId"] = this.professionalDesignationId;
    data["professionalDesignationCode"] = this.professionalDesignationCode;
    data["professionalSpecialtyCode"] = this.professionalSpecialtyCode;
    data["specialtyId"] = this.specialtyId;
    data["stateLicenseStateId"] = this.stateLicenseStateId;
    data["stateLicenseNbr"] = this.stateLicenseNbr;
    data["stateId"] = this.stateId;
    data["countryId"] = this.countryId;
    data["address1Text"] = this.address1Text;
    data["address2Text"] = this.address2Text;
    data["cityName"] = this.cityName;
    data["zipCode"] = this.zipCode;
    data["addressId"] = this.addressId;
    data["companyName"] = this.companyName;
    data["san"] = this.san;
    data["deaNbr"] = this.deaNbr;
    data["emailAddressText"] = this.emailAddressText;
    data["phoneNbr"] = this.phoneNbr;
    data["phoneExtensionNbr"] = this.phoneExtensionNbr;
    data["faxNbr"] = this.faxNbr;
    data["missingFirstNameFlag"] = this.missingFirstNameFlag;
    data["missingLastNameFlag"] = this.missingLastNameFlag;
    data["missingSpecialtyCodeFlag"] = this.missingSpecialtyCodeFlag;
    data["missingStateLicenseNbrFlag"] = this.missingStateLicenseNbrFlag;
    data["missingAddress1TextFlag"] = this.missingAddress1TextFlag;
    data["missingCityNameFlag"] = this.missingCityNameFlag;
    data["missingZipCodeFlag"] = this.missingZipCodeFlag;
    data["missingStateCodeFlag"] = this.missingStateCodeFlag;
    data["missingProfessionalDesignationCodeFlag"] = this.missingProfessionalDesignationCodeFlag;
    data["missingStateLicenseStateCodeFlag"] = this.missingStateLicenseStateCodeFlag;
    data["missingDeaNumberFlag"] = this.missingDeaNumberFlag;
    data["missingSanFlag"] = this.missingSanFlag;
    data["formModFirstNameFlag"] = this.formModFirstNameFlag;
    data["formModMiddleNameFlag"] = this.formModMiddleNameFlag;
    data["formModLastNameFlag"] = this.formModLastNameFlag;
    data["formModStateLicenseNumberFlag"] = this.formModStateLicenseNumberFlag;
    data["formModDeaLicenseNumberFlag"] = this.formModDeaLicenseNumberFlag;
    data["formModProfessionalDesignationFlag"] = this.formModProfessionalDesignationFlag;
    data["formModSpecialtyFlag"] = this.formModSpecialtyFlag;
    data["formModCompanyFlag"] = this.formModCompanyFlag;
    data["formModAddress1Flag"] = this.formModAddress1Flag;
    data["formModAddress2Flag"] = this.formModAddress2Flag;
    data["formModCityFlag"] = this.formModCityFlag;
    data["formModStateFlag"] = this.formModStateFlag;
    data["formModZipCodeFlag"] = this.formModZipCodeFlag;
    data["institutionTerritoryNumber"] = this.institutionTerritoryNumber;
    data["recipientAttentionToName"] = this.recipientAttentionToName;
    return data;
  }

  clone(): DataEntryOrderHcpDetailsDto {
    const json = this.toJSON();
    let result = new DataEntryOrderHcpDetailsDto();
    result.init(json);
    return result;
  }
}

export interface IDataEntryOrderHcpDetailsDto {
  hcpId: string | undefined;
  knipperHcpId: string | undefined;
  clientTargetId: string | undefined;
  firstName: string | undefined;
  middleName: string | undefined;
  lastName: string | undefined;
  suffixId: string | undefined;
  professionalDesignationId: string | undefined;
  professionalDesignationCode: string | undefined;
  professionalSpecialtyCode: string | undefined;
  specialtyId: string | undefined;
  stateLicenseStateId: string | undefined;
  stateLicenseNbr: string | undefined;
  stateId: string | undefined;
  countryId: string | undefined;
  address1Text: string | undefined;
  address2Text: string | undefined;
  cityName: string | undefined;
  zipCode: string | undefined;
  addressId: string | undefined;
  companyName: string | undefined;
  san: string | undefined;
  deaNbr: string | undefined;
  emailAddressText: string | undefined;
  phoneNbr: string | undefined;
  phoneExtensionNbr: string | undefined;
  faxNbr: string | undefined;
  missingFirstNameFlag: boolean | undefined;
  missingLastNameFlag: boolean | undefined;
  missingSpecialtyCodeFlag: boolean | undefined;
  missingStateLicenseNbrFlag: boolean | undefined;
  missingAddress1TextFlag: boolean | undefined;
  missingCityNameFlag: boolean | undefined;
  missingZipCodeFlag: boolean | undefined;
  missingStateCodeFlag: boolean | undefined;
  missingProfessionalDesignationCodeFlag: boolean | undefined;
  missingStateLicenseStateCodeFlag: boolean | undefined;
  missingDeaNumberFlag: boolean | undefined;
  missingSanFlag: boolean | undefined;
  formModFirstNameFlag: boolean | undefined;
  formModMiddleNameFlag: boolean | undefined;
  formModLastNameFlag: boolean | undefined;
  formModStateLicenseNumberFlag: boolean | undefined;
  formModDeaLicenseNumberFlag: boolean | undefined;
  formModProfessionalDesignationFlag: boolean | undefined;
  formModSpecialtyFlag: boolean | undefined;
  formModCompanyFlag: boolean | undefined;
  formModAddress1Flag: boolean | undefined;
  formModAddress2Flag: boolean | undefined;
  formModCityFlag: boolean | undefined;
  formModStateFlag: boolean | undefined;
  formModZipCodeFlag: boolean | undefined;
  /** Gets or sets the institution territory number. */
  institutionTerritoryNumber: string | undefined;
  recipientAttentionToName: string | undefined;
}

export class DataEntryOrderLineDto implements IDataEntryOrderLineDto {
  orderId: string | undefined;
  productId: string | undefined;
  distributionUoMClassificationValueId: string | undefined;
  offeredQty: number | undefined;
  orderQty: number | undefined;
  wmsProductId: string | undefined;
  wmsProductName: string | undefined;
  missingOrderQtyFlag: boolean | undefined;
  missingOfferedQtyFlag: boolean | undefined;
  reasonForModificationFromOffer: string | undefined;
  isIncluded: boolean | undefined;
  formModProductFlag: boolean | undefined;
  formModQuantityOrderedFlag: boolean | undefined;
  pageNbr: number | undefined;
  displayOrderNbr: number | undefined;
  displayQuantity: string | undefined;
  /** Gets or sets FranchiseCode/TherapeuticClass for a order line. */
  therapeuticClass: string | undefined;
  id: string | undefined;

  constructor(data?: IDataEntryOrderLineDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.productId = _data["productId"];
      this.distributionUoMClassificationValueId = _data["distributionUoMClassificationValueId"];
      this.offeredQty = _data["offeredQty"];
      this.orderQty = _data["orderQty"];
      this.wmsProductId = _data["wmsProductId"];
      this.wmsProductName = _data["wmsProductName"];
      this.missingOrderQtyFlag = _data["missingOrderQtyFlag"];
      this.missingOfferedQtyFlag = _data["missingOfferedQtyFlag"];
      this.reasonForModificationFromOffer = _data["reasonForModificationFromOffer"];
      this.isIncluded = _data["isIncluded"];
      this.formModProductFlag = _data["formModProductFlag"];
      this.formModQuantityOrderedFlag = _data["formModQuantityOrderedFlag"];
      this.pageNbr = _data["pageNbr"];
      this.displayOrderNbr = _data["displayOrderNbr"];
      this.displayQuantity = _data["displayQuantity"];
      this.therapeuticClass = _data["therapeuticClass"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): DataEntryOrderLineDto {
    data = typeof data === 'object' ? data : {};
    let result = new DataEntryOrderLineDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["productId"] = this.productId;
    data["distributionUoMClassificationValueId"] = this.distributionUoMClassificationValueId;
    data["offeredQty"] = this.offeredQty;
    data["orderQty"] = this.orderQty;
    data["wmsProductId"] = this.wmsProductId;
    data["wmsProductName"] = this.wmsProductName;
    data["missingOrderQtyFlag"] = this.missingOrderQtyFlag;
    data["missingOfferedQtyFlag"] = this.missingOfferedQtyFlag;
    data["reasonForModificationFromOffer"] = this.reasonForModificationFromOffer;
    data["isIncluded"] = this.isIncluded;
    data["formModProductFlag"] = this.formModProductFlag;
    data["formModQuantityOrderedFlag"] = this.formModQuantityOrderedFlag;
    data["pageNbr"] = this.pageNbr;
    data["displayOrderNbr"] = this.displayOrderNbr;
    data["displayQuantity"] = this.displayQuantity;
    data["therapeuticClass"] = this.therapeuticClass;
    data["id"] = this.id;
    return data;
  }

  clone(): DataEntryOrderLineDto {
    const json = this.toJSON();
    let result = new DataEntryOrderLineDto();
    result.init(json);
    return result;
  }
}

export interface IDataEntryOrderLineDto {
  orderId: string | undefined;
  productId: string | undefined;
  distributionUoMClassificationValueId: string | undefined;
  offeredQty: number | undefined;
  orderQty: number | undefined;
  wmsProductId: string | undefined;
  wmsProductName: string | undefined;
  missingOrderQtyFlag: boolean | undefined;
  missingOfferedQtyFlag: boolean | undefined;
  reasonForModificationFromOffer: string | undefined;
  isIncluded: boolean | undefined;
  formModProductFlag: boolean | undefined;
  formModQuantityOrderedFlag: boolean | undefined;
  pageNbr: number | undefined;
  displayOrderNbr: number | undefined;
  displayQuantity: string | undefined;
  /** Gets or sets FranchiseCode/TherapeuticClass for a order line. */
  therapeuticClass: string | undefined;
  id: string | undefined;
}

export class DataEntryOrderUnauthorizedFormChangeDto implements IDataEntryOrderUnauthorizedFormChangeDto {
  requestorFirstNameFlag: boolean | undefined;
  requestorDEANbrFlag: boolean | undefined;
  requestorCityFlag: boolean | undefined;
  requestorMiddleNameFlag: boolean | undefined;
  requestorStateLicenseNbrFlag: boolean | undefined;
  requestorLastNameFlag: boolean | undefined;
  requestorSpecialtyFlag: boolean | undefined;
  requestorStateFlag: boolean | undefined;
  recipientFirstNameFlag: boolean | undefined;
  recipientDEANbrFlag: boolean | undefined;
  recipientMiddleNameFlag: boolean | undefined;
  recipientAddress1Flag: boolean | undefined;
  recipientAddress2Flag: boolean | undefined;
  recipientLastNameFlag: boolean | undefined;
  recipientCityFlag: boolean | undefined;
  recipientStateLicenseNbrFlag: boolean | undefined;
  quantityFlag: boolean | undefined;
  requestDateFlag: boolean | undefined;
  productFlag: boolean | undefined;
  requestorProfessionalDesignationFlag: boolean | undefined;
  requestorCompanyFlag: boolean | undefined;
  requestorAddress1Flag: boolean | undefined;
  requestorAddress2Flag: boolean | undefined;
  requestorZipFlag: boolean | undefined;
  recipientCompanyFlag: boolean | undefined;
  recipientStateFlag: boolean | undefined;
  recipientZipFlag: boolean | undefined;
  requestorFirstNameReason: string | undefined;
  requestorDEANbrReason: string | undefined;
  requestorCityReason: string | undefined;
  requestorMiddleNameReason: string | undefined;
  requestorStateLicenseNbrReason: string | undefined;
  requestorLastNameReason: string | undefined;
  requestorSpecialtyReason: string | undefined;
  requestorStateReason: string | undefined;
  recipientFirstNameReason: string | undefined;
  recipientDEANbrReason: string | undefined;
  recipientMiddleNameReason: string | undefined;
  recipientAddress1Reason: string | undefined;
  recipientAddress2Reason: string | undefined;
  recipientLastNameReason: string | undefined;
  recipientCityReason: string | undefined;
  recipientStateLicenseNbrReason: string | undefined;
  quantityReason: string | undefined;
  requestDateReason: string | undefined;
  productReason: string | undefined;
  requestorProfessionalDesignationReason: string | undefined;
  requestorCompanyReason: string | undefined;
  requestorAddress1Reason: string | undefined;
  requestorAddress2Reason: string | undefined;
  requestorZipReason: string | undefined;
  recipientCompanyReason: string | undefined;
  recipientStateReason: string | undefined;
  recipientZipReason: string | undefined;

  constructor(data?: IDataEntryOrderUnauthorizedFormChangeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.requestorFirstNameFlag = _data["requestorFirstNameFlag"];
      this.requestorDEANbrFlag = _data["requestorDEANbrFlag"];
      this.requestorCityFlag = _data["requestorCityFlag"];
      this.requestorMiddleNameFlag = _data["requestorMiddleNameFlag"];
      this.requestorStateLicenseNbrFlag = _data["requestorStateLicenseNbrFlag"];
      this.requestorLastNameFlag = _data["requestorLastNameFlag"];
      this.requestorSpecialtyFlag = _data["requestorSpecialtyFlag"];
      this.requestorStateFlag = _data["requestorStateFlag"];
      this.recipientFirstNameFlag = _data["recipientFirstNameFlag"];
      this.recipientDEANbrFlag = _data["recipientDEANbrFlag"];
      this.recipientMiddleNameFlag = _data["recipientMiddleNameFlag"];
      this.recipientAddress1Flag = _data["recipientAddress1Flag"];
      this.recipientAddress2Flag = _data["recipientAddress2Flag"];
      this.recipientLastNameFlag = _data["recipientLastNameFlag"];
      this.recipientCityFlag = _data["recipientCityFlag"];
      this.recipientStateLicenseNbrFlag = _data["recipientStateLicenseNbrFlag"];
      this.quantityFlag = _data["quantityFlag"];
      this.requestDateFlag = _data["requestDateFlag"];
      this.productFlag = _data["productFlag"];
      this.requestorProfessionalDesignationFlag = _data["requestorProfessionalDesignationFlag"];
      this.requestorCompanyFlag = _data["requestorCompanyFlag"];
      this.requestorAddress1Flag = _data["requestorAddress1Flag"];
      this.requestorAddress2Flag = _data["requestorAddress2Flag"];
      this.requestorZipFlag = _data["requestorZipFlag"];
      this.recipientCompanyFlag = _data["recipientCompanyFlag"];
      this.recipientStateFlag = _data["recipientStateFlag"];
      this.recipientZipFlag = _data["recipientZipFlag"];
      this.requestorFirstNameReason = _data["requestorFirstNameReason"];
      this.requestorDEANbrReason = _data["requestorDEANbrReason"];
      this.requestorCityReason = _data["requestorCityReason"];
      this.requestorMiddleNameReason = _data["requestorMiddleNameReason"];
      this.requestorStateLicenseNbrReason = _data["requestorStateLicenseNbrReason"];
      this.requestorLastNameReason = _data["requestorLastNameReason"];
      this.requestorSpecialtyReason = _data["requestorSpecialtyReason"];
      this.requestorStateReason = _data["requestorStateReason"];
      this.recipientFirstNameReason = _data["recipientFirstNameReason"];
      this.recipientDEANbrReason = _data["recipientDEANbrReason"];
      this.recipientMiddleNameReason = _data["recipientMiddleNameReason"];
      this.recipientAddress1Reason = _data["recipientAddress1Reason"];
      this.recipientAddress2Reason = _data["recipientAddress2Reason"];
      this.recipientLastNameReason = _data["recipientLastNameReason"];
      this.recipientCityReason = _data["recipientCityReason"];
      this.recipientStateLicenseNbrReason = _data["recipientStateLicenseNbrReason"];
      this.quantityReason = _data["quantityReason"];
      this.requestDateReason = _data["requestDateReason"];
      this.productReason = _data["productReason"];
      this.requestorProfessionalDesignationReason = _data["requestorProfessionalDesignationReason"];
      this.requestorCompanyReason = _data["requestorCompanyReason"];
      this.requestorAddress1Reason = _data["requestorAddress1Reason"];
      this.requestorAddress2Reason = _data["requestorAddress2Reason"];
      this.requestorZipReason = _data["requestorZipReason"];
      this.recipientCompanyReason = _data["recipientCompanyReason"];
      this.recipientStateReason = _data["recipientStateReason"];
      this.recipientZipReason = _data["recipientZipReason"];
    }
  }

  static fromJS(data: any): DataEntryOrderUnauthorizedFormChangeDto {
    data = typeof data === 'object' ? data : {};
    let result = new DataEntryOrderUnauthorizedFormChangeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["requestorFirstNameFlag"] = this.requestorFirstNameFlag;
    data["requestorDEANbrFlag"] = this.requestorDEANbrFlag;
    data["requestorCityFlag"] = this.requestorCityFlag;
    data["requestorMiddleNameFlag"] = this.requestorMiddleNameFlag;
    data["requestorStateLicenseNbrFlag"] = this.requestorStateLicenseNbrFlag;
    data["requestorLastNameFlag"] = this.requestorLastNameFlag;
    data["requestorSpecialtyFlag"] = this.requestorSpecialtyFlag;
    data["requestorStateFlag"] = this.requestorStateFlag;
    data["recipientFirstNameFlag"] = this.recipientFirstNameFlag;
    data["recipientDEANbrFlag"] = this.recipientDEANbrFlag;
    data["recipientMiddleNameFlag"] = this.recipientMiddleNameFlag;
    data["recipientAddress1Flag"] = this.recipientAddress1Flag;
    data["recipientAddress2Flag"] = this.recipientAddress2Flag;
    data["recipientLastNameFlag"] = this.recipientLastNameFlag;
    data["recipientCityFlag"] = this.recipientCityFlag;
    data["recipientStateLicenseNbrFlag"] = this.recipientStateLicenseNbrFlag;
    data["quantityFlag"] = this.quantityFlag;
    data["requestDateFlag"] = this.requestDateFlag;
    data["productFlag"] = this.productFlag;
    data["requestorProfessionalDesignationFlag"] = this.requestorProfessionalDesignationFlag;
    data["requestorCompanyFlag"] = this.requestorCompanyFlag;
    data["requestorAddress1Flag"] = this.requestorAddress1Flag;
    data["requestorAddress2Flag"] = this.requestorAddress2Flag;
    data["requestorZipFlag"] = this.requestorZipFlag;
    data["recipientCompanyFlag"] = this.recipientCompanyFlag;
    data["recipientStateFlag"] = this.recipientStateFlag;
    data["recipientZipFlag"] = this.recipientZipFlag;
    data["requestorFirstNameReason"] = this.requestorFirstNameReason;
    data["requestorDEANbrReason"] = this.requestorDEANbrReason;
    data["requestorCityReason"] = this.requestorCityReason;
    data["requestorMiddleNameReason"] = this.requestorMiddleNameReason;
    data["requestorStateLicenseNbrReason"] = this.requestorStateLicenseNbrReason;
    data["requestorLastNameReason"] = this.requestorLastNameReason;
    data["requestorSpecialtyReason"] = this.requestorSpecialtyReason;
    data["requestorStateReason"] = this.requestorStateReason;
    data["recipientFirstNameReason"] = this.recipientFirstNameReason;
    data["recipientDEANbrReason"] = this.recipientDEANbrReason;
    data["recipientMiddleNameReason"] = this.recipientMiddleNameReason;
    data["recipientAddress1Reason"] = this.recipientAddress1Reason;
    data["recipientAddress2Reason"] = this.recipientAddress2Reason;
    data["recipientLastNameReason"] = this.recipientLastNameReason;
    data["recipientCityReason"] = this.recipientCityReason;
    data["recipientStateLicenseNbrReason"] = this.recipientStateLicenseNbrReason;
    data["quantityReason"] = this.quantityReason;
    data["requestDateReason"] = this.requestDateReason;
    data["productReason"] = this.productReason;
    data["requestorProfessionalDesignationReason"] = this.requestorProfessionalDesignationReason;
    data["requestorCompanyReason"] = this.requestorCompanyReason;
    data["requestorAddress1Reason"] = this.requestorAddress1Reason;
    data["requestorAddress2Reason"] = this.requestorAddress2Reason;
    data["requestorZipReason"] = this.requestorZipReason;
    data["recipientCompanyReason"] = this.recipientCompanyReason;
    data["recipientStateReason"] = this.recipientStateReason;
    data["recipientZipReason"] = this.recipientZipReason;
    return data;
  }

  clone(): DataEntryOrderUnauthorizedFormChangeDto {
    const json = this.toJSON();
    let result = new DataEntryOrderUnauthorizedFormChangeDto();
    result.init(json);
    return result;
  }
}

export interface IDataEntryOrderUnauthorizedFormChangeDto {
  requestorFirstNameFlag: boolean | undefined;
  requestorDEANbrFlag: boolean | undefined;
  requestorCityFlag: boolean | undefined;
  requestorMiddleNameFlag: boolean | undefined;
  requestorStateLicenseNbrFlag: boolean | undefined;
  requestorLastNameFlag: boolean | undefined;
  requestorSpecialtyFlag: boolean | undefined;
  requestorStateFlag: boolean | undefined;
  recipientFirstNameFlag: boolean | undefined;
  recipientDEANbrFlag: boolean | undefined;
  recipientMiddleNameFlag: boolean | undefined;
  recipientAddress1Flag: boolean | undefined;
  recipientAddress2Flag: boolean | undefined;
  recipientLastNameFlag: boolean | undefined;
  recipientCityFlag: boolean | undefined;
  recipientStateLicenseNbrFlag: boolean | undefined;
  quantityFlag: boolean | undefined;
  requestDateFlag: boolean | undefined;
  productFlag: boolean | undefined;
  requestorProfessionalDesignationFlag: boolean | undefined;
  requestorCompanyFlag: boolean | undefined;
  requestorAddress1Flag: boolean | undefined;
  requestorAddress2Flag: boolean | undefined;
  requestorZipFlag: boolean | undefined;
  recipientCompanyFlag: boolean | undefined;
  recipientStateFlag: boolean | undefined;
  recipientZipFlag: boolean | undefined;
  requestorFirstNameReason: string | undefined;
  requestorDEANbrReason: string | undefined;
  requestorCityReason: string | undefined;
  requestorMiddleNameReason: string | undefined;
  requestorStateLicenseNbrReason: string | undefined;
  requestorLastNameReason: string | undefined;
  requestorSpecialtyReason: string | undefined;
  requestorStateReason: string | undefined;
  recipientFirstNameReason: string | undefined;
  recipientDEANbrReason: string | undefined;
  recipientMiddleNameReason: string | undefined;
  recipientAddress1Reason: string | undefined;
  recipientAddress2Reason: string | undefined;
  recipientLastNameReason: string | undefined;
  recipientCityReason: string | undefined;
  recipientStateLicenseNbrReason: string | undefined;
  quantityReason: string | undefined;
  requestDateReason: string | undefined;
  productReason: string | undefined;
  requestorProfessionalDesignationReason: string | undefined;
  requestorCompanyReason: string | undefined;
  requestorAddress1Reason: string | undefined;
  requestorAddress2Reason: string | undefined;
  requestorZipReason: string | undefined;
  recipientCompanyReason: string | undefined;
  recipientStateReason: string | undefined;
  recipientZipReason: string | undefined;
}

export class DeleteDataEntryOrderRequestDto implements IDeleteDataEntryOrderRequestDto {
  orderId: string | undefined;
  commentTypeId: string | undefined;

  constructor(data?: IDeleteDataEntryOrderRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.commentTypeId = _data["commentTypeId"];
    }
  }

  static fromJS(data: any): DeleteDataEntryOrderRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new DeleteDataEntryOrderRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["commentTypeId"] = this.commentTypeId;
    return data;
  }

  clone(): DeleteDataEntryOrderRequestDto {
    const json = this.toJSON();
    let result = new DeleteDataEntryOrderRequestDto();
    result.init(json);
    return result;
  }
}

export interface IDeleteDataEntryOrderRequestDto {
  orderId: string | undefined;
  commentTypeId: string | undefined;
}

export class AjaxResponseOfDeleteDataEntryOrderResultDto implements IAjaxResponseOfDeleteDataEntryOrderResultDto {
  result: DeleteDataEntryOrderResultDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfDeleteDataEntryOrderResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? DeleteDataEntryOrderResultDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfDeleteDataEntryOrderResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfDeleteDataEntryOrderResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfDeleteDataEntryOrderResultDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfDeleteDataEntryOrderResultDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfDeleteDataEntryOrderResultDto {
  result: DeleteDataEntryOrderResultDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class DeleteDataEntryOrderResultDto implements IDeleteDataEntryOrderResultDto {
  orderId: string | undefined;
  orderNumber: string | undefined;
  orderStatusId: string | undefined;
  isSuccessfullyDeleted: boolean | undefined;
  deletionFailureReasonText: string | undefined;

  constructor(data?: IDeleteDataEntryOrderResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderNumber = _data["orderNumber"];
      this.orderStatusId = _data["orderStatusId"];
      this.isSuccessfullyDeleted = _data["isSuccessfullyDeleted"];
      this.deletionFailureReasonText = _data["deletionFailureReasonText"];
    }
  }

  static fromJS(data: any): DeleteDataEntryOrderResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new DeleteDataEntryOrderResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderNumber"] = this.orderNumber;
    data["orderStatusId"] = this.orderStatusId;
    data["isSuccessfullyDeleted"] = this.isSuccessfullyDeleted;
    data["deletionFailureReasonText"] = this.deletionFailureReasonText;
    return data;
  }

  clone(): DeleteDataEntryOrderResultDto {
    const json = this.toJSON();
    let result = new DeleteDataEntryOrderResultDto();
    result.init(json);
    return result;
  }
}

export interface IDeleteDataEntryOrderResultDto {
  orderId: string | undefined;
  orderNumber: string | undefined;
  orderStatusId: string | undefined;
  isSuccessfullyDeleted: boolean | undefined;
  deletionFailureReasonText: string | undefined;
}

export class OrderFileUploadDto implements IOrderFileUploadDto {
  programId: string | undefined;
  fileUpload: FileUpload | undefined;
  creatorUserId: number | undefined;
  creationTime: Date | undefined;
  uploadedOrderIds: string[] | undefined;
  ordersLoaded: number | undefined;
  ordersInvalid: number | undefined;
  ordersTotal: number | undefined;

  constructor(data?: IOrderFileUploadDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programId = _data["programId"];
      this.fileUpload = _data["fileUpload"] ? FileUpload.fromJS(_data["fileUpload"]) : <any>undefined;
      this.creatorUserId = _data["creatorUserId"];
      this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
      if (Array.isArray(_data["uploadedOrderIds"])) {
        this.uploadedOrderIds = [] as any;
        for (let item of _data["uploadedOrderIds"])
          this.uploadedOrderIds.push(item);
      }
      this.ordersLoaded = _data["ordersLoaded"];
      this.ordersInvalid = _data["ordersInvalid"];
      this.ordersTotal = _data["ordersTotal"];
    }
  }

  static fromJS(data: any): OrderFileUploadDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderFileUploadDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["programId"] = this.programId;
    data["fileUpload"] = this.fileUpload ? this.fileUpload.toJSON() : <any>undefined;
    data["creatorUserId"] = this.creatorUserId;
    data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    if (Array.isArray(this.uploadedOrderIds)) {
      data["uploadedOrderIds"] = [];
      for (let item of this.uploadedOrderIds)
        data["uploadedOrderIds"].push(item);
    }
    data["ordersLoaded"] = this.ordersLoaded;
    data["ordersInvalid"] = this.ordersInvalid;
    data["ordersTotal"] = this.ordersTotal;
    return data;
  }

  clone(): OrderFileUploadDto {
    const json = this.toJSON();
    let result = new OrderFileUploadDto();
    result.init(json);
    return result;
  }
}

export interface IOrderFileUploadDto {
  programId: string | undefined;
  fileUpload: FileUpload | undefined;
  creatorUserId: number | undefined;
  creationTime: Date | undefined;
  uploadedOrderIds: string[] | undefined;
  ordersLoaded: number | undefined;
  ordersInvalid: number | undefined;
  ordersTotal: number | undefined;
}

export class AjaxResponseOfOrderFileUploadDto implements IAjaxResponseOfOrderFileUploadDto {
  result: OrderFileUploadDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfOrderFileUploadDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? OrderFileUploadDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfOrderFileUploadDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfOrderFileUploadDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfOrderFileUploadDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfOrderFileUploadDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfOrderFileUploadDto {
  result: OrderFileUploadDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class AjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean implements IAjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean {
  result: TupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? TupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean {
    const json = this.toJSON();
    let result = new AjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfTupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean {
  result: TupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class TupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean implements ITupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean {
  readonly item1: string | undefined;
  readonly item2: boolean | undefined;
  readonly item3: boolean | undefined;
  readonly item4: boolean | undefined;

  constructor(data?: ITupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).item1 = _data["item1"];
      (<any>this).item2 = _data["item2"];
      (<any>this).item3 = _data["item3"];
      (<any>this).item4 = _data["item4"];
    }
  }

  static fromJS(data: any): TupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean {
    data = typeof data === 'object' ? data : {};
    let result = new TupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["item1"] = this.item1;
    data["item2"] = this.item2;
    data["item3"] = this.item3;
    data["item4"] = this.item4;
    return data;
  }

  clone(): TupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean {
    const json = this.toJSON();
    let result = new TupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean();
    result.init(json);
    return result;
  }
}

export interface ITupleOfStringAndNullableOfBooleanAndNullableOfBooleanAndNullableOfBoolean {
  item1: string | undefined;
  item2: boolean | undefined;
  item3: boolean | undefined;
  item4: boolean | undefined;
}

export class AjaxResponseOfLockAckDto implements IAjaxResponseOfLockAckDto {
  result: LockAckDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfLockAckDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? LockAckDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfLockAckDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfLockAckDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfLockAckDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfLockAckDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfLockAckDto {
  result: LockAckDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class LockAckDto implements ILockAckDto {
  isLocked: boolean | undefined;
  lockConfig: LockConfigDto | undefined;

  constructor(data?: ILockAckDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isLocked = _data["isLocked"];
      this.lockConfig = _data["lockConfig"] ? LockConfigDto.fromJS(_data["lockConfig"]) : <any>undefined;
    }
  }

  static fromJS(data: any): LockAckDto {
    data = typeof data === 'object' ? data : {};
    let result = new LockAckDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isLocked"] = this.isLocked;
    data["lockConfig"] = this.lockConfig ? this.lockConfig.toJSON() : <any>undefined;
    return data;
  }

  clone(): LockAckDto {
    const json = this.toJSON();
    let result = new LockAckDto();
    result.init(json);
    return result;
  }
}

export interface ILockAckDto {
  isLocked: boolean | undefined;
  lockConfig: LockConfigDto | undefined;
}

export class LockConfigDto implements ILockConfigDto {
  warnLockExpiryFromInSeconds: number | undefined;
  expireLockDurationInSeconds: number | undefined;

  constructor(data?: ILockConfigDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.warnLockExpiryFromInSeconds = _data["warnLockExpiryFromInSeconds"];
      this.expireLockDurationInSeconds = _data["expireLockDurationInSeconds"];
    }
  }

  static fromJS(data: any): LockConfigDto {
    data = typeof data === 'object' ? data : {};
    let result = new LockConfigDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["warnLockExpiryFromInSeconds"] = this.warnLockExpiryFromInSeconds;
    data["expireLockDurationInSeconds"] = this.expireLockDurationInSeconds;
    return data;
  }

  clone(): LockConfigDto {
    const json = this.toJSON();
    let result = new LockConfigDto();
    result.init(json);
    return result;
  }
}

export interface ILockConfigDto {
  warnLockExpiryFromInSeconds: number | undefined;
  expireLockDurationInSeconds: number | undefined;
}

export class AjaxResponseOfLockInfoDto implements IAjaxResponseOfLockInfoDto {
  result: LockInfoDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfLockInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? LockInfoDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfLockInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfLockInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfLockInfoDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfLockInfoDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfLockInfoDto {
  result: LockInfoDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class LockInfoDto implements ILockInfoDto {
  lock: LockDto | undefined;
  lockConfig: LockConfigDto | undefined;

  constructor(data?: ILockInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lock = _data["lock"] ? LockDto.fromJS(_data["lock"]) : <any>undefined;
      this.lockConfig = _data["lockConfig"] ? LockConfigDto.fromJS(_data["lockConfig"]) : <any>undefined;
    }
  }

  static fromJS(data: any): LockInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new LockInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lock"] = this.lock ? this.lock.toJSON() : <any>undefined;
    data["lockConfig"] = this.lockConfig ? this.lockConfig.toJSON() : <any>undefined;
    return data;
  }

  clone(): LockInfoDto {
    const json = this.toJSON();
    let result = new LockInfoDto();
    result.init(json);
    return result;
  }
}

export interface ILockInfoDto {
  lock: LockDto | undefined;
  lockConfig: LockConfigDto | undefined;
}

export class AjaxResponseOfAssociatedOrderItemDto implements IAjaxResponseOfAssociatedOrderItemDto {
  result: AssociatedOrderItemDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfAssociatedOrderItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? AssociatedOrderItemDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfAssociatedOrderItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfAssociatedOrderItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfAssociatedOrderItemDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfAssociatedOrderItemDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfAssociatedOrderItemDto {
  result: AssociatedOrderItemDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class AssociatedOrderItemDto implements IAssociatedOrderItemDto {
  id: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  orderStatusId: string | undefined;
  readonly orderStatusTimeDiff: number | undefined;
  orderStatusLastModifiedTime: Date | undefined;
  associatedChildOrders: AssociatedChildOrderDto[] | undefined;
  orderStatusReasonTypeIds: string[] | undefined;
  names: LocalizedValue[] | undefined;

  constructor(data?: IAssociatedOrderItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.orderNumber = _data["orderNumber"];
      this.externalOrderNumber = _data["externalOrderNumber"];
      this.orderStatusId = _data["orderStatusId"];
      (<any>this).orderStatusTimeDiff = _data["orderStatusTimeDiff"];
      this.orderStatusLastModifiedTime = _data["orderStatusLastModifiedTime"] ? new Date(_data["orderStatusLastModifiedTime"].toString()) : <any>undefined;
      if (Array.isArray(_data["associatedChildOrders"])) {
        this.associatedChildOrders = [] as any;
        for (let item of _data["associatedChildOrders"])
          this.associatedChildOrders.push(AssociatedChildOrderDto.fromJS(item));
      }
      if (Array.isArray(_data["orderStatusReasonTypeIds"])) {
        this.orderStatusReasonTypeIds = [] as any;
        for (let item of _data["orderStatusReasonTypeIds"])
          this.orderStatusReasonTypeIds.push(item);
      }
      if (Array.isArray(_data["names"])) {
        this.names = [] as any;
        for (let item of _data["names"])
          this.names.push(LocalizedValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AssociatedOrderItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new AssociatedOrderItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["orderNumber"] = this.orderNumber;
    data["externalOrderNumber"] = this.externalOrderNumber;
    data["orderStatusId"] = this.orderStatusId;
    data["orderStatusTimeDiff"] = this.orderStatusTimeDiff;
    data["orderStatusLastModifiedTime"] = this.orderStatusLastModifiedTime ? this.orderStatusLastModifiedTime.toISOString() : <any>undefined;
    if (Array.isArray(this.associatedChildOrders)) {
      data["associatedChildOrders"] = [];
      for (let item of this.associatedChildOrders)
        data["associatedChildOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.orderStatusReasonTypeIds)) {
      data["orderStatusReasonTypeIds"] = [];
      for (let item of this.orderStatusReasonTypeIds)
        data["orderStatusReasonTypeIds"].push(item);
    }
    if (Array.isArray(this.names)) {
      data["names"] = [];
      for (let item of this.names)
        data["names"].push(item.toJSON());
    }
    return data;
  }

  clone(): AssociatedOrderItemDto {
    const json = this.toJSON();
    let result = new AssociatedOrderItemDto();
    result.init(json);
    return result;
  }
}

export interface IAssociatedOrderItemDto {
  id: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  orderStatusId: string | undefined;
  orderStatusTimeDiff: number | undefined;
  orderStatusLastModifiedTime: Date | undefined;
  associatedChildOrders: AssociatedChildOrderDto[] | undefined;
  orderStatusReasonTypeIds: string[] | undefined;
  names: LocalizedValue[] | undefined;
}

export class AssociatedChildOrderDto implements IAssociatedChildOrderDto {
  id: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  orderStatusId: string | undefined;

  constructor(data?: IAssociatedChildOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.orderNumber = _data["orderNumber"];
      this.externalOrderNumber = _data["externalOrderNumber"];
      this.orderStatusId = _data["orderStatusId"];
    }
  }

  static fromJS(data: any): AssociatedChildOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new AssociatedChildOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["orderNumber"] = this.orderNumber;
    data["externalOrderNumber"] = this.externalOrderNumber;
    data["orderStatusId"] = this.orderStatusId;
    return data;
  }

  clone(): AssociatedChildOrderDto {
    const json = this.toJSON();
    let result = new AssociatedChildOrderDto();
    result.init(json);
    return result;
  }
}

export interface IAssociatedChildOrderDto {
  id: string | undefined;
  orderNumber: string | undefined;
  externalOrderNumber: string | undefined;
  orderStatusId: string | undefined;
}

export class AjaxResponseOfAllocationAssociatedOrderItemDto implements IAjaxResponseOfAllocationAssociatedOrderItemDto {
  result: AllocationAssociatedOrderItemDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfAllocationAssociatedOrderItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? AllocationAssociatedOrderItemDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfAllocationAssociatedOrderItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfAllocationAssociatedOrderItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfAllocationAssociatedOrderItemDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfAllocationAssociatedOrderItemDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfAllocationAssociatedOrderItemDto {
  result: AllocationAssociatedOrderItemDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class AllocationAssociatedOrderItemDto implements IAllocationAssociatedOrderItemDto {
  id: string | undefined;
  orderNumber: string | undefined;
  submissionDate: Date | undefined;
  associatedChildOrders: AssociatedChildOrderDto[] | undefined;
  names: LocalizedValue[] | undefined;

  constructor(data?: IAllocationAssociatedOrderItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.orderNumber = _data["orderNumber"];
      this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : <any>undefined;
      if (Array.isArray(_data["associatedChildOrders"])) {
        this.associatedChildOrders = [] as any;
        for (let item of _data["associatedChildOrders"])
          this.associatedChildOrders.push(AssociatedChildOrderDto.fromJS(item));
      }
      if (Array.isArray(_data["names"])) {
        this.names = [] as any;
        for (let item of _data["names"])
          this.names.push(LocalizedValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AllocationAssociatedOrderItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new AllocationAssociatedOrderItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["orderNumber"] = this.orderNumber;
    data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
    if (Array.isArray(this.associatedChildOrders)) {
      data["associatedChildOrders"] = [];
      for (let item of this.associatedChildOrders)
        data["associatedChildOrders"].push(item.toJSON());
    }
    if (Array.isArray(this.names)) {
      data["names"] = [];
      for (let item of this.names)
        data["names"].push(item.toJSON());
    }
    return data;
  }

  clone(): AllocationAssociatedOrderItemDto {
    const json = this.toJSON();
    let result = new AllocationAssociatedOrderItemDto();
    result.init(json);
    return result;
  }
}

export interface IAllocationAssociatedOrderItemDto {
  id: string | undefined;
  orderNumber: string | undefined;
  submissionDate: Date | undefined;
  associatedChildOrders: AssociatedChildOrderDto[] | undefined;
  names: LocalizedValue[] | undefined;
}

export class AjaxResponseOfListOfInvestigationDto implements IAjaxResponseOfListOfInvestigationDto {
  result: InvestigationDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfListOfInvestigationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result.push(InvestigationDto.fromJS(item));
      }
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfListOfInvestigationDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfListOfInvestigationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfListOfInvestigationDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfListOfInvestigationDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfListOfInvestigationDto {
  result: InvestigationDto[] | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class AjaxResponseOfOrderValidationResultDto implements IAjaxResponseOfOrderValidationResultDto {
  result: OrderValidationResultDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  readonly __abp: boolean | undefined;

  constructor(data?: IAjaxResponseOfOrderValidationResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? OrderValidationResultDto.fromJS(_data["result"]) : <any>undefined;
      this.targetUrl = _data["targetUrl"];
      this.success = _data["success"];
      this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
      this.unAuthorizedRequest = _data["unAuthorizedRequest"];
      (<any>this).__abp = _data["__abp"];
    }
  }

  static fromJS(data: any): AjaxResponseOfOrderValidationResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new AjaxResponseOfOrderValidationResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["targetUrl"] = this.targetUrl;
    data["success"] = this.success;
    data["error"] = this.error ? this.error.toJSON() : <any>undefined;
    data["unAuthorizedRequest"] = this.unAuthorizedRequest;
    data["__abp"] = this.__abp;
    return data;
  }

  clone(): AjaxResponseOfOrderValidationResultDto {
    const json = this.toJSON();
    let result = new AjaxResponseOfOrderValidationResultDto();
    result.init(json);
    return result;
  }
}

export interface IAjaxResponseOfOrderValidationResultDto {
  result: OrderValidationResultDto | undefined;
  targetUrl: string | undefined;
  success: boolean | undefined;
  error: ErrorInfo | undefined;
  unAuthorizedRequest: boolean | undefined;
  __abp: boolean | undefined;
}

export class OrderValidationResultDto implements IOrderValidationResultDto {
  orderId: string | undefined;
  orderLineId: string | undefined;
  orderValidationId: string | undefined;
  items: OrderValidationResultItemDto[] | undefined;

  constructor(data?: IOrderValidationResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
      this.orderLineId = _data["orderLineId"];
      this.orderValidationId = _data["orderValidationId"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items.push(OrderValidationResultItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): OrderValidationResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderValidationResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderId"] = this.orderId;
    data["orderLineId"] = this.orderLineId;
    data["orderValidationId"] = this.orderValidationId;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }

  clone(): OrderValidationResultDto {
    const json = this.toJSON();
    let result = new OrderValidationResultDto();
    result.init(json);
    return result;
  }
}

export interface IOrderValidationResultDto {
  orderId: string | undefined;
  orderLineId: string | undefined;
  orderValidationId: string | undefined;
  items: OrderValidationResultItemDto[] | undefined;
}

export class OrderValidationResultItemDto implements IOrderValidationResultItemDto {
  orderStatusReasonTypeId: string | undefined;
  ruleItems: OrderValidationResultItemRuleDto[] | undefined;

  constructor(data?: IOrderValidationResultItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderStatusReasonTypeId = _data["orderStatusReasonTypeId"];
      if (Array.isArray(_data["ruleItems"])) {
        this.ruleItems = [] as any;
        for (let item of _data["ruleItems"])
          this.ruleItems.push(OrderValidationResultItemRuleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): OrderValidationResultItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderValidationResultItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orderStatusReasonTypeId"] = this.orderStatusReasonTypeId;
    if (Array.isArray(this.ruleItems)) {
      data["ruleItems"] = [];
      for (let item of this.ruleItems)
        data["ruleItems"].push(item.toJSON());
    }
    return data;
  }

  clone(): OrderValidationResultItemDto {
    const json = this.toJSON();
    let result = new OrderValidationResultItemDto();
    result.init(json);
    return result;
  }
}

export interface IOrderValidationResultItemDto {
  orderStatusReasonTypeId: string | undefined;
  ruleItems: OrderValidationResultItemRuleDto[] | undefined;
}

export class OrderValidationResultItemRuleDto implements IOrderValidationResultItemRuleDto {
  ruleCode: string | undefined;
  ruleName: string | undefined;
  displayOrder: number | undefined;

  constructor(data?: IOrderValidationResultItemRuleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ruleCode = _data["ruleCode"];
      this.ruleName = _data["ruleName"];
      this.displayOrder = _data["displayOrder"];
    }
  }

  static fromJS(data: any): OrderValidationResultItemRuleDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderValidationResultItemRuleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ruleCode"] = this.ruleCode;
    data["ruleName"] = this.ruleName;
    data["displayOrder"] = this.displayOrder;
    return data;
  }

  clone(): OrderValidationResultItemRuleDto {
    const json = this.toJSON();
    let result = new OrderValidationResultItemRuleDto();
    result.init(json);
    return result;
  }
}

export interface IOrderValidationResultItemRuleDto {
  ruleCode: string | undefined;
  ruleName: string | undefined;
  displayOrder: number | undefined;
}

export enum ShipDays {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum DocumentLocationStorageLocation {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
}

export enum OutboundCommunicationOptionsCommunicationRecordOptions {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum AcceptableDeliveryDays {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum acceptableDeliveryDays {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum ValidationFailureSeverity {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export enum InvestigationSubmittedValueDtoMode {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
}

export enum InvestigationValidationReferenceDtoMode {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
}

export enum InvestigationActionDtoMode {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
}

export enum TextInvestigationValueMask {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
}

export enum LookupInvestigationValueDataType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum LookupInvestigationValueFormType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export enum LookupsInvestigationValueDataType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum LookupsInvestigationValueFormType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export enum InvestigationCurrentValueDtoMode {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
}

export enum StepperLifeCycleStageDtoStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export enum LocalizedValueLanguage {
  _0 = 0,
  _1 = 1,
}

export enum OrderDetailsDtoOrderDeliveryType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export enum AcceptableDaysOfDelivery {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum ProgramDeliverySelectDays {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum ProgramShipDays {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export enum TaskStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
}

export enum TaskCreationOptions {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _4 = 4,
  _8 = 8,
  _16 = 16,
  _64 = 64,
}

export enum AjaxResponseOfSSDCalculationResultEnumResult {
  _0 = 0,
  _1 = 1,
}

export enum InactiveHCPOrderExceptionHandlerDtoAction {
  _0 = 0,
  _1 = 1,
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return throwError(result);
  else
    return throwError(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
